(function() {
  'use strict';

  angular
    .module('app', [
             'ngAnimate', 'ngCookies', 'ngSanitize',
             'ngMessages', 'ngAria', 'ngRoute', 'ui.bootstrap', 'toastr',
             'pascalprecht.translate', 'ngLocale', 'ui.select',
             'datik-utils', 'datik-constants',
             'datik-connection', 'datik-composition', 'base64',
             'datik-selectores','ngMaterial','angular-md5','ui.ace', 'ngCsv'
           ]
  );

})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:TablaPantallaCompletaModalController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('TablaPantallaCompletaModalController', TablaPantallaCompletaModalController);

  function TablaPantallaCompletaModalController($uibModalInstance, datos) {
    var vm = this;

    vm.datos = datos;

    vm.close = function() {
      $uibModalInstance.dismiss();
    };



  }



})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('vehiService', vehiService);

  function vehiService($log, $http, $window, $q, $timeout, $translate, constantes, conexion) {
    var service = {
      getVehiculos: getVehiculos
    };

    return service;

    function validaVacios (value) {
      if(value === null) return '-';
      return value;
    }

    function getVehiculos(page,size,filter,sort) {
      var colores = ["transparent","#4EAD5C"];
      var url = constantes.getApiUrl('ips_mng', 'getVehiculosOF');

      var dtos = [];

      filter = filter.split("#");

      if (sort !== "" && filter[0] === "" && filter[1] === "<reg>") {
        sort = sort.replace("tipo","type");
        sort = sort.replace("activo","active");
        url += '?sort='+ sort +'&page='+ page +'&size=' + size;
      } else if (sort === "" && filter[0] !== "" && filter[1] !== "<reg>") {

        dtos = filter[1].split("<reg>");
        if (dtos[1] !== "") {
          url += '?filter='+ filter + '&lt='+ dtos[0] + '&page='+ page +'&size=' + size;
        } else if (dtos[2] !== "") {
          url += '?filter='+ filter + '&gt='+ dtos[1] +'&page='+ page +'&size=' + size;
        } else if (dtos[1] !== "" && dtos[2] !== "") {
          url += '?filter='+ filter + '&lt='+ dtos[1] + '&gt='+ dtos[2]  +'&page='+ page +'&size=' + size;
        } else {
          url += '?filter='+ filter +'&page='+ page +'&size=' + size;
        }

      } else if (sort !== "" && filter[0] !== "" && filter[1] !== "<reg>") {

        dtos = filter[1].split("<reg>");
        if (dtos[1] !== " " && dtos[2] === "") {
          url += '?sort='+ sort + '&filter='+ filter + '&lt='+ dtos[1] + '&page='+ page +'&size=' + size;
        } else if (dtos[1] === " " && dtos[2] !== "") {
          url += '?sort='+ sort + '&filter='+ filter + '&gt='+ dtos[2] +'&page='+ page +'&size=' + size;
        } else if (dtos[1] !== " " && dtos[2] !== "") {
          url += '?sort='+ sort + '&filter='+ filter + '&lt='+ dtos[1] + '&gt='+ dtos[2]  +'&page='+ page +'&size=' + size;
        } else {
          url += '?sort='+ sort + '&filter='+ filter + '&page='+ page +'&size=' + size;
        }

      } else if (sort !== "" && filter[0] === "" && filter[1] !== "<reg>") {

        dtos = filter[1].split("<reg>");
        if (dtos[1] !== " " && dtos[2] === "") {
          url += '?sort='+ sort + '&lt='+ dtos[1] + '&page='+ page +'&size=' + size;
        } else if (dtos[1] === " " && dtos[2] !== "") {
          url += '?sort='+ sort + '&gt='+ dtos[2] +'&page='+ page +'&size=' + size;
        } else if (dtos[1] !== "" && dtos[2] !== "") {
          url += '?sort='+ sort + '&lt='+ dtos[1] + '&gt='+ dtos[2]  +'&page='+ page +'&size=' + size;
        }

      } else if (sort === "" && filter[0] === "" && filter[1] !== "<reg>") {

        dtos = filter[1].split("<reg>");
        if (dtos[1] !== " " && dtos[2] === "") {
          url += '?lt='+ dtos[0] + '&page='+ page +'&size=' + size;
        } else if (dtos[1] === " " && dtos[2] !== "") {
          url += '?gt='+ dtos[1] +'&page='+ page +'&size=' + size;
        } else if (dtos[1] !== "" && dtos[2] !== "") {
          url += '?lt='+ dtos[1] + '&gt='+ dtos[2]  +'&page='+ page +'&size=' + size;
        }

      } else if (sort !== "" && filter[0] !== "" && filter[1] === "<reg>") {
        sort = sort.replace("tipo","type");
        sort = sort.replace("activo","active");
        url += '?sort='+ sort + '&filter='+ filter + '&page='+ page +'&size=' + size;
      } else {
        url += '?page='+ page + '&size=' + size;
      }

      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.vehicles.forEach(function(elemento) {
          if (elemento.active) {
            elemento.activo = colores[1];
            elemento.titleText = "Activo";
            elemento.hideBtnActivar = false;
            elemento.hideBtnDesactivar = true;
          } else {
            elemento.activo = colores[0];
            elemento.titleText = "Inactivo";
            elemento.hideBtnActivar = true;
            elemento.hideBtnDesactivar = false;
          }

          if (elemento.type === 0) {
            elemento.tipo = "Hibrido";
          } else if (elemento.type === 1) {
            elemento.tipo = "Diesel";
          } else if (elemento.type === 2) {
            elemento.tipo = "Eléctrico";
          }
          elemento.tooltip = [{name: $translate.instant('Modelo') + "" + ": " + validaVacios(elemento.model)},
                              {name: $translate.instant('Motor')  + "" + ": " + validaVacios(elemento.engine)},
                              {name: $translate.instant('Depósito')  + "" + "(L): " + validaVacios(elemento.deposit)},
                              {name: $translate.instant('Vel. Max')  + "" + ": " + validaVacios(elemento.velMax)},
                              {name: $translate.instant('Vehiculo Externo')  + "" + ": " + validaVacios(elemento.idExternal)},
                              {name: $translate.instant('Número de obra')  + "" + ": " + validaVacios(elemento.workNumber)},
                              {name: $translate.instant('VIN')  + "" + ": " + validaVacios(elemento.vin)},
                              {name: $translate.instant('Mac interoperable')  + "" + ": " + validaVacios(elemento.macInteroperable)},
                              {name: $translate.instant('Chasis') + "" + ": " + validaVacios(elemento.sistemConfiguration)}
                            ];
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('altaVehiculoService', altaVehiculoService);

  function altaVehiculoService($log, $http, $window, $q, $timeout, $translate, constantes, conexion) {
    var service = {
      getFlotas: getFlotas,
      getSedes: getSedes,
      getGrupos: getGrupos,
      postMasivoVehiculo: postMasivoVehiculo,
      postVehiculo: postVehiculo,
      putVehiculo: putVehiculo,
      deleteVehiculo: deleteVehiculo
    };

    return service;

    function getFlotas () {
      var url = constantes.getApiUrl('ips_corp', 'getCuentasFlotasVehiculos');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          elemento.display = elemento.name;
          elemento.value = elemento.name.toLowerCase();
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getSedes(dtos){
      var url = constantes.getApiUrl('ips_mng', 'getSedesVehiculos');
      url = url.replace("{0}", dtos.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          elemento.display = elemento.code;
          elemento.value = elemento.code.toLowerCase();
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getGrupos(dtos){
      var url = constantes.getApiUrl('ips_mng', 'getGruposVehiculos');
      url = url.replace("{0}", dtos.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          elemento.display = elemento.code;
          elemento.value = elemento.code.toLowerCase();
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function valida(dto){
      var resp = dto;
      if (dto === "undefined") {
        resp = "";
        return resp;
      }
      return resp;
    }

    function postMasivoVehiculo(dtos) {
      var deferred  = $q.defer();
      var promisesAlta = [];
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      for (var i = 0; i < dtos.length; i++) {
        var url = constantes.getApiUrl('ips_mng', 'postVehiculos');
        url = url.replace("{0}", dtos[i].uid);
        var params = {
          "idOperator": dtos[i].id,
          "uidOperator": dtos[i].uid,
          "idGroupType": dtos[i].idGrupo,
          "idHeadquarters": dtos[i].idSede,
          "code" : dtos[i].code,
          "type" : dtos[i].valType,
          "model" : dtos[i].model,
          "velMax": dtos[i].velMax,
          "deposit": dtos[i].deposit,
          "engine": dtos[i].engine,
          "registration": dtos[i].registration,
          "idExternal" : dtos[i].idExternal,
          "workNumber": dtos[i].workNumber,
          "vin": dtos[i].vin,
          "macInteroperable": dtos[i].macInteroperable,
          "sistemConfiguration": dtos[i].sistemConfiguration
        };

        promisesAlta.push($http.post(url, params, config).then(function(response){
          return response;
        },function(error){
          return error;
        }));
      }
      var theResults = [];
      $q.all(promisesAlta).then(function(result) {
        for (var i = 0; i < result.length; i++) {
          theResults.push(result[i]);
        }
        deferred.resolve(theResults);
      }, function(error) {
        error.error = "Ocurrio un error inesperado";
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function postVehiculo(dtos) {
      var url = constantes.getApiUrl('ips_mng', 'postVehiculos');
      url = url.replace("{0}", dtos.nameOperator.uid);
      var datos = localStorage.getItem('datosPrimeraParte');
      datos = datos.split(",");
      var params = {
        "idOperator": dtos.nameOperator.id,
        "uidOperator": dtos.nameOperator.uid,
        "idGroupType": dtos.nameGroupType.id,
        "idHeadquarters": dtos.nameHeadquarters.id,
        "code" : valida(datos[0]),
        "type" : valida(datos[1]),
        "model" : valida(datos[2]),
        "velMax": valida(datos[3]),
        "deposit": valida(datos[4]),
        "engine": valida(datos[5]),
        "registration": valida(datos[6]),
        "idExternal" : valida(datos[7]),
        "workNumber": valida(datos[8]),
        "vin": valida(datos[9]),
        "macInteroperable": valida(datos[10]),
        "sistemConfiguration": valida(datos[11])
      };
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      localStorage.removeItem('datosPrimeraParte');
      return $http.post(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function putVehiculo(dtos) {
      var url = constantes.getApiUrl('ips_mng', 'putVehiculos');
      url = url.replace("{0}", dtos.uidOperator).replace("{1}",dtos.uid);
      var params = {
        "idOperator": dtos.idOperator,
        "uidOperator": dtos.uidOperator,
        "idGroupType": dtos.idGroupType,
        "idHeadquarters": dtos.idHeadquarters,
        "code" : dtos.code,
        "type" : dtos.type,
        "model" : dtos.model,
        "velMax": dtos.velMax,
        "deposit": dtos.deposit,
        "engine": dtos.engine,
        "registration": dtos.registration,
        "idExternal" : dtos.idExternal,
        "workNumber": dtos.workNumber,
        "vin": dtos.vin,
        "macInteroperable": dtos.macInteroperable,
        "sistemConfiguration": dtos.sistemConfiguration,
        "active" : true
      };
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.put(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function deleteVehiculo(dtos) {
      var url = constantes.getApiUrl('ips_mng', 'deleteVehiculos');
      url = url.replace("{0}", dtos.uidOperator).replace("{1}",dtos.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.delete(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikVehiculosManager', datikVehiculosManager);

  function datikVehiculosManager() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/vehiculos/directives/tblVehiculos.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate',
        '$timeout', '$uibModal', '$mdDialog', 'vehiService', 'conexion', 'notificaciones', '$q', 'tblCuentasService', vehiculosManagerController
      ]
    };

    function vehiculosManagerController($log, $scope, $filter, $translate,
      $timeout, $uibModal, $mdDialog, vehiService, conexion, notificaciones,$q, tblCuentasService) {

      var vm = this;
      var filtros = "";
      var sort = "";
      vm.disabledCSV = true;
      vm.loading = true;
      vm.loadingBoton = false;
      vm.loadingFiltros = false;
      localStorage.removeItem('datosPrimeraParte');
      vm.eventoVehiculosSeleccionado = 'vehiculo-table-change-selection';
      var tipo = [$translate.instant("Hibrido"), $translate.instant("Diesel"), $translate.instant("Eléctrico")];

      vm.headerVehiculos = [$translate.instant('Activo'), $translate.instant('Entrada Servicio'), $translate.instant('Código Vehículo'), $translate.instant('ID Vehiculo'), $translate.instant('Número de obra'),
      $translate.instant('Matrícula'), $translate.instant('Tipo vehiculo'), $translate.instant('Cliente'), $translate.instant('Sede'), $translate.instant('Tipo Grupo'), $translate.instant('Modelo'), $translate.instant('Motor'),
      $translate.instant('Depósito'),$translate.instant('Vel. Max'),$translate.instant('Vehiculo Externo'),$translate.instant('Número de obra'),$translate.instant('VIN'),$translate.instant('Mac interoperable'),$translate.instant('Chasis')];

      var colores = ["transparent;margin-left: 8px;margin-top: 4px;height: 25px;width: 25px;border-radius: 25px;border-style: solid;border-width: 2px;border-color: #D13F4A",
                     "#4EAD5C;margin-left: 8px;margin-top: 4px;height: 25px;width: 25px;border-radius: 25px"];

      var shouldHideBtnFunctionAct = function(elemento/*,indexRelativo*/){
        if(angular.isUndefined(elemento.hideBtnActivar) || !elemento.hideBtnActivar){
          return false;
        }
        return true;
      };

      var shouldHideBtnFunctionDes = function(elemento/*,indexRelativo*/){
        if(angular.isUndefined(elemento.hideBtnDesactivar) || !elemento.hideBtnDesactivar){
          return false;
        }
        return true;
      };

      function funcionInfo (){
        $log.info("Info.");
      }

      var disabledNotDisabledInactiveVehiculos = function(elemento/*,indexRelativo*/){
        if (angular.isDefined(elemento)) {
          if (!tblCuentasService.obtinePermisos(9)) {
            vm.permisoVehiculos = true;
            return true;
          }
        }
      };

      var disabledNotDisabledActiveVehiculos = function(elemento/*,indexRelativo*/){
        if (angular.isDefined(elemento)) {
          if (!tblCuentasService.obtinePermisos(9)) {
            vm.permisoVehiculos = true;
            return true;
          }
        }
      };

      var disabledNotDisabledEditPartOneVehiculos = function(elemento/*,indexRelativo*/){
        if (angular.isDefined(elemento)) {
          if (!tblCuentasService.obtinePermisos(9)) {
            vm.permisoVehiculos = true;
            return true;
          }
        }
      };

      var disabledNotDisabledEditPartTwoVehiculos = function(elemento/*,indexRelativo*/){
        if (angular.isDefined(elemento)) {
          if (!tblCuentasService.obtinePermisos(9)) {
            vm.permisoVehiculos = true;
            return true;
          }
        }
      };

      $scope.$on('recuperDtosForm', function(event,datos) {
          vm.dtosForm = datos;
      });

      $scope.showLoadingVehiculos = function(dato){
        if (dato == 1) {
          vm.loadingBoton = true;
        } else {
          vm.loadingBoton = false;
        }
      };

      $scope.refrescarVehiculos = function(){
        getVehiculos(1,40,filtros,sort);
      };

      $scope.limpiarDtosRecuperados = function(){
        vm.dtosForm = undefined;
      };

      // CREACION DE LA TABLA DE EQUIPAMIENTOS
      vm.tblVehiculos = {
        contenedor: "tblScrollableComplete",
        maxHeight: "calc(100vh - 260px)",
        currentPage: 1,
        perPage: 1000000,
        elements: [{
          title: 'Activo',
          information: 'activo',
          type: 'colorVehiculos',
          titleText: 'titleText',
          sortArray: colores,
          width: '10%'
          }, {
          title: 'Entrada Servicio',
          information: 'hightDate',
          // sort: 'reverse',
          type: 'date',
          width: '10%'
        }, {
          title: 'Código Vehículo',
          information: 'code',
          type: 'string',
          width: '10%'
        }, {
          title: 'ID Vehiculo',
          information: 'id',
          type: 'string',
          width: '8%'
        }, {
          title: 'Número de obra',
          information: 'workNumber',
          type: 'string',
          width: '8%'
        }, {
          title: 'Mac interoperable',
          information: 'macInteroperable',
          type: 'string',
          width: '8%'
        }, {
          title: 'Matrícula',
          information: 'registration',
          type: 'string',
          width: '8%'
        }, {
          title: 'Tipo vehiculo',
          information: 'tipo',
          type: 'string',
          sortArray: tipo,
          width: '8%'
        }, {
          title: 'Cliente',
          information: 'nameOperator',
          type: 'string',
          width: '10%'
        }, {
          title: 'Sede',
          information: 'nameHeadquarters',
          type: 'string',
          width: '10%'
        }, {
          title: 'Tipo Grupo',
          information: 'nameGroupType',
          type: 'string',
          width: '10%'
        }],
        options: {
          title: 'Acciones',
          showTitle: undefined,
          width: undefined,
          buttons: [{
            type: 'tooltip',
            function: funcionInfo
            },{
              title: 'Asignar cliente/vehiculo',
              type: 'addUser',
              disabled: disabledNotDisabledEditPartOneVehiculos,
              function: funcionAsignar
            },{
            title: 'Editar',
            type: 'edit' ,
            disabled: disabledNotDisabledEditPartTwoVehiculos,
            function: funcionEditarVehi // , disabled: disabledNotDisabledEditCuenta,
          },{
            title: 'Desactivar',
            type: 'off',
            function: funcionEliminarVehiDialogo,
            disabled: disabledNotDisabledInactiveVehiculos,
            shouldHideBtn: shouldHideBtnFunctionAct
          },{
            title: 'Activar',
            type: 'plus',
            function: funcionActivarVehiDialogo,
            disabled: disabledNotDisabledActiveVehiculos,
            shouldHideBtn: shouldHideBtnFunctionDes// , disabled: disabledNotDisabledDeleteCuenta, function: funcionEliminar
          }
        ]},
        selection: {
          mode: 'simple',
          getSelectedElements: undefined,
          changeSelectionEventName: $scope.eventoVehiculosSeleccionado
        },
        data: [],
        loadData: function(pages,sizes,filter,sortInicial,flag,deferred) {
          vm.disabledCSV = true;
          vm.loadingFiltros = true;
          var objDtos = {};
          sort = sortInicial;
          filtros = validaFiltros(filter);
          if (flag == 1) {
            vm.tblVehiculos.totalCount = 0;
          }
          vehiService.getVehiculos(pages,sizes,filtros,sort).then(function(data) {
            vm.disabledCSV = false;
            vm.loading = false;
            vm.loadingFiltros = false;
            if (angular.isDefined(data) && angular.isDefined(data.vehicles)) {
              data.vehicles.forEach(function (value) {
                vm.tblVehiculos.data.push(value);
              });
              vm.tblVehiculos.totalCount = data.totalCount;
              objDtos.dtos = data.vehicles;
              objDtos.totalCount = data.totalCount;
            } else {
              objDtos.dtos = [];
              objDtos.totalCount = 0;
            }
            deferred.resolve(objDtos);
          });
          return deferred.promise;
        }
      };

      function validaFiltros(filter) {
        var filtro = "";
        var filtroDate = "<reg>";
        angular.forEach(filter,function (value,index) {
          if (index == "tipo") {
            switch(value) {
              case $translate.instant("Hibrido"):
                value = 0;
                break;
              case $translate.instant("Diesel"):
                value = 1;
                break;
              case $translate.instant("Eléctrico"):
                value = 2;
                break;
              default:
                break;
            }
            index = "type";
            filtro += index +":"+ value + ",";
          } else if (index == "activo"){
            if (value == "transparent") {
              value = false;
            } else {
              value = true;
            }
            index = "active";
            filtro += index +":"+ value + ",";
          } else if (index == "hightDate" && (angular.isDefined(value.lower) || angular.isDefined(value.higher))) {
            var valorLower;
            var valorHigher;
            if (angular.isDefined(value.lower)) {
              valorLower = new Date(value.lower) / 1000;
              filtroDate += index +":"+ valorLower + "<reg>";
            } else {
              filtroDate += " <reg>";
            }

            if (angular.isDefined(value.higher)) {
              valorHigher = new Date(value.higher) / 1000;
              filtroDate += index +":"+ valorHigher;
            }
          } else if(index !== "hightDate" && index !== "activo" && index !== "tipo"){
            filtro += index +":"+ value + ",";
          }
        });

        if (filtro !== "") {
          filtro = filtro.substring(0,filtro.length-1);
          return filtro +"#"+filtroDate;
        }

        return filtro +"#"+filtroDate;
      }

      $scope.$on('reload-primeraParte', function(event) {
          vm.altaVehiculo = event;
      });

      vm.exportarDatos = function(){
        vm.loadingCSV = true;
        var deferred = $q.defer();
        var promises = [];
        var registros = 150;
        var maxPaginas = 1;
        if (vm.tblVehiculos.totalCount > 150) {
            var a = vm.tblVehiculos.totalCount / 150;
            maxPaginas = Math.ceil(a);
        }

        for (var paginasCSV = 1; paginasCSV <= maxPaginas; paginasCSV++) {
          promises.push(vehiService.getVehiculos(paginasCSV,registros,filtros,sort).then(function(data) {
            return data.vehicles;
          }));
        }

        $q.all(promises).then(function(result) {
          vm.loadingCSV = false;
          var newData = [];
          result.forEach(function(elemenResult){
            elemenResult.forEach(function(elemento){
              var modelo = elemento.tooltip[0].name.split(":");
              var motor = elemento.tooltip[1].name.split(":");
              var deposito = elemento.tooltip[2].name.split(":");
              var velMax = elemento.tooltip[3].name.split(":");
              var vehículoExterno = elemento.tooltip[4].name.split(":");
              var numeroObra = elemento.tooltip[5].name.split(":");
              var vin = elemento.tooltip[6].name.split(":");
              var mac = elemento.tooltip[7].name.split(":");
              var chasis = elemento.tooltip[8].name.split(":");

              newData.push({active: elemento.active, hightDate: elemento.hightDate, code: elemento.code, id: elemento.id, workNumber: elemento.workNumber, registration: elemento.registration, tipo: elemento.tipo,
              nameOperator: elemento.nameOperator, nameHeadquarters: elemento.nameHeadquarters, nameGroupType: elemento.nameGroupType, modelo: modelo[1], motor: motor[1], deposito: deposito[1], velMax: velMax[1], vehículoExterno: vehículoExterno[1],
              numeroObra: numeroObra[1], vin: vin[1], mac: mac[1], chasis: chasis[1]});
            });
          });
          deferred.resolve(newData);
        });

        return deferred.promise;
      };

      // FUNCION QUE OBTIENE LOS VEHICULOS EXISTENTES
      function getVehiculos(page,size,filter,sort) {
        vehiService.getVehiculos(page,size,filter,sort).then(function(data) {
          vm.loading = false;
          if (data.vehicles.length > 0) {
            vm.dtosForm = undefined;
            vm.loadingBoton = false;
            vm.tblVehiculos.data = data.vehicles;
            vm.tblVehiculos.totalCount = data.totalCount;
            $scope.$broadcast('limpiarDynamicData',data.vehicles);
          } else {
           getVehiculos(pages,sizes,"#<reg>",sort);
         }
        }, function (error) {
          $log.info(error);
          vm.loading = false;
          vm.tblVehiculos.data = [];
        });
      }

      $scope.funcionPadreTbl = function() {
        $log.info('Recibi la llamada TBL');
      };

      // FUNCION QUE ABRE EL MODAL DE LA ALTA DE UN VEHICULO
      vm.agregarMultiVehi = function () {
        var elemento = {
          titulo:  $translate.instant("Alta múltiple vehículos"),
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/vehiculos/modals/vehiculoMultiple.modal.html',
          controller: 'vehiculoMultipleController as vm',
          // backdrop: 'static',
          q: $q,
          scope: $scope,
          size: 'lg', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        }, function(dato){
          $log.info(dato);
        });
      };

      // FUNCION QUE ABRE EL MODAL DE LA ALTA DE UN VEHICULO
      vm.agregarVehi = function () {
        var states = [
          {display: 'Hibrido',  value:('Hibrido').toLowerCase(),  val: 0},
          {display: 'Diesel',   value:('Diesel').toLowerCase(),   val: 1},
          {display: 'Eléctrico', value:('Eléctrico').toLowerCase(), val: 2}
        ];

        var elemento = {
          dtosRecuperado: vm.dtosForm,
          titulo:  $translate.instant("Alta de vehículo"),
          tipo: states
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/vehiculos/modals/vehiculoPrimeraParte.modal.html',
          controller: 'altaVehiculosController as vm',
          // backdrop: 'static',
          q: $q,
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        }, function(dato){
          $log.info(dato);
        });
      };

      function funcionEditarVehi(data){
        var states = [
          {display: 'Hibrido',  value:('Hibrido').toLowerCase(),  val: 0},
          {display: 'Diesel',   value:('Diesel').toLowerCase(),   val: 1},
          {display: 'Eléctrico', value:('Eléctrico').toLowerCase(), val: 2}
        ];

        var elemento = {
          titulo:  $translate.instant("Modificación de un vehículo"),
          tipo: states,
          element: data
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/vehiculos/modals/vehiculoPrimeraParte.modal.html',
          controller: 'editarVehiculosController as vm',
          q: $q,
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        });
      }

      function funcionAsignar(data){
        var elemento = {
          titulo:  $translate.instant("Modificacion de un vehículo"),
          element: data
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/vehiculos/modals/vehiculoEdicionSegundaParte.modal.html',
          controller: 'editarVehiculosDosController as vm',
          q: $q,
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        });
      }

      function funcionEliminarVehiDialogo(data) {
        var elemento = {
          titulo:  $translate.instant("Eliminación de un vehículo"),
          element: data
        };
        $mdDialog.show({
          controller: 'eliminarVehiculosController as vm',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals:{scopeDataToPass: $scope},
          resolve: {
            datos: function() {
              return elemento;
            }
          },
          template:
          '<md-dialog md-theme="default" aria-label="{{vm.titulo}}" ng-class="dialog.css" class="_md md-default-theme md-transition-in" role="dialog" tabindex="-1" aria-describedby="dialogContent_0">' +
          '  <md-dialog-content class="md-dialog-content" role="document" tabindex="-1">' +
          '    <h2 class="md-title ng-binding">{{vm.titulo}}</h2>' +
          '    <div class="md-dialog-content-body ng-scope">' +
          '     <p class="ng-binding">{{"¿Está seguro de que quiere dar de baja el vehículo" | translate}} {{vm.response.code}}?</p>' +
          '    </div>' +
          '  </md-dialog-content>' +
          '  <md-dialog-actions>' +
          '  <md-button ng-click="vm.close()" class="md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" type="button">' +
          '     {{"Cancelar" | translate }} ' +
          '   </md-button> ' +
          '  <md-button ng-click="vm.aceptarElim(vm.response)" class="md-primary md-raised md-confirm-button md-button md-ink-ripple md-default-theme" type="button">' +
          '     {{"Eliminar" | translate}}' +
          '  </md-button>' +
          ' </md-dialog-actions>' +
          '</md-dialog>'
        }).then(function() {
          $log.info("Dialog Close Vehicles");
        });
      }

      function funcionActivarVehiDialogo(data) {
        var elemento = {
          titulo:  $translate.instant("Dar de alta vehículo"),
          element: data
        };
        $mdDialog.show({
          controller: 'activarVehiculosController as vm',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals:{scopeDataToPass: $scope},
          resolve: {
            datos: function() {
              return elemento;
            }
          },
          template:
          '<md-dialog md-theme="default" aria-label="{{vm.titulo}}" ng-class="dialog.css" class="_md md-default-theme md-transition-in" role="dialog" tabindex="-1" aria-describedby="dialogContent_0">' +
          '  <md-dialog-content class="md-dialog-content" role="document" tabindex="-1">' +
          '    <h2 class="md-title ng-binding">{{vm.titulo}}</h2>' +
          '    <div class="md-dialog-content-body ng-scope">' +
          '     <p class="ng-binding">{{"¿Está seguro de querer dar de alta el vehículo" | translate}} {{vm.response.code}}?</p>' +
          '    </div>' +
          '  </md-dialog-content>' +
          '  <md-dialog-actions>' +
          '  <md-button ng-click="vm.close()" class=" md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" type="button">' +
          '     {{"Cancelar" | translate }} ' +
          '   </md-button> ' +
          '  <md-button ng-click="vm.activarVehiculo(vm.response)" class="md-primary md-raised md-confirm-button md-button md-ink-ripple md-default-theme" type="button">' +
          '     {{"Dar de alta" | translate}}' +
          '  </md-button>' +
          ' </md-dialog-actions>' +
          '</md-dialog>'
        }).then(function() {
          $log.info("Dialog Close Vehicles");
        });
      }

      // getVehiculos(0,0);

    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:TblVehiculosController
   * @description
   * Controller para el menu de Live
   *
   */

  angular
    .module('app')
    .directive('datikVehiculos', datikVehiculos);

  function datikVehiculos() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/vehiculos/directives/mainVehiculos.html',
      controllerAs: 'vm',
      controller: ['$log', '$translate', '$filter', '$location', '$uibModal',
      'conexion', 'constantes', 'ayuda', 'composicion', '$scope', tblVehiculosController
      ]
    };

    function tblVehiculosController ($log, $translate, $filter, $location, $uibModal,
      conexion, constantes, ayuda, composicion, $scope) {

    var vm = this;


    }
  }
})();

(function() {
  'use strict';

    /**
     * @ngdoc function
     * @name datik-selectores.directive:datikTable
     * @description
     * # datikTable
     * Directive de las tablas de Datik
     */
    angular.module('app')
      .directive('datikVehiculosSegparte', datikVehiculosSegparte);

    function datikVehiculosSegparte() {
      return {
        restrict: 'E',
        scope: {
          accountevent: '@'
        },
        templateUrl: 'app/views/vehiculos/modals/vehiculoSegundaParte.modal.html',
        controllerAs: 'vm',
        controller: ['$log', '$scope', '$filter', '$translate',
          '$timeout', '$uibModal', 'altaVehiculoService', 'conexion', 'notificaciones', '$q', vehiculosSegundaParteManagerController
        ]
      };

      function vehiculosSegundaParteManagerController($log, $scope, $filter, $translate,
        $timeout, $uibModal, altaVehiculoService, conexion, notificaciones, $q) {

        var vm = this;
        var lstDtosFlota = "";
        var lstDtosSede = "";
        var lstDtosGrupo = "";
        var dtosOcultos = undefined;
        var scopePrimerModal = undefined;
        vm.btnSegPart = true;
        vm.simulateQuery = false;
        vm.altaVehiculo = false;
        vm.sedeDisabled = true;
        vm.grupoDisabled = true;
        vm.showSedeGrupo = true;

        vm.regPrimeraPrt = function(dtos){
          dtosOcultos.nameOperator = dtos.nameOperator;
          dtosOcultos.nameHeadquarters = dtos.nameHeadquarters;
          dtosOcultos.nameGroupType = dtos.nameGroupType;
          $scope.$emit('regresar-primerPantalla',dtosOcultos);
        };

        $scope.$on('iniciaSegParte', function(event, datosInputOculto,scopePrimeraParte) {
          getFlota();
          scopePrimerModal = scopePrimeraParte;
          if (angular.isDefined(datosInputOculto)) {
            dtosOcultos = datosInputOculto;
            vm.response = angular.copy(datosInputOculto);
            if(angular.isDefined(vm.response.nameOperator) && vm.response.nameOperator !== null &&
               angular.isDefined(vm.response.nameHeadquarters) && vm.response.nameHeadquarters !== null &&
               angular.isDefined(vm.response.nameGroupType) && vm.response.nameGroupType !== null) {
                 vm.btnSegPart = false;
                 getSede(vm.response.nameOperator);
                 getGrupo(vm.response.nameOperator);
               }
          }
        });

        vm.querySearchFlota = function (query) {
          var results = query ? lstDtosFlota.filter(createFilterFor(query),lstDtosFlota) : lstDtosFlota,
            deferred;
            if (vm.simulateQuery) {
              deferred = $q.defer();
              $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
              return results;
            }
        };

        vm.querySearchSede = function (query) {
          var results = query ? lstDtosSede.filter(createFilterFor(query,lstDtosSede)) : lstDtosSede,
            deferred;
            if (vm.simulateQuery) {
              deferred = $q.defer();
              $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
              return results;
            }
        };

        vm.querySearchGrupo = function (query) {
          var results = query ? lstDtosGrupo.filter(createFilterFor(query,lstDtosGrupo)) : lstDtosGrupo,
            deferred;
            if (vm.simulateQuery) {
              deferred = $q.defer();
              $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
              return results;
            }
        };

        function createFilterFor(query,lstDtos) {
          var lowercaseQuery = angular.lowercase(query);
          return function filterFn(lstDtos) {
            return (lstDtos.value.indexOf(lowercaseQuery) === 0);
          };
        }

        vm.selectedItemChange = function (item) {
          if (angular.isDefined(item)) {
            vm.showSedeGrupo = false;
            getSede(item);
            getGrupo(item);
          } else {
            vm.sedeDisabled = true;
            vm.selectedItemSede = null;
            vm.searchSede = "";
            vm.grupoDisabled = true;
            vm.selectedItemGrupo = null;
            vm.searchGrupo = "";
          }
        };

        function getFlota(){
          altaVehiculoService.getFlotas().then(function(data) {
            if (data.length > 0) {
              lstDtosFlota = data;
            }
          }, function (error) {
            $log.info(error);
          });
        }

        function getSede(dtos){
          altaVehiculoService.getSedes(dtos).then(function(data) {
            if (data.length > 0) {
              lstDtosSede = data;
              vm.sedeDisabled = false;
              vm.showSedeGrupo = true;
            } else {
              vm.sedeDisabled = true;
            }
          }, function (error) {
            $log.info(error);
          });
        }

        function getGrupo(dtos){
          altaVehiculoService.getGrupos(dtos).then(function(data) {
            if (data.length > 0) {
              lstDtosGrupo = data;
              vm.grupoDisabled = false;
              vm.showSedeGrupo = true;
            } else {
              vm.grupoDisabled = true;
            }
          }, function (error) {
            $log.info(error);
          });
        }

        vm.guardarVehi = function (datos) {
          $scope.$emit('closeModal');
          $scope.$parent.invocaFuncishowLoading(1);
          altaVehiculoService.postVehiculo(datos).then(function(data) {
            if (data.status === 200) {
              notificaciones.showNotification("Vehiculos", "El alta del vehiculo fue realizada correctamente", "success");
              $scope.$parent.invocaFuncionGetVehiculos();
            } else {
              if (angular.isDefined(data.data.message)) {
                notificaciones.showNotification(data.data.message, "Error al intentar dar de alta un vehiculo", "error");
              } else {
                notificaciones.showNotification("Vehiculos", "Error al intentar dar de alta un vehiculo", "error");
              }
              $scope.$parent.invocaFuncishowLoading(0);
            }
          }, function(error) {
            notificaciones.showNotification("Vehiculos", "Error al intentar dar de alta un vehiculo " + error, "error");
            $scope.$parent.invocaFuncishowLoading(0);
          });
        };

        vm.recuperDtosDos = function(datos){
           $scope.$emit("recuperDtosForm",datos);
        };

        vm.validaDtosForm = function (dtos) {
          var datos = localStorage.getItem('datosPrimeraParte');
          // if(dtos.projectPartDosForm.$dirty === false){
            // vm.btnSegPart = true;
            // return;
          // }

          if(dtos.nameOperator === null || angular.isUndefined(dtos.nameOperator)){
            vm.btnSegPart = true;
            return;
          }

          if(dtos.nameHeadquarters === null || angular.isUndefined(dtos.nameHeadquarters)){
            vm.btnSegPart = true;
            return;
          }

          if(dtos.nameGroupType === null || angular.isUndefined(dtos.nameGroupType)){
            vm.btnSegPart = true;
            return;
          }

          if(angular.isUndefined(datos)) {
            vm.btnSegPart = true;
            return;
          }
          vm.btnSegPart = false;
        };
      }
    }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:vehiculoMultipleController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('vehiculoMultipleController', vehiculoMultipleController);

  function vehiculoMultipleController($log,  $uibModalInstance, $scope, datos, $sce, notificaciones, $q, $filter, $interval, $translate, altaVehiculoService) {
    var vm = this;
    var _lstFlotas = "";
    var arrayPromesas = [];
    vm.Items = [];
    vm.titulo = datos.titulo;
    vm.response = angular.copy(datos.element);
    vm.loadingAlta = false;
    vm.disabledBtnAlta = true;
    vm.showContent = true;
    vm.progressBar = 1;
    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    vm.loadDatos = function() {
      var inputs = document.querySelectorAll('.input-file');
      inputs[0].addEventListener('change', recorrerDatos, false);
    };

    $interval(function() {
      if (vm.progressBar === 100) {
        vm.progressBar = 1;
      }
      vm.progressBar += 1;
    }, 100, 0, true);

    function recorrerDatos(oEvent) {
      // Get The File From The Input
      var oFile = oEvent.target.files[0];
      var sFilename = oFile.name;
      // Create A File Reader HTML5
      var reader = new FileReader();

      // Ready The Event For When A File Gets Selected
      reader.onload = function(e) {
        var datos = e.target.result;
        var record = datos.split(/\r\n|\n/);
        var headers = record[0].split(',');
        var param = ["code", "type", "model", "velMax", "deposit", "engine", "registration", "idExternal", "workNumber",
          "vin", "sistemConfiguration", "macInteroperable", "nameOperator", "nameHeadquarters", "nameGroupType"];
        vm.disabledBtnAlta = true;
        var json = {};
        for (var i = 1; i < record.length-1; i++) {
          var data = record[i].split(',');
          var valTipo = 0;
          var flota = $filter('filter')(_lstFlotas,{'name': data[12]})[0];
          var flotaId = flota.id;
          var flotaUid = flota.uid;
          var sede = "";
          var grupo = "";
          var cont = 0;

          if (data[1] === 'Hibrido') {
            valTipo = 0;
          } else if (data[1] === 'Diesel') {
            valTipo = 1;
          } else if (data[1] === 'Eléctrico') {
            valTipo = 2;
          }

          for (var j = 0; j < data.length; j++) {
            if (data[j] !== "") {
              cont++;
            }
          }

          var cadena = $translate.instant('Modelo') + " : " + data[2] + "<br>" +
                       $translate.instant('Vel. Max') + " : " + data[3] + "<br>" +
                       $translate.instant('Depósito') + " : " + data[4] + "<br>" +
                       $translate.instant('Motor') + " : " + data[5] + "<br>" +
                       $translate.instant('Matrícula') + " : " + data[6] + "<br>" +
                       $translate.instant('Vehiculo Externo') + " : " + data[7] + "<br>" +
                       $translate.instant('Número de obra') + " : " + data[8] + "<br>" +
                       $translate.instant('VIN') + " : " + data[9] + "<br>" +
                       $translate.instant('Chasis') + " : " + data[10] + "<br>" +
                       $translate.instant('Mac interoperable') + " : " + data[11] + "<br>" +
                       $translate.instant('Cliente') + " : "  + data[12] + "<br>" +
                       $translate.instant('Sede') + " : " + data[13] + "<br>" +
                       $translate.instant('Tipo Grupo') + " : " + data[14];

          json [i - 1] = { code: data[0], type: data[1], valType: valTipo, model: data[2], velMax: data[3], deposit: data[4], engine: data[5], registration: data[6], idExternal: data[7], workNumber: data[8], vin: data[9], sistemConfiguration: data[10],
            macInteroperable: data[11], nameOperator: data[12], id: flotaId, uid: flotaUid, nameHeadquarters: data[13], idSede: sede, nameGroupType: data[14], idGrupo: grupo, dtos: (cont-2), status: "", cadena: $sce.trustAsHtml(cadena), message: ""};

          vm.Items.push(json[i - 1]);

          arrayPromesas.push(obtSede(flota,(i -1)));
          arrayPromesas.push(obtGrupo(flota,(i -1)));

          $q.all(arrayPromesas).then(function(result){
            if (result.length === arrayPromesas.length) {
              vm.disabledBtnAlta = false;
            }
          });
        }
      };
      reader.readAsText(oFile, 'UTF-8');
      vm.showContent = false;
    }

    vm.cargar = function() {
      vm.loadingAlta = true;
      for (var i = 0; i < vm.Items.length; i++) {
        vm.Items[i].status = 0;
      }

      altaVehiculoService.postMasivoVehiculo(vm.Items).then(function(response) {
      $scope.refrescarVehiculos();
      vm.loadingAlta = false;
       for (var i = 0; i < vm.Items.length; i++) {
         for (var j = 0; j < response.length; j++) {
           if (response[j].status === 200) {
             if (vm.Items[i].code === response[j].data.code) {
                vm.Items[i].status = response[j].status;
             }
           } else {
             var value = response[j].data.value.split(":");
             if (vm.Items[i].code === value[1].trim()) {
                vm.Items[i].status = response[j].status;
                vm.Items[i].message = response[j].data.message;
             }
           }
         }
       }
     }, function(error) {
       vm.loadingAlta = false;
       for (var i = 0; i < vm.Items.length; i++) {
         vm.Items[i].status = 400;
       }
     });
    };

    function obtSede(uidFlota, posicion){
      var deferred = $q.defer();
      altaVehiculoService.getSedes(uidFlota).then(function(data) {
        vm.Items[posicion].idSede = $filter('filter')(data,{'code': vm.Items[posicion].nameHeadquarters})[0].id;
        deferred.resolve();
      }, function(err) {
        deferred.reject();
      });
      return deferred.promise;
    }

    function obtGrupo(uidFlota, posicion){
      var deferred = $q.defer();
      altaVehiculoService.getGrupos(uidFlota).then(function(data) {
        vm.Items[posicion].idGrupo = $filter('filter')(data,{'code': vm.Items[posicion].nameGroupType})[0].id;
        deferred.resolve();
      }, function(err) {
        deferred.reject();
      });
      return deferred.promise;
    }

    function getFlota(){
      altaVehiculoService.getFlotas().then(function(data) {
        if (data.length > 0) {
          _lstFlotas = data;
        }
      }, function (error) {
        $log.info(error);
      });
    }

    getFlota();

  }
})();

(function(){
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:eliminarVehiculosController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('eliminarVehiculosController', eliminarVehiculosController);

    function eliminarVehiculosController($log, $mdDialog, scopeDataToPass, datos, notificaciones, $q, $translate, altaVehiculoService){
      var vm = this;
      vm.titulo = datos.titulo;
      vm.response = angular.copy(datos.element);
      vm.close = function() {
        $mdDialog.cancel();
      };

      var VEHICULOS = $translate.instant("Vehículos");

      vm.aceptarElim = function(dato){
        $mdDialog.hide();
        altaVehiculoService.deleteVehiculo(dato).then(function(data){
          if(data.status === 204){
            notificaciones.showNotification(VEHICULOS, $translate.instant("La eliminación de vehiclo fue realizada correctamente"), "success");
            scopeDataToPass.refrescarVehiculos();
          }else{
            if (angular.isDefined(data.data.message)) {
              notificaciones.showNotification(data.data.message, $translate.instant("Error al intentar Eliminar un vehículo"), "error");
            } else {
              notificaciones.showNotification(VEHICULOS, $translate.instant("Error al intentar Eliminar un vehículo"), "error");
            }
            scopeDataToPass.refrescarVehiculos();
          }
        },function(error){
            notificaciones.showNotification(VEHICULOS, $translate.instant("Error al intentar dar de baja un vehículo")  + error, "error");
            scopeDataToPass.refrescarVehiculos();
        });
      };
    }

})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:editarVehiculosDosController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('editarVehiculosDosController', editarVehiculosDosController);

  function editarVehiculosDosController($log, $uibModalInstance, $scope, $q, $timeout, datos, notificaciones, $translate, altaVehiculoService) {
    var vm = this;
    var lstDtosFlota = "";
    var lstDtosSede = "";
    var lstDtosGrupo = "";
    vm.titulo = datos.titulo;
    vm.guardarEditDos = false;
    vm.simulateQuery = false;
    vm.showSedeGrupo = true;
    vm.response = angular.copy(datos.element);
    var dats = {uid:datos.element.uidOperator};
    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    var VEHICULOS = $translate.instant("Vehículos");

    vm.querySearchFlota = function (query) {
      var results = query ? lstDtosFlota.filter(createFilterFor(query),lstDtosFlota) : lstDtosFlota,
        deferred;
        if (vm.simulateQuery) {
          deferred = $q.defer();
          $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
          return results;
        }
    };

    vm.querySearchSede = function (query) {
      var results = query ? lstDtosSede.filter(createFilterFor(query,lstDtosSede)) : lstDtosSede,
        deferred;
        if (vm.simulateQuery) {
          deferred = $q.defer();
          $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
          return results;
        }
    };

    vm.querySearchGrupo = function (query) {
      var results = query ? lstDtosGrupo.filter(createFilterFor(query,lstDtosGrupo)) : lstDtosGrupo,
        deferred;
        if (vm.simulateQuery) {
          deferred = $q.defer();
          $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
          return results;
        }
    };

    function createFilterFor(query,lstDtos) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(lstDtos) {
        return (lstDtos.value.indexOf(lowercaseQuery) === 0);
      };
    }

    vm.selectedItemChange = function (item) {
      if (angular.isDefined(item)) {
        vm.showSedeGrupo = false;
        getSede(item);
        getGrupo(item);
      } else {
        vm.sedeDisabled = true;
        vm.selectedItemSede = null;
        vm.searchSede = "";
        vm.grupoDisabled = true;
        vm.selectedItemGrupo = null;
        vm.searchGrupo = "";
        getFlota();
      }
    };

    function getFlota(){
      vm.showSedeGrupo = false;
      altaVehiculoService.getFlotas().then(function(data) {
        if (data.length > 0) {
          lstDtosFlota = data;
          vm.showSedeGrupo = true;
        }
      }, function (error) {
        $log.info(error);
      });
    }

    function getSede(dtos){
      altaVehiculoService.getSedes(dtos).then(function(data) {
        if (data.length > 0) {
          lstDtosSede = data;
          vm.sedeDisabled = false;
          vm.showSedeGrupo = true;
        } else {
          vm.sedeDisabled = true;
        }
      }, function (error) {
        $log.info(error);
      });
    }

    function getGrupo(dtos){
      altaVehiculoService.getGrupos(dtos).then(function(data) {
        if (data.length > 0) {
          lstDtosGrupo = data;
          vm.grupoDisabled = false;
          vm.showSedeGrupo = true;
        } else {
          vm.grupoDisabled = true;
        }
      }, function (error) {
        $log.info(error);
      });
    }

    vm.focusEditar = function(dtos){
      if(dtos.projectPartDosForm.$dirty === false){
        vm.guardarEditDos = true;
        return;
      }

      if(dtos.nameOperator === null){
        vm.guardarEditDos = true;
        return;
      }

      if(dtos.nameHeadquarters === null){
        vm.guardarEditDos = true;
        return;
      }

      if(dtos.nameGroupType === null){
        vm.guardarEditDos = true;
        return;
      }

      vm.guardarEditDos = false;
    };

    function validaDatos(dtos) {
      var resp = false;

      if(dtos.nameOperator === null){
        resp = true;
        return resp;
      }

      if(dtos.nameHeadquarters === null){
        resp = true;
        return resp;
      }

      if(dtos.nameGroupType === null){
        resp = true;
        return resp;
      }

      if(angular.isUndefined(datos)) {
        resp = true;
        return resp;
      }
      return resp;
    }

    vm.guardarEditVehi = function(dtos){
      $uibModalInstance.dismiss();
      if (angular.isDefined(dtos.nameGroupType.id)) {
        dtos.idGroupType = dtos.nameGroupType.id;
      }
      if (angular.isDefined(dtos.nameHeadquarters.id)) {
        dtos.idHeadquarters = dtos.nameHeadquarters.id;
      }
      if (angular.isDefined(dtos.nameOperator.id)) {
        dtos.idOperator = dtos.nameOperator.id;
        dtos.uidOperator = dtos.nameOperator.uid;
      }

      if (!validaDatos(dtos)) {
        altaVehiculoService.putVehiculo(dtos).then(function(data) {
          if (data.status === 200) {
            notificaciones.showNotification(VEHICULOS, $translate.instant("La modificación del vehiculo fue realizada correctamente"), "success");
            $scope.refrescarVehiculos();
          } else {
            if (angular.isDefined(data.data.message)) {
              notificaciones.showNotification(data.data.message, $translate.instant("Error al intentar modificar un vehículo"), "error");
            } else {
              notificaciones.showNotification(VEHICULOS, $translate.instant("Error al intentar modificar un vehículo"), "error");
            }
          }
        }, function(error) {
          notificaciones.showNotification(VEHICULOS, $translate.instant("Error al intentar modificar un vehículo") + error, "error");
        });
      }
    };

    getFlota();
    getSede(dats);
    getGrupo(dats);
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:editarVehiculosController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('editarVehiculosController', editarVehiculosController);

  function editarVehiculosController($log, $uibModalInstance, $scope, $q, $timeout, datos, notificaciones, $translate, altaVehiculoService) {
    var vm = this;
    vm.titulo = datos.titulo;
    vm.ocultaPasos = false;
    vm.modalPrimerPart = true;
    vm.modalSegPart = false;
    vm.botonesAlta = false;
    vm.response = angular.copy(datos.element);
    if (datos.element.type === 2) {
      vm.macInter = true;
    }

    // VALIDA QUE EL CARACTER INGRESADO EN EL INPUT NO TENGA ESPACIOS
    vm.validaEspacios = function(e) {
     var keyCode = e.key;
     if (keyCode == " ") {
       e.preventDefault();
     }
   };

   var VEHICULOS = $translate.instant("Vehículos");

    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    $scope.$on('closeModalEdit', function() {
      $uibModalInstance.dismiss();
    });

    vm.itemChange = function (item) {
      if(item === "2"){
        vm.macInter = true;
      } else {
        vm.macInter = false;
      }
    };

    vm.focusAlta = function(dtos){
     if(dtos.projectForm.$dirty === false){
       vm.disabled = true;
       return;
     }

     if(angular.isUndefined(dtos.code)){
       vm.disabled = true;
       return;
     }

     if(angular.isUndefined(dtos.type)){
       vm.disabled = true;
       return;
     }

     if(angular.isUndefined(dtos.model)){
       vm.disabled = true;
       return;
     }

     if(angular.isUndefined(dtos.velMax) || dtos.velMax > 120){
       vm.disabled = true;
       return;
     }
     if(angular.isUndefined(dtos.deposit)){
       vm.disabled = true;
       return;
     }

     vm.disabled = false;
   };

    vm.guardarPP = function(dtos){
      $uibModalInstance.dismiss();

      altaVehiculoService.putVehiculo(dtos).then(function(data) {
        if (data.status === 200) {
          notificaciones.showNotification(VEHICULOS, $translate.instant("La modificación del vehiculo fue realizada correctamente"), "success");
          $scope.refrescarVehiculos();
        } else {
          if (angular.isDefined(data.data.message)) {
            notificaciones.showNotification((data.data.value) ? data.data.value : VEHICULOS, $translate.instant(data.data.message), "error");
          } else {
            notificaciones.showNotification(VEHICULOS, $translate.instant("Error al intentar modificar un vehículo"), "error");
          }
        }
      }, function(error) {
        notificaciones.showNotification(VEHICULOS, $translate.instant("Error al intentar modificar un vehículo") + error, "error");
      });
    };

  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:altaVehiculosController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('altaVehiculosController', altaVehiculosController);

  function altaVehiculosController($log, $uibModalInstance, $scope, $mdSelect, $timeout, datos, notificaciones, $q) {
    var vm = this;
    vm.macInter = false;
    vm.ocultaPasos = true;
    vm.botonesAlta = true;
    vm.disabled = true;
    vm.modalPrimerPart = true;
    vm.modalSegPart = false;
    vm.simulateQuery = false;
    vm.titulo = datos.titulo;
    var dtosSegPart = localStorage.getItem('datosPrimeraParte');

    if (angular.isDefined(datos.dtosRecuperado) && dtosSegPart === null) {
      vm.response = angular.copy(datos.dtosRecuperado);
      if (angular.isDefined(vm.response.type) && angular.isDefined(vm.response.code) &&
        angular.isDefined(vm.response.model) && angular.isDefined(vm.response.velMax) &&
        angular.isDefined(vm.response.registration) && angular.isDefined(vm.response.engine) &&
        angular.isDefined(vm.response.deposit))
        vm.disabled = false;
      if (angular.isDefined(vm.response.type) && vm.response.type === "2") {
        vm.macInter = true;
      } else {
        vm.response.macInteroperable = "";
      }
    } else {
      if (dtosSegPart !== null) {
        vm.modalPrimerPart = false;
        vm.modalSegPart = true;
        $timeout(function () {
          $scope.$broadcast('iniciaSegParte', datos.dtosRecuperado);
        }, 10);
      }
    }

    // VALIDA QUE EL CARACTER INGRESADO EN EL INPUT NO TENGA ESPACIOS
    vm.validaEspacios = function (e) {
      var keyCode = e.key;
      if (keyCode == " ") {
        e.preventDefault();
      }
    };

    vm.close = function () {
      $uibModalInstance.dismiss();
    };

    $scope.$on('closeModal', function () {
      $uibModalInstance.dismiss();
    });

    $scope.invocaFuncishowLoading = function (dto) {
      $scope.showLoadingVehiculos(dto);
    };

    $scope.invocaFuncionGetVehiculos = function () {
      $scope.refrescarVehiculos();
    };

    vm.itemChange = function (item) {
      if (item === "2") {
        vm.macInter = true;
      } else {
        vm.macInter = false;
      }
    };

    vm.focusAlta = function (dtos) {
      if (angular.isUndefined(dtos.code)) {
        vm.disabled = true;
        return;
      }

      if (angular.isUndefined(dtos.type)) {
        vm.disabled = true;
        return;
      }

      if (angular.isUndefined(dtos.model)) {
        vm.disabled = true;
        return;
      }

      if (angular.isUndefined(dtos.velMax) || dtos.velMax > 120) {
        vm.disabled = true;
        return;
      }
      if (angular.isUndefined(dtos.deposit)) {
        vm.disabled = true;
        return;
      }
      if (angular.isUndefined(dtos.registration)) {
        vm.disabled = true;
        return;
      }
      if (angular.isUndefined(dtos.engine)) {
        vm.disabled = true;
        return;
      }

      vm.disabled = false;
    };

    vm.recuperDtos = function (datos) {
      $scope.$emit("recuperDtosForm", datos);
    };

    vm.almacenar = function (dtos) {
      localStorage.removeItem('datosPrimeraParte');
      localStorage.setItem('datosPrimeraParte', dtos.code + "," + dtos.type + "," + dtos.model + "," + dtos.velMax +
        "," + dtos.deposit + "," + dtos.engine + "," + dtos.registration + "," + dtos.idExternal +
        "," + dtos.workNumber + "," + dtos.vin + "," + dtos.macInteroperable + "," + dtos.sistemConfiguration);

      vm.modalPrimerPart = false;
      vm.modalSegPart = true;
      $scope.$broadcast('iniciaSegParte', dtos);
    };

    $scope.$on('regresar-primerPantalla', function (event, datosInputOculto) {
      localStorage.removeItem('datosPrimeraParte');
      vm.modalPrimerPart = true;
      vm.modalSegPart = false;
      if (angular.isDefined(datosInputOculto) && angular.isDefined(dtosSegPart)) {
        vm.response = angular.copy(datosInputOculto);
        if (angular.isDefined(vm.response.type) && angular.isDefined(vm.response.code) &&
          angular.isDefined(vm.response.model) && angular.isDefined(vm.response.velMax) &&
          angular.isDefined(vm.response.registration) && angular.isDefined(vm.response.engine) &&
          angular.isDefined(vm.response.deposit))
          vm.disabled = false;
        if (angular.isDefined(vm.response.type) && vm.response.type === "2") {
          vm.macInter = true;
        } else {
          vm.response.macInteroperable = "";
        }
      }
    });
  }
})();

(function(){
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:activarVehiculosController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('activarVehiculosController', activarVehiculosController);

    function activarVehiculosController($log, $mdDialog, scopeDataToPass, datos, notificaciones, $q, $translate, altaVehiculoService){
      var vm = this;
      vm.titulo = datos.titulo;
      vm.response = angular.copy(datos.element);
      vm.close = function() {
        $mdDialog.cancel();
      };

      var VEHICULOS = $translate.instant("Vehículos");

      vm.activarVehiculo = function(dato){
        $mdDialog.hide();
        altaVehiculoService.putVehiculo(dato).then(function(data){
          if(data.status === 200){
            notificaciones.showNotification(VEHICULOS, $translate.instant("La activación del vehiclo fue realizada correctamente"), "success");
            scopeDataToPass.refrescarVehiculos();
          }else{
            if (angular.isDefined(data.data.message)) {
              notificaciones.showNotification(data.data.message, $translate.instant("Error al intentar Activar un vehículo"), "error");
            } else {
              notificaciones.showNotification(VEHICULOS, $translate.instant("Error al intentar Activar un vehículo"), "error");
            }
            scopeDataToPass.refrescarVehiculos();
          }
        },function(error){
            notificaciones.showNotification(VEHICULOS, $translate.instant("Error al intentar Activar un vehículo")  + error, "error");
            scopeDataToPass.refrescarVehiculos();
        });
      };
    }

})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikTblusuariosManager', datikTblusuariosManager);

  function datikTblusuariosManager() {
    return {
      restrict: 'E',
      scope: {
        // accountevent: '@'
      },
      templateUrl: 'app/views/usuarios/directives/tblUsuarios.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate',
        '$timeout', '$uibModal', '$mdDialog', 'conexion', 'notificaciones', '$q',
        'usuariosService', 'tblCuentasService', usuariosManagerController
      ]
    };

    function usuariosManagerController($log, $scope, $filter, $translate,
      $timeout, $uibModal, $mdDialog, conexion, notificaciones, $q, usuariosService, tblCuentasService) {

      var vm = this;
      vm.loading = false;
      vm.showPermisos = false;

      vm.eventoUserSelec = 'usuarios-table-change-selection';

      // CREACION DE LA TABLA DE RECURSOS
      vm.tblUsuarios = {
        maxHeight: "calc(100vh - 260px) !important",
        currentPage: 1,
        perPage: 1000000,
        elements: [{
          title: 'Nombre usuario',
          information: 'user.username',
          type: 'string',
           width: '10%'
        }, {
          title: 'Nombre cuenta',
          information: 'user.nameAccount',
          type: 'string',
          width: '10%'
        }, {
          title: 'Permisos',
          information: 'cadenaCode',
          type: 'string',
          width: '80%'
        }],
        options: {
          title: 'Acciones',
          showTitle: undefined,
          width: undefined,
          buttons: [
          // {
          //   type: 'tooltipPermisos',
          //   // function: funcionInfo
          // }
          {
            title: 'Editar',
            type: 'edit',
            function: funcionEditarUsu,
            // disabled: disabledNotDisabledEditUsu
          }, {
            title: 'Eliminar',
            type: 'delete',
            function: funcionEliminarUsu,
            // disabled: disabledNotDisabledDeleteUsu
          }]
        },
        selection: {
          mode: 'simple',
          getSelectedElements: undefined,
          changeSelectionEventName: vm.eventoUserSelec
        },
        data: []
      };

      $scope.$on('reloadTblUsuarios-Tab', function(event, elemento) {
        reloadTblUsers(elemento);
      });

      // EVENTO QUE CIERRA EL MODAL DE CUENTAS AL FINALIZAR UNA ALTA DE USUARIO
      $scope.refrescarUsuarios = function() {
        getUsers();
        angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(1) input").attr("disabled", false);
        angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(2) input").attr("disabled", false);
        angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(3) input").attr("disabled", false);

        angular.element(".tblUser .c-datik-table-thead-withscroll .c-datik-table-head-tr").attr("style", "");
        vm.showPermisos = false;
      };

      // FUNCION QUE ABRE EL MODAL DE EDITAR UN USUARIO
      function funcionEditarUsu(data) {
        var elemento = {
          titulo: $translate.instant("Editar"),
          cuenta: data.user.uidOperator,
          element: data.user
        };
        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/cuentas/modals/usuarios.modal.html',
          controller: 'editarUsuarioController as vm',
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
      }

      // FUNCION QUE ABRE EL MODAL DE ELIMINACION DE UN USUARIO
      function funcionEliminarUsu(data) {
        data.user.nombre = $translate.instant("el usuario") + " " + data.user.name;
        var elemento = {
          titulo: $translate.instant("Confimación"),
          cuenta: data.user.uidOperator,
          element: data.user
        };
        $mdDialog.show({
          controller: 'eliminarUsuarioController as vm',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            scopeDataToPass: $scope
          },
          resolve: {
            datos: function() {
              return elemento;
            }
          },
          template:
          '<md-dialog md-theme="default" aria-label="{{vm.titulo}}" ng-class="dialog.css" class="_md md-default-theme md-transition-in" role="dialog" tabindex="-1" aria-describedby="dialogContent_0">' +
            '  <md-dialog-content class="md-dialog-content" role="document" tabindex="-1">' +
            '    <h2 class="md-title ng-binding">{{vm.titulo}}</h2>' +
            '    <div class="md-dialog-content-body ng-scope">' +
            '     <p class="ng-binding">{{"¿Desea eliminar" | translate}} {{vm.response.nombre}}?</p>' +
            '    </div>' +
            '  </md-dialog-content>' +
            '  <md-dialog-actions>' +
            '  <md-button ng-click="vm.close()" class="md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" type="button">' +
            '     {{"Cancelar" | translate }} ' +
            '   </md-button> ' +
            '  <md-button ng-click="vm.aceptar(vm.response)" class="md-primary md-raised md-confirm-button md-button md-ink-ripple md-default-theme" type="button">' +
            '     {{"Eliminar" | translate}}' +
            '  </md-button>' +
            ' </md-dialog-actions>' +
            '</md-dialog>'
        }).then(function() {
          $log.info("Dialog Close Users");
        });
      }

      // EVENTO QUE OBTIENE LOS DATOS DEL USUARIO SELECCIONADO DE LA TABLA DE USUARIOS
      $scope.$on(vm.eventoUserSelec, function(event, elementosSeleccionados) {
        if (elementosSeleccionados.length > 0) {
          elementosSeleccionados[0].uid = elementosSeleccionados[0].user.uidOperator;
          $scope.$broadcast('hideRowsUsers', elementosSeleccionados[0], true);
          // Para enviar un evento a las directivas
          $scope.$broadcast('user-selec', elementosSeleccionados[0]);
          angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(1) input").attr("disabled", true);
          angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(2) input").attr("disabled", true);
          angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(3) input").attr("disabled", true);

          angular.element(".tblUser .c-datik-table-thead-withscroll .c-datik-table-head-tr").attr("style", "pointer-events:none;");
          vm.showPermisos = true;
        } else {
          $scope.$broadcast('hideRowsUsers', elementosSeleccionados[0], undefined);
          angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(1) input").attr("disabled", false);
          angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(2) input").attr("disabled", false);
          angular.element(".tblUser .c-datik-table-filter-row .c-datik-table-filter:nth-child(3) input").attr("disabled", false);

          angular.element(".tblUser .c-datik-table-thead-withscroll .c-datik-table-head-tr").attr("style", "");
          vm.showPermisos = false;
        }
      });

      function getUsers() {
        var deferred = $q.defer();
        vm.loading = true;
        usuariosService.getUsers().then(function(data) {
          if (angular.isDefined(data)) {
            var cuentas = tblCuentasService.getCuentas("").then(function(dataCuentas) {
              data.forEach(function(element) {
                var tipoCuenta = $filter('filter')(dataCuentas,{'uid': element.user.uidOperator})[0];
                element.user.nameAccount = tipoCuenta.name;
              });
              vm.loading = false;
              vm.tblUsuarios.data = data;
            });
          }
          deferred.resolve(vm.tblUsuarios.data);
        });
        return deferred.promise;
      }

      function reloadTblUsers(user) {
        var usuario = user;
        vm.loading = true;
        usuariosService.getUsers().then(function(data) {
          vm.loading = false;
          if (angular.isDefined(data)) {
            for (var i = 0; i < data.length; i++) {
              if(data[i].user.id === usuario.id) {
                $scope.$broadcast('updateRowUser', data[i]);
                break;
              }
            }
          }
        });
      }

      getUsers();

    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:TblUsuariosController
   * @description
   * Controller para el menu de Live
   *
   */

  angular
    .module('app')
    .directive('datikUsers', datikUsers);

  function datikUsers() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/usuarios/directives/mainUsuarios.html',
      controllerAs: 'vm',
      controller: ['$log', '$translate', '$filter', '$location', '$uibModal',
      'conexion', 'constantes', 'ayuda', 'composicion', '$scope', tblUsuariosController
      ]
    };

    function tblUsuariosController ($log, $translate, $filter, $location, $uibModal,
      conexion, constantes, ayuda, composicion, $scope) {

    var vm = this;


    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('recursosService', recursosService);

  function recursosService($log, $http, constantes, conexion, utilidades) {
    var service = {
      getRecursosEquipamiento: getRecursosEquipamiento,
      getRecursos: getRecursos,
      postRecursos: postRecursos,
      putRecursos: putRecursos,
      deleteRecursos: deleteRecursos
    };

    return service;

    function getRecursosEquipamiento(dtosFlota) {
      var url = constantes.getApiUrl('ips_resources', 'getResources');

      var uidCliente = utilidades.isEmpty(dtosFlota.uid) ? dtosFlota.resource.uidOperator : dtosFlota.uid

      url += '?page=1&size=500&resourceTypeCodes=totem,charger&uidClient='+ uidCliente;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.content.forEach(function(elemento) {
          elemento.display = elemento.code;
          elemento.value = elemento.code.toLowerCase();
        });
        
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getRecursos(page,size,filter,sort,resourceTypeCode) {
      
      var url = constantes.getApiUrl('ips_resources', 'getResources');
      if (page !== "" && size !== "" && filter !== "" && sort !== "") {
        url += '?sort='+ sort + '&filter='+ filter + '&page='+ page +'&size=' + size;

      } else if (page !== "" && size !== "" && filter !== "" && sort === "") {
        url += '?filter='+ filter + '&page='+ page +'&size=' + size;

      } else if(page !== "" && size !== "" && filter === "" && sort !== "") {
        url += '?sort='+ sort + '&page='+ page +'&size=' + size;

      } else if(page !== "" && size !== "" && filter === "" && sort === "") {
        url += '?page=' + page + '&size=' + size;
      }

      url += '&resourceTypeCodes=' + resourceTypeCode;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function postRecursos(data) {
      var url = constantes.getApiUrl('ips_resources', 'postResource');
      var params = {
          uidClient: data.cliente.uid,
          code: data.codigo,
          resourceTypeCode: data.recurso
      };
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.post(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function putRecursos(data) {
      var url = constantes.getApiUrl('ips_resources', 'putResource');
      url = url.replace("{0}", data.recursoUid);
      var params = {
        "uidClient": data.cliente.uid,
        "code": data.codigo,
        "originId": 0,
        "resourceTypeCode": data.recurso
      };
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.put(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function deleteRecursos(data) {
      var url = constantes.getApiUrl('ips_resources', 'delResource');
      url = url.replace("{0}", data.uidResource) + '?uidClient=' + data.uidClient;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.delete(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }
  }

})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikRecursosManager', datikRecursosManager);

  function datikRecursosManager() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/recursos/directives/tblRecursos.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate',
        '$timeout', '$uibModal', '$mdDialog', 'conexion', 'notificaciones', '$q',
        'recursosService', 'tblCuentasService', recursosManagerController
      ]
    };

    function recursosManagerController($log, $scope, $filter, $translate,
      $timeout, $uibModal, $mdDialog, conexion, notificaciones, $q, recursosService, tblCuentasService) {

      var vm = this;
      var filtros = "";
      var sort = "";
      var sortDefault = "";
      vm.resourceTypeCode = "totem,pip";
      vm.loading = true;
      vm.loadingBoton = false;
      vm.loadingFiltros = false;
      vm.headerRecursos = [$translate.instant('uid Recurso'), $translate.instant('Código'), $translate.instant('Tipo de recurso'), $translate.instant('Cliente')];
      vm.availableResourceTypes = [$translate.instant("Totem")];//$translate.instant("Bateria"),$translate.instant("Cargadores")

      var disabledNotDisabledEditRecurso = function(elemento/*,indexRelativo*/){
        if (angular.isDefined(elemento)) {
          if (tblCuentasService.obtinePermisos(14) && !tblCuentasService.obtinePermisos(15)) {
            vm.permisoRecursos = true;
            return true;
          } else {
            vm.permisoRecursos = false;
            return false;
          }
        }
      };

      var disabledNotDisabledDeleteRecursos = function(elemento/*,indexRelativo*/){
        if (angular.isDefined(elemento)) {
          if (tblCuentasService.obtinePermisos(14) && !tblCuentasService.obtinePermisos(15)) {
            vm.permisoRecursos = true;
            return true;
          } else {
            vm.permisoRecursos = false;
            return false;
          }
        }
      };

      $scope.$on('recuperDtosRecurso', function(event,datos) {
          vm.dtosFormRecursos = datos;
      });

      $scope.limpiarDtosRecuperadosRecursos = function(){
        vm.dtosFormRecursos = undefined;
      };

      $scope.refrescarRecursos = function() {
        vm.loadingBoton = true;
        getRecursos(1,40,filtros,sort,vm.resourceTypeCode);
      };

      // CREACION DE LA TABLA DE RECURSOS
      vm.tblRecursos = {
        contenedor: "tblScrollableComplete",
        maxHeight: "calc(100vh - 260px) !important",
        currentPage: 1,
        perPage: 1000000,
        elements: [{
          title: 'uid Recurso',
          information: 'uidResource',
          type: 'string'
        }, {
          title: 'Código',
          information: 'code',
          type: 'string'
        }, {
          title: 'Tipo de recurso',
          information: 'resourceTypeCode',
          type: 'string',
          sortArray: ['totem', 'pip']
        }, {
          title: 'Cliente',
          information: 'client',
          type: 'string'
        }],
        options: {
          title: 'Acciones',
          showTitle: undefined,
          width: undefined,
          buttons: [{
            title: 'Editar',
            type: 'edit',
            disabled: disabledNotDisabledEditRecurso,
            function: funcionEditarRecurso
          }, {
            title: 'Eliminar',
            type: 'delete',
            disabled: disabledNotDisabledDeleteRecursos,
            function: funcionEliminarRecurso
          }]
        },
        selection: {
          mode: 'simple',
          getSelectedElements: undefined,
          changeSelectionEventName: $scope.accountevent
        },
        data: [],
        loadData: function(pages,sizes,filter,sortInicial,flag,deferred) {
          vm.loadingFiltros = true;
          var objDtos = {};
          // sort = sortInicial.replace(":",",");
          sort = validaSort(sortInicial);
          filtros = validaFiltros(filter);
          if (flag == 1) {
            vm.tblRecursos.totalCount  = 0;
          }
          if (sort === "hightDate,desc") {
            sort = sortDefault;
          }
          recursosService.getRecursos(pages,sizes,filtros,sort,vm.resourceTypeCode).then(function(data) {
            if (angular.isDefined(data)) {
              vm.loading = false;
              vm.loadingFiltros = false;
              vm.loadingBoton = false;

              if(angular.isDefined(data.content)) {
                data.content.forEach(function (value) {
                  vm.tblRecursos.data.push(value);
                });
                vm.tblRecursos.totalCount = data.totalElements;
                objDtos.dtos = data.content;
                objDtos.totalCount = data.totalElements;
              }
            }
            deferred.resolve(objDtos);
          });
          return deferred.promise;
        }
      };

      function validaFiltros(filter) {
        var filtro = "";
        angular.forEach(filter, function(val, index) {
          filtro += index +":"+ val + ",";
        });

        if (filtro !== "") {
          filtro = filtro.substring(0,filtro.length-1);
          return filtro;
        }

        return filtro;
      }

      function validaSort(sort) {
        sort = sort.replace(":",",");
        var sortCopy = sort;
        sortCopy = sortCopy.split(",");
        if (sortCopy[0] === "uidResource") {
          sort = sort.replace("uidResource","uuidRecurso");
        } else if (sortCopy[0] === "code") {
          sort = sort.replace("code","codigo");
        } else if (sortCopy[0] === "resourceTypeCode") {
          sort = sort.replace("resourceTypeCode","recursosTipo");
        } else if (sortCopy[0] === "client") {
          sort = sort.replace("client","idCliente");
        }
        return sort;
      }

      function getRecursos(pages,sizes,filtros,sort) {
        recursosService.getRecursos(pages,sizes,filtros,sort,vm.resourceTypeCode).then(function(data) {
          if (angular.isDefined(data.content)) {
            vm.loading = false;
            vm.loadingFiltros = false;
            vm.loadingBoton = false;
            if (data.content.length > 0) {
              vm.tblRecursos.data = data.content;
              vm.tblRecursos.totalCount = data.totalElements;
              $scope.$broadcast('limpiarDynamicData',data.content);
            }
          }
        });
      }

      vm.agregarRecurso = function () {
        var elemento = {
          dtosRecupeRecursos : vm.dtosFormRecursos,
          titulo:  $translate.instant("Alta de recurso")
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/recursos/modals/recursosAltaCamb.modal.html',
          controller: 'altaRecursoController as vm',
          q: $q,
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        });
      };

      function funcionEditarRecurso(data) {
        var elemento = {
          element : data,
          titulo:  $translate.instant("Modificación de un recurso")
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/recursos/modals/recursosAltaCamb.modal.html',
          controller: 'editarRecursoController as vm',
          q: $q,
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        });
      }

      function funcionEliminarRecurso(data) {
        var elemento = {
          titulo:  $translate.instant("Eliminación de un recurso"),
          element: data
        };
        $mdDialog.show({
          controller: 'eliminarRecursoController as vm',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals:{scopeDataToPass: $scope},
          resolve: {
            datos: function() {
              return elemento;
            }
          },
          template:
          '<md-dialog md-theme="default" aria-label="{{vm.titulo}}" ng-class="dialog.css" class="_md md-default-theme md-transition-in" role="dialog" tabindex="-1" aria-describedby="dialogContent_0">' +
          '  <md-dialog-content class="md-dialog-content" role="document" tabindex="-1">' +
          '    <h2 class="md-title ng-binding"><b>{{vm.titulo}}</b></h2>' +
          '    <div class="md-dialog-content-body ng-scope">' +
          '     <p class="ng-binding">{{"¿Está seguro de que quiere dar de baja el recurso" | translate}} {{vm.response.code}}?</p>' +
          '    </div>' +
          '  </md-dialog-content>' +
          '  <md-dialog-actions>' +
          '  <md-button ng-click="vm.close()" class="md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" type="button">' +
          '     <b>{{"Cancelar" | translate }}</b> ' +
          '   </md-button> ' +
          '  <md-button ng-click="vm.aceptarEliminarRecurso(vm.response)" class="md-primary md-raised md-confirm-button md-button md-ink-ripple md-default-theme" type="button">' +
          '     <b>{{"Eliminar" | translate}}</b>' +
          '  </md-button>' +
          ' </md-dialog-actions>' +
          '</md-dialog>'
        }).then(function() {
          $log.info("Dialog Close Recurso");
        });
      }

      vm.exportarDatos = function(){
        vm.loadingCSV = true;
        var deferred = $q.defer();
        var promises = [];
        var registros = 500;
        var maxPaginas = 1;
        if (vm.tblRecursos.totalCount > 500) {
            var a = vm.tblRecursos.totalCount / 500;
            maxPaginas = Math.ceil(a);
        }

        for (var paginasCSV = 1; paginasCSV <= maxPaginas; paginasCSV++) {
          promises.push(recursosService.getRecursos(paginasCSV,registros,"","",vm.resourceTypeCode).then(function(data) {
            return data.content;
          }));
        }

        $q.all(promises).then(function(result) {
          vm.loadingCSV = false;
          var newData = [];
          result.forEach(function(elemenResult){
            elemenResult.forEach(function(elemento){
              newData.push({uidResource: elemento.uidResource, code: elemento.code,
                resourceTypeCode: elemento.resourceTypeCode, client: elemento.client});
            });
          });
          deferred.resolve(newData);
        });

        return deferred.promise;
      };
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:TblRecursosController
   * @description
   * Controller para el menu de Live
   *
   */

  angular
    .module('app')
    .directive('datikRecursos', datikRecursos);

  function datikRecursos() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/recursos/directives/mainRecursos.html',
      controllerAs: 'vm',
      controller: ['$log', '$translate', '$filter', '$location', '$uibModal',
      'conexion', 'constantes', 'ayuda', 'composicion', '$scope', tblRecursosController
      ]
    };

    function tblRecursosController ($log, $translate, $filter, $location, $uibModal,
      conexion, constantes, ayuda, composicion, $scope) {

    var vm = this;


    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:eliminarRecursoController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('eliminarRecursoController', eliminarRecursoController);

  function eliminarRecursoController($log, $mdDialog, scopeDataToPass, $scope, datos, notificaciones, $q, $filter, $translate, altaEquipamientosService, recursosService) {
    var vm = this;
    vm.titulo = datos.titulo;
    vm.response = angular.copy(datos.element);
    vm.close = function() {
      $mdDialog.cancel();
    };

    var RECURSOS = $translate.instant("Recursos");

    altaEquipamientosService.getFlotas().then(function(data) {
      if (data.length > 0) {
        vm.response.client = $filter('filter')(data,{display: vm.response.client})[0];
      }
    }, function(error) {
      $log.info(error);
    });

    vm.aceptarEliminarRecurso = function(dato) {
      $mdDialog.hide();
      recursosService.deleteRecursos(dato).then(function(data) {
        if (angular.isDefined(data) && data.data === true) {
          notificaciones.showNotification(RECURSOS, $translate.instant("La eliminación del Recurso fue realizada correctamente"), "success");
          scopeDataToPass.refrescarRecursos();
        } else {
          if (angular.isDefined(data.data.message)) {
            notificaciones.showNotification(data.data.message, $translate.instant("Error al intentar eliminar un recurso"), "error");
          } else {
            notificaciones.showNotification(RECURSOS, $translate.instant("Error al intentar eliminar un recurso"), "error");
          }
          scopeDataToPass.refrescarRecursos();
        }
      }, function(error) {
        notificaciones.showNotification(RECURSOS, $translate.instant("Error al intentar eliminar un recurso") + error, "error");
        scopeDataToPass.refrescarRecursos();
      });
    };
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:editarRecursoController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('editarRecursoController', editarRecursoController);

    function editarRecursoController($log, $uibModalInstance, $scope, $q, $timeout, datos, notificaciones, $filter, $translate, altaEquipamientosService, recursosService){
      var vm = this;
      var _datos = datos;
      var lstDtosFlota = "";
      vm.showIdRecurso = true;
      vm.showboton = false;
      vm.titulo = datos.titulo;
      vm.response = {
        recursoUid: datos.element.uidResource,
        codigo: datos.element.code,
        recurso: datos.element.resourceTypeCode,
        cliente: datos.element.client,
        clienteOld: datos.element.client,
        codigoOld: datos.element.code
      };

      var RECURSOS = $translate.instant("Recursos");

      vm.querySearchCliente = function(query) {
        var results = query ? lstDtosFlota.filter(createFilterFor(query, lstDtosFlota)) : lstDtosFlota,
          deferred;
        if (vm.simulateQuery) {
          deferred = $q.defer();
          $timeout(function() {
            deferred.resolve(results);
          }, Math.random() * 1000, false);
          return deferred.promise;
        } else {
          return results;
        }
      };

      function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(lst) {
          return (lst.value.indexOf(lowercaseQuery) === 0);
        };
      }

      function getFlota() {
        altaEquipamientosService.getFlotas().then(function(data) {
          if (data.length > 0) {
            lstDtosFlota = data;
            vm.response.clienteOld = vm.response.cliente =  lstDtosFlota.find(function (x){
              return x.uid === _datos.element.uidClient
            })
          }
        }, function(error) {
          $log.info(error);
        });
      }

      vm.close = function() {
        $uibModalInstance.dismiss();
      };

      vm.focusRecursos = function(datos) {
        if (angular.isUndefined(datos.codigo) || datos.codigo === null) {
          vm.recursosDisabled = true;
          return;
        }

        if (angular.isUndefined(datos.cliente) || datos.cliente === null) {
          vm.recursosDisabled = true;
          return;
        }

        if (angular.isUndefined(datos.recurso) || datos.recurso === null) {
          vm.recursosDisabled = true;
          return;
        }

        vm.recursosDisabled = false;
      };

      vm.editarRecursos = function(datos) {
        $uibModalInstance.dismiss();
        if (angular.isDefined(datos)) {
          recursosService.putRecursos(datos).then(function(data) {
            $scope.limpiarDtosRecuperadosRecursos();
            if (angular.isDefined(data) && data.data === true) {
              notificaciones.showNotification(RECURSOS, $translate.instant("La modificación del Recurso fue realizada correctamente"), "success");
              $scope.refrescarRecursos();
            } else {
              if (angular.isDefined(data.data.message)) {
                notificaciones.showNotification(data.data.message, $translate.instant("Error al intentar hacer una modificación de un recurso"), "error");
              } else {
                notificaciones.showNotification(RECURSOS, $translate.instant("Error al intentar hacer una modificación de un recurso"), "error");
              }
              $scope.refrescarRecursos();
            }
          }, function(error) {
            notificaciones.showNotification(RECURSOS, $translate.instant("Error al intentar hacer una modificación de un recurso") + error, "error");
            $scope.refrescarRecursos();
          });
        }
      };

      getFlota();
    }
  })();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:altaEquipamientoController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('altaRecursoController', altaRecursoController);

  function altaRecursoController($log, $uibModalInstance, $scope, $q, $timeout, datos, notificaciones, $translate, $filter, recursosService, altaEquipamientosService) {
    var vm = this;
    vm.titulo = datos.titulo;
    var lstDtosFlota = "";
    vm.showIdRecurso = false;
    vm.recursosDisabled = true;
    vm.showboton = true;

    var RECURSOS = $translate.instant("Recursos");
    
    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    if (angular.isDefined(datos.dtosRecupeRecursos)) {
      vm.response = angular.copy(datos.dtosRecupeRecursos);
      if (angular.isDefined(vm.response.codigo) && angular.isDefined(vm.response.cliente) && angular.isDefined(vm.response.recurso)) {
        vm.recursosDisabled = false;
      } else {
        vm.recursosDisabled = true;
      }
    }

    vm.querySearchCliente = function(query) {
      var results = query ? lstDtosFlota.filter(createFilterFor(query, lstDtosFlota)) : lstDtosFlota,
        deferred;
      if (vm.simulateQuery) {
        deferred = $q.defer();
        $timeout(function() {
          deferred.resolve(results);
        }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    };

    function createFilterFor(query, lst) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(lst) {
        return (lst.value.indexOf(lowercaseQuery) === 0);
      };
    }

    function getFlota() {
      altaEquipamientosService.getFlotas().then(function(data) {
        if (data.length > 0) {
          lstDtosFlota = data;
        }
      }, function(error) {
        $log.info(error);
      });
    }

    vm.focusRecursos = function(datos) {
      if (angular.isUndefined(datos.codigo) || datos.codigo === null) {
        vm.recursosDisabled = true;
        return;
      }

      if (angular.isUndefined(datos.cliente) || datos.cliente === null) {
        vm.recursosDisabled = true;
        return;
      }

      if (angular.isUndefined(datos.recurso) || datos.recurso === null) {
        vm.recursosDisabled = true;
        return;
      }

      vm.recursosDisabled = false;
    };

    vm.recuperDtos = function(datos) {
      $scope.$emit("recuperDtosRecurso", datos);
    };

    vm.altaRecursos = function(datos) {
      $uibModalInstance.dismiss();
      if (angular.isDefined(datos)) {
        recursosService.postRecursos(datos).then(function(data) {
          $scope.limpiarDtosRecuperadosRecursos();
          if (angular.isDefined(data) && data.data === true) {
            notificaciones.showNotification(RECURSOS, $translate.instant("El alta del Recurso fue realizada correctamente"), "success");
            $scope.refrescarRecursos();
          } else {
            if (angular.isDefined(data.data.message)) {
              notificaciones.showNotification(data.data.message, $translate.instant("Error al intentar dar de alta un recurso"), "error");
            } else {
              notificaciones.showNotification(RECURSOS, $translate.instant("Error al intentar dar de alta un recurso"), "error");
            }
            $scope.refrescarRecursos();
          }
        }, function(error) {
          notificaciones.showNotification(RECURSOS, $translate.instant("Error al intentar dar de alta un recurso") + error, "error");
          $scope.refrescarRecursos();
        });
      }
    };

    setTimeout(function() {
      getFlota();
    }, 0);
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('nagiosService', nagiosService);

  function nagiosService($log, $http, $window, $translate, constantes, conexion, $q, $base64) {
    var service = {
      getSystems: getSystems
    };
    return service;

    function getSystems() {
      var colorStatus = ["green", "orange", "red", "gris"];

      var auth = $base64.encode("datikmonitoring:AKIASKDO2UO5XZLHBTGC"),
        headers = {
          "Authorization": "Basic " + auth
        };

      var config = {
        timeout: 90000,
        headers: {
          "Authorization": "Basic " + auth
        }
      };

      return $http.get("https://monitoring.ipanel.cloud/nagios/cgi-bin/status", {
        headers: headers
      }).then(okFunction, errorFunction);

      function okFunction(response) {
        var nagios2 = [];
        var nagios = {};
        Object.keys(response.data).forEach(function(key, index) {
          var split = key.split(".");
          var elemento = response.data[key];
          if (angular.isUndefined(nagios[split[1]])) {
            nagios[split[1]] = [];
          }
          var microService = elemento;
          microService.host = split[0];
          nagios[split[1]].push(microService);
        });
        return nagios;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-Grid-List-Nagios.directive:GridList
   * @description
   * # GridList
   */
  angular.module('app')
    .directive('datikNagios', datikNagios);

  function datikNagios() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/nagios/directives/gridListNagios.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate', '$location',
        '$timeout', '$uibModal', '$mdDialog', 'conexion', 'notificaciones', '$q', 'composicion', 'nagiosService', '$interval', datikNagiosController
      ]
    };
  }

  function datikNagiosController($log, $scope, $filter, $translate, $location,
    $timeout, $uibModal, $mdDialog, conexion, notificaciones, $q, composicion, nagiosService, $interval) {

    var vm = this;
    vm.nagios = null;
    vm.loading = true;
    vm.nagios = [];
    // var array = ["0","1","2","3"];

    vm.getSystemas = function() {
      vm.loadingSystems = true;
      var tabSelect = localStorage.getItem('tabNagios');
      nagiosService.getSystems().then(function (data) {
        vm.loadingSystems = false;
        vm.loading = false;
        if (angular.isDefined(data)) {
          vm.nagios = [];
          var systemsErrorsWarnings = [];
          var totalErrorsWarnings = 0;
          var messageGeneral = {};
          var totalOk = 0;
          var totalWarning = 0;
          var totalError = 0;
          var totalUnknown = 0;
          Object.keys(data).forEach(function(key){
            systemsErrorsWarnings = [];
            totalErrorsWarnings = 0;
            messageGeneral = {};
            totalOk = 0;
            totalWarning = 0;
            totalError = 0;
            totalUnknown = 0;
            data[key].forEach(function(elemento) {
              var ok = 0;
              var warning = 0;
              var error = 0;
              var unknown = 0;
              var pluginOutput = (angular.isDefined(elemento.plugin_output) && elemento.plugin_output !== "") ? elemento.plugin_output : "";
              elemento.services.forEach(function(resp) {
                // resp.current_state = array[Math.floor(Math.random() * (3 - 0) + 0)];
                ok = angular.equals(resp.current_state, "0") ? (ok + 1) : ok;
                if (angular.equals(resp.current_state, "0")) {
                  elemento.issues = "ok";
                }

                warning = angular.equals(resp.current_state, "1") ? (warning + 1) : warning;
                if(angular.equals(resp.current_state, "1")) {
                  systemsErrorsWarnings.push({host: elemento.host + " - " + resp.service_description, messageError: resp.plugin_output, issues: "warning"});
                }

                error = angular.equals(resp.current_state, "2") ? (error + 1 ) : error;
                if(angular.equals(resp.current_state, "2")) {
                  systemsErrorsWarnings.push({host: elemento.host + " - " + resp.service_description, messageError: resp.plugin_output, issues: "error"});
                }

                unknown = angular.equals(resp.current_state, "3") ? (unknown + 1) : unknown;
                if (angular.equals(resp.current_state, "3")) {
                  systemsErrorsWarnings.push({host: elemento.host + " - " + resp.service_description, messageError: resp.plugin_output, issues: "zunknown"});
                }

              });

              totalOk = totalOk + ok;
              totalWarning = totalWarning + warning;
              totalError = totalError + error;
              totalUnknown = totalUnknown + unknown;

              elemento.totalServices = elemento.services.length - error - warning - unknown;
              totalErrorsWarnings = totalErrorsWarnings + error + warning + unknown;
            });

            messageGeneral = (totalOk > 0 && totalError === 0 && totalWarning === 0 && totalUnknown === 0) ? {message:"All systems operational", color:"cyan-message"} :
                             (totalError > 0 && totalWarning === 0 && totalUnknown === 0) ? {message: "Some systems have critical issues", color:"red-message"} :
                             (totalError > 0 && totalWarning > 0 && totalUnknown === 0) ? {message: "Some systems have critical errors and warnings", color:"red-message"} :
                             (totalError > 0 && totalWarning > 0 && totalUnknown > 0) ? {message: "Some systems have critical errors, warnings and some systems unknown", color:"red-message"} :
                             (totalError === 0 && totalWarning > 0 && totalUnknown === 0) ? {message: "Some systems have warnings", color:"orange-message"} :
                             (totalError === 0 && totalWarning > 0 && totalUnknown > 0) ? {message: "Some systems have warnings, some systems unknown", color:"orange-message"} :
                             (totalError === 0 && totalWarning === 0 && totalUnknown > 0) ? {message: "Some systems unknown", color:"zunknown-message"} : undefined;

            vm.nagios.push({name: key, datos: [data[key]], systemsErrorsWarnings: systemsErrorsWarnings, totalErrorsWarnings: totalErrorsWarnings, messageGeneral: messageGeneral});
          });
          if (angular.isDefined(tabSelect) && tabSelect !== null) {
            for (var i = 0; i < vm.nagios.length; i++) {
              if (angular.equals(tabSelect, vm.nagios[i].name)) {
                vm.goto(vm.nagios[i].name, vm.nagios[i].datos, vm.nagios[i].systemsErrorsWarnings, vm.nagios[i].messageGeneral);
              }
            }
          } else {
            vm.goto(vm.nagios[0].name, vm.nagios[0].datos, vm.nagios[0].systemsErrorsWarnings, vm.nagios[0].messageGeneral);
          }
        }
      });
    };

    $interval(function() {
     vm.getSystemas();
    }, 30000);

    vm.goto = function (item, item2, item3, item4) {
      localStorage.setItem("tabNagios",item);
      vm.messageNagios =  item4;
      vm.tabServicios = item;
      vm.datosServicios = item2[0];
      vm.datosErrorsWarnings = item3;
    };

    vm.getSystemas();

  }

})();

(function() {
  'use strict';


  /**
   * @ngdoc controller
   * @name login.controller:SignInController
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */
  angular
    .module('app')
    .controller('SignInViewController', SignInViewController);

  /** @ngInject */
  function SignInViewController($rootScope, $location, $log,
                                $q, $window,
                                conexion, composicion,
                                constantes, utilidades,
                                signInService) {

    if (conexion.estaConectado()) {
      $location.path('/');
    } else {
      composicion.pantallaLogin();
      $window.document.getElementById('usuario').focus();
    }
    var vm = this;
    vm.cambiarIdioma = function(idioma){
      conexion.cambiarIdioma(idioma);
    };
    vm.logear = function() {
      if (angular.isUndefined(vm.user.pwd) || vm.user.pwd === "" ||
        angular.isUndefined(vm.user.usuario) || vm.user.usuario === "") {
        return;
      }
      vm.loading = true;
      signInService.login(vm.user.usuario, vm.user.pwd).then(function(data) {
        vm.loading = false;
        if (angular.isDefined(data.error)) {
          if (data.error.code === -1) {
            vm.user.error = "Error al intentar conectarse, vuelva a intentarlo";
          } else if (data.error.code === 401) {
            vm.user.error = "Usuario o contraseña incorrectos";
          } else {
            vm.user.error = "Error al intentar conectarse, vuelva a intentarlo";
          }
          return;
        }
        if (data.resetPassword) {
          conexion.setUsuario(data.user);
          $location.path('/resetPwd');
          return;
        }
        var usuario = data.user;
        if (angular.isUndefined(usuario.apps.GO) || usuario.apps.GO === null) {
          vm.user.error = "No tiene permiso para entrar a iPanelGO, por favor contacte con Datik";
          return;
        }
        usuario.navegador = utilidades.getBrowser();
        usuario.os = utilidades.getOS();
        usuario.expiresIn = data.expiresIn;
        usuario.token = data.token,
        usuario.refreshToken = data.refreshToken;
        $log.info('Navegador: ' + usuario.navegador + '; OS: ' + usuario.os);

        conexion.setUsuario(usuario);
        $location.path('/');

      });

    };

  }
})();

(function() {
  'use strict';


  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */
  angular
    .module('app')
    .factory('signInService', signInService);

  function signInService($log, $http, $window,
                         constantes) {
    var urlLogin = constantes.getApiUrl('ips_authorization', 'session');

    var service = {
      login: login
    };

    return service;

    function login(user, password) {
      var login = {
        user: user,
        password: password
      };
      var config = {
        timeout: 90000
      };
      return $http.post(urlLogin, login, config)
        .then(loginComplete)
        .catch(loginFailed);

      function loginComplete(response) {
        try {
          var token = response.data.access_token;
          var expires_in = response.data.expires_in;
          var user = parseToken(token);
          return {
            token: token,
            user: user,
            expiresIn: expires_in,
            resetPassword: response.data.reset_password,
            refreshToken: response.data.refresh_token
          };
        } catch (e) {
          return {
            error: {
              code: 0,
              message: "Error con el servidor"
            }
          };
        }
      }

      function loginFailed(error) {
        if (error.status === -1) {
          $log.error("La api ha tardado mas que el timeout");
          return {
            error: {
              code: -1,
              message: "Tiempo de respuesta del servidor excesiva"
            }
          };
        } else if (error.status === 401) {
          $log.error("Usuario no autorizado");
          return {
            error: error.data
          };
        }
        return {
          error: {
            code: 500,
            message: "Error desconocido"
          }
        };
      }
    }

    function parseToken(token) {
      var authToken = token.replace(/(\r\n|\n|\r)/gm, '');
      var splitedToken = authToken.split('.',3);
      var strData = b64DecodeUnicode(splitedToken[1]);
      var respuesta = angular.fromJson(strData);
      return respuesta;
    }

    function b64DecodeUnicode(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent($window.atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    };

  }

})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name login.controller:RestorePwdViewController
   * @description
   * Este controlador se encarga de la vista para enviar un email con la
   * información del usuario y contraseña si ha olvidado el usuario.
   */
  angular
    .module('app')
    .controller('RestorePwdViewController', RestorePwdViewController);

  /** @ngInject */
  function RestorePwdViewController($log, $http, $location, $window,
                                    composicion, constantes, conexion, restorePwdService) {

    if (conexion.estaConectado()) {
      $location.path('/');
      return;
    }

    var key = $location.search().key;
    if (angular.isUndefined(key)) {
      $location.path('/signIn');
    }
    composicion.iniciarPantallaNoToken();

    var vm = this;

    vm.cambiarIdioma = function(idioma){
      conexion.cambiarIdioma(idioma);
    };

    vm.error = '';
    vm.loading = false;
    vm.enviadaPwd = false;
    $window.document.getElementById("email").focus();

    vm.cancelar = function() {
      $log.info('Vuelta a la pantalla login');
      $location.path('/signIn');
    };


    /**
     * @ngdoc method
     * @name ForgotPwdController#enviarEmail
     * @methodOf login.controller:ForgotPwdController
     * @description
     * Función para enviar el email al usuario.
     */
    vm.enviar = function() {
      if (angular.isUndefined(vm.email) || vm.email === '') {
        vm.error = 'Introduce un usuario';
        return;
      }
      if (!validoEmail(vm.email)) {
        vm.error = 'El usuario que ha introducido necesita formato email';
        return;
      }
      if (angular.isUndefined(vm.newPwd) || vm.newPwd === '') {
        vm.error = 'Introduce la contraseña';
        return;
      }
      if (angular.isUndefined(key) || key === '') {
        vm.error = 'No se encuentra el identificador para cambiar la contraseña';
        return;
      }
      vm.loading = true;
      restorePwdService.restorePwd(vm.email, vm.newPwd, key)
        .then(function(response) {
          vm.loading = false;
          if (angular.isDefined(response) && response.code == 200) {
            $location.path('/signIn');
          } else if (angular.isDefined(response) && response.code == 400) {
            vm.error = response.message;
          } else {
            vm.error = 'Error con el código, por favor solicite de nuevo una nueva contraseña';
          }
        });
    };

    var validoEmail = function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };



  }

})();

(function() {
  'use strict';


  /**
   * @ngdoc controller
   * @name login.controller:ResestPwdService
   * @description
   *
   */
  angular
    .module('app')
    .factory('restorePwdService', restorePwdService);

  function restorePwdService($log, $http, $window,
                             constantes) {
    var urlRestorePwd = constantes.getApiUrl('ips_authorization', 'restoreCredential');

    var service = {
      restorePwd: restorePwd
    };

    return service;

    function restorePwd(email, newPwd, key) {
      var url = urlRestorePwd + '?key=' + key;
      var params = {
        'email': email,
        'password': newPwd
      };
      var config = {
        timeout: 90000
      };
      return $http.post(url, params, config)
        .then(restorePwdComplete)
        .catch(restorePwdFailed);

      function restorePwdComplete() {
        return {
          code: 200
        };
      }

      function restorePwdFailed(error) {
        if (error.status === -1) {
          $log.error('Timeout al cambiar el password');
        } else if (error.status === 400) {
          $log.error('Los datos introducidos no son validos');
          return {
            code: 400,
            message: 'Los datos introducidos no son validos'
          }
        }
        return;
      }
    }

  }

})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name login.controller:ResetPwdViewController
   * @description
   * Este controlador se encarga de la vista para enviar un email con la
   * información del usuario y contraseña si ha olvidado el usuario.
   */
  angular
    .module('app')
    .controller('ResetPwdViewController', ResetPwdViewController);

  /** @ngInject */
  function ResetPwdViewController($log, $http, $location, $window,
                                  composicion, constantes,
                                  conexion, resetPwdService) {

    conexion.validarConexion();
    composicion.iniciarPantallaNoToken();

    var vm = this;
    vm.error = '';
    vm.loading = false;
    vm.enviadaPwd = false;
    $window.document.getElementById("actualPwd").focus();

    vm.enviar = function() {
      vm.error = '';
      if (angular.isUndefined(vm.actualPwd) || vm.actualPwd === "") {
        vm.error = 'Introduzca los datos';
        return;
      }
      if (angular.isUndefined(vm.newPwd) || vm.newPwd === "") {
        vm.error = 'Introduzca los datos';
        return;
      }
      if (angular.isUndefined(vm.newPwd2) || vm.newPwd2 === "") {
        vm.error = 'Introduzca los datos';
        return;
      }
      if (vm.newPwd !== vm.newPwd2) {
        vm.error = 'La nueva contraseña ha de ser igual';
        return;
      }
      vm.loading = true;
      resetPwdService.resetPwd(vm.actualPwd, vm.newPwd).then(function(data) {
        vm.loading = false;
        if (angular.isUndefined(data)) {
          vm.error = 'Error al cambiar la contraseña';
        } else {
          conexion.desconectar();
        }
      })
    }
  }
})();

(function() {
  'use strict';


  /**
   * @ngdoc controller
   * @name login.controller:ResestPwdService
   * @description
   *
   */
  angular
    .module('app')
    .factory('resetPwdService', resetPwdService);

  function resetPwdService($log, $http, $window,
    constantes, conexion) {
    var urlResetPwd = constantes.getApiUrl('ips_authorization', 'changeCredential');

    var service = {
      resetPwd: resetPwd
    };

    return service;

    function resetPwd(actualPwd, newPwd) {
      var params = {
        'actualPassword': actualPwd,
        'newPassword': newPwd
      };
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.put(urlResetPwd, params, config)
                      .then(resetPwdComplete)
                      .catch(resetPwdFailed);

      function resetPwdComplete() {
        return {
          code: 200
        };
      }

      function resetPwdFailed(error) {
        if (error.status === -1) {
          $log.error('Timeout al cambiar el password');
        } else {
          $log.error('Error al cambiar el password');
        }
        return;
      }
    }


  }

})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name login.controller:ForgotPwdController
   * @description
   * Este controlador se encarga de la vista para enviar un email con la
   * información del usuario y contraseña si ha olvidado el usuario.
   */
  angular
    .module('app')
    .controller('ForgotPwdViewController', ForgotPwdViewController);

  /** @ngInject */
  function ForgotPwdViewController($log, $location, $window,
                                  composicion, conexion, forgotPwdService) {

    if (conexion.estaConectado()) {
      $location.path('/');
    } else {
      composicion.iniciarPantallaNoToken();

      var vm = this;
      vm.cambiarIdioma = function(idioma){
        conexion.cambiarIdioma(idioma);
      };
      vm.error = '';
      vm.loading = false;
      vm.enviadaPwd = false;
      $window.document.getElementById("email").focus();

      vm.cancelar = function() {
        $log.info('Vuelta a la pantalla login');
        $location.path('/signIn');
      };


      /**
       * @ngdoc method
       * @name ForgotPwdController#enviarEmail
       * @methodOf login.controller:ForgotPwdController
       * @description
       * Función para enviar el email al usuario.
       */
      vm.enviarEmail = function() {
        if (vm.email === '') {
          vm.error = 'Introduce un email';
        } else {
          if (validoEmail(vm.email)) {
            vm.error = '';
            vm.loading = true;
            forgotPwdService.forgotPwd(vm.email).then(function(response) {
              vm.loading = false;
              if (response.code === 200) {
                vm.enviadaPwd = true;
                $log.info('Datos enviados correctamente');
              } else if (response.code === 400) {
                vm.error = 'Email no encontrado';
              } else {
                vm.error = 'Error al enviar los datos al servidor, intentelo más tarde o pongase en contácto con nosotros.';
              }
            });
          } else {
            vm.error = 'El email que ha introducido no es valido';
          }
        }
      };

      var validoEmail = function(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      };

    }
  }
})();

(function() {
  'use strict';


  /**
   * @ngdoc controller
   * @name login.controller:ForgotPwdService
   * @description
   *
   */
  angular
    .module('app')
    .factory('forgotPwdService', forgotPwdService);

  function forgotPwdService($log, $http, $window,
                            constantes) {
    var urlForgotPwd = constantes.getApiUrl('ips_authorization', 'forgetCredential');

    var service = {
      forgotPwd: forgotPwd
    };

    return service;

    function forgotPwd(email) {
      var params = {
        'email': email
      };
      var config = {
        timeout: 90000
      };
      return $http.post(urlForgotPwd, params, config)
        .then(getPermissionsComplete)
        .catch(getPermissionsFailed);

      function getPermissionsComplete() {
        return {
          code: 200
        };
      }

      function getPermissionsFailed(error) {
        if (error.status === -1) {
          $log.error("La api ha tardado mas que el timeout");
          return {
            code: -1,
            message: "Tiempo de respuesta del servidor excesiva"
          };
        } else if (error.status === 400) {
          return {
            code: 400,
            message: "El usuario no existe"
          }
        } else {
          return {
            code: 500,
            message: "Error con el servidor"
          }
        }
      }
    }


  }

})();

(function() {

/**
* @ngdoc service
* @name utilidades.service:utilidades
* @module utilidades
*
* @description
* Servicio con diferentes funciones utilies para todo el proyecto.
*/
angular.module('app')
  .service('utilidadesGO', function($window, $interval, $http, $log, $mdToast, $filter, $mdDialog,
               $timeout, $translate, $compile, $document, moment, conexion, constantes) {

    /**
     * @ngdoc method
     * @name utilidades#getUTCDate
     * @methodOf utilidades.service:utilidades
     *
     * @description
     * Funcion para obtener la hora en UTC
     * @return {date} Hora actual en UTC
     */
    this.getUTCDate = function() {
        var now = new Date();
        var nowUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
        return nowUTC;
    };

    /**
     * @ngdoc method
     * @name utilidades.utilidades#getUserDate
     * @methodOf utilidades.service:utilidades
     *
     * @description
     * Funcion para obtener la hora del usuario
     * @return {date} Hora actual del usuario
     */
    this.getUserDate = function() {
        if (angular.isUndefined(conexion.getUsuario())) {
            return new Date();
        }
        var offset = conexion.getUsuario().clientOffset;
        var now = new Date(this.getUTCDate().getTime() + parseInt(offset));
        return now;
    };

    /**
     * @ngdoc method
     * @name utilidades#getUserDateAddMonth
     * @methodOf utilidades.service:utilidades
     *
     * @description
     * Funcion para sumar o restar mes(es) a una fecha
     * @param {int} Cantidad de meses a sumar o restar
     * @return {date} Devuelve la fecha con los meses añadidos o restados
     */
    this.getUserDateAddMonth = function(valor) {
        var offset = conexion.getUsuario().offset;
        var d = new Date(this.getUTCDate().getTime() + parseInt(offset));
        d.setMonth(d.getMonth() + valor);
        return d;
    };

    /**
     * @ngdoc method
     * @name utilidades#getNumeroLocal
     * @methodOf utilidades.service:utilidades
     *
     * @description
     * Función que devuelve un numero en el formato local.
     * @param {number} numero Numero que deseamos convertir a formato local
     * @return {string} Cadena de caracteres con el número en el formato de la localidad del usuario
     */
    this.getNumeroLocal = function(numero) {
        if (angular.isNumber(numero)) {
            numero = Number(numero);
        }
        var usoLocal = conexion.getUsuario().idioma.substring(0, 2) + '-' + conexion.getUsuario().idioma.substring(2, 4);
        return numero.toLocaleString(usoLocal);
    };

    /**
     * @ngdoc method
     * @name utilidades.utilidades#mayusculaPrimeraLetra
     * @methodOf utilidades.service:utilidades
     *
     * @description
     * Función mediante la cual hacemos que la primera letra de la palabra sea mayúscula.
     * @param {string} palabra Palabra la cual deseamos modificar
     * @return {string} Palabra con la primera letra en mayúscula
     */
    this.mayusculaPrimeraLetra = function(palabra) {
        if (angular.isString(palabra)) {
            palabra = String(palabra);
        }
        return palabra.charAt(0).toUpperCase() + palabra.slice(1);
    };

    /**
     * @ngdoc method
     * @name utilidades#capitalizeFirstLetter
     * @methodOf utilidades.service:utilidades
     *
     * @description
     * Una vez introducido el modulo utilidades a cualquier variable de tipo String
     * se le añade esta función. Mediante la cual podemos hacer mayuscula la primera letra.
     * El modo de usarlo sería el siguiente
     * <pre>
     * 'gato'.capitalizeFirstLetter();
     * //Otro modo de uso
     * var gato = 'gato';
     * gato.capitalizeFirstLetter();
     * </pre>
     */
    String.prototype.capitalizeFirstLetter = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };

    /**
     * @ngdoc method
     * @name utilidades#resaltado
     * @methodOf utilidades.service:utilidades
     *
     * @description
     * Una vez introducido el modulo utilidades a cualquier variable de tipo String
     * se le añade esta función. Esta función nos permite resaltar el texto ya que lo pasa
     * a negrita.
     * El modo de usarlo sería el siguiente
     * <pre>
     * 'gato'.resaltado();
     * //Otro modo de uso
     * var gato = 'gato';
     * gato.resaltado();
     * </pre>
     */
    String.prototype.resaltado = function() {
        return this.bold();
    };

    /**
     * @ngdoc method
     * @name utilidades#ajustarPantalla
     * @methodOf utilidades.service:utilidades
     *
     * @description
     * Función para llamar al evento resize y que ciertos elementos como mapas se
     * se actualicen.
     */
    var timeoutAnterior;
    this.ajustarPantalla = function() {
        if (angular.isUndefined(timeoutAnterior)) {
            timeoutAnterior = $timeout(function() {
                angular.element($window).triggerHandler('resize');
                $window.dispatchEvent(new Event('resize'));
                timeoutAnterior = undefined;
            }, 100);
        } else {
            $timeout.cancel(timeoutAnterior);
            timeoutAnterior = undefined;
            this.ajustarPantalla();
        }
    };

    /**
     * @ngdoc method
     * @name utilidades#ajustarPantalla
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que imite un click sobre unas coordenadas x o y
     * @param {int} x Coordenada X
     * @param {int} y Coordenada Y
     */
    this.click = function(x, y) {
        var ev = document.createEvent('MouseEvent');
        var el = document.elementFromPoint(x, y);
        ev.initMouseEvent(
            'click',
            true /* bubble */ , true /* cancelable */ ,
            window, null,
            x, y, 0, 0, /* coordinates */
            false, false, false, false, /* modifier keys */
            0 /*left*/ , null
        );
        el.dispatchEvent(ev);
    };

    /**
     * @ngdoc method
     * @name utilidades#mostrarProblemaConexion
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que muestra que hay problemas de conexión
     */
    this.mostrarProblemaConexion = function() {
        var problemas = angular.element($document[0].querySelector('#problemas'));
        if (!problemas.length) {
            var vista = angular.element('#cabecera');
            var texto = $translate.instant('Problemas de conexión');
            var elementoComp = '<span id="problemas" class="problemas">' + texto + '</span>';
            vista.append(elementoComp);
        }
    };
    /**
     * @ngdoc method
     * @name utilidades#ocultarProblemaConexion
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que oculta el problema de conexión
     */
    this.ocultarProblemaConexion = function() {
        var problemas = angular.element($document[0].querySelector('#problemas'));
        if (problemas.length) {
            problemas.remove();
        }
    };

    /**
     * @ngdoc method
     * @name utilidades#getBrowser
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que obtiene el navegador
     */
    this.getBrowser = function() {
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browserName = navigator.appName;
        var fullVersion = '' + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;

        // In Opera, the true version is after "Opera" or after "Version"
        if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
            browserName = 'Opera';
            fullVersion = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf('Version')) !== -1) {
                fullVersion = nAgt.substring(verOffset + 8);
            }
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
            browserName = 'Microsoft Internet Explorer';
            fullVersion = nAgt.substring(verOffset + 5);
        }
        // In Chrome, the true version is after "Chrome"
        else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
            browserName = 'Chrome';
            fullVersion = nAgt.substring(verOffset + 7);
        }
        // In Safari, the true version is after "Safari" or after "Version"
        else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
            browserName = 'Safari';
            fullVersion = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) !== -1) {
                fullVersion = nAgt.substring(verOffset + 8);
            }
        }
        // In Firefox, the true version is after "Firefox"
        else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
            browserName = 'Firefox';
            fullVersion = nAgt.substring(verOffset + 8);
        }
        // In most other browsers, "name/version" is at the end of userAgent
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browserName = nAgt.substring(nameOffset, verOffset);
            fullVersion = nAgt.substring(verOffset + 1);
            if (browserName.toLowerCase() === browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }
        // trim the fullVersion string at semicolon/space if present
        if ((ix = fullVersion.indexOf(';')) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
        }

        if ((ix = fullVersion.indexOf(' ')) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
        }

        majorVersion = parseInt('' + fullVersion, 10);
        if (isNaN(majorVersion)) {
            fullVersion = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        nVer = browserName + ' ' + fullVersion;
        return nVer;
    };

    /**
     * @ngdoc method
     * @name utilidades#getOS
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que obtiene el sistema operativo
     */
    this.getOS = function() {
        var OSName = 'Unknown OS';
        if (navigator.appVersion.indexOf('Win') !== -1) {
            OSName = 'Windows';
        }
        if (navigator.appVersion.indexOf('Mac') !== -1) {
            OSName = 'MacOS';
        }
        if (navigator.appVersion.indexOf('X11') !== -1) {
            OSName = 'UNIX';
        }
        if (navigator.appVersion.indexOf('Linux') !== -1) {
            OSName = 'Linux';
        }
        return OSName;
    };

    /**
     * @ngdoc method
     * @name utilidades#getClientOffsetForDateTime
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que obtiene el offset del cliente
     */
    this.getClientOffsetForDateTime = function (date){
        var momentDate = moment(date).format(constantes.formatoComunicacion);
        return moment.tz(momentDate, conexion.getUsuario().timeZone)._offset * 60000;
    };

    /**
     * @ngdoc method
     * @name utilidades#convertMachineDateTimeToUTC
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que convierte un dateTime a UTC partiendo del objeto creado en la máquina local
     */
    this.convertMachineDateTimeToUTC = function (dateIncident, timeIncident){
        var fechaSuceso = new Date(dateIncident.getFullYear(), dateIncident.getMonth(), dateIncident.getDate(),
            timeIncident.split(':')[0], timeIncident.split(':')[1], timeIncident.split(':')[2]);
        var offsetLocal = fechaSuceso.getTimezoneOffset() * 60000 * -1;
        // Restamos el offset local a la fecha dateTime de la máquina
        var fechaSucesoDate = new Date(fechaSuceso - offsetLocal);
        return moment(fechaSucesoDate);
    };

    /**
     * @ngdoc method
     * @name utilidades#convertDateTimeToUTC
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que convierte un dateTime a UTC partiendo del timeZone de la flota del usuario
     */
    this.convertDateTimeToUTC = function (dateIncident, timeIncident){
        var offsetLocal = dateIncident.getTimezoneOffset() * 60000;
        //Sacamos el clientOffset partiendo del timeZone del usuario (información que disponemos en usuario)
        var clientOffset = this.getClientOffsetForDateTime(dateIncident);
        var fechaSuceso = new Date(dateIncident.getFullYear(), dateIncident.getMonth(), dateIncident.getDate(),
            timeIncident.getHours(), timeIncident.getMinutes(), timeIncident.getSeconds());
        // Obtenemos la fecha y hora en zona horaria local
        // Restamos el offset de la zona horaria local y el offset del cliente para pasar la fecha y hora a UTC
        var fechaSucesoDate = new Date(fechaSuceso - offsetLocal - clientOffset);

        return moment.utc(fechaSucesoDate);
    };

    /**
     * @ngdoc method
     * @name utilidades#convertFromUTCToClientTimeZone
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que convierte de UTC a dateTime del timeZone del usuario
     */
    this.convertFromUTCToClientTimeZone = function (dateTime){
        return moment.utc(dateTime).tz(conexion.getUsuario().timeZone);
    };

    /**
     * @ngdoc method
     * @name utilidades#convertAndFormatFromUTCToClientTZ
     * @methodOf utilidades.service:utilidades
     * @description
     * Función que convierte de UTC a dateTime del timeZone del usuario y devuelve la fecha formateada
     */
    this.convertAndFormatFromUTCToClientTZ = function (dateTime){
      return moment.utc(dateTime).tz(conexion.getUsuario().timeZone).format("YYYY-MM-DD HH:mm:ss");
    };

    /* Funcion que obtiene el dia operativo del cliente */
    this.getCurrentClientDay = function(){
      return moment.utc().tz(conexion.getUsuario().timeZone).format("YYYY-MM-DD");
    }

    /* Funcion que transforma una fecha a un formato amigable para el ser humano
       @date Fecha a formatear
    */
    this.getHumanReadableFormat = function(date){
      return moment(date).format('HH:mm:ss DD MMM');
    }

    /* Funcion que transforma una fecha tokenizada en segundos
       @dt Fecha tokenizada en formato array
    */
    function dateTokens2seconds(dt){
      if(angular.isUndefined(dt) || dt === null || dt.length !== 6){
        return undefined;
      } else {
        var year = (parseInt(dt[0]) - 1970) * 31536000;
        var month = parseInt(dt[1]) * 2628000;
        var day = parseInt(dt[2]) * 86400;
        var hour = parseInt(dt[3]) * 3600;
        var min = parseInt(dt[4]) * 60;
        var sec = parseInt(dt[5]);
        return year + month + day + hour + min + sec;
      }
    }

    /* Funcion que formatea el valor del odometro
       @odometer Valor de odometro
    */
    this.formatOdometry = function(odometer){
      if(angular.isUndefined(odometer) || odometer === null || odometer === '-'){
        return '-';
      } else {
        var resto = odometer % 1;
        var entero = Math.floor(odometer).toString().split('');
        var pos=0;
        var newEntero = [];
        for(var i=entero.length-1; i>=0; i--){
          newEntero.push(entero[i]);
          pos++;
          if(pos % 3 === 0 && i > 0){ newEntero.push('.'); }
        }
        return  newEntero.reverse().join('');
      }
    }

    /* Funcion que formatea la fecha de ultima actualizacion
       @lastUpdate Hora de ultima actualizacion
    */
    this.formatLastUpdate = function(lastUpdate){
      try {
        if(angular.isDefined(lastUpdate) && lastUpdate !== null && lastUpdate.length === 19){
          var daysUntil = parseInt(secondsUntilNow(lastUpdate) / 86400);
          if(daysUntil < 0){
            return '-';
          } else if(daysUntil === 0){
            var hourTokens = calculateHourTokens(lastUpdate);
            if(hourTokens === null){
              return '-';
            } else if(this.isYesterday(lastUpdate)){
              return $translate.instant('Ayer');
            } else {
              var hours = hourTokens[0];
              var minutes = hourTokens[1];
              var ampm = hours >= 12 ? 'pm' : 'am';
              hours = hours % 12;
              hours = hours ? hours : 12;
              return hours + ':' + minutes + ' ' + ampm;
            }
          } else {
            return (this.isYesterday(lastUpdate)) ? $translate.instant('Ayer') : daysUntil + ' ' + $translate.instant('dias');
          }
        } else{
          return '-';
        }
      } catch(ex){
        $log.warn('lastUpdate: ' + lastUpdate)
      }
    }

    /* Funcion que formatea la informacion relativa a la última actualización
       para mostrar la unidad más representativa.
       @lastUpdate Hora de ultima actualizacion en formato YYYY-MM-DDTHH:mm:ss
    */
    this.lastUpdateUnit = function(lastUpdate){
      if(!isEmpty(lastUpdate) && lastUpdate.length === 19){
        var periods = [
          { unit: 'd', sec: 86400 }, { unit: 'h', sec: 3600 }, { unit: 'm', sec: 60 }, { unit: 's', sec: 1 }
        ];
        var secondsElapsed = secondsUntilNow(lastUpdate);
        if(secondsElapsed < 60){
          return { value: $translate.instant('Ahora'), isHour: false };
        } else {
          var period = periods.find(function(x){ return secondsElapsed/x.sec > 1; });
          return { value: isEmpty(period) ? '-' : parseInt(secondsElapsed / period.sec) + period.unit, isHour: true };
        }
      } else {
        $log.error('[lastUpdateUnit] La fecha especificada no cumple con el formato YYYY-MM-DDTHH:mm:ss');
        return { value: '-', isHour: false };
      }
    }

    /* Funcion que indica si la fecha de ultima actualizacion es de ayer
       @lastUpdate Fecha de ultima actualizacion
    */
    this.isYesterday = function(lastUpdate){
      var today = moment($filter('date')(this.getUserDate(), 'yyyy-MM-dd'));
      var yesterday = today.subtract(1, 'days').format('YYYY-MM-DD');
      var lastUpdateF = (lastUpdate.includes(' ')) ? lastUpdate.split(' ')[0] : lastUpdate.split('T')[0];
      return yesterday === lastUpdateF;
    }

    /* Funcion que tokenifica una fecha
       @date Fecha en formato ISO
    */
    function calculateHourTokens(date){
      if(date.includes('T')){
        return date.split('T')[1].split(':');
      } else if(date.includes(' ')){
        return date.split(' ')[1].split(':');
      } else {
        $log.warn('Error calculando token de horas');
        return null;
      }
    }

    function secondsUntilNow(date){
      var usuario;
      if(angular.isDefined(conexion.getOrganizacion()) && angular.isDefined(conexion.getOrganizacion().org)){
        if(conexion.estaPersonado()){
          usuario = conexion.getUsuario();
        }else{
          usuario = conexion.getOrganizacion();
        }
      }else{
        usuario = conexion.getUsuario();
      }
      var dateReal = new Date(Date.now() + usuario.clientOffset).toISOString();
      return diffSecondsDates(dateReal, date);
    }

    function diffSecondsDates(usrReal, date){
      var usrRealTokens = usrReal.split('.')[0].replace('T', ':').replace(/-/g, ':').split(':');
      var dateTokens;
      if(date.includes('T')){
        dateTokens = date.replace('T', ':').replace(/-/g, ':').split(':');
      } else {
        dateTokens = date.replace(' ', ':').replace(/-/g, ':').split(':');
      }
      /* Calcular segundos */
      var usrRealSec = dateTokens2seconds(usrRealTokens);
      var dateSec = dateTokens2seconds(dateTokens);
      var diff = usrRealSec - dateSec;
      return diff;
    }

    /* Funcion que se encarga de agrupar los vehiculos por fecha de
    ultima actualizacion */
    this.getGroupByLastUpdate = function(vehicleList, dateformat){
      var groups = { actual: [], antiguo: [], muyAntiguo: [], extAntiguo: [] };
      var horaCliente = moment(this.getUTCDate());
      // Obtener periodos
      var datoAntiguo = Number(conexion.getUsuario().valores.TIEMPO_EN_ESTADO_OK_SIN_DATOS / 60);
      var datoMuyAntiguo = Number(conexion.getUsuario().valores.TIEMPO_EN_ESTADO_WARNING_SIN_DATOS / 60);
      var extAntiguo = Number(conexion.getUsuario().valores.TIEMPO_EN_ESTADO_ERROR_SIN_DATOS / 60);
      // Alimentar grupos
      vehicleList.forEach(function(x){
        var client_date = moment(x.lastUpdateUtc, dateformat);
        var diff = horaCliente.diff(client_date) / 1000 / 60;
        diff = Math.abs(diff);
        if(diff <  datoAntiguo){
          groups.actual.push(x);
        }else if(diff >= datoAntiguo && diff < datoMuyAntiguo){
          groups.antiguo.push(x);
        }else if(diff >= datoMuyAntiguo && diff < extAntiguo){
          groups.muyAntiguo.push(x);
        }else{
          groups.extAntiguo.push(x);
        }
      });
      return groups;
    }

    /* Funcion que formatea la fecha de alerta al formato dd-MM hh:mm
       @fechaAlerta Fecha que se desea formatear
    */
    this.formatFechaAlerta = function(fechaAlerta){
      if(angular.isUndefined(fechaAlerta) || fechaAlerta === null){
        return '-';
      } else {
        var tokens;
        if(fechaAlerta.includes('T')){
          tokens = fechaAlerta.split('T');
        } else {
          tokens = fechaAlerta.split(' ');
        }
        var day = tokens[0].substring(8,10) + '-' + tokens[0].substring(5,7);
        var hours = tokens[1].substring(0,5);
        return day + ' ' + hours;
      }
    }

    /* Funcion que se encarga de pasar a minusculas todas las letras de un string
       @string Cadena cuyas letras se quieren pasar a minusculas
       Devuelve un string vacio si el string inicial NULL o UNDEFINED
    */
    this.toLowerCase = function(string){
      if(angular.isDefined(string) && string !== null && angular.isString(string)){
        return string.toLowerCase();
      } else {
        return '';
      }
    }

    /* Funcion que comprueba si el elemento es vacio
       @elem Elemento a tratar
       @attr Atributo a analizar
    */
    var isEmpty = function(elem, attr){
      return angular.isUndefined(attr) ? elemIsEmpty(elem) : nestedElemIsEmpty(elem, attr);
    }
    this.isEmpty = isEmpty;

    /* Funcion privada que determina si un elemento es vacio
       @elem Elemento a tratar
    */
    function elemIsEmpty(elem){
      if(angular.isUndefined(elem) || elem === null){
        return true;
      } else if(angular.isString(elem)){
        return elem.length === 0;
      } else if(angular.isArray(elem)){
        return elem.length === 0;
      } else if(angular.isObject(elem)){
        for(var key in elem) {
          if(elem.hasOwnProperty(key))
            return false;
        }
        return true;
      } else {
        return false;
      }
    }

    /* Funcion privada que determina si un atributo de un elemento anidado es vacio
       @elem Elemento a tratar
       @attr Atributo a analizar
    */
    function nestedElemIsEmpty(elem, attr){
      var elem_c = angular.copy(elem);
      if(elemIsEmpty(elem_c) || elemIsEmpty(attr) || !angular.isObject(elem_c) || !angular.isString(attr) || !attr.includes('.')){
        return true;
      } else {
        var attrs = attr.split('.').slice(1);
        for(var i=0; i < attrs.length; i++){
          if(angular.isObject(elem_c) && !elemIsEmpty(elem_c[attrs[i]])){
            elem_c = elem_c[attrs[i]];
          } else {
            return true;
          }
        }
        return false;
      }
    }

    /* Funcion que mezcla una lista de colores
       @colorList Lista de colores a ordenar. Si no se define se obtiene desde constantes
       @numColors Numero de colores a devolver. Si no se define se inicializa a 20.
       @separation Numero de colores adyacented que no pueden estar al lado de un color. En caso de no especificarlo sera de 4.
    */
    this.getIpanelColors = function(colorList, numColors, separation){
      // Validar parametros
      numColors = (isEmpty(numColors)) ? 20 : numColors;
      separation = (isEmpty(separation) || separation > numColors || separation <= 0) ? 4 : separation;
      // Obtener los colores en caso de no haberlos obtenido por parametro
      if(isEmpty(colorList)){
        colorList = [];
        next = true;
        var color;
        var i = 0;
        while(next){
          color = constantes.getColor('colorPicker' + i);
          isEmpty(color) ? (next = false) : colorList.push(color);
          i++;
        }
      }
      // Reordenar colores en caso de haberlos
      if(!isEmpty(colorList)){
        var colorMap = [];
        var pos, posIndex;
        colorList.forEach(function(x, i){
          pos = i % separation;
          posIndex = colorMap.findIndex(function(y){ return y.key === pos; });
          if(posIndex === -1){
            colorMap.push({ key: pos, values: [x] });
          } else {
            colorMap[posIndex].values.push(x);
          }
        });
        // Reagrupar colores
        var result = [];
        colorMap.forEach(function(x){ result = result.concat(x.values); });
        return result.splice(0, numColors);
      } else {
        return [];
      }
    }

    /* Funcion que transforma los segundos recibidos al formato HH:MM:SS
       @seg Cantidad de segundos a transformar
    */
    this.seconds2Hour = function(seg){
      if(this.isEmpty(seg)){
        return null;
      } else {
        var hour = parseInt(seg / 3600);
        var min = parseInt((seg - (3600 * hour)) / 60);
        var sec = seg - (3600 * hour + 60 * min);
        var result = '';
        if(hour > 0){
          result = hour + 'h ' + min + 'm ' + sec + 's';
        } else if(min > 0) {
          result = min + 'm ' + sec + 's';
        } else {
          result = sec + 's';
        }
        return result;
      }
    }

    /* Funcion que genera la URL final a partir de los parametros
       @params Parametros formateados para la URL
       @variable Variables a añadir en la url
       @nombre Nombre de la variable a tratar
    */
    this.generateUrlParams = function(params, variable, nombre){
      if(isEmpty(variable) || isEmpty(nombre)){
        return params;
      } else {
        return params + ((isEmpty(params)) ? '?' : '&') + nombre + '=' + variable;
      }
    }

    /* Funcion que obtiene la localizacion raiz del usuario */
    this.getRootLocation = function(){
      var curLocation = window.location.href;
      return curLocation.substring(0, getPosition(curLocation, '/', 3));
    }

    /* Funcion que devuelve la informacion del navegador en donde se esta
       ejecutando el codigo
    */
    this.getBrowserInfo = function(){

      try {

        var navUserAgent = navigator.userAgent;
        var browserName  = navigator.appName;
        var browserVersion  = ''+parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion,10);
        var tempNameOffset,tempVersionOffset,tempVersion;

        if ((tempVersionOffset=navUserAgent.indexOf("Opera"))!=-1) {
         browserName = "Opera";
         browserVersion = navUserAgent.substring(tempVersionOffset+6);
         if ((tempVersionOffset=navUserAgent.indexOf("Version"))!=-1)
           browserVersion = navUserAgent.substring(tempVersionOffset+8);
        } else if ((tempVersionOffset=navUserAgent.indexOf("MSIE"))!=-1) {
         browserName = "Microsoft Internet Explorer";
         browserVersion = navUserAgent.substring(tempVersionOffset+5);
        } else if ((tempVersionOffset=navUserAgent.indexOf("Chrome"))!=-1) {
         browserName = "Chrome";
         browserVersion = navUserAgent.substring(tempVersionOffset+7);
        } else if ((tempVersionOffset=navUserAgent.indexOf("Safari"))!=-1) {
         browserName = "Safari";
         browserVersion = navUserAgent.substring(tempVersionOffset+7);
         if ((tempVersionOffset=navUserAgent.indexOf("Version"))!=-1)
           browserVersion = navUserAgent.substring(tempVersionOffset+8);
        } else if ((tempVersionOffset=navUserAgent.indexOf("Firefox"))!=-1) {
         browserName = "Firefox";
         browserVersion = navUserAgent.substring(tempVersionOffset+8);
        } else if ( (tempNameOffset=navUserAgent.lastIndexOf(' ')+1) < (tempVersionOffset=navUserAgent.lastIndexOf('/')) ) {
         browserName = navUserAgent.substring(tempNameOffset,tempVersionOffset);
         browserVersion = navUserAgent.substring(tempVersionOffset+1);
         if (browserName.toLowerCase()==browserName.toUpperCase()) {
          browserName = navigator.appName;
         }
        }

        // trim version
        if ((tempVersion=browserVersion.indexOf(";"))!=-1)
           browserVersion=browserVersion.substring(0,tempVersion);
        if ((tempVersion=browserVersion.indexOf(" "))!=-1)
           browserVersion=browserVersion.substring(0,tempVersion);

        return { name: browserName, version: browserVersion };

      } catch(error){
        return { name: 'Unknown', version: undefined };
      }

    }

    /*********************************/
    /**   Enseñar mensajes Toogle   **/
    /*********************************/

    /* Funcion que se encarga de visualizar el toast para notificar si una operacion
       se ha realizado correctamente o no
       @msg Mensaje a mostrar en el toast
       @messageData Objeto con la informacion a interpolar
    */
    this.showNotificacion = function(message, messageData){
      if(!this.isEmpty(message)){
        $mdToast.show(defineToast(message, messageData));
      }
    }

    /* Funcion que se encarga de visualizar el toast para notificar si una operacion
       se ha realizado correctamente o no
       @container Identificador del container en el que se quiere enseñar. Ej: #idContainer
       @msg Mensaje a mostrar en el toast
       @messageData Objeto con la informacion a interpolar
    */
    this.showNotificacionWithContainer = function(container, message, messageData){
      if(!this.isEmpty(message)){
        $mdToast.show(defineToast(message, messageData, container));
      }
    }

    /* Funcion interna que crea la parametrizacion para el toast
       @msg Mensaje a mostrar en el toast
       @messageData Objeto con la informacion a interpolar
       @container Identificador del container en el que se quiere enseñar. Ej: #idContainer
    */
    function defineToast(message, messageData, container){
      var msg = (isEmpty(messageData) ? $translate.instant(message) : $translate.instant(message, messageData));
      var toastInfo = $mdToast.simple().textContent(msg).position(getToastPosition()).hideDelay(3000);
      if(!isEmpty(container)){
        toastInfo.parent($(container));
      }
      return toastInfo;
    }

    /* Funcion que devuelve la posicion del toast */
    function getToastPosition() {
      var toastPosition = angular.extend({}, { bottom: false, top: true, left: false, right: true });
      return Object.keys(toastPosition)
      .filter(function(pos) {
        return toastPosition[pos];
      }).join(' ');
    }

    /* Funcion que devuelve el dia del usuario en formato YYYY-MM-DD */
    this.getCurrentLocalDay = function(){
      var userDate = this.getUserDate();
      return moment(userDate).format("YYYY-MM-DD");
    }

    /**************************/
    /* Enseñar mensaje Alerta */
    /**************************/

    /* Funcion que se encarga de abrir un popup de alerta
       @clickOutsideToClose True si se quiere permitir cerrar el dialog pulsando fuera del mismo
       @title Titulo del dialog
       @textContent Texto que se quiere enseñar en el cuerpo del dialog
       @textButton Texto a enseñar en el boton de cierre de dialog
       @ev Evento nativo de AngularJS que se genera en la apertura del dialog
    */
    this.showConfirmDialog = function (clickOutsideToClose, title, textContent, textButton, ev) {
      return $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(clickOutsideToClose)
          .title($translate.instant(title))
          .textContent($translate.instant(textContent))
          .ok($translate.instant(textButton))
          .multiple(true)
          .targetEvent(ev)
      )
    }

    /* Funcion que se encarga de abrir un popup de confirmacion
       @title Titulo del dialog
       @textContent Texto que se quiere enseñar en el cuerpo del dialog
       @okBtn Texto a enseñar en el boton de aceptar
       @cancelBtn Texto a enseñar en el boton de cancelar
       @ev Evento nativo de AngularJS que se genera en la apertura del dialog
    */
    this.showConfirm = function(title, textContent, okBtn, cancelBtn, ev) {
      var confirm = $mdDialog.confirm()
            .title($translate.instant(title))
            .textContent($translate.instant(textContent))
            .ok($translate.instant(okBtn))
            .cancel($translate.instant(cancelBtn))
            .targetEvent(ev)
      return $mdDialog.show(confirm);
    };

    /*
       Utilidad que comprueba si la hora es entre las 7:00 y las 22:00 en hora de la máquina local
    */
    this.isDay = function () {
      var currentHour = new Date().getHours();
      return (currentHour > 6 && currentHour < 22);
    }

    this.isJSON = function(str){
      try {
        var json = JSON.parse(str);
        return (typeof json === 'object');
      } catch (e) {
        return false;
      }
    }

  });
})();

(function() {
  'use strict';

  angular
    .module('app')
    .service('mdmService', mdmService);

  function mdmService($log, $http, $window, $translate, constantes, conexion, $q, utilidades, moment) {
    var systemsData;
    var versionData;
    var service = {
      getMdms2: getMdms2,
      getTareas: getTareas,
      configuracion: configuracion,
      configuracionMultiples: configuracionMultiples,
      getEquipamiento: getEquipamiento,
      searchConfig: searchConfig,
      searchVersion: searchVersion,
      saveFileVersion: saveFileVersion,
      updateNameVersion: updateNameVersion,
      deleteVersion: deleteVersion,
      getSystems: getSystems,
      sendConfiguracion: sendConfiguracion,
      getVersionSystema: getVersionSystema,
      getAllVersion: getAllVersion,
      putVersions: putVersions,
      putVersionMultiSelect: putVersionMultiSelect,
      putConfigMultiSelect: putConfigMultiSelect,
      getVersions: getVersions,
      postVersions: postVersions,
      putVersion: putVersion,
      putCancelUpdate : putCancelUpdate,
      putVersionsEquipment: putVersionsEquipment
    };
    return service;

    function putCancelUpdate(equipments){
      var url = constantes.getApiUrl('ips_go_mdm', 'cancelUpdate') + '?equipmentId=' + equipments;
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.put(url, {}, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
      }
    }


    function getMdms2() {
      var filejson = 'assets/jsons/dispositivos.json';

      return $http.get(filejson).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
      }
    }

    function getTareas(task, inicioFecha, finFecha, page, size) {
      var deferredAbort  = $q.defer();

      var url = constantes.getApiUrl('ips_go_mdm', 'tareasxdispositivo');
      url = url + "?equipmentId=" + task;

      if (inicioFecha !== "") url = url + "&dateIni=" + inicioFecha;
      if (finFecha !== "") url = url + "&dateEnd=" + finFecha;
      if (page !== "") url = url + "&page=" + page;
      if (size !== "") url = url + "&size=" + size;

      var config = {
        headers: {'Authorization': 'Bearer ' + conexion.getAuthToken()},
        timeout: deferredAbort.promise
      };

      var request = $http.get(url, config)
      var promise = request.then(okFunction).catch(errorFunction);

      promise.abort = function() {
        deferredAbort.resolve();
      };

      function okFunction(response) {
        response.data.content.forEach(function(elemento) {
          elemento.utcIniDate = moment(utilidades.convertFromUTCToClientTimeZone(elemento.dateIni)).format('YYYY-MM-DDTHH:mm:ss');
        });
        return {
          mac: task,
          data: response.data
        };
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Timeout al intentar recuperar tareas' : 'Error en ' + angular.toJson(error));
      }

      promise.finally(
        function() {
            promise.abort = angular.noop;
            deferredAbort = request = promise = null;
        }
    );

      return( promise );
    }

    //Petición principal a la API para obtencion de equipamientos
    function getEquipamiento(page, size, sort, filter, firstTime) {
      var url = constantes.getApiUrl('ips_go_mdm', 'equipamiento');

      if (!utilidades.isEmpty(filter) && !utilidades.isEmpty(sort) && !utilidades.isEmpty(page) && !utilidades.isEmpty(size)) {
        url += '?filter=' + filter + '&sort=' + sort + '&page=' + page + '&size=' + size;
      } else if(!utilidades.isEmpty(filter) && utilidades.isEmpty(sort) && !utilidades.isEmpty(page) && !utilidades.isEmpty(size)) {
        url += '?filter=' + filter + '&page=' + page + '&size=' + size;
      } else if (utilidades.isEmpty(filter) && !utilidades.isEmpty(sort) && !utilidades.isEmpty(page) && !utilidades.isEmpty(size)) {
        url += '?sort=' + sort + '&page=' + page + '&size=' + size;
      } else if (utilidades.isEmpty(filter) && utilidades.isEmpty(sort) && !utilidades.isEmpty(page) && !utilidades.isEmpty(size)) {
        url += '?page=' + page + '&size=' + size;
      }

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      
      return $http.get(url, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        if (firstTime === 1 && !utilidades.isEmpty(response, "response.data.content")) {
          response.data.content[0].selected = true;
        }

        response.data.content.forEach(function(elemento) {
          elemento.task = [];
          elemento.groups = [];
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Timeout al recuperar tareas de dispositivo' : 'Error en ' + angular.toJson(error));
      }
    }

    //Funcion para la configuracion de servicios basados por dispositivo
    function configuracion(vequipamiento, subsystem) {
      var url = constantes.getApiUrl('ips_go_mdm', 'sumatoriahash');
      url = url.replace('{0}', vequipamiento);
      url = url.replace('{1}', subsystem);

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.get(url, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Tiempo sobrepasado para solicitud' : 'Error en ' + angular.toJson(error));
      }
    }

    function configuracionMultiples(vequipamiento, subsystem) {
      var url = constantes.getApiUrl('ips_go_mdm', 'getConfiguracionesMultiples');
      url = url.replace('{0}', subsystem) + "?equipmentId=" + vequipamiento;
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.get(url, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        if (error.status === -1) {
          $log.error('Tiempo sobrepasado para solicitud');
        } else {
          $log.error('Error' + angular.toJson(error));
        }
      }

    }

    //Peticion para obtencion de valores por configuracion
    function searchConfig(hash) {
      var url = constantes.getApiUrl('ips_go_mdm', 'configxversion');
      url = url.replace('{0}', hash);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken(),
          'Content-Type': 'text/plain'
        },
        data: '',
        timeout: 90000,
        transformResponse: function(data) {
          return data;
        }
      };
      return $http.get(url, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Tiempo sobrepasado para solicitud' : 'Error en ' + angular.toJson(error));
      }
    }

    function searchVersion(sistema, tiposub) {
      var url = constantes.getApiUrl('ips_go_mdm', 'configxsubsistema');
      url = url.replace('{0}', sistema);
      url = url.replace('{1}', tiposub);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.get(url, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Tiempo sobrepasado para solicitud' : 'Error en ' + angular.toJson(error));
      }
    }

    function saveFileVersion(textarea, nameVersion, fichero) { // Añadir parametros version
      var datosend = {
        "content": textarea,
        "uidConfigurationType": fichero.configurationType.uidConfigurationType,
        "uidSubsystemType": fichero.subsystemType.uidSubsystemType,
        "version": nameVersion
      };
      var url = constantes.getApiUrl('ips_go_mdm', 'nuevaversion');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.post(url, datosend, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Tiempo sobrepasado para solicitud' : 'Error en ' + angular.toJson(error));
      }
    }

    function updateNameVersion(nameVersion, fichero) {
      var datosend = {
        "version": nameVersion
      };
      var url = constantes.getApiUrl('ips_go_mdm', 'updateversion');
      url = url.replace('{0}', fichero.hash);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.put(url, datosend, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Tiempo sobrepasado para solicitud' : 'Error en ' + angular.toJson(error));
      }
    }

    // Funcion para la eliminacion de servicios filtraddos pos dispositivo
    function deleteVersion(version) {
      var url = constantes.getApiUrl('ips_go_mdm', 'deleteVersion');
      url = url.replace('{0}', version.hash);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.delete(url, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Timeout al eliminar servicio por dispositivo' : 'Error en ' + angular.toJson(error));
      }
    }
    
    //Petición para traer equipamientos desde core_mng
    function getSystems() {
      if(!utilidades.isEmpty(systemsData)){
        return systemsData
      }

      var url = constantes.getApiUrl('ips_go_mdm', 'getSystems');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      systemsData = $http.get(url, config).then(okFunction).catch(errorFunction);

      return systemsData

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'timeout al realizar la peticion' : 'Error en ' + angular.toJson(error));
      }
    }

    //Peticion para el envio de versión
    function sendConfiguracion(vequipamiento, hashNuevo) {
      var url = constantes.getApiUrl('ips_go_mdm', 'sendConfig');
      url = url.replace('{0}', vequipamiento);
      url = url.replace('{1}', hashNuevo);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.put(url, '', config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'timeout al realizar la peticion' : 'Error en ' + angular.toJson(error));
      }

    }

    function getVersionSystema(idEquipamiento, uidVersionSystema) {
      var url = constantes.getApiUrl('ips_go_mdm', 'getVersionSystema');
      url = url.replace('{0}', idEquipamiento).replace('{1}', uidVersionSystema);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.get(url, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'timeout al realizar la peticion' : 'Error en ' + angular.toJson(error));
      }
    }

    function getAllVersion(subSystema) {
      var url = constantes.getApiUrl('ips_go_mdm', 'getAllVersion');
      url = url.replace('{0}', subSystema);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.get(url, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'timeout al realizar la peticion' : 'Error en ' + angular.toJson(error));
      }
    }

    function putVersions(vequipamiento, subSystema, version) {
      var url = constantes.getApiUrl('ips_go_mdm', 'putVersions');
      url = url.replace('{0}', vequipamiento).replace('{1}', subSystema);

      var datos = {
        "version": version
      };

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.put(url, datos, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Timeout al realizar la peticion' : 'Error en ' + angular.toJson(error));
      }
    }

    function putVersionMultiSelect(vequipamiento, subSystemas, version) {
      var deferred = $q.defer();
      var promises = [];

      for (var i = 0; i < vequipamiento.length; i++) {
        var url = constantes.getApiUrl('ips_go_mdm', 'putVersions');
        url = url.replace('{0}', vequipamiento[i]).replace('{1}', subSystemas);

        var datos = {
          "version": version
        };

        var config = {
          headers: {
            'Authorization': 'Bearer ' + conexion.getAuthToken()
          },
          timeout: 90000
        };
        promises.push($http.put(url, datos, config));
      }

      $q.all(promises).then(function(response) {
        deferred.resolve(response);
      });

      return deferred.promise;
    }

    function putConfigMultiSelect(subSystemas, hashNuevo) {
      var deferred = $q.defer();
      var promises = [];

      for (var i = 0; i < subSystemas.length; i++) {
        var url = constantes.getApiUrl('ips_go_mdm', 'sendConfig');
        url = url.replace('{0}', subSystemas[i]);
        url = url.replace('{1}', hashNuevo);
        var config = {
          headers: {
            'Authorization': 'Bearer ' + conexion.getAuthToken()
          },
          timeout: 90000
        };
        promises.push($http.put(url, '', config));
      }

      $q.all(promises).then(function(response) {
        deferred.resolve(response);
      });

      return deferred.promise;
    }
    
    //Petición para traer equipamientos desde core_mng
    function getVersions(refreshFlag) {
      if(!utilidades.isEmpty(versionData) && !refreshFlag){
        return versionData;
      }

      var url = constantes.getApiUrl('ips_go_mdm', 'getVersions');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      versionData = $http.get(url, config).then(okFunction).catch(errorFunction);

      return versionData;

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'timeout al realizar la peticion' : 'Error en ' + angular.toJson(error));
      }
    }

    /* AGREGA NUEVA VERSION */
    function postVersions(dtos) {
      var param = dtos;
      var url = constantes.getApiUrl('ips_go_mdm', 'postVersions');
      var config = {
        headers: {
          'Content-Type': undefined,
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.post(url, param, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Tiempo sobrepasado para solicitud' : 'Error en ' + angular.toJson(error));
      }
    }

    function putVersion(dtos, hash) {
      var url = constantes.getApiUrl('ips_go_mdm', 'putVersion');
      url = url.replace('{0}', hash);

      var datos = dtos;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.put(url, datos, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Timeout al realizar la peticion' : 'Error en ' + angular.toJson(error));
      }
    }

    function putVersionsEquipment(vequipamiento, versionHash) {
      var url = constantes.getApiUrl('ips_go_mdm', 'putVersionsEquipment');
      url = url.replace('{0}', vequipamiento);

      
      var datos = {
        hash : versionHash
      };
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.put(url, datos, config).then(okFunction).catch(errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error((error.status === -1) ? 'Timeout al realizar la peticion' : 'Error en ' + angular.toJson(error));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('configuracionMdmController', configuracionMdmController);

  // function configuracionMdmController($scope, $log, $uibModalInstance, timeZones, datos, languajes, mdmService, md5) {
  function configuracionMdmController($scope, $log, $uibModalInstance, timeZones, datos, mdmService, md5) {
    var vm = this;
    vm.guardarConfig = true;
    vm.hashes = [];
    vm.configuraciones = {};
    vm.select_version = {};
    vm.versiones = [];
    vm.timeZones = timeZones;
    var vequipamiento;
    // var index = vm.select_hash;
    vm.input_nv = true;
    vm.btn_rtn = true;
    vm.btn_save = true;
    vm.btn_del = false;
    vm.btn_edit = false;
    vm.select1 = false;

    if (angular.isDefined(datos)) {
      vm.resultado = angular.copy(datos);
      vequipamiento = vm.resultado.mac;
      vm.titulo = "CONFIGURACIÓN DE dispositivos";
    } else {
      vm.resultado = {};
      vm.titulo = "AGREGAR NUEVA CONFIGURACIÓN";
    }

    angular.forEach(vm.resultado, function(value, ind) {});

    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    //Carga de menu tabs con respectivos sistemas por equipamiento
    vm.obtainSystem = function() {
      mdmService.getSystems().then(function(data) {
        vm.resultado = angular.copy(data);
        vm.subsistemas = data;
        if (!vm.select_hash) {
          vm.obtenerHash(data[0].uidSubsystemType);
        }
      });
    };
    vm.obtainSystem();


    //Funcion para la busqueda de hashes mediante mac y tipo subsistema
    vm.obtenerHash = function(index) {
      mdmService.configuracion(vequipamiento, index).then(function(data) {
        if (data.length > 0) {
          vm.hashActual = '';
          angular.element(document.getElementById('vm.textarea'))[0].disabled = true;
          vm.configuraciones.availableOptions = data;
          data.forEach(function(elemento,index) {
            if(index == 0){
              vm.hashActual = elemento.hash;
              vm.configuraciones.selectedOption = elemento;
              vm.loadVersion(elemento.subsystemType.uidSubsystemType, elemento.configurationType.uidConfigurationType);
              loadConfigVersion(elemento.hash);
            }
          });
          vm.input_nv = true;
          vm.btn_rtn = true;
          vm.btn_edit = false;
        } else {
          vm.configuraciones.availableOptions = [];
          vm.select_version.availableOptions = [];
          vm.hashActual = "";
          vm.hashg = "";
          vm.textarea1 = "";
          vm.select1 = false;
          vm.select_v = false;
          vm.input_nv = true;
          angular.element(document.getElementById('vm.textarea'))[0].disabled = true;
        }
      });
    };

    function loadConfigVersion(dtos) {
      if (dtos !== null) {
        mdmService.searchConfig(dtos).then(function(data) {
          if (data !== "") {
            vm.textarea1 = data;
          } else {
            vm.textarea1 = "";
          }
        });
      }
    }

    vm.loadConfigFichero = function (dtos) {
      if (dtos !== null) {
          vm.loadVersion(dtos.subsystemType.uidSubsystemType, dtos.configurationType.uidConfigurationType);
      }
    };

    //Funcion para petición y obtención de hash
    vm.loadConfig = function(dat) {
      if (dat !== null) {
        // vm.hashActual = dat.hash;
        vm.hashg = dat.hash;
        vm.textarea1 = '';
        if (vm.hashActual !== vm.hashg) {
          vm.guardarConfig = false;
        } else {
          vm.guardarConfig = true;
        }
        // vm.loadVersion(dat.subsystemType.uidSubsystemType, dat.configurationType.uidConfigurationType);
        mdmService.searchConfig(dat.hash).then(function(data) {
          var i = 0;
          vm.textarea1 = data;
          var s = vm.textarea1;
          if (vm.textarea1) {
            vm.generateHash(s);
          }
        });
      }
    };

    //Funcion para la generacion de hash mediante onkeypress
    vm.generateHash = function(text) {
      var s = text;
      s = md5.createHash(s || '');
      vm.hashg = s;
      if (vm.hashActual !== vm.hashg) {
        vm.guardarConfig = false;
      } else {
        vm.guardarConfig = true;
      }
    };

    //Funcion para peticion y carga de versión por subsistema
    vm.loadVersion = function(tipoSubsistema, fileTypeUid) {
      mdmService.searchVersion(tipoSubsistema, fileTypeUid).then(function(data) {
        vm.versiones = [];
        vm.resultado = angular.copy(data);
        vm.select_v = false;
        vm.select_version.availableOptions = data;
        data.forEach(function(elemento) {
          if(elemento !== null && (elemento.hash === vm.hashActual)){
            if (elemento.version == null){
              elemento.version = "No existen versiones";
            }
            vm.select_version.selectedOption = elemento;
            vm.hashg = elemento.hash;
            if (vm.hashActual !== vm.hashg) {
              vm.guardarConfig = false;
            } else {
              vm.guardarConfig = true;
            }
          }
        });

      });
    };

    //Funcionalidad para resetear inputs y comportamiento botones
    vm.newVersion = function() {
      vm.select1 = true;
      vm.select_v = true;
      vm.fileVersionName = "";
      vm.input_nv = false;
      vm.btn_rtn = false;
      vm.btn_edit = true;
      vm.btn_save = false;
      vm.btn_del = true;
      vm.textarea1 = "";
      vm.hashg = "";
      //angular.element(document.getElementById('vm.selector_config'))[0].disabled = true;
      angular.element(document.getElementById('vm.textarea'))[0].disabled = false;
    };

    vm.backVersion = function () {
      loadConfigVersion(vm.select_version.selectedOption.hash);
      vm.btn_rtn = !vm.btn_rtn;
      vm.input_nv = true;
      vm.btn_save = !vm.btn_save;
      vm.btn_del = !vm.btn_del;
      vm.select_v = false;
      vm.btn_edit = !vm.btn_edit;
      vm.select1 = false;
      vm.fileVersionName = "";
      vm.hashg = vm.select_version.selectedOption.hash;
      //angular.element(document.getElementById('vm.selector_config'))[0].disabled = true;
      angular.element(document.getElementById('vm.textarea'))[0].disabled = true;
      if (vm.hashActual !== vm.hashg) {
        vm.guardarConfig = false;
      } else {
        vm.guardarConfig = true;
      }
    };

    //Funcionalidad para edición de versión
    vm.editVersion = function() {
      vm.fileVersionName = vm.select_version.selectedOption.version;
      vm.btn_rtn = !vm.btn_rtn;
      vm.btn_edit = !vm.btn_edit;
      vm.btn_del = !vm.btn_del;
      vm.btn_save = !vm.btn_save;
      vm.select_v = true;
      vm.input_nv = false;
      vm.select1 = true;
      //angular.element(document.getElementById('vm.selector_config'))[0].disabled = true;
      angular.element(document.getElementById('vm.textarea'))[0].disabled = true;
    };

    //Funcion para envio de datos nueva configuración
    vm.sendFile = function(textarea, nameVersion, fichero) {
      var respuesta;
      if (angular.element(document.getElementById('vm.textarea'))[0].disabled != true) {
        mdmService.saveFileVersion(textarea, nameVersion, fichero).then(function(data) {
          respuesta = angular.toJson(data);
          if (respuesta == "true") {
            vm.loadVersion(vm.configuraciones.selectedOption.subsystemType.uidSubsystemType, vm.configuraciones.selectedOption.configurationType.uidConfigurationType);
            vm.textarea1 = "";
            vm.select_v = false;
            vm.select1 = false;
            vm.default_value = nameVersion;
            vm.input_nv = true;
            vm.btn_del = false;
            vm.btn_edit = false;
            vm.btn_save = true;
            vm.btn_rtn = true;
            angular.element(document.getElementById('vm.textarea'))[0].disabled = true;
            //angular.element(document.getElementById('vm.selector_config'))[0].disabled = false;
          }
        });
      } else {
        mdmService.updateNameVersion(nameVersion, fichero).then(function(data) {
          respuesta = angular.toJson(data);
          if (respuesta == "true") {
            vm.loadVersion(vm.configuraciones.selectedOption.subsystemType.uidSubsystemType, vm.configuraciones.selectedOption.configurationType.uidConfigurationType);
            vm.textarea1 = "";
            vm.select_v = false;
            vm.select1 = false;
            vm.input_nv = true;
            vm.btn_del = false;
            vm.btn_edit = false;
            vm.btn_save = true;
            vm.btn_rtn = true;
            angular.element(document.getElementById('vm.textarea'))[0].disabled = true;
            //angular.element(document.getElementById('vm.selector_config'))[0].disabled = false;
          }
        });
      }
    };

    //Función para proceder a eliminar configuraciones
    vm.delFunction = function(hashActual) {
      mdmService.deleteVersion(hashActual).then(function(data) {
        if (data) {
          vm.loadVersion(vm.configuraciones.selectedOption.subsystemType.uidSubsystemType, vm.configuraciones.selectedOption.configurationType.uidConfigurationType);
          vm.textarea1 = "";
          vm.select_v = false;
          vm.select1 = false;
          vm.input_nv = true;
          vm.btn_del = false;
          vm.btn_edit = false;
          vm.btn_save = true;
          vm.btn_rtn = true;
          angular.element(document.getElementById('vm.textarea'))[0].disabled = true;
        }
      });
    };

    //Funcion para envio de configuracion de acuerdo a coincidencia hashActual y hashg
    vm.sendConfig = function(version){
      if (angular.isDefined(version)) {
        mdmService.sendConfiguracion(vequipamiento, version).then(function(data){
          $log.info('Response for the sendConfiguracion: ' + data);
        });
      }
    };

  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
   angular.module('app')
     .directive('datikGestionDispositivosMovilesManager', datikGestionDispositivosMovilesManager);

     function datikGestionDispositivosMovilesManager() {
       return {
         restrict: 'E',
         scope: {
           accountevent: '@'
         },
         templateUrl: 'app/views/gestDispositivosMoviles/directives/tblGestDispMoviles.directive.html',
         controllerAs: 'vm',
         controller: ['$scope','composicion', 'utilidades', '$translate', 'tblCuentasService', 'notificaciones', gestDispositivosMovilesManagerController]
       };

       function gestDispositivosMovilesManagerController($scope, composicion, utilidades, $translate, tblCuentasService, notificaciones) {

         var vm = this;
         composicion.iniciarPantalla();
         vm.datos = [];
         vm.mostrar = {
           tareas: true,
           configDisp: false,
           dispMultiples: false,
           msjSelec: false
         };
         vm.mostrar.tareas = false

         vm.EquipmentType = 'tipo'
         vm.selectVersion = {
          list : [],
          selected : undefined
         }
         vm.showClearBtn = false
         var totalInputChips = 0;

         var macPattern = /^[0-9a-fA-F]+(\s+[0-9a-fA-F]+)*$/
         vm.showMsgDiffTypes = false
         vm.selectedVersion = []
         vm.showVersionManagement = tblCuentasService.obtinePermisos(17);
         var defaultSize = 40

         vm.query = ''
         vm.macList = [];
         vm.filteredMacList = []
         var obj = {}
         var show = true

         vm.onChange = function (){
          obj = { page : 1, size : defaultSize, sort : '', firstTime : 0, list : undefined, showMassive : true }
          show = true
          if (!utilidades.isEmpty(vm, "vm.macList")) {
            show = false
            vm.showClearBtn = true
            var tmpList = csvToArray(vm.macList.toString().replaceAll(' ', ',')).filter(function (x) {return isValidMacAddr(x)})
            
            if (tmpList.length > 100) {
              tmpList.length = 100;
              notificaciones.showNotification('Equipamientos', $translate.instant('Se han solicitado un maximo 100 MACs'), 'info')
            }
            
            vm.macList = tmpList;
            obj.list = vm.macList;
            obj.totalChips = totalInputChips;
            obj.size = vm.macList.length;
          }

          $scope.$broadcast('mostrarConfig', { massive : false, solo : false })
          vm.mostrar.tareas = false
          $scope.$broadcast('manially-show-filter', show);
          $scope.$broadcast('reloadTblMDM', obj);
        }

        function csvToArray(input){
          var arr = [input];
          arr = input.split(',');
          totalInputChips = arr.length;
          arr = filterRepetedValues(arr);
          return arr;
         }

         function filterRepetedValues(arr) {
          var tmp = []
          arr.forEach(function(val)  {
            if(!tmp.includes(val)){
              tmp.push(val)
            }
          });
          return tmp;
         }
        
        $scope.$on('massive-filtered-data', function (ev, data){
          $scope.$broadcast('mdm-massive-filter-data', data)
        })

        vm.cleanMassiveFilter = function (){
          vm.macList = []
          vm.showClearBtn = false
          vm.onChange()
          $scope.$broadcast('mostrarConfig', { massive : false, solo : false })
        }

        $scope.$on('versiones', function (ev, data){
          vm.selectVersion.list = data
        })

        function isValidMacAddr(value){
          return macPattern.test(value);
        }

        vm.gestionarVersiones = function (){
          $scope.$broadcast('version-manager-modal')
        }

         vm.eventoEquipoSeleccionado = 'mdm-item-change-selection';

        $scope.$on('clean-mdm-datik-table', function(){
          $scope.$broadcast('clean-mdm-table');
          vm.mostrar.tareas = false
        })

         $scope.$on("refrescarPantallaMDM", function(ev, soloObj){
           obj = { sort : '',firstTime : 0,page : 1,size : vm.macList.length,list: vm.macList, soloObj : soloObj }
           $scope.$broadcast('reloadTblMDM', obj);
         });

         $scope.$on("muestraDispMultiple", function(event, mostrar){
           vm.mostrar.dispMultiples = mostrar;
         });

         $scope.$on("mostraTareas", function(event, mostrar){
          vm.mostrar.tareas = mostrar;
          vm.mostrar.dispMultiples = false;
         });

         $scope.$on(vm.eventoEquipoSeleccionado, function(event, filaSeleccionada){
          $scope.$broadcast('cambio-en-el-dispositivo-seleccionado', filaSeleccionada[0]);
          if(utilidades.isEmpty(filaSeleccionada[0]) && !utilidades.isEmpty(vm, "vm.macList")){
            $scope.$broadcast('mostrarConfig', { massive : true, solo : false })
          } else if(utilidades.isEmpty(filaSeleccionada[0]) && utilidades.isEmpty(vm, "vm.macList")) {
            $scope.$broadcast('mostrarConfig', { massive : false, solo : false })
          }
          
         });
       }
     }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .directive('datikTareas', datikTareas);

  function datikTareas() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/views/gestDispositivosMoviles/directives/tareas.directive.html',
      controllerAs: 'vm',
      controller: ['$log', 'utilidades', '$scope', '$window','$timeout','$filter', '$translate', '$uibModal', 'timeZones','notificaciones', 'mdmService','$interval','$anchorScroll', datikTareasController]
    };

    function datikTareasController($log, utilidades, $scope, $window, $timeout, $filter, $translate, $uibModal, timeZones,notificaciones, mdmService, $interval,$anchorScroll) {
      var vm = this;
      vm.loading = true;
      vm.pagesTotal = undefined;
      vm.totalCount = undefined;
      vm.dispositivoSeleccionado = 'usuario-table-change-selection';
      vm.dispositivom;
      vm.mostrar = {
        tareas: false
      };
      var tasksPromise

      vm.loadingTasks = true

      vm.determinateValue = 30;
      $interval(function() {
        vm.determinateValue += 1;
        if (vm.determinateValue > 100) {
          vm.determinateValue = 30;
        }
      }, 100);

      $interval(function() {
        var isOnTop = angular.element('#seccionTareas .md-virtual-repeat-scroller').scrollTop() === 0;
        var task;
        if (angular.isDefined(vm.dispositivom) && isOnTop && vm.mostrar.tareas) {
          mdmService.getTareas(vm.dispositivom.equipmentId,'','',2,10).then(function(objTareas) {
            if (angular.isDefined(objTareas) && objTareas.data.content.length > 0) {
              var contador = angular.equals(Math.floor(objTareas.data.content.length / 10), 0) ? 1 : Math.floor(objTareas.data.content.length / 10);
              for (var i = 1; i <= contador; i++) {
                for(var nivel1 = 0 ; nivel1 < 10 ; nivel1++) {
                  if(!utilidades.isEmpty(vm, "vm.dynamicItems1.loadedPages") &&  !utilidades.isEmpty(vm.dynamicItems1.loadedPages[i][nivel1]) && !utilidades.isEmpty(vm.dynamicItems1.loadedPages[i][nivel1].uidTask)){
                    task = objTareas.data.content.find(function (x) {
                      return x.uidTask === vm.dynamicItems1.loadedPages[i][nivel1].uidTask
                    })
                  }
                  if (!utilidades.isEmpty(task)) {
                    vm.dynamicItems1.loadedPages[i][nivel1] = {
                      "uidTask"    : task.uidTask,     "uidTaskType": task.uidTaskType,
                      "idEquipment": task.idEquipment, "status"     : task.status,
                      "parameters" : task.parameters,  "description": task.description,
                      "utcIniDate"    : task.utcIniDate,     "dateEnd"    : task.dateEnd
                    };
                  }
                }
              }
            }
          });
        }
      }, 15000);

      $scope.$on('cambio-en-el-dispositivo-seleccionado', function(event, dispositivoSeleccionado) {
        vm.dispositivom = dispositivoSeleccionado;
        if (!utilidades.isEmpty(dispositivoSeleccionado)) {
          getTareas();
        } else {
          $scope.$emit('mostraTareas', false);
          vm.mostrar.tareas = false;
        }
      });

      vm.table_tareas = {
        maxHeight: "calc(100vh-150px)",
        currentPage: 1,
        perPage: 10,
        numberElementsShowing: undefined,
        elements: [{
          title: 'task',
          information: 'task',
          type: 'array'
        }],
        selection: {
          mode: 'simple',
          getSelectedElements: undefined,
          changeSelectionEventName: 'task-table-change-selection'
        },
        data: []
      };

      function getTareas() {
        vm.loadingTasks = true
        vm.mostrar.tareas = false;
        tasksPromise = mdmService.getTareas(vm.dispositivom.equipmentId,'','',1,'');
        tasksPromise.then(function(objTareas) {
          if (!utilidades.isEmpty(objTareas, "objTareas.data.content")) {
            vm.loadingTasks = false
            vm.mostrar.tareas = true;
            $scope.$emit('mostraTareas', true);
            vm.totalCount = objTareas.data.totalElements;
            vm.dynamicItems1 = new dynamicItems1();
          } else {
            $scope.$emit('mostraTareas', false);
          }
        });
      }

      //Implementación comportamiento scroll infinito
      var dynamicItems1 = function() {
        /**
         * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
         */
        this.loadedPages = {};
        /** @type {number} Total number of items. */
        this.numItems = vm.totalCount;
        /** @const {number} Number of items to fetch per request. */
        this.PAGE_SIZE = 10;
        this.fetchNumItems_();
      };

      // Required.
      dynamicItems1.prototype.getItemAtIndex = function(index) {
        var pageNumber = Math.floor(index / this.PAGE_SIZE) + 1;
        var page = this.loadedPages[pageNumber];

        if (page) {
          return page[index % this.PAGE_SIZE];
        } else if (page !== null) {
          this.fetchPage_(pageNumber);
        }
      };

      // Required.
      dynamicItems1.prototype.getLength = function() {
        return this.numItems;
      };

      dynamicItems1.prototype.fetchPage_ = function(pageNumber) {
        // Set the page to null so we know it is already being fetched.
        var thisItem = this;
        thisItem.loadedPages[pageNumber] = null;

        $timeout(angular.noop, 300).then(angular.bind(this, function() {
          if (vm.mostrar.tareas) {
            thisItem.loadedPages[pageNumber] = [];
            mdmService.getTareas(vm.dispositivom.equipmentId,'','', pageNumber, this.PAGE_SIZE).then(function(objTareas) {
              angular.forEach(objTareas.data.content, function(value) {
                thisItem.loadedPages[pageNumber].push(value);
              });
            });
          }
        }));
      };

      dynamicItems1.prototype.fetchNumItems_ = function() {
        $timeout(angular.noop, 300).then(angular.bind(this, function() {
          this.numItems = vm.totalCount;
        }));
      };

      vm.showLogs = function() {
        var elemento = {
          titulo: $translate.instant("Ver logs") + "-" + vm.dispositivom.equipmentId
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/gestDispositivosMoviles/modals/verLogs.modal.html',
          controller: 'verLogsController as vm',
          windowClass: 'logsInfo',
          scope: $scope,
          size: 'lg', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {});
      };

    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app')
    .controller('datikScrollController', datikScrollController)

      datikScrollController.$inject = ['$scope', '$window', '$timeout', 'constantes', 'conexion', '$http'];

      function datikScrollController($scope, $window, $timeout, constantes, conexion, $http) {
        var vm = this;
        // In this example, we set up our model using a class.
        // Using a plain object works too. All that matters
        // is that we implement getItemAtIndex and getLength.
        var DynamicItems = function() {
          /**
           * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
           */
          this.loadedPages = {};

          /** @type {number} Total number of items. */
          this.numItems = 0;

          /** @const {number} Number of items to fetch per request. */
          this.PAGE_SIZE = 3;

          this.fetchNumItems_();
        };

        // Required.
        DynamicItems.prototype.getItemAtIndex = function(index) {
          var pageNumber = Math.floor(index / this.PAGE_SIZE);
          var page = this.loadedPages[pageNumber];

          if (page) {
            return page[index % this.PAGE_SIZE];
          } else if (page !== null) {
            this.fetchPage_(pageNumber);
          }
        };

        // Required.
        DynamicItems.prototype.getLength = function() {
          return this.numItems;
        };

        DynamicItems.prototype.fetchPage_ = function(pageNumber) {
          // Set the page to null so we know it is already being fetched.
          var thisItem = this;
          this.loadedPages[pageNumber] = null;

          var url = constantes.getApiUrl('ips_go_mdm', 'tareasxdispositivo');
          url = url.replace('{0}', '0013951E0E8B');
          url += '?page=' + pageNumber + '&size=' + this.PAGE_SIZE;
          var config = {
            headers: {
              'Authorization' : 'Bearer ' + conexion.getAuthToken()
            },
            timeout: 90000
          };
          $http.get(url, config).then(angular.bind(this, function(response) {
            thisItem.loadedPages[pageNumber] = [];
            angular.forEach(response.data.content, function(value, idx) {
                thisItem.loadedPages[pageNumber].push(value.uidTask);
            });
          }));
        };

        DynamicItems.prototype.fetchNumItems_ = function() {
          // For demo purposes, we simulate loading the item count with a timed
          // promise. In real code, this function would likely contain an
          // $http request.

          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.numItems = 20;
          }));
        };

        this.dynamicItems = new DynamicItems();
      }
})();

(function(){
  angular
  .module('app')
  .directive('datikMdm',datikMdm);

  function datikMdm(){
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/gestDispositivosMoviles/directives/mdm.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$q', 'mdmService', '$interval', 'altaEquipamientosService', 'utilidades', 'notificaciones', '$translate', datikMdmController]
    };

    function datikMdmController($log, $scope, $q,mdmService,$interval, altaEquipamientosService, utilidades, notificaciones, $translate){
      var vm = this;
      vm.loading = true;
      var tamScroll = [];
      var isOnTopScroll = 0;
      var filtros = "";
      var pagina = 0;
      var tamano = 0;
      var okQty;
      var massiveFilteredData;
      vm.showTareas = false;
      var SEPARATOR = '%7C'
      vm.mostrar = {
        tareas: false,
        diagnostico: false,
        dispMultiples: false
      };
      var equipmentType = [];
      var intervalPromise;
      var filtersBack;

      vm.table_mdm = {
        contenedor: "tblLessThanHalf",
        maxHeight: "calc(100vh - 260px)",
        currentPage: 1,
        perPage: 1000000,
        elements: [
          { title: 'Mac', information: 'equipmentId', type: 'string' },
          { title: 'Tipo', information: 'equipmentType', type: 'string' },
          { title: 'Version', information: 'version', type: 'string' },
          { title: 'Cliente', information: 'nameOperator', type: 'string' },
          { title: 'Tipo de recurso', information: 'resourceTypeName', type: 'string' },
          { title: 'Unidad', information: 'codeVehicle', type: 'string' },
          { title: 'Sistemas', information: 'subsystems' },
          { title: 'Diagnostico', information: 'diagnosis' },
          { title: 'Tareas', information: 'task', color: 'task.color' }
      ],
        selection: {
          mode: 'multiple',
          etSelectedElements: undefined,
          changeSelectionEventName: $scope.accountevent
        },
        data: [],
        loadData: function(pagina, sizes, sortInicial, filter, flag, firstTime, scrollTopMdm, deferred){
          vm.loading = true;
          tamano = sizes;
          var sort = sortInicial;

          filtros = validaFiltros(filter)
      
          if(!utilidades.isEmpty(filtersBack) && utilidades.isEmpty(filtros)){
            filtros = filtersBack
            filtersBack = ''
          }

          if (flag == 1) {
            vm.table_mdm.totalCount  = 0;
            tamScroll = [];
          }

          var equipamientosPromise = mdmService.getEquipamiento(pagina,sizes,sort,filtros,firstTime)
          var systemsPromise = mdmService.getSystems();
          $q.all([equipamientosPromise, systemsPromise]).then(function (response) {
            var equipamientos = response[0];
            var systems = response[1];
            if (!utilidades.isEmpty(equipamientos, "equipamientos.content")) {
              tamScroll.push(scrollTopMdm);
              if (firstTime == 1) {
                equipamientos.content.forEach(function(elemento){
                  if(elemento.selected){
                    $scope.$emit('cambio-en-el-dispositivo-seleccionado',elemento);
                    $scope.$emit('mdm-item-change-selection',[elemento]);
                  }
                });
              }
              vm.table_mdm.totalCount = equipamientos.totalElements;
            }

            if (!utilidades.isEmpty(equipamientos, "equipamientos.content")) {
              equipamientos.content.forEach(function(equipamiento) {
                if (!utilidades.isEmpty(equipamiento.subsystems)) {
                  equipamiento.subsystems.forEach(function (x) {
                    systems.forEach(function (z) {
                      if(z.uidTypeSubsystem === x.uidSubsystemType){
                        x.name = z.name;
                      }
                    });
                  });
                }
                vm.table_mdm.data.push(equipamiento);
              });
            }
            vm.loading = false;
            deferred.resolve(equipamientos, obtTareas(equipamientos));
          })
          return deferred.promise;
        }
      };

      function getTypes(){
        altaEquipamientosService.getTiposEquipamientos().then(function(data) {
          if (!utilidades.isEmpty(data)) {
            data.forEach(function(element){
              equipmentType.push(element.display);
            })
            vm.table_mdm.elements[1].sortArray = equipmentType;
          }
        }, function (error) {
          $log.error(error);
        });
      }

      $scope.$on('clean-mdm-table', function(){
        vm.loading = true
      })

      $scope.$on("reloadTblMDM",function(ev, data){
        vm.loading = true;
        $scope.$broadcast('mdm-data-table', [])
        var filter;

        if(!utilidades.isEmpty(data, "data.list")){
          filter = 'equipmentId:' + data.list.toString().replaceAll(',', SEPARATOR)
          massiveFilteredData = data.list
        } else {
          filter = ''
          massiveFilteredData = []
        }

        loadMassiveData(data, filter)
      });

      function loadMassiveData(data, filter){
        vm.table_mdm.loadData(data.page, data.size, data.sort, filter, data.firstTime, 0, 0, $q.defer()).then(function (response){
          var equipList = response.content;
          okQty = response.numberOfElements
          if(!utilidades.isEmpty(massiveFilteredData)){
            intervalManager(false)

            $scope.$broadcast('mdm-data-table', equipList)
            $scope.$emit('massive-filtered-data', equipList)
            $scope.$emit('cambio-en-el-dispositivo-seleccionado', data.soloObj);
            $scope.$emit('mdm-item-change-selection', [data.soloObj]);

            vm.table_mdm.totalCount = response.totalElements

            changeVisualizationStates(massiveFilteredData)
            notificaciones.showNotification('Equipamientos', $translate.instant('Se han recibido', { okQty: okQty, totalQty : massiveFilteredData.length }), 'info')
          } else {
            intervalManager(true)
            vm.table_mdm.totalCount = response.totalElements
            $scope.$broadcast('mdm-data-table', equipList)
            $scope.$emit('massive-filtered-data', massiveFilteredData)

            $scope.$emit('cambio-en-el-dispositivo-seleccionado',data.soloObj);
            $scope.$emit('mdm-item-change-selection',[data.soloObj]);

            changeVisualizationStates(massiveFilteredData)
          }
          vm.loading = false;
        })
      }

      function changeVisualizationStates(data) {
        var showObj = {massive : undefined, solo : undefined};
        if(!utilidades.isEmpty(data, "data.soloObj")){
          showObj.massive = false
          showObj.solo  = true
        } else {
          showObj.massive = true
          showObj.solo  = false
        }
        $scope.$emit('mostrarConfig', showObj)
      }

      function intervalManager(flag){
        if (flag) {
          $interval(getInforInterval, 15000)
        } else {
          $interval.cancel(intervalPromise);
        }
      }
      
      var getInforInterval = function() {
        var sort = ''
        
        if (!utilidades.isEmpty(vm, "vm.table_mdm.data")) {
          isOnTopScroll = angular.element('.c-datik-table-body').scrollTop();
          for (var i = 1; i <= tamScroll.length; i++) {
            if(isOnTopScroll < tamScroll[i]){
              pagina = i;
              break;
            } else if(i == tamScroll.length){
              pagina = i;
            }
          }

          $q.all([mdmService.getEquipamiento(pagina,tamano,sort,filtros,0), mdmService.getSystems()]).then(function (data){
            var find
            if(!utilidades.isEmpty(data[0], "data[0].content")){
              var equipList = data[0]
              var systemList = data[1]
              if (!utilidades.isEmpty(equipList, "equipList.content")) {
                equipList.content.forEach(function (x){
  
                  if(!utilidades.isEmpty(x, "x.equipmentId")){
                    find = vm.table_mdm.data.find(function (z){return x.equipmentId === z.equipmentId})
                    if (!utilidades.isEmpty(find)) find.version = x.version;
                    find = systemList.find(function (z){return x.uidTypeSubsystem === z.uidSubsystemType})
                    if(!utilidades.isEmpty(find)) x.name = find.name
                  }
                })
                vm.table_mdm.data = equipList.content
                obtTareas(equipList)
              }
            }
          })
        } 
      }
      
      intervalPromise = $interval(getInforInterval, 15000);


      function validaFiltros(filter) {
        var filtro = "";
        if(typeof filter !== 'object') {
          return filter
        }

        angular.forEach(filter, function (value,index) {
          filtro += index +":"+ value + ",";
        });
        filtersBack = filtro
        return !utilidades.isEmpty(filtro) ? filtro.substring(0,filtro.length-1) : filtro;
      }

      function obtTareas(equipamientos){
        var cadenaMacs = "";
        if (!utilidades.isEmpty(equipamientos)) {
          for (var i = 0; i < equipamientos.content.length; i++) {
            cadenaMacs += equipamientos.content[i].equipmentId + ",";
          }
          cadenaMacs = cadenaMacs.substring(0,cadenaMacs.length-1);
          mdmService.getTareas(cadenaMacs,"","",1,"").then(function(objTareas){
            if (objTareas.data.content.length > 0) {
              for (var j = 0; j < objTareas.data.content.length; j++) {
                angular.forEach(vm.table_mdm.data, function(dataItem) {
                  if(dataItem.equipmentId === objTareas.data.content[j].idEquipment) {
                    var status = (objTareas.data.content[j].status.code >= 300) ? 'failure' : (objTareas.data.content[j].status.code >= 200 && objTareas.data.content[j].status.code < 300) ? 'success' : 'in progress';
                    dataItem.task.push({date: objTareas.data.content[j].dateIni, name: objTareas.data.content[j].uidTask, status: status});
                    return;
                  }
                });
              }
            }
          });
        }

      }

      getTypes()
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:TblVehiculosController
   * @description
   * Controller para el menu de Live
   *
   */

  angular
    .module('app')
    .directive('datikGestionDispositivosMoviles', datikGestionDispositivosMoviles);

  function datikGestionDispositivosMoviles() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/gestDispositivosMoviles/directives/mainGestDispMoviles.html',
      controllerAs: 'vm',
      controller: ['$log', '$translate', '$filter', '$location', '$uibModal',
      'conexion', 'constantes', 'ayuda', 'composicion', '$scope', tblGestDispMovilesController
      ]
    };

    function tblGestDispMovilesController ($log, $translate, $filter, $location, $uibModal,
      conexion, constantes, ayuda, composicion, $scope){

      var vm = this;

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('datikConfig', datikConfig);

  function datikConfig() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/views/gestDispositivosMoviles/directives/configMultiple.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate', '$timeout', '$uibModal', 'timeZones', 'notificaciones', 'utilidadesGO', '$q', 'mdmService', 'tblCuentasService', datikConfigController]
    };

    function datikConfigController($log, $scope, $filter, $translate, $timeout, $uibModal, timeZones, notificaciones, utilidadesGO, $q, mdmService, tblCuentasService) {
      var vm = this;
      var lstDispositivos;
      var versionEquipmente;
      vm.aplicarDisabled = false;
      vm.versionesDisabled = false;
      var EQUIPAMIENTO = $translate.instant("Equipamiento");

      vm.configMultiple = [];
      vm.configMultipleVersion = [];
      vm.core = [];
      vm.mdm = [];
      vm.cctv = [];
      vm.wifi = [];
      vm.ecoassist = [];
      vm.loading = true;

      $scope.$on("selecMasDispo", function(lstDispo) {
        if (angular.isDefined(lstDispo) && lstDispo.length > 0) {
          versionEquipmente = lstDispo[0].equipmentType;
          lstDispositivos = lstDispo;
          loadSystem();
          $timeout(function() {
            if (vm.core.length > 0 || vm.mdm.length > 0 || vm.cctv.length > 0 || vm.wifi.length > 0 || vm.ecoassist.length > 0) {
              getSystemasExistentes();
            } else {
              $scope.$emit('muestraDispMultiple', false);
            }
          }, 1);
        }
      });


      function loadSystem() {
        if (angular.isDefined(lstDispositivos)) {
          var flag = false;
          var core = "";
          var mdm = "";
          var cctv = "";
          var wifi = "";
          var ecoassist = "";
          vm.core = [];
          vm.mdm = [];
          vm.cctv = [];
          vm.wifi = [];
          vm.ecoassist = [];
          for (var i = 0; i < lstDispositivos.length; i++) {
            var subsystems = lstDispositivos[i].subsystems;
            for (var j = 0; j < subsystems.length; j++) {
              var systems = subsystems[j];
              if (systems.name == "core") {
                flag = core.includes(lstDispositivos[i].equipmentId);
                if (!flag) {
                  core += lstDispositivos[i].equipmentId + ",";
                  vm.core.push(lstDispositivos[i].equipmentId);
                }
              } else if (systems.name == "mdm") {
                flag = mdm.includes(lstDispositivos[i].equipmentId);
                if (!flag) {
                  mdm += lstDispositivos[i].equipmentId + ",";
                  vm.mdm.push(lstDispositivos[i].equipmentId);
                }
              } else if (systems.name == "cctv") {
                flag = cctv.includes(lstDispositivos[i].equipmentId);
                if (!flag) {
                  cctv += lstDispositivos[i].equipmentId + ",";
                  vm.cctv.push(lstDispositivos[i].equipmentId);
                }
              } else if (systems.name == "wifi") {
                flag = wifi.includes(lstDispositivos[i].equipmentId);
                if (!flag) {
                  wifi += lstDispositivos[i].equipmentId + ",";
                  vm.wifi.push(lstDispositivos[i].equipmentId);
                }
              } else if (systems.name == "ecoassist") {
                flag = ecoassist.includes(lstDispositivos[i].equipmentId);
                if (!flag) {
                  ecoassist += lstDispositivos[i].equipmentId + ",";
                  vm.ecoassist.push(lstDispositivos[i].equipmentId);
                }
              }
              flag = false;
            }
          }
        }
      }

      function getAllVersions() {
        mdmService.getVersions().then(function(data) {
          vm.selectVersion = [];
          if (angular.isDefined(data)) {
            data.forEach(function(item) {
              var find = $filter('filter')(item.equipmentTypes, versionEquipmente, true)[0];
              if (angular.isDefined(find)) {
                vm.selectVersion.push(item);
              }
            });
            vm.selectVersion1 = vm.selectVersion[0].version;
          }
        });
      }

      function getSystemasExistentes() {
        var pushData;
        var systemas = [{
          name: "Sistema"
        }];
        mdmService.getSystems().then(function(data) {
          for (var i = 0; i < data.length; i++) {
            pushData = false;
            if (data[i].name == "core" && vm.core.length > 0) {
              data[i].icon = "fa fa-circle fa-lg";
              data[i].idsMac = vm.core;
              pushData = true;
            } else if (data[i].name == "mdm" && vm.mdm.length > 0) {
              data[i].icon = "fa fa-refresh fa-lg";
              data[i].idsMac = vm.mdm;
              pushData = true;
            } else if (data[i].name == "cctv" && vm.cctv.length > 0) {
              data[i].icon = "fa fa-video-camera fa-lg";
              data[i].idsMac = vm.cctv;
              pushData = true;
            } else if (data[i].name == "wifi" && vm.wifi.length > 0) {
              data[i].icon = "fa fa-wifi fa-lg";
              data[i].idsMac = vm.wifi;
              pushData = true;
            } else if (data[i].name == "ecoassist" && vm.ecoassist.length > 0) {
              data[i].icon = "fa fa-television fa-lg";
              data[i].idsMac = vm.ecoassist;
              pushData = true;
            }

            if (pushData) {
              data[i].color = "color: color:#CCCCCC;";
              systemas.push(data[i]);
            }
          }
          vm.subSistemasMultiple = systemas;
          vm.subSistemasMultiple[0].idsMac = vm.subSistemasMultiple[1].idsMac;
          vm.currentNavItem = vm.subSistemasMultiple[0].name;
          vm.obtenerConfig(vm.subSistemasMultiple[0]);
        });
      }


      vm.obtenerConfig = function(dtos) {
        vm.showSistemaTab = angular.equals(dtos.name, "Sistema") ? true : false;
        if (!vm.showSistemaTab) {
          vm.systemaSelec = dtos.uidSubsystemType;
          obtieneConfig(dtos.idsMac, dtos.uidSubsystemType);
        }
        vm.macs = dtos.idsMac;
        getAllVersions();
        validaBtn();
      };

      function validaBtn() {
        if (tblCuentasService.obtinePermisos(11)) {
          vm.versionesDisabled = true;
          vm.aplicarDisabled = true;
        }

        if (tblCuentasService.obtinePermisos(12)) {
          vm.versionesDisabled = true;
          vm.aplicarDisabled = false;
        }

        if (tblCuentasService.obtinePermisos(13)) {
          vm.versionesDisabled = false;
          vm.aplicarDisabled = false;
        }
      }

      function obtieneConfig(dato, uidSystem) {
        if (angular.isDefined(dato) && angular.isDefined(uidSystem)) {
          mdmService.configuracionMultiples(dato, uidSystem).then(function(data) {
            if (data.length > 0) {
              vm.configMultiple.availableOptions = data;
              data.forEach(function(elemento, index) {
                if (index == 0 && elemento !== null) {
                  vm.configMultiple.selectedOption = elemento;
                  vm.getVersionesConfig(elemento);
                }
              });
            } else {
              vm.configMultiple.availableOptions = [];
              vm.configMultipleVersion.availableOptions = [];
              vm.configMultiple.selectedOption = [];
              vm.configMultipleVersion.selectedOption = [];
            }
          });
        }
      }

      vm.getVersionesConfig = function(elemento) {
        if (angular.isDefined(elemento)) {
          mdmService.searchVersion(vm.systemaSelec, elemento.uidConfigurationType).then(function(data) {
            if (data.length > 0) {
              vm.configMultipleVersion.availableOptions = data;
              vm.configMultipleVersion.selectedOption = data[0];
            } else {
              vm.configMultipleVersion.availableOptions = [];
              vm.configMultipleVersion.selectedOption = [];
            }
          });
        }
      };

      vm.cambiaVersion = function() {
        var deferred = $q.defer();
        var promisesVersions = [];
        var updateOk = [];
        var updateError = [];
        var message = "";
        var objVersion = {
          "version": vm.selectVersion1
        };
        for (var i = 0; i < lstDispositivos.length; i++) {
          promisesVersions.push(mdmService.putVersionsEquipment(lstDispositivos[i].equipmentId, objVersion).then(function(response) {
            return response;
          }, function(error) {
            return error;
          }));
        }

        $q.all(promisesVersions).then(function(result) {
          for (var i = 0; i < result.length; i++) {
            if (result[i].status === 200) {
              updateOk.push(result[i]);
            } else {
              updateError.push(result[i]);
            }
          }
          if (updateOk.length) {
            message = (updateOk.length > 1) ? updateOk.length + " " + $translate.instant("equipamientos actualizados correctamente") : $translate.instant("Equipamiento actualizado correctamente");
            utilidadesGO.showNotificacion(message);
          }

          if (updateError.length) {
            message = (updateError.length > 1) ? updateError.length + " " + $translate.instant("equipamientos no actualizados correctamente") : $translate.instant("Equipamiento no actualizado correctamente");
            utilidadesGO.showNotification(message);
          }
          deferred.resolve(result);
        }, function(error) {
          error.error = "Ocurrio un error inesperado";
          deferred.reject(error);
        });
      };

      vm.cambiaConfig = function() {
        if (angular.isDefined(vm.macs) && angular.isDefined(vm.configMultipleVersion.selectedOption.hash)) {
          mdmService.putConfigMultiSelect(vm.macs, vm.configMultipleVersion.selectedOption.hash).then(function(data) {
            if (angular.isDefined(data)) {
              $log.info(data);
            }
          });
        }
      };

      // FUNCION QUE ABRE EL MODAL QUE GESTIONA LAS VERSIONES EXISTENTES
      vm.gestionarVersiones = function() {
        var elemento = {
          titulo: $translate.instant("Gestionar versiones")
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/gestDispositivosMoviles/modals/gestionarVersiones.modal.html',
          controller: 'gestionarVersionesController as vm',
          windowClass: 'ipanel-pref',
          scope: $scope,
          size: 'sm418', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {});
      };

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('datikConfigDisp', datikConfigDisp);

  function datikConfigDisp() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/views/gestDispositivosMoviles/directives/configDisp.directive.html',
      controllerAs: 'vm',
      controller: ['$scope', '$filter', '$translate', '$timeout', '$uibModal', 'timeZones', 'mdmService', 'md5', '$interval', 'tblCuentasService', 'utilidades', 'notificaciones', datikConfigDispController]
    };

    function datikConfigDispController($scope, $filter, $translate, $timeout, $uibModal, timeZones, mdmService, md5, $interval, tblCuentasService, utilidades, notificaciones) {
      var vm = this;
      vm.cbmVersion = false;
      vm.subsistemas;
      vm.loadingSave = false;
      vm.loadingVersions = false;
      vm.updating = false
      vm.loadingConfig = true;
      vm.loadingUpdateVersion = false;
      vm.loadingHashActual = false;
      vm.plusDisabled = false;
      vm.editDisabled = false;
      vm.deleteDisabled = false;
      vm.sendDisabled = false;
      vm.loadSendConfig = false;
      vm.systemaSelec = undefined;
      vm.disableMassiveCancelBtn = false
      vm.guardarConfig = true;
      vm.hashes = [];
      vm.disableCancelBtn = false
      vm.configuraciones = {};
      vm.select_version = {};
      vm.modes = {};
      vm.showSameVersionTxt = false;
      vm.versiones = [];
      vm.timeZones = timeZones;
      var vequipamiento;
      vm.showMjsActualizacion = false;
      vm.input_nv = true;
      vm.btn_rtn = true;
      vm.btn_save = true;
      vm.btn_del = false;
      vm.btn_edit = false;
      vm.showUpdateButton = false;
      vm.showCancelUpdatingButton = false
      vm.select1 = false;
      vm.cmbVersion = false;
      vm.aceEditorObj = null;
      vm.versionSubsystema = "";
      vm.showMsgDiffTypes = false
      var allVersions = []
      vm.selectedEquip;
      var massiveFilteredData = []
      var colors = ['#E84B3A', '#27AE61', '#CCCCCC'];
      vm.mostrar = {
        configDisp: false
      };
      
      vm.showUnicVersionSelector = true
      vm.showConfig = false

      vm.unicVersionSelector = {
        list : [],
        selected: []
      }
      vm.massiveVersionSelected = []
      vm.disableMassiveSendBtn = true;
      vm.disableUpdateOption = false;

      var updateOkQty = 0

      var typeBlackList = ["dcb", "MTX", "web-service", "FLEX", "UREADER", "telemetria", "DCB.L", "DCB.LD 3G", "DCB.V", "DCB.LD 4G", "DCB.X"];

      vm.modes.availableOptions = [
        { id: 0,  editor: 'Scheme' },
        { id: 1, editor: 'XML' },
        { id: 2, editor: 'JSON' }
      ];
      vm.modes.selectedOption = vm.modes.availableOptions[0];

      vm.aceOption = {
        mode: vm.modes.selectedOption.editor.toLowerCase(),
        useWrapMode: true,
        showGutter: true,
        showPrintMargin: false,
        theme: 'twilight',
        firstLineNumber: 1,
        onLoad: function (_ace) {
          vm.aceEditorObj = _ace;
          vm.aceEditorObj.setReadOnly(true);
          vm.modeChanged = function () {
            _ace.getSession().setMode("ace/mode/" + vm.modes.selectedOption.editor.toLowerCase());
          };
        }
      };

      vm.soloSelectorChange = function (){
        vm.disableUpdateOption = utilidades.isEmpty(vm.selectVersion1)
      }

      function selectedEquipStateUpdate(){
        vm.blackListFlag = typeBlackList.includes(vm.selectedEquip.equipmentType)
        vm.disableUpdateOption =  utilidades.isEmpty(vm.selectVersion1)
        vm.versionEquipmente = vm.selectedEquip.equipmentType;
        vm.versionSubsystema = vm.selectedEquip.version;
        vm.mac = vm.selectedEquip.equipmentId;
        vequipamiento = vm.selectedEquip.equipmentId;
        vm.updating = vm.selectedEquip.updating || null;
        obtainSystem(vm.selectedEquip);
      }

      function filterMacList(){
        var tmp = [];
        massiveFilteredData.forEach(function (x){
          if(x.updating){
            tmp.push(x.equipmentId)
          }
        })
        return tmp;
      }
      
      vm.cancelUpdate = function (equip) {
        loadingSimulation()
        var macList = filterMacList()
        vm.disableMassiveCancelBtn = utilidades.isEmpty(equip)
        vm.disableCancelBtn = true
        mdmService.putCancelUpdate(utilidades.isEmpty(equip) ? macList.toString() : equip.equipmentId).then(function (response){
          if (!utilidades.isEmpty(response, "response.data")) {
            notificaciones.showNotification($translate.instant('Actualizacion cancelada exitosamente'), 'Actualización' , 'success')
          } else {
            notificaciones.showNotification($translate.instant('Algo ha ido mal al intentar cancelar la actualizacion'), 'Actualización', 'error')
          }
        }).finally(function() {
          $timeout(function () {$scope.$emit("refrescarPantallaMDM");}, 5000);
          vm.disableMassiveCancelBtn = false
          vm.disableCancelBtn = false
        })
      }

      function getUpdatePromiseList(){
        return massiveFilteredData.filter(function (equip) {
          if(!equip.updating && equip.version !== vm.massiveVersionSelected.version){
            return mdmService.putVersionsEquipment(equip.equipmentId, vm.massiveVersionSelected.hash)
          }
       })
      }
      
      vm.updateAll = function() {
        vm.disableMassiveSendBtn = true
        vm.showUnicVersionSelector = true
        vm.showConfig = false
        loadingSimulation()
        
        Promise.allSettled(getUpdatePromiseList()).then(function (response){
          updateOkQty = 0;
          response.forEach(function(el) {
            if (el.status === 'fulfilled') updateOkQty++
          });
        }).finally(function (){
          $timeout(function () {$scope.$emit("refrescarPantallaMDM");}, 5000);
          notificaciones.showNotification('Equipamientos', $translate.instant('{{okQty}} actualizaciones enviadas exitosamente', { okQty :  updateOkQty}), 'info')
          vm.showUnicVersionSelector = false
          vm.showConfig = false
        })
      }

      function validaBtn() {
        if (tblCuentasService.obtinePermisos(11)) {
          vm.plusDisabled = true;
          vm.editDisabled = true;
          vm.deleteDisabled = true;
          vm.sendDisabled = true;
        }

        if (tblCuentasService.obtinePermisos(12)) {
          vm.plusDisabled = false;
          vm.editDisabled = false;
          vm.deleteDisabled = false;
          vm.sendDisabled = false;
        }

        if (tblCuentasService.obtinePermisos(13)) {
          vm.plusDisabled = false;
          vm.editDisabled = false;
          vm.deleteDisabled = false;
          vm.sendDisabled = false;
        }
      }

      function obtainSystem(dispositivoSeleccionado){
        vm.subsistemas = [{uidSubsystemType: !utilidades.isEmpty(dispositivoSeleccionado, "dispositivoSeleccionado.subsystems") ? dispositivoSeleccionado.subsystems[0].uidTypeSubsystem : dispositivoSeleccionado.subsystems,name: "Sistema"}]

        if (typeBlackList.includes(dispositivoSeleccionado.equipmentType)) {
          mdmService.getSystems().then(function (data) {
            data.forEach(function (x) {
              if (!utilidades.isEmpty(dispositivoSeleccionado.subsystems)) {
                dispositivoSeleccionado.subsystems.forEach(function (z){
                  if (x.uidSubsystemType === z.uidTypeSubsystem) {
                    if (x.name == "core") {
                      x.icon = "fa fa-circle fa-lg";
                    } else if (x.name == "mdm") {
                      x.icon = "fa fa-refresh";
                    } else if (x.name == "cctv") {
                      x.icon = "fa fa-video-camera";
                    } else if (x.name == "wifi") {
                      x.icon = "fa fa-wifi";
                    } else if (x.name == "ecoassist") {
                      x.icon = "fa fa-television";
                    }
                    x.color = "padding-right: 5px; color: " + colors[z.status];
                    vm.subsistemas.push(x);
                  }
                })
              }
            });
          });
        }
        vm.currentNavItem = vm.subsistemas[0].name;
        
        validaBtn();
        if(!utilidades.isEmpty(vm.subsistemas) && !utilidades.isEmpty(vm.subsistemas[0].uidSubsystemType)){
          vm.obtenerHash(vm.subsistemas[0].uidSubsystemType, 0, vm.subsistemas[0]);
        }

      }
      getAllVersions(false)

      $interval(function () {
        var btnGuardar = vm.btn_save;
        var btnRegresar = vm.btn_rtn;
        var uidConfigurationType;
        if (!utilidades.isEmpty(vm.configuraciones, "vm.configuraciones.selectedOption")) {
          uidConfigurationType = vm.configuraciones.selectedOption.configurationType.uidConfigurationType;
        }
        if (btnGuardar && btnRegresar && !utilidades.isEmpty(vm.selectedEquip) && !utilidades.isEmpty(uidConfigurationType)) {
          var udiConfig = uidConfigurationType;
          mdmService.configuracion(vequipamiento, vm.systemaSelec).then(function (data) {
            if (data.length > 0) {
              vm.configuraciones.availableOptions = data;
              data.forEach(function (elemento) {
                if (elemento.configurationType.uidConfigurationType == udiConfig) {
                  if (elemento.updateStatus == 0) {
                    vm.showMjsActualizacion = false;
                    vm.hashActual = elemento.hash;
                    vm.configuraciones.selectedOption = elemento;
                  }
                }
              });
            }
          });
        }
      }, 15000);

      vm.onVersionSelectorChange = function (){
        var sameVersionQty = getSameVersionAmount();
        vm.showSameVersionTxt = true
        vm.updateVersionAmountTxt = $translate.instant('{{sameVersionQty}} equipos ya están en la version: {{version}}', { sameVersionQty : sameVersionQty, version : vm.massiveVersionSelected.version });
        vm.disableMassiveSendBtn = utilidades.isEmpty(vm.massiveVersionSelected)
      }

      $scope.refreshVersions = function () {
        getAllVersions(true);
      };

      function getAllVersions(flag) {
        mdmService.getVersions(flag).then(function (data) {
          allVersions = data
          vm.selectVersion = [];
          if (!utilidades.isEmpty(data)) {
            vm.selectVersion = data.filter(function (item) {
              var find;
              if(!utilidades.isEmpty(item, "item.equipmentTypes")){
                find = item.equipmentTypes.find(function (x) {return x === vm.versionEquipmente})
              }
              return !utilidades.isEmpty(find) && !item.protected && !item.internal
            });

            vm.selectVersion = $filter('orderBy')(vm.selectVersion, '-version');
            if (!utilidades.isEmpty(vm.versionSubsystema)) {
              vm.selectVersion1 = vm.versionSubsystema
            }
          }
        });
      }
      
      $scope.$on('mdm-massive-filter-data', function (ev, data){
        massiveFilteredData = data
        vm.showUpdateButton = massiveFilteredData.some(function (x){return !x.updating})
        vm.showCancelUpdatingButton = massiveFilteredData.some(function (x){return x.updating})
        vm.showSameVersionTxt = false
        vm.massiveVersionSelected = []
        getAllVersionsMassiveMode()
      })
      
      function getAllVersionsMassiveMode() {
        vm.showMsgDiffTypes = false
        var versionList = []
        var equipmentTypeList = []
        massiveFilteredData.forEach(function (item) {
          if(!equipmentTypeList.includes(item.equipmentType)){
            equipmentTypeList.push(item.equipmentType)
          }
          allVersions.forEach(function (version) {
            if(!utilidades.isEmpty(version, "version.equipmentTypes") && version.equipmentTypes.includes(item.equipmentType) && !version.protected && versionList.every(function (x){ return x.hash !== version.hash })){
              versionList.push(version)
            }
          })
        });

        vm.equipmentSelectionTxt = $translate.instant('Se han seleccionado {{updateAmount}} equipos', {updateAmount : massiveFilteredData.length});

        changeMassiveUpdateText(equipmentTypeList)
        vm.versionEquipmente = !utilidades.isEmpty(massiveFilteredData[0]) ? massiveFilteredData[0].equipmentType : '';
        vm.unicVersionSelector.list = versionList;
        vm.disableMassiveSendBtn = utilidades.isEmpty(versionList) || utilidades.isEmpty(vm.massiveVersionSelected);
      }

      function changeMassiveUpdateText(equipmentTypeList){
        var updateAmount = getUpdatingAmount();
        var cancelUpdatingAmount = massiveFilteredData.length - updateAmount;
        if(equipmentTypeList.length > 1){
          vm.showMsgDiffTypes = true;
          vm.updateAmountDiffTxt = $translate.instant('No se pueden actualizar diferentes tipos de DCB de forma masiva. Por favor, escoge un grupo de DCBs del mismo tipo');
        } else {
          vm.updateAmountTxt = $translate.instant('Disponibles para actualizar: {{cancelUpdatingAmount}} Equipos', {cancelUpdatingAmount : cancelUpdatingAmount});
          vm.notUpdateAmountTxt = $translate.instant('Disponibles para anular actualizacion: {{updateAmount}} Equipos', {updateAmount : updateAmount});
        }
      }

      function getUpdatingAmount(){
        return massiveFilteredData.filter(function(x){return x.updating}).length
      }

      function getSameVersionAmount(){
        return massiveFilteredData.filter(function(x){return x.version === vm.massiveVersionSelected.version}).length
      }

      //Funcion para la busqueda de hashes mediante mac y tipo subsistema
      vm.obtenerHash = function (index, flag, tabSubsistema) {
        vm.showSistemaTab = angular.equals(tabSubsistema.name, "Sistema") ? true : false;
        vm.systemaSelec = index;
        getAllVersions(true);
        vm.loadingConfig = true;
        vm.loadingVersions = true;
        vm.select_v = true;
        vm.loadingHashActual = true;
        bloqueoDesbloqueoElementos(true);
        if(typeBlackList.includes(index)){
          mdmService.configuracion(vequipamiento, index).then(function (data) {
            vm.loadingVersions = false;
            vm.select_v = false;
            vm.loadingConfig = false;
            vm.loadingHashActual = false;
            bloqueoDesbloqueoElementos(false);
            if (!utilidades.isEmpty(data)) {
              vm.hashActual = '';
              vm.select1 = false;
              vm.cmbVersion = false;
              vm.aceEditorObj.setReadOnly(true);
              vm.configuraciones.availableOptions = data;
              data.forEach(function (elemento, index) {
                if (flag == 0 && index == 0) {
                  vm.hashActual = elemento.hash;
                  vm.showMjsActualizacion = (elemento.updateStatus === 1);
                  vm.configuraciones.selectedOption = elemento;
                  vm.loadVersion(elemento.subsystemType.uidSubsystemType, elemento.configurationType.uidConfigurationType, 0, "");
                } else if (flag == 1 && vm.select_version.selectedOption.version == elemento.version) {
                  vm.hashActual = elemento.hash;
                  vm.showMjsActualizacion = (elemento.updateStatus === 1);
                  vm.configuraciones.selectedOption = elemento;
                  vm.loadVersion(elemento.subsystemType.uidSubsystemType, elemento.configurationType.uidConfigurationType, 0, "");
                }
              });
              vm.input_nv = true;
              vm.btn_rtn = true;
              vm.btn_edit = false;
            } else {
              vm.modes.selectedOption = vm.modes.availableOptions[0];
              vm.aceEditorObj.getSession().setMode("ace/mode/" + vm.modes.selectedOption.editor.toLowerCase());
              vm.showMjsActualizacion = false;
              vm.configuraciones.availableOptions = undefined;
              vm.configuraciones.selectedOption = undefined;
              vm.select_version.availableOptions = undefined;
              vm.select_version.selectedOption = undefined;
              vm.hashActual = "";
              vm.hashg = "";
              vm.aceOption1 = "";
              vm.select1 = true;
              vm.cmbVersion = true;
              vm.select_v = false;
              vm.input_nv = true;
              vm.btn_rtn = true;
              vm.btn_edit = false;
              vm.btn_save = true;
              vm.btn_del = false;
              vm.fileVersionName = "";
              vm.aceEditorObj.setReadOnly(true);
            }
          });
        }
      };

      function validaConfig(data) {
        var config;
        try {
          config = $.parseJSON(data) ? false : undefined;
        } catch (e) {
          config = undefined;
        }

        if (config == undefined) {
          var oParser = new DOMParser();
          var oDOM = oParser.parseFromString(data, "text/xml");
          config = oDOM.getElementsByTagName('parsererror').length ? (new XMLSerializer()).serializeToString(oDOM) : true;
        }

        if (config == true) {
          vm.modes.selectedOption = vm.modes.availableOptions[1];
          vm.aceEditorObj.getSession().setMode("ace/mode/" + vm.modes.selectedOption.editor.toLowerCase());
        } else if (config == false) {
          vm.modes.selectedOption = vm.modes.availableOptions[2];
          vm.aceEditorObj.getSession().setMode("ace/mode/" + vm.modes.selectedOption.editor.toLowerCase());
        } else {
          vm.modes.selectedOption = vm.modes.availableOptions[0];
          vm.aceEditorObj.getSession().setMode("ace/mode/" + vm.modes.selectedOption.editor.toLowerCase());
        }
      }

      function loadConfigVersion(dtos) {
        if (!utilidades.isEmpty(dtos)) {
          mdmService.searchConfig(dtos).then(function (data) {
            validaConfig(data);
            if (data !== "") {
              vm.aceOption1 = data;
            } else {
              vm.aceOption1 = "";
            }
          });
        } else {
          vm.aceOption1 = "";
        }
      }

      vm.loadConfigFichero = function (dtos) {
        if (dtos !== null) {
          vm.aceOption1 = "";
          vm.hashActual = dtos.hash;
          vm.showMjsActualizacion = (dtos.updateStatus === 1);
          vm.loadVersion(dtos.subsystemType.uidSubsystemType, dtos.configurationType.uidConfigurationType, 0, "");
        }
      };

      //Funcion para petición y obtención de hash
      vm.loadConfig = function (dat) {
        if (dat !== null) {
          vm.hashg = dat.hash;
          vm.aceOption1 = '';
          if (vm.hashActual !== vm.hashg && !vm.showMjsActualizacion) {
            vm.guardarConfig = false;
          } else {
            vm.guardarConfig = true;
          }
          mdmService.searchConfig(dat.hash).then(function (data) {
            validaConfig(data);
            vm.aceOption1 = data;
            var s = vm.aceOption1;
            if (vm.aceOption1) {
              vm.generateHash(s);
            }
          });
        }
      };

      //Funcion para la generacion de hash mediante onkeypress
      vm.generateHash = function (text) {
        if (!vm.aceEditorObj.$readOnly) {
          vm.hashg = md5.createHash(text || '');
        }
      };

      //Funcion para peticion y carga de versión por subsistema
      vm.loadVersion = function (tipoSubsistema, fileTypeUid, flag, newVersion) {
        var flagAgregar = flag;
        var nuevaVersionAgragada = newVersion;
        vm.loadingVersions = true;
        vm.select_v = true;
        vm.input_nv = true;
        mdmService.searchVersion(tipoSubsistema, fileTypeUid).then(function (data) {
          vm.loadingVersions = false;
          vm.resultado = angular.copy(data);
          vm.select_v = false;
          vm.select_version.availableOptions = data;
          data.forEach(function (elemento) {
            if (flagAgregar === 0) {
              if (elemento !== null && (elemento.hash === vm.hashActual)) {
                if (elemento.version == null) {
                  elemento.version = "No existen versiones";
                }
                vm.select_version.selectedOption = elemento;
                vm.hashg = elemento.hash;
              }
            } else {
              if (elemento.version === nuevaVersionAgragada) {
                vm.select_version.selectedOption = elemento;
                vm.hashg = elemento.hash;
              }
            }
          });

          if (!utilidades.isEmpty(vm.select_version, "vm.select_version.selectedOption.hash")) {
            loadConfigVersion(vm.select_version.selectedOption.hash);
          }

          if (vm.hashActual !== vm.hashg && !vm.showMjsActualizacion) {
            vm.guardarConfig = false;
          } else {
            vm.guardarConfig = true;
          }
        });
      };

      //Funcionalidad para resetear inputs y comportamiento botones
      vm.newVersion = function () {
        if (!utilidades.isEmpty(vm.configuraciones, "vm.configuraciones.selectedOption")) {
          vm.select1 = true;
          vm.select_v = true;
          vm.fileVersionName = "";
          vm.input_nv = false;
          vm.btn_rtn = false;
          vm.btn_edit = true;
          vm.btn_save = false;
          vm.btn_del = true;
          vm.aceOption1 = "";
          vm.hashg = "";
          vm.guardarConfig = true;
          vm.aceEditorObj.setReadOnly(false);
        }
      };

      vm.backVersion = function () {
        loadConfigVersion(vm.select_version.selectedOption.hash);
        vm.btn_rtn = !vm.btn_rtn;
        vm.input_nv = true;
        vm.btn_save = !vm.btn_save;
        vm.btn_del = !vm.btn_del;
        vm.select_v = false;
        vm.btn_edit = !vm.btn_edit;
        vm.select1 = false;
        vm.fileVersionName = "";
        if (!utilidades.isEmpty(vm.select_version, "vm.select_version.selectedOption.hash")) {
          vm.hashg = vm.select_version.selectedOption.hash;
        } else {
          vm.hashg = "";
        }
        vm.aceEditorObj.setReadOnly(true);
        if (vm.hashActual !== vm.hashg && !vm.showMjsActualizacion) {
          vm.guardarConfig = false;
        } else {
          vm.guardarConfig = true;
        }
      };

      //Funcionalidad para edición de versión
      vm.editVersion = function () {
        if (!utilidades.isEmpty(vm.select_version, "vm.select_version.selectedOption")) {
          vm.fileVersionName = vm.select_version.selectedOption.version;
          vm.btn_rtn = !vm.btn_rtn;
          vm.btn_edit = !vm.btn_edit;
          vm.btn_del = !vm.btn_del;
          vm.btn_save = !vm.btn_save;
          vm.select_v = true;
          vm.input_nv = false;
          vm.select1 = true;
          vm.aceEditorObj.setReadOnly(true);
        }
      };

      //Funcion para envio de datos nueva configuración
      vm.sendFile = function (textarea, nameVersion, fichero) {
        var newVersion = nameVersion;
        if (!vm.aceEditorObj.$readOnly && !utilidades.isEmpty(fichero, "fichero.configurationType") && !utilidades.isEmpty(fichero, "fichero.subsystemType.uidSubsystemType")) {
          vm.loadingSave = true;
          bloqueoDesbloqueoElementos(true);
          mdmService.saveFileVersion(textarea, nameVersion, fichero).then(function (data) {
            vm.loadingSave = false;
            bloqueoDesbloqueoElementos(false);
            if (angular.toJson(data) == "true") {
              vm.loadVersion(vm.configuraciones.selectedOption.subsystemType.uidSubsystemType, vm.configuraciones.selectedOption.configurationType.uidConfigurationType, 1, newVersion);
              vm.select_version.availableOptions = undefined;
              vm.select_version.selectedOption = undefined;
              vm.select1 = false;
              vm.btn_del = false;
              vm.btn_edit = false;
              vm.btn_save = true;
              vm.btn_rtn = true;
              vm.aceEditorObj.setReadOnly(true);
            }
          });
        } else {
          if (!utilidades.isEmpty(fichero, "fichero.configurationType") && !utilidades.isEmpty(fichero, "fichero.subsystemType.uidSubsystemType")) {
            vm.loadingSave = true;
            bloqueoDesbloqueoElementos(true);
            mdmService.updateNameVersion(nameVersion, fichero).then(function (data) {
              vm.loadingSave = false;
              bloqueoDesbloqueoElementos(false);
              if (angular.toJson(data) == "true") {
                vm.loadVersion(vm.configuraciones.selectedOption.subsystemType.uidSubsystemType, vm.configuraciones.selectedOption.configurationType.uidConfigurationType, 1, newVersion);
                vm.select_version.availableOptions = undefined;
                vm.select_version.selectedOption = undefined;
                vm.select1 = false;
                vm.btn_del = false;
                vm.btn_edit = false;
                vm.btn_save = true;
                vm.btn_rtn = true;
                vm.aceEditorObj.setReadOnly(true);
              }
            });
          }
        }
      };

      //Función para proceder a eliminar configuraciones
      vm.delFunction = function (hashActual) {
        if (!utilidades.isEmpty(hashActual, "hashActual.hash")) {
          mdmService.deleteVersion(hashActual).then(function (data) {
            if (data) {
              vm.loadVersion(vm.configuraciones.selectedOption.subsystemType.uidSubsystemType, vm.configuraciones.selectedOption.configurationType.uidConfigurationType, 0, "");
              vm.aceOption1 = "";
              vm.select_v = false;
              vm.select1 = false;
              vm.input_nv = true;
              vm.btn_del = false;
              vm.btn_edit = false;
              vm.btn_save = true;
              vm.btn_rtn = true;
              vm.aceEditorObj.setReadOnly(true);
            }
          });
        }
      };

      function bloqueoDesbloqueoElementos(val) {
        vm.select1 = val;
        vm.plusDisabled = val;
        vm.cmbVersion = val;
        vm.editDisabled = val;
        vm.deleteDisabled = val;
        vm.cbmVersion = val;
        vm.inpVersionDisabled = val;
        vm.sendDisabled = val;
      }

      //Funcion para envio de configuracion de acuerdo a coincidencia hashActual y hashg
      vm.sendConfig = function () {
        if (!utilidades.isEmpty(vm.hashg)) {
          vm.loadSendConfig = true;
          bloqueoDesbloqueoElementos(true);
          mdmService.sendConfiguracion(vequipamiento, vm.hashg).then(function (data) {
            vm.loadSendConfig = false;
            bloqueoDesbloqueoElementos(false);
            if (data) {
              vm.obtenerHash(vm.systemaSelec, 1);
              $timeout(function () {
                $scope.$emit("refrescarPantallaMDM");
              }, 2000);
            }
          });
        }
      };

      function loadingSimulation (){
        $scope.$emit('clean-mdm-datik-table')
        vm.showUnicVersionSelector = true
        vm.showConfig = false
      }

      vm.putVersions = function () {
        bloqueoDesbloqueoElementos(true);
        if (!utilidades.isEmpty(vequipamiento) && !utilidades.isEmpty(vm.selectVersion1)) {
          mdmService.putVersionsEquipment(vequipamiento, vm.selectVersion1).then(function (data) {
            if (!utilidades.isEmpty(data) && data.status === 200) {
              bloqueoDesbloqueoElementos(false);
              notificaciones.showNotification($translate.instant("El envio de actualizacion fue exitoso"), 'Actualización' , 'success')
              $timeout(function () {$scope.$emit("refrescarPantallaMDM");}, 2000);
            } else {
              notificaciones.showNotification($translate.instant("La actualizacion no fue exitosa"), 'Actualización' , 'error')
              vm.selectVersion1 = !utilidades.isEmpty(vm.versionSubsystema) && !utilidades.isEmpty(vm.versionSubsystema) ? vm.versionSubsystema : vm.selectVersion[0].version;
            }
          }).finally(function (){
            bloqueoDesbloqueoElementos(false);
          });
        }
      };

      /* FUNCION QUE ABRE EL MODAL QUE GESTIONA LAS VERSIONES EXISTENTES */
      vm.gestionarVersiones = function () {
        var elemento = {
          titulo: $translate.instant("Gestionar versiones")
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/gestDispositivosMoviles/modals/gestionarVersiones.modal.html',
          controller: 'gestionarVersionesController as vm',
          windowClass: 'ipanel-pref',
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function () {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function () {
          getAllVersionsMassiveMode()
         });
      };

      function cambiarEstados(show){
        if(show.solo && !show.massive){
          vm.showUnicVersionSelector = true
          vm.showConfig = true
        } else if(show.massive && !show.solo) {
          vm.showUnicVersionSelector = false
          vm.showConfig = false
        }else if(!show.massive && !show.solo) {
          vm.showUnicVersionSelector = true
          vm.showConfig = false
        }
      }

      $scope.$on('cambio-en-el-dispositivo-seleccionado', function (event, dispositivoSeleccionado) {
        vm.selectVersion1 = undefined;
        vm.selectedEquip = dispositivoSeleccionado
        if (!utilidades.isEmpty(dispositivoSeleccionado)) {
          selectedEquipStateUpdate()
          vm.showUnicVersionSelector = true
          vm.showConfig = true
        } else {
          vm.showUnicVersionSelector = false
          vm.showConfig = true
        }
      });

      $scope.$on('mostrarConfig', function (ev, show) {
        cambiarEstados(show)
      });

      $scope.$on('version-manager-modal', vm.gestionarVersiones)
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('verLogsController', verLogsController);

  function verLogsController($log, $uibModalInstance, $mdDialog, $interval, $scope, datos, $filter, $translate,
    $timeout, $uibModal, utilidades, $q, mdmService) {

    var vm = this;
    vm.titulo = datos.titulo;
    vm.loading = false;

    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    vm.logsAce = {
      useWrapMode: true,
      showGutter: false,
      theme: 'twilight',
      mode: 'xml',
      showPrintMargin: false
    };

    function functionSimularLogs() {
      mdmService.searchConfig("1c06e4a25cda74124264d564ce5cae12").then(function(data) {
        vm.logsAce1 = (data !== "") ? data : "";
      });
    }

    functionSimularLogs();

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('infoVersionController', infoVersionController);

  function infoVersionController($log, $uibModalInstance, $mdDialog, $interval, $scope, datos, $filter, $translate,
    $timeout, $uibModal, utilidades, $q, $window, $sce, utilidadesGO, mdmService, notificaciones, altaEquipamientosService) {

    var vm = this;
    vm.titulo = datos.titulo;
    vm.description = datos.data.description;
    vm.changeLog = datos.data.changeLog;

    vm.close = function() {
      $uibModalInstance.dismiss();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('gestionarVersionesController', gestionarVersionesController);

  function gestionarVersionesController($log, $uibModalInstance, $mdDialog, $interval, $scope, datos, $filter, $translate, $timeout, $uibModal, utilidades, $q, mdmService) {

    var vm = this;
    vm.titulo = datos.titulo;
    vm.loading = true;

    vm.close = function() {
      $uibModalInstance.close();
    };

    // CREA LA TABLA DE INFORMACION DE LAS VERSIONES
    vm.gestionarVersiones = {
      maxHeight: "calc(100vh - 150px)",
      currentPage: 1,
      perPage: 10,
      elements: [{
        title: 'Version',
        information: 'version',
        type: 'string'
      }, {
        title: 'Equipamientos',
        information: 'equipmentTypes',
        type: 'string'
      }],
      options: {
        title: 'Accion',
        showTitle: undefined,
        width: undefined,
        buttons: [{
          type: 'info',
          function: infoVersion
        }, {
          title: 'Editar',
          type: 'edit',
          function: editarVersion
        }, {
          title: 'Eliminar',
          type: 'delete',
          function: deleteVersion
        }]
      },
      data: []
    };

    $scope.refreshTblGest = function() {
      vm.loading = true;
      getVersions(true);
    };

    function infoVersion(data) {
      var elemento = {
        titulo: $translate.instant("Información version"),
        data: data
      };

      var modalInstance = $uibModal.open({
        templateUrl: 'app/views/gestDispositivosMoviles/modals/infoVersion.modal.html',
        controller: 'infoVersionController as vm',
        // windowClass: 'info',
        scope: $scope,
        size: 'lg', // puede ser lg, md,sm segun el tamaño que se desee
        resolve: {
          datos: function() {
            return elemento;
          }
        }
      });
      modalInstance.result.then(function() {});
    }

    function editarVersion(data) {
      var elemento = {
        titulo: $translate.instant("Modificar version"),
        data: data
      };

      var modalInstance = $uibModal.open({
        templateUrl: 'app/views/gestDispositivosMoviles/modals/addEditVersion.modal.html',
        controller: 'addEditVersionController as vm',
        windowClass: 'ipanel-pref',
        scope: $scope,
        size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
        resolve: {
          datos: function() {
            return elemento;
          }
        }
      });
      modalInstance.result.then(function() {
        getVersions(true)
      });
    }

    vm.addVersion = function() {
      var elemento = {
        titulo: $translate.instant("Anadir nueva version")
      };

      var modalInstance = $uibModal.open({
        templateUrl: 'app/views/gestDispositivosMoviles/modals/addEditVersion.modal.html',
        controller: 'addEditVersionController as vm',
        windowClass: 'ipanel-pref',
        scope: $scope,
        size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
        resolve: {
          datos: function() {
            return elemento;
          }
        }
      });
      modalInstance.result.then(function() {
        getVersions(true)
      });
    };

    function validaVacios (value) {
      return value === null ? '-' : value;
    }

    function getVersions(flag) {
      mdmService.getVersions(flag).then(function(data) {
        vm.loading = false;
        for (var i = 0; i < data.length; i++) {
          data[i].tooltip = [];
          data[i].tooltip.push({
            name: $translate.instant('Descripcion') + "" + ": " + validaVacios(data[i].description)
          }, {
            name: $translate.instant('ChangeLog') + "" + ": " + validaVacios(data[i].changeLog)
          });
        }
        vm.gestionarVersiones.data = data;
      });
    }

    function deleteVersion(data) {
      var msjConfim = $translate.instant("Desea eliminar la version") + " " + data.version + "?";
      showConfirm("Borrar servicio", msjConfim, "Aceptar", "Cancelar").then(function() {
        mdmService.deleteVersion(data).then(function(resp) {
          if (angular.isDefined(resp) && resp.data && angular.equals(resp.status, 200)) {
            vm.loading = true;
            $scope.$parent.refreshVersions();
            getVersions(true);
          }
        });
      });
    }

    function showConfirm(title, textContent, okBtn, cancelBtn, ev) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant(title))
        .textContent($translate.instant(textContent))
        .ok($translate.instant(okBtn))
        .cancel($translate.instant(cancelBtn))
        .targetEvent(ev);
      return $mdDialog.show(confirm);
    }

    getVersions(false);
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('addEditVersionController', addEditVersionController);

  function addEditVersionController($log, $uibModalInstance, $mdDialog, $interval, $scope, datos, $filter, $translate,
    $timeout, $uibModal, utilidades, $q, $window, $sce, utilidadesGO, mdmService, notificaciones, altaEquipamientosService) {

    var vm = this;
    vm.titulo = datos.titulo;
    vm.dtosEdit = !utilidades.isEmpty(datos, "datos.data") ? datos.data : undefined;
    vm.archivo = !utilidades.isEmpty(datos, "datos.data") ? [{name:datos.data.fileName}] : undefined;
    vm.loading = false;
    vm.lstEquipamiento = [];

    vm.response = {
      file: !utilidades.isEmpty(datos, "datos.data") ? datos.data.fileName : undefined,
      nameVersion: !utilidades.isEmpty(datos, "datos.data") ? datos.data.version : undefined,
      equipmentsCheck: [],
      descripcion: !utilidades.isEmpty(datos, "datos.data") ? datos.data.description : undefined,
      changelog: !utilidades.isEmpty(datos, "datos.data") ? datos.data.changeLog : undefined,
      internal : !utilidades.isEmpty(datos, "datos.data.internal") ? datos : null
    };

    vm.close = function() {
      $uibModalInstance.close();
    };

    vm.loadDatos = function() {
      var inputs = document.querySelectorAll('.input-file');
      inputs[0].addEventListener('change', addFile, false);
    };

    vm.checkEquipment = function(item) {
      var find = $filter('filter')(vm.response.equipmentsCheck, {
        'id': item.id
      }, true)[0];
      if (angular.isUndefined(find)) {
        item.checked = true;
        vm.response.equipmentsCheck.push(item);
      } else {
        for (var i = 0; i < vm.response.equipmentsCheck.length; i++) {
          if (angular.equals(vm.response.equipmentsCheck[i].id, item.id)) {
            item.checked = false;
            vm.response.equipmentsCheck.splice(i, 1);
            break;
          }
        }
      }
    };

    function addFile() {
      vm.archivo = [];
      vm.chipClass = false;
      var files = document.getElementById('file').files;
      vm.response.file = files;
      if (files.length > 0) {
        vm.archivo.push({
          name: files[0].name
        });
        var dcbImage = "dcb-image";
        if (vm.archivo[0].name.startsWith(dcbImage)) {
          var nameVersion = vm.archivo[0].name.split("_");
          var imageExt = nameVersion[1].split(".image");
          var imageUpg = nameVersion[1].split(".upgrade");

          if (imageExt.length > 1) {
            validaArchivo(imageExt, "image");
          } else {
            validaArchivo(imageUpg, "upgrade");
          }
        } else {
          vm.chipClass = true;
        }
      } else {
        vm.removeFile();
      }
    }

    function validaArchivo(nameFile, extension) {
      var validaPtos = nameFile[0].split(".");
      vm.response.nameVersion = !utilidades.isEmpty(validaPtos) && validaPtos.length > 2 ? nameFile[0] : undefined;
      vm.msjError = $translate.instant('El nombre de fichero no tiene el formato dcb-image*_x.y.z.' + extension);
      vm.chipClass = !utilidades.isEmpty(validaPtos) && validaPtos.length > 2 ? false : true;
    }

    vm.removeFile = function() {
      vm.archivo = null;
      vm.response.file = undefined;
      vm.response.nameVersion = undefined;
      document.getElementById('file').value = "";
      vm.chipClass = false;
    };

    function getEquipamientos() {
      altaEquipamientosService.getTiposEquipamientos().then(function(data) {
        if (!utilidades.isEmpty(data)) {
          for (var i = 0; i < data.length; i++) {
            if (!utilidades.isEmpty(vm, "vm.dtosEdit") && !utilidades.isEmpty(vm, "vm.dtosEdit.equipmentTypes")) {
              for (var j = 0; j < vm.dtosEdit.equipmentTypes.length; j++) {
                if (angular.equals(vm.dtosEdit.equipmentTypes[j], data[i].code)) {
                  data[i].checked = true;
                  vm.response.equipmentsCheck.push(data[i]);
                  break;
                } else {
                  data[i].checked = false;
                }
              }
            } else {
              data[i].checked = false;
            }
          }
          vm.lstEquipamiento = data;
        }
      }, function(error) {
        $log.info(error);
      });
    }

    $interval(function() {
      var dtos = vm.response;
      if (vm.chipClass) {
        vm.btnAddVersion = true;
        return;
      }

      if (angular.isUndefined(dtos.file)) {
        vm.btnAddVersion = true;
        return;
      }

      if (angular.isUndefined(dtos.nameVersion) || angular.equals(dtos.nameVersion, "")) {
        vm.btnAddVersion = true;
        return;
      }

      if (angular.isUndefined(dtos.equipmentsCheck) || dtos.equipmentsCheck.length < 1) {
        vm.btnAddVersion = true;
        return;
      }

      vm.btnAddVersion = false;
    }, 500);

    vm.addVersion = function() {
      vm.loading = true;
      var fd = new FormData();
      var equipmentType = vm.response.equipmentsCheck.map(function(x){
        return x.code;
      })

      var objVersion = {
        equipmentTypes: equipmentType,
        description: vm.response.descripcion,
        changeLog: vm.response.changelog,
        internal : vm.response.internal
      };

      fd.append('file',vm.response.file[0]);
      fd.append('json', JSON.stringify(objVersion));
      mdmService.postVersions(fd).then(function(resp) {
        vm.loading = false;
        if (!utilidades.isEmpty(resp) && resp.data && angular.equals(resp.status, 200)) {
          $uibModalInstance.dismiss();
          $scope.$parent.refreshTblGest(undefined);
          $scope.$parent.$parent.refreshVersions();
          var msj = $translate.instant("La alta fue exitosa");
          utilidadesGO.showNotificacion("Gestionar versiones", msj,"success");
        } else {
          utilidadesGO.showNotificacion($translate.instant("La alta no fue exitosa"));
        }
      });
    };

    vm.editVersion = function() {
      vm.loading = true;
      var equipmentType = [];
      for (var i = 0; i < vm.response.equipmentsCheck.length; i++) {
        equipmentType.push(vm.response.equipmentsCheck[i].code);
      }

      var objVersion = {
        fileName: vm.archivo[0].name,
        equipmentTypes: equipmentType,
        description: !utilidades.isEmpty(vm, "vm.response.descripcion") && !angular.equals(vm.response.descripcion, "") ? vm.response.descripcion : null,
        changeLog: !utilidades.isEmpty(vm, "vm.response.changelog") && !angular.equals(vm.response.changelog, "") ? vm.response.changelog : null,
        internal : vm.response.internal
      };

      mdmService.putVersion(objVersion, vm.dtosEdit.hash).then(function(resp) {
        vm.loading = false;
        if (!utilidades.isEmpty(resp) && resp.data && angular.equals(resp.status, 200)) {
          $uibModalInstance.dismiss();
          $scope.$parent.refreshTblGest(objVersion, vm.dtosEdit.hash);
          $scope.$parent.$parent.refreshVersions();
          utilidadesGO.showNotificacion($translate.instant("La modificacion fue exitosa"));
        } else {
          utilidadesGO.showNotificacion($translate.instant("La modificacion no fue exitosa"));
        }
      });
    };

    getEquipamientos();
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:MainController
   * @description
   * Controller para el menu de Live
   *
   */
  angular.module('app')
    .controller('ExampleTablaPantallaCompletaController',TablaPantallaCompletaController);

    function TablaPantallaCompletaController ($log, $translate, $filter,
                                              $location, $uibModal,
                                              conexion, constantes, ayuda,
                                              composicion, tablaPantallaCompletaService) {

        var vm = this;

        composicion.iniciarPantalla();

        //Ayuda
        var arrayAyuda = [];

        ayuda.ponerValorVista('TituloAyuda Live', 'TextoAyuda Live', arrayAyuda);
        vm.arrayAyuda = arrayAyuda;

        vm.loading = true;
        vm.datos = [];
        var colores = ["#ABBA76", "#881AB6", "#F20A16", "#561A76" ];
        var sistemas = ["MOTOR", "FRENOS", "SUSPENSION" ];
        function obtenerDatos(){
          tablaPantallaCompletaService.getData().then(function(data){
            vm.loading = false;
            vm.table.data = data;
          });
        }

        vm.table = {
          maxHeight: "calc(100vh - 150px)",
          currentPage: 1,
          perPage: 30,
          numberElementsShowing: undefined,
          elements: [{
            title: 'VehicleID',
            information: 'vehicle.id',
            bubble: 'vehicle.color',
            type: 'integer'
          },{
            title: 'Código',
            information: 'vehicle.code',
            color: 'vehicle.color',
            type: 'string',
            sort: 'true'
          },{
            title: 'Sistema',
            information: 'system.code',
            type: 'string',
            sortArray: sistemas
          },{
            title: 'Descripción',
            information: 'description',
            type: 'string'
          },{
            title: 'Gravedad',
            information: 'gravityColor',
            type: 'color',
            titleText: 'titleText',
            sortArray: colores
          },{
            title: 'Fecha inicio',
            information: 'initDate',
            type: 'datetime'
          },{
            title: 'Fecha fin',
            information: 'endDate',
            type: 'datetime'
          },{
            title: 'Progreso',
            information: 'valueProgress',
            type: 'progress'
          },{
            title: 'Odometria',
            information: 'odometry',
            type: 'number'
          },{
            title: 'Cantidad',
            information: 'numberA',
            type: 'integer'
          },{
            title: 'Revisión',
            information: 'revision',
            type: 'boolean',
            sortArray: [true, false]
          }

        ],
        options: {
            title: '',
            showTitle: undefined,
            width: undefined,
            buttons: [{
              title: 'Información',
              type: 'info',
              function: infoFunction,
              disabled: disabledInfoFunction
            },{
              title: 'Alerta',
              type: 'alert',
              function: infoFunction,
              disabled: disabledInfoFunction
            },{
              title: 'Gráfica',
              type: 'graphic',
              function: infoFunction,
              disabled: disabledInfoFunction
            },{
              title: 'Batería',
              type: 'battery',
              function: infoFunction,
              disabled: disabledInfoFunction
            }
            /*,{
              title: 'Editar',
              type: 'edit',
              function: infoFunction,
              disabled: disabledInfoFunction
            },{
              title: 'Eliminar',
              type: 'delete',
              function: infoFunction,
              disabled: disabledInfoFunction
            },{
              title: 'Asignar',
              type: 'assign',
              function: infoFunction,
              disabled: disabledInfoFunction
            },{
              title: 'Geolocalizar',
              type: 'geolocate',
              function: infoFunction,
              disabled: disabledInfoFunction
            }*/
          ]
        },
        data: [],
        getCsvData: undefined
      };

      vm.csv = {
        exportarDatos: function() {
          return vm.table.getCsvData();
        },
        nombreFichero: function() {
          return $translate.instant('Tabla pantalla completa') + '-' + $filter('date')(new Date(), $translate.instant('fechaHoraIdioma')) + '.csv';
        }
      };

      function infoFunction(data){
          $log.info("Se ha hecho click sobre " + data);


      }
      function disabledInfoFunction(data){
          if(data.tipoFlotista === 1){
            return false;
          }
          return true;
      }


      vm.add = function(){
        var element = {
          info: "Datos a mostrar"
        };
        var modalInstance = $uibModal.open({
              templateUrl: 'app/views/examples/tablaPantallaCompleta/modals/TablaPantallaController.modal.html',
              controller: 'TablaPantallaCompletaModalController as vm',
              size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
              resolve: {
                        datos: function () {
                          return element;
                        }
                      }
        });

        modalInstance.result.then(function(resultado){
          $log.info("Resultado: " + resultado );
        }, function () {
             $log.info('Modal quitado vehiculos electricos de baterías dismissed at: ' + new Date());
        });
      }

      obtenerDatos();

      }

})();

(function() {
  'use strict';


  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */
  angular
    .module('app')
    .factory('tablaPantallaCompletaService', tablaPantallaCompletaService);

  function tablaPantallaCompletaService($log, $http, $window, $q, $timeout) {

    var colores = ['#0214A2','#B10855','#53C276'];
    var service = {
      getData: getData
    };

    return service;


    function getData() {
      var deferred = $q.defer();
      $timeout(function(){
        var data = [
          {system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[0], titleText:'Título de color', numberA : 2, valueProgress: 14, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[0], titleText:'Título de color', numberA : 2, valueProgress: 14, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[1], numberA : 6, valueProgress: 44, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[2], numberA : 97, valueProgress: 69, revision:true},
          {vehicle: {code: "120005", id: 5, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[3], numberA : 33, valueProgress: 99, revision:true},
          {vehicle: {code: "120005", id: 5, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[1], numberA : 3456, valueProgress: 5, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[3], numberA : 754, revision:true},
          {vehicle: {code: "120004", id: 4, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[2], numberA : 345, revision:false},
          {vehicle: {code: "120001", id: 1, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[0], numberA : 347, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[1], numberA : 264, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[0], numberA : 6784, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[2], numberA : 489, revision:true},
          {vehicle: {code: "120005", id: 5, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[2], numberA : 56, revision:false},
          {vehicle: {code: "120006", id: 6, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[3], numberA : 7684, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[0], numberA : 8345, revision:false},
          {vehicle: {code: "120004", id: 4, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[0], numberA : 3568, revision:true},
          {vehicle: {code: "120006", id: 6, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[2], numberA : 5673, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[1], numberA : 8731, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[0], numberA : 5440, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[3], numberA : 2489, revision:false},
          {vehicle: {code: "120005", id: 5, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[3], numberA : 7354, revision:true},
          {vehicle: {code: "120007", id: 7, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[0], numberA : 9063, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[1], numberA : 853, revision:true},
          {vehicle: {code: "120007", id: 7, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[2], numberA : 8643, revision:false},
          {vehicle: {code: "120001", id: 1, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[2], numberA : 894, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[3], numberA : 987, revision:true},
          {vehicle: {code: "120005", id: 5, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[3], numberA : 4567, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[2], numberA : 634, revision:true},
          {vehicle: {code: "120006", id: 6, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[1], numberA : 975, revision:false},
          {vehicle: {code: "120005", id: 5, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[0], numberA : 322, revision:true},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[0], numberA : 124, revision:false},
          {vehicle: {code: "120007", id: 7, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[1], numberA : 1274, revision:false},
          {vehicle: {code: "120001", id: 1, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[1], numberA : 174, revision:false},
          {vehicle: {code: "120008", id: 8, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[3], numberA : 7648, revision:false},
          {vehicle: {code: "120001", id: 1, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[2], numberA : 5935, revision:true},
          {vehicle: {code: "120008", id: 8, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[2], numberA : 663, revision:true},
          {vehicle: {code: "120005", id: 5, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[1], numberA : 895, revision:true},
          {vehicle: {code: "120009", id: 9, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[1], numberA : 932, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[0], numberA : 352, revision:false},
          {vehicle: {code: "120004", id: 4, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[2], numberA : 213, revision:true},
          {vehicle: {code: "120006", id: 6, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[0], numberA : 562, revision:false},
          {vehicle: {code: "120001", id: 1, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[1], numberA : 286, revision:false},
          {vehicle: {code: "120007", id: 7, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[1], numberA : 780, revision:true},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[0], numberA : 605, revision:false},
          {vehicle: {code: "120005", id: 5, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[3], numberA : 317, revision:true},
          {vehicle: {code: "120008", id: 8, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[2], numberA : 544, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[1], numberA : 856, revision:true},
          {vehicle: {code: "120008", id: 8, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[1], numberA : 722, revision:false},
          {vehicle: {code: "120001", id: 1, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[2], numberA : 54, revision:false},
          {vehicle: {code: "120001", id: 1, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[2], numberA : 62, revision:false},
          {vehicle: {code: "120009", id: 9, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[2], numberA : 28, revision:true},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[3], numberA : 653, revision:false},
          {vehicle: {code: "120005", id: 5, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[1], numberA : 64, revision:true},
          {vehicle: {code: "120009", id: 9, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[0], numberA : 537, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[0], numberA : 83, revision:true},
          {vehicle: {code: "120008", id: 8, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[1], numberA : 22, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[1], numberA : 456, revision:false},
          {vehicle: {code: "120008", id: 8, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[1], numberA : 86, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[0], numberA : 43, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[2], numberA : 95, revision:true},
          {vehicle: {code: "120007", id: 7, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[0], numberA : 254, revision:false},
          {vehicle: {code: "120006", id: 6, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[2], numberA : 475, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[0], numberA : 294, revision:true},
          {vehicle: {code: "120008", id: 8, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[3], numberA : 255, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[3], numberA : 244, revision:false},
          {vehicle: {code: "120008", id: 8, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[3], numberA : 74, revision:false},
          {vehicle: {code: "120009", id: 9, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[0], numberA : 54, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[1], numberA : 844, revision:true},
          {vehicle: {code: "120006", id: 6, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[1], numberA : 67, revision:true},
          {vehicle: {code: "120005", id: 5, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[0], numberA : 887, revision:false},
          {vehicle: {code: "120008", id: 8, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[1], numberA : 943, revision:true},
          {vehicle: {code: "120004", id: 4, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[0], numberA : 456, revision:false},
          {vehicle: {code: "120006", id: 6, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[0], numberA : 274, revision:true},
          {vehicle: {code: "120001", id: 1, color:"#ABBA76" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T04:33:25",endDate: "2019-01-31T06:31:21",odometry: 149006.2, gravityColor:colores[1], numberA : 843, revision:false},
          {vehicle: {code: "120007", id: 7, color:"#881AB6" },system: {code: "MOTOR", id : 3},description: "Alerta del motor",severity: 2,initDate: "2019-01-31T07:13:42",endDate: "2019-01-31T08:23:22",odometry: 1494361.3, gravityColor:colores[1], numberA : 234, revision:true},
          {vehicle: {code: "120002", id: 2, color:"#F20A16" },system: {code: "FRENOS", id : 1},description: "Freno bloqueado",severity: 3,initDate: "2019-01-31T17:43:49",endDate: "2019-01-31T17:51:29",odometry: 1357743.3, gravityColor:colores[0], numberA : 745, revision:false},
          {vehicle: {code: "120009", id: 9, color:"#B6AA06" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 1,initDate: "2019-01-31T10:11:42",endDate: "2019-01-31T11:00:22",odometry: 8684537.3, gravityColor:colores[3], numberA : 8483, revision:false},
          {vehicle: {code: "120005", id: 5, color:"#23ABC6" },system: {code: "SUSPENSION", id : 2},description: "Suspensión no monitorizada",severity: 2,initDate: "2019-01-31T04:33:12",endDate: "2019-01-31T05:33:52",odometry: 5327832.3, gravityColor:colores[0], numberA : 2390, revision:false},
          {vehicle: {code: "120002", id: 2, color:"#12AD26" },system: {code: "MOTOR", id : 3},description: "RPM alto",severity: 2,initDate: "2019-01-31T07:16:12",endDate: "2019-01-31T07:23:22",odometry: 7524432.3, gravityColor:colores[3], numberA : 54, revision:true},
          {vehicle: {code: "120008", id: 8, color:"#BCA216" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 2,initDate: "2019-01-31T10:11:12",endDate: "2019-01-31T11:00:02",odometry: 6542433.2, gravityColor:colores[2], numberA : 234, revision:true},
          {vehicle: {code: "120006", id: 6, color:"#561A76" },system: {code: "FRENOS", id : 1},description: "Frenada brusca",severity: 3,initDate: "2019-01-31T16:33:42",endDate: "2019-01-31T16:35:22",odometry: 1494481.7, gravityColor:colores[1], numberA : 6322, revision:false}
        ];
        deferred.resolve(data);
      },1000);

      return deferred.promise
    }



  }

})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:MainController
   * @description
   * Controller para el menu de Live
   *
   */
  angular.module('app')
    .controller('ExampleTablaController',TablaController);

    function TablaController ($rootScope, $translate, $location, $timeout, $log,
        conexion, constantes, ayuda, composicion) {

        var vm = this;

        composicion.iniciarPantalla();

        //Ayuda
        var arrayAyuda = [];

        ayuda.ponerValorVista('TituloAyuda Live', 'TextoAyuda Live', arrayAyuda);
        vm.arrayAyuda = arrayAyuda;

        var funcionEditar = function(elemento, index){
          $log.info("EDITAR " + elemento + ' index: '+ index);
        };
        var funcionEliminar = function(elemento, index){
          $log.info("ELIMINAR " + elemento + ' index: '+ index);
        };
        var funcionOtros = function(elemento, index){
          $log.info("OTROS " + elemento + ' index: '+ index);
        };
        var disabledFunction = function(/*elemento,indexRelativo*/){
          return true;
        }
        var showLoadingDeleteFunction = function(elemento/*,indexRelativo*/){
          if(angular.isUndefined(elemento.showLoadingDelete) || !elemento.showLoadingDelete){
            return false;
          }else{
            return true;
          }
        }
        var notDisabledFunction = function(/*elemento,indexRelativo*/){
          return false;
        }
        vm.loading = true;
        vm.datos = [];
        function obtenerDatos(){
          vm.loading = false;
          vm.datos = [
                      {date:'2018-10-02T00:00:00', lastUpdate:'2018-10-02T14:26:14', vehicle:{id:1,code:"AAAA"}, litres: 12, percent: 21.2, tags:["aa1","bb2"], available: true, showLoadingDelete:true},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T14:24:17', vehicle:{id:2,code:"BBBB"}, litres: 16, percent: 52.2, tags:["bb2"], available: false},
                      {date:'2018-10-07T00:00:00', lastUpdate:'2018-10-07T16:46:18', vehicle:{id:3,code:"CCCC"}, litres: 14, percent: 31.2, tags:["cc3"], available: true, showLoadingDelete:false},
                      {date:'2018-10-09T00:00:00', lastUpdate:'2018-10-09T18:14:15', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: false},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T18:15:13', vehicle:{id:1,code:"AAAA"}, litres: 17, percent: 24, tags:["bb2"], available: true},
                      {date:'2018-10-05T00:00:00', lastUpdate:'2018-10-05T15:25:17', vehicle:{id:1,code:"AAAA"}, litres: 15, percent: 41.2, tags:["aa1","bb2"], available: true},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T17:24:13', vehicle:{id:2,code:"BBBB"}, litres: 14, percent: 72.2, tags:["bb2"], available: false, showLoadingDelete:true},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T12:48:12', vehicle:{id:3,code:"CCCC"}, litres: 33, percent: 91.2, tags:["cc3"], available: true},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T11:11:17', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: false},
                      {date:'2018-10-05T00:00:00', lastUpdate:'2018-10-05T14:11:18', vehicle:{id:1,code:"AAAA"}, litres: 19, percent: 54, tags:["bb2"], available: false},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T18:22:19', vehicle:{id:1,code:"AAAA"}, litres: 14, percent: 61.2, tags:["aa1","bb2"], available: false},
                      {date:'2018-10-06T00:00:00', lastUpdate:'2018-10-06T15:22:14', vehicle:{id:2,code:"BBBB"}, litres: 17, percent: 42.2, tags:["bb2"], available: true},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T19:46:15', vehicle:{id:3,code:"CCCC"}, litres: 6, percent: 81.2, tags:["cc3"], available: false},
                      {date:'2018-10-05T00:00:00', lastUpdate:'2018-10-05T13:11:13', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: false},
                      {date:'2018-10-09T00:00:00', lastUpdate:'2018-10-09T18:11:18', vehicle:{id:1,code:"AAAA"}, litres: 13, percent: 44, tags:["bb2"], available: true},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T10:22:15', vehicle:{id:1,code:"AAAA"}, litres: 13, percent: 21.2, tags:["aa1","bb2"], available: true},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T11:22:12', vehicle:{id:2,code:"BBBB"}, litres: 19, percent: 42.2, tags:["bb2"], available: true},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T17:46:14', vehicle:{id:3,code:"CCCC"}, litres: 9, percent: 61.2, tags:["cc3"], available: false},
                      {date:'2018-10-06T00:00:00', lastUpdate:'2018-10-06T19:11:16', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: false},
                      {date:'2018-10-06T00:00:00', lastUpdate:'2018-10-06T14:11:17', vehicle:{id:1,code:"AAAA"}, litres: 6, percent: 74, tags:["bb2"], available: true},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T19:22:19', vehicle:{id:1,code:"AAAA"}, litres: 23, percent: 41.2, tags:["aa1","bb2"], available: false},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T13:22:10', vehicle:{id:2,code:"BBBB"}, litres: 31, percent: 42.2, tags:["bb2"], available: true},
                      {date:'2018-10-02T00:00:00', lastUpdate:'2018-10-02T17:46:12', vehicle:{id:3,code:"CCCC"}, litres: 33, percent: 31.2, tags:["cc3"], available: false},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T18:11:13', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: true},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T13:11:14', vehicle:{id:1,code:"AAAA"}, litres: 19, percent: 84, tags:["bb2"], available: false},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T19:22:15', vehicle:{id:1,code:"AAAA"}, litres: 12, percent: 51.2, tags:["aa1","bb2"], available: true},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T14:22:16', vehicle:{id:2,code:"BBBB"}, litres: 14, percent: 42.2, tags:["bb2"], available: false},
                      {date:'2018-10-09T00:00:00', lastUpdate:'2018-10-09T19:46:17', vehicle:{id:3,code:"CCCC"}, litres: 8, percent: 81.2, tags:["cc3"], available: true},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T13:11:18', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: true},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T12:11:19', vehicle:{id:1,code:"AAAA"}, litres: 16, percent: 24, tags:["bb2"], available: false},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T19:22:10', vehicle:{id:1,code:"AAAA"}, litres: 13, percent: 41.2, tags:["aa1","bb2"], available: false},
                      {date:'2018-10-06T00:00:00', lastUpdate:'2018-10-06T10:22:12', vehicle:{id:2,code:"BBBB"}, litres: 14, percent: 52.2, tags:["bb2"], available: false},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T13:46:11', vehicle:{id:3,code:"CCCC"}, litres: 5, percent: 61.2, tags:["cc3"], available: true},
                      {date:'2018-10-05T00:00:00', lastUpdate:'2018-10-05T12:11:15', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: true},
                      {date:'2018-10-09T00:00:00', lastUpdate:'2018-10-09T15:11:17', vehicle:{id:1,code:"AAAA"}, litres: 18, percent: 74, tags:["bb2"], available: false},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T17:22:18', vehicle:{id:1,code:"AAAA"}, litres: 17, percent: 41.2, tags:["aa1","bb2"]},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T13:22:19', vehicle:{id:2,code:"BBBB"}, litres: 14, percent: 62.2, tags:["bb2"], available: false},
                      {date:'2018-10-07T00:00:00', lastUpdate:'2018-10-07T19:46:14', vehicle:{id:3,code:"CCCC"}, litres: 28, percent: 71.2, tags:["cc3"], available: false},
                      {date:'2018-10-01T00:00:00', lastUpdate:'2018-10-01T14:11:16', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: true},
                      {date:'2018-10-02T00:00:00', lastUpdate:'2018-10-02T19:11:12', vehicle:{id:1,code:"AAAA"}, litres: 35, percent: 44, tags:["bb2"], available: true},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T14:22:13', vehicle:{id:1,code:"AAAA"}, litres: 17, percent: 41.2, tags:["aa1","bb2"], available: false},
                      {date:'2018-10-09T00:00:00', lastUpdate:'2018-10-09T16:22:13', vehicle:{id:2,code:"BBBB"}, litres: 17, percent: 52.2, tags:["bb2"], available: true},
                      {date:'2018-10-09T00:00:00', lastUpdate:'2018-10-09T18:46:16', vehicle:{id:3,code:"CCCC"}, litres: 28, percent: 61.2, tags:["cc3"], available: false},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T13:11:15', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: false},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T16:11:13', vehicle:{id:1,code:"AAAA"}, litres: 33, percent: 74, tags:["bb2"], available: true},
                      {date:'2018-10-04T00:00:00', lastUpdate:'2018-10-04T18:22:14', vehicle:{id:1,code:"AAAA"}, litres: 42, percent: 81.2, tags:["aa1","bb2"], available: true},
                      {date:'2018-10-06T00:00:00', lastUpdate:'2018-10-06T10:22:16', vehicle:{id:2,code:"BBBB"}, litres: 1, percent: 42.2, tags:["bb2"], available: false},
                      {date:'2018-10-08T00:00:00', lastUpdate:'2018-10-08T13:11:18', vehicle:{id:2,code:"BBBB"}, percent: '-', tags:["cc3"], available: false},
                      {date:'2018-10-03T00:00:00', lastUpdate:'2018-10-03T15:46:17', vehicle:{id:3,code:"CCCC"}, litres: 2, percent: 31.2, tags:["cc3"], available: true},
                      {date:'2018-10-05T00:00:00', lastUpdate:'2018-10-05T19:11:13', vehicle:{id:1,code:"AAAA"}, litres: 14, percent: 44, tags:["bb2"], available: true}
                    ];
        }

        vm.tabla1 = {
          elementos : [{title: 'Fecha', information: 'date', type: 'date', sort: 'reverse' },
                      {title: 'Vehículo', information: 'vehicle.code', type: 'string'},
                      {title: 'Combustible', information: 'litres', type: 'integer', unit: 'Combustible'},
                      {title: 'Porcentaje', information: 'percent', type: 'number', unit: 'percentage'}
                    ],
          opciones : {
            title: 'Opciones',
            //width: '320px',
            //showTitles: true,
            buttons: [{title:'Editar', type:'edit', function:funcionEditar, disabled:notDisabledFunction},
                      {title:'Eliminar', type:'delete', function:funcionEliminar, disabled:disabledFunction, showLoadingImage:showLoadingDeleteFunction},
                      {title:'Asignar', type:'assign', function:funcionOtros, disabled:notDisabledFunction},
                      {title:'Info', type:'info', function:funcionOtros, disabled:disabledFunction}
                    ]
          },
          selection: {
            mode: 'checkbox',
            getSelectedElements: undefined,
            changeSelectionEventName : 'datik-table-change-selection'
          }
        };
        vm.tabla2 = {
          elementos : [{title: 'Última actualización', information: 'lastUpdate', type: 'datetime', sort: 'reverse' },
                      {title: 'Vehículo', information: 'vehicle.code', type: 'string'},
                      {title: 'Disponible', information: 'available', type: 'boolean', sortArray:[true,false]},
                      {title: 'Etiquetas', information: 'tags', type: 'array'}
                    ],
          opciones : {
            title: 'Opciones',
            //width: '320px',
            //showTitles: true,
            buttons: [
                      {title:'Streaming', type:'streaming', function:funcionOtros, disabled:disabledFunction },
                      {title:'Mensaje', type:'message', function:funcionOtros, disabled:disabledFunction },
                      {title:'Geolocalizar', type:'geolocate', function:funcionOtros, disabled:disabledFunction }
                    ]
          },
          selection: {
            mode: 'multiple',
            getSelectedElements: undefined,
            changeSelectionEventName : 'datik-table-change-selection'
          }
        }
        vm.tabla3 = {
          elementos : [{title: 'Última actualización', information: 'lastUpdate', type: 'datetime', sort: 'reverse' },
                      {title: 'Vehículo', information: 'vehicle.code', type: 'string'},
                      {title: 'Disponible', information: 'available', type: 'boolean', sortArray:[true,false]},
                      {title: 'Etiquetas', information: 'tags', type: 'array'}
                    ],
          opciones : {
            title: 'Options',
            //width: '320px',
            //showTitles: true,
            buttons: [
                      {title:'Asignar', type:'assign', function:funcionOtros, disabled:notDisabledFunction },
                      {title:'Info', type:'info', function:funcionOtros, disabled:notDisabledFunction }
                    ]
          },
          selection: {
            mode: 'simple',
            getSelectedElements: undefined,
            changeSelectionEventName : 'datik-table-change-selection'
          }
        }
        vm.tabla4 = {
          elementos : [{title: 'Última actualización', information: 'lastUpdate', type: 'datetime', sort: 'reverse' },
                      {title: 'Vehículo', information: 'vehicle.code', type: 'string'},
                      {title: 'Disponible', information: 'available', type: 'boolean', sortArray:[true,false]},
                      {title: 'Etiquetas', information: 'tags', type: 'array'}
                    ],
          opciones : {
            title: '',
            //width: '320px',
            //showTitles: true,
            buttons: [
                      {title:'Info', type:'info', function:funcionOtros, disabled:notDisabledFunction }
                    ]
          },
          selection: undefined
        }
        vm.showTable = true;
        vm.selectTabla = function(index){
          vm.showTable = false;
          if(index === 1){
            vm.elementos = vm.tabla1.elementos;
            vm.opciones = vm.tabla1.opciones;
            vm.selection = vm.tabla1.selection;
          }else if(index === 2){
            vm.elementos = vm.tabla2.elementos;
            vm.opciones = vm.tabla2.opciones;
            vm.selection = vm.tabla2.selection;
          }else if(index === 3){
            vm.elementos = vm.tabla3.elementos;
            vm.opciones = vm.tabla3.opciones;
            vm.selection = vm.tabla3.selection;
          }else if(index === 4){
            vm.elementos = vm.tabla4.elementos;
            vm.opciones = vm.tabla4.opciones;
            vm.selection = vm.tabla4.selection;
          }
          $timeout(function(){
            vm.showTable = true;
            vm.loading = true;
            vm.datos.length = 0;
            $timeout(obtenerDatos,2000);
          },0);
        }

        vm.selectTabla(1);
        vm.table={
          currentPage :1,
          perPage : 100
        };

      }

})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:NotificacionesController
   * @description
   * Controller para el menu de Live
   *
   */
  angular.module('app')
    .controller('ExamplesNotificacionesController',
      function($log, notificaciones) {

        var vm = this;

        vm.opcionesNotificaciones = ["success", "error", "warning", "info"]
        vm.tituloNotificaciones = "Titulo del elemento";
        vm.textoNotificaciones = "Texto de ejemplo";
        vm.opcion = vm.opcionesNotificaciones[0];

        vm.showNotification = function(){
          notificaciones.showNotification(vm.tituloNotificaciones, vm.textoNotificaciones, vm.opcion);
        }


      });

})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:FechaController
   * @description
   * Controller para el menu de Live
   *
   */
  angular.module('app')
    .controller('ExampleFechaController',FechaController);

    function FechaController ($translate, $timeout, $filter, $location,
                              $scope, $log, moment, ayuda, composicion, constantes) {

        var vm = this;

        composicion.iniciarPantalla();

        //Ayuda
        var arrayAyuda = [];

        ayuda.ponerValorVista('TituloAyuda Live', 'TextoAyuda Live', arrayAyuda);
        vm.arrayAyuda = arrayAyuda;

        vm.date = {
          placeholder: "Fecha",
          initDate : moment().format(constantes.formatoComunicacion),
          //min: moment(new Date((new Date()).getTime() - 30*24*60*60*1000)).format(constantes.formatoComunicacion),
          //max: moment(new Date((new Date()).getTime() + 30*24*60*60*1000)).format(constantes.formatoComunicacion),
          eventName: "cambioFecha",
          showHours: true,
          getDate: undefined
        };

        vm.datos = angular.copy(vm.date);

        vm.mostrar = true;
        vm.aplicarCambios = function(){
          vm.mostrar = false;
          vm.date = vm.datos;
          $timeout(function(){
            vm.mostrar = true;
          },200)
        };

        $scope.$on(vm.date.eventName,function(event, data){
          $log.info("CAMBIO FECHA: " + data);
        });
        $scope.$on("datik-date-change",function(event, data){
          $log.info("CAMBIO FECHA datik-date-change: " + data);
        });
      }

})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('equipamientosService', equipamientosService);

  function equipamientosService($log, $http, $q, $translate, $filter, constantes, conexion, utilidades) {
    var service = {
      getEquipamientos: getEquipamientos,
      validaVacios: validaVacios,
      numeroRecuVehi: numeroRecuVehi
    };

    return service;

    function getTooltipInfo(elemento, responseElement) {
        return [{name: $translate.instant('Actualización') + "" + ": " + validaVacios(elemento.uidResource)},
                {name: $translate.instant('IP privada') + "" + ": " + ((angular.isDefined(responseElement)) ? validaVacios(responseElement.privateIp) : "-")},
                {name: $translate.instant('IP pública') + "" + ": " + ((angular.isDefined(responseElement)) ? validaVacios(responseElement.publicIp) : "-")},
                {name: $translate.instant('Versión') + "" + ": " + ((angular.isDefined(responseElement)) ? validaVacios(responseElement.version) : "-")},
                {name: $translate.instant('Versión requerida') + "" + ": " + validaVacios(elemento.updateVersion)}
              ];
    }

    function validaVacios (value) {
      if(value == null) return '-';
      return value;
    }

    function numeroRecuVehi(datos,val) {
      var url = constantes.getApiUrl('ips_mng', 'getEquipamentos');
      if (val === 0) {
        url = url + '?filter=codeVehicle:'+ datos.code + ",nameOperator:" + datos.nameOperator;
      } else {
        url = url + '?filter=codeResource:'+ datos.code+ ",nameOperator:" + datos.client;
      }

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getEquipamientos(page,size,filter,sort) {
      var url = constantes.getApiUrl('ips_mng', 'getEquipamentos');
      var dtos = [];
      var filtro = [];
      var filtroUno = "";
      var filtroDos = "";

      filter = filter.split("#");
      filtro = filter[0].split(",");
      for (var i = 0; i < filtro.length; i++) {
        if (angular.isDefined(filtro[i]) && filtro[i].includes("<filtro>") && filtroUno == "") {
          filtroUno = filtro[i];
        } else if (angular.isDefined(filtro[i]) && filtro[i].includes("<filtro>") && filtroUno !== "" && filtroDos == "") {
          filtroDos = filtro[i];
        }
      }

      if (filtroUno.length > 0 || filtroDos.length > 0) {
        filtro = [];
        filter[0] = filter[0].replace(filtroUno,"").replace(filtroDos,"");
        filter[0] = filter[0].substring(0).replace(",","");
        if (filtroUno.includes("privateIp") && filtroDos == "") {
          filtroUno = filtroUno.split("<filtro>");
          filtro.push(filtroUno[1]);
          filtro.push("");
        } else if (filtroUno.includes("sim") && filtroDos == "") {
          filtroUno = filtroUno.split("<filtro>");
          filtro.push("");
          filtro.push(filtroUno[1]);
        } else if (filtroDos.includes("privateIp") && filtroUno.includes("sim")) {
          filtroDos = filtroDos.split("<filtro>");
          filtroUno = filtroUno.split("<filtro>");
          filtro.push(filtroDos[1]);
          filtro.push(filtroUno[1]);
        } else if (filtroDos.includes("sim") && filtroUno.includes("privateIp")) {
          filtroDos = filtroDos.split("<filtro>");
          filtroUno = filtroUno.split("<filtro>");
          filtro.push(filtroUno[1]);
          filtro.push(filtroDos[1]);
        }
      } else {
        filtro = [];
      }

      if (sort !== "" && filter[0] === "" && filter[1] === "<reg>") {
        sort = sort.replace("tipo","equipmentType");
        url += '?sort='+ sort +'&page='+ page +'&size=' + size;
      } else if (sort === "" && filter[0] !== "" && filter[1] !== "<reg>") {

        dtos = filter[1].split("<reg>");
        if (dtos[1] !== "") {
          url += '?filter='+ filter + '&lt='+ dtos[0] + '&page='+ page +'&size=' + size;
        } else if (dtos[2] !== "") {
          url += '?filter='+ filter + '&gt='+ dtos[1] +'&page='+ page +'&size=' + size;
        } else if (dtos[1] !== "" && dtos[2] !== "") {
          url += '?filter='+ filter + '&lt='+ dtos[1] + '&gt='+ dtos[2]  +'&page='+ page +'&size=' + size;
        } else {
          url += '?filter='+ filter +'&page='+ page +'&size=' + size;
        }

      } else if (sort !== "" && filter[0] !== "" && filter[1] !== "<reg>") {

        dtos = filter[1].split("<reg>");
        if (dtos[1] !== " " && dtos[2] === "") {
          url += '?sort='+ sort + '&filter='+ filter + '&lt='+ dtos[1] + '&page='+ page +'&size=' + size;
        } else if (dtos[1] === " " && dtos[2] !== "") {
          url += '?sort='+ sort + '&filter='+ filter + '&gt='+ dtos[2] +'&page='+ page +'&size=' + size;
        } else if (dtos[1] !== " " && dtos[2] !== "") {
          url += '?sort='+ sort + '&filter='+ filter + '&lt='+ dtos[1] + '&gt='+ dtos[2]  +'&page='+ page +'&size=' + size;
        } else {
          url += '?sort='+ sort + '&filter='+ filter + '&page='+ page +'&size=' + size;
        }

      } else if (sort !== "" && filter[0] === "" && filter[1] !== "<reg>") {

        dtos = filter[1].split("<reg>");
        if (dtos[1] !== " " && dtos[2] === "") {
          url += '?sort='+ sort + '&lt='+ dtos[1] + '&page='+ page +'&size=' + size;
        } else if (dtos[1] === " " && dtos[2] !== "") {
          url += '?sort='+ sort + '&gt='+ dtos[2] +'&page='+ page +'&size=' + size;
        } else if (dtos[1] !== "" && dtos[2] !== "") {
          url += '?sort='+ sort + '&lt='+ dtos[1] + '&gt='+ dtos[2]  +'&page='+ page +'&size=' + size;
        }

      } else if (sort === "" && filter[0] === "" && filter[1] !== "<reg>") {

        dtos = filter[1].split("<reg>");
        if (dtos[1] !== " " && dtos[2] === "") {
          url += '?lt='+ dtos[0] + '&page='+ page +'&size=' + size;
        } else if (dtos[1] === " " && dtos[2] !== "") {
          url += '?gt='+ dtos[1] +'&page='+ page +'&size=' + size;
        } else if (dtos[1] !== "" && dtos[2] !== "") {
          url += '?lt='+ dtos[1] + '&gt='+ dtos[2]  +'&page='+ page +'&size=' + size;
        }

      } else if (sort !== "" && filter[0] !== "" && filter[1] === "<reg>") {
        sort = sort.replace("tipo","equipmentType");
        url += '?sort='+ sort + '&filter='+ filter[0] + '&page='+ page +'&size=' + size;
      } else {
        url += '?page='+ page + '&size=' + size;
      }

      var cadena = "";
      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        var deferred = $q.defer();
        var promises = [];

        var totalCount = 0;
        var dividedResponseData = [];
        cadena = "";
        var filteredEquipments = response.data.equipments;
        // A veces el backend no filtra bien para nombres cortos y devuelve todo. Esto es un workaround hasta que se arregle en el backend
        if(response.data.equipments.length > size) {
          filteredEquipments = response.data.equipments.splice((page*size) - size, size);
        }
        filteredEquipments.forEach(function(elemento, index) {
          elemento.uidOperator = !utilidades.isEmpty(elemento.resourceList) ? elemento.resourceList[0].uidOperator : undefined
          if(!utilidades.isEmpty(elemento, 'elemento.resourceList')){
            elemento.codeResource  = ''
            elemento.resourceList.forEach(function (x, index){
              elemento.codeResource += index !== elemento.resourceList.length -1 ? x.code + ', ' : x.code
            })
          }
          if(index < filteredEquipments.length) {
            cadena += elemento.uidVehicle + ",";
            elemento.tipo = elemento.equipmentType;
            dividedResponseData.push(elemento);
            index++;
          }
          totalCount++;
          if(index === filteredEquipments.length) {
            cadena = cadena.substring(0,cadena.length-1);
            promises.push(getEquipmentData(dividedResponseData, cadena,filtro ));
            cadena = "";
            dividedResponseData = [];
          }
        });

        var theResults = [];
        $q.all(promises).then(function(result) {
            for (var i = 0; i < result.length; i++){
              theResults.push(result[i]);
            }
            deferred.resolve({ equipments: theResults.flat(), totalCount: response.data.totalCount});
        });

        return deferred.promise;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getEquipmentData(dividedResponseData, cadena,filtro) {
      var recvData = { data: dividedResponseData };
      return getEquipamentoSegundaPart(recvData,cadena).then(function(response) {
           recvData.data.forEach(function(elemento) {
             var result = $filter('filter')(response.data, {'uid': elemento.uidVehicle});
             if(result.length) {
                 elemento.sim = result[0].sim;
                 elemento.privateIp = result[0].privateIp;
                 elemento.publicIp = result[0].publicIp;
                 elemento.version = result[0].version;
                 elemento.tooltip = getTooltipInfo(elemento, result[0]);
             } else {
                 elemento.tooltip = getTooltipInfo(elemento);
             }
            });
            // // Filtrar resultados que concuerden con ip y/o sim
            if (filtro.length > 0) {
              if(angular.isDefined(filtro[0]) && angular.isUndefined(filtro[1])) {
                recvData.data = $filter('filter')(recvData.data, {'privateIp': filtro[0]});
              }
              if(angular.isDefined(filtro[1]) && angular.isUndefined(filtro[0])) {
                recvData.data = $filter('filter')(recvData.data, {'sim': filtro[1]});
              }
              if (angular.isDefined(filtro[0]) && angular.isDefined(filtro[1])){
                recvData.data = $filter('filter')(recvData.data, {'privateIp': filtro[0],'sim': filtro[1]});
              }
            }

           return  getEquipamentoTerceraPart(recvData.data, cadena);
       }, function(error) {
          $log.error("Error en " + error);
          return error;
       }).then(function(response) {
           recvData.data.forEach(function(elemento) {
             var result = $filter('filter')(response.data.vehicles, {'uid': elemento.uidVehicle});
             if(result.length) {
                 elemento.code = result[0].code;
                 elemento.nameOperator = result[0].nameOperator;
                 elemento.uidOperator = result[0].uidOperator;
                }
            if (elemento.uidVehicle === null && elemento.uidResource !== null && elemento.resourceList.length > 0) {
               elemento.nameOperator = elemento.resourceList[0].nameOperator;
             }
           });
           return recvData.data;
       }, function(error) {
          $log.error("Error en " + error);
          return error;
       });
    }

    function getEquipamentoSegundaPart(datos,cadena){
      var url = constantes.getApiUrl('ips_mng', 'getEquipamentosDos');
      url = url.replace("{0}", cadena);
      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };
      return $http.get(url, config);
    }

    function getEquipamentoTerceraPart(datos,cadena){
      var url = constantes.getApiUrl('ips_mng', 'getEquipamentosTres');
      url = url.replace("{0}", cadena);
      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };
      return $http.get(url, config);
    }

  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('altaEquipamientosService', altaEquipamientosService);

  function altaEquipamientosService($log, $http, $q,constantes, conexion, utilidades) {
    var service = {
      getTiposEquipamientos: getTiposEquipamientos,
      getTiposEquipamientosSubsys: getTiposEquipamientosSubsys,
      getTiposEquipamientosSubsysEdit: getTiposEquipamientosSubsysEdit,
      getFlotas: getFlotas,
      getVehiculos: getVehiculos,
      getRecursos: getRecursos,
      postMasivoEquipamiento: postMasivoEquipamiento,
      postEquipamiento: postEquipamiento,
      putEquipamiento: putEquipamiento,
      deleteEquipamiento: deleteEquipamiento
    };

    return service;

    function getTiposEquipamientos(){
      var url = constantes.getApiUrl('ips_mng', 'getTiposEquipamentos');
      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          elemento.display = elemento.code;
          elemento.value = elemento.code.toLowerCase();
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getTiposEquipamientosSubsys(dtos) {
      var url = constantes.getApiUrl('ips_mng', 'getEquipamentosSubsys');
      url = url.replace("{0}", dtos.id);
      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          elemento.select = false;
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getTiposEquipamientosSubsysEdit(dtos) {
      var url = constantes.getApiUrl('ips_mng', 'getEquipamentosSubsys');
      url = url.replace("{0}", dtos.id);
      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        if (angular.isDefined(dtos.subsystems) && dtos.subsystems !== null) {
            response.data.forEach(function(elemento) {
              for (var i = 0; i < dtos.subsystems.length; i++) {
                if (elemento.code === dtos.subsystems[i].code) {
                  elemento.uid = dtos.subsystems[i].uid;
                  elemento.uidSubsystemType = dtos.subsystems[i].uidSubsystemType;
                  elemento.select = true;
                  break;
                }
              }
            });
          }
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getFlotas() {
      var url = constantes.getApiUrl('ips_corp', 'getCuentasFlotasVehiculos');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          elemento.display = elemento.name;
          elemento.value = elemento.name.toLowerCase();
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getVehiculos(dtos) {
      var url = constantes.getApiUrl('ips_mng', 'getVehiculos');
      url = url.replace("{0}", dtos.uid);
      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.vehicles.forEach(function(elemento) {
          elemento.value = elemento.code.toLowerCase();
        });
        return response.data.vehicles;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getRecursos(dtos) {
      var url = constantes.getApiUrl('ips_mng', 'getVehiculos');
      url = url.replace("{0}", dtos.uid);
      var params = {};
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data.vehicles;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function postMasivoEquipamiento(dtos) {
      var deferred  = $q.defer();
      var promisesAlta = [];
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      for (var i = 0; i < dtos.length; i++) {
        var url = constantes.getApiUrl('ips_mng', 'postEquipamiento');
        url = url.replace("{0}", dtos[i].uidFlota);
        var params = {
          "equipmentId": dtos[i].equipmentId.toLowerCase(),
          "equipmentTypeId": dtos[i].equipmentTypeId,
          "uidVehicle": dtos[i].uidVehicle,
          "updateTime" : dtos[i].updateTime,
          "updateVersion" : dtos[i].updateVersion,
          "subsystems": dtos[i].subsystems
        };
        promisesAlta.push($http.post(url, params, config).then(function(response){
          return response;
        },function(error){
          return error;
        }));
      }
      var theResults = [];
      $q.all(promisesAlta).then(function(result) {
        for (var i = 0; i < result.length; i++) {
          theResults.push(result[i]);
        }
        deferred.resolve(theResults);
      }, function(error) {
        error.error = "Ocurrio un error inesperado";
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function postEquipamiento(dtos,subSys) {
      var url = constantes.getApiUrl('ips_mng', 'postEquipamiento');
      url = url.replace("{0}", dtos.flota.uid);

      var params = {
        "equipmentId": dtos.equipmentId.toLowerCase(),
        "equipmentTypeId": dtos.th.id,
        "updateTime" : dtos.updateTime,
        "updateVersion" : dtos.updateVersion,
        "uidResourceList":  utilidades.isEmpty(dtos, "dtos.vehi") ? dtos.recu.uidResourceList : null,
        "resourceList" : utilidades.isEmpty(dtos, "dtos.vehi") ? dtos.recu.resourceList : null,
        "subsystems": subSys,
        "uidVehicle" : utilidades.isEmpty(dtos, "dtos.vehi") ? null : dtos.vehi.uid
      };

      if(!utilidades.isEmpty(dtos, "dtos.vehi")) {
        params['uidVehicle'] = dtos.vehi.uid
        params['vehicle'] = dtos.vehi
      } else if(!utilidades.isEmpty(dtos, "dtos.resourceList")) {
        params['uidVehicle'] = null
      }
      
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.post(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function putEquipamiento(dtos,subSys){
      var url = constantes.getApiUrl('ips_mng', 'putEquipamiento');
      
      var params = {
        "equipmentId": dtos.equipmentId.toLowerCase(),
        "equipmentTypeId": dtos.th.id,
        "updateTime" : dtos.updateTime,
        "updateVersion" : dtos.updateVersion,
        "highDate" : dtos.highDate,
        "subsystems": subSys,
        "uidResourceList":  utilidades.isEmpty(dtos, "dtos.vehicle") ? dtos.uidResourceList : null,
        "resourceList" : utilidades.isEmpty(dtos, "dtos.vehicle") ? dtos.resourceList : null,
      };
      
      if(!utilidades.isEmpty(dtos, "dtos.vehicle")) {
        params['vehicle'] = dtos.vehicle
        params['uidVehicle'] = dtos.vehicle.uid
      } else if(!utilidades.isEmpty(dtos, "dtos.resource")) {
        params['uidVehicle'] = null
      }

      url = url.replace("{0}", dtos.uidOperator).replace("{1}",dtos.equipmentIdViejo).replace("{2}",dtos.equipmentTypeId);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.put(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function deleteEquipamiento(dtos) {
      var url = constantes.getApiUrl('ips_mng', 'deleteEquipamiento');
      url = url.replace("{0}", dtos.uidOperator);
      url = url.replace("{1}",dtos.equipmentId).replace("{2}",dtos.equipmentTypeId);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.delete(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikEquipamientosManager', datikEquipamientosManager);

  function datikEquipamientosManager() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/equipamientos/directives/tblEquipamientos.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate',
        '$timeout', '$uibModal', '$mdDialog', 'equipamientosService', 'conexion', 'notificaciones', '$q', 'tblCuentasService', 'altaEquipamientosService', 'utilidades', equipamientosManagerController
      ]
    };

    function equipamientosManagerController($log, $scope, $filter, $translate,
      $timeout, $uibModal, $mdDialog, equipamentoService, conexion, notificaciones, $q, tblCuentasService, altaEquipamientosService, utilidades) {

      var vm = this;
      var filtros = "";
      var sort = "";
      var sortDefault = "highDate:desc";
      vm.disabledCSV = true;
      vm.loading = true;
      vm.loadingBoton = false;
      vm.loadingFiltros = false;
      vm.eventoEquipamentoSeleccionado = 'equipamiento-table-change-selection';

      vm.headerEquipamentos = [$translate.instant('Mac'), $translate.instant('Tipo de hardware'), $translate.instant('Cliente'), $translate.instant('Código Vehículo'), $translate.instant('Recurso'), $translate.instant('IP Privada'),
      $translate.instant('IP pública'), $translate.instant('SIM'), $translate.instant('Fecha Alta'), $translate.instant('Actualización'), $translate.instant('Versión'), $translate.instant('Versión requerida'), $translate.instant('Subsistemas')];

      function funcionInfo() {
        $log.info("Info.");
      }

      var disabledNotDisabledDeleteEquipamientos = function (elemento) {
        if (angular.isDefined(elemento)) {
          if (!tblCuentasService.obtinePermisos(9)) {
            vm.permisoEquipamiento = true;
            return true;
          }
        }
      };

      var disabledNotDisabledEditEquipamientos = function (elemento) {
        if (angular.isDefined(elemento)) {
          if (!tblCuentasService.obtinePermisos(9)) {
            vm.permisoEquipamiento = true;
            return true;
          }
        }
      };

      $scope.$on('recuperDtosFormEquipa', function (event, datos) {
        vm.dtosFormEquipa = datos;
      });

      $scope.refrescarEquipamientos = function () {
        vm.loadingBoton = true;
        getEquipamientos(1, 40, filtros, sort);
      };

      $scope.limpiarDtosRecuperadosEquipa = function () {
        vm.dtosFormEquipa = undefined;
      };

      // CREACION DE LA TABLA DE EQUIPAMIENTOS
      vm.tblEquipamientos = {
        contenedor: "tblScrollableComplete",
        maxHeight: "calc(100vh - 260px) !important",
        currentPage: 1,
        perPage: 1000000,
        elements: [{
          title: 'Mac',
          information: 'equipmentId',
          type: 'string'
        }, {
          title: 'Tipo de hardware',
          information: 'tipo',
          type: 'string'
        }, {
          title: 'Cliente',
          information: 'nameOperator',
          type: 'string'
        }, {
          title: 'Código Vehículo',
          information: 'code',
          type: 'string'
        }, {
          title: 'Recurso',
          information: 'codeResource',
          type: 'string'
        }, {
          title: 'IP Privada',
          information: 'privateIp',
          type: 'string'
        }, {
          title: 'SIM',
          information: 'sim',
          type: 'string'
        }, {
          title: 'Fecha Alta',
          information: 'highDate',
          type: 'date'
        }],
        options: {
          title: 'Acciones',
          showTitle: undefined,
          width: undefined,
          buttons: [{
            type: 'tooltip',
            function: funcionInfo
          }, {
            title: 'Editar',
            type: 'edit',
            disabled: disabledNotDisabledEditEquipamientos,
            function: funcionEditarEquipa // , disabled: disabledNotDisabledEditCuenta
          }, {
            title: 'Eliminar',
            type: 'delete',
            disabled: disabledNotDisabledDeleteEquipamientos,
            function: funcionEliminarEquipaDialogo // , disabled: disabledNotDisabledDeleteCuenta
          }]
        },
        selection: {
          mode: 'simple',
          getSelectedElements: undefined,
          changeSelectionEventName: $scope.accountevent
        },
        data: [],
        loadData: function (pages, sizes, filter, sortInicial, flag, deferred) {
          vm.loadingFiltros = true;
          vm.disabledCSV = true;
          var objDtos = {};
          sortInicial = validaSort(sortInicial);
          sort = sortInicial;
          filtros = validaFiltros(filter);
          if (flag == 1) {
            vm.tblEquipamientos.totalCount = 0;
          }
          if (sort === "hightDate:desc") {
            sort = sortDefault;
          }
          equipamentoService.getEquipamientos(pages, sizes, filtros, sort).then(function (data) {
            if (!utilidades.isEmpty(data)) {
              vm.disabledCSV = false;
              vm.loading = false;
              vm.loadingFiltros = false;
              vm.loadingBoton = false;

              // Disable IP Privada y SIM
              angular.element(".c-datik-table-filter-row .c-datik-table-filter:nth-child(6) input").attr("disabled", true);
              angular.element(".c-datik-table-filter-row .c-datik-table-filter:nth-child(7) input").attr("disabled", true);

              if (!utilidades.isEmpty(data.equipments)) {
                data.equipments.forEach(function (value) {
                  vm.tblEquipamientos.data.push(value);
                });
              }

              vm.tblEquipamientos.totalCount = data.totalCount;
              objDtos.dtos = data.equipments;
              objDtos.totalCount = data.totalCount;
            }
            deferred.resolve(objDtos);
          });
          return deferred.promise;
        }
      };

      var tipo = [];
      altaEquipamientosService.getTiposEquipamientos().then(function (data) {
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            tipo.push(data[i].display);
          }
          vm.tblEquipamientos.elements[1].sortArray = tipo;
        }
      }, function (error) {
        $log.info(error);
      });

      function validaSort(sort) {
        var sortCopy = sort.split(":");
        if (sortCopy[0] == "code") {
          return "codeVehicle:" + sortCopy[1];
        }
        return sort;
      }

      function validaFiltros(filter) {
        var filtro = "";
        var filtroDate = "<reg>";
        angular.forEach(filter, function (value, index) {
          if (index == "tipo") {
            index = "equipmentType";
            filtro += index + ":" + value + ",";
          } else if (index == "code") {
            index = "codeVehicle";
            filtro += index + ":" + value + ",";
          } else if (index == "highDate" && (angular.isDefined(value.lower) || angular.isDefined(value.higher))) {
            var valorLower;
            var valorHigher;
            if (angular.isDefined(value.lower)) {
              valorLower = new Date(value.lower) / 1000;
              filtroDate += index + ":" + valorLower + "<reg>";
            } else {
              filtroDate += " <reg>";
            }
            if (angular.isDefined(value.higher)) {
              valorHigher = new Date(value.higher) / 1000;
              filtroDate += index + ":" + valorHigher;
            }
          } else if (index === "privateIp" || index === "sim") {
            filtro += index + "<filtro>" + value + ",";
          } else if (index === "resource") {
            index = "codeResource";
            filtro += index + ":" + value.code + ",";
          } else if (index !== "tipo" && index !== "code" && index !== "highDate" && index !== "resource") {
            filtro += index + ":" + value + ",";
          }
        });

        if (filtro !== "") {
          filtro = filtro.substring(0, filtro.length - 1);
          return filtro + "#" + filtroDate;
        }

        return filtro + "#" + filtroDate;
      }

      vm.exportarDatos = function () {
        vm.loadingCSV = true;
        var deferred = $q.defer();
        var promises = [];
        var registros = 150;
        var maxPaginas = 1;
        if (vm.tblEquipamientos.totalCount > 150) {
          var a = vm.tblEquipamientos.totalCount / 150;
          maxPaginas = Math.ceil(a);
        }

        for (var paginasCSV = 1; paginasCSV <= maxPaginas; paginasCSV++) {
          promises.push(equipamentoService.getEquipamientos(paginasCSV, registros, filtros, sort).then(function (data) {
            return data.equipments;
          })
          );
        }

        var newData = [];
        $q.all(promises).then(function (result) {
          vm.loadingCSV = false;
          for (var k = 0; k < result.length; k++) {
            var elemento = result[k];
            for (var i = 0; i < elemento.length; i++) {
              var publicIp = elemento[i].tooltip[2].name.split(":");
              var version = elemento[i].tooltip[3].name.split(":");
              var subsystmas = "-";
              if (elemento[i].subsystems !== null) {
                if (elemento[i].subsystems.length > 0) {
                  subsystmas = "";
                  for (var j = 0; j < elemento[i].subsystems.length; j++) {
                    subsystmas += elemento[i].subsystems[j].code + " | ";
                  }
                  subsystmas = subsystmas.substring(0, subsystmas.length - 2);
                }
              }
              if (elemento[i].vehicle !== null) {
                newData.push({
                  equipmentId: elemento[i].equipmentId, equipmentType: elemento[i].equipmentType, nameOperator: elemento[i].vehicle.nameOperator, code: elemento[i].vehicle.code, resource: "-",
                  privateIp: equipamentoService.validaVacios(elemento[i].privateIp), publicIp: publicIp[1], sim: equipamentoService.validaVacios(elemento[i].sim), highDate: moment(elemento[i].highDate).format('DD-MM-YYYY'), uidResource: elemento[i].uidResource, version: version[1], updateVersion: elemento[i].updateVersion, subsystems: subsystmas
                });
              } else {
                newData.push({
                  equipmentId: elemento[i].equipmentId, equipmentType: elemento[i].equipmentType, nameOperator: elemento[i].resource.nameOperator, code: "-", resource: elemento[i].resource.code,
                  privateIp: equipamentoService.validaVacios(elemento[i].privateIp), publicIp: publicIp[1], sim: equipamentoService.validaVacios(elemento[i].sim), highDate: moment(elemento[i].highDate).format('DD-MM-YYYY'), uidResource: elemento[i].uidResource, version: version[1], updateVersion: elemento[i].updateVersion, subsystems: subsystmas
                });
              }
            }
          }
          deferred.resolve(newData.flat());
        }, function (error) {
          error.error = "Ocurrio un error inesperado";
          deferred.reject(error);
        });

        return deferred.promise;
      };

      // FUNCION QUE OBTIENE LOS VEHICULOS EXISTENTES
      function getEquipamientos(pages, sizes, filtros, sort) {
        equipamentoService.getEquipamientos(pages, sizes, filtros, sort).then(function (data) {
          vm.loading = false;
          vm.loadingFiltros = false;
          vm.loadingBoton = false;
          if (data.equipments.length > 0) {
            vm.tblEquipamientos.data = data.equipments;
            vm.tblEquipamientos.totalCount = data.totalCount;
            $scope.$broadcast('limpiarDynamicData', data.equipments);
          } else {
            getEquipamientos(pages, sizes, "#<reg>", sort);
          }
        }, function (error) {
          $log.info(error);
          vm.loading = false;
          vm.tblEquipamientos.data = [];
        });
      }

      // FUNCION QUE ABRE EL MODAL DE LA ALTA MASIVA DE UN EQUIPAMIENTOS
      vm.agregarMultiEquipa = function () {
        var elemento = {
          titulo: $translate.instant("Alta múltiple equipamientos")
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/equipamientos/modals/equipamientoMultiple.modal.html',
          controller: 'equipamientoMultipleController as vm',
          // backdrop: 'static',
          q: $q,
          scope: $scope,
          size: 'lg', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function () {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function () {
          vm.loadingBoton = true;
        }, function (dato) {
          $log.info(dato);
        });
      };

      vm.agregarEquipa = function () {
        var elemento = {
          dtosRecupeEquipa: vm.dtosFormEquipa,
          titulo: $translate.instant("Alta de equipamiento")
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/equipamientos/modals/equipamientoAlta.modal.html',
          controller: 'altaEquipamientoController as vm',
          q: $q,
          scope: $scope,
          size: 'md', 
          resolve: {
            datos: function () {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function () {
          vm.loadingBoton = true;
        });
      };

      function funcionEditarEquipa(data) {
        var elemento = {
          element: data,
          titulo: $translate.instant("Modificación de un equipamiento")
        };

        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/equipamientos/modals/equipamientoAlta.modal.html',
          controller: 'editarEquipamientoController as vm',
          q: $q,
          scope: $scope,
          size: 'md',
          resolve: {
            datos: function () {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function () {
          vm.loadingBoton = true;
        });
      }

      function funcionEliminarEquipaDialogo(data) {
        var elemento = {
          titulo: $translate.instant("Eliminación de un equipamiento"),
          element: data
        };
        $mdDialog.show({
          controller: 'eliminarEquipamientoController as vm',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: { scopeDataToPass: $scope },
          resolve: {
            datos: function () {
              return elemento;
            }
          },
          template:
            '<md-dialog md-theme="default" aria-label="{{vm.titulo}}" ng-class="dialog.css" class="_md md-default-theme md-transition-in" role="dialog" tabindex="-1" aria-describedby="dialogContent_0">' +
            '  <md-dialog-content class="md-dialog-content" role="document" tabindex="-1">' +
            '    <h2 class="md-title ng-binding">{{vm.titulo}}</h2>' +
            '    <div class="md-dialog-content-body ng-scope">' +
            '     <p class="ng-binding">{{"¿Está seguro de que quiere dar de baja el equipamiento" | translate}} {{vm.response.equipmentId}}?</p>' +
            '    </div>' +
            '  </md-dialog-content>' +
            '  <md-dialog-actions>' +
            '  <md-button ng-click="vm.close()" class="md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" type="button">' +
            '     {{"Cancelar" | translate }} ' +
            '   </md-button> ' +
            '  <md-button ng-click="vm.aceptarElimEquipa(vm.response)" class="md-primary md-raised md-confirm-button md-button md-ink-ripple md-default-theme" type="button">' +
            '     {{"Eliminar" | translate}}' +
            '  </md-button>' +
            ' </md-dialog-actions>' +
            '</md-dialog>'
        }).then(function () {
          $log.info("Dialog Close Equipments");
        });
      }
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:TblEquipamentosController
   * @description
   * Controller para el menu de Live
   *
   */

  angular
    .module('app')
    .directive('datikEquipamientos', datikEquipamientos);

  function datikEquipamientos() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/equipamientos/directives/mainEquipamientos.html',
      controllerAs: 'vm',
      controller: ['$log', '$translate', '$filter', '$location', '$uibModal',
      'conexion', 'constantes', 'ayuda', 'composicion', '$scope', tblEquipamentosController
      ]
    };

    function tblEquipamentosController ($log, $translate, $filter, $location, $uibModal,
      conexion, constantes, ayuda, composicion, $scope) {

    var vm = this;


    }
  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:equipamientoMultipleController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('equipamientoMultipleController', equipamientoMultipleController);

  function equipamientoMultipleController($log, $uibModalInstance, $scope, datos, $sce, $timeout, notificaciones, $q, $filter, $interval, $translate, recursosService, altaEquipamientosService) {
    var vm = this;
    var _lstFlotas = "";
    var _lstTypeEquip = "";
    var arrayPromesas = [];
    vm.Items = [];
    vm.titulo = datos.titulo;
    vm.response = angular.copy(datos.element);
    vm.loadingAlta = false;
    vm.disabledBtnAlta = true;
    vm.showContent = true;
    vm.progressBar = 1;
    vm.close = function () {
      $uibModalInstance.dismiss();
    };

    vm.loadDatos = function () {
      var inputs = document.querySelectorAll('.input-file');
      inputs[0].addEventListener('change', recorrerDatos, false);
    };

    $interval(function () {
      if (vm.progressBar === 100) {
        vm.progressBar = 1;
      }
      vm.progressBar += 1;
    }, 100, 0, true);

    function recorrerDatos(oEvent) {
      // Get The File From The Input
      var oFile = oEvent.target.files[0];
      // Create A File Reader HTML5
      var reader = new FileReader();

      // Ready The Event For When A File Gets Selected
      reader.onload = function (e) {
        var datos = e.target.result;
        var record = datos.split(/\r\n|\n/);
        vm.disabledBtnAlta = true;
        var json = {};
        for (var i = 1; i < record.length - 1; i++) {
          var data = record[i].split(',');
          var flota = $filter('filter')(_lstFlotas, { 'name': data[4] })[0];
          var flotaUid = flota.uid;
          var typeEquip = $filter('filter')(_lstTypeEquip, { 'code': data[1] })[0];

          var cadena = $translate.instant('Actualización (H)') + " : +" + data[2] + "<br>" +
            $translate.instant('Versión requerida') + " : " + data[3] + "<br>" +
            $translate.instant('Cliente') + " : " + data[4] + "<br>" +
            $translate.instant('Código Vehículo') + " : " + data[5] + "<br>";

          json[i - 1] = {
            equipmentId: data[0], equipmentTypeId: typeEquip.id, typeHardware: data[1], uidFlota: flotaUid, updateTime: data[2], updateVersion: data[3], subsystems: ["core", "mdm"],
            cliente: data[4], codeVehicle: data[5], uidVehicle: "", dtos: 5, status: "", cadena: $sce.trustAsHtml(cadena), message: ""
          };

          vm.Items.push(json[i - 1]);

          arrayPromesas.push(getSubsys(typeEquip, (i - 1), json[i - 1].subsystems));
          arrayPromesas.push(getVehiculos(flota, (i - 1)));

          $q.all(arrayPromesas).then(function (result) {
            if (result.length === arrayPromesas.length) {
              vm.disabledBtnAlta = false;
            }
          });
        }
      };

      reader.readAsText(oFile, 'UTF-8');
      vm.showContent = false;
    }

    vm.cargar = function () {
      vm.loadingAlta = true;
      for (var i = 0; i < vm.Items.length; i++) {
        vm.Items[i].status = 0;
      }
      altaEquipamientosService.postMasivoEquipamiento(vm.Items).then(function (response) {
        $scope.refrescarEquipamientos();
        vm.loadingAlta = false;
        for (var i = 0; i < vm.Items.length; i++) {
          for (var j = 0; j < response.length; j++) {
            if (angular.isDefined(response[j].data)) {
              if (response[j].status === 200) {
                if (vm.Items[i].equipmentId === response[j].data.equipmentId) {
                  vm.Items[i].status = response[j].status;
                  break;
                }
              } else {
                var value = response[j].data.value.split(":");
                if (vm.Items[i].equipmentId + " equipmentTypeId" === value[1].trim()) {
                  vm.Items[i].status = response[j].status;
                  vm.Items[i].message = response[j].data.message;
                  break;
                }
              }
            }
          }
        }
      }, function () {
        vm.loadingAlta = false;
        for (var i = 0; i < vm.Items.length; i++) {
          vm.Items[i].status = 400;
        }
      });

    };

    function getVehiculos(item, posicion) {
      altaEquipamientosService.getVehiculos(item).then(function (data) {
        if (data.length > 0) {
          vm.Items[posicion].uidVehicle = $filter('filter')(data, { 'code': vm.Items[posicion].codeVehicle })[0].uid;
        }
      }, function (error) {
        $log.info(error);
      });
    }

    function getSubsys(item, posicion, subsytemas) {
      var subSys = subsytemas;
      vm.Items[posicion].cadena += $sce.trustAsHtml($translate.instant('Subsytemas') + " : " + subSys);
      altaEquipamientosService.getTiposEquipamientosSubsys(item).then(function (data) {
        var subSystemas = [];
        if (data.length > 0) {
          angular.forEach(data, function (item) {
            for (var i = 0; i < subSys.length; i++) {
              if (subSys[i].trim() === item.code) {
                subSystemas.push({
                  "code": item.code,
                  "uidSubsystemType": item.uid
                });
              }
            }
          });
          vm.Items[posicion].subsystems = subSystemas;
        }
      });
    }

    function getTiposEquipamientos() {
      altaEquipamientosService.getTiposEquipamientos().then(function (data) {
        if (data.length > 0) {
          _lstTypeEquip = data;
        }
      }, function (error) {
        $log.info(error);
      });
    }

    function getFlotas() {
      altaEquipamientosService.getFlotas().then(function (data) {
        if (data.length > 0) {
          _lstFlotas = data;
        }
      }, function (error) {
        $log.info(error);
      });
    }

    getTiposEquipamientos();
    getFlotas();

  }
})();

(function(){
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:eliminarEquipamientoController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('eliminarEquipamientoController', eliminarEquipamientoController);

    function eliminarEquipamientoController($log, $mdDialog,scopeDataToPass, $scope, datos, notificaciones, $q, $translate, altaEquipamientosService){
      var vm = this;
      vm.titulo = datos.titulo;
      vm.response = angular.copy(datos.element);
      vm.close = function() {
        $mdDialog.cancel();
      };

      var EQUIPAMIENTO = $translate.instant("Equipamiento");

      vm.aceptarElimEquipa = function(dato){
        $mdDialog.hide();
        altaEquipamientosService.deleteEquipamiento(dato).then(function(data){
          if(data.status === 204){
            notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("La eliminación de un equipamiento fue realizada correctamente"), "success");
            scopeDataToPass.refrescarEquipamientos();
          }else{
            if (angular.isDefined(data.data.message)) {
              notificaciones.showNotification(data.data.message, $translate.instant("Error al intentar Eliminar un equipamiento"), "error");
            } else {
              notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("Error al intentar Eliminar un equipamiento"), "error");
            }
            scopeDataToPass.refrescarEquipamientos();
          }
        },function(error){
            notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("Error al intentar dar de baja un equipamiento")  + error, "error");
            scopeDataToPass.refrescarEquipamientos();
        });
      };
    }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:editarEquipamientoController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('editarEquipamientoController', editarEquipamientoController);

  function editarEquipamientoController($log, $uibModalInstance, $scope, $q, $timeout, $interval, $translate, datos, notificaciones, $filter, altaEquipamientosService, equipamientosService, recursosService, utilidades) {
    var vm = this;
    var lstDtosTH = "";
    var lstDtosFlota = "";
    var lstDtosVehi = "";
    var lstDtosRecu = "";
    vm.tooltip = "";
    vm.loadingRecuVehi = false;
    vm.checkVehiRecu = false;
    vm.warningVehiRecu = false;

    const TOTEM = 'totem'
    const CARGADOR = 'charger'

    vm.constants = {
      CORE: "core",
      MDM: "mdm",
      ECOASSIST: "ecoassist",
      DCB_LD_3G: "DCB.LD 3G",
      DCB_LD_4G: "DCB.LD 4G"
    };

    vm.titulo = datos.titulo;
    vm.equipaEditDisabled = false;
    vm.equipaShow = false;
    vm.recuDisabled = true;
    vm.simulateQuery = false;
    vm.vehiDisabled = true;
    vm.vehiDisabledEquipa = true;
    vm.switch = true;
    vm.showCheks = true;
    vm.showSinSubsis = false;
    vm.hideAsignation = true;
    vm.asignarVehiculo = true
    vm.selectedRecModel = []
    vm.selectedHwType = datos.element.equipmentType;
    vm.selectedRecModel = datos.element.resourceList
    var lstDtosRecuBack
    var groundMis = false

    function formatTagList(list, model){
      var tmp = []
      list.forEach(function(x) {
        var tag = model.find(function(z){return x.code === z.code})
        if(!utilidades.isEmpty(tag)){
          tmp.push(x)
        }
      })
      return tmp
    }

    vm.onChangeResource = function (recursos){
      vm.equipaDisabled = utilidades.isEmpty(recursos)
      lstDtosRecu = formatTagList(lstDtosRecu, vm.selectedRecModel)
    }

    var EQUIPAMIENTO = $translate.instant("Equipamiento");

    function getEquipamientos() {
      altaEquipamientosService.getTiposEquipamientos().then(function(data) {
        if (data.length > 0) {
          lstDtosTH = data;
        }
      }, function(error) {
        $log.info(error);
      });
    }

    // VALIDA QUE EL CARACTER INGRESADO EN EL INPUT NO TENGA ESPACIOS
    vm.validaEspacios = function(e) {
      var keyCode = e.key;
      if (keyCode == " ") {
        e.preventDefault();
      }
    };

    vm.lowerCase = function(txt) {
      if (angular.isDefined(txt)) {
        vm.response.equipmentId = txt.toLowerCase();
      }
    };

    datos.element.uid = datos.element.uidOperator;
    datos.element.id = datos.element.equipmentTypeId;
    datos.element.equipmentIdViejo = datos.element.equipmentId;

    datos.element.th = {
      display: datos.element.equipmentType,
      value: datos.element.equipmentType.toLowerCase(),
      id: datos.element.equipmentTypeId
    };

    if (datos.element.vehicle !== null) {
      datos.element.flota = {
        display: datos.element.nameOperator,
        value: datos.element.nameOperator.toLowerCase()
      };

      datos.element.vehi = {
        display: datos.element.code,
        value: datos.element.code.toLowerCase(),
        uid: datos.element.uidVehicle,
        code: datos.element.code
      };
      getVehiculo(datos.element);
    }
    
    if (!utilidades.isEmpty(datos.element.uidResourceList)) {
      datos.element.flota = {
        display: datos.element.resourceList[0].nameOperator,
        value: datos.element.resourceList[0].nameOperator.toLowerCase()
      };

      datos.element.recu = {
        display: datos.element.resourceList[0].code,
        value: datos.element.resourceList[0].code.toLowerCase(),
        uidResource: datos.element.resourceList[0].uidResource,
        code: datos.element.resourceList[0].code
      };
      
      getRecursos(datos.element);
    }

    getEquipamientos();
    getTypeSubsysEdit(datos.element);
    getFlota();

    vm.response = angular.copy(datos.element);

    vm.asignarVehiculo = !utilidades.isEmpty(datos.element.uidVehicle)
    vm.onBoard = !vm.asignarVehiculo

    vm.querySearchTH = function(query) {
      return query ? lstDtosTH.filter(function(x){
        return x.value.toLowerCase().includes(query.toLowerCase())
      }) : lstDtosTH
    };

    vm.querySearchFlota = function(query) {
      return query ? lstDtosFlota.filter(function(x){
        return x.value.toLowerCase().includes(query.toLowerCase())
      }) : lstDtosFlota
    };

    vm.querySearchVehi = function(query) {
      return query ? lstDtosVehi.filter(function(x){
        return x.value.toLowerCase().includes(query.toLowerCase())
      }) : lstDtosVehi;
    };

    vm.querySearchRecu = function(query) {
      return query ? lstDtosRecu.filter(function(x){
        return x.value.toLowerCase().includes(query.toLowerCase())
      }) : lstDtosRecu
    };

    function getFlota() {
      altaEquipamientosService.getFlotas().then(function(data) {
        if (data.length > 0) {
          lstDtosFlota = data;
        }
      }, function(error) {
        $log.info(error);
      });
    }

    vm.selectedItemChange = function(item) {
      if (angular.isDefined(item)) {
        getTypeSubsys(item);
      } else {
        vm.showCheks = true;
        vm.showSinSubsis = false;
        vm.response.subsystems = [];
        limpiarAsignar();
      }
    };

    function getTypeSubsys(item) {
      vm.selectedHwType = item.code;
      altaEquipamientosService.getTiposEquipamientosSubsys(item).then(function(data) {
        if (data.length > 0) {
          vm.showCheks = false;
          angular.forEach(data, function(item) {
            if ((item.code === vm.constants.CORE || item.code === vm.constants.MDM) || (item.code === vm.constants.ECOASSIST && (vm.selectedHwType === vm.constants.DCB_LD_3G || vm.selectedHwType === vm.constants.DCB_LD_4G))) {
              item.select = true;
            }

            if ((item.code === vm.constants.CORE || item.code === vm.constants.MDM) || (item.code === vm.constants.ECOASSIST && (vm.selectedHwType === vm.constants.DCB_LD_3G || vm.selectedHwType === vm.constants.DCB_LD_4G))) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
          });
          data = $filter('orderBy')(data, '-select');
          vm.response.subsystems = data;
        } else {
          vm.showCheks = false;
          vm.showSinSubsis = true;
        }
      }, function(error) {
        $log.info(error);
      });
    }
    
    vm.close = function() {
      $uibModalInstance.dismiss();
      vm.selectedRecModel = []
    };

    function limpiarAsignar() {
      vm.vehiDisabledEquipa = true;
      vm.loadingRecuVehi = false;

      vm.warningVehiRecu = false;
      vm.response.recu = undefined;
      vm.recuDisabled = true;
      vm.response.vehi = undefined;
      vm.vehiDisabled = true;
    }

    vm.asignarVehiculoOrecurso = function (){
      if(vm.asignarVehiculo){
        vm.onBoard = true
        vm.response.flota = undefined;
        vm.recuDisabled = true;
        vm.response.vehi = undefined;
      }else{
        vm.onBoard = false
        vm.response.flota = undefined;
      }
      vm.selectedRecModel = []
    }

    function ifGroundResource(recursosList){
      return recursosList.filter(function (x){
        if(groundMis){
          return x.resourceTypeCode === TOTEM
        }
        return x.resourceTypeCode === CARGADOR
      })
    }

    vm.toggleCheck = function(val) {
      groundMis = val.code === "ground_mis" && val.select
      if (val.code === 'ground_mis') {
        if(!utilidades.isEmpty(lstDtosRecuBack)){
          lstDtosRecu = ifGroundResource(lstDtosRecuBack)
        }
        for (var i = 0; i < vm.response.subsystems.length; i++) {
          if (vm.response.subsystems[i].code === "onboard_mis") {
            vm.response.subsystems[i].select = false;
            vm.selectedRecModel = []
            break;
          }
        }
      } else if (val.code === "onboard_mis") {
        for (var j = 0; j < vm.response.subsystems.length; j++) {
          if (vm.response.subsystems[j].code === "ground_mis") {
            vm.response.subsystems[j].select = false
            break;
          }
        }
      }
    };

    function getTypeSubsysEdit(item) {
      altaEquipamientosService.getTiposEquipamientosSubsysEdit(item).then(function(data) {
        if (data.length > 0) {
          vm.showCheks = false;
          angular.forEach(data, function(item) {
            if ((item.code === vm.constants.CORE || item.code === vm.constants.MDM) || (item.code === vm.constants.ECOASSIST && (vm.selectedHwType === vm.constants.DCB_LD_3G || vm.selectedHwType === vm.constants.DCB_LD_4G))) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
          });
          data = $filter('orderBy')(data, ['select', '-disabled']);
          vm.response.subsystems  = data
        } else {
          vm.showCheks = false;
          vm.showSinSubsis = true;
        }
      }, function(error) {
        $log.info(error);
      });
    }

    vm.selectedItemChangeFlota = function(item) {
      vm.selectedRecModel = []
      if (angular.isDefined(item)) {
        vm.vehiDisabledEquipa = false;
        if (!vm.onBoard) {
          altaEquipamientosService.getVehiculos(item).then(function(data) {
            if (angular.isDefined(data) && data.length > 0) {
              lstDtosVehi = data;
              vm.vehiDisabled = false;
              vm.vehiDisabledEquipa = true;
            } else if (data.length <= 0) {
              lstDtosVehi = "";
              vm.vehiDisabled = true;
              vm.vehiDisabledEquipa = true;
            }
          }, function(error) {
            $log.info(error);
          });
        } else {
          recursosService.getRecursosEquipamiento(item).then(function(data) {
            if (angular.isDefined(data.content) && data.content.length > 0) {
              lstDtosRecuBack = data.content
              lstDtosRecu = ifGroundResource(lstDtosRecuBack)
              console.log(lstDtosRecu)
              vm.lstDtosRecu = lstDtosRecu
              vm.recuDisabled = false;
              vm.vehiDisabledEquipa = true;
            } else if (data.length <= 0) {
              lstDtosRecu = "";
              vm.recuDisabled = true;
              vm.vehiDisabledEquipa = true;
            }

          }, function(error) {
            $log.info(error);
          });
        }
      } else {
        vm.vehiDisabled = true;
        vm.selectedItemVehi = null;
        vm.searchVehi = "";
        vm.response.projectFormEquipa.autocompleteVehi.$setUntouched();
        vm.response.projectFormEquipa.autocompleteVehi.$setPristine();

        vm.vehiDisabledEquipa = true;

        vm.recuDisabled = true;
        vm.selectedItemRecu = null;
        vm.searchRecu = "";
      }
    };

    function getVehiculo(item) {
      altaEquipamientosService.getVehiculos(item).then(function(data) {
        if (data.length > 0) {
          lstDtosVehi = data;
          vm.vehiDisabled = false;
          vm.vehiDisabledEquipa = true;
        }
      }, function(error) {
        $log.info(error);
      });
    }

    function includesGroundMis(element){
      if(!utilidades.isEmpty(element.subsystems)){
        groundMis = element.subsystems.some(function (x){return x.code === 'ground_mis'})
      }
    }

    // ESTE VA TRONAR CADA VEZ QUE ENTRES A CON EL ID DEL RECURSO YA QUE NO ES LA API DE RECURSOS ES LA DE VEHICULOS
    function getRecursos(item) {
      if (!utilidades.isEmpty(utilidades)) {
        recursosService.getRecursosEquipamiento(item).then(function(data) {
          if (!utilidades.isEmpty(data.content)) {
            lstDtosRecuBack = data.content
            lstDtosRecu = ifGroundResource(lstDtosRecuBack)
            vm.lstDtosRecu = lstDtosRecu
            vm.recuDisabled = false;
            vm.vehiDisabledEquipa = true;
          }
        }, function(error) {
          $log.info(error);
        });
      } else {
        vm.recuDisabled = true;
        vm.selectedItemRecu = null;
        vm.searchRecu = "";
      }
    }

    $interval(function() {
      var dtos = vm.response;
      if (angular.isDefined(dtos.projectFormEquipa)) {
        if (angular.isUndefined(dtos.equipmentId)) {
          vm.equipaEditDisabled = true;
          return;
        }

        if (dtos.th === null) {
          vm.equipaEditDisabled = true;
          return;
        }

        if (angular.isUndefined(dtos.updateTime)) {
          vm.equipaEditDisabled = true;
          return;
        }

        if (angular.isUndefined(dtos.flota) || dtos.flota === null) {
          vm.equipaEditDisabled = true;
          return;
        }

        if (!vm.onBoard) {
          if (angular.isUndefined(dtos.vehi) || dtos.vehi === null) {
            vm.equipaEditDisabled = true;
            return;
          }
        } else {
          if (angular.isUndefined(dtos.recu) || dtos.recu === null) {
            vm.equipaEditDisabled = true;
            return;
          }
        }

        if (vm.loadingRecuVehi === true) {
          vm.equipaEditDisabled = true;
          return;
        }

        vm.equipaEditDisabled = false;

      }
    }, 500);

    vm.selectedItemChangeVehiculoRecurso = function(item, val) {
      var valor = val;
      var cadena = "";
      vm.styleWarningCheck = "";
      if (angular.isDefined(item)) {
        vm.loadingRecuVehi = true;
        equipamientosService.numeroRecuVehi(item, val).then(function(data) {
          vm.loadingRecuVehi = false;
          if (angular.isDefined(data)) {
            if (data.equipments.length > 0) {
              vm.styleWarningCheck = "inputWarning";
              vm.checkVehiRecu = false;
              vm.warningVehiRecu = true;
              data.equipments.forEach(function(response) {
                cadena += response.equipmentId + ", ";
              });
              cadena = cadena.substring(0, cadena.length - 2);
              if (valor === 1) {
                vm.tooltip = $translate.instant("El recurso seleccionado ya tiene equipamientos asociados") + "  " + cadena;
              } else {
                vm.tooltip = $translate.instant("El vehículo seleccionado ya tiene equipamientos asociados") + "  " + cadena;
              }
            } else {
              vm.styleWarningCheck = "inputSuccess";
              vm.checkVehiRecu = true;
              vm.warningVehiRecu = false;
            }
          } else {
            vm.loadingRecuVehi = false;
            vm.checkVehiRecu = false;
            vm.warningVehiRecu = false;
          }
        });
      } else {
        vm.loadingRecuVehi = false;
        vm.checkVehiRecu = false;
        vm.warningVehiRecu = false;
      }
    };

    function stringifyRecuUid(list){
      return list.map(function(element) {
        return element.uidResource
      });
    }

    function formatearVehiculo(vehicle){
      return {
        "id" : vehicle.id,
        "uid" : vehicle.uid,
        "code" : vehicle.code,
        "registration" : vehicle.registration,
        "model" : vehicle.model,
        "type" : vehicle.type,
        "velMax" : vehicle.velMax,
        "deposit" : vehicle.deposit,
        "idOperator" : vehicle.idOperator,
        "uidOperator" : vehicle.uidOperator,
        "idHeadquarters" : vehicle.idHeadquarters,
        "idGroupType" : vehicle.idGroupType
      }
    }

    function formatResource(resource) {
      return {
        'uidResource' : resource.uidResource,
        'nameOperator' : resource.client,
        'code' : resource.code,
        'resourceTypeCode' : resource.resourceTypeCode,
        'uidOperator' : resource.uidClient,
      }
    }

    vm.editEquipamiento = function(datos) {
      var subSys = [];
      $uibModalInstance.dismiss();
      if (angular.isDefined(datos.subsystems)) {
        datos.subsystems.forEach(function(elemento) {
          if (elemento.select && angular.isDefined(elemento.uidSubsystemType)) {
            subSys.push({
              "uid": elemento.uid,
              "code": elemento.code,
              "uidSubsystemType": elemento.uidSubsystemType
            });
          } else if (elemento.select) {
            subSys.push({
              "code": elemento.code,
              "uidSubsystemType": elemento.uid
            });
          }
        });
      }
      
      if(utilidades.isEmpty(vm.selectedRecModel)){
        datos['vehicle'] = formatearVehiculo(datos.vehi)
        datos.uidOperator = (!utilidades.isEmpty(datos.vehi.uidOperator)) ? datos.vehi.uidOperator : datos.uidOperator;
      }else{
        datos.uidVehicle = null
        datos['vehicle'] = null
        datos.uidResourceList = stringifyRecuUid(vm.selectedRecModel)
        datos.resourceList = vm.selectedRecModel.map(function (rec){
          return formatResource(rec)
        })
        if(!utilidades.isEmpty(datos.resourceList)) {
          var uidOpe = datos.resourceList[0].uidOperator;
          if(!utilidades.isEmpty(uidOpe)) {
              datos.uidOperator = uidOpe;
          }
        }
      }

      altaEquipamientosService.putEquipamiento(datos, subSys).then(function(data) {
        if (data.status === 200) {
          notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("La modificación del Equipamiento fue realizada correctamente"), "success");
          $scope.refrescarEquipamientos();
        } else {
          notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("Error al intentar hacer una modificación de un equipamiento"), "error");
          $scope.refrescarEquipamientos();
        }
      }, function(error) {
        notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("Error al intentar hacer una modificación de un equipamiento") + error, "error");
      });
    };

    vm.disableMac = true;
    includesGroundMis(datos.element)
  }
}());
(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:altaEquipamientoController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('altaEquipamientoController', altaEquipamientoController);

  function altaEquipamientoController($log, $uibModalInstance, $scope, $q, $timeout, $interval, datos, notificaciones, $filter, $translate, altaEquipamientosService, equipamientosService, recursosService, utilidades) {
    var vm = this;
    var lstDtosTH
    var lstDtosFlota
    var lstDtosVehi
    var lstDtosRecu

    const TOTEM = 'totem'
    const CARGADOR = 'charger'

    vm.tooltip = "";
    vm.loadingRecuVehi = false;
    vm.checkVehiRecu = false;
    vm.warningVehiRecu = false;
    
    vm.constants = {
      CORE: "core",
      MDM: "mdm",
      ECOASSIST: "ecoassist",
      DCB_LD_3G: "DCB.LD 3G",
      DCB_LD_4G: "DCB.LD 4G"
    };

    vm.titulo = datos.titulo;
    vm.equipaShow = true;
    vm.onBoard = false;
    vm.recuDisabled = true;
    vm.equipaDisabled = true;
    vm.simulateQuery = false;
    vm.vehiDisabled = true;
    vm.vehiDisabledEquipa = true;
    vm.switch = true;
    vm.hideAsignation = false;
    vm.showCheks = true;
    vm.showSinSubsis = false;
    vm.lstDtosVehi
    vm.selectedRecModel = []
    vm.recursos = []
    var lstDtosRecuBack
    var groundMis = false

    var EQUIPAMIENTO = $translate.instant("Equipamiento");
    vm.asignarVehiculo = true

    function formatTagList(list, model){
      var tmp = []
      list.forEach(function(x) {
        if(model.every(function(z){ return x.code !== z.code })){
          tmp.push(x)
        }
      })
      return tmp
    }
    
    vm.onChangeResource = function (recursos){
      vm.equipaDisabled = utilidades.isEmpty(recursos)
      /* tieneRecoursos = utilidades.isEmpty(vm.selectedRecModel) */
      lstDtosRecu = formatTagList(lstDtosRecu, vm.selectedRecModel)
    }

    // updateTime debe ser +1 por defecto
    vm.response = {
      updateTime: "+1"
    };

    vm.asignarVehiculoOrecurso = function (){
      if(vm.asignarVehiculo){
        vm.onBoard = true
        vm.response.flota = undefined;
        vm.recuDisabled = true;
        vm.response.vehi = undefined;
      }else{
        vm.onBoard = false
        vm.response.flota = undefined;
      }
    }
    
    function ifGroundResource(recursosList){
      return recursosList.filter(function (x){
        if(groundMis){
          return x.resourceTypeCode === TOTEM
        }
        return x.resourceTypeCode === CARGADOR
      })
    }

    // VALIDA QUE EL CARACTER INGRESADO EN EL INPUT NO TENGA ESPACIOS
    vm.validaEspacios = function(e) {
      var keyCode = e.key;
      if (keyCode == " ") {
        e.preventDefault();
      }
    };

    vm.lowerCase = function(txt) {
      if (angular.isDefined(txt)) {
        vm.response.equipmentId = txt.toLowerCase();
      }
    };

    if (angular.isDefined(datos.dtosRecupeEquipa)) {
      var flag = true;
      vm.response = angular.copy(datos.dtosRecupeEquipa);
      if (angular.isDefined(vm.response.equipmentId) && angular.isDefined(vm.response.th) && angular.isDefined(vm.response.updateTime) &&
        angular.isDefined(vm.response.flota) && ((angular.isDefined(vm.response.vehi) && vm.response.vehi !== null) || (angular.isDefined(vm.response.recu) && vm.response.recu !== null))) {
        vm.equipaDisabled = false;
      } else {
        vm.equipaDisabled = true;
      }

      if (angular.isDefined(vm.response.subsystems)) {
        for (var i = 0; i < vm.response.subsystems.length; i++) {
          if (vm.response.subsystems[i].code === "ground_mis" && vm.response.subsystems[i].select === true) {
            if (angular.isDefined(vm.response.flota) && vm.response.flota !== null) {
              vm.recuDisabled = false;
              getRecursos(vm.response.flota);
            }
            flag = false;
            break;
          }
        }
      }

      if (flag && angular.isDefined(vm.response.flota) && vm.response.flota !== null) {
        vm.vehiDisabled = false;
        getVehiculos(vm.response.flota);
      }

      if (angular.isDefined(vm.response.vehi) && vm.response.vehi !== null) {
        vm.loadingRecuVehi = true;
        validaVehiRecu(vm.response.vehi, 0);
      } else if (angular.isDefined(vm.response.recu) && vm.response.recu !== null) {
        vm.loadingRecuVehi = true;
        validaVehiRecu(vm.response.recu, 1);
      }

      if (angular.isDefined(vm.response.subsystems) && vm.response.subsystems !== null && vm.response.subsystems.length > 0) {
        vm.showCheks = false;
      } else {
        vm.showCheks = true;
      }
    }

    vm.querySearchTH = function(query) {
      return query ? lstDtosTH.filter(function(x){
        return x.value.toLowerCase().includes(query.toLowerCase())
      }) : lstDtosTH
    };

    vm.querySearchFlota = function(query) {
      return query ? lstDtosFlota.filter(function(x){
        return x.value.toLowerCase().includes(query.toLowerCase())
      }) : lstDtosFlota
    };

    vm.querySearchVehi = function(query) {
      return query ? lstDtosVehi.filter(function(x){
        return x.value.toLowerCase().includes(query.toLowerCase())
      }) : lstDtosVehi;
    };

    vm.querySearchRecu = function(query) {
      return query ? lstDtosRecu.filter(function(x){
        return x.value.toLowerCase().includes(query.toLowerCase())
      }) : lstDtosRecu
    };

    function getEquipamientos() {
      altaEquipamientosService.getTiposEquipamientos().then(function(data) {
        if (data.length > 0) {
          lstDtosTH = data;
        }
      }, function(error) {
        $log.info(error);
      });
    }

    function getFlota() {
      altaEquipamientosService.getFlotas().then(function(data) {
        if (data.length > 0) {
          lstDtosFlota = data;
        }
      }, function(error) {
        $log.info(error);
      });
    }

    vm.selectedHwType = null;
    vm.selectedItemChange = function(item) {
      if (angular.isDefined(item)) {
        vm.selectedHwType = item.code;
        altaEquipamientosService.getTiposEquipamientosSubsys(item).then(function(data) {
          if (data.length > 0) {
            vm.showCheks = false;
            angular.forEach(data, function(item) {
              if ((item.code === vm.constants.CORE || item.code === vm.constants.MDM) || (item.code === vm.constants.ECOASSIST && (vm.selectedHwType === vm.constants.DCB_LD_3G || vm.selectedHwType === vm.constants.DCB_LD_4G))) {
                item.select = true;
              }

              if ((item.code === vm.constants.CORE || item.code === vm.constants.MDM) || (item.code === vm.constants.ECOASSIST && (vm.selectedHwType === vm.constants.DCB_LD_3G || vm.selectedHwType === vm.constants.DCB_LD_4G))) {
                item.disabled = true;
              } else {
                item.disabled = false;
              }
            });
            data = $filter('orderBy')(data, '-select');
            vm.response.subsystems = data;
          } else {
            vm.showCheks = false;
            vm.showSinSubsis = true;
          }
        }, function(error) {
          $log.info(error);
        });
      } else {
        vm.showCheks = true;
        vm.showSinSubsis = false;
        vm.response.subsystems = [];
        limpiarAsignar();
      }
    };
    
    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    function limpiarAsignar() {
      vm.vehiDisabledEquipa = true;
      vm.loadingRecuVehi = false;

      vm.warningVehiRecu = false;
      vm.response.recu = undefined;
      vm.recuDisabled = true;
      vm.response.vehi = undefined;
      vm.vehiDisabled = true;
      vm.response.flota = undefined;

      vm.searchFlota = "";
    }

    vm.toggleCheck = function(val) {
      groundMis = val.code === "ground_mis" && val.select
      if (val.code === "ground_mis") {
        if(!utilidades.isEmpty(lstDtosRecuBack)){
          lstDtosRecu = ifGroundResource(lstDtosRecuBack)
        }
        for (var i = 0; i < vm.response.subsystems.length; i++) {
          if (vm.response.subsystems[i].code === "onboard_mis") {
            vm.response.subsystems[i].select = false;
            vm.response.flota = undefined;
            vm.recuDisabled = true;
            vm.response.vehi = undefined;
            i = vm.response.subsystems.length
          }
        }
      } else {
        if (val.code === "onboard_mis"){
          
          for (var j = 0; j < vm.response.subsystems.length; j++) {
            if (vm.response.subsystems[j].code === "ground_mis") {
              vm.response.subsystems[j].select = false;
              vm.response.flota = undefined;
              vm.vehiDisabled = true;
              vm.response.recu = undefined;
              j = vm.response.subsystems.length
            }
          }
        }
        limpiarAsignar();
      }
    };

    vm.selectedItemChangeFlota = function(item) {
      if (angular.isDefined(item)) {
        vm.vehiDisabledEquipa = false;
        if (!vm.onBoard) {
          altaEquipamientosService.getVehiculos(item).then(function(data) {
            if (!utilidades.isEmpty(data)) {
              lstDtosVehi = data;
              vm.vehiDisabled = false;
              vm.vehiDisabledEquipa = true;
            } else if (data.length <= 0) {
              lstDtosVehi = "";
              vm.vehiDisabled = true;
              vm.vehiDisabledEquipa = true;
            }
          }, function(error) {
            $log.info(error);
          });
        } else {
          recursosService.getRecursosEquipamiento(item).then(function(data) {
            if (!utilidades.isEmpty(data, "data.content")) {
              lstDtosRecuBack =  data.content
              lstDtosRecu = ifGroundResource(lstDtosRecuBack)
              vm.lstDtosRecu = lstDtosRecu
              vm.recuDisabled = false;
              vm.vehiDisabledEquipa = true;
            } else {
              lstDtosRecu = "";
              vm.recuDisabled = true;
              vm.vehiDisabledEquipa = true;
            }

          }, function(error) {
            $log.info(error);
          });
        }
      } else {
        vm.vehiDisabled = true;
        vm.searchVehi = "";
        vm.vehiDisabledEquipa = true;
        vm.recuDisabled = true;
        vm.searchRecu = "";
      }
    };

    function validaVehiRecu(item, val) {
      var valor = val;
      var cadena = "";
      vm.styleWarningCheck = "";
      if (angular.isDefined(item)) {
        vm.loadingRecuVehi = true;
        equipamientosService.numeroRecuVehi(item, val).then(function(data) {
          vm.loadingRecuVehi = false;
          if (angular.isDefined(data)) {
            if (data.equipments.length > 0) {
              vm.styleWarningCheck = "inputWarning";
              vm.checkVehiRecu = false;
              vm.warningVehiRecu = true;
              data.equipments.forEach(function(response){
                cadena += response.equipmentId + ", ";
              });
              cadena = cadena.substring(0,cadena.length - 2);
              if (valor === 1) {
                vm.tooltip = $translate.instant("El recurso seleccionado ya tiene equipamientos asociados") + "  " + cadena;
              } else {
                vm.tooltip = $translate.instant("El vehículo seleccionado ya tiene equipamientos asociados") + "  " + cadena;
              }
            } else {
              vm.styleWarningCheck = "inputSuccess";
              vm.checkVehiRecu = true;
              vm.warningVehiRecu = false;
            }
          } else {
            vm.loadingRecuVehi = false;
            vm.checkVehiRecu = false;
            vm.warningVehiRecu = false;
          }
        });
      }
    }

    vm.selectedItemChangeVehiculoRecurso = function(item, val) {
      var valor = val;
      var cadena = "";
      vm.styleWarningCheck = "";
      if (angular.isDefined(item)) {
        vm.loadingRecuVehi = true;
        equipamientosService.numeroRecuVehi(item, val).then(function(data) {
          vm.loadingRecuVehi = false;
          if (angular.isDefined(data)) {
            if (data.equipments.length > 0) {
              vm.styleWarningCheck = "inputWarning";
              vm.checkVehiRecu = false;
              vm.warningVehiRecu = true;
              data.equipments.forEach(function(response){
                cadena += response.equipmentId + ", ";
              });
              cadena = cadena.substring(0,cadena.length - 2);
              if (valor === 1) {
                vm.tooltip = $translate.instant("El recurso seleccionado ya tiene equipamientos asociados") + "  " + cadena;
              } else {
                vm.tooltip = $translate.instant("El vehículo seleccionado ya tiene equipamientos asociados") + "  " + cadena;
              }
            } else {
              vm.styleWarningCheck = "inputSuccess";
              vm.checkVehiRecu = true;
              vm.warningVehiRecu = false;
            }
          } else {
            vm.styleWarningCheck = "";
            vm.loadingRecuVehi = false;
            vm.checkVehiRecu = false;
            vm.warningVehiRecu = false;
          }
        });
      } else {
        vm.loadingRecuVehi = false;
        vm.checkVehiRecu = false;
        vm.warningVehiRecu = false;
      }
    };

    function getVehiculos(item) {
      if (angular.isDefined(item)) {
        altaEquipamientosService.getVehiculos(item).then(function(data) {
          if (!utilidades.isEmpty(data)) {
            lstDtosVehi = data;
          } else {
            vm.vehiDisabled = true;
          }
        }, function(error) {
          $log.info(error);
        });
      } else {
        vm.vehiDisabled = true;
        vm.searchVehi = "";
      }
    }

    function getRecursos(item) {
      if (angular.isDefined(item)) {
        recursosService.getRecursosEquipamiento(item).then(function(data) {
          if (angular.isDefined(data.content) && data.content.length > 0) {
            lstDtosRecu = data.content;
            vm.lstDtosRecu = lstDtosRecu
          }  else {
            vm.recuDisabled = true;
          }
        }, function(error) {
          $log.info(error);
        });
      } else {
        vm.recuDisabled = true;
        vm.searchRecu = "";
      }
    }

    $interval(function() {
      var dtos = vm.response;
      if (angular.isDefined(dtos.projectFormEquipa)) {

        if (angular.isUndefined(dtos.equipmentId)) {
          vm.equipaDisabled = true;
          return;
        }

        if (dtos.th === null) {
          vm.equipaDisabled = true;
          return;
        }

        if (angular.isUndefined(dtos.updateTime)) {
          vm.equipaDisabled = true;
          return;
        }

        if (angular.isUndefined(dtos.flota) || dtos.flota === null) {
          vm.equipaDisabled = true;
          return;
        }

        if (!vm.onBoard) {
          if (angular.isUndefined(dtos.vehi) || dtos.vehi === null) {
            vm.equipaDisabled = true;
            return;
          }
        } else {
          if (angular.isUndefined(dtos.recu) || dtos.recu === null) {
            vm.equipaDisabled = true;
            return;
          }
        }
        
        if (vm.loadingRecuVehi === true) {
          vm.equipaDisabled = true;
          return;
        }

        vm.equipaDisabled = false;

      }
    }, 500);

    $interval(function() {
      var datos = vm.response;
      $scope.$emit("recuperDtosFormEquipa", datos);
    }, 500);

    function stringifyRecuUid(list){
      return list.map(function(element) {
        /* element.idOperator =  */
        element.uidOperator = element.uidClient
        delete element.uidClient
        delete element.client
        delete element.display
        delete element.value
        return element.uidResource
      });
    }

    function formatearVehiculo(vehicle){
      return {
        "id" : vehicle.id,
        "uid" : vehicle.uid,
        "code" : vehicle.code,
        "registration" : vehicle.registration,
        "model" : vehicle.model,
        "type" : vehicle.type,
        "velMax" : vehicle.velMax,
        "deposit" : vehicle.deposit,
        "idOperator" : vehicle.idOperator,
        "uidOperator" : vehicle.uidOperator,
        "idHeadquarters" : vehicle.idHeadquarters,
        "idGroupType" : vehicle.idGroupType
      }
    }

    vm.altaEquipamiento = function(datos) {
      var subSys = [];
      $uibModalInstance.dismiss();
      if (!utilidades.isEmpty(datos.subsystems)) {
        datos.subsystems.forEach(function(elemento) {
          if (elemento.select) {
            subSys.push({
              "code": elemento.code,
              "uidSubsystemType": elemento.uid
            });
          }
        });
      }

      if(vm.asignarVehiculo){
        datos.vehi = formatearVehiculo(datos.vehi)
        datos['type'] = 'vehicle'
      }else{
        datos.recu = {
          resourceList : vm.selectedRecModel,
          uidResourceList : stringifyRecuUid(vm.selectedRecModel)
        }
        datos['type'] = 'recurso'
      }

      altaEquipamientosService.postEquipamiento(datos, subSys).then(function(data) {
        $scope.limpiarDtosRecuperadosEquipa();
        if (data.status === 200) {
          notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("El alta del Equipamiento fue realizada correctamente"), "success");
          $scope.refrescarEquipamientos();
        } else {
          if (angular.isDefined(data.data.message)) {
            notificaciones.showNotification(data.data.message, $translate.instant("Error al intentar dar de alta un equipamiento"), "error");
          } else {
            notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("Error al intentar dar de alta un equipamiento"), "error");
          }
          $scope.refrescarEquipamientos();
        }
      }, function(error) {
        notificaciones.showNotification(EQUIPAMIENTO, "Error al intentar dar de alta un equipamiento" + error, "error");
        $scope.refrescarEquipamientos();
      }).catch(function () {
        notificaciones.showNotification(EQUIPAMIENTO, $translate.instant("Error al intentar dar de alta un equipamiento"), "error")
      });

    };

    setTimeout(function() {
      getEquipamientos();
      getFlota();
    }, 0);
  }
}());

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('vinculacionService', vinculacionService);

  function vinculacionService($log, $http, $window, $q, $timeout, constantes, $translate, conexion) {
    var service = {
      getVinculaciones: getVinculaciones,
      deleteVinculacion: deleteVinculacion,
      addVinculacion: addVinculacion
    };

    return service;

    // FUNCION QUE OBTIENE LAS VICUALCIONES DEPENDIENDO DE LA CUENTA SELECCIONADA
    function getVinculaciones(cuenta) {
      var url = constantes.getApiUrl('ips_corp', 'getVinculaciones');
      url = url.replace("{0}",cuenta.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          if (elemento.type == 1) {
            elemento.tipo = $translate.instant("Flota");
            elemento.hideBtn = true;
          } else if (elemento.type == 2) {
            elemento.tipo = $translate.instant("Organización");
          }
        });
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE ELIMINA UNA VICULACION DE LA CUENTA SELECCIONADA
    function deleteVinculacion(data) {
      var url = constantes.getApiUrl('ips_corp', 'deleteVinculacion');
      if (angular.isDefined(data.eliminacionFlota) && data.eliminacionFlota === true) {
        url = url.replace("{0}",data.uid).replace("{1}",data.cuenta.uid);
      } else {
        url = url.replace("{0}",data.cuenta.uid).replace("{1}",data.uid);
      }

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.delete(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE AGREGA UNA VICULACION DE LA CUENTA SELECCIONADA
    function addVinculacion(data) {
      var url = constantes.getApiUrl('ips_corp', 'addVinculacion');
      url = url.replace("{0}",data.cuenta).replace("{1}",data.cuentaVinculacion.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.post(url, "" ,config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('usuariosService', usuariosService);

  function usuariosService($log, $http, $window, $q, $timeout, moment, $filter, constantes, conexion) {
    var cancelerCuentas;
    var service = {
      getCuentasUsuarios: getCuentasUsuarios,
      altaUsuario: altaUsuario,
      deleteUsuario: deleteUsuario,
      editUsuario: editUsuario,
      getBsqUsuarios: getBsqUsuarios,
      getUsers: getUsers
    };

    return service;

    // FUNCION QUE OBTIENE UN LISTADO DE USUARIOS DEPENDIENDO LA CUENTA SELECCIONADA
    function getCuentasUsuarios(cuentaSelec) {
      if (angular.isDefined(cancelerCuentas) && cancelerCuentas !== null) {
        cancelerCuentas.resolve();
      }
      cancelerCuentas = $q.defer();
      var url = constantes.getApiUrl('ips_authorization', 'cuentasUsu');
      url = url.replace("{0}", cuentaSelec.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: cancelerCuentas.promise
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        cancelerCuentas = null;
        response.data.forEach(function(response) {
          var fecha = (response.initDate).substring(0, 10);
          fecha = fecha.split("-");
          response.fecha = fecha[2] + "-" + fecha[1] + "-" + fecha[0];
        });
        return response.data;
      }

      function errorFunction(error) {
        error.cancel = true;
        return error;
      }
    }

    // FUNCION QUE GUARDA UNA USUARIO
    function altaUsuario(data) {
      var url = constantes.getApiUrl('ips_authorization', 'altaUsu');
      url = url.replace("{0}", data.cuenta).replace("{1}", data.language);
      var params = {
        name: data.name,
        surname: data.surname,
        email: data.email,
        telephone: data.telephone
      };

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.post(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE ELIMINA UN USUARIO
    function deleteUsuario(data) {
      var url = constantes.getApiUrl('ips_authorization', 'eliminarUsu');
      url = url.replace("{0}", data.cuenta).replace("{1}", data.id);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.delete(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE EDITA UNA USUARIO
    function editUsuario(data) {
      var url = constantes.getApiUrl('ips_authorization', 'editUsu');
      url = url.replace("{0}", data.cuenta).replace("{1}", data.id);
      var params = {
        name: data.name,
        surname: data.surname,
        email: data.email,
        telephone: data.telephone,
        uidOperator: data.account.uid,
      };
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.put(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getBsqUsuarios(dato) {
      var url = constantes.getApiUrl('ips_authorization', 'getBsqUsuarios');
      if (dato !== "") {
        url += "?userName=" + dato;
      }
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          elemento.display = elemento.username;
          elemento.value = elemento.username.toLowerCase();
        });
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getUsers() {
      var url = constantes.getApiUrl('ips_authorization', 'getUser');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };


      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          elemento.profilesLegacy = $filter('orderBy')(elemento.profilesLegacy, 'profileId', false);

          elemento.cadenaCode = "";
          elemento.tooltip = [];
          elemento.cadenaCodeLegacy = "";
          elemento.cadenaProfileLegacy = "";

          elemento.user.fecha = moment(elemento.user.initDate).format('DD-MM-YYYY');

          if (elemento.profiles.length > 0) {
            elemento.profiles.forEach(function(elemenProfile) {
              elemento.cadenaCode += elemenProfile.code + " | ";
            });
            elemento.cadenaCode = elemento.cadenaCode.substring(0,elemento.cadenaCode.length-2);
          }

          if (elemento.profilesLegacy.length > 0) {
            elemento.profilesLegacy.forEach(function(elemenProfile) {
              elemento.cadenaProfileLegacy += elemenProfile.profileId + " - ";
              elemento.tooltip.push({name:elemenProfile.code});
            });

            elemento.cadenaCodeLegacy = elemento.cadenaCodeLegacy.substring(0,elemento.cadenaCodeLegacy.length-2);
            elemento.cadenaProfileLegacy = elemento.cadenaProfileLegacy.substring(0,elemento.cadenaProfileLegacy.length-2);
          }

        });
        return response.data;
      }

      function errorFunction(error) {
        return error;
      }
    }

  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('permisosLegacyService', permisosLegacyService);

  function permisosLegacyService($log, $http, $window, $q, $timeout, constantes, conexion) {
    var cancelerUsuario;
    var service = {
      getPermisosLegacy: getPermisosLegacy,
      putPermisoUser: putPermisoUser,
      deletePermisoUser: deletePermisoUser
    };

    return service;

    // FUNCION QUE OBTIENE LOS PERMISOS EXISTENTES
    function getPermisosLegacy(cuenta, usuario) {
      if (angular.isDefined(cancelerUsuario) && cancelerUsuario !== null) {
        cancelerUsuario.resolve();
      }

      cancelerUsuario = $q.defer();

      var deferred = $q.defer();
      var urlAllPermisosLegacy = constantes.getApiUrl('ips_authorization', 'getAllPermisosLegacy');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: cancelerUsuario.promise
      };

      var promesaAllPermisosLegacy = $http.get(urlAllPermisosLegacy, config);
      var urlPermisosLegacyUser = constantes.getApiUrl('ips_authorization', 'getUserPermisosLegacy');
      urlPermisosLegacyUser = urlPermisosLegacyUser.replace("{0}", cuenta.uid).replace("{1}", usuario.id);

      var promesaPermisosLegacyUser = $http.get(urlPermisosLegacyUser, config);
      $q.all([promesaAllPermisosLegacy,promesaPermisosLegacyUser]).then(function(response){
        cancelerUsuario = null;
        var permisos = response[0].data;
        var permisosUser = response[1].data;
        if (angular.isUndefined(permisos) || angular.isUndefined(permisosUser)) {
          deferred.reject();
        }
        if (permisosUser.length === 0) {
          for (var ii = 0; ii < permisos.length; ii++) {
            // permisos[ii].disabled = "pointer-events:none;opacity: 0.3;";
          }
        } else {
          permisos.forEach(function(permisos) {
            for (var ii = 0; ii < permisosUser.length; ii++) {
              // permisos.disabled = "pointer-events:none;opacity: 0.3;";
              if (permisos.profileId === permisosUser[ii].profileId) {
                permisos.selected = true;
                break;
              }
            }
          });
        }
        deferred.resolve(permisos);
      }, function (error){
        if (cancelerUsuario !== null) {
          return error;
        } else {
          error.error = "Ocurrio un error inesperado";
          deferred.reject(error);
        }
      });

      return deferred.promise;
    }

    function putPermisoUser(idPermiso, cuenta, usuario){
      var url = constantes.getApiUrl('ips_authorization', 'putUserPermisosLegacy');
      url = url.replace("{0}", cuenta.uid).replace("{1}", usuario.id).replace("{2}", idPermiso.profileId);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.put(url, "", config).then(okFunction, errorFunction);

      function okFunction(resp) {
        return resp;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function deletePermisoUser(idPermiso, cuenta, usuario) {
      var url = constantes.getApiUrl('ips_authorization', 'deleteUserPermisosLegacy');
      url = url.replace("{0}", cuenta.uid).replace("{1}", usuario.id).replace("{2}", idPermiso.profileId);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.delete(url, config).then(okFunction, errorFunction);

      function okFunction(resp) {
        return resp;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('permisosService', permisosService);

  function permisosService($log, $http, $mdDialog, $window, $q, $timeout, $filter, constantes, conexion, tblCuentasService) {
    var cancelerUsuario;
    var cancelerUsuarioDos;
    var permisos;
    
    var service = {
      getApps: getApps,
      getPerfiles: getPerfiles,
      putPerfilApp: putPerfilApp,
      deletePerfilApp: deletePerfilApp,
      getPermisos:getPermisos,
    };

    return service;

    // FUNCION QUE OBTIENE LAS APPS EXISTENTES
    function getApps(cuenta) {
      var url = constantes.getApiUrl('ips_authorization', 'apps');
      url = url.replace("{0}", cuenta.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }
    // FUNCION QUE OBTIENE LOS PERFILES DEL USUARIO LOGEADO
    function getPermisos(){
      return permisos;
    }

    // FUNCION QUE OBTIENE LOS PERFILES DEPENDIENDO DE LA CUENTA Y USUARIO
    function getPerfiles(apps, cuenta, usuario) {
      var promisesApps = [];
      if (angular.isDefined(cancelerUsuarioDos) && cancelerUsuarioDos !== null) {
        cancelerUsuarioDos.resolve();
      }

      cancelerUsuarioDos = $q.defer();
      var deferred  = $q.defer();

      var url = constantes.getApiUrl('ips_authorization', 'chkPerfiles');
      url = url.replace("{0}", cuenta.uid).replace("{1}", usuario.id);

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: cancelerUsuarioDos.promise
      };

      promisesApps.push($http.get(url, config));

      for (var i = 0; i < apps.length; i++) {
        var urlAllPerfiles = constantes.getApiUrl('ips_authorization', 'perfiles');
        urlAllPerfiles = urlAllPerfiles.replace("{0}", apps[i].id);
        promisesApps.push($http.get(urlAllPerfiles, config));
      }

      var theResults = [];
      $q.all(promisesApps).then(function(result) {
        cancelerUsuarioDos = null;
        permisos = result;
        for (var i = 1; i < result.length; i++) {
          var perfilesUsu = result[0].data;
          result[i].data.forEach(function (elemento) {
            var result = $filter('filter')(perfilesUsu, {'profileId': elemento.profileId, 'code': elemento.code});
            if (result.length) {
              elemento.disabled = "pointer-events:none;opacity: 0.3;";
              elemento.selected = true;
            }

            if (tblCuentasService.obtinePermisos(8)) {
              elemento.disabled = "";
            } else if (tblCuentasService.obtinePermisos(4) && tblCuentasService.obtinePermisos(5)) {
              elemento.disabled = "";
            } else if (tblCuentasService.obtinePermisos(4) && !tblCuentasService.obtinePermisos(5) && cuenta.uid === usuario.acc) {
              elemento.disabled = "";
            }

          });
          theResults.push(result[i]);
        }
        deferred.resolve(theResults);
      }, function(error) {
        if (cancelerUsuario !== null) {
          return error;
        } else {
          error.error = "Ocurrio un error inesperado";
          deferred.reject(error);
        }
      });
      return deferred.promise;
    }


    // FUNCION QUE GUARDA UN NUEVO PERFIL DEL USUARIO SELECCIONADO
    function putPerfilApp(idPerfiles, cuenta, usuario) {
      var deferred = $q.defer();
      var promisesAlta = [];

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      for (var i = 0; i < idPerfiles.length; i++) {
        var url = constantes.getApiUrl('ips_authorization', 'putPerfilApp');
        url = url.replace("{0}", cuenta.uid).replace("{1}", usuario.id).replace("{2}", idPerfiles[i].profileId);
        promisesAlta.push($http.put(url, "", config).then(function(response) {
          return response;
        }, function(error) {
          return error;
        }));
      }

      var theResults = [];
      $q.all(promisesAlta).then(function(result) {
        for (var i = 0; i < result.length; i++) {
          theResults.push(result[i]);
        }
        deferred.resolve(theResults);
      }, function(error) {
        error.error = "Ocurrio un error inesperado";
        deferred.reject(error);
      });
      return deferred.promise;
    }

    // FUNCION QUE ELIMINA UN NUEVO PERFIL DLE USUARIO SELECCIONADO
    function deletePerfilApp(idPerfiles, cuenta, usuario) {
      var deferred = $q.defer();
      var promisesDelete = [];

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      for (var i = 0; i < idPerfiles.length; i++) {
        var url = constantes.getApiUrl('ips_authorization', 'deletePerfilApp');
        url = url.replace("{0}", cuenta.uid).replace("{1}", usuario.id).replace("{2}", idPerfiles[i].profileId);
        promisesDelete.push($http.delete(url, config).then(function(response) {
          return response;
        }, function(error) {
          return error;
        }));
      }

      var theResults = [];
      $q.all(promisesDelete).then(function(result) {
        for (var i = 0; i < result.length; i++) {
          theResults.push(result[i]);
        }
        deferred.resolve(theResults);
      }, function(error) {
        error.error = "Ocurrio un error inesperado";
        deferred.reject(error);
      });
      return deferred.promise;
    }

  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   *
   */

  angular
    .module('app')
    .factory('parametrosService', parametrosService);

  function parametrosService($log, $http, $window, $q, $timeout, $translate, constantes, conexion) {
    var service = {
      infoCuenta: infoCuenta,
      obtieneTiposParam: obtieneTiposParam,
      postParam: postParam,
      putParam: putParam
    };

    return service;

    // FUNCION QUE OBTIENE LOS PARAMETROS UNA CUENTA
    function infoCuenta(data) {
      var url = constantes.getApiUrl('ips_corp', 'cuentasParam');
      url = url.replace("{0}", data.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE OBTIENE LOS TIPOS DE PARAMETROS EXISTENTES
    function obtieneTiposParam() {
      var url = constantes.getApiUrl('ips_corp', 'getParamTypes');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE EDITA UN PARAMETRO DE LA CUENTA SELECCIONADA
    function postParam(datosCuenta, param) {
      var url = constantes.getApiUrl('ips_corp', 'putParam');
      url = url.replace("{0}", datosCuenta.uid);
      var params = [{
        "uidAccount": datosCuenta.uid,
        "parameter": param.param.parameter,
        "value": param.valueParam
      }];
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.post(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE AGREGA UN NUEVO PARAMETRO A LA CUENTA SELECCIONADA
    function putParam(datosCuenta, paramtroSeleccionado, param) {
      var url = constantes.getApiUrl('ips_corp', 'postParam');
      url = url.replace("{0}", datosCuenta.uid);
      var params = [{
        "uidAccount": datosCuenta.uid,
        "parameter": paramtroSeleccionado.parameter,
        "value": param.valueParam
      }];
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.put(url, params, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

  }
}());

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('appsCuentasService', appsCuentasService);

  function appsCuentasService($log, $http, $window, $q,$translate, $timeout, constantes, conexion) {
    var cancelerCuentas;
    var service = {
      getAllAppsCuenta: getAllAppsCuenta,
      putAppCuenta: putAppCuenta,
      deleteAppCuenta: deleteAppCuenta
    };

    return service;

    // FUNCION QUE OBTIENE LAS APLICACIONES DE UNA CUENTA
    function getAllAppsCuenta(data) {
      if(angular.isDefined(cancelerCuentas) && cancelerCuentas !== null) {
        cancelerCuentas.resolve();
      }

      cancelerCuentas = $q.defer();

      var deferred = $q.defer();
      var urlAllApps = constantes.getApiUrl('ips_authorization', 'allAppsCuenta');
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: cancelerCuentas.promise
      };

      var promesaTodasApps = $http.get(urlAllApps, config);
      var urlAppsCuenta = constantes.getApiUrl('ips_authorization', 'appsCuenta');
      urlAppsCuenta = urlAppsCuenta.replace("{0}", data.uid);
      var promesaAppsCuenta = $http.get(urlAppsCuenta, config);
      $q.all([promesaTodasApps, promesaAppsCuenta]).then(function(response) {
        cancelerCuentas = null;
        var apps = response[0].data;
        var appsCuenta = response[1].data;
        if (angular.isUndefined(apps) || angular.isUndefined(appsCuenta)) {
          deferred.reject();
        }
        if (appsCuenta.length === 0) {
          for (var ii = 0; ii < apps.length; ii++) {
            apps[ii].disabled = "pointer-events:none;opacity: 0.3;";
          }
        } else {
          apps.forEach(function(app) {
            for (var ii = 0; ii < appsCuenta.length; ii++) {
              app.disabled = "pointer-events:none;opacity: 0.3;";
              if (app.id === appsCuenta[ii].id) {
                app.selected = true;
                break;
              }
            }
          });
        }
        deferred.resolve(apps);
      }, function(error) {
        if (cancelerCuentas !== null) {
          deferred.reject(error);
        } else {
          error.error = "Ocurrio un error inesperado";
          deferred.reject(error);
        }
      } );
      return deferred.promise;
    }

    // FUNCION QUE GUARDA UNA APLICACION
    function putAppCuenta(data, datos) {
      var url = constantes.getApiUrl('ips_authorization', 'putAppCuenta');
      url = url.replace("{0}", datos.uid).replace("{1}", data.id);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.put(url, "", config).then(okFunction, errorFunction);

      function okFunction(resp) {
        return resp;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE ELEMINA UNA APLICACION
    function deleteAppCuenta(data, datos) {
      var url = constantes.getApiUrl('ips_authorization', 'deleteAppCuena');
      url = url.replace("{0}", datos.uid).replace("{1}", data.id);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.delete(url, config).then(okFunction, errorFunction);

      function okFunction(resp) {
        return resp;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('vehiculosService', vehiculosService);

  function vehiculosService($log, $http, $window, $q, $timeout, constantes, conexion) {
    var service = {
      getVehiculos: getVehiculos,
      deleteVehiculo: deleteVehiculo,
      postVehiculo: postVehiculo
    };

    return service;

    // FUNCION QUE OBTIENE LOS VEHICULOS DEPENDIENDO SU CUENTA Y SU VICNULACION
    function getVehiculos(cuenta,cuentaVinculada) {
      var deferred = $q.defer();
      var urlAllVehiculos = constantes.getApiUrl('ips_corp', 'getVehiculosFlota');
      urlAllVehiculos = urlAllVehiculos.replace("{0}",cuentaVinculada.uid);
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      var promesaAllVehiculos = $http.get(urlAllVehiculos, config);
      var urlVehiculosCuenta = constantes.getApiUrl('ips_corp', 'getVehiculosSponsors');
      urlVehiculosCuenta = urlVehiculosCuenta.replace("{0}",cuenta.uid).replace("{1}",cuentaVinculada.uid);
      var promesaVehiculosCuenta = $http.get(urlVehiculosCuenta, config);
      $q.all([promesaAllVehiculos, promesaVehiculosCuenta]).then(function(response) {
        var vehiculos = response[0].data;
        var vehiculosCuenta = response[1].data;
        if (angular.isUndefined(vehiculos) || angular.isUndefined(vehiculosCuenta)) {
          deferred.reject();
        }

        if (vehiculosCuenta.sponsors.length === 0) {
          for (var ii = 0; ii < vehiculos.length; ii++) {
            vehiculos[ii].disabled = "pointer-events:none;opacity: 0.3;";
          }
        } else {
          vehiculos.forEach(function(vehiculos) {
            for (var ii = 0; ii < vehiculosCuenta.sponsors.length; ii++) {
              var vehi = vehiculosCuenta.sponsors[ii];
              for (var jj = 0; jj < vehi.vehicles.length; jj++) {
                vehiculos.disabled = "pointer-events:none;opacity: 0.3;";
                if (vehiculos.id === vehi.vehicles[jj].id) {
                  vehiculos.selected = true;
                  break;
                }
              }
            }
          });
        }
        deferred.resolve(vehiculos);
      }, function() {
        deferred.reject({
          error: "Ocurrio un error inesperado"
        });
      } );
      return deferred.promise;
    }

    // FUNCION QUE ELIMINA UN VEHICULO DE ESA VINCULACION
    function deleteVehiculo (vehiculo, cuenta, cuentaVinculada,migasCuentas) {
      var url = constantes.getApiUrl('ips_corp', 'deleteVehiculo');

      var link = (angular.isDefined(migasCuentas) && migasCuentas.length > 0) ? "?link=" + migasCuentas : "";

      if(angular.isArray(vehiculo)) {
        var vehiclesChain = '';
        angular.forEach(vehiculo, function(value) {
          vehiclesChain += value.id + ',';
        });
        url = url.replace("{0}",cuenta.uid).replace("{1}",cuentaVinculada.uid).replace("{2}",vehiclesChain.substring(0,vehiclesChain.length-1)) + link;
      } else {
        url = url.replace("{0}",cuenta.uid).replace("{1}",cuentaVinculada.uid).replace("{2}",vehiculo.id) + link;
      }

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.delete(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE AGREGA UN VEHICULO DE ESA VINCULACION
    function postVehiculo (vehiculo, cuenta, cuentaVinculada,migasCuentas) {
      var url = constantes.getApiUrl('ips_corp', 'postVehiculo');

      var link = (angular.isDefined(migasCuentas) && migasCuentas.length > 0) ? "?link=" + migasCuentas : "";

      if(angular.isArray(vehiculo)) {
        var vehiclesChain = '';
        angular.forEach(vehiculo, function(value) {
          vehiclesChain += value.id + ',';
        });
        url = url.replace("{0}",cuenta.uid).replace("{1}",cuentaVinculada.uid).replace("{2}",vehiclesChain.substring(0,vehiclesChain.length-1)) + link;
      } else {
        url = url.replace("{0}",cuenta.uid).replace("{1}",cuentaVinculada.uid).replace("{2}",vehiculo.id) + link;
      }

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      return $http.post(url, "", config).then(okFunction, errorFunction);

      function okFunction(resp) {
        return resp;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikVinculacionManager', datikVinculacionManager);

  function datikVinculacionManager() {
    return {
      restrict: 'E',
      scope: {
        // accountevent: '@'
      },
      templateUrl: 'app/views/cuentas/directives/vinculacionManager.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$rootScope','$filter', '$translate', 'conexion', '$q',
        '$timeout', '$uibModal', '$mdDialog', 'timeZones', 'notificaciones', 'tblCuentasService', 'vinculacionService', vinculacionManagerController
      ]
    };

    function vinculacionManagerController($log, $scope, $rootScope, $filter, $translate, conexion, $q,
      $timeout, $uibModal, $mdDialog, timeZones, notificaciones, tblCuentasService, vinculacionService) {

      var vm = this;
      var migas = [];
      var arrayPromesasNiveles = [];
      var cuentaSelecArbol = undefined;
      var cuentaSeleccionada = undefined;
      var vinculacionSleccionada = undefined;
      var tipo = [$translate.instant("Flota"), $translate.instant("Organización")];

      vm.loading = true;
      vm.showOrgFlo = false;
      vm.loadingBoton = false;
      vm.permisoVinculo = true;
      vm.showArbolVehi = true;
      vm.mostrar = {
        vinculaciones : false,
        vehiculos: false
      };

      // EVENTE QUE OBTIENE LOS DATOS DE LA CUENTA SELECCIONADA DE LA TABLA DE CUENTAS
      $scope.$on('cuenta-seleccionada', function(event, objetoEvento){
        vm.viculacion.data = [];
        vm.permisoVinculo = true;
        cuentaSeleccionada = objetoEvento;
        if (angular.isDefined(cuentaSeleccionada) && cuentaSeleccionada.type === 2) {
          vm.showArbolVehi = true;
          migas = [];
          migas.push({
            name: cuentaSeleccionada.name,
            uid: cuentaSeleccionada.uid,
            style: 'font-weight: 500; pointer-events:none;'
          });
          vm.migas = migas;
          getViculaciones(cuentaSeleccionada);
          vm.organizacionPadre = cuentaSeleccionada.name;
          $scope.$broadcast('cuentaVinculacion-seleccionadaOrg', []);
        } else {
          vm.migas = undefined;
          vm.showArbolVehi = false;
          vm.loading = true;
          vm.viculacion.data = [];
          arrayPromesasNiveles = [];
          var deferred  = $q.defer();
          var usuario = conexion.getUsuario();
          var cuenta = $filter('filter')(vm.datos, {'uid': usuario.acc})[0];
          var promesa = arrayVinculaciones(cuenta, deferred);
          arrayPromesasNiveles.push(promesa);
          promesasResult(arrayPromesasNiveles);
        }
      });

      $scope.$on('cuentaSeleccionadaBsqUsuario', function(event, objetoEvento){
        vm.viculacion.data = [];
        vm.permisoVinculo = true;
        cuentaSeleccionada = objetoEvento;
        if (angular.isDefined(cuentaSeleccionada) && cuentaSeleccionada.type === 2) {
          migas = [];
          migas.push({
            name: cuentaSeleccionada.name,
            uid: cuentaSeleccionada.uid,
            style: 'font-weight: 500; pointer-events:none;'
          });
          vm.migas = migas;
          getViculaciones(cuentaSeleccionada);
          vm.organizacionPadre = cuentaSeleccionada.name;
          $scope.$broadcast('cuentaVinculacion-seleccionadaOrg', []);
        }
      });

      // EVENTE QUE OBTIENE LOS DATOS DEL USUARIO SELECCIONADO DE LA TABLA DE USUARIOS
      $scope.$on('vinvulaciones-table-change-selection', function(event, objetoEvento){
        if (angular.isDefined(cuentaSelecArbol) && objetoEvento.length > 1) {
          for (var i = 0; i < objetoEvento.length; i++) {
            if(cuentaSelecArbol.uid !== objetoEvento[i].uid){
              cuentaSelecArbol = undefined;
              vinculacionSleccionada = [];
              vinculacionSleccionada.push(objetoEvento[i]);
              $scope.$broadcast('desSeleccionarElementoVin',objetoEvento[i]);
              break;
            }
          }
        } else {
          vinculacionSleccionada = objetoEvento;
        }

        if (vinculacionSleccionada.length > 0 && vinculacionSleccionada[0].type === 1) {
          seHaSeleccionadoVinculacion(vinculacionSleccionada[0]);
        } else {
          limpiarRamaSelec();
          vm.mostrar.vehiculos = false;
          $scope.$broadcast('array-miga', vm.migas);
          $scope.$broadcast('cuentaVinculacion-seleccionadaOrg', vinculacionSleccionada);
        }
      });

      // EVENTO QUE RECARGA LA TABLA DE VINCULACIONES
      $scope.refrescarVinculacion = function() {
        vm.loadingBoton = false;
        if (cuentaSeleccionada.type === 1) {
          vm.migas = undefined;
          vm.showArbolVehi = false;
          vm.loading = true;
          vm.viculacion.data = [];
          arrayPromesasNiveles = [];
          var deferred  = $q.defer();
          var usuario = conexion.getUsuario();
          var cuenta = $filter('filter')(vm.datos, {'uid': usuario.acc})[0];
          var promesa = arrayVinculaciones(cuenta, deferred);
          arrayPromesasNiveles.push(promesa);
          promesasResult(arrayPromesasNiveles);
        } else {
          vm.migas = [];
          migas = [];
          migas.push({
            name: cuentaSeleccionada.name,
            uid: cuentaSeleccionada.uid,
            style: 'font-weight: 500; pointer-events:none;'
          });
          vm.migas = migas;
          getViculaciones(cuentaSeleccionada);
          $scope.$broadcast('restartArbol');
        }
      };

      // FUNCION QUE DESHABILITA O HABILITA EL BOTON DE ELIMINAR EN LA TABLA DE VINCULACIONES, DEPENDIENDO SUS PERMISOS
      var disabledNotDisabledDeleteVin = function(elemento/*,indexRelativo*/){
        if (tblCuentasService.obtinePermisos(8)) {
          vm.permisoVinculo = false;
          return false;
        } else if (tblCuentasService.obtinePermisos(0)) {
          return true;
        } else if (tblCuentasService.obtinePermisos(2) && !tblCuentasService.obtinePermisos(3)) {
            vm.permisoVinculo = false;
            if (elemento.type !== 2) {
              return false;
            }
            return true;
        } else if (tblCuentasService.obtinePermisos(3)) {
          vm.permisoVinculo = false;
          return false;
        } else {
          return true;
        }
      };

      // FUNCION QUE OCULTA EL BOTON DE ENTRAR, SOLO SI ES ORGANIZACION EN LA TABLA DE VINCULACION
      var shouldHideBtnFunction = function(elemento/*,indexRelativo*/){
        if(elemento.type === 2) {
          if(angular.isUndefined(elemento.hideBtn) || !elemento.hideBtn){
            return false;
          } else {
            return true;
          }
        } else{
          return true;
        }
      };

      // CREACION DE LA TABLA APLICACIONES DE UNA CUENTA
      vm.viculacion = {
        maxHeight: "calc(100vh - 150px)",
        currentPage: 1,
        perPage: 10000,
        elements: [{
          title: 'Nombre',
          information: 'name',
          type: 'string'
        }, {
          title: 'Tipo',
          information: 'tipo',
          tipo: 'type',
          type: 'string',
          sortArray: tipo
        }],
        options: {
          title: 'Acciones',
          showTitle: undefined,
          // width: '10%',
          buttons: [{
              title: 'Entrar',
              type: 'into',
              function: functionIntoVin,
              shouldHideBtn:shouldHideBtnFunction
            }, {
            title: 'Eliminar',
            type: 'delete',
            function: funcionEliminarOper,
            disabled: disabledNotDisabledDeleteVin
          }]
        },
        selection: {
          mode: 'simple',
          getSelectedElements: undefined,
          changeSelectionEventName: 'vinvulaciones-table-change-selection'
        },
        data: []
      };

      function arrayVinculaciones(cuenta, deferred) {
        var _cuenta = cuenta;
        vinculacionService.getVinculaciones(cuenta).then(function(data) {
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              data[i].padre = _cuenta;
              var promesa = arrayVinculaciones(data[i],$q.defer());
              arrayPromesasNiveles.push(promesa);
            }
          }
          deferred.resolve(data);
        });
        return deferred.promise;
      }

      function promesasResult( array ) {
          $q.all( array ).then(function(result) {
              if (result.length == arrayPromesasNiveles.length) {
                result.forEach(function(elemento) {
                  if (elemento.length > 0) {
                    for (var i = 0; i < elemento.length; i++) {
                      if (cuentaSeleccionada.uid === elemento[i].uid) {
                        elemento[i].padre.hideBtn = true;
                        elemento[i].padre.eliminacionFlota = true;
                        var result = $filter('filter')(vm.viculacion.data,{'uid': elemento[i].padre.uid})[0];
                        if (angular.isUndefined(result)) {
                          vm.viculacion.data.push(elemento[i].padre);
                        }
                        break;
                      }
                    }
                  }
                });
                vm.loading = false;
              } else {
                return promesasResult( arrayPromesasNiveles );
              }
          });
      }

      // FUNCION QUE VALIDA QUE EL REGISTRO SELECIONADO DE LA TABLA DE VINCULACION ESTE DEFINIDO
      function functionIntoVin(data){
        if (angular.isDefined(data)) {
          seHaSeleccionadoVinculacion(data);
        } else {
          seHaSeleccionadoVinculacion();
        }
      }

      // FUNCION QUE OBTIENE OPERADORES DEPENDIENDO LA CUENTA SELECCIONADA
      function getViculaciones(operadorSelec) {
        if (angular.isDefined(operadorSelec)) {
          vm.loading = true;
          vinculacionService.getVinculaciones(operadorSelec).then(function(data) {
              vm.loading = false;
              if(data.length > 0){
                if (angular.isDefined(operadorSelec.selected)) {
                  for (var i = 0; i < data.length; i++) {
                    if (operadorSelec.uidF === data[i].uid) {
                      data[i].selected = true;
                      break;
                    }
                  }
                }
                vm.viculacion.data = data;
                vm.permisoVinculo = false;
              } else {
                angular.element("datik-vinculacion-manager #datikTableEmptyMessage").text($translate.instant("La cuenta seleccionada no tiene vinculaciones asociadas"));
                if (tblCuentasService.obtinePermisos(3) || tblCuentasService.obtinePermisos(8)) {
                  vm.permisoVinculo = false;
                }
                vm.viculacion.data = [];
                vm.mostrar.vehiculos = false;
              }
          },function(error){
              notificaciones.showNotification($translate.instant("Cuentas"), error.error, "error");
              vm.viculacion.data = [];
              vm.mostrar.vehiculos = false;
              vm.mostrar.vinculaciones = false;
              vm.loading = false;
          });
        }
      }

      // FUNCION QUE ABRE EL MODAL DE LA ALTA DE VINCULACIONES
      vm.agregarOper = function() {
        var cuenta = "";
        if (angular.isDefined(vm.migas) && vm.migas.length > 0) {
          cuenta = vm.migas[vm.migas.length-1];
        } else {
          cuenta = cuentaSeleccionada;
        }
        var elemento = {
          titulo: $translate.instant("Añadir"),
          name: cuenta.name,
          cuenta: cuenta.uid,
          migas: vm.migas,
          vinculaciones: vm.viculacion.data
        };
        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/cuentas/modals/altaVinculacion.modal.html',
          controller: 'altaVinculacionController as vm',
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        });
      };

      function funcionEliminarOper(data) {
        data.nombre = $translate.instant("la vinculación con") + " " + data.name;
        var cuenta = "";
        if (angular.isDefined(vm.migas) && vm.migas.length > 0) {
          cuenta = vm.migas[vm.migas.length-1];
        } else {
          cuenta = cuentaSeleccionada;
        }
        var elemento = {
          titulo: $translate.instant("Confimación"),
          element: data,
          cuenta: cuenta
        };
        $mdDialog.show({
          controller: 'eliminarVinculacionrController as vm',
          parent: angular.element(document.body),
          locals:{scopeDataToPass: $scope},
          clickOutsideToClose: true,
          resolve: {
            datos: function() {
              return elemento;
            }
          },
          template:
          '<md-dialog md-theme="default" aria-label="{{vm.titulo}}" ng-class="dialog.css" class="_md md-default-theme md-transition-in" role="dialog" tabindex="-1" aria-describedby="dialogContent_0">' +
          '  <md-dialog-content class="md-dialog-content" role="document" tabindex="-1">' +
          '    <h2 class="md-title ng-binding"><b>{{vm.titulo}}</b></h2>' +
          '    <div class="md-dialog-content-body ng-scope">' +
          '     <p class="ng-binding">{{"¿Desea eliminar" | translate}} {{vm.response.nombre}}?</p>' +
          '    </div>' +
          '  </md-dialog-content>' +
          '  <md-dialog-actions>' +
          '  <md-button ng-click="vm.close()" class="md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" type="button">' +
          '     <b>{{"Cancelar" | translate }}</b> ' +
          '   </md-button> ' +
          '  <md-button ng-click="vm.aceptar(vm.response)" class="md-primary md-confirm-button md-button md-ink-ripple md-default-theme" type="button">' +
          '     <b>{{"Eliminar" | translate}}</b>' +
          '  </md-button>' +
          ' </md-dialog-actions>' +
          '</md-dialog>'
        }).then(function() {
          $log.info("Dialog Close");
        });
      }

      // FUNCION QUE SE ADENTRA MAS EN UNA ORGANIZACION Y MUESTRA UN ARBOL DE VICULACIONES O SI ES UNA FLOTA MUESTRA SUS APADRINAMIENTOS
      function seHaSeleccionadoVinculacion(operadorSelec) {
        if (angular.isUndefined(operadorSelec)) {
          vinculacionSleccionada = undefined;
          vm.mostrar.vehiculos = false;
        } else {
          vinculacionSleccionada = operadorSelec;
          if (vinculacionSleccionada.type == 1) {
            vm.mostrar.vehiculos = true;
            $scope.$broadcast('cuentaVinculacion-seleccionada', vinculacionSleccionada);
            $scope.$broadcast('array-migas', vm.migas);
          } else {
            migas = [];
            for (var ii = 0; ii < vm.migas.length; ii++) {
              var previus = vm.migas[ii];
              migas.push({
                name: previus.name,
                uid: previus.uid
              });
            }
            limpiarRamaSelec();
            angular.element('#hijo_'+ vm.migas[vm.migas.length-1].uid + "_" + vinculacionSleccionada.uid).addClass('OrgActiva');
            vm.migas = [];
            migas.push({
              name: operadorSelec.name,
              uid: operadorSelec.uid,
              style: 'font-weight: 500; pointer-events:none;'
            });
            vm.migas = migas;
            vm.mostrar.vehiculos = false;
            getViculaciones(vinculacionSleccionada);
          }
        }
      }

      // FUNCION QUE CONCATENA LA PROFUNDIDAD DE LA ORGANIZACION PADRE Y LA MUESTRA EN LAS MIGAS
      vm.vistaVin = function(dato) {
        migas = [];
        getViculaciones(dato);
        for (var ii = 0; ii < vm.migas.length; ii++) {
          var previus = vm.migas[ii];
          if (previus.uid === dato.uid) {
            migas.push({
              name: previus.name,
              uid: previus.uid,
              style: 'font-weight: 500; pointer-events:none;'
            });

            vm.migas = [];
            vm.migas = migas;
            limpiarRamaSelec();
            if (ii > 0) {
              angular.element('#hijo_'+ vm.migas[ii-1].uid + "_" + dato.uid).addClass('OrgActiva');
            } else {
              angular.element('#padre_' + dato.uid).addClass('OrgActiva');
            }
            break;
          } else {
            migas.push({
              name: previus.name,
              uid: previus.uid
            });
          }
        }
        vm.mostrar = {
          vehiculos: false
        };
      };

      $scope.$on('limpiarArbol', function(event, objetoEvento){
        limpiarRamaSelec();
        var cuenta = {};
        var cuenta2 = {};
        var ids = $(objetoEvento).attr('id');
        var name = $(objetoEvento).find(".node-name").text();
        if (angular.isDefined(ids)) {
          getMigasArbol(ids);
          if (ids.substring(4,5) === "_") {
            angular.element("#" + ids).addClass('OrgActiva');
            ids = ids.split("_");
            cuenta = {
              uid: ids[2],
              type: 2,
              name: name
            };
            getViculaciones(cuenta);
          } else if (ids.substring(5,6) === "_" && ids.substring(0,1) === "p") {
            angular.element("#" + ids).addClass('OrgActiva');
            ids = ids.split("_");
            if (ids[0].substring(0,1) === "p") {
              vm.migas = [];
              vm.migas.push({
                uid: ids[1],
                name: name,
                style: 'font-weight: 500; pointer-events:none;'
              });
            }
            cuenta = {
              uid: ids[1],
              type: 2,
              name: name
            };
            getViculaciones(cuenta);
          } else if (ids.substring(4,5) === "F") {
            vm.migas.pop();
            ids = ids.split("_");
            cuenta2 = {
              uid: vm.migas[vm.migas.length-1].uid,
              uidF: ids[2],
              type: 2,
              name: vm.migas[vm.migas.length-1].name,
              selected : true
            };
            cuenta = {
              uid: ids[2],
              type: 1,
              name: name
            };
            getViculaciones(cuenta2);
            seHaSeleccionadoVinculacion(cuenta);
            cuentaSelecArbol = cuenta;
          }
        }
      });

      function getMigasArbol(objeto){
        var miga  = [];
        var nameSelect  = angular.element("#" + objeto).find(".node-name").text();
        var objId = objeto;
        objId = objId.split("_");
        miga.push({
          name: nameSelect,
          uid: objId[2],
          style: 'font-weight: 500; pointer-events:none;'
        });
        obtMigas(miga,objId);
      }

      function obtMigas (miga,objId){
        var miga2  = [];
        var migaCopy = miga;
        angular.element('#OrganiseChart-big-commpany div').each(function(){
          if (angular.isDefined(objId)) {
            var id = $(this).attr('id');
            var name = angular.element("#" + id).find(".node-name").text();
            id = id.split("_");
            if (id[0].substring(0,1) === "h") {
              if (id[2] === objId[1]) {
                miga.push({
                  name: name,
                  uid: id[2],
                  style: ''
                });
                objId = ["",id[1],""];
                obtMigas (migas,objId);
              }
            } else if(id[0].substring(0,1) === "p"){
              if (id[1] === objId[1]) {
                miga.push({
                  name: name,
                  uid: id[1],
                  style: ''
                });
              }
            }
          }
        });
        for (var i = miga.length-1; i > 0; i--) {
          miga2.push(miga[i]);
        }
        miga2.push(migaCopy[0]);
        vm.migas = [];
        vm.migas = miga2;
      }

      function limpiarRamaSelec(){
        angular.element('#OrganiseChart-big-commpany div').each(function(){
          var id = $(this).attr('id');
          if (angular.isDefined(id)) {
            angular.element("#" + id).removeClass('OrgActiva');
          }
        });
      }

      // OBTIENE UNA LISTA DE LAS CUENTAS EXISTENTES
      function obtenerCuentas() {
        tblCuentasService.getCuentas("").then(function(data) {
          if(data.length > 0){
            vm.datos = data;
          }
        });
      }

      obtenerCuentas();
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikVinculacionTreeManager', datikVinculacionTreeManager);

  function datikVinculacionTreeManager() {
    return {
      restrict: 'E',
      scope: {
        // accountevent: '@'
      },
      templateUrl: 'app/views/cuentas/directives/vinculacionesTree.directive.html',
      controllerAs: 'vm',
      // link: function ($scope, $el, $attrs) {
      //
      // },
      controller: ['$log', '$scope', '$filter', '$translate',
        '$timeout', '$uibModal', 'timeZones', 'notificaciones', 'tblCuentasService','$q', 'vinculacionService', vinculacionesTreeController
      ]
    };

    function vinculacionesTreeController($log, $scope, $filter, $translate,
      $timeout, $uibModal, timeZones, notificaciones, tblCuentasService, $q, vinculacionService) {

      var vm = this;
      var _chartConfig = {};
      var nodoActivo = "";
      var cuentaSeleccionada = undefined;
      var cuentaSeleccionadaVin = undefined;
      var cadenaMigas = undefined;
      var migas = [];
      var arrayPromesasNiveles = [];
      var tipo = [$translate.instant('Flota'), $translate.instant('Organización')];

      vm.loadingTree = true;
      vm.mostrar = {
        vinculaciones : false,
        vehiculos: false
      };

      // EVENTE QUE OBTIENE LOS DATOS DE LA CUENTA SELECCIONADA DE LA TABLA DE CUENTAS
      $scope.$on('cuenta-seleccionada', function(event, objetoEvento){
        cuentaSeleccionada = objetoEvento;
        if (angular.isDefined(cuentaSeleccionada) && cuentaSeleccionada.type === 2 &&
        cuentaSeleccionadaVin.length == 0) {
          vm.loadingTree = true;
          angular.element('#OrganiseChart-big-commpany').html('');
          var promesa = crearEncabezadoArbol(cuentaSeleccionada, $q.defer());
          arrayPromesasNiveles.push(promesa);
          recursiveAll(arrayPromesasNiveles);
        }
      });

      $scope.$on('cuentaSeleccionadaBsqUsuario', function(event, objetoEvento){
        cuentaSeleccionada = objetoEvento;
        if (angular.isDefined(cuentaSeleccionada) && cuentaSeleccionada.type === 2 &&
        cuentaSeleccionadaVin.length == 0) {
          vm.loadingTree = true;
          angular.element('#OrganiseChart-big-commpany').html('');
          var promesa = crearEncabezadoArbol(cuentaSeleccionada, $q.defer());
          arrayPromesasNiveles.push(promesa);
          recursiveAll(arrayPromesasNiveles);
        }
      });

      $scope.$on('restartArbol', function(){
        vm.loadingTree = true;
        angular.element('#OrganiseChart-big-commpany').html('');
        var promesa = crearEncabezadoArbol(cuentaSeleccionada, $q.defer());
        arrayPromesasNiveles.push(promesa);
        recursiveAll(arrayPromesasNiveles);
      });

      /**
       * Esta función espera hasta que se completen
       * todas las promesas del arrayPromesasNiveles
       */
      function recursiveAll( array ) {
          // Esperar a que se resuelva el array de promesas
          $q.all( array ).then(function( result ) {
              if ( result.length == arrayPromesasNiveles.length ) {
                // Si no se han añadido promesas al array pintamos el arbol
                vm.loadingTree = false;
                muestraArbol(_chartConfig);
              } else {
                // Si hay nuevas promesas en el array seguimos esperando
                return recursiveAll( arrayPromesasNiveles );
              }
          });
      }

      // EVENTO QUE OBTIENE EL ARREGLO DE LAS MIGAS DE VINCULACION
      $scope.$on('array-miga', function(event, objetoEvento){
        cadenaMigas = objetoEvento;
        migas = [];
        if (angular.isDefined(cadenaMigas)) {
          for (var ii = 0; ii < cadenaMigas.length; ii++) {
            migas.push({
              uid: cadenaMigas[ii].uid
            });
          }
        }
      });

      // EVENTE QUE OBTIENE LOS DATOS DE LA ORGANIZACION SELECCIONADA DE LA TABLA DE VINCULACIONES
      $scope.$on('cuentaVinculacion-seleccionadaOrg', function (event, objetoEvento){
        cuentaSeleccionadaVin = objetoEvento;
        if (cuentaSeleccionadaVin.length > 0 && cuentaSeleccionada.type === 2 &&
          angular.isDefined(cuentaSeleccionada) ) {
            angular.element('#padre_' + cuentaSeleccionada.uid).removeClass('OrgActiva');
            nodoActivo = migas[migas.length-1].uid+"_"+cuentaSeleccionadaVin[0].uid;
            angular.element('#hijo_'+nodoActivo).addClass('OrgActiva');
          } else if (migas.length > 0){
            if (migas.length == 1) {
              angular.element('#padre_' + migas[0].uid).addClass('OrgActiva');
            } else {
              nodoActivo = migas[migas.length-2].uid+"_"+migas[migas.length-1].uid;
              angular.element('#hijo_'+nodoActivo).addClass('OrgActiva');
            }
          }
       });

      // FUNCION QUE PINTA EL ARBOL DE VICULACIONES
      function muestraArbol(chart_config) {
         if(angular.element('#OrganiseChart-big-commpany').is(':visible')) {
          new Treant( chart_config );
         } else {
          var unbind = $scope.$watch(function() { return angular.element('#OrganiseChart-big-commpany').is(':visible'); },
          function(value) {
            if(value) {
                new Treant( chart_config );
                unbind();
                angular.element('#padre_' + cuentaSeleccionada.uid).addClass('OrgActiva');
            }
         });
        }
      }

      // FUNCION QUE CREA EL ENCABEZADO DEL ARBOL DE VINCULACIONES
      function crearEncabezadoArbol(cSeleccionada,deferred){
        _chartConfig = {
          chart: {
            container: '#OrganiseChart-big-commpany',
            levelSeparation: 45,
            rootOrientation: 'WEST',
            nodeAlign: 'BOTTOM',
            connectors: {
              type: 'step',
              style: {
                'stroke-width': 2
              }
            },
            node: {
              HTMLclass: 'big-commpany'
            }
          },
          nodeStructure: {
            text: {
              name: cSeleccionada.name
            },
            HTMLid: "padre_"+cSeleccionada.uid,
            connectors: {
              type: 'step',
              style: {
                stroke: '#55A5DB'
              }
            }
          }
        };
        return crearCuerpoArbol(cSeleccionada, _chartConfig.nodeStructure, deferred);
      }

      // FUNCION QUE CREA EL CUERPO DEL ARBOL DE VINCULACIONES
      function crearCuerpoArbol(cuenta, arbol, deferred) {
        if (angular.isDefined(cuenta)) {
          vinculacionService.getVinculaciones(cuenta).then(function(data) {
            if (data.length > 0) {
              arbol.children = [];
              for (var i = 0; i < data.length; i++) {
                if (data[i].type === 1) {
                  arbol.children[i] = {
                    text: {
                      name: data[i].name
                    },
                    HTMLid: "hijoF_" + cuenta.uid + "_" + data[i].uid,
                    HTMLclass: tipo[(data[i].type) - 1]
                  };
                } else {
                  arbol.children[i] = {
                    text: {
                      name: data[i].name
                    },
                    HTMLid: "hijo_" + cuenta.uid + "_" + data[i].uid,
                    connectors: {
                      type: 'step',
                      style: {
                        stroke: '#55A5DB'
                      }
                    }
                  };
                }
                var promesa = crearCuerpoArbol(data[i], arbol.children[i],$q.defer());
                arrayPromesasNiveles.push(promesa);
              }
            }
            deferred.resolve();
          });
          return deferred.promise;
        }
      }

      $('body').on('click', '.Treant .node', function() {
        $scope.$emit('limpiarArbol',this);
      });

    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikUsuariosManager', datikUsuariosManager);

  function datikUsuariosManager() {
    return {
      restrict: 'E',
      scope: {
        // accountevent: '@'
      },
      templateUrl: 'app/views/cuentas/directives/usuariosManager.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$rootScope', '$filter', '$translate', '$q',
        '$timeout', '$uibModal', '$mdDialog', 'timeZones', 'notificaciones', 'conexion', 'tblCuentasService', 'usuariosService', 'permisosService', usuariosManagerController
      ]
    };

    function usuariosManagerController($log, $scope, $rootScope, $filter, $translate, $q,
      $timeout, $uibModal, $mdDialog, timeZones, notificaciones, conexion, tblCuentasService, usuariosService, permisosService) {

      var vm = this;
      var horario = timeZones;
      var cuentaSeleccionada = undefined;
      var usuarioSeleccionado = undefined;
      var usuario = conexion.getUsuario();
      var msjLoad = $translate.instant("Cargando...");
      var lstBsqDtos = "";
      var busquedaUsuario = 0;

      var USUARIO = $translate.instant("Usuario");

      vm.simulateQuery = false;

      vm.loading = true;
      vm.loadingBoton = false;
      vm.permisoUsuario = true;
      vm.mostrar = {
        apps: false,
        msjUsuarios: false
      };
      vm.isDisabled = true;

      vm.eventoUsuarioSeleccion = 'usuarios-table-change-selection';
      vm.headerUsuarios = [$translate.instant('Username'), $translate.instant('Nombre'), $translate.instant('Apellido'), $translate.instant('Correo'), $translate.instant('Teléfono'), $translate.instant('Tipo de cuenta'), $translate.instant('Cuenta'), $translate.instant('Fecha Alta')];
      $scope.$on('reloadTblUsuarios', function(event, dtos, flagBsqUsuario) {
        busquedaUsuario = flagBsqUsuario;
        // var autoChild = document.getElementById('campo2').firstElementChild;
        // var el = angular.element(autoChild);
        // el.scope().$mdAutocompleteCtrl.hidden = true;

        vm.permisoUsuario = true;
        vm.isDisabled = true;
        usuariosService.getCuentasUsuarios(dtos).then(function(data) {
          vm.loading = false;
          if (data.length > 0) {
            data.forEach(function(elemento) {
              if (elemento.id == dtos.id) {
                elemento.selected = true;
                $scope.$broadcast('cambiarPreviusSelection', elemento);
                $scope.$broadcast('usuarioSeleccionadoBsqUsuario', elemento);
              }
            });
            vm.usuarios.data = data;
            vm.mostrar.apps = true;
            vm.permisoUsuario = false;
            vm.isDisabled = false;
            buscarUsu();
          } else {
            angular.element("datik-usuarios-manager #datikTableEmptyMessage").text($translate.instant("La cuenta seleccionada no tiene usuarios existentes"));
            vm.mostrar.apps = false;
            vm.mostrar.msjUsuarios = true;
            vm.usuarios.data = [];
            if (tblCuentasService.obtinePermisos(8) || tblCuentasService.obtinePermisos(5) ||
                  (cuentaSeleccionada.uid === usuario.acc && tblCuentasService.obtinePermisos(4))) {
              vm.permisoUsuario = false;
              vm.isDisabled = false;
            } 
          }
        },function(error) {
          notificaciones.showNotification(USUARIO, error.error, "error");
          vm.usuarios.data = [];
          vm.mostrar.apps = false;
          vm.mostrar.msjUsuarios = true;
          vm.loading = false;
        });
      });

      // EVENTE QUE OBTIENE LOS DATOS DE LA CUENTA SELECCIONADA DE LA TABLA DE CUENTAS
      $scope.$on('cuenta-seleccionada', function(event, objetoEvento) {
        angular.element("datik-usuarios-manager #datikTableEmptyMessage").text(msjLoad);
        vm.usuarios.data = [];
        vm.permisoUsuario = true;
        vm.isDisabled = true;
        vm.loading = true;
        cuentaSeleccionada = objetoEvento;
        vm.mostrar.msjUsuarios = true;
        vm.mostrar.apps = false;
        //vm.selecTabItem = "permisos";
        getUsuarios();
        // buscarUsu();
      });

      // EVENTO QUE OBTIENE LOS DATOS DEL USUARIO SELECCIONADO DE LA TABLA DE USUARIOS
      $scope.$on(vm.eventoUsuarioSeleccion, function(event, elementosSeleccionados) {
        if (elementosSeleccionados.length > 0) {
          seHaSeleccionadoUsuario(elementosSeleccionados[0]);
        } else {
          seHaSeleccionadoUsuario();
        }
        //Para enviar un evento a las directivas
        $scope.$broadcast('usuario-seleccionado', usuarioSeleccionado);
      });

      // EVENTO QUE CIERRA EL MODAL DE CUENTAS AL FINALIZAR UNA ALTA DE USUARIO
      $scope.refrescarUsuarios = function() {
        vm.mostrar.msjUsuarios = true;
        vm.mostrar.apps = false;
        vm.loadingBoton = false;
        getUsuarios();
        var element = angular.element("#campo2");
        element.focus();
        buscarUsu();
      };

      // FUNCION QUE DESHABILITA O HABILITA EL BOTON DE EDITAR EN LA TABLA DE USUARIOS, DEPENDIENDO SUS PERMISOS
      var disabledNotDisabledEditUsu = function( /*elemento,indexRelativo*/ ) {
        if (tblCuentasService.obtinePermisos(8) || tblCuentasService.obtinePermisos(5)) {
          return false;
        } else if (tblCuentasService.obtinePermisos(4) && cuentaSeleccionada.uid === usuario.acc) {
          return false;
        } else {
          return true;
        }
      };

      // FUNCION QUE DESHABILITA O HABILITA EL BOTON DE ELIMINAR EN LA TABLA DE USUARIOS, DEPENDIENDO SUS PERMISOS
      var disabledNotDisabledDeleteUsu = function(elemento /*,indexRelativo*/ ) {
        if (tblCuentasService.obtinePermisos(8) || tblCuentasService.obtinePermisos(5) ||
            (tblCuentasService.obtinePermisos(4) && cuentaSeleccionada.uid === usuario.acc)) {
          vm.permisoUsuario = false;
          vm.isDisabled = false;
          return false;
        } else {
          vm.permisoUsuario = true;
          vm.isDisabled = true;
          return true;
        }
      };

      // CREACION DE LA TABLA DE USUARIOS
      vm.usuarios = {
        maxHeight: "calc(100vh - 150px)",
        currentPage: 1,
        perPage: 10000,
        elements: [{
          title: 'Username',
          information: 'username',
          type: 'string'
        }, {
          title: 'Nombre',
          information: 'name',
          type: 'string'
        }, {
          title: 'Apellido',
          information: 'surname',
          type: 'string'
        }, {
          title: 'Correo',
          information: 'email',
          type: 'string'
        }],
        options: {
          title: 'Acciones',
          showTitle: undefined,
          width: undefined,
          buttons: [{
            title: 'Editar',
            type: 'edit',
            function: funcionEditarUsu,
            disabled: disabledNotDisabledEditUsu
          }, {
            title: 'Eliminar',
            type: 'delete',
            function: funcionEliminarUsu,
            disabled: disabledNotDisabledDeleteUsu
          }]
        },
        selection: {
          mode: 'simple',
          getSelectedElements: undefined,
          changeSelectionEventName: vm.eventoUsuarioSeleccion
        },
        data: []
      };

      // OBTIENE UNA LISTA DE USUARIOS DE UNA CUENTA
      function getUsuarios() {
        if (angular.isDefined(cuentaSeleccionada) && busquedaUsuario == 0) {
          usuariosService.getCuentasUsuarios(cuentaSeleccionada).then(function(data) {
            if (angular.isDefined(data.cancel) && data.cancel) {
              // Cancelled request
              vm.loading = false;
              angular.element("datik-usuarios-manager #datikTableEmptyMessage").text($translate.instant("Ha ocurrido un error al intentar obtener los usuarios de la cuenta seleccionada."));
            } else if (data.length > 0) {
              vm.loading = false;
              vm.permisoUsuario = false;
              vm.isDisabled = false;
              vm.usuarios.data = data;
            } else {
              vm.loading = false;
              angular.element("datik-usuarios-manager #datikTableEmptyMessage").text($translate.instant("La cuenta seleccionada no tiene usuarios existentes"));
              vm.mostrar.apps = false;
              vm.mostrar.msjUsuarios = true;
              vm.usuarios.data = [];
              vm.permisoUsuario = true;
              vm.isDisabled = true;
              if (tblCuentasService.obtinePermisos(8) || tblCuentasService.obtinePermisos(5) ||
                  (cuentaSeleccionada.uid === usuario.acc && tblCuentasService.obtinePermisos(4))) {
                vm.permisoUsuario = false;
                vm.isDisabled = false;
              }
            }
          }, function(error) {
            notificaciones.showNotification(USUARIO, error.error, "error");
            vm.usuarios.data = [];
            vm.mostrar.apps = false;
            vm.mostrar.msjUsuarios = true;
            vm.loading = false;
          });
        } else {
          busquedaUsuario = 0;
        }
      }

      // FUNCION QUE ABRE EL MODAL DE LA ALTA DE UN USUARIO
      vm.agregarUsu = function() {
        var elemento = {
          titulo: $translate.instant("Añadir"),
          element: horario,
          cuenta: cuentaSeleccionada.uid
        };
        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/cuentas/modals/usuarios.modal.html',
          controller: 'altaUsuariosController as vm',
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        });
      };

      // FUNCION QUE ABRE EL MODAL DE ELIMINACION DE UN USUARIO
      function funcionEliminarUsu(data) {
        data.nombre = $translate.instant("el usuario") + " " + data.name;
        var elemento = {
          titulo: $translate.instant("Confimación"),
          element: data,
          cuenta: cuentaSeleccionada.uid
        };
        $mdDialog.show({
          controller: 'eliminarUsuarioController as vm',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            scopeDataToPass: $scope
          },
          resolve: {
            datos: function() {
              return elemento;
            }
          },
          template: '<md-dialog md-theme="default" aria-label="{{vm.titulo}}" ng-class="dialog.css" class="_md md-default-theme md-transition-in" role="dialog" tabindex="-1" aria-describedby="dialogContent_0">' +
            '  <md-dialog-content class="md-dialog-content" role="document" tabindex="-1">' +
            '    <h2 class="md-title ng-binding"><b>{{vm.titulo}}</b></h2>' +
            '    <div class="md-dialog-content-body ng-scope">' +
            '     <p class="ng-binding">{{"¿Desea eliminar" | translate}} {{vm.response.nombre}}?</p>' +
            '    </div>' +
            '  </md-dialog-content>' +
            '  <md-dialog-actions>' +
            '  <md-button ng-click="vm.close()" class="md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" type="button">' +
            '     <b>{{"Cancelar" | translate }}</b> ' +
            '   </md-button> ' +
            '  <md-button ng-click="vm.aceptar(vm.response)" class="md-primary md-confirm-button md-button md-ink-ripple md-default-theme" type="button">' +
            '     <b>{{"Eliminar" | translate}}</b>' +
            '  </md-button>' +
            ' </md-dialog-actions>' +
            '</md-dialog>'
        }).then(function() {
          $log.info("Dialog Close Users");
        });
      }

      // FUNCION QUE ABRE EL MODAL DE EDITAR UN USUARIO
      function funcionEditarUsu(data) {
        var elemento = {
          titulo: $translate.instant("Editar"),
          cuenta: cuentaSeleccionada.uid,
          element: data
        };
        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/cuentas/modals/usuarios.modal.html',
          controller: 'editarUsuarioController as vm',
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
      }

      // FUNCION QUE VALIDA LA SELECCION DE UN REGISTRO DE UN REGISTRO DE LA TABLA DE USUARIOS
      function seHaSeleccionadoUsuario(usuario) {
        if (angular.isUndefined(usuario)) {
          usuarioSeleccionado = undefined;
          vm.mostrar.apps = false;
          vm.mostrar.msjUsuarios = true;
        } else {
          usuarioSeleccionado = usuario;
          vm.mostrar.apps = true;
          vm.mostrar.msjUsuarios = false;
        }
      }

      vm.querySearch = function(query) {
        var results = query ? lstBsqDtos.filter(createFilterFor(query, lstBsqDtos)) : lstBsqDtos,
          deferred;
        if (vm.simulateQuery) {
          deferred = $q.defer();
          $timeout(function() {
            deferred.resolve(results);
          }, Math.random() * 1000, false);
          return deferred.promise;
        } else {
          return results;
        }
      };

      function createFilterFor(query, lst) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(lst) {
          return (lst.value.indexOf(lowercaseQuery) === 0);
        };
      }

      function buscarUsu() {
        usuariosService.getBsqUsuarios("").then(function(data) {
          lstBsqDtos = data.data;
        }, function(error) {

        });
      }

      vm.selectedItemChange = function(dto) {
        if (angular.isDefined(dto)) {
          vm.loading = true;
          vm.searchText = "";
          vm.usuarios.data = [];
          vm.mostrar.apps = false;
          $scope.$emit("seleccionaCuenta", dto, 0);
        }
      };
      buscarUsu();
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikPermisosManager', datikPermisosManager);

  function datikPermisosManager() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/cuentas/directives/permisosManager.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$rootScope', '$filter', '$translate',
        '$timeout', '$uibModal', 'timeZones', 'notificaciones', 'tblCuentasService', 'utilidades',
        'conexion', 'permisosService', '$mdDialog', 'usuariosService', permisosManagerController
      ]
    };

    function permisosManagerController($log, $scope, $rootScope, $filter, $translate,
      $timeout, $uibModal, timeZones, notificaciones, tblCuentasService, utilidades, 
      conexion, permisosService, $mdDialog, usuariosService) {

      var vm = this;
      var cuentaSeleccionada = undefined;
      var usuarioSeleccionado = undefined;
      
      var PERMISOS = $translate.instant("Permisos");

      vm.arrayApps = [];

      vm.loading = true;
      vm.mostrar = {
        apps: false
      };

      $scope.$on('user-selec', function(event, objetoEvento) {
        cuentaSeleccionada = objetoEvento;
        usuarioSeleccionado = objetoEvento.user;
        vm.appsUsu = [];
        obtAppsTblUser();
        });
      
      $rootScope.$on('clone-state', function(ev, data){vm.cloning = data;});
      

      // EVENTE QUE OBTIENE LOS DATOS DE LA CUENTA SELECCIONADA DE LA TABLA DE CUENTAS
      $scope.$on('cuentaSeleccionadaBsqUsuario', function(event, objetoEvento) {
        cuentaSeleccionada = objetoEvento;
        obtApps();
        // vm.permisosIdx = 0;
      });

      $scope.$on('usuarioSeleccionadoBsqUsuario', function(event, objetoEvento) {
        usuarioSeleccionado = objetoEvento;
        obtAppsTblUser();
        // obtPerfiles(vm.appsUsu);
        // vm.permisosIdx = 0;
      });

      // EVENTE QUE OBTIENE LOS DATOS DE LA CUENTA SELECCIONADA DE LA TABLA DE CUENTAS
      $scope.$on('cuenta-seleccionada', function(event, objetoEvento) {
        cuentaSeleccionada = objetoEvento;
        obtApps();
      });

      // EVENTE QUE OBTIENE LOS DATOS DEL USUARIO SELECCIONADO DE LA TABLA DE USUARIOS
      $scope.$on('usuario-seleccionado', function(event, objetoEvento) {
        vm.perfilesApp.data = [];
        usuarioSeleccionado = objetoEvento;
        obtPerfiles(vm.appsUsu);
        vm.permisosIdx = 0;
      });

      $scope.$on('reload-permisos', function() {obtApps();});

      // CREACION DE LA TABLA DE PERFILES DE LA APLICACION
      vm.perfilesApp = {
        maxHeight: "calc(100vh - 150px)",
        currentPage: 1,
        perPage: 10000,
        elements: [{
          title: 'Código',
          information: 'code',
          type: 'string',
          width: '10%'
        }, {
          title: 'Pos',
          information: 'position',
          type: 'string',
          width: '10%'
        }, {
          title: 'Descripción',
          information: 'description',
          type: 'string',
          width: '80%'
        }],
        selection: {
          mode: 'checkbox',
          getSelectedElements: undefined,
          changeSelectionEventName: 'perfiles-table-change-selection'
        },
        data: []
      };
      
      function formatPermisos(todosPermisos){
        var str;
        var appName;
        todosPermisos.forEach(function(x) {
          str = "";
          appName = "";
          x.forEach(function(ele, i){
            if(x.length > 1){
              if(i === 0){
                appName = ele.application.code;
                str = appName + ": " + ele.code + ","
              }else if(i !== x.length-1){
                str += ele.code + ","
              }else{
                str += ele.code
              }
            }else{
              appName = ele.application.code;
              str = appName + ": " + ele.code
            }
          })
          vm.permisosString.push(str);
        })
        return vm.permisosString
      }
      
      vm.cloneModal = function() {
        usuariosService.getCuentasUsuarios(cuentaSeleccionada).then(function (data) {
          vm.permisosString = []
          var todosPermisos = []
          var permisosSeleccionados = []
          var permisosNoSeleccionados = []
          // EXCLUSION DEL USUARIO SELECCIONADO PARA NO PODER COPIARLE SUS PROPIOS PERMISOS
          vm.userList = data.filter(function(user) {if(user.id !== usuarioSeleccionado.id){return user;}})
          obtPerfiles(vm.appsUsu)
          // PERMISOS A MOSTRAR EN EL MODAL
          todosPermisos = vm.arrayApps.map(function(x){
            if(!utilidades.isEmpty(x.data)){
              todosPermisos = x.data.filter(function(z){
                if(!utilidades.isEmpty(z.selected) && z.application.code !== 'GO'){
                  permisosSeleccionados.push(z)
                  return x.data
                }else if(utilidades.isEmpty(z.selected) && z.application.code !== 'GO'){
                  permisosNoSeleccionados.push(z)
                }
              })
            }
            return todosPermisos
          });
          todosPermisos = formatPermisos(todosPermisos);

          var obj = {
            el: vm.userList,
            permisosSeleccionados: permisosSeleccionados,
            permisosNoSeleccionados: permisosNoSeleccionados,
            usuario: usuarioSeleccionado,
            cuenta: cuentaSeleccionada,
            todosPermisos: todosPermisos
          }

          $uibModal.open({
            templateUrl: 'app/views/cuentas/modals/clonarPermisos.modal.html',
            controller: 'clonarPermisosController as vm',
            parent: angular.element(document.body),
            size: 'md',
            windowClass: 'clonar-permisos',
            resolve: {
              datos: function() {return obj;}
            }
          })
        })
      }

      // OBTIENE LOS VALORES SELECCIONADOS DE LA TABLA DE USUARIOS
      vm.lstPerfiles = function(index) {
        for (var i = 0; i < vm.arrayApps.length; i++) {
          if (angular.isDefined(vm.arrayApps[i].data[0]) && index === vm.arrayApps[i].data[0].application.code) {
            vm.perfilesApp.data = vm.arrayApps[i].data;
            //vm.perfilesApp.previousData = vm.arrayApps[i].data;
            vm.perfilesApp.previousData = angular.copy(vm.arrayApps[i].data);
            break;
          }
        }
      };

      // OBTIENE LOS PERFILES DE UNA CUENTA DEPENDIENDO DE EL USUARIO QUE ESTE SELECCIONADO
      function obtPerfiles(apps) {
        if (angular.isDefined(apps) && angular.isDefined(usuarioSeleccionado)) {
          vm.loading = true;
          permisosService.getPerfiles(apps, cuentaSeleccionada, usuarioSeleccionado).then(function(data) {
            vm.loading = false;
            if (data.length > 0) {
              vm.arrayApps = data;
              if (!tblCuentasService.obtinePermisos(4) && !tblCuentasService.obtinePermisos(5) && !tblCuentasService.obtinePermisos(8)) {
                angular.element('datik-permisos-manager #idCheckCabecera').attr("style", "pointer-events:none;none;opacity: 0.3;");
              }
              if (!tblCuentasService.obtinePermisos(4) && tblCuentasService.obtinePermisos(5) && cuentaSeleccionada.uid === usuario.acc && !tblCuentasService.obtinePermisos(8)) {
                angular.element('datik-permisos-manager #idCheckCabecera').attr("style", "pointer-events:none;none;opacity: 0.3;");
              }
              vm.perfilesApp.data = data[0].data;
              vm.perfilesApp.previousData = angular.copy(data[0].data);
            } else {
              vm.perfilesApp.data = [];
              vm.perfilesApp.previousData = [];
            }
          }, function(error) {
            notificaciones.showNotification(PERMISOS, error.error, "error");
            vm.vehiculos.data = [];
            vm.vehiculos.previousData = [];
            vm.mostrar.vehiculos = false;
            vm.loading = false;
          });
        }
      }

      // FUNCION QUE OBTIENE LAS APLICACIONES EXISTENTES DEL USUARIO SELECCIONADO
      function obtApps() {
        if (angular.isDefined(cuentaSeleccionada)) {
          vm.loading = true;
          permisosService.getApps(cuentaSeleccionada).then(function(data) {
            if (data.length > 0) {
              data.forEach(function(response) {
                if (response.code === "GO" && !tblCuentasService.obtinePermisos(8)) {
                  response.vistaApp = 'pointer-events:none;opacity: 0.6;';
                }
              });
              vm.appsUsu = data;
              $timeout(function() {
                vm.permisosIdx = 0;
              }, 0);
            } else {
              vm.appsUsu = [];
              vm.perfilesApp.data = [];
              vm.perfilesApp.previousData = [];
              vm.mostrar.apps = false;
              vm.loading = false;
            }
          }, function(error) {
            notificaciones.showNotification(PERMISOS, error.error, "error");
            vm.appsUsu = [];
            vm.mostrar.apps = false;
            vm.loading = false;
          });
        } else {
          vm.appsUsu = [];
          vm.mostrar.apps = false;
          vm.loading = false;
        }
      }

      // FUNCION QUE OBTIENE LAS APLICACIONES EXISTENTES DEL USUARIO SELECCIONADO
      function obtAppsTblUser() {
        if (angular.isDefined(cuentaSeleccionada)) {
          vm.loading = true;
          permisosService.getApps(cuentaSeleccionada).then(function(data) {
            if (data.length > 0) {
              data.forEach(function(response) {
                if (response.code === "GO" && !tblCuentasService.obtinePermisos(8)) {
                  response.vistaApp = 'pointer-events:none;opacity: 0.6;';
                }
              });
              vm.appsUsu = data;
              $timeout(function() {
                obtPerfiles(vm.appsUsu);
                vm.permisosIdx = 0;
              }, 0);
            } else {
              vm.appsUsu = [];
              vm.perfilesApp.data = [];
              vm.perfilesApp.previousData = [];
              vm.mostrar.apps = false;
              vm.loading = false;
            }
          }, function(error) {
            notificaciones.showNotification(PERMISOS, error.error, "error");
            vm.appsUsu = [];
            vm.mostrar.apps = false;
            vm.loading = false;
          });
        } else {
          vm.appsUsu = [];
          vm.mostrar.apps = false;
          vm.loading = false;
        }
      }

      // OBTIENE LOS DATOS SELECCIONADOS DE LA TABLA DE PERFILES DE UNA APLICACION
      $scope.$on('perfiles-table-change-selection', function(event, elementSelec) {
        validaPerfilApp(elementSelec);
      });

      // VALIDA QUE TENGA UN REGISTRO SELECCIONADO DE LA TABLA DE USUARIOS Y UN REGISTRO SELECCIONADO DE LA TABLA DE PERFILES, PARA DESPUES MODIFICAR O ELIMINAR UNA APLICACION
      function validaPerfilApp(datos) {
        if (angular.isDefined(datos)) {
          var permisosUpdate = [];
          var permisosDelete = [];
          var permisosOk = [];
          var permisosError = [];
          var message = "";
          vm.perfilesApp.previousData.forEach(function(previous) {
            for (var ii = 0; ii < vm.perfilesApp.data.length; ii++) {
              var actual = vm.perfilesApp.data[ii];
              if (actual.profileId === previous.profileId) {
                if (actual.selected && !previous.selected) {
                  permisosUpdate.push(actual);
                }
                if (!actual.selected && previous.selected) {
                  permisosDelete.push(actual);
                }
                break;
              }
            }
          });

          if (permisosUpdate.length > 0) {
            permisosService.putPerfilApp(permisosUpdate, cuentaSeleccionada, usuarioSeleccionado).then(function(data) {
              for (var i = 0; i < data.length; i++) {
                if (data[i].status === 204) {
                  permisosOk.push(data[i]);
                } else {
                  permisosError.push(data[i]);
                }
              }
              if (permisosOk.length) {
                message = (permisosOk.length > 1) ? permisosOk.length + " " + $translate.instant("permisos han sido modificados correctamente") : $translate.instant("La modificación del perfil fue realizada correctamente");
                notificaciones.showNotification(PERMISOS, message, "success");
                $scope.$emit('reloadTblUsuarios-Tab', usuarioSeleccionado);
              }
              if (permisosError.length) {
                message = (permisosError.length > 1) ? permisosError.length + " " + $translate.instant("permisos no se han podido modificar") : $translate.instant("El permiso no ha sido modificado correctamente");
                notificaciones.showNotification(PERMISOS, message, "error");
              }
            }, function(error) {
              notificaciones.showNotification(PERMISOS, error.error, "error");
            });
          }

          if (permisosDelete.length) {
            permisosService.deletePerfilApp(permisosDelete, cuentaSeleccionada, usuarioSeleccionado).then(function(data) {
              for (var i = 0; i < data.length; i++) {
                if (data[i].status === 204) {
                  permisosOk.push(data[i]);
                } else {
                  permisosError.push(data[i]);
                }
              }
              if (permisosOk.length) {
                message = (permisosOk.length > 1) ? permisosOk.length + " " + $translate.instant("permisos han sido eliminados correctamente") : $translate.instant("La eliminación del perfil fue realizada correctamente");
                notificaciones.showNotification(PERMISOS, message, "success");
                $scope.$emit('reloadTblUsuarios-Tab', usuarioSeleccionado);
              }
              if (permisosError.length) {
                message = (permisosOk.length > 1) ? permisosOk.length + " " + $translate.instant("permisos no se han podido eliminar") : $translate.instant("El permiso no ha sido eliminado correctamente");
                notificaciones.showNotification(PERMISOS, message, "error");
              }
            }, function(error) {
              notificaciones.showNotification(PERMISOS, error.error, "error");
            });
          }
          vm.perfilesApp.previousData = angular.copy(vm.perfilesApp.data);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikCuentasManager', datikCuentasManager);

  function datikCuentasManager() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/cuentas/directives/cuentasManager.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate', '$q', '$uibModal', '$mdDialog', 'timeZones', 'tblCuentasService', 'conexion', 'notificaciones', 'usuariosService', 'moment', cuentasManagerController ]
    };

    function cuentasManagerController($log, $scope, $filter, $translate, $q, $uibModal, $mdDialog, timeZones, tblCuentasService , conexion, notificaciones, usuariosService, moment) {

      var vm = this;

      vm.loading = true;
      vm.loadingCSV = false;
      vm.loadingBoton = false;
      vm.mostrar = {
        msjCuentas : false
      };
      vm.mostrar.msjCuentas = false;
      vm.permisoCuentas = true;
      var USUARIO = $translate.instant("Usuario");
      var CUENTAS = $translate.instant("Cuentas");

      vm.headerCuentas = [$translate.instant('Nombre'), $translate.instant('Tipo'), $translate.instant('cif'), $translate.instant('Idioma'), $translate.instant('Horario'), $translate.instant('Fecha Alta')];
      var tipo = [$translate.instant("Flota"), $translate.instant("Organización")];
      var language = ["en", "es", "fr"];
      var horario = timeZones;

      $scope.$on('reloadCuentaSeleccionada', function(event, dtos, flagUsu){
        var flag = flagUsu;
        vm.loading = true;
        vm.cuentas.data = [];
        vm.permisoCuentas = true;
        tblCuentasService.getCuentas("").then(function(data) {
          vm.loading = false;
          if(data.length > 0){
            data.forEach(function(elemento){
              if(elemento.uid == dtos.uidOperator){
                elemento.selected = true;
                dtos.uid = elemento.uid;
                dtos.type = elemento.type;
                $scope.$broadcast('cambiarPreviusSelection',elemento);
                $scope.$emit('seleccionaUsuario',dtos,elemento,flag);
              }
            });
            vm.loading = false;
            vm.cuentas.data = data;
            vm.permisoCuentas = false;
          } else {
            if (tblCuentasService.obtinePermisos(8)) {
              vm.permisoCuentas = false;
            } else if (tblCuentasService.obtinePermisos(2) && !tblCuentasService.obtinePermisos(3)) {
              vm.permisoCuentas = false;
            } else if (tblCuentasService.obtinePermisos(3)) {
              vm.permisoCuentas = false;
            }
          }
        },function(error){
          notificaciones.showNotification(CUENTAS, error.error, "error");
          vm.cuentas.data = [];
          vm.loading = false;
        });
      });

      // EVENTO QUE RECARGA LA TABLA DE CUENTAS, AL DAR DE ALTA UNA CUENTA
      $scope.$on('close-modal-cuentas', function(){
        $scope.refrescarCuentas();
      });

      $scope.refrescarCuentas = function() {
          vm.loadingBoton = false;
          obtenerCuentas();
      };

      // FUNCION QUE DESHABILITA O HABILITA EL BOTON DE EDITAR EN LA TABLA DE CUENTAS, DEPENDIENDO SUS PERMISOS
      var disabledNotDisabledEditCuenta = function(elemento){
        if (angular.isDefined(elemento)) {
          var usuario = conexion.getUsuario().acc;
          if (tblCuentasService.obtinePermisos(8)) {
            vm.permisoCuentas = false;
            return false;
          } else if (tblCuentasService.obtinePermisos(0)) {
            return true;
          } else if (tblCuentasService.obtinePermisos(1) && !tblCuentasService.obtinePermisos(2)) {
            if (elemento.uid !== usuario) {
              return true;
            }
          } else if (tblCuentasService.obtinePermisos(2) && !tblCuentasService.obtinePermisos(3)) {
            vm.permisoCuentas = false;
            if (elemento.type !== 1 && elemento.uid !== usuario) {
              return true;
            }
          } else if (tblCuentasService.obtinePermisos(3)) {
            vm.permisoCuentas = false;
            return false;
          } else {
            return true;
          }
        }
      };

      // FUNCION QUE DESHABILITA O HABILITA EL BOTON DE ELIMINAR EN LA TABLA DE CUENTAS, DEPENDIENDO SUS PERMISOS
      var disabledNotDisabledDeleteCuenta = function(elemento){
        var usuario = conexion.getUsuario().acc;
        if (tblCuentasService.obtinePermisos(8)) {
          return false;
        } else if (tblCuentasService.obtinePermisos(0)) {
          return true;
        } else if (tblCuentasService.obtinePermisos(1) && !tblCuentasService.obtinePermisos(2)) {
          return true;
        } else if (tblCuentasService.obtinePermisos(2) && !tblCuentasService.obtinePermisos(3)) {
          if (elemento.type !== 1) {
            return true;
          }
        } else if (tblCuentasService.obtinePermisos(3)) {
          if (elemento.uid === usuario) {
            return true;
          }
          return false;
        } else {
          return true;
        }
      };

      var shouldHideBtnInfo = function(){
        if (!tblCuentasService.obtinePermisos(3)) {
          return false;
        } else {
          return true;
        }
      };

      var shouldHideBtnEditParam = function(){
        if (tblCuentasService.obtinePermisos(3)) {
          return false;
        } else {
          return true;
        }
      };

      // CREACION DE LA TABLA DE CUENTAS
      vm.cuentas = {
        maxHeight: "calc(100vh - 150px)",
        currentPage: 1,
        perPage: 10000,
        elements: [{
          title: 'Nombre',
          information: 'name',
          type: 'string'
        }, {
          title: 'Tipo',
          information: 'tipo',
          type: 'string',
          sortArray: tipo
        }, {
          title: 'cif',
          information: 'cif',
          type: 'string'
        }, {
          title: 'Idioma',
          information: 'language',
          type: 'string',
          sortArray: language
        }, {
          title: 'Horario',
          information: 'timeZone',
          type: 'string',
          sortArray: horario
        }, {
          title: 'Fecha Alta',
          information: 'highDate',
          sort: 'reverse',
          type: 'date'
        }],
        options: {
          title: 'Acciones',
          showTitle: undefined,
          width: undefined,
          buttons: [{
            title: 'Editar Parametros',
            type: 'infoParamEdit',
            function: funcionEditParam,
            shouldHideBtn: shouldHideBtnEditParam
          }, {
            title: 'Info',
            type: 'info',
            function: funcionInfo,
            shouldHideBtn: shouldHideBtnInfo
          },{
            title: 'Editar',
            type: 'edit',
            disabled: disabledNotDisabledEditCuenta,
            function: funcionEditar
          }, {
            title: 'Eliminar',
            type: 'delete',
            disabled: disabledNotDisabledDeleteCuenta,
            function: funcionEliminar
          }]
        },
        selection: {
          mode: 'simple',
          getSelectedElements: undefined,
          changeSelectionEventName: $scope.accountevent
        },
        data: []
      };

      // OBTIENE UNA LISTA DE LAS CUENTAS EXISTENTES
      function obtenerCuentas() {
        tblCuentasService.getCuentas("").then(function(data) {
          vm.loading = false;
          if(data.length > 0){
            vm.loading = false;
            vm.cuentas.data = data;
            vm.datos = data;
            $scope.$emit('showMsjCuentas');
          } else {
            if (tblCuentasService.obtinePermisos(8)) {
              vm.permisoCuentas = false;
            } else if (tblCuentasService.obtinePermisos(2) && !tblCuentasService.obtinePermisos(3)) {
              vm.permisoCuentas = false;
            } else if (tblCuentasService.obtinePermisos(3)) {
              vm.permisoCuentas = false;
            }
          }
        },function(error){
          notificaciones.showNotification(CUENTAS, error.error, "error");
          vm.cuentas.data = [];
          vm.loading = false;
        });
      }

      vm.exportarCuentas = function(){
        var deferred = $q.defer();
        vm.loadingCSV = true;
        tblCuentasService.getCuentas("").then(function(data) {
          var newData = [];
          vm.loadingCSV = false;
          data.forEach(function(elemento){
            newData.push({name: elemento.name, type: elemento.tipo, cif: elemento.cif, language: elemento.language, horario: elemento.timeZone, fecha: elemento.fecha});
          });
          deferred.resolve(newData);
        },function(error){
          notificaciones.showNotification(CUENTAS, error.error, "error");
          vm.cuentas.data = [];
          vm.loading = false;
        });
        return deferred.promise;
      };

      vm.exportarUsuarios = function() {
        var deferred = $q.defer();
        vm.loadingCSV = true;
        usuariosService.getBsqUsuarios("").then(function(data) {
          var cuentas = tblCuentasService.getCuentas("").then(function(dataCuentas) {
            var newData = [];
            vm.loadingCSV = false;
            data.data.forEach(function(elemento) {
              var dtosCuenta = $filter('filter')(dataCuentas, {
                'uid': elemento.uidOperator
              });
              if (angular.isDefined(dtosCuenta[0])) {
                newData.push({
                  username: elemento.username,
                  name: elemento.name,
                  surname: elemento.surname,
                  email: elemento.email,
                  telephone: elemento.telephone,
                  typeAccount: dtosCuenta[0].tipo,
                  nameAccount: dtosCuenta[0].name,
                  initDate: moment(elemento.initDate).format('DD-MM-YYYY')
                });
              } else {
                newData.push({
                  username: elemento.username,
                  name: elemento.name,
                  surname: elemento.surname,
                  email: elemento.email,
                  telephone: elemento.telephone,
                  typeAccount: "-",
                  nameAccount: "-",
                  initDate: moment(elemento.initDate).format('DD-MM-YYYY')
                });
              }
            });
            deferred.resolve(newData);
          });
        }, function(error) {
          notificaciones.showNotification(USUARIO, error.error, "error");
          vm.usuarios.data = [];
          vm.mostrar.apps = false;
          vm.mostrar.msjUsuarios = true;
          vm.loading = false;
        });
        return deferred.promise;
      };

      // FUNCION QUE ABRE EL MODAL DE LA ALTA DE UNA CUENTA
      vm.agregar = function() {
        var elemento = {
          titulo:  $translate.instant("Añadir"),
          element: horario
        };
        var modalInstance = $uibModal.open({
          templateUrl: 'app/views/cuentas/modals/cuentas.modal.html',
          controller: 'altaCuentasController as vm',
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
        modalInstance.result.then(function() {
          vm.loadingBoton = true;
        });
      };

      // FUNCION QUE ABRE EL MODAL DE EDITAR UNA CUENTA
      function funcionEditar(data) {
        var elemento = {
          titulo: $translate.instant("Modificar"),
          element: data
        };
        $uibModal.open({
          templateUrl: 'app/views/cuentas/modals/cuentas.modal.html',
          controller: 'editarCuentasController as vm',
          scope: $scope,
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
      }

      // FUNCION QUE ABRE EL MODAL DE BAJA DE UNA CUENTA (BAJA LOGICA)
      function funcionEliminar(data) {
        data.nombre = $translate.instant("la cuenta")+ " " + data.name;
        var elemento = {
          titulo: $translate.instant("Confimación"),
          element: data
        };
        $mdDialog.show({
          controller: 'eliminarCuentasController as vm',
          /* parent: angular.element(document.body), */
          clickOutsideToClose: true,
          locals:{scopeDataToPass: $scope},
          resolve: {
            datos: function() {
              return elemento;
            }
          },
          template:
          '<md-dialog md-theme="default" aria-label="{{vm.titulo}}" ng-class="dialog.css" class="_md md-default-theme md-transition-in" role="dialog" tabindex="-1" aria-describedby="dialogContent_0">' +
          '  <md-dialog-content class="md-dialog-content" role="document" tabindex="-1">' +
          '    <h2 class="md-title ng-binding"><b>{{vm.titulo}}</b></h2>' +
          '    <div class="md-dialog-content-body ng-scope">' +
          '     <p class="ng-binding">{{"¿Desea eliminar" | translate}} {{vm.response.nombre}}?</p>' +
          '    </div>' +
          '  </md-dialog-content>' +
          '  <md-dialog-actions>' +
          '  <md-button ng-click="vm.close()" class="md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" type="button">' +
			    '     {{"Cancelar" | translate }} ' +
		      '   </md-button> ' +
          '  <md-button ng-click="vm.aceptar(vm.response)" class="md-primary md-raised md-confirm-button md-button md-ink-ripple md-default-theme" type="button">' +
          '     {{"Eliminar" | translate}}' +
          '  </md-button>' +
          ' </md-dialog-actions>' +
          '</md-dialog>'
        }).then(function() {
          $log.info("Dialog Close Account");
        });
      }

      // FUNCION QUE ABRE EL MODAL DE INFORMACION DE LOS PARAMETROS DE UNA CUENTA
      function funcionInfo(data) {
        var elemento = {
          titulo: $translate.instant("Parametros cuenta"),
          element: data
        };
        $uibModal.open({
          templateUrl: 'app/views/cuentas/modals/info.modal.html',
          controller: 'infoCuentasController as vm',
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
      }

      function funcionEditParam(data) {
        var elemento = {
          titulo: $translate.instant("Parametros cuenta"),
          element: data
        };
        $uibModal.open({
          templateUrl: 'app/views/cuentas/modals/editParam.modal.html',
          controller: 'editParamController as vm',
          size: 'md', // puede ser lg, md,sm segun el tamaño que se desee
          resolve: {
            datos: function() {
              return elemento;
            }
          }
        });
      }
      obtenerCuentas();
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikAppsCuentasManager', datikAppsCuentasManager);

  function datikAppsCuentasManager() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/cuentas/directives/appsCuentasManager.directive.html',
      controllerAs: 'vm',
      controller: ['$scope', '$translate', 'notificaciones', 'tblCuentasService', 'appsCuentasService', 'utilidades', '$mdDialog', appsCuentasManagerController]
    };

    function appsCuentasManagerController($scope, $translate, notificaciones, tblCuentasService, appsCuentasService, utilidades, $mdDialog) {

      var vm = this;
      var cuentaSeleccionada = undefined;
      vm.loading = true;
      var APLICACIONES = $translate.instant("Aplicaciones");

      vm.eventoApp = 'apps-cuentas';

      $scope.$on('cuenta-seleccionada', function(event, objetoEvento){
        vm.appsCuenta.data = [];
        vm.appsCuenta.previusData = [];
        cuentaSeleccionada = objetoEvento;
        obtAppsCuenta(cuentaSeleccionada);
      });

      $scope.$on('cuentaSeleccionadaBsqUsuario', function(event, objetoEvento){
        vm.appsCuenta.data = [];
        vm.appsCuenta.previusData = [];
        cuentaSeleccionada = objetoEvento;
        obtAppsCuenta(cuentaSeleccionada);
      });

      // CREACION DE LA TABLA APLICACIONES DE UNA CUENTA
      vm.appsCuenta = {
        maxHeight: "calc(100vh - 150px)",
        currentPage: 1,
        perPage: 10000,
        elements: [{
          title: 'Nombre',
          information: 'code',
          type: 'string'
        }, {
          title: 'Descripción',
          information: 'description',
          type: 'string'
        }, {
          title: 'Universal',
          information: 'universal',
          type: 'boolean'
        }],
        selection: {
          mode: 'checkbox',
          getSelectedElements: undefined,
          changeSelectionEventName: 'appCuenta-table-change-selection'
        },
        data: []
      };

      // OBTIENE LAS APLICACIONES DE UNA CUENTA
      function obtAppsCuenta(cuenta) {
        if (!utilidades.isEmpty(cuenta)) {
          vm.loading = true;
          appsCuentasService.getAllAppsCuenta(cuenta).then(function(data) {
            if (!utilidades.isEmpty(data.cancel) && data.cancel) {
              vm.loading = false;
              angular.element("datik-apps-cuentas-manager #datikTableEmptyMessage").text($translate.instant("Ha ocurrido un error al intentar obetener las aplicaicones de la cuenta seleccionada."));
            } else if(data.length > 0) {
              vm.loading = false;
              data.forEach(function(x){
                if (tblCuentasService.obtinePermisos(8) || tblCuentasService.obtinePermisos(7)) {
                  x.disabled = "";
                  angular.element('datik-apps-cuentas-manager #idCheckCabecera').attr("style","pointer-events:none;none;opacity: 0.3;");
                }
              });

              vm.appsCuenta.data = data;
              vm.appsCuenta.previusData = angular.copy(data);
            } else {
              angular.element("datik-apps-cuentas-manager #datikTableEmptyMessage").text($translate.instant("La cuenta seleccionada no tiene aplicaciones asociados"));
              vm.appsCuenta.data = [];
              vm.appsCuenta.previusData = [];
            }
          }, function(){
            vm.appsCuenta.data = [];
            vm.appsCuenta.previusData = [];
            vm.loading = false;
            angular.element("datik-apps-cuentas-manager #datikTableEmptyMessage").text($translate.instant("Ha ocurrido un error al intentar obetener las aplicaicones de la cuenta seleccionada."));
          })
        }
      }

      // OBTIENE LOS DATOS SELECCIONADOS DE LA TABLA DE APLICACIONES DE UNA CUENTA
      $scope.$on('appCuenta-table-change-selection', function() {
        var selectedApp = getSelectedApp();
        if (!utilidades.isEmpty(selectedApp)) {
          showConfirmation(selectedApp).then(function(){
            validaAppCuenta(selectedApp)
          }, function(){
            obtAppsCuenta(cuentaSeleccionada)
          });
        }
      });

      function showConfirmation (selectedApp){
        return $mdDialog.show(
          $mdDialog.confirm()
          .title($translate.instant('Atencion'))
          .textContent($translate.instant('Estas seguro de que quieres añadir/quitar la aplicación XXX de la cuenta YYYY?', {app : selectedApp.code, account : cuentaSeleccionada.name}))
          .ok($translate.instant('Confirmar'))
          .cancel($translate.instant('Cancelar'))
        )
      }

      function getSelectedApp(){
        return vm.appsCuenta.previusData.find(function(oldApp){
            return vm.appsCuenta.data.find(function(newApp){
              return oldApp.id === newApp.id && (oldApp.selected && !newApp.selected || !oldApp.selected && newApp.selected)
            })
        })
      }

      function addAppInAccount(actual){
        appsCuentasService.putAppCuenta(actual, cuentaSeleccionada).then(function(data) {
          if(data.status === 204){
            notificaciones.showNotification(APLICACIONES, $translate.instant("La modificación de la aplicación fue realizada correctamente"), "success");
            obtAppsCuenta(cuentaSeleccionada)
            $scope.$emit('reload-usuarios');
          } else {
            notificaciones.showNotification(APLICACIONES, $translate.instant("Ocurrió un error inesperado al agregar una aplicación"), "error");
          }
        },function(error){
          notificaciones.showNotification(APLICACIONES, error.error, "error");
        });
      }

      function deleteAppFromAccount(actual){
        appsCuentasService.deleteAppCuenta(actual, cuentaSeleccionada).then(function(data) {
          if(data.status === 204){
            notificaciones.showNotification(APLICACIONES, $translate.instant("La eliminación de la aplicación fue realizada correctamente"), "success");
            obtAppsCuenta(cuentaSeleccionada)
            $scope.$emit('reload-usuarios');
          } else {
            notificaciones.showNotification(APLICACIONES, $translate.instant("Ocurrió un error inesperado al eliminar una aplicación"), "error");
          }
        },function(error){
          notificaciones.showNotification(APLICACIONES, error.error, "error");
        });
      }

      // VALIDA QUE TENGA UN REGISTRO SELECCIONADO DE LA TABLA DE APLICACIONDES DE UNA CUENTA PARA DESPUES MODIFICAR O ELIMINAR UNA APLICACION
      function validaAppCuenta(selectedApp) {
        if(selectedApp.selected){
          deleteAppFromAccount(selectedApp)
        } else {
          addAppInAccount(selectedApp)
        }

        vm.appsCuenta.previusData = angular.copy(vm.appsCuenta.data);
      }

    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('app')
    .directive('datikApadrinamientoManager', datikApadrinamientoManager);

  function datikApadrinamientoManager() {
    return {
      restrict: 'E',
      scope: {
        // accountevent: '@'
      },
      templateUrl: 'app/views/cuentas/directives/apadrinamientoManager.directive.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate',
        '$timeout', '$uibModal', 'timeZones', 'notificaciones', 'tblCuentasService', 'vehiculosService', apadrinamientoManagerController
      ]
    };

    function apadrinamientoManagerController($log, $scope, $filter, $translate,
      $timeout, $uibModal, timeZones, notificaciones, tblCuentasService, vehiculosService) {

      var vm = this;
      var cuentaSeleccionada = undefined;
      var cuentaSeleccionadaVin = undefined;
      var cadenaMigas = undefined;
      var migas = "";
      var APADRINAMIENTOS = $translate.instant("Apadrinamientos");

      vm.loading = true;
      vm.mostrar = {
        vehiculos: false
      };

      vm.eventoVehiculoSeleccion = 'vehiculo-table-change-selection';

      $scope.$on('cuenta-seleccionada', function(event, objetoEvento){
        vm.vehiculos.data = [];
        vm.vehiculos.previusData = [];
        cuentaSeleccionada = objetoEvento;
      });

      $scope.$on('cuentaVinculacion-seleccionada', function (event, objetoEvento){
        cuentaSeleccionadaVin = objetoEvento;
        if (angular.isDefined(cuentaSeleccionadaVin) && cuentaSeleccionadaVin.type === 1) {
            vm.vehiculos.data = [];
            vm.vehiculos.previusData = [];
            getVehiculos();
            vm.organizacionPadre = cuentaSeleccionada.name;
            vm.flotaHijo = cuentaSeleccionadaVin.name;
        }
      });

      $scope.$on('array-migas', function (event, objetoEvento){
        cadenaMigas = objetoEvento;
        migas = "";
        if (angular.isDefined(cadenaMigas)) {
          for (var ii = 1; ii < cadenaMigas.length; ii++) {
            migas += cadenaMigas[ii].uid + ">";
          }
          migas = migas.substring(0,migas.length-1);
        }
      });

      // CREACION DE LA TABLA APLICACIONES DE UNA CUENTA
      vm.vehiculos = {
        maxHeight: "calc(100vh - 150px)",
        currentPage: 1,
        perPage: 1000000,
        elements: [{
          title: 'Código',
          information: 'code',
          type: 'string'
        }, {
          title: 'Matrícula',
          information: 'registration',
          type: 'string'
        }, {
          title: 'Motor',
          information: 'model',
          type: 'string'
        }],
        selection: {
          mode: 'checkbox',
          getSelectedElements: undefined,
          changeSelectionEventName: vm.eventoVehiculoSeleccion
        },
        data: []
      };

      // OBTIENE LOS DATOS SELECCIONADOS DE LA TABLA DE PERFILES DE UNA APLICACION
      //var timeout;
      $scope.$on(vm.eventoVehiculoSeleccion, function(event, elementSelec) {
        sponsorUnsponsorVehicles(elementSelec);
      });

      function getVehiculos() {
        if (angular.isDefined(cuentaSeleccionada) && angular.isDefined(cuentaSeleccionadaVin)) {
          vm.loading = true;
          vehiculosService.getVehiculos(cuentaSeleccionada,cuentaSeleccionadaVin).then(function(data) {
            vm.loading = false;
            if(data.length > 0){
              for (var ii = 0; ii < data.length; ii++) {
                if (tblCuentasService.obtinePermisos(8)) {
                  data[ii].disabled = "";
                } else if (tblCuentasService.obtinePermisos(6)) {
                  data[ii].disabled = "";
                } else if (!tblCuentasService.obtinePermisos(6)) {
                  angular.element('datik-apadrinamiento-manager #idCheckCabecera').attr("style","pointer-events:none;none;opacity: 0.3;");
                } else if (tblCuentasService.obtinePermisos(0) && !tblCuentasService.obtinePermisos(6)) {
                  angular.element('datik-apadrinamiento-manager #idCheckCabecera').attr("style","pointer-events:none;none;opacity: 0.3;");
                }
              }
              vm.vehiculos.data = data;
              vm.vehiculos.previusData = angular.copy(data);
            } else {
              angular.element("datik-apadrinamiento-manager #datikTableEmptyMessage").text($translate.instant("La flota seleccionada no tiene apadrinamientos asociados"));
              vm.vehiculos.data = [];
              vm.vehiculos.previusData = [];
            }
          },function(error){
              notificaciones.showNotification(APADRINAMIENTOS, error.error, "error");
              // vm.vehiculos.data = [];
              // vm.vehiculos.previusData = [];
              vm.mostrar.vehiculos = false;
              vm.loading = false;
          });
        }
      }

      function sponsorUnsponsorVehicles(datos){
        if (angular.isDefined(datos)) {
          var vehiclesToSponsor = [];
          var vehiclesToUnsponsor = [];
          vm.vehiculos.previusData.forEach(function(previus) {
            for (var ii = 0; ii < vm.vehiculos.data.length; ii++) {
              var actual = vm.vehiculos.data[ii];
              if (actual.id === previus.id) {
                if (actual.selected && !previus.selected) {
                  vehiclesToSponsor.push(actual);
                }
                if (!actual.selected && previus.selected) {
                  vehiclesToUnsponsor.push(actual);
                }
                break;
              }
            }
          });

          if(vehiclesToSponsor.length > 0) {
            vehiculosService.postVehiculo(vehiclesToSponsor, cuentaSeleccionada, cuentaSeleccionadaVin, migas).then(function(data) {
              if(data.status === 200){
                var message = (vehiclesToSponsor.length > 1) ? vehiclesToSponsor.length + " " + $translate.instant("vehículos apadrinados correctamente") : $translate.instant("Vehículo apadrinado correctamente");
                notificaciones.showNotification(APADRINAMIENTOS, message, "success");
              } else{
                notificaciones.showNotification(APADRINAMIENTOS, $translate.instant("Error al intentar apadrinar vehículos"), "error");
                getVehiculos();
              }
            },function(error){
              notificaciones.showNotification(APADRINAMIENTOS, error.error, "error");
              getVehiculos();
            });
          }

          if(vehiclesToUnsponsor.length > 0) {
            vehiculosService.deleteVehiculo(vehiclesToUnsponsor, cuentaSeleccionada, cuentaSeleccionadaVin, migas).then(function(data) {
              if(data.code === 200){
                var message = (vehiclesToUnsponsor.length > 1) ? vehiclesToUnsponsor.length + " " + $translate.instant("apadrinamientos borrados correctamente") : $translate.instant("Apadrinamiento borrado correctamente");
                notificaciones.showNotification(APADRINAMIENTOS, message, "success");
              }else{
                notificaciones.showNotification(APADRINAMIENTOS, $translate.instant("Error al intentar eliminar un vehículo"), "error");
                getVehiculos();
              }
            },function(error){
              notificaciones.showNotification(APADRINAMIENTOS, error.error, "error");
              getVehiculos();
            });
          }

          vm.vehiculos.previusData = angular.copy(vm.vehiculos.data);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:infoCuentasController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('infoCuentasController', infoCuentasController);

  function infoCuentasController($log, $uibModalInstance, datos, parametrosService) {
    var vm = this;

    // CREA LA TABLA DE INFORMACION DE UNA CUENTA
    vm.informacion = {
      maxHeight: "calc(100vh - 150px)",
      currentPage: 1,
      perPage: 10,
      elements: [{
        title: 'Parámetro',
        information: 'parameter',
        type: 'string'
      }, {
        title: 'Valor',
        information: 'value',
        type: 'string'
      }],
      data: []
    };

    vm.loading = true;
    // OBTIENE LOS PARAETRO DE LA CUENTA Y PINTA LA TABLA DE INFORMACION
    parametrosService.infoCuenta(datos.element).then(function(response){
      vm.loading = false;
      vm.informacion.data = response;
    });

    vm.titulo = datos.titulo;

    // CIERRA EL MODAL DE INFORMACION DE UNA CUENTA
    vm.close = function() {
      $uibModalInstance.dismiss();
    };
    $uibModalInstance.close(vm.response);
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:eliminarVinculacionrController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('eliminarVinculacionrController', eliminarVinculacionrController);

  function eliminarVinculacionrController($log, $mdDialog, scopeDataToPass, datos, notificaciones, $translate, vinculacionService) {
    var vm = this;
    vm.response = angular.copy(datos.element);
    vm.titulo = datos.titulo;
    vm.cuenta = datos.cuenta;
    vm.close = function() {
      $mdDialog.cancel();
    };

    var VINCULACION = $translate.instant("Vinculación");

    // FUNCION QUE ELIMINA UNA Vinculacion
    vm.aceptar = function(dato){
      dato.cuenta = vm.cuenta;
      $mdDialog.hide();
      vinculacionService.deleteVinculacion(dato).then(function(data){
        if(data.code === 200){
          notificaciones.showNotification(VINCULACION, $translate.instant("La eliminación del operador fue realizada correctamente"), "success");
          scopeDataToPass.refrescarVinculacion();
        }else{
          notificaciones.showNotification(VINCULACION, $translate.instant("Error al intentar Eliminar un operador"), "error");
          scopeDataToPass.refrescarVinculacion();
        }
      },function(error){
          notificaciones.showNotification(VINCULACION, $translate.instant("Error al intentar dar de alta un operador")  + error, "error");
          scopeDataToPass.refrescarVinculacion();
      });
    };
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:mensajeCuentasController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('eliminarUsuarioController', eliminarUsuarioController);

  function eliminarUsuarioController($log, $mdDialog, scopeDataToPass, datos, notificaciones, $translate, usuariosService) {
    var vm = this;
    vm.response = angular.copy(datos.element);
    vm.titulo = datos.titulo;
    vm.cuenta = datos.cuenta;
    vm.close = function() {
      $mdDialog.cancel();
    };

    var USUARIOS = $translate.instant("Usuarios");

    // FUNCION QUE ELIMINA UN USUARIO
    vm.aceptar = function(dato){
      dato.cuenta = vm.cuenta;
      $mdDialog.hide();
      usuariosService.deleteUsuario(dato).then(function(data){
        if(data.status === 204){
          notificaciones.showNotification(USUARIOS, $translate.instant("La eliminación del usuario fue realizada correctamente"), "success");
          scopeDataToPass.refrescarUsuarios();
        }else{
          notificaciones.showNotification(USUARIOS, $translate.instant("Error al intentar Eliminar un usuario"), "error");
          scopeDataToPass.refrescarUsuarios();
        }
      },function(error){
          notificaciones.showNotification($translate.instant("Cuentas"), $translate.instant("Error al intentar dar de alta una cuenta")  + error, "error");
          scopeDataToPass.refrescarUsuarios();
      });
    };
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:eliminarCuentasController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('eliminarCuentasController', eliminarCuentasController);

  function eliminarCuentasController($log, $mdDialog, scopeDataToPass, datos, notificaciones, $translate, tblCuentasService) {
    var vm = this;
    vm.response = angular.copy(datos.element);
    vm.titulo = datos.titulo;
    vm.close = function() {
      $mdDialog.cancel();
    };

    var CUENTAS = $translate.instant("Cuentas");

    // FUNCION QUE ELEMINA UNA CUENTA
    vm.aceptar = function(dato){
      $mdDialog.hide();
      tblCuentasService.deleteCuenta(dato).then(function(data){
        if(data.status === 200){
          notificaciones.showNotification(CUENTAS, $translate.instant("La eliminación de una cuenta fue realizada correctamente"), "success");
          scopeDataToPass.refrescarCuentas();
        }else{
          notificaciones.showNotification(CUENTAS, $translate.instant("Error al intentar Eliminar una cuenta"), "error");
          scopeDataToPass.refrescarCuentas();
        }
      },function(error){
          notificaciones.showNotification(CUENTAS, $translate.instant("Error al intentar dar de alta una cuenta")  + error, "error");
          scopeDataToPass.refrescarCuentas();
      });
    };
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:editarUsuarioController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('editarUsuarioController', editarUsuarioController);

  function editarUsuarioController($log, $uibModalInstance, $scope, $filter, timeZones, datos, notificaciones, $translate, tblCuentasService, usuariosService) {
    var vm = this;
    vm.response = angular.copy(datos.element);
    vm.fecha = "";
    vm.titulo = datos.titulo;
    vm.cuenta = datos.cuenta;
    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    vm.showCuentas = true;

    var USUARIOS = $translate.instant("Usuarios");

    // OBTIENE UNA LISTA DE LAS CUENTAS EXISTENTES
    function obtenerCuentas() {
      tblCuentasService.getCuentas("").then(function(data) {
        vm.loading = false;
        if(data.length > 0){
          vm.loading = false;
          vm.cuentas = data;
          vm.response.account= $filter('filter')(data, {'uid': vm.response.uidOperator})[0];
        } else {
          vm.cuentas = [];
        }
      },function(error){
        notificaciones.showNotification($translate.instant("Cuentas"), error.error, "error");
        vm.cuentas = [];
        vm.loading = false;
      });
    }

    // FUNCION QUE EDITA UN USUARIO
    vm.guardar = function(dato){
      dato.cuenta = vm.cuenta;
      $uibModalInstance.close();
      usuariosService.editUsuario(dato).then(function(data){
        if(data.status === 204){
          notificaciones.showNotification(USUARIOS, $translate.instant("La modificación del usuario fue realizada correctamente"), "success");
          $scope.refrescarUsuarios();
        }else{
          notificaciones.showNotification(USUARIOS, $translate.instant("Error al intentar modificar el usuario"), "error");
        }
      },function(error){
          notificaciones.showNotification(USUARIOS, $translate.instant("Error al intentar dar de alta una cuenta")  + error, "error");
          $scope.refrescarUsuarios();
      });
    };
    obtenerCuentas();
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:editarCuentasController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('editarCuentasController', editarCuentasController);

  function editarCuentasController($uibModalInstance, $scope, timeZones, datos, notificaciones, $translate, tblCuentasService, utilidades) {
    var vm = this;
    vm.includesTV
    vm.loading = true
    vm.response = angular.copy(datos.element);
    vm.timeZone = timeZones;
    vm.response.type = vm.response.type+'';
    vm.disableSaveAccount = true;
    vm.response.visibleUid = true;
    vm.fecha = "";
    vm.titulo = datos.titulo;
    vm.disable = true
    vm.cuenta = datos.element
    var CUENTAS = $translate.instant("Cuentas");

    vm.validateAccountName = function (value) {
      if(utilidades.isEmpty(value.name)){
        vm.disableSaveAccount = true;
      } else {
        if(utilidades.includesSpecialCharacters(value.name)){
          vm.disableSaveAccount = true;
          vm.error = 'El nombre no puede tener caracteres especiales'
        } else {
          vm.error = ''
          vm.disableSaveAccount = false;
        }
      }
    };

    // FUNCION QUE EDITA UNA CUENTA
    vm.guardar = function(dato){
      vm.error="";
      if(angular.isUndefined(dato)){
        vm.error = "Introduzca los datos de la cuenta";
        return;
      }
      if(angular.isUndefined(dato.name)){
        vm.error = "Introduzca el nombre de la cuenta";
        return;
      }
      if(angular.isUndefined(dato.type)){
        vm.error = "Introduce el tipo de cuenta";
        return;
      }
      if(angular.isUndefined(dato.cif)){
        vm.error = "Introduzca el cif";
        return;
      }
      if(angular.isUndefined(dato.timeZone)){
        vm.error = "Introduce la zona horaria";
        return;
      }
      if(angular.isUndefined(dato.language)){
        vm.error = "Introduce el idioma";
        return;
      }

      $uibModalInstance.close();

      tblCuentasService.editCuentas(dato).then(function(data){
        if(data.status === 200){
          notificaciones.showNotification(CUENTAS, $translate.instant("La modificación de una cuenta fue realizada correctamente"), "success");
          $scope.refrescarCuentas();
        }else{
          notificaciones.showNotification(CUENTAS, $translate.instant("Error al intentar Modificar una cuenta"), "error");
        }
      },function(error){
          notificaciones.showNotification(CUENTAS, $translate.instant("Error al intentar Modificar una cuenta")  + error, "error");
          $scope.refrescarCuentas();
      });
    };

    vm.close = function() {
      $uibModalInstance.dismiss();
    };
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:infoCuentasController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('editParamController', editParamController);

  function editParamController($log, $uibModalInstance, $translate, $scope, datos, $filter, parametrosService, permisosService, tblCuentasService, utilidades, notificaciones) {
    var vm = this;
    var datosCuenta = datos;
    var paramtroSeleccionado;
    vm.loading = true;
    vm.paramAE = true;
    vm.loadingParam = false;
    vm.disabledParam = true;
    vm.titulo = datos.titulo;
    var cameraQty;
    var TV = 6;
    var FLOTA = 1;
    vm.loadingCameras = true;
    var CUENTAS = $translate.instant("Cuentas");

    vm.response = {
      param: undefined
    };
    // CIERRA EL MODAL DE INFORMACION DE UNA CUENTA
    vm.close = function() {
      $uibModalInstance.dismiss();
    };
    $uibModalInstance.close(vm.response);

    vm.eventoParametroSeleccion = "param-table-change-selection";

    // CREA LA TABLA DE INFORMACION DE UNA CUENTA
    vm.editParam = {
      maxHeight: "calc(100vh - 150px)",
      currentPage: 1,
      perPage: 10,
      elements: [{
        title: 'Parámetro',
        information: 'parameter',
        type: 'string'
      }, {
        title: 'Valor',
        information: 'value',
        type: 'string'
      }],
      selection: {
        mode: 'simple',
        getSelectedElements: undefined,
        changeSelectionEventName: vm.eventoParametroSeleccion
      },
      data: []
    };

    function getAppsSelectedAccount(){
      permisosService.getApps(datos.element).then(success, fail).catch(fail).finally(function(){vm.loadingCameras = false})

      function success(response){
        vm.isTipoFlota = datos.element.type === FLOTA
        vm.includesTV = response.find(function (x){return x.id === TV ? true : false})

        if(vm.includesTV && vm.isTipoFlota){
          getCameras()
        }
      }

      function fail(){
        $log.info("Error obteniendo las aplicaciones de la cuenta" + datos.element.uid)
      }
    }

    function getCameras(equipment) {
      tblCuentasService.getCameras(datosCuenta.element, equipment).then(function(response){
        if(!utilidades.isEmpty(response.data)){
          cameraQty = response.data.cameraQty
          vm.response.cameraAmount = response.data.cameraQty
        }else{
          vm.response.cameraAmount = 0
        }
      })
    }

     vm.checkInfo = function (dato){
      vm.disable = utilidades.isEmpty(dato) || dato === cameraQty
    }
  
    vm.putCamerasAmount = function(equipment) {
      var cameraAmount = {cameraQty : vm.response.cameraAmount}
      tblCuentasService.putCameras(datos.element, cameraAmount, equipment).then(success, fail).catch(fail)
      
      function success() {
        notificaciones.showNotification(CUENTAS, $translate.instant("La modificación de numero de camaras fue realizada correctamente"), "success");
        vm.disable = true
      }

      function fail() {
        notificaciones.showNotification(CUENTAS, $translate.instant("Error modificar el numero de camaras"), "error");
      }
    }

    vm.autenticacionArray = [{'value': 'RFID'}, {'value': 'DALLAS_KEY'}, {'value': 'TACOGRAPH'},
                             {'value': 'FACE_ID'}, {'value': 'CODE'}, {'value': 'USER_PASS'}, {'value': 'EXTERNAL'}];

    // VALIDA LOS DATOS QUE SE INGRESAN PARA LOS VALORES DEL PARAMETRO
    vm.valida = function(e, permitidos) {
      var permidosCopy = permitidos;
      var numeros = "0123456789";
      var caracteres = " abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMN‘OPQRSTUVWXYZ@.";
      var decimales = "0123456789.";
      var numeros_caracteres = numeros + caracteres;

      switch (permitidos) {
        case 'num':
          permitidos = numeros;
          break;
        case 'dec':
          permitidos = decimales;
          break;
        case 'num_car':
          permitidos = numeros_caracteres;
          break;
      }

      var evento = e || window.event;
      var codigoCaracter = evento.charCode || evento.keyCode;
      var caracter = String.fromCharCode(codigoCaracter);
      if (permidosCopy == 'dec' && vm.response.valueParam.indexOf(".") === 1 && caracter === ".") {
        e.preventDefault();
      }
      if (permitidos.indexOf(caracter) === -1) {
        e.preventDefault();
      }
    };

    // SELECCIONA O DESELECCIONA UN REGISTRO DE LA TABLA DE PARAMTROS
    $scope.$on(vm.eventoParametroSeleccion, function(event, objetoEvento) {
      if (angular.isDefined(objetoEvento[0])) {
        vm.editParamForm.$setUntouched();
        vm.editParamForm.$setPristine();
        paramtroSeleccionado = objetoEvento[0];
        vm.paramAE = false;
        vm.editParametroSelec = objetoEvento[0].parameter;
        vm.tipoParametro = undefined;
        validaTipoDto(objetoEvento[0]);
        vm.response.valueParam = objetoEvento[0].value;
        vm.disabledParam = false;
      } else {
        vm.editParamForm.$setUntouched();
        vm.editParamForm.$setPristine();
        paramtroSeleccionado   = undefined;
        vm.editParametroSelec  = undefined;
        vm.disabledParam       = true;
        vm.paramAE             = true;
        vm.response.valueParam = "";
        obtieneTiposParam();
      }
    });

    // OBTIENE LOS PARAETRO DE LA CUENTA Y PINTA LA TABLA DE EDITAR PARAMETROS
    function obtieneParametros(datos) {
      parametrosService.infoCuenta(datos.element).then(function(response) {
        vm.loadingParam = false;
        vm.editParamForm.$setUntouched();
        vm.editParamForm.$setPristine();
        vm.disabledParam = true;
        vm.paramAE = true;
        vm.loading = false;
        vm.editParam.data = response;
        obtieneTiposParam();
      });
    }

    // OBTIENE LOS TIPOS DE PARAMETROS EXITENTES
    function obtieneTiposParam() {
      parametrosService.obtieneTiposParam().then(function(response) {
        response.forEach(function(element) {
          var dtosParam = $filter('filter')(vm.editParam.data, {'parameter': element.parameter});
          if (angular.isDefined(dtosParam[0])) {
            element.existe = true;
            dtosParam[0].type = element.type;
          } else {
            element.existe = false;
          }
        });
        response = $filter('filter')(response, {existe: false}, false);
        vm.response.param = response[0];
        validaTipoDto(vm.response.param);
        vm.tiposParam = response;
      });
    }

    vm.clearSearchTerm = function() {
      vm.searchTerm = '';
    };

    // CAMBIA EL TIPO DE VALIDACION QUE SE INGRESARA AL VALOR DEL PARAMETRO
    vm.changeParam = function(param) {
      if (angular.isDefined(param)) {
        vm.tipoParametro = undefined;
        vm.disabledParam = true;
        vm.response.valueParam = "";
        validaTipoDto(param);
      }
    };

    function validaTipoDto(value) {
      if (value.type === 'string' && value.parameter === "AUTENTICACION_CONDUCTOR") {
        vm.tipoParametro = 'select';
        vm.parametroTipo = $translate.instant('de tipo Array');
      } else if (value.type === 'string') {
        vm.tipoParametro = 'num_car';
        vm.parametroTipo = $translate.instant('de tipo texto');
      } else if (value.type === 'integer') {
        vm.tipoParametro = 'num';
        vm.parametroTipo = $translate.instant('de tipo numérico');
      } else if (value.type === 'double') {
        vm.tipoParametro = 'dec';
        vm.parametroTipo = $translate.instant('de tipo decimal');
      } else {
        vm.tipoParametro = value.type;
        vm.parametroTipo = $translate.instant('de tipo binario');
      }
    }

    // VALIDA QUE SE ALLAN CAPTURADO EL VALOR DEL PARAMETRO Y TE HABILITA O DESHABILITA EL BOTON
    vm.validaDtosParam = function(dtos) {
      if(angular.isDefined(dtos.valueParam)) {
        vm.disabledParam = false;
      } else {
        vm.disabledParam = true;
      }
    };

    // AGREGA UN NUEVO PARAMETRO A LA CUENTA SELECCIONADA
    vm.agregarParametro = function(datos) {
      if (angular.isDefined(datos) && datos !== "") {
        vm.loadingParam = true;
        parametrosService.postParam(datosCuenta.element, datos).then(function(response) {
          resetValueError();
          vm.response.valueParam = undefined;
          obtieneParametros(datosCuenta);
        });
      }
    };

    // EDITA EL PARAMETRO SELECCIONADO DE LA CUENTA SELECCIONADA
    vm.editarParametro = function(datos) {
      if (angular.isDefined(datos)) {
        vm.loadingParam = true;
        parametrosService.putParam(datosCuenta.element, paramtroSeleccionado, datos).then(function(response) {
          resetValueError();
          vm.response.valueParam = undefined;
          obtieneParametros(datosCuenta);
        });
      }
    };

    function resetValueError() {
      vm.editParamForm.param.$setUntouched();
      vm.editParamForm.param.$setPristine();

      vm.editParamForm.text.$setUntouched();
      vm.editParamForm.text.$setPristine();

      vm.editParamForm.boolean.$setUntouched();
      vm.editParamForm.boolean.$setPristine();

      vm.editParamForm.select.$setUntouched();
      vm.editParamForm.select.$setPristine();
    }

    obtieneParametros(datos);
    getAppsSelectedAccount()
  }
})();

(function () {
    'use strict';

    /**
     * @ngdoc function
     * @name app.controller:clonarPermisosController
     * @description
     * # ModalsCtrl
     * Controller of the Analisis
     */
    angular.module('app').controller('clonarPermisosController', clonarPermisosController);

    function clonarPermisosController(permisosService, notificaciones, $mdDialog, $uibModalInstance, datos, $translate, $scope, $rootScope, $q) {
        var vm = this;
        var cuentaSeleccionada = datos.cuenta;
        vm.user;
        vm.userList = datos.el;
        vm.permisosSeleccionados = datos.permisosSeleccionados;
        vm.permisosNoSeleccionados = datos.permisosNoSeleccionados;
        vm.todosPermisos = datos.todosPermisos;
        vm.usDestino;
        vm.str = $translate.instant('Los permisos del usuario {{nombreOrigen}} seran copiados a ', { nombreOrigen: datos.usuario.name });
        vm.getUser = function (user) {vm.usDestino = user}
        // FUNCION QUE COPIA LOS PERMISOS DEL USUARIO SELECCIONADO
        vm.copiarPermisos = function (usuario) {
            usuario = JSON.parse(usuario)
            var counter = 0
            $rootScope.$emit('clone-state', true);

            // PERMISOS A SER ELIMINADOS
            var delte = permisosService.deletePerfilApp(vm.permisosNoSeleccionados, cuentaSeleccionada, usuario).then().catch()
            // PERMISOS A SER AÑADIDOS
            var put = permisosService.putPerfilApp(vm.permisosSeleccionados, cuentaSeleccionada, usuario).then().catch()

            $q.all([delte, put]).then(ok).catch(error).finally($uibModalInstance.dismiss());

            function ok(response) {
                response.forEach(function (resp){resp.every(function (x) {return x.status === 204 }) ? counter++ : counter})
                if (counter === 2) {
                    notificaciones.showNotification("PERMISOS", "Permisos copiados exitosamente.", "success");
                } else {
                    notificaciones.showNotification("PERMISOS", "Ocurrio un error al copiar los permisos.", "error");
                }
                $rootScope.$emit('clone-state', false);
            }
            function error(error) { return error; }
        }
        
        vm.close = function () {
            $uibModalInstance.dismiss();
        }
    }
})();
(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:altaVinculacionController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('altaVinculacionController', altaVinculacionController);

  function altaVinculacionController($translate, $log, $uibModalInstance, $scope, datos, notificaciones, vinculacionService, conexion, tblCuentasService, $q, $timeout) {
    var vm = this;
    var orgFlo = "";
    var lstD = [];
    var lstDtos = "";
    vm.titulo = datos.titulo;
    vm.nombre = datos.name;
    vm.cuenta = datos.cuenta;
    vm.vinculaciones = datos.vinculaciones;
    vm.orgFlo = "";
    vm.flota = false;
    vm.organizacion = false;
    vm.simulateQuery = false;

    var VINCULACION = $translate.instant("Vinculación");

    // VALIDA QUE MUESTRE ORGANIZACIONES,FLOTAS O AMBAS, DEPENDIENDO SUS PERMISOS
    if(tblCuentasService.obtinePermisos(8) || tblCuentasService.obtinePermisos(2)){
      vm.orgFlo = $translate.instant("Organización") + " / " + $translate.instant("Flota");
    } else if (tblCuentasService.obtinePermisos(2) && !tblCuentasService.obtinePermisos(3)){
      orgFlo = 1;
      vm.orgFlo = $translate.instant("Flota");
    } else if (tblCuentasService.obtinePermisos(3)) {
      orgFlo = 2;
      vm.orgFlo = $translate.instant("Organización");
    }

    // MUESTRA LAS ORGANIZACIONES O FLOTAS DEPENDIENDO LAS QUE EXISTAN EN LAS MIGAS DE VICNULACION
    tblCuentasService.getCuentas(orgFlo).then(function(data) {
      data.forEach(function(element) {
        for (var i = 0; i < datos.vinculaciones.length; i++) {
          element.display = element.name;
          element.value = element.name.toLowerCase();
          if (element.uid === datos.vinculaciones[i].uid) {
            element.mostrar = false;
            break;
          } else {
            element.mostrar = true;
          }
        }
      });

      data.forEach(function(elemento) {
        for (var ii = 0; ii < datos.migas.length; ii++) {
          elemento.display = elemento.name;
          elemento.value = elemento.name.toLowerCase();
          if (elemento.uid === datos.migas[ii].uid) {
            elemento.mostrar = false;
            break;
          } else if (datos.vinculaciones.length === 0) {
            elemento.mostrar = true;
          }
        }
      });

      data.forEach(function(element){
        if (element.mostrar) {
          lstD.push(element);
        }
      });

      lstDtos = lstD;
      vm.showOrgFlo = true;
    });

    vm.querySearch = function (query) {
      var results = query ? lstDtos.filter(createFilterFor(query,lstDtos)) : lstDtos,
        deferred;
        if (vm.simulateQuery) {
          deferred = $q.defer();
          $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
            return deferred.promise;
        } else {
          return results;
        }
    };

    function createFilterFor(query,lstDtos) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(lstDtos) {
        return (lstDtos.value.indexOf(lowercaseQuery) === 0);
      };
    }

    // FUNCION QUE CIERRA EL MODAL DE LA ALTA DE UNA VICNULACION
    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    // FUNCION QUE VALIDA LOS DATOS INGRESADOS EN LA ALTA DE UNA VICNULACION
    vm.guardar = function(dato){
      vm.error = "";
      if(angular.isUndefined(dato)){
        vm.error = "Introduzca una viculación";
        return;
      }

      if(angular.isUndefined(dato.cuentaVinculacion)){
        vm.error = "Introduzca una viculación";
        return;
      }

      dato.cuenta = vm.cuenta;
      $uibModalInstance.close();
      vinculacionService.addVinculacion(dato).then(function(data){
        if(data.code === 200){
          notificaciones.showNotification(VINCULACION, $translate.instant("El alta de la cuenta vinculada, fue realizada correctamente"), "success");
          $scope.refrescarVinculacion();
        } else {
          notificaciones.showNotification(VINCULACION, $translate.instant("Error al intentar Guardar un cuenta vinculada"), "error");
          $scope.refrescarVinculacion();
        }
      },function(error){
          notificaciones.showNotification(VINCULACION, $translate.instant("Error al intentar dar de alta una cuenta vinculada")  + error, "error");
          $scope.refrescarVinculacion();
      });
    };
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:altaCuentasController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('altaUsuariosController', altaUsuariosController);

  function altaUsuariosController($log, $uibModalInstance, $scope, datos, notificaciones, $translate, usuariosService) {
    var vm = this;
    var fecha = hoyFecha();
    vm.titulo = datos.titulo;
    vm.response = {fecha: fecha};
    vm.cuenta = datos.cuenta;
    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    var USUARIOS = $translate.instant("Usuarios");

    function hoyFecha(){
        var hoy = new Date();
        var dd = hoy.getDate();
        var mm = hoy.getMonth()+1;
        var yyyy = hoy.getFullYear();

        dd = addZero(dd);
        mm = addZero(mm);

        return dd+'/'+mm+'/'+yyyy;
    }

    function addZero(i) {
        if (i < 10) {
            i = '0' + i;
        }
        return i;
    }

    // FUNCION QUE VALIDA LOS DATOS INGRESADOS EN LA ALTA DE UN USUARIO
    vm.guardar = function (dato) {
      vm.error="";
      if(angular.isUndefined(dato)){
        vm.error = "Introduzca los datos del usuario";
        return;
      }
      if(angular.isUndefined(dato.name)){
        vm.error = "Introduzca el nombre del usuario";
        return;
      }
      if(angular.isUndefined(dato.surname)){
        vm.error = "Introduce el apellido del usuario";
        return;
      }
      if(!dato.usuariosForm.email.$dirty){
        vm.error = "Introduzca el email del usuario";
        return;
      }
      if(dato.usuariosForm.email.$invalid){
        vm.error = "Introduzca un email valido";
        return;
      }
      if(dato.usuariosForm.telephone.$invalid){
        vm.error = "Introduzca un teléfono valido";
        return;
      }

      dato.cuenta = vm.cuenta;
      $uibModalInstance.close();
      usuariosService.altaUsuario(dato).then(function(data){
        if(data.status === 200){
          notificaciones.showNotification(USUARIOS,$translate.instant("La alta de un usuario fue realizada correctamente"), "success");
          $scope.refrescarUsuarios();
        }else{
          notificaciones.showNotification(USUARIOS, $translate.instant("Error al intentar dar de alta a un usuario"), "error");
        }
      },function(error){
          notificaciones.showNotification(USUARIOS, $translate.instant("Error al intentar dar de alta a un usuario") + error, "error");
          $scope.refrescarUsuarios();
      });
    };
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name app.controller:altaCuentasController
   * @description
   * # ModalsCtrl
   * Controller of the Analisis
   */
  angular.module('app')
    .controller('altaCuentasController', altaCuentasController);

  function altaCuentasController($log, $uibModalInstance, datos, notificaciones, $translate, tblCuentasService, $scope, utilidades) {
    var vm = this;
    vm.titulo = datos.titulo;
    vm.timeZone = datos.element;
    vm.disableSaveAccount = true;
    var fecha = hoyFecha();
    vm.response = {fecha: fecha,
                   visibleUid: false};
    vm.close = function() {
      $uibModalInstance.dismiss();
    };

    var CUENTAS = $translate.instant("Cuentas");

    function hoyFecha(){
        var hoy = new Date();
        var dd = hoy.getDate();
        var mm = hoy.getMonth()+1;
        var yyyy = hoy.getFullYear();

        dd = addZero(dd);
        mm = addZero(mm);

        return dd+'/'+mm+'/'+yyyy;
    }

    function addZero(i) {
        if (i < 10) {
            i = '0' + i;
        }
        return i;
    }

    vm.validateAccountName = function (value) {
      if(utilidades.isEmpty(value.name)){
        vm.disableSaveAccount = true;
      } else {
        if(utilidades.includesSpecialCharacters(value.name)){
          vm.disableSaveAccount = true;
          vm.error = 'El nombre no puede tener caracteres especiales'
        } else {
          vm.error = ''
          vm.disableSaveAccount = false;
        }
      }
    };

    // FUNCION QUE VALIDA LOS DATOS INGRESADOS EN LA ALTA DE UNA CUENTA
    vm.guardar = function (dato) {
      vm.error="";
      if(angular.isUndefined(dato)){
        vm.error = "Introduzca los datos de la cuenta";
        return;
      }
      if(angular.isUndefined(dato.name)){
        vm.error = "Introduzca el nombre de la cuenta";
        return;
      }
      if(angular.isUndefined(dato.type)){
        vm.error = "Introduce el tipo de cuenta";
        return;
      }
      if(angular.isUndefined(dato.cif)){
        vm.error = "Introduzca el cif";
        return;
      }
      if(angular.isUndefined(dato.timeZone)){
        vm.error = "Introduce la zona horaria";
        return;
      }
      if(angular.isUndefined(dato.language)){
        vm.error = "Introduce el idioma";
        return;
      }
      
      $uibModalInstance.close();

      tblCuentasService.saveCuentas(dato).then(function(data){
        if(data.status === 200){
          notificaciones.showNotification(CUENTAS, $translate.instant("La alta de una cuenta fue realizada correctamente"), "success");
          $scope.refrescarCuentas();
        }else{
          notificaciones.showNotification(CUENTAS, $translate.instant("Error al intentar dar de alta una cuenta"), "error");
        }
      },function(error){
          notificaciones.showNotification(CUENTAS, $translate.instant("Error al intentar dar de alta una cuenta") + error, "error");
          $scope.refrescarCuentas();
      });
    };
  }
})();

(function () {
    'use strict';
    angular.module('app').directive('datikCargadores', datikCargadores);

    function datikCargadores() {
        return {
            restrict: 'E',
            scope: {
                accountevent: '@'
            },
            templateUrl: 'app/views/cargadores/directives/cargadores.html',
            controllerAs: 'vm',
            controller: ['$rootScope', '$uibModal', 'cargadoresService', 'tblCuentasService', '$mdDialog', '$translate', 'notificaciones', tblCargadoresManager]
        };

        function tblCargadoresManager($rootScope, $uibModal, cargadoresService, tblCuentasService, $mdDialog, $translate, notificaciones) {
            var vm = this;

            var eventoVehiculosSeleccionado = 'vehiculo-table-change-selection';
            vm.loading
            const EXITO = 'success'
            const ERROR = 'error'
            const CARGADOR = 'Cargador'
            
            var info = {
                lista : undefined,
                cargador : undefined
            }

            vm.tblCargadores = {
                maxHeight: "calc(100vh - 260px)",
                currentPage: 1,
                perPage: 1000000,
                totalCount: 0,
                elements: [
                    {
                        title: 'ID Cargador',
                        information: 'id',
                        type: 'string',
                        width: '10%'
                    },
                    {
                        title: 'UID',
                        information: 'uid',
                        type: 'string',
                        width: '10%'
                    },
                    {
                        title: 'Nombre',
                        information: 'name',
                        type: 'string',
                        width: '15%'
                    },
                    {
                        title: 'Cliente',
                        information: 'operatorName',
                        type: 'string',
                        width: '15%'
                    },
                    {
                        title: 'Codigo',
                        information: 'code',
                        type: 'string',
                        width: '15%'
                    },
                    {
                        title: 'Descripcion',
                        information: 'description',
                        type: 'string',
                        width: '15%'
                    },
                    {
                        title: 'Latitud',
                        information: 'lat',
                        type: 'string',
                        width: '10%'
                    },
                    {
                        title: 'Longitud',
                        information: 'lon',
                        type: 'string',
                        width: '10%'
                    }
                ],
                options: {
                    title: 'Acciones',
                    buttons: [
                        {
                            title: 'Editar',
                            type: 'edit',
                            function: editarCargador
                        },
                        {
                            title: 'Eliminar',
                            type: 'delete',
                            function: eliminarCargador
                        }
                    ]
                },
                data: [],
                loading: false,
                selection: {
                    mode: 'simple',
                    getSelectedElements: undefined,
                    changeSelectionEventName: eventoVehiculosSeleccionado
                }
            }

            function obtenerCargadores() {
                vm.loading = true
                vm.tblCargadores.data = []
                cargadoresService.getCargadores().then(function (response) {
                    vm.tblCargadores.data = response.data[0]
                    vm.tblCargadores.numberElementsShowing = response.data[0].length
                }).finally(function (){
                    vm.loading = false
                })
            }

            tblCuentasService.getCuentas().then(function (response) {
                info.lista = response.filter(function(cliente){
                    return cliente.type === 1
                })
            })

            vm.registrarCargador = function () {
                $uibModal.open({
                    templateUrl: 'app/views/cargadores/modals/registrarCargadores.modal.html',
                    controller: 'cargadoresController as vm',
                    size: 'sm', // puede ser lg, md,sm segun el tamaño que se desee
                    resolve: {
                        datos: function () {
                            return info;
                        }
                    }
                });
            }

            $rootScope.$on('refrescar-tabla', function(ev, data){
                obtenerCargadores()
            })

            function editarCargador(cargador) {
                info.cargador = cargador
                /* OBTENER DATOS DEL CARGADOR Y MOSTRARLOS EN EL MODAL */
                $uibModal.open({
                    templateUrl: 'app/views/cargadores/modals/editarCargadores.modal.html',
                    controller: 'cargadoresController as vm',
                    backdrop: 'static',
                    size: 'sm', // puede ser lg, md,sm segun el tamaño que se desee
                    resolve: {
                        datos: function () {
                            return info;
                        }
                    }
                });
            }

            function eliminarCargador(cargador){
                var dialog = $mdDialog.confirm()
                    .title('Eliminar cargador')
                    .textContent('Se va a eliminar el cargador.')
                    .ok($translate.instant('Eliminar'))
                    .cancel($translate.instant('Cancelar'))

                $mdDialog.show(dialog).then(function (){
                    cargadoresService.deleteCargadores(cargador).then(function (response) {
                        if(response.status === 200){
                            notificaciones.showNotification(CARGADOR, 'Cargador exitosamente modificado', EXITO)
                        }
                    }, function(){
                        notificaciones.showNotification(CARGADOR, 'Ha ocurrido un error al modificar el cargador', ERROR)
                    }).finally(function () {
                        obtenerCargadores()
                    })
                })
            }
            /* FUNCIONES AUXILIARES */
            vm.close = function () {
                $uibModalInstance.dismiss();
            }

            obtenerCargadores()
        }
    }
})();
(function () {
    'use strict';

    /**
     * @ngdoc Service
     * @name app.service:cargadoresService
     * @description
     * Este service se encarga de interactuar con los datos entre la API y el controlador de cargadores
     */

    angular.module('app').service('cargadoresService', cargadoresService);

    function cargadoresService(conexion, constantes, $http, $log) {
        var service = {
            getCargadores : getCargadores,
            postCargadores : postCargadores,
            putCargadores : putCargadores,
            deleteCargadores : deleteCargadores
        };

        return service;

        
        function getCargadores() {
            var url = constantes.getApiUrl('ips_chargers', 'getChargers');
            
            var config = {
                headers: {
                    'Authorization':  'Bearer ' + conexion.getAuthToken()
                },
                timeout: 90000
            };

            return $http.get(url, config).then(okFunction, errorFunction);

            function okFunction(response) {
                return response;
            }

            function errorFunction(error) {
                $log.error("Error en " + error);
                return error;
            }
        }

        function postCargadores(params) {
            var url = constantes.getApiUrl('ips_chargers', 'postChargers');

            var config = {
                headers: {
                    'Authorization': 'Bearer ' + conexion.getAuthToken()
                },
                timeout: 90000
            };

            return $http.post(url, params, config).then(okFunction, errorFunction);

            function okFunction(response) {
                return response;
            }

            function errorFunction(error) {
                $log.error("Error en " + error);
                return error;
            }
        }


        function putCargadores(cargador) {
            var url = constantes.getApiUrl('ips_chargers', 'putChargers').replace('{0}', cargador.uid);

            var config = {
                headers: {
                    'Authorization': 'Bearer ' + conexion.getAuthToken()
                },
                timeout: 90000
            };

            var params = {
                name: cargador.name,
                description: cargador.description,
                code: cargador.code,
                location: cargador.location.code,
                operatorUid: cargador.operatorUid,
                lat: cargador.lat,
                lon: cargador.lon
            }

            return $http.put(url, params, config).then(okFunction, errorFunction);

            function okFunction(response) {
                return response;
            }

            function errorFunction(error) {
                $log.error("Error en " + error);
                return error;
            }
        }

        function deleteCargadores(cargador) {
            var url = constantes.getApiUrl('ips_chargers', 'deleteChargers').replace('{0}', cargador.uid);

            var config = {
                headers: {
                    'Authorization': 'Bearer ' + conexion.getAuthToken()
                },
                timeout: 90000
            };

            return $http.delete(url, config).then(okFunction, errorFunction);

            function okFunction(response) {
                return response;
            }

            function errorFunction(error) {
                $log.error("Error en " + error);
                return error;
            }
        }
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc function
     * @name app.controller:cargadoresController
     * @description
     * # ModalsCtrl
     * Controlador de permisos
     */

    angular.module('app').controller('cargadoresController', cargadoresController);

    function cargadoresController($rootScope, datos, $uibModalInstance, cargadoresService, notificaciones, utilidades) {
        var vm = this;
        vm.listaClientes = datos.lista
        var listaClientes = datos.lista
        vm.itemSelected = undefined
        vm.cargadorEditar = datos.cargador
        vm.cargador = {
            name : '',
            description : '',
            code : '',
            location : 'COCHERAS',
            operatorUid : '',
            lat : null,
            lon : null
        }
        
        vm.cargadorSeleccionado
        vm.searchText = ''
        const ERROR = 'error'
        const EXITO = 'success'
        const CARGADOR = 'Cargador'

        vm.guardarCargador = function () {
            vm.loading = true
            cargadoresService.postCargadores(vm.cargador).then(function (response) {
                if(response.status === 200){
                    setTimeout(function() {
                        vm.loading = false
                        vm.close()
                        $rootScope.$emit('refrescar-tabla') 
                    }, 500);
                    notificaciones.showNotification(CARGADOR, 'Cargador exitosamente creado', EXITO)
                }else{
                    vm.loading = false
                    notificaciones.showNotification(CARGADOR, 'El cargador no se ha podido crear', ERROR)
                }
            }, function (){
                vm.loading = false
                notificaciones.showNotification(CARGADOR, 'Algo ha ido mal al intentar crear el cargador', ERROR)
            })
        }
        vm.editarCargador = function (cargador) {
            cargador.uid = datos.cargador.uid
            vm.loading = true
            cargadoresService.putCargadores(cargador).then(function (response) {
                if(response.status === 200){
                    setTimeout(function() {
                        vm.close()
                        vm.loading = false
                        $rootScope.$emit('refrescar-tabla') 
                        notificaciones.showNotification(CARGADOR, 'Cargador exitosamente', EXITO)
                    }, 500);
                }else{
                    notificaciones.showNotification(CARGADOR, 'El cargador no se ha podido editar', ERROR)
                    vm.loading = false
                }
            }, function (){
                vm.loading = false
                notificaciones.showNotification(CARGADOR, 'Algo ha ido mal al intentar editar el cargador', ERROR)
            })
        }
        
        vm.getFleet = function (cliente) {
            if(!utilidades.isEmpty(cliente)){
                vm.cargador.operatorUid = cliente.uid
            }
        }

        vm.filterClient = function (query) {
            if(query){
                return vm.listaClientes.filter(function (x) {
                    return x.name.toLowerCase().includes(query.toLowerCase())
                })
            }
            return listaClientes
        }
        
        vm.close = function () {
            $uibModalInstance.close();
        }
    }
})();
(function() {
  'use strict';
  /**
   * @ngdoc service
   * @name Composicion
   * @description
   * # Servicio que ayuda a la composicion de la página de iPanel
   */
  angular.module('datik-composition',
              ['pascalprecht.translate', 'ui.bootstrap',
               'datik-utils', 'datik-constants',
               'datik-connection']);
})();

(function() {
  'use strict';

  angular
    .module('datik-composition')
    .directive('pie', pie);

  /** @ngInject */
  function pie() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/composition/directives/pie/pie.html',
      controller: pieController,
      controllerAs: 'vm'
    };
    return directive;

    /** @ngInject */
    function pieController() {
      var vm = this;

      vm.pie = '';
    }
  }

})();

(function() {
  'use strict';


  /**
   * @ngdoc controller
   * @name login.controller:CorporationManagerService
   * @description
   *
   */
  angular
    .module('datik-composition')
    .factory('menuUsuarioService', menuUsuarioService);

  function menuUsuarioService($log, $http,
                              constantes, conexion) {

    var service = {
      changeCredential: changeCredential,
      changeConfiguration: changeConfiguration
    };

    return service;

    function changeCredential(actualPwd, newPwd) {
      var url = constantes.getApiUrl('ips_authorization', 'changeCredential');

      var params = {
        'actualPassword': actualPwd,
        'newPassword': newPwd
      };
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.put(url, params, config)
        .then(changeCredentialComplete)
        .catch(changeCredentialFailed);

      function changeCredentialComplete(response) {
        return response.data;
      }

      function changeCredentialFailed(error) {
        if (error.status === -1) {
          $log.error('Timeout al cambiar el password');
        } else {
          $log.error('Error al cambiar el password');
        }
        return;
      }
    }

    function changeConfiguration(type_conf, value) {
      var url = constantes.getApiUrl('ips_authorization', 'configurations');
      
      var params = {
        type: type_conf,
        value: value
      };
      var config = {
        header: {
          Authorization: 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };
      return $http.put(url, params, config)
        .then(changeConfigurationComplete)
        .catch(changeConfigurationFailed);

      function changeConfigurationComplete(response) {
        return response.data;
      }

      function changeConfigurationFailed(error) {
        if (error.status === -1) {
          $log.error('Timeout al cambiar la configuración del usuario');
        } else {
          $log.error('Error al cambiar la configuración del usuario');
        }
        return;
      }
    }
  }

})();

(function () {
  'use strict';


  /**
   * @ngdoc controller
   * @name datik-composicion.controller:UsuarioModalController
   * @description
   * # UsuarioModalController
   * Modal que se carga cuando el usuario hace click en las preferencias del usuario
   */
  angular
    .module('datik-composition')
    .controller('UsuarioModalController',
      function ($uibModalInstance, $window, $translate, conexion, utilidades) {
        var vm = this;
        var consumoUnidad;
        vm.errorIdioma = '';
        vm.errorClave = '';
        if (angular.isUndefined(conexion.getUsuario().valores.UNIDAD_CONSUMO) ||
          isNaN(conexion.getUsuario().valores.UNIDAD_CONSUMO)) {
          consumoUnidad = 0;
        } else {
          consumoUnidad = conexion.getUsuario().valores.UNIDAD_CONSUMO;
        }


        //Configurar idiomas
        vm.idiomas = [{
          key: 'esES',
          value: $translate.instant('Español (España)')
        }, {
          key: 'esMX',
          value: $translate.instant('Español (Mexico)')
        }, {
          key: 'enGB',
          value: $translate.instant('Ingles (Reino Unido)')
        }, {
          key: 'frFR',
          value: $translate.instant('Frances (Francia)')
        }, {
          key: 'ptPT',
          value: $translate.instant('Portugués (Portugal)')
        }];
        var selectidioma = 2;
        if (conexion.getUsuario().idioma === 'esES') {
          selectidioma = 0;
        } else if (conexion.getUsuario().idioma === 'esMX') {
          selectidioma = 1;
        } else if (conexion.getUsuario().idioma === 'enGB') {
          selectidioma = 2;
        } else if (conexion.getUsuario().idioma === 'frFR') {
          selectidioma = 3;
        } else if (conexion.getUsuario().idioma === 'ptPT') {
          selectidioma = 4;
        }

        vm.pwdActualTexto = $translate.instant('Contraseña actual');
        vm.newPwdTexto = $translate.instant('Nueva contraseña');
        vm.repitNewPwdTexto = $translate.instant('Repita la nueva contraseña');

        vm.unidadesConsumo = [{
          key: '0',
          value: 'L/100Km'
        },
        {
          key: '1',
          value: 'Km/L'
        }
        ];
        var selectunidad;
        if (consumoUnidad === 0 || consumoUnidad === '0') { // L/100Km
          selectunidad = 0;
        } else { // Km/L
          selectunidad = 1;
        }


        vm.objeto = {
          idioma: vm.idiomas[selectidioma],
          unidadConsumo: vm.unidadesConsumo[selectunidad],
          consumoUnidadActual: consumoUnidad
        };

        vm.mostrarExplicacion = false;
        /**
         * @ngdoc method
         * @name datik-composicion.controller:UsuarioModalController#cambiarEstadoMostrarExplicacion
         * @methodOf datik-composicion.controller:UsuarioModalController
         * @description
         * Según el valor que se reciba en esta función, en la ventana se mostrará la información de
         * ayuda o no. <i>true</i> si se quiere mostrar la información añadidda, y <i>false</i> si no
         * se quiere mostrar
         */
        vm.cambiarEstadoMostrarExplicacion = function (estado) {
          vm.mostrarExplicacion = estado;
        };

        /**
         * @ngdoc method
         * @name datik-composicion.controller:UsuarioModalController#guardarElemento
         * @methodOf datik-composicion.controller:UsuarioModalController
         * @description
         * Funcion para el boton de guardado de la ventana de configuración del usuario
         */
        vm.guardarElemento = function (objeto) {
          if(utilidades.isEmpty(objeto.pwdactual) || utilidades.isEmpty(objeto.pwdnueva) || utilidades.isEmpty(objeto.pwdnuevabis)){
              vm.errorClave = 'Faltan datos por rellenar';
          }else if(objeto.pwdnueva !== objeto.pwdnuevabis){
              vm.errorClave = 'La contraseña nueva debe ser igual en los dos campos';
          }else{
            $uibModalInstance.close(objeto);
          }
        };

        /**
         * @ngdoc method
         * @name datik-composicion.controller:UsuarioModalController#cancelar
         * @methodOf datik-composicion.controller:UsuarioModalController
         * @description
         * Funcion para el boton de cancelar de la ventana de configuración del usuario
         */
        vm.close = function () {
          $uibModalInstance.dismiss('cancel');
        };
      });
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-composicion.directive:menuUsuario
   * @description
   * # menuUsuario
   * Directive para el control y manejo del menu del usuario que aparece
   * a la derecha
   */
  angular.module('datik-composition')
    .directive('menuUsuario', function() {
      return {
        restrict: 'E',
        templateUrl: 'app/composition/directives/menuUsuario/menuUsuario.modal.html',
        controller: function($http, $interval, conexion, $filter, $rootScope,
                             $uibModal, $log, $translate,
                             menuUsuarioService) {

          var vm = this;
          /**
           * @ngdoc method
           * @name menuUsuario.desconectar
           * @methodOf menuUsuario
           * @description
           * Función que se ejecuta cuando usuario pulsa el botón de desconectar
           * y llama al servicio <i>Conexión</i> para cerrar la conexión y desconectar
           * al usuario de la aplicación
           */
          vm.desconectar = function() {
            conexion.desconectar();
          };

          

          /**
           * @ngdoc method
           * @name menuUsuario.mostrarPreferenciasUsuario
           * @methodOf menuUsuario
           * @description
           * Funcion que muestra el modal con las posiblidades de modificar datos del usuario
           * como el idioma de la aplicación, la contraseña para entrar en iPanel o la unidad
           * de los indicadores
           */
          vm.mostrarPreferenciasUsuario = function(size) {
            var modalInstance = $uibModal.open({
              templateUrl: 'app/composition/directives/menuUsuario/menuUsuario.modal.html',
              controller: 'UsuarioModalController',
              controllerAs: 'UsuarioModalCtrl',
              size: size
            });

            

            modalInstance.result.then(function(resultado) {
              //Funcion que nos permite hacer cosas cuando se cierra el modal
              if (resultado.idioma.key !== conexion.getUsuario().idioma) {
                menuUsuarioService.changeConfiguration("IDIOMA", resultado.idioma.key)
                  .then(function(response) {
                    if (angular.isUndefined(response)) {
                      $log.error('No se ha podido modificar el idioma a la hora:' + new Date());
                    } else {
                      $log.info('Modificado idioma con exito a la hora:' + new Date());
                      conexion.cambiarIdioma(resultado.idioma.key);
                      sessionStorage.setItem('idioma', resultado.idioma.key);
                    }
                  });
              }
              if (resultado.pwdactual && resultado.pwdnueva && resultado.pwdnuevabis) {
                if (resultado.pwdnueva === resultado.pwdnuevabis) {
                  menuUsuarioService.changeCredential(resultado.pwdactual, resultado.pwdnueva).then(function(response) {
                    if (angular.isUndefined(response)) {
                      $log.error('No se ha podido modificar la clave a la hora:' + new Date());
                    } else {
                      $log.info('Modificada clave con exito a la hora:' + new Date());
                    }
                  });
                }
              }
              //Unidad del consumo
              if (resultado.unidadConsumo.key !== resultado.consumoUnidadActual) {
                menuUsuarioService.changeConfiguration("UNIDADCONSUMO", resultado.unidadConsumo.key)
                  .then(function(response) {
                    if (angular.isUndefined(response)) {
                      $log.error('No se ha podido modificar la unidad del consumo a la hora:' + new Date());
                    } else {
                      var usuario = conexion.getUsuario();
                      usuario.consumo = resultado.unidadConsumo.key
                      conexion.setUsuario(usuario);
                    }
                  });
              }

            }, function() {
              $log.info('Modal configuracion usuario dismissed at: ' + new Date());
            });
          };
        },
        controllerAs: 'menuUsuarioController'
      };
    })

})();

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name ayuda
   * @description
   * # Servicio para controlar la información de las ayudas
   */
  angular
    .module('datik-composition')
    .service('ayuda', ayuda);

  /** @ngInject */
  function ayuda($rootScope, $translate, $sce, $timeout, utilidades) {
    /**
     * @ngdoc method
     * @name ayuda.ponerValorVista
     * @methodOf ayuda
     * @description
     * Funcion para poner los valores de ayuda de la vista
     * @param {string} titulo Título que se mostrará en la vista de la ayuda
     * @param {string} valor Texto que se mostrará como descripción general de la pantalla
     * @param {array} arrayAyuda Array de los textos que se deberán de mostrar en la ayuda
     * @param {array} parametros Array de los parametros
     */
    var ponerValorVista = function(titulo, valor, arrayAyuda, parametros) {
      if (titulo === 0) {
        titulo = '';
      }
      $rootScope.ayuda.tituloVista = titulo;
      $rootScope.ayuda.valorVista = valor;

      $timeout(function() {
        $rootScope.tituloAyuda = $sce.trustAsHtml($translate.instant(titulo));
        $rootScope.contenidoAyuda = $sce.trustAsHtml($translate.instant(valor, parametros));
      }, 1000);

      $rootScope.ayuda.arrayAyuda = arrayAyuda;
      var valorAyudaExtra = '';
      if (angular.isUndefined(arrayAyuda)) {
        $rootScope.contenidoExtraAyuda = $sce.trustAsHtml(valorAyudaExtra);
      } else {
        for (var ii = 0; ii < arrayAyuda.length; ii++) {
          valorAyudaExtra = valorAyudaExtra + '<span class="ayudaCirculoPequeno">' + (arrayAyuda[ii].numero) + '</span>' +
            $translate.instant(arrayAyuda[ii].valor) + '</br>';
        }
        $rootScope.contenidoExtraAyuda = $sce.trustAsHtml(valorAyudaExtra);
      }
    };

    /**
     * @ngdoc method
     * @name ayuda.insertarValoresLocales
     * @methodOf ayuda
     * @description
     * Funcion para insertar los textos de ayuda en las directivas
     * @param {array} arrayAyudaLocales Array de los textos que se mostrarán en las vistas de la ayuda
     */
    var insertarValoresLocales = function(arrayAyudaLocales) {
      var valorAyudaExtra = '';
      if (angular.isUndefined(arrayAyudaLocales)) {
        $rootScope.contenidoExtraAyuda = $sce.trustAsHtml(valorAyudaExtra);
      } else {
        $rootScope.ayuda.arrayAyuda = $rootScope.ayuda.arrayAyuda.concat(arrayAyudaLocales);

        for (var ii = 0; ii < $rootScope.ayuda.arrayAyuda.length; ii++) {
          valorAyudaExtra = valorAyudaExtra +
            '<span class="ayudaCirculoPequeno">' + $rootScope.ayuda.arrayAyuda[ii].numero + '</span>' +
            $translate.instant($rootScope.ayuda.arrayAyuda[ii].valor) +
            '</br>';
        }
        $rootScope.contenidoExtraAyuda = $sce.trustAsHtml(valorAyudaExtra);
      }
    };


    /**
     * @ngdoc method
     * @name ayuda.ponerValorElemento
     * @methodOf ayuda
     * @description
     * Funcion para poner un elemento especifico en ayuda, al restaurar desaparecera
     * @param {string} titulo Título que se mostrará en la vista de la ayuda
     * @param {string} valor Texto que se mostrará como descripción general de la pantalla
     * @param {array} parametros Array de los textos que se mostrarán en la vista de la ayuda
     */
    var ponerValorElemento = function(titulo, valor, parametros) {
      if (titulo) {
        $rootScope.tituloAyuda = $sce.trustAsHtml($translate.instant(titulo));
      }
      if (valor) {
        $rootScope.contenidoAyuda = $sce.trustAsHtml($translate.instant(valor, parametros));
      }
    };

    /**
     * @ngdoc method
     * @name ayuda.restaurarValorVista
     * @methodOf ayuda
     * @description
     * Cuando el usuario ya no apunta al número mostrado en la pantalla, se le llama a esta función
     * y vuelve a su estado original
     * @param {array} parametros Array de los textos que se mostrarán en la vista de la ayuda
     */
    var restaurarValorVista = function(parametros) {
      $rootScope.tituloAyuda = $sce.trustAsHtml($translate.instant($rootScope.ayuda.tituloVista));
      $rootScope.contenidoAyuda = $sce.trustAsHtml($translate.instant($rootScope.ayuda.valorVista, parametros));
    };

    /*Iniciamos los valores globales de ayuda*/
    $rootScope.ayuda = {
      tituloVista: '',
      valorVista: '',
      arrayAyuda: []
    };


    /**
     * @ngdoc method
     * @name ayuda.ponerValor
     * @methodOf ayuda
     * @description
     * Funcion para poner un valor de ayuda en esa vista
     * @param {string} titulo Título que se mostrará en la vista de la ayuda
     * @param {string} valor Texto que se mostrará como descripción general de la pantalla
     * @param {int} num Número que se mostrará en el círuclo de la ayuda
     * @param {array} parametros Array de los textos que se mostrarán en la vista de la ayuda
     */
    var ponerValor = function(titulo, valor, num, parametros) {
      if (titulo) {
        $rootScope.tituloAyuda = $sce.trustAsHtml($translate.instant(titulo));
      }
      if (valor) {
        $rootScope.contenidoAyuda = $sce.trustAsHtml('<span class="ayudaCirculoPequeno">' + num + '</span>' + $translate.instant(valor, parametros)
          /*+ '<iframe width="150" height="150" src="https://www.youtube.com/embed/5aeWmaF5eh8?autoplay=1" frameborder="0" allowfullscreen></iframe>'*/
          /*+ '<video width="150" height="150" src="video/VID-20150413-WA0003.mp4" autoplay controlls></video>'*/
        );
      }
    };

    $rootScope.ayuda.ponerValor = ponerValor;
    /**
     * @ngdoc method
     * @name ayuda.restaurarValor
     * @methodOf ayuda
     * @description
     * Si se ha puesto un valor temporal a la ayuda esta vuelve a su estado original
     * @param {array} parametros Array de los textos que se mostrarán en la vista de la ayuda
     */
    var restaurarValor = function(parametros) {
      $rootScope.tituloAyuda = $sce.trustAsHtml($translate.instant($rootScope.ayuda.tituloVista));
      $rootScope.contenidoAyuda = $sce.trustAsHtml($translate.instant($rootScope.ayuda.valorVista, parametros));
      if ($rootScope.index.verAyuda) {
        $timeout(
          function() {
            utilidades.ajustarPantalla();
          }, 100);
      }
    };
    $rootScope.ayuda = {
      tituloVista: '',
      valorVista: '',
      arrayAyuda: [],
      arrayAyudaLocales: [],
      restaurarValor: restaurarValor,
      ponerValor: ponerValor
    };

    $rootScope.ayuda.restaurarValor = restaurarValor;

    var funcionesAyuda = {
      'ponerValor': ponerValor,
      'restaurarValor': restaurarValor
    };

    var service = {
      'ponerValorVista': ponerValorVista,
      'insertarValoresLocales': insertarValoresLocales,
      'ponerValorElemento': ponerValorElemento,
      'restaurarValorVista': restaurarValorVista,
      'ponerValor': ponerValor,
      'restaurarValor': restaurarValor,
      'funcionesAyuda': funcionesAyuda
    };
    return service;
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-composicion.directive:ayuda
   * @description
   * # ayuda
   * Directive para el apartado de ayuda
   */
  angular.module('datik-composition').directive('ayuda', function() {
    return {
      restrict: 'E',
      templateUrl: 'app/composition/directives/ayuda/ayuda.html'
    };
  });

})();

(function () {
  'use strict';

  angular.module('app').controller('MainController', MainController);

  /** @ngInject */
  function MainController($log, $window, $location, $interval, utilidades,$translate,conexion, composicion,ayuda, tblCuentasService, $mdMenu) {

    var vm = this;
    vm.mostrarUsuarios = tblCuentasService.obtinePermisos(5);
    vm.mostrarMDM = tblCuentasService.obtinePermisos(11);
    vm.mostrarRecursos = tblCuentasService.obtinePermisos(14);
    vm.mostrarNagios = tblCuentasService.obtinePermisos(16);
    vm.mostrarCargadores = tblCuentasService.obtinePermisos(18)

    conexion.validarConexion();
    composicion.iniciarPantalla();

    //Ayuda
    vm.arrayAyuda = [
      { valor: $translate.instant('Info Main 1'), numero: '1' }, //0
      { valor: $translate.instant('Info Main 2'), numero: '2' } //1
    ];
    ayuda.ponerValorVista('TituloAyuda Main', 'TextoAyuda Main');

    var tabSelect = localStorage.getItem('tabsIpanelGO');

    if (angular.isDefined(tabSelect) && tabSelect !== null) {
      vm.currentNavItem = tabSelect;
    } else {
      vm.currentNavItem = 'cuentas';
    }
    vm.goto = function (page) {
      localStorage.setItem("tabsIpanelGO", page);
      vm.currentNavItem = page;
    }

    vm.abrirMenu = function ($mdMenu) {
      $mdMenu.open();
    }

    $interval(function () {
      vm.fechaUsuario = utilidades.getUserDate();
    }, 1000);

  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .constant('timeZones', ['America/Belize', 'Mexico/BajaSur', 'Mexico/BajaNorte',
                            'Mexico/General', 'Europe/Berlin',
                            'UTC', 'Europe/Madrid',
                            'Europe/London', 'Europe/Lisbon', 'Europe/Sofia', 'Europe/Istanbul', 'Asia/Dubai',
                            'America/Santiago', 'America/Lima', 'America/Sao_Paulo',
                            'Europe/Paris', 'America/Mexico_City',
                            'America/Monterrey', 'Africa/Ouagadougou',
                            'Australia/Sydney', 'Asia/Singapore', 'Europe/Oslo',
                            'America/New_York', 'Africa/Johannesburg', 'Africa/Bamako']);

})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name live.controller:TblCuentasController
   * @description
   * Controller para el menu de Live
   *
   */

  angular
    .module('app')
    .directive('datikCuentas', datikCuentas);

  function datikCuentas() {
    return {
      restrict: 'E',
      scope: {
        accountevent: '@'
      },
      templateUrl: 'app/views/cuentas/tblCuentas.html',
      controllerAs: 'vm',
      controller: ['$log', '$translate', '$filter', '$location', '$uibModal',
        'conexion', 'constantes', 'ayuda', 'composicion', '$scope', 'usuariosService', '$q', 'tblCuentasService', tblCuentasController
      ]
    };

    function tblCuentasController($log, $translate, $filter, $location, $uibModal,
      conexion, constantes, ayuda, composicion, $scope, usuariosService, $q, tblCuentasService) {

      var vm = this;
      var cuentaSeleccionada = undefined;
      var lstBsqDtos = "";

      vm.contador = 0;

      vm.loading = true;
      vm.showMsjCuentas;
      vm.mostrar = {
        usuarios: false,
        vinculaciones: false,
        msjCuentas: false
      };

      $scope.$watchCollection("vm.contador", function() {
        if (vm.contador == 1) {
          vm.tabsCuentas = "vinculaciones";
          vm.tabsCuentas = "aplicaciones";
          vm.tabsCuentas = "usuarios";
        }
      });

      vm.gotoD = function(page) {
        vm.tabsCuentas = page;
      };

      vm.eventoCuentaSeleccion = 'cuentas-table-change-selection';

      // EVENTO QUE INVOCA UNA FUNCION PARA VALIDAR QUE EL ELEMENTO SELECCIONADO TENGA DATOS
      $scope.$on(vm.eventoCuentaSeleccion, function(event, elementosSeleccionados) {

        if (elementosSeleccionados.length > 0) {
          seHaSeleccionadoCuenta(elementosSeleccionados[0]);
        } else {
          seHaSeleccionadoCuenta();
        }

        if (angular.isDefined(elementosSeleccionados[0]) && elementosSeleccionados[0].type === 1 && !vm.mostrar.vinculaciones && vm.cuentasIdx === 2) {
          vm.cuentasIdx = 0;
        }

      });

      // EVENTO QUE REDIRECCIONA AL EVENTO DE RE-CARGAR LOS PERMISOS EN LA TABLA DE PERMISOS
      $scope.$on('reload-usuarios', function() {
        $scope.$broadcast('reload-permisos');
      });

      $scope.$on('seleccionaCuenta', function(event, dtos, flag) {
        $scope.$broadcast('reloadCuentaSeleccionada', dtos, flag);
      });

      $scope.$on('seleccionaUsuario', function(event, dtos, data, flag) {
        $scope.$broadcast('reloadTblUsuarios', dtos, flag);
        vm.mostrar.msjCuentas = false;
        vm.mostrar.usuarios = true;
        if (dtos.type === 2) {
          vm.mostrar.vinculaciones = true;
        } else {
          vm.mostrar.vinculaciones = false;
        }
        $scope.$broadcast('cuentaSeleccionadaBsqUsuario', data);
      });

      $scope.$on('showMsjCuentas', function() {
        vm.mostrar.msjCuentas = true;
        vm.mostrar.usuarios = false;
        vm.mostrar.vinculaciones = false;
      });

      // VALIDA QUE TENGA UNA CUANTA SELECCIONADA DE LA TABLA DE CUENTAS
      function seHaSeleccionadoCuenta(cuenta) {
        if (angular.isUndefined(cuenta)) {
          vm.contador = 0;
          cuentaSeleccionada = undefined;
          vm.mostrar.usuarios = false;
          /* vm.mostrar.apps = false; */
          vm.mostrar.msjCuentas = true;
        } else {
          vm.contador++;
          cuentaSeleccionada = cuenta;
          vm.mostrar.msjCuentas = false; 
          vm.mostrar.usuarios = true;
          $scope.$broadcast('cuenta-seleccionada', cuentaSeleccionada);
        }
      }

      vm.selectedItemChange = function(dto) {
        if (angular.isDefined(dto)) {
          vm.searchText = "";
          $scope.$broadcast('reloadCuentaSeleccionada', dto, 1);
        }
      };

      vm.querySearch = function(query) {
        var results = query ? lstBsqDtos.filter(createFilterFor(query, lstBsqDtos)) : lstBsqDtos,
          deferred;
        if (vm.simulateQuery) {
          deferred = $q.defer();
          $timeout(function() {
            deferred.resolve(results);
          }, Math.random() * 1000, false);
          return deferred.promise;
        } else {
          return results;
        }
      };

      function createFilterFor(query, lst) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(lst) {
          return (lst.value.indexOf(lowercaseQuery) === 0);
        };
      }

      function buscarUsu() {
        usuariosService.getBsqUsuarios("").then(function(data) {
          lstBsqDtos = data.data;
        }, function(error) {

        });
      }

      buscarUsu();

    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc controller
   * @name app.controller:SignInService
   * @description
   * Este controlador se encarga de la vista para conectarse a iPanel.
   */

  angular
    .module('app')
    .factory('tblCuentasService', tblCuentasService);

  function tblCuentasService($log, $http, $q, $translate, constantes, conexion) {
    var service = {
      obtinePermisos: obtinePermisos,
      getCuentas: getCuentas,
      saveCuentas: saveCuentas,
      editCuentas: editCuentas,
      deleteCuenta: deleteCuenta,
      putCameras : putCameras,
      getCameras : getCameras
    };

    return service;

    // FUNCION QUE OBTIENE LOS PERMISOS DEL USUARIO LOGGEADO
    function obtinePermisos(op) {
      var permisos = (conexion.getUsuario().apps.GO).split(""); //"YYYYYYYYNYYYNN".split("");
      if (permisos.length == 1 && permisos[op] === "Y") {
        return true;
      }

      if (permisos.length > 8 && op == 8 && permisos[op] === "Y") {
        return true;
      }

      if (op !== 0 && op !== 8 && permisos[op] === "Y") {
        return true;
      }
    }

    // FUNCION QUE OBTIENE LAS CUENTAS
    function getCuentas(tipo) {
      var url = constantes.getApiUrl('ips_corp', 'cuentas');
      var params = {};
      if (tipo !== "") {
        params.accountType = tipo;
      }
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000,
        params: params
      };

      return $http.get(url, config).then(okFunction, errorFunction);

      function okFunction(response) {
        response.data.forEach(function(elemento) {
          if (elemento.type == 1) {
            elemento.tipo = $translate.instant("Flota");
          } else if (elemento.type == 2) {
            elemento.tipo = $translate.instant("Organización");
          }
          var fecha = (elemento.highDate).substring(0, 10);
          fecha = fecha.split("-");
          elemento.fecha = fecha[2] + "-" + fecha[1] + "-" + fecha[0];
        });
        
        return response.data;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE GUARDA UNA CUENTA
    function saveCuentas(data) {
      var url = "";
      var params = {
        name: data.name,
        type: data.type,
        cif: data.cif,
        timeZone: data.timeZone,
        language: data.language
      };

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 120000
      };

      if (data.type === "1") {
        var deferred = $q.defer();
        url = constantes.getApiUrl('ips_corp', 'cuenta_fleets');
        $http.post(url, params, config).then(function(response) {
          var urlCore = constantes.getApiUrl('ips_core', 'cuentasPost');
          urlCore = urlCore.replace('{0}', response.data.uid);
          $http.post(urlCore, response.data, config).then(function() {
            deferred.resolve({
              status: 200
            });
          }, function() {
            deferred.reject({
              status: 500
            });
          });
        }, function() {
          deferred.reject({
            status: 500
          });
        });
        return deferred.promise;
      } else {
        url = constantes.getApiUrl('ips_corp', 'cuenta_organizations');
        return $http.post(url, params, config).then(okFunction, errorFunction);
      }

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE EDITA UNA CUENTA
    function editCuentas(data) {
      var url = "";
      var params = {
        id: data.id,
        uid: data.uid,
        name: data.name,
        type: data.type,
        cif: data.cif,
        highDate: data.highDate,
        timeZone: data.timeZone,
        language: data.language
      };

      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      if (data.type === "1") {
        var deferred = $q.defer();
        url = constantes.getApiUrl('ips_corp', 'cuenta_fleetsEdit');
        url = url.replace("{0}", data.uid);
        $http.put(url, params, config).then(function(response) {
          var urlCore = constantes.getApiUrl('ips_core', 'cuentasPut');
          urlCore = urlCore.replace('{0}', response.data.uid);
          $http.put(urlCore, response.data, config).then(function() {
            deferred.resolve({
              status: 200
            });
          }, function() {
            deferred.reject({
              status: 500
            });
          });
        }, function() {
          deferred.reject({
            status: 500
          });
        });
        return deferred.promise;
      } else {
        url = constantes.getApiUrl('ips_corp', 'cuenta_organizationsEdit');
        url = url.replace("{0}", data.uid);
        return $http.put(url, params, config).then(okFunction, errorFunction);
      }

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    // FUNCION QUE ELIMINA UNA CUENTA
    function deleteCuenta(data) {
      var url = "";
      var config = {
        headers: {
          'Authorization': 'Bearer ' + conexion.getAuthToken()
        },
        timeout: 90000
      };

      if (data.type === 1) {
        var deferred = $q.defer();
        url = constantes.getApiUrl('ips_corp', 'cuenta_fleetsDelet');
        url = url.replace("{0}", data.uid);
        $http.delete(url, config).then(function() {
          var urlCore = constantes.getApiUrl('ips_core', 'cuentasDel');
          urlCore = urlCore.replace('{0}', data.uid);
          $http.delete(urlCore, config).then(function() {
            deferred.resolve({
              status: 200
            });
          }, function() {
            deferred.reject({
              status: 500
            });
          });
        }, function() {
          deferred.reject({
            status: 500
          });
        });
        return deferred.promise;
      } else {
        url = constantes.getApiUrl('ips_corp', 'cuenta_organizationsEdit');
        url = url.replace("{0}", data.uid);
        return $http.delete(url, config).then(okFunction, errorFunction);
      }

      function okFunction(response) {
        return response;
      }

      function errorFunction(error) {
        $log.error("Error en " + error);
        return error;
      }
    }

    function getCameras(account) {
      var url = constantes.getApiUrl('ips_web', 'getCameraAmount').replace('{0}', account.uid);

      var config = {
        headers: {'Authorization': 'Bearer ' + conexion.getAuthToken()}
      };

      return $http.get(url, config);
    }

    function putCameras(account, cameraObj) {
      var url = constantes.getApiUrl('ips_web', 'putCameraAmount').replace('{0}', account.uid);
      
      var config = {
        headers: {'Authorization': 'Bearer ' + conexion.getAuthToken()}
      };
      
      return $http.put(url, cameraObj, config);
    }
    
  }
})();

(function(){

  'use strict';

  /**
   * @ngdoc overview
   * @name Selectores
   * @description
   * # Selectores
   *
   * Modulo de los selectores de iPanel
   */
 angular.module('datik-selectores',
          ['pascalprecht.translate',
           'toastr', 'ngAnimate',
           'smart-table', 'ui.select',
           'datik-connection', 'datik-utils']);

})();

/* global moment:false*/
(function() {
  'use strict';

  /**
  * @ngdoc function
  * @name datik-selectores.directive:selectorPeriodo
  * @description
  * # selectorPeriodo
  * Directive del selector de un periodo de fecha
  */
  angular.module('datik-selectores').directive('selectorPeriodo', function() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/periodo/periodo.html',
      scope: {
        menurapidomin: '@',
        menurapidomax: '@',
        periodominutosmax: '@',
        tipo: '@',
        apartadoinicio: '@',
        fechadesdeinicio: '@',
        fechahastainicio: '@',
        alineado: '@',
        mostrarhoras: '@',
        selector: '='
      },
      controller: ['$log', '$scope', '$translate', '$uibModal', '$q', '$timeout',
        'utilidades', 'constantes', 'conexion',
        function($log, $scope, $translate, $uibModal, $q, $timeout,
          utilidades, constantes, conexion) {
          conexion.fechasSelector = [];

          if (angular.isUndefined($scope.selector)) {
            $scope.selector = {};
          }

          $scope.month = 'month';
          $scope.day = 'day';

          if (angular.isUndefined($scope.mostrarhoras)) {
            $scope.mostrandohoras = true;
          }else{
            $scope.mostrandohoras = false;
          }
          /*
           * Iniciamos las variables
           */
          var apartado = 'dia'; 
          var menuRapidoMin = '6horas'; 
          var menuRapidoMax = 'ultmes';
          var menuRapido = true;
          var fechaDesde;
          var fechaHasta;

          $scope.fechaMax = moment(utilidades.getUserDate()).add(1, 'day').startOf('day').toDate();
          $scope.fechaMaxDesdeString = moment(utilidades.getUserDate()).startOf('day').format('YYYY-MM-DD');
          $scope.fechaMaxString = moment($scope.fechaMax).format('YYYY-MM-DD');
          $scope.fechaMin = new Date(2012, 1, 1, 0, 0, 0, 0);
          $scope.fechaMinString = moment($scope.fechaMin).format('YYYY-MM-DD');

          var dateCambioDeferred = $q.defer();
          $scope.cambioPromise = dateCambioDeferred.promise;

           /**
               * @ngdoc method
               * @name selectorPeriodo.clickSelectorFecha
               * @methodOf selectorPeriodo
               * @description
               * Cuando se hace click en el boton de la fecha se actualiza la fecha máxima
               */
          var clickSelectorFecha = function() {
            $scope.fechaMax = moment(utilidades.getUserDate()).add(1, 'day').startOf('day').toDate();
            dateCambioDeferred.notify($scope.fechaDia);
          };
          $scope.clickSelectorFecha = clickSelectorFecha;

           /**
               * @ngdoc method
               * @name selectorPeriodo.cancelar
               * @methodOf selectorPeriodo
               * @description
               * Cierra la ventana del selector de fecha
               */
          var cancelar = function() {
            $scope.dropIsOpen = false;
          };
          $scope.cancelar = cancelar;

           /**
               * @ngdoc method
               * @name selectorPeriodo.actualizarTextoMostrar
               * @methodOf selectorPeriodo
               * @description
               * Actualiza el texto que se muestra en el botón del selector y después se lanza un evento
               * para notificar el cambio en el selector de fecha
               */
          var actualizarTextoMostrar = function() {
            switch (apartado) {
              case 'dia':
                $scope.textoFechaPeriodo = moment(fechaDesde).format('DD') + ' ' + moment(fechaDesde).format('MMMM YYYY').capitalizeFirstLetter();
                $scope.titletextoFechaPeriodo = $scope.textoFechaPeriodo;
                break;
              case 'semana':
                $scope.textoFechaPeriodo = moment(fechaDesde).format('DD') + ' ' + moment(fechaDesde).format('MMMM YYYY').capitalizeFirstLetter() + ' - ' + moment(fechaHasta).format('DD') + ' ' + moment(fechaHasta).format('MMMM YYYY').capitalizeFirstLetter();
                $scope.titletextoFechaPeriodo = $translate.instant('Desde') + ': ' + moment(fechaDesde).format('DD') + ' ' + moment(fechaDesde).format('MMMM YYYY').capitalizeFirstLetter() + ' - ' + $translate.instant('Hasta') + ': ' + moment(fechaHasta).format('DD') + ' ' + moment(fechaHasta).format('MMMM YYYY').capitalizeFirstLetter();
                break;
              case 'mes':
                $scope.textoFechaPeriodo = moment(fechaDesde).format('MMMM YYYY').capitalizeFirstLetter();
                $scope.titletextoFechaPeriodo = $scope.textoFechaPeriodo;
                break;
              case 'personalizado':
              if($scope.mostrandohoras){
                $scope.textoFechaPeriodo = moment(fechaDesde).format('DD/MM/YYYY HH:mm') + ' - ' + moment(fechaHasta).format('DD/MM/YYYY HH:mm');
                $scope.titletextoFechaPeriodo = $translate.instant('Desde') + ': ' + moment(fechaDesde).format('DD/MM/YYYY HH:mm') + ' - ' + $translate.instant('Hasta') + ': ' + moment(fechaHasta).format('DD/MM/YYYY HH:mm');
              }else{
                $scope.textoFechaPeriodo = moment(fechaDesde).format('DD/MM/YYYY') + ' - ' + moment(fechaHasta).format('DD/MM/YYYY');
                $scope.titletextoFechaPeriodo = $translate.instant('Desde') + ': ' + moment(fechaDesde).format('DD/MM/YYYY') + ' - ' + $translate.instant('Hasta') + ': ' + moment(fechaHasta).format('DD/MM/YYYY');
              }
                break;
            }
            //Lanzamos un evento para decir que ha habido un cambio en el selector de fecha
            $scope.$emit('cambioSelectorFecha');
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.atrasTiempo
               * @methodOf selectorPeriodo
               * @description
               * Función que retrocede el tiempo. Si en el texto se muestra un día, retrocederá un día. Si
               * se muestra un mes, se retrocederá un mes
               */
          var atrasTiempo = function() {
            var fecha;
            var cambiado = false;
            switch (apartado) {
              case 'dia':
                fecha = moment(fechaHasta).add(-1, 'day').startOf('day').toDate();
                if (fecha > $scope.fechaMin) {
                  fechaDesde = moment(fechaDesde).add(-1, 'day').startOf('day').toDate();
                  fechaHasta = moment(fechaHasta).add(-1, 'day').startOf('day').toDate();
                  cambiado = true;
                }
                break;
              case 'semana':
                fecha = moment(fechaHasta).add(-7, 'day').startOf('day').toDate();
                if (fecha > $scope.fechaMin) {
                  fechaDesde = moment(fechaDesde).add(-7, 'day').startOf('day').toDate();
                  fechaHasta = moment(fechaHasta).add(-7, 'day').startOf('day').toDate();
                  cambiado = true;
                }
                break;
              case 'mes':
                fecha = moment(fechaHasta).add(-1, 'month').startOf('month').toDate();
                if (fecha > $scope.fechaMin) {
                  fechaDesde = moment(fechaDesde).add(-1, 'month').startOf('month').toDate();
                  fechaHasta = moment(fechaHasta).add(-1, 'month').startOf('month').toDate();
                  cambiado = true;
                }
                break;
              case 'personalizado':
                var diferencia = fechaHasta.getTime() - fechaDesde.getTime();
                fecha = new Date(fechaHasta.getTime() - diferencia);
                if (fecha > $scope.fechaMin) {
                  fechaDesde = new Date(fechaDesde.getTime() - diferencia);
                  fechaHasta = new Date(fechaHasta.getTime() - diferencia);
                  cambiado = true;
                }
                break;
            }

            if (cambiado) {
              $scope.fechaDia = fechaDesde;
              $scope.fechaSemana = fechaDesde;
              $scope.fechaMes = fechaDesde;
              $scope.personalizado.fechaInicio = fechaDesde;
              $scope.personalizado.horaInicio = fechaDesde;
              $scope.personalizado.fechaFin = fechaHasta;
              $scope.personalizado.horaFin = fechaHasta;

              actualizarTextoMostrar();
            }
          };
          $scope.atrasTiempo = atrasTiempo;

           /**
               * @ngdoc method
               * @name selectorPeriodo.adelanteTiempo
               * @methodOf selectorPeriodo
               * @description
               * Función que avanza el tiempo. Si en el texto se muestra un día, avanzará un día. Si
               * se muestra un mes, se avanzará un mes
               */
          var adelanteTiempo = function() {
            var fecha;
            var cambiado = false;
            switch (apartado) {
              case 'dia':
                fecha = moment(fechaDesde).add(1, 'day').startOf('day').toDate();
                if (fecha < $scope.fechaMax) {
                  fechaDesde = moment(fechaDesde).add(1, 'day').startOf('day').toDate();
                  fechaHasta = moment(fechaHasta).add(1, 'day').startOf('day').toDate();
                  cambiado = true;
                }
                break;
              case 'semana':
                fecha = moment(fechaDesde).add(7, 'day').startOf('day').toDate();
                if (fecha < $scope.fechaMax) {
                  fechaDesde = moment(fechaDesde).add(7, 'day').startOf('day').toDate();
                  fechaHasta = moment(fechaHasta).add(7, 'day').startOf('day').toDate();
                  cambiado = true;
                }
                break;
              case 'mes':
                fecha = moment(fechaDesde).add(1, 'month').startOf('month').toDate();
                if (fecha < $scope.fechaMax) {
                  fechaDesde = moment(fechaDesde).add(1, 'month').startOf('month').toDate();
                  fechaHasta = moment(fechaHasta).add(1, 'month').startOf('month').toDate();
                  cambiado = true;
                }
                break;
              case 'personalizado':
                var diferencia = fechaHasta.getTime() - fechaDesde.getTime();
                fecha = new Date(fechaDesde.getTime() + diferencia);
                if (fecha < $scope.fechaMax) {
                  fechaDesde = new Date(fechaDesde.getTime() + diferencia);
                  fechaHasta = new Date(fechaHasta.getTime() + diferencia);
                  cambiado = true;
                }
                break;
            }

            if (cambiado) {
              $scope.fechaDia = fechaDesde;
              $scope.fechaSemana = fechaDesde;
              $scope.fechaMes = fechaDesde;
              $scope.personalizado.fechaInicio = fechaDesde;
              $scope.personalizado.horaInicio = fechaDesde;
              $scope.personalizado.fechaFin = fechaHasta;
              $scope.personalizado.horaFin = fechaHasta;

              actualizarTextoMostrar();
            }
          };
          $scope.adelanteTiempo = adelanteTiempo;


           /**
               * @ngdoc method
               * @name selectorPeriodo.cambioDia
               * @methodOf selectorPeriodo
               * @description
               * Función que se ejecuta cuando el usuario hace click sobre un día en el
               * calendario del apartado día
               */
          var cambioDia = function() {
            $scope.fechaDia = moment($scope.fechaDia).startOf('day').toDate();
            $scope.fechaSemana = $scope.fechaDia;
            $scope.fechaMes = $scope.fechaDia;

            $scope.personalizado.fechaInicio = $scope.fechaDia;
            $scope.personalizado.horaInicio = $scope.fechaDia;
            $scope.personalizado.fechaFin = moment($scope.fechaDia).add(1, 'day').toDate();
            $scope.personalizado.horaFin = new Date($scope.personalizado.fechaFin);
          };
          $scope.cambioDia = cambioDia;

          /**
              * @ngdoc method
              * @name selectorPeriodo.cambioMes
              * @methodOf selectorPeriodo
              * @description
              * Función que se ejecuta cuando el usuario hace click sobre un mes en el
              * calendario del apartado mes
              */
          var cambioMes = function() {
            var fechaMoment = moment($scope.fechaMes);
            if (moment($scope.fechaDia).month() !== fechaMoment.month()) {
              $scope.fechaDia = moment($scope.fechaDia).month(fechaMoment.month()).year(fechaMoment.year()).toDate();
              $scope.fechaSemana = moment($scope.fechaSemana).month(fechaMoment.month()).year(fechaMoment.year()).toDate();

              $scope.personalizado.fechaInicio = fechaMoment.startOf('month').toDate();
              $scope.personalizado.horaInicio = $scope.personalizado.fechaInicio;
              $scope.personalizado.fechaFin = angular.copy(fechaMoment).add(1, 'month').toDate();
              $scope.personalizado.horaFin = $scope.personalizado.fechaFin;
            }
          };
          $scope.cambioMes = cambioMes;

          /**
              * @ngdoc method
              * @name selectorPeriodo.seleccionarApartado
              * @methodOf selectorPeriodo
              * @description
              * Función que se ejecuta cuando hay un cambio en la selección de apartados
              * @param {string} apa Texto que equivale al apartado seleccionado
              */
          var seleccionarApartado = function(apa) {
            if (apartado === 'mes' && apa !== apartado) {
              cambioMes();
            }
            if (apa === 'semana' && apa !== apartado) {
              $timeout(function() {
                dateCambioDeferred.notify($scope.fechaDia);
              }, 0);
            }
            apartado = apa;
          };
          $scope.seleccionarApartado = seleccionarApartado;

           /**
               * @ngdoc method
               * @name selectorPeriodo.seleccionadoApartado
               * @methodOf selectorPeriodo
               * @description
               * Función que se encarga de ver si un apartado está seleccionado o no, y según lo que devuelve,
               * en la vista se mostrará como seleccionado o no.
               * @param {string} apa Tipo de apartado al que queremos consultar
               * @return {string} Devuelve 'active' si coincide el apartado sino, devuelve un string vacio
               */
          var seleccionadoApartado = function(apa) {
            if (apartado === apa) {
              return 'active';
            }
            return '';
          };
          $scope.seleccionadoApartado = seleccionadoApartado;

          /**
              * @ngdoc method
              * @name selectorPeriodo.setFechas
              * @methodOf selectorPeriodo
              * @description
              * Función que se encarga de asignar nuevos valores a fechaDesde y fechaHasta
              * @param {Date} fechaInicio fecha que se asignará a fechaDesde
              * @param {Date} fechaFin fecha que se asignará a fechaHasta
              */
         $scope.selector.setFechas = function(fechaInicio,fechaFin,ap) {
           fechaDesde = fechaInicio;
           fechaHasta = fechaFin;
           $scope.personalizado.fechaInicio = fechaDesde;
           $scope.personalizado.horaInicio = fechaDesde;
           $scope.personalizado.fechaFin = fechaHasta;
           $scope.personalizado.horaFin = fechaHasta;
           apartado = ap;
           //Actualizamos el texto a mostrar en el selector
           $scope.seleccionarFecha();
         };


          /**
              * @ngdoc method
              * @name selectorPeriodo.cambioSemana
              * @methodOf selectorPeriodo
              * @description
              * Función que se ejecuta cuando el usuario hace click sobre una semana en el
              * calendario del apartado semana
              */
          var cambioSemana = function() {
            $scope.fechaDia = moment($scope.fechaSemana).startOf('isoWeek').toDate();
            $scope.fechaMes = $scope.fechaDia;

            $scope.personalizado.fechaInicio = $scope.fechaDia;
            $scope.personalizado.horaInicio = $scope.fechaDia;
            $scope.personalizado.fechaFin = moment($scope.fechaDia).add(1, 'week').toDate();
            $scope.personalizado.horaFin = $scope.fechaDia;

            dateCambioDeferred.notify($scope.fechaDia);
          };
          $scope.cambioSemana = cambioSemana;

           /**
               * @ngdoc method
               * @name selectorPeriodo.claseParaSemana
               * @methodOf selectorPeriodo
               * @description
               * Devuelve 'fechaSemana' si son los elementos que esta en la semana seleccionada
               * @param {date} date Fecha a evaluar
               * @param {string} mode Tipo de vista del mapa
               * @return {string} Devuelve 'fechaSemana' si la fecha pasada esta en la semana
               */
          $scope.claseParaSemana = function(date, mode) {
            if (mode === 'day') {
              var inicio = moment($scope.fechaSemana).startOf('isoWeek').toDate();
              var fin = moment(inicio).add(1, 'week');
              if (inicio <= date && fin > date) {
                return 'fechaSemana';
              }
            }
            return '';
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.numeroMenu
               * @methodOf selectorPeriodo
               * @description
               * Devuelve el orden en el que esta ese elemento
               * @param {string} tipo Tipo de apartado del menu
               * @return {number} Devuelve un numero segun el orden
               */
          var numeroMenu = function(tipo) {
            var vuelta;
            switch (tipo) {
              case '6horas':
                vuelta = 1;
                break;
              case 'hoy':
                vuelta = 2;
                break;
              case 'ayer':
                vuelta = 3;
                break;
              case 'semana':
                vuelta = 4;
                break;
              case '7dias':
                vuelta = 5;
                break;
              case 'ultsemana':
                vuelta = 6;
                break;
              case 'mes':
                vuelta = 7;
                break;
              case '30dias':
                vuelta = 8;
                break;
              case 'ultmes':
                vuelta = 9;
                break;
              default:
                vuelta = 0;
            }
            return vuelta;
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.verMenuRapido
               * @methodOf selectorPeriodo
               * @description
               * Devuelve true si hay que mostrar esos apartados del menu rapido
               * @param {string} tipo Tipo de apartado del menu
               * @return {boolean} Devuelve la promesa sobre la colección
               */
          var verMenuRapido = function(tipo) {
            if (menuRapido) {
              var inicio = numeroMenu(menuRapidoMin);
              var fin = numeroMenu(menuRapidoMax);
              var actual = numeroMenu(tipo);
              if ((actual >= inicio && actual <= fin) || tipo === 'personalizado') {
                return true;
              } else if (tipo === 'todos') {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          };
          $scope.verMenuRapido = verMenuRapido;

           /**
               * @ngdoc method
               * @name selectorPeriodo.guardarSelector
               * @methodOf selectorPeriodo
               * @description
               * Guarda el selector para si asi se utiliza en otro lugar con el mismo apartado
               * poder ejecutarlo
               */
          var guardarSelector = function() {
            if ($scope.tipo) {
              var esta = false;
              for (var ii = 0; ii < conexion.fechasSelector.length; ii++) {
                if ($scope.tipo === conexion.fechasSelector[ii].tipo) {
                  conexion.fechasSelector[ii].apartado = apartado;
                  conexion.fechasSelector[ii].fechaDesde = fechaDesde;
                  conexion.fechasSelector[ii].fechaHasta = fechaHasta;
                  esta = true;
                  break;
                }
              }
              if (!esta) {
                var insertar = {
                  tipo: $scope.tipo,
                  apartado: apartado,
                  fechaDesde: fechaDesde,
                  fechaHasta: fechaHasta
                };
                conexion.fechasSelector.push(insertar);
              }
            }
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.seleccionRapida
               * @methodOf selectorPeriodo
               * @description
               * Ejecuta las acciones cuando selecciona un elemento del menu rápido
               * @param {string} tipo Tipo de apartado del menu
               */
          var seleccionRapida = function(tipo) {
            switch (tipo) {
              case '6horas':
                fechaDesde = new Date(utilidades.getUserDate() - 6 * 60 * 60 * 1000);
                fechaHasta = utilidades.getUserDate();
                apartado = 'personalizado';
                break;
              case 'hoy':
                fechaDesde = moment(utilidades.getUserDate()).startOf('day').toDate();
                fechaHasta = moment(utilidades.getUserDate()).add(1, 'day').startOf('day').toDate();
                apartado = 'dia';
                break;
              case 'ayer':
                fechaDesde = moment(new Date(utilidades.getUserDate() - 24 * 60 * 60 * 1000)).startOf('day').toDate();
                fechaHasta = moment(new Date(utilidades.getUserDate())).startOf('day').toDate();
                apartado = 'dia';
                break;
              case 'semana':
                fechaDesde = moment(utilidades.getUserDate()).startOf('isoWeek').startOf('day').toDate();
                fechaHasta = moment(utilidades.getUserDate()).add(1, 'week').startOf('isoWeek').startOf('day').toDate();
                apartado = 'semana';
                break;
              case '7dias':
                fechaDesde = moment(new Date(utilidades.getUserDate() - 7 * 24 * 60 * 60 * 1000)).startOf('day').toDate();
                fechaHasta = moment(utilidades.getUserDate()).add(0, 'day').startOf('day').toDate();
                apartado = 'personalizado';
                break;
              case 'ultsemana':
                fechaDesde = moment(utilidades.getUserDate()).add(-1, 'week').startOf('isoWeek').startOf('day').toDate();
                fechaHasta = moment(utilidades.getUserDate()).startOf('isoWeek').startOf('day').toDate();
                apartado = 'semana';
                break;
              case 'mes':
                fechaDesde = moment(utilidades.getUserDate()).startOf('month').startOf('day').toDate();
                fechaHasta = moment(utilidades.getUserDate()).startOf('month').add(1, 'month').startOf('day').toDate();
                apartado = 'mes';
                break;
              case '30dias':
                fechaDesde = moment(new Date(utilidades.getUserDate() - 30 * 24 * 60 * 60 * 1000)).startOf('day').toDate();
                fechaHasta = moment(utilidades.getUserDate()).add(1, 'day').startOf('day').toDate();
                apartado = 'personalizado';
                break;
              case 'ultmes':
                fechaDesde = moment(utilidades.getUserDate()).startOf('month').add(-1, 'month').startOf('day').toDate();
                fechaHasta = moment(utilidades.getUserDate()).startOf('month').startOf('day').toDate();
                apartado = 'mes';
                break;
            }
            actualizarTextoMostrar();
            guardarSelector();
            $scope.dropIsOpen = false;
          };
          $scope.seleccionRapida = seleccionRapida;

           /**
               * @ngdoc method
               * @name selectorPeriodo.showErrorMsg
               * @methodOf selectorPeriodo
               * @description
               * Muestra el mensaje de error en la pantalla mediante el modal prestablecido
               * @param {object} deferred El modal para mostrar
               * @param {string} message Mensaje que se mostrará en el modal de error
               * @return {string} Devuelve el mensaje que se mostrará en el modal
               */
          var showErrorMsg = function(deferred, message) {
            var modalInstance = $uibModal.open({
              templateUrl: 'app/components/templates/modalError.html',
              controller: 'ModalErrorCtrl as vm',
              size: 'sm',
              resolve: {
                msg: function() {
                  return message;
                }
              }
            });

            modalInstance.result.then(function() {
              deferred.reject(message);
            }, function() {});
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.seleccionarFecha
               * @methodOf selectorPeriodo
               * @description
               * Ejecuta las acciones cuando se hace click sobre el boton de seleccionar fecha
               */
          var seleccionarFecha = function() {
            switch (apartado) {
              case 'dia':
                fechaDesde = moment($scope.fechaDia).startOf('day').toDate();
                fechaHasta = moment($scope.fechaDia).add(1, 'day').startOf('day').toDate();
                break;
              case 'semana':
                fechaDesde = moment($scope.fechaSemana).startOf('week').toDate();
                fechaHasta = moment($scope.fechaSemana).add(1, 'week').startOf('week').toDate();
                break;
              case 'mes':
                fechaDesde = moment($scope.fechaMes).startOf('month').toDate();
                fechaHasta = moment($scope.fechaMes).add(1, 'month').startOf('month').toDate();
                break;
              case 'personalizado':
                var horaInicio = moment($scope.personalizado.horaInicio);
                var horaFin = moment($scope.personalizado.horaFin);
                if (!$scope.personalizado.fechaInicio) {
                  $scope.personalizado.fechaInicio = utilidades.getUserDate();
                  $scope.personalizado.fechaInicio.setSeconds(0);
                }
                if (!$scope.personalizado.fechaFin) {
                  $scope.personalizado.fechaFin = moment(utilidades.getUserDate()).add(1, 'day').toDate();
                  $scope.personalizado.fechaFin.setSeconds(0);
                }
                var fechaDesdeLag = moment($scope.personalizado.fechaInicio).set('hour', horaInicio.get('hour')).set('minute', horaInicio.get('minute')).toDate();
                var fechaHastaLag = moment($scope.personalizado.fechaFin).set('hour', horaFin.get('hour')).set('minute', horaFin.get('minute')).toDate();

                if ($scope.periodominutosmax) {
                  var milisegundos = Number($scope.periodominutosmax) * 60 * 1000;
                  var dif = fechaHastaLag.getTime() - fechaDesdeLag.getTime();
                  if (dif > milisegundos) {
                    var deferred = $q.defer();
                    showErrorMsg(deferred, $translate.instant('La fecha excede el periodo de tiempo máximo'));
                    return;
                  } else {
                    //Para el control del cambio de hora
                    var desde = angular.copy($scope.personalizado.fechaInicio);
                    var hasta = angular.copy($scope.personalizado.fechaFin);
                    var minutosAhora = Number((hasta.getTime() - desde.getTime()) / 60000);

                    var fechaDesdeEnero = moment(desde.setMonth(0)).set('hour', horaInicio.get('hour')).set('minute', horaInicio.get('minute')).toDate();
                    var fechaHastaEnero = moment(hasta.setMonth(0)).set('hour', horaInicio.get('hour')).set('minute', horaInicio.get('minute')).toDate();
                    var minutosEnero = Number((fechaHastaEnero.getTime() - fechaDesdeEnero.getTime()) / 60000);

                    var diferenciaMinutos = minutosAhora - minutosEnero;
                    var maxMin = 0;
                    if (diferenciaMinutos >= 0) {
                      maxMin = Number($scope.periodominutosmax) + diferenciaMinutos;
                    } else {
                      maxMin = Number($scope.periodominutosmax);
                    }
                    $scope.periodominutosmax = maxMin.toString();

                    if (fechaDesdeLag > fechaHastaLag) {
                      showErrorMsg($q.defer(), $translate.instant('La fecha de inicio es mayor a la fecha final'));
                      return;
                    }
                    if ($scope.periodominutosmax) {
                      milisegundos = Number($scope.periodominutosmax) * 60 * 1000;
                      var test = new Date(fechaDesdeLag.getTime() + milisegundos);
                      if (test < fechaHastaLag) {
                        showErrorMsg($q.defer(), $translate.instant('La fecha excede el periodo de tiempo máximo'));
                        return;
                      }
                    }
                  }
                }
                fechaDesde = fechaDesdeLag;
                fechaHasta = fechaHastaLag;
                break;
            }
            actualizarTextoMostrar();
            guardarSelector();
            $scope.dropIsOpen = false;

          };
          $scope.seleccionarFecha = seleccionarFecha;

           /**
               * @ngdoc method
               * @name selectorPeriodo.iniciar
               * @methodOf selectorPeriodo
               * @description
               * Función que inicia el selector
               */
          var iniciar = function() {
            if (!$scope.menurapidomin && !$scope.menurapidomax) {
              menuRapido = false;
            }
            if (menuRapido) {
              if ($scope.menurapidomin) {
                menuRapidoMin = $scope.menurapidomin;
                if (numeroMenu(menuRapidoMin) === 0) {
                  menuRapido = false;
                }
              } else {
                menuRapidoMin = '6horas';
              }
              if ($scope.menurapidomax) {
                menuRapidoMax = $scope.menurapidomax;
                if (numeroMenu(menuRapidoMax) === 0) {
                  menuRapido = false;
                }
              } else {
                menuRapidoMax = 'ultmes';
              }

              if (menuRapido) {
                if (numeroMenu(menuRapidoMin) > numeroMenu(menuRapidoMax)) {
                  menuRapido = false;
                }
              }
            }
            var numMenu;
            if ($scope.periodominutosmax) {
              var minutos = Number($scope.periodominutosmax);
              if (minutos < 24 * 60) {
                $scope.mostrarApartados = false;
                apartado = 'personalizado';
                menuRapido = false;
              } else if (minutos < 7 * 24 * 60) {
                $scope.mostrarApartados = true;
                $scope.mostrarSemana = false;
                $scope.mostrarMes = false;
                numMenu = numeroMenu(menuRapidoMax);
                if (numMenu !== 0 && numMenu > numeroMenu('ayer')) {
                  menuRapidoMax = 'ayer';
                }
              } else if (minutos < 31 * 24 * 60) {
                $scope.mostrarApartados = true;
                $scope.mostrarSemana = true;
                $scope.mostrarMes = false;
                numMenu = numeroMenu(menuRapidoMax);
                if (numMenu !== 0 && numMenu > numeroMenu('ultsemana')) {
                  menuRapidoMax = 'ultsemana';
                }
              } else {
                $scope.mostrarApartados = true;
                $scope.mostrarSemana = true;
                $scope.mostrarMes = true;
              }

              var horas = parseInt(minutos / 60);
              var dias = 0;
              if (horas > 0) {
                minutos = minutos % 60;
                $scope.tiempoMaximo = minutos + ' ' + $translate.instant('minuto(s)');
                dias = parseInt(horas / 24);
                if (dias > 0) {
                  horas = horas % 24;
                }
              }

              $scope.tiempoMaximo = '';
              if (minutos > 0) {
                $scope.tiempoMaximo = minutos + ' ' + $translate.instant('minuto(s)');
              }
              if (horas > 0) {
                $scope.tiempoMaximo = horas + ' ' + $translate.instant('hora(s)') + ' ' + $scope.tiempoMaximo;
              }
              if (dias > 0) {
                $scope.tiempoMaximo = dias + ' ' + $translate.instant('día(s)') + ' ' + $scope.tiempoMaximo;
              }
            } else {
              $scope.mostrarApartados = true;
              $scope.mostrarSemana = true;
              $scope.mostrarMes = true;
            }

            $scope.textoFechaPeriodo = undefined;
            $scope.titletextoFechaPeriodo = undefined;

            var esta = false;
            for (var ii = 0; ii < conexion.fechasSelector.length; ii++) {
              if ($scope.tipo === conexion.fechasSelector[ii].tipo) {
                esta = true;
                apartado = conexion.fechasSelector[ii].apartado;
                fechaDesde = conexion.fechasSelector[ii].fechaDesde;
                fechaHasta = conexion.fechasSelector[ii].fechaHasta;
                $scope.fechaDia = fechaDesde;
                $scope.fechaSemana = fechaDesde;
                $scope.fechaMes = fechaDesde;
                $scope.personalizado = {};
                $scope.personalizado.fechaInicio = fechaDesde;
                $scope.personalizado.horaInicio = fechaDesde;
                $scope.personalizado.fechaFin = fechaHasta;
                $scope.personalizado.horaFin = fechaHasta;
              }
            }

            if (!esta) {
              var fechaUsuario = utilidades.getUserDate();

              $scope.fechaDia = fechaUsuario;
              $scope.fechaSemana = fechaUsuario;
              $scope.fechaMes = fechaUsuario;
              $scope.personalizado = {};
              $scope.personalizado.fechaInicio = fechaUsuario;
              $scope.personalizado.horaInicio = fechaUsuario;

              if ($scope.apartadoinicio) {
                apartado = $scope.apartadoinicio;
              }

              if ($scope.fechadesdeinicio === '6horas') {
                seleccionRapida('6horas');
                return;
              } else if ($scope.fechadesdeinicio === 'hoy') {
                seleccionRapida('hoy');
                return;
              } else if ($scope.fechadesdeinicio === 'ayer') {
                seleccionRapida('ayer');
                return;
              } else if ($scope.fechadesdeinicio === 'semana') {
                seleccionRapida('semana');
                return;
              } else if ($scope.fechadesdeinicio === '7dias') {
                seleccionRapida('7dias');
                return;
              } else if ($scope.fechadesdeinicio === 'ultsemana') {
                seleccionRapida('ultsemana');
                return;
              } else if ($scope.fechadesdeinicio === 'mes') {
                seleccionRapida('mes');
                return;
              } else if ($scope.fechadesdeinicio === '30dias') {
                seleccionRapida('30dias');
                return;
              } else if ($scope.fechadesdeinicio === 'ultmes') {
                seleccionRapida('ultmes');
                return;
              } else if ($scope.fechadesdeinicio) {
                fechaUsuario = moment($scope.fechadesdeinicio).toDate();
                $scope.personalizado.fechaInicio = fechaUsuario;
                $scope.personalizado.horaInicio = fechaUsuario;
              }

              if ($scope.fechadesdeinicio && $scope.fechahastainicio) {
                $scope.personalizado.fechaFin = moment($scope.fechahastainicio).toDate();
                //$scope.personalizado.fechaInicio = moment($scope.fechadesdeinicio).toDate();

                //if (!(moment($scope.fechadesdeinicio).add(1, 'day').startOf('day').isSame(moment($scope.fechadesdeinicio).add(1, 'day')) &&
                  //  moment($scope.fechadesdeinicio).add(1, 'day').isSame(moment($scope.fechahastainicio)))) {
                  apartado = 'personalizado';
                //}
              } else {
                $scope.personalizado.fechaFin = moment(fechaUsuario).add(1, 'day').toDate();

              }
              $scope.personalizado.horaFin = new Date($scope.personalizado.fechaFin);
            }

            if ($scope.periodominutosmax) {
              if (Number($scope.periodominutosmax) < 24 * 60) {
                //$scope.personalizado.fechaFin = moment(utilidades.getUserDate()).add(minutos, 'minute').toDate();
                $scope.personalizado.fechaFin = new Date($scope.personalizado.fechaFin);
                $scope.personalizado.horaFin = new Date($scope.personalizado.fechaFin);
              }
            }

            seleccionarFecha();
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.getFechaDesde
               * @methodOf selectorPeriodo
               * @description
               * Función mediante la cual obtenemos la fecha desde
               * @return {date} Devuelve la fecha de inicio
               */
          $scope.selector.getFechaDesde = function() {
            // return fechaDesde;
            return moment($scope.fechaDesde).format();
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.getFechaHasta
               * @methodOf selectorPeriodo
               * @description
               * Función mediante la cual obtenemos la fecha hasta
               * @return {date} Devuelve la fecha final
               */
          $scope.selector.getFechaHasta = function() {
            // return fechaHasta;
            return moment($scope.fechaHasta).format();
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.getFechaDesdeComunicacion
               * @methodOf selectorPeriodo
               * @description
               * Función mediante la cual obtenemos la fecha desde con el formato de comunicación
               * @return {string} Devuelve la fecha inicio en formato string
               */
          $scope.selector.getFechaDesdeComunicacion = function() {
            var formato = constantes.getConstante('fechaComunicacion');
            return moment(fechaDesde).format(formato);
          };

           /**
               * @ngdoc method
               * @name selectorPeriodo.getFechaHastaComunicacion
               * @methodOf selectorPeriodo
               * @description
               * Función mediante la cual obtenemos la fecha hasta con el formato de comunicación
               * @return {string} Devuelve la fecha final en formato string
               */
          $scope.selector.getFechaHastaComunicacion = function() {
            var formato = constantes.getConstante('fechaComunicacion');
            return moment(fechaHasta).format(formato);
          };

          /**
              * @ngdoc method
              * @name selectorPeriodo.setFechaDesde
              * @methodOf selectorPeriodo
              * @description
              * Función mediante la cual le damos un nuevo valor a la fecha desde
              * @param {date} fechaDesdeNuevo Nueva fecha para asignar a fechaDesde
              */
         $scope.selector.setFechaDesde = function(fechaDesdeNuevo) {
            fechaDesde = fechaDesdeNuevo;
         };

          /**
              * @ngdoc method
              * @name selectorPeriodo.getFechaHasta
              * @methodOf selectorPeriodo
              * @description
              * Función mediante la cual obtenemos la fecha hasta
              * @param {date} fechaHastaNuevo Nueva fecha para asignar a fechaHasta
              */
         $scope.selector.setFechaHasta = function(fechaHastaNuevo) {
             fechaHasta = fechaHastaNuevo;
         };

          //Ejecutamos iniciar para iniciar el selector
          iniciar();

        }
      ], //end controller
      controllerAs: 'selectorPeriodoController'
    };
  })

  .directive('jmDpRefreshView', function($timeout) {
    var noop = function() {};
    var refreshDpOnNotify = function(dpCtrl) {
      return function() {
        var month = angular.copy(dpCtrl.activeDate.getMonth());
        var year = angular.copy(dpCtrl.activeDate.getFullYear());
        dpCtrl.activeDate.setMonth(dpCtrl.activeDate.getMonth() + 1);
        dpCtrl.refreshView();
        $timeout(function() {
          dpCtrl.activeDate.setMonth(month);
          dpCtrl.activeDate.setYear(year);
          dpCtrl.refreshView();
        }, 1);
      };
    };
    return {
      require: 'uib-datepicker',
      link: function(scope, elem, attrs, dpCtrl) {
        var refreshPromise = scope[attrs.jmDpRefreshView];
        refreshPromise.then(noop, noop, refreshDpOnNotify(dpCtrl));
      }
    };
  });

})();

(function() {

  'use strict';

  /**
   * @ngdoc service
   * @name notificaciones
   * @description
   * Este servicio gestiona las notificaciones que se dan en la aplicación de iPanel
   */
  angular.module('datik-selectores')
    .service('notificaciones',
      function($rootScope, toastr, toastrConfig) {

        var vm = this;

        var options = {
          autoDismiss: false,
          containerId: 'toast-container',
          maxOpened: 3,
          closeButton: false,
          tapToDismiss: true,
          progressBar: false,
          newestOnTop: true,
          positionClass: 'toast-bottom-right',
          preventDuplicates: false,
          preventOpenDuplicates: false,
          target: 'body'
        };
        angular.extend(toastrConfig, options);

        /**
         * @ngdoc method
         * @name notificaciones.showNotification
         * @methodOf notificaciones
         * @description
         * Función que hace que se muestre la notificación en la patalla
         * @param {string} message Mensaje que se mostrará en la notificación
         * @param {object} data el tipo de la notificación
         */
        var showNotification = function(title, message, type) {
          var toast;
          if (type === 'info') {
            toast = toastr.info(title, message);
          } else if (type === 'success') {
            toast=toastr.success(title, message);
          } else if (type === 'error') {
            toast=toastr.error(title, message);
          } else if (type === 'warning') {
            toast=toastr.warning(title, message);
          } else {
            toast=toastr.info(title);
          }
          /*$.amaran({
            content: {
              'title': '',
              'message': message,
              'position': 'bottom right',
              'inEffect': 'slideBottom',
              'info': ''
            },
            theme: 'awesome ' + type
          });*/
        }

        vm.showNotification = showNotification;
        $rootScope.showNotification = showNotification;

      });
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.Filter:datikTableFilter
   * @description
   * # datikTable
   * Utilizado para filtrar los valores numéricos de los indicadores de la eficiencia en la conducción.
   * Filtra los datos de la tabla, cogiendo como umbral el valor que introduzca el usuario. </br>
   * e.j:  Si el usuario introduce el valor 100 en el campo <i>menor que</i>, en la tabla solo se mostrarán
   * los valores de ese indicador que sean menores a 100
   */
  angular.module('datik-selectores')
  .filter('datikTableFilter', datikTableFilter);

  function datikTableFilter($filter){

    var filterFilter = $filter('filter');
    var standardComparator = function standardComparator(obj, text) {
      text = ('' + text).toLowerCase();
      return ('' + obj).toLowerCase().indexOf(text) > -1;
    };

    return function datikTableFilter(array, expression) {
      function customComparator(actual, expected) {
        var isLower = expected.lower;
        var isHigher = expected.higher;
        var higherLimit;
        var lowerLimit;

        if (angular.isObject(expected)) {
          //date range
          if (angular.isDefined(isLower) || angular.isDefined(isHigher)) {
            //number range
            if (angular.isDefined(isLower)) {
              higherLimit = expected.lower;
              if(angular.isUndefined(actual) || actual === '-'){
                return false;
              }
              if (actual > higherLimit) {
                return false;
              }
            }
            if (angular.isDefined(isHigher)) {
              lowerLimit = expected.higher;
              if(angular.isUndefined(actual) || actual === '-'){
                return false;
              }
              if (actual < lowerLimit) {
                return false;
              }
            }
            return true;
          }
          return true;
        }
        return standardComparator(actual, expected);
      }

      var output = filterFilter(array, expression, customComparator);
      return output;
    };
  }


})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('datik-selectores')
    .directive('datikTable', datikTable);

  function datikTable() {
    return {
      restrict: 'E',
      scope: {
        maxHeight: '@', //Altura máxima calc(100vh - 100px) p.e.
        perPage: '@', // Número de elementos por página
        currentPage: '=', // Página actual que se muestra
        numberElementsShowing: '=', //Función para saber el número de elemenentos que se muestra
        elements: '=', //Array para saber que elementos tenemos que mostrar
        data: '=', // Array con los datos a mostrar
        options: '=', //Botones que permiten hacer cosas con los datos
        loading: '=', // Elemento para saber cuando esta cargando
        csvData: '=', // Función para obtener los datos en un array
        selection: '=', // Que tipo de selección queremos para la tabla
        isSortable: '@' //False si no se quiere que se muestre los filtros para filtrar
      },
      templateUrl: 'app/components/datikTable/datikTable.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$parse', '$filter', '$translate', '$timeout', '$sce', tableController]

    };

    function tableController($log, $scope, $parse, $filter, $translate, $timeout, $sce) {

      var vm = this;

      vm.id = parseInt(Math.random() * 1000);

      vm.dynamicData = [];
      //Elementos para la paginación

      var fechaHora = $translate.instant('fechaHoraIdioma');
      var fecha = $translate.instant('fechaIdioma');

      /**
      * Configuración de la altura
      */
      vm.tableStyle = "";
      if(angular.isDefined($scope.maxHeight) && $scope.maxHeight != ''){
        vm.tableStyle += "max-height:"+$scope.maxHeight+";";
      }

      /**
      * Muestra el número de elementos que se muestran
      */
      $scope.numberElementsShowing = function() {
        return vm.dynamicData.length;
      };

      /**
      * Devuelve el ancho correspondiente
      */
      vm.getWidth = function(elemento, index/*, data, dataIdx*/) {
        if (angular.isDefined(elemento.width)) {
          return elemento.width;
        } else {
          if(index === -1){
            return (elemento.buttons.length * 40) + 'px';
          }
          var mod = 100 % $scope.elements.length;
          var percentage = 100 / $scope.elements.length;
          if (index < mod) {
            return (percentage + 1) + '%';
          } else {
            return percentage + '%';
          }
        }
      };

      /**
      * Devuelve el padding de
      */
      vm.getLeftPadding = function(elemento, data, dataIdx, index) {
          if (angular.isDefined(elemento['padding-left'])) {
            return elemento['padding-left'];
        } else if(index === -1){
          var hiddenElements = 0;
          for(var i= 0 ; i < elemento.buttons.length ; i++) {
            if(vm.shouldHide(elemento.buttons[i], data[dataIdx], dataIdx))
              hiddenElements++;
          }
          return (hiddenElements * 40) + 'px';
        } else {
          return 0 + 'px';
        }
      };

      /**
      * Devuelve si tiene que mostrar el filtro
      */
      vm.showFilter = function() {
        if(angular.isDefined($scope.data) && $scope.isSortable != 'false'){
          return $scope.data.length > 0;
        }else{
          return false;
        }
      };

      /**
      * Obtiene el valor a mostrar en el elemento
      */
      vm.getData = function(data, elemento){
        var value = undefined;
        var color = undefined;
        var bubble = undefined;
        var titleText = undefined;
        var htmlValue = undefined;
        var getter = $parse(elemento.information);
        var getterTitle = $parse(elemento.titleText);
        try{
          value = getter(data);
          if(angular.isUndefined(value) || value === '-' || value === null){
            return '-';
          }
          titleText = getterTitle(data);
          switch (elemento.type){
            case 'string':
              color = getDataColor(data,elemento);
              bubble = getDataBubble(data,elemento);
              return getDataForView(value,color,bubble);
            case 'integer':
              color = getDataColor(data,elemento);
              bubble = getDataBubble(data,elemento);
              return getDataForView($filter('number')(value),color,bubble);
            case 'number':
              color = getDataColor(data,elemento);
              bubble = getDataBubble(data,elemento);
              return getDataForView($filter('number')(value,2),color,bubble);
            case 'datetime':
              color = getDataColor(data,elemento);
              bubble = getDataBubble(data,elemento);
              return getDataForView($filter('date')(value,fechaHora),color,bubble);
            case 'date':
              color = getDataColor(data,elemento);
              bubble = getDataBubble(data,elemento);
              return getDataForView($filter('date')(value,fecha),color,bubble);
            case 'array':
              color = getDataColor(data,elemento);
              bubble = getDataBubble(data,elemento);
              return getDataForView(value.toString(),color,bubble);
            case 'boolean':
              color = getDataColor(data,elemento);
              bubble = getDataBubble(data,elemento);
              if(value){
                return getDataForView($translate.instant('Sí'),color,bubble);
              }else{
                return getDataForView($translate.instant('No'),color,bubble);
              }
              break;
            case 'color':
              if(angular.isUndefined(titleText)){
                titleText = '';
              }
              htmlValue = '<div class="c-datik-color-value" title="'+titleText+'" style="background-color:'+value+'">&nbsp;</div>';
              return $sce.trustAsHtml(htmlValue);
            case 'progress':
              if(value>=100){value = 100;}
              if(value<=0){value=0;}
              if(angular.isUndefined(titleText)){
                titleText = '';
              }
              htmlValue = '<div class="progress c-datik-table-progress" title="'+titleText+'" style="margin-bottom: 0px;background-color: #DFDFDF;color:#979796;">'+
                            '<div class="progress-bar progress-bar-success" style="line-height: 15px;width: '+value+'%;"'+
                                 'aria-valuenow="'+value+'" aria-valuemin="0" aria-valuemax="100">'+
                                   value + ' %' +
                             '</div>'+
                           '</div>';
              return $sce.trustAsHtml(htmlValue);
            case 'colorVehiculos':
              if(angular.isDefined(elemento.titleText) && elemento.titleText === "Activo"){
                titleText = elemento.titleText;
                htmlValue = '<div class="c-datik-color-value'+titleText+'" style="background-color:'+value+'">&nbsp;</div>';
              } else {
                htmlValue = '<div class="c-datik-color-value'+titleText+'" style="background-color:'+value+'">&nbsp;</div>';
              }
              return $sce.trustAsHtml(htmlValue);
            default:
                $log.error("No se ha encontrado tipo de elemento para mostrar en la tabla " + elemento.type);
                return '-';
          }
        }catch(e){
          return '-';
        }
      };

      /**
      * Parsea los datos para el csv
      */
      function getDataForCSV(data, elemento){
        var value = undefined;
        var viewValue = undefined;
        var getter = $parse(elemento.information);
        try{
          value = getter(data);
          if(angular.isUndefined(value) || value === '-' || value === null){
            return '-';
          }
          switch (elemento.type){
            case 'string':
              return value;
            case 'integer':
              viewValue = $filter('number')(value);
              return viewValue;
            case 'number':
              viewValue = $filter('number')(value, 2);
              return viewValue;
            case 'datetime':
              viewValue = $filter('date')(value,fechaHora);
              return viewValue;
            case 'date':
              viewValue = $filter('date')(value, fecha);
              return viewValue;
            case 'array':
              return value.toString();
            case 'boolean':
              return value ? $translate.instant('Sí') : $translate.instant('No');
            case 'color':
              return value;
            case 'progress':
              return value + ' %';
            default:
              $log.error("No se ha encontrado tipo de elemento pasar al csv " + elemento.type);
              return '-';
          }
        }catch(e){
          return '-';
        }
      }

      function getDataColor(data, elemento){
        if(angular.isDefined(elemento.color)){
          if(angular.isDefined(elemento.color)){
            var getterColor = $parse(elemento.color);
            try{
              var color = getterColor(data);
              return color;
            }catch(e){
              return;
            }
          }
        }
        return;
      }
      function getDataBubble(data, elemento){
        if(angular.isDefined(elemento.bubble)){
          if(angular.isDefined(elemento.bubble)){
            var getterBubble = $parse(elemento.bubble);
            try{
              var bubbleColor = getterBubble(data);
              return bubbleColor;
            }catch(e){
              return;
            }
          }
        }
        return;
      }
      function getDataForView(value,color,bubble){
        if(angular.isUndefined(color) && angular.isUndefined(bubble)){
          return value;
        }else{
          var htmlValue;
          if(angular.isUndefined(bubble)){
            htmlValue = '<div style="color:'+color+'">'+value+'</div>';
            return $sce.trustAsHtml(htmlValue);
          }else{
            var colorStyle = '';
            if(angular.isDefined(color)){
              colorStyle = 'color:' + color + ';';
            }
            htmlValue = '<div class="c-datik-bubble-type"><div class="c-datik-bubble-value" style="background-color:'+bubble+'; '+colorStyle+' ">'+value+'</div></div>';
            return $sce.trustAsHtml(htmlValue);
          }
        }
      }
      /**
      * Obtiene la unidad del elemento
      */
      vm.obtenerUnidad = function(elemento){
        if(elemento.type === 'number' || elemento.type === 'integer'){
          if(angular.isDefined(elemento.unit)){
            if(elemento.unit === 'percentage'){
              return '(%)';
            }else{
              return '(' + $filter('unidad')(elemento.unit) + ')';
            }
          }
        }
      };
      /**
      * Función para definir cual es el elemento que hay que ordenar inicialmente
      */
      vm.initialSort = function(elemento){
        if(angular.isDefined(elemento.sort)){
          if(elemento.sort === true || elemento.sort === 'true'){
            return 'true';
          }else if(elemento.sort === 'reverse'){
            return 'reverse';
          }
        }
        return 'false';
      };
      /**
      * Función que se ejecuta cuando se ejecuta el boton
      */
      vm.clickButton = function(bottom, data, index){
        bottom.function(data, index);
      };
      /**
      * El boton esta disponible o no disponible
      */
      vm.isDisabled = function(bottom, data, index){
        if(angular.isDefined(bottom.disabled)){
          return bottom.disabled(data,index);
        }
        return false;
      };
      /**
      * Se debe mostrar loading en el boton
      */
      vm.showLoading = function(bottom, data, index){
        if(angular.isDefined(bottom.showLoadingImage)){
          return bottom.showLoadingImage(data,index);
        }
        return false;
      };
      /**
      * Se debe ocultar el boton
      */
      vm.shouldHide = function(bottom, data, index){
        if(angular.isDefined(bottom.shouldHideBtn)){
          return bottom.shouldHideBtn(data,index);
        }
        return false;
      };
      /**
      * Sabe si el elemento es buscable o no
      */
      vm.isElementSearchable = function(element){
        if(element.type === 'string' || element.type === 'integer' ||
          element.type === 'number' || element.type === 'date' ||
          element.type === 'datetime' || element.type === 'progress'){
          return true;
        }else if(angular.isDefined(element.sortArray) && element.sortArray.length >0 ){
          return true;
        }
        return false;
      };
      /**
      * Saca los elementos a devolver si se pide el csv
      */
      $scope.csvData = function(){
        var titulos = [];
        $scope.elements.forEach(function(element){
          titulos.push($translate.instant(element.title));
        });
        var respuesta = [titulos,[]];
        vm.dynamicData.forEach(function(row){
          var columna = [];
          $scope.elements.forEach(function(element){
            columna.push(getDataForCSV(row, element));
          });
          respuesta.push(columna);
        });
        return respuesta;
      };

      /**
      * Iniciamos la seleccion
      */
      if(angular.isUndefined($scope.selection)){
        vm.selection = {
          mode: undefined
        };
      }else{
        vm.selection = $scope.selection;
        if(angular.isUndefined(vm.selection.changeSelectionEventName)){
          vm.selection.changeSelectionEventName = 'datik-table-change-selection';
        }
        $scope.selection.getSelectedElements = getSelectedElements;
        // Si hay cambios en página en la que esta generamos un evento
        if(angular.isDefined($scope.selection.mode) && $scope.selection.mode){
          $scope.$watch('currentPage',function(newValue){
            var currentPage = Number(newValue);
            if(currentPage > 0){
              changeSelectionEvent();
            }
          });
          // Si hay cambios en el numero elementos es que se ha hecho
          // un cambio en la tabla por lo que si el tamaño es distinto
          //  a lo anteriormente seleccionadogeneramos el evento
          $scope.$watch('vm.dynamicData.length', function(value){
            if(value > 0){
              var selectedElements = getSelectedElements();
              if(previusSelectedElements.length != selectedElements.length){
                $scope.$emit(vm.selection.changeSelectionEventName,selectedElements);
              }
              previusSelectedElements = selectedElements;
            }
          });
        }
      }

      /**
      * Función para obtener los elementos que el usuario tiene a la vista
      * y estan seleccionados
      */
      function getSelectedElements(){
        var perPage = parseInt($scope.perPage);
        var currentPage = parseInt($scope.currentPage);
        if(!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage <1){
          return [];
        }
        var ii = perPage*(currentPage-1);
        var response = [];
        var length = vm.selection.numElementsShowing() + ii;
        for(ii; ii < length; ii++){
          if(vm.dynamicData[ii].selected){
            response.push(vm.dynamicData[ii]);
          }
        }
        return response;
      }
      /**
      * Obtiene los datos que estan en el objeto que tienen la propiedad seleccionada
      function getAllDataSelectedElements(){
        var response = [];
        $scope.data.forEach(function(element){
          if(element.selected){
            response.push(element);
          }
        });
        return response;
      }
      */
      /**
      * Función para ver si hay que enseñar los checkboxes
      */
      vm.selection.showCheckBoxes = function(){
        if(angular.isDefined(vm.selection.mode) && vm.selection.mode === 'checkbox'){
          return true;
        }else{
          return false;
        }
      };
      /**
      * Función para saber cuantos elementos seleccionados se estan mostrando
      */
      vm.selection.numShowingElementsSelected = function(){
        var perPage = Number($scope.perPage);
        var currentPage = Number($scope.currentPage);
        if(!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage <1){
          return 0;
        }
        var response = 0;
        var ii = perPage*(currentPage-1);
        var length = vm.selection.numElementsShowing() + ii;
        for(ii; ii < length; ii++){
          if(vm.dynamicData[ii].selected){
            response++;
          }
        }
        return response;
      };
      /**
      * Número de elementos que se estan mostrando
      */
      vm.selection.numElementsShowing = function(){
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if(!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage <1){
          return 0;
        }
        var ii = perPage*(currentPage-1);
        var length = ii + perPage;
        if(length > vm.dynamicData.length){
          length = vm.dynamicData.length;
        }
        return length - ii;
      };
      /**
      * Selecciona los elementos que esta viendo el usuario
      */
      vm.selection.selectElements = function(){
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if(!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage <1){
          return;
        }
        var ii = perPage*(currentPage-1);
        var length = vm.selection.numElementsShowing() + ii;
        for(ii; ii <  length; ii++){
          vm.dynamicData[ii].selected = true;
        }
        $timeout(changeSelectionEvent,0);
      };
      /*
      * Deselecciona los elementos que ve el usuario
      */
      vm.selection.unselectElements = function(){
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if(!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage <1){
          return;
        }
        var ii = perPage*(currentPage-1);
        var length = vm.selection.numElementsShowing() + ii;
        for(ii; ii <  length; ii++){
          vm.dynamicData[ii].selected = false;
        }
        $timeout(changeSelectionEvent,0);
      };
      /**
      * Selecciona un elemento
      */
      vm.selection.selectElement = function(row){
        row.selected = true;
        $timeout(changeSelectionEvent,0);
      };
      /**
      * Deselecciona un elemento
      */
      vm.selection.unselectElement = function(row){
        row.selected = false;
        $timeout(changeSelectionEvent,0);
      };

      /**
      * Se hace click sobre una seccion
      */
      var previusSelection = undefined;
      vm.selection.rowClicked = function(row){
          if(angular.isDefined(vm.selection) && angular.isDefined(vm.selection.mode)){
            if(vm.selection.mode === 'simple'){
              if(row.selected){
                row.selected = false;
                $timeout(changeSelectionEvent,0);
              }else{
                if(angular.isDefined(previusSelection)){
                  previusSelection.selected = false;
                }
                row.selected = true;
                previusSelection = row;
                $timeout(changeSelectionEvent,0);
              }
            }
            if(vm.selection.mode === 'multiple'){
              if(row.selected){
                row.selected = false;
              }else{
                row.selected = true;
              }
              $timeout(changeSelectionEvent,0);
            }
          }
      };

      $scope.$on('cambiarPreviusSelection',function(evento,elemento){
        previusSelection = elemento;
      });

      $scope.$on('hideRowsUsers',function(evento,data, valor){
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return;
        }
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        if (vm.dynamicData.length > 0 && angular.isDefined(vm.dynamicData[ii].user) && angular.isDefined(data)) {
          for (ii; ii < length; ii++) {
            if (data.user.id !== vm.dynamicData[ii].user.id) {
              vm.dynamicData[ii].hide = valor;
            }
          }
        } else {
          for (ii; ii < vm.dynamicData.length; ii++) {
            vm.dynamicData[ii].hide = valor;
          }
        }
      });

      $scope.$on('updateRowUser',function(evento,data){
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return;
        }
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          if (angular.isDefined(vm.dynamicData[ii].user)) {
            if (vm.dynamicData[ii].user.id === data.user.id) {
              vm.dynamicData[ii] = data;
              vm.dynamicData[ii].selected = true;
              previusSelection = data;
              break;
            }
          }
        }
      });

      $scope.$on('desSeleccionarElementoVin',function(evento,data){
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return;
        }
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          if (data.uid !== vm.dynamicData[ii].uid) {
            vm.dynamicData[ii].selected = false;
          }
        }
        // $timeout(changeSelectionEvent, 0);
      });

      /**
      * Gestiona el cambio de eventos seleccionados
      */
      var previusSelectedElements = [];
      function changeSelectionEvent(){
        var response = getSelectedElements();
        if(previusSelectedElements.length != 0 || response.length != 0){
          $scope.$emit(vm.selection.changeSelectionEventName,response);
        }
        previusSelectedElements = response;
      }

      $scope.$watch('vm.dynamicData', validateScrollTable);
      /**
      * Mira si la tabla esta con escroll y si es asi ajusta la cabecera
      */
      function validateScrollTable(){
        var elem = angular.element('#tbody'+vm.id);
        if (elem.length > 0 &&elem[0].clientHeight < elem[0].scrollHeight){
          vm.theadClass= "c-datik-table-thead-withscroll";
        }else{
          vm.theadClass = "";
        }
      }
    }

  }

})();

(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('datik-selectores')
    .directive('datikScrollableTable', datikScrollableTable)
    .directive('ngEnterBlur', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            event.target.blur();
            event.preventDefault();
          }
        });
      };
    })
    .directive('infinitescroll', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          element.bind('scroll', function () {
            if (element[0].scrollTop + element[0].offsetHeight == element[0].scrollHeight) {
              if (element[0].scrollHeight > 0) {
                scope.$apply(attrs.infinitescroll);
              }
            }
          });
        }
      };
    });

  function datikScrollableTable() {
    return {
      restrict: 'E',
      scope: {
        contenedor: '@', // Nombre del contenedor (Su tamaño)
        maxHeight: '@', //Altura máxima calc(100vh - 100px) p.e.
        perPage: '@', // Número de elementos por página
        currentPage: '=', // Página actual que se muestra
        numberElementsShowing: '=', //Función para saber el número de elemenentos que se muestra
        elements: '=', //Array para saber que elementos tenemos que mostrar
        data: '=', // Array con los datos a mostrar
        options: '=', //Botones que permiten hacer cosas con los datos
        loading: '=', // Elemento para saber cuando esta cargando
        csvData: '=', // Función para obtener los datos en un array
        selection: '=', // Que tipo de selección queremos para la tabla
        isSortable: '@', //False si no se quiere que se muestre los filtros para filtrar
        loadData: '='
      },
      templateUrl: 'app/components/datikTable/datikScrollableTable.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$parse', '$filter', '$translate', '$timeout', '$sce', '$q', tableController]

    };

    function tableController($log, $scope, $parse, $filter, $translate, $timeout, $sce, $q) {

      var vm = this;

      vm.id = parseInt(Math.random() * 1000);

      vm.dynamicData = [];
      //Elementos para la paginación

      var fechaHora = $translate.instant('fechaHoraIdioma');
      var fecha = $translate.instant('fechaIdioma');

      vm.container = "";
      if (angular.isDefined($scope.contenedor) && $scope.contenedor != '') {
        vm.container = $scope.contenedor;
      }

      /**
      * Configuración de la altura
      */
      vm.tableStyle = "";
      if (angular.isDefined($scope.maxHeight) && $scope.maxHeight != '') {
        vm.tableStyle += "max-height:" + $scope.maxHeight + ";";
      }

      /**
      * Muestra el número de elementos que se muestran
      */
      $scope.numberElementsShowing = function () {
        return vm.dynamicData.length;
      };

      /**
      * Devuelve el ancho correspondiente
      */
      vm.getWidth = function (elemento, index) {
        if (angular.isDefined(elemento.width)) {
          return elemento.width;
        } else {
          if (index === -1) {
            return (elemento.buttons.length * 40) + 'px';
          }
          var mod = 100 % $scope.elements.length;
          var percentage = 100 / $scope.elements.length;
          if (index < mod) {
            return (percentage + 1) + '%';
          } else {
            return percentage + '%';
          }
        }
      };

      /**
      * Devuelve el padding de
      */
      vm.getLeftPadding = function (elemento, data, dataIdx, index) {
        if (angular.isDefined(elemento['padding-left'])) {
          return elemento['padding-left'];
        } else if (index === -1) {
          var hiddenElements = 0;
          for (var i = 0; i < elemento.buttons.length; i++) {
            if (vm.shouldHide(elemento.buttons[i], data[dataIdx], dataIdx))
              hiddenElements++;
          }
          return (hiddenElements * 40) + 'px';
        } else {
          return 0 + 'px';
        }
      };

      /**
      * Devuelve si tiene que mostrar el filtro
      */
      vm.showFilter = function () {
        if (angular.isDefined($scope.data) && $scope.isSortable != 'false') {
          return $scope.data.length > 0;
        } else {
          return false;
        }
      };

      /**
      * Obtiene el valor a mostrar en el elemento
      */
      vm.getData = function (data, elemento) {
        var value = undefined;
        var color = undefined;
        var bubble = undefined;
        var titleText = undefined;
        var htmlValue = undefined;
        var getter = $parse(elemento.information);
        var getterTitle = $parse(elemento.titleText);
        try {
          value = getter(data);
          if (angular.isUndefined(value) || value === '-' || value === null) {
            return '-';
          }
          titleText = getterTitle(data);
          switch (elemento.type) {
            case 'string':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView(value, color, bubble);
            case 'integer':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($filter('number')(value), color, bubble);
            case 'number':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($filter('number')(value, 2), color, bubble);
            case 'datetime':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($filter('date')(value, fechaHora), color, bubble);
            case 'date':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($filter('date')(value, fecha), color, bubble);
            case 'array':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView(value.toString(), color, bubble);
            case 'boolean':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($translate.instant((value) ? 'Sí' : 'No'), color, bubble);
            case 'color':
              if (angular.isUndefined(titleText)) {
                titleText = '';
              }
              htmlValue = '<div class="c-datik-color-value" title="' + titleText + '" style="background-color:' + value + '">&nbsp;</div>';
              return $sce.trustAsHtml(htmlValue);
            case 'progress':
              if (value >= 100) { value = 100; }
              if (value <= 0) { value = 0; }
              if (angular.isUndefined(titleText)) {
                titleText = '';
              }
              htmlValue = '<div class="progress c-datik-table-progress c-datik-table-title" title="' + titleText + '">' +
                '<div class="progress-bar progress-bar-success" style="width: ' + value + '%;"' +
                'aria-valuenow="' + value + '" aria-valuemin="0" aria-valuemax="100">' +
                value + ' %' +
                '</div>' +
                '</div>';
              return $sce.trustAsHtml(htmlValue);
            case 'colorVehiculos':
              if (angular.isDefined(elemento.titleText) && elemento.titleText === "Activo") {
                titleText = elemento.titleText;
                htmlValue = '<div class="c-datik-color-value' + titleText + '" style="background-color:' + value + '">&nbsp;</div>';
              } else {
                htmlValue = '<div class="c-datik-color-value' + titleText + '" style="background-color:' + value + '">&nbsp;</div>';
              }
              return $sce.trustAsHtml(htmlValue);
            default:
              $log.error("No se ha encontrado tipo de elemento para mostrar en la tabla " + elemento.type);
              return '-';
          }
        } catch (e) {
          return '-';
        }
      };

      /**
      * Parsea los datos para el csv
      */
      function getDataForCSV(data, elemento) {
        var value = undefined;
        var viewValue = undefined;
        var getter = $parse(elemento.information);
        try {
          value = getter(data);
          if (angular.isUndefined(value) || value === '-' || value === null) {
            return '-';
          }
          switch (elemento.type) {
            case 'string':
              return value;
            case 'integer':
              viewValue = $filter('number')(value);
              return viewValue;
            case 'number':
              viewValue = $filter('number')(value, 2);
              return viewValue;
            case 'datetime':
              viewValue = $filter('date')(value, fechaHora);
              return viewValue;
            case 'date':
              viewValue = $filter('date')(value, fecha);
              return viewValue;
            case 'array':
              return value.toString();
            case 'boolean':
              if (value) {
                return $translate.instant('Sí');
              } else {
                return $translate.instant('No');
              }
              break;
            case 'color':
              return value;
            case 'progress':
              return value + ' %';
            default:
              $log.error("No se ha encontrado tipo de elemento pasar al csv " + elemento.type);
              return '-';
          }
        } catch (e) {
          return '-';
        }
      }

      function getDataColor(data, elemento) {
        if (angular.isDefined(elemento.color)) {
          if (angular.isDefined(elemento.color)) {
            var getterColor = $parse(elemento.color);
            try {
              var color = getterColor(data);
              return color;
            } catch (e) {
              return;
            }
          }
        }
        return;
      }
      function getDataBubble(data, elemento) {
        if (angular.isDefined(elemento.bubble)) {
          if (angular.isDefined(elemento.bubble)) {
            var getterBubble = $parse(elemento.bubble);
            try {
              var bubbleColor = getterBubble(data);
              return bubbleColor;
            } catch (e) {
              return;
            }
          }
        }
        return;
      }
      function getDataForView(value, color, bubble) {
        if (angular.isUndefined(color) && angular.isUndefined(bubble)) {
          return value;
        } else {
          var htmlValue;
          if (angular.isUndefined(bubble)) {
            htmlValue = '<div style="color:' + color + '">' + value + '</div>';
            return $sce.trustAsHtml(htmlValue);
          } else {
            var colorStyle = '';
            if (angular.isDefined(color)) {
              colorStyle = 'color:' + color + ';';
            }
            htmlValue = '<div class="c-datik-bubble-type"><div class="c-datik-bubble-value" style="background-color:' + bubble + '; ' + colorStyle + ' ">' + value + '</div></div>';
            return $sce.trustAsHtml(htmlValue);
          }
        }
      }
      /**
      * Obtiene la unidad del elemento
      */
      vm.obtenerUnidad = function (elemento) {
        if (elemento.type === 'number' || elemento.type === 'integer') {
          if (angular.isDefined(elemento.unit)) {
            if (elemento.unit === 'percentage') {
              return '(%)';
            } else {
              return '(' + $filter('unidad')(elemento.unit) + ')';
            }
          }
        }
      };
      /**
      * Función para definir cual es el elemento que hay que ordenar inicialmente
      */
      vm.initialSort = function (elemento) {
        if (angular.isDefined(elemento.sort)) {
          if (elemento.sort === true || elemento.sort === 'true') {
            return 'true';
          } else if (elemento.sort === 'reverse') {
            return 'reverse';
          }
        }
        return 'false';
      };
      /**
      * Función que se ejecuta cuando se ejecuta el boton
      */
      vm.clickButton = function (bottom, data, index) {
        bottom.function(data, index);
      };
      /**
      * El boton esta disponible o no disponible
      */
      vm.isDisabled = function (bottom, data, index) {
        if (angular.isDefined(bottom.disabled)) {
          return bottom.disabled(data, index);
        }
        return false;
      };
      /**
      * Se debe mostrar loading en el boton
      */
      vm.showLoading = function (bottom, data, index) {
        if (angular.isDefined(bottom.showLoadingImage)) {
          return bottom.showLoadingImage(data, index);
        }
        return false;
      };
      /**
      * Se debe ocultar el boton
      */
      vm.shouldHide = function (bottom, data, index) {
        if (angular.isDefined(bottom.shouldHideBtn)) {
          return bottom.shouldHideBtn(data, index);
        }
        return false;
      };
      /**
      * Sabe si el elemento es buscable o no
      */
      vm.isElementSearchable = function (element) {
        if (element.type === 'string' || element.type === 'integer' ||
          element.type === 'number' || element.type === 'date' ||
          element.type === 'datetime' || element.type === 'progress') {
          return true;
        } else if (angular.isDefined(element.sortArray) && element.sortArray.length > 0) {
          return true;
        }
        return false;
      };
      /**
      * Saca los elementos a devolver si se pide el csv
      */
      $scope.csvData = function () {
        var titulos = [];
        $scope.elements.forEach(function (element) {
          titulos.push($translate.instant(element.title));
        });
        var respuesta = [titulos, []];
        vm.dynamicData.forEach(function (row) {
          var columna = [];
          $scope.elements.forEach(function (element) {
            columna.push(getDataForCSV(row, element));
          });
          respuesta.push(columna);
        });
        return respuesta;
      };

      /**
      * Iniciamos la seleccion
      */
      if (angular.isUndefined($scope.selection)) {
        vm.selection = {
          mode: undefined
        };
      } else {
        vm.selection = $scope.selection;
        if (angular.isUndefined(vm.selection.changeSelectionEventName)) {
          vm.selection.changeSelectionEventName = 'datik-table-change-selection';
        }
        $scope.selection.getSelectedElements = getSelectedElements;
        // Si hay cambios en página en la que esta generamos un evento
        if (angular.isDefined($scope.selection.mode) && $scope.selection.mode) {
          $scope.$watch('currentPage', function (newValue) {
            var currentPage = Number(newValue);
            if (currentPage > 0) {
              changeSelectionEvent();
            }
          });
          // Si hay cambios en el numero elementos es que se ha hecho
          // un cambio en la tabla por lo que si el tamaño es distinto
          //  a lo anteriormente seleccionadogeneramos el evento
          $scope.$watch('vm.dynamicData.length', function (value) {
            if (value > 0) {
              var selectedElements = getSelectedElements();
              if (previusSelectedElements.length != selectedElements.length) {
                $scope.$emit(vm.selection.changeSelectionEventName, selectedElements);
              }
              previusSelectedElements = selectedElements;
            }
          });
        }
      }

      /**
      * Función para obtener los elementos que el usuario tiene a la vista
      * y estan seleccionados
      */
      function getSelectedElements() {
        var perPage = parseInt($scope.perPage);
        var currentPage = parseInt($scope.currentPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return [];
        }
        var ii = perPage * (currentPage - 1);
        var response = [];
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          if (vm.dynamicData[ii].selected) {
            response.push(vm.dynamicData[ii]);
          }
        }
        return response;
      }
      /**
      * Obtiene los datos que estan en el objeto que tienen la propiedad seleccionada
      function getAllDataSelectedElements(){
        var response = [];
        $scope.data.forEach(function(element){
          if(element.selected){
            response.push(element);
          }
        });
        return response;
      }
      */
      /**
      * Función para ver si hay que enseñar los checkboxes
      */
      vm.selection.showCheckBoxes = function () {
        if (angular.isDefined(vm.selection.mode) && vm.selection.mode === 'checkbox') {
          return true;
        } else {
          return false;
        }
      };
      /**
      * Función para saber cuantos elementos seleccionados se estan mostrando
      */
      vm.selection.numShowingElementsSelected = function () {
        var perPage = Number($scope.perPage);
        var currentPage = Number($scope.currentPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return 0;
        }
        var response = 0;
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          if (vm.dynamicData[ii].selected) {
            response++;
          }
        }
        return response;
      };
      /**
      * Número de elementos que se estan mostrando
      */
      vm.selection.numElementsShowing = function () {
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return 0;
        }
        var ii = perPage * (currentPage - 1);
        var length = ii + perPage;
        if (length > vm.dynamicData.length) {
          length = vm.dynamicData.length;
        }
        return length - ii;
      };
      /**
      * Selecciona los elementos que esta viendo el usuario
      */
      vm.selection.selectElements = function () {
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return;
        }
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          vm.dynamicData[ii].selected = true;
        }
        $timeout(changeSelectionEvent, 0);
      };
      /*
      * Deselecciona los elementos que ve el usuario
      */
      vm.selection.unselectElements = function () {
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return;
        }
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          vm.dynamicData[ii].selected = false;
        }
        $timeout(changeSelectionEvent, 0);
      };
      /**
      * Selecciona un elemento
      */
      vm.selection.selectElement = function (row) {
        row.selected = true;
        $timeout(changeSelectionEvent, 0);
      };
      /**
      * Deselecciona un elemento
      */
      vm.selection.unselectElement = function (row) {
        row.selected = false;
        $timeout(changeSelectionEvent, 0);
      };
      /**
      * Se hace click sobre una seccion
      */
      var previusSelection = undefined;
      vm.selection.rowClicked = function (row) {
        if (angular.isDefined(vm.selection) && angular.isDefined(vm.selection.mode)) {
          if (vm.selection.mode === 'simple') {
            if (row.selected) {
              row.selected = false;
              $timeout(changeSelectionEvent, 0);
            } else {
              if (angular.isDefined(previusSelection)) {
                previusSelection.selected = false;
              }
              row.selected = true;
              previusSelection = row;
              $timeout(changeSelectionEvent, 0);
            }
          }
          if (vm.selection.mode === 'multiple') {
            if (row.selected) {
              row.selected = false;
            } else {
              row.selected = true;
            }
            $timeout(changeSelectionEvent, 0);
          }
        }
      };
      /**
      * Gestiona el cambio de eventos seleccionados
      */
      var previusSelectedElements = [];
      function changeSelectionEvent() {
        var response = getSelectedElements();
        if (previusSelectedElements.length != 0 || response.length != 0) {
          $scope.$emit(vm.selection.changeSelectionEventName, response);
        }
        previusSelectedElements = response;
      }

      $scope.$watch('vm.dynamicData', validateScrollTable);
      /**
      * Mira si la tabla esta con escroll y si es asi ajusta la cabecera
      */
      function validateScrollTable() {
        var elem = angular.element('#tbody' + vm.id);
        if (elem.length > 0 && elem[0].clientHeight < elem[0].scrollHeight) {
          vm.theadClass = "c-datik-table-thead-withscroll";
        } else {
          vm.theadClass = "";
        }
      }

      // VALIDA QUE EL CARACTER INGRESADO EN EL INPUT SEA UN PUNTO O DOS PUNTOS
      vm.validaCaracter = function (e) {
        var keyCode = e.key;
        if (keyCode == "," || keyCode == ":") {
          e.preventDefault();
        }
      };

      // EVENTO QUE LIMPIA EL ARREGLO DYNAMICDATA
      $scope.$on('limpiarDynamicData', function (evento, data) {
        vm.dynamicData = [];
        vm.currentpage = 2;
        for (var i = 0; i < data.length; i++) {
          vm.dynamicData.push(data[i]);
        }
      });

      /* NÚMERO DE PAGINA CON LA QUE SE VA INICIALIZAR */
      vm.currentpage = 1;
      // EL NÚMERO DE ELEMENTOS QUE SE MOSTRARARN POR PAGINA
      vm.size = 40;
      // TOTAL DE REGISTROS EXISTENTES
      vm.totalRegistros = 0;
      // ELEMENTOS A BUSACR EN LA TABLA
      vm.filteredSearch = undefined;
      vm.filteredSort = undefined;

      //EVENTO QUE SE EJECUTA AL MOVER EL SCROLL
      vm.loadMore = function () {
        if (vm.dynamicData.length < vm.totalRegistros) {

          var resp = $scope.loadData(vm.currentpage, vm.size, vm.filteredSearch, vm.filteredSort, 0, $q.defer());
          resp.then(function (response) {
            if (angular.isDefined(response) && angular.isDefined(response.dtos) && response.dtos.length > 0) {
              response.dtos.forEach(function (value) {
                vm.dynamicData.push(value);
              });
              vm.currentpage += 1;
              vm.totalRegistros = response.totalCount;
            }
          });
        }
      };

      //EVENTO QUE SE EJECUTA AL CREAR LA TABLA CON ELEMENTOS
      var deferredResponse = null;
      vm.testCall = function callServer(tableState) {
        if (deferredResponse !== null) {
          deferredResponse.reject();
        }
        deferredResponse = $q.defer();

        vm.filteredSearch = tableState.search.predicateObject;
        vm.filteredSort = angular.isDefined(tableState.sort.predicate) ? tableState.sort.predicate + ":" + (tableState.sort.reverse == true ? "desc" : "asc") : "hightDate:desc";

        if (angular.isDefined(vm.filteredSearch) || vm.filteredSort !== "") {
          vm.dynamicData = [];
          vm.currentpage = 1;
        }

        var resp = $scope.loadData(vm.currentpage, vm.size, vm.filteredSearch, vm.filteredSort, 1, $q.defer()).then(function (response) {
          if (deferredResponse !== null && angular.isDefined(response) && angular.isDefined(response.dtos) && response.dtos.length > 0) {
            deferredResponse.resolve(response);
          }
          deferredResponse = null;
        });

        deferredResponse.promise.then(function (response) {
          if (angular.isDefined(response) && angular.isDefined(response.dtos) && response.dtos.length > 0) {
            response.dtos.forEach(function (value) {
              vm.dynamicData.push(value);
            });
            vm.currentpage += 1;
            vm.totalRegistros = response.totalCount;
          }
        });
      };
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('datik-selectores')
    .directive('datikNumberRange', datikNumberRange);

    function datikNumberRange(){
     return {
         restrict: 'E',
         require: '^stTable',
         scope: {
             lower: '=',
             higher: '='
         },
         template: '<div class="c-datik-number-ranger">'+
                      '<div class="input-group">'+
                          '<input placeholder="{{\'Menor a\' | translate}}" type="number" class="form-control input-sm" step="1" ng-model="lower"/>'+
                       '</div>'+
                       '<div class="input-group">'+
                          '<input placeholder="{{\'Mayor a\' | translate}}" type="number" class="form-control input-sm" step="1" ng-model="higher"/>'+
                       '</div>'+
                    '</div>',
         link: function (scope, element, attr, table) {
             var inputs = element.find('input');
             var inputLower = angular.element(inputs[0]);
             var inputHigher = angular.element(inputs[1]);
             var predicateName = attr.attribute;
             var multiplicador = attr.multiplicador;

             [inputLower, inputHigher].forEach(function (input/*, index*/) {

                 input.bind('blur', function () {
                   actualizarDatos();
                 });

                 input.bind('input', function () {
                   actualizarDatos();
                 });

                 var actualizarDatos = function(){
                   var query = {};
                   var multi = 1;
                   if(angular.isDefined(multiplicador)){
                     multi = Number(multiplicador);
                   }
                   if (angular.isDefined(scope.lower) && scope.lower !== null) {
                        query.lower = scope.lower * multi;
                   }else{
                        query.lower = undefined;
                   }

                   if (angular.isDefined(scope.higher) && scope.higher !== null) {
                       query.higher = scope.higher * multi;
                   }else{
                       query.higher = undefined;
                   }

                   scope.$apply(function () {
                       table.search(query, predicateName);
                   });
                 };

             });
         }
     };
 }

 })();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('datik-selectores')
    .directive('datikDateRangeScroll', function (moment) {
     return {
         restrict: 'E',
         require: '^stTable',
         scope: {
             lower: '=',
             higher: '=',
             format: '@'
         },
         template: '<div class="c-datik-date-range">'+
                      '<div class="c-datik-date-range-input-group {{error.lower}}">'+
                          '<input type="text" class="u-datik-placeholder input-sm c-datik-date-range-input" placeholder="{{\'Menor a\' | translate}}" '+
                          'uib-datepicker-popup="{{format}}" ng-model="lower" is-open="popUpLow.opened" '+
                          'datepicker-options="dateOptions" ' +
                          'close-text="{{ \'Cerrar\' | translate }}" clear-text="{{ \'Limpiar\' | translate }}" current-text="{{ \'Hoy\' | translate }}" '+
                          'alt-input-formats="{{altInputFormats}}" ng-change="changeLower()"/>'+
                          '<button type="button" class="btn c-datik-date-range-button" ng-click="openLower()"><i class="glyphicon glyphicon-calendar"></i></button>'+
                       '</div>'+
                       '<div class="c-datik-date-range-input-group {{error.higher}}">'+
                          '<input type="text" class="u-datik-placeholder input-sm c-datik-date-range-input" placeholder="{{\'Mayor a\' | translate}}" '+
                          'uib-datepicker-popup="{{format}}" ng-model="higher" is-open="popUpHigh.opened" '+
                          'datepicker-options="dateOptions" '+
                          'close-text="{{ \'Cerrar\' | translate }}" clear-text="{{ \'Limpiar\' | translate }}" current-text="{{ \'Hoy\' | translate }}" '+
                          'alt-input-formats="altInputFormats" ng-change="changeHigher()" />'+
                          '<button type="button" class="btn c-datik-date-range-button" ng-click="openHigher()"><i class="glyphicon glyphicon-calendar"></i></button>'+
                       '</div>'+
                    '</div>',
         controller : function($scope, constantes){
           $scope.error = {};
           $scope.dateOptions = {
                      datepickerMode: 'day',
                      startingDay: 1,
                      maxMode: 'month',
                      showWeeks : false
                    };
           $scope.altInputFormats = ['yyyy-M!-d!', 'yyyy-MM-dd', 'yyyy-M!-d! HH:mm:ss', 'yyyy-M!-d! HH:mm', 'yyyy-MM-dd HH:mm','yyyy-M!-d! H!:mm:ss', 'yyyy-M!-d! H!:mm', 'yyyy-MM-dd H!:mm', 'yyyy-M!-d! H:m', 'yyyy-MM-dd H!:m!'];
           $scope.popUpLow = { opened: false };
           $scope.popUpHigh = { opened: false };
           $scope.openLower = function(){
             $scope.popUpLow.opened = true;
           };
           $scope.openHigher = function(){
             $scope.popUpHigh.opened = true;
           };
           $scope.fechaFormato =constantes.formatoComunicacion;
           $scope.changeLower = function(){
             if(angular.isUndefined($scope.lower)){
               $scope.error.lower = "c-datik-date-range-error";
             }else{
               $scope.error.lower = "";
             }
           };
           $scope.changeHigher = function(){
             if(angular.isUndefined($scope.higher)){
               $scope.error.higher = "c-datik-date-range-error";
             }else{
               $scope.error.higher = "";
             }
           };
         },
         link: function (scope, element, attr, table) {
             var inputs = element.find('input');
             var inputLower = angular.element(inputs[0]);
             var inputHigher = angular.element(inputs[1]);
             var predicateName = attr.attribute;

             [inputLower, inputHigher].forEach(function (input) {

                 input.bind('blur', function () {
                   actualizarDatos();
                 });

                 input.bind('input', function () {
                   actualizarDatos();
                 });

                 input.bind('change', function () {
                   actualizarDatos();
                 });

                 var actualizarDatos = function(){
                   var query = {};
                   if (angular.isDefined(scope.lower) && scope.lower !== null) {
                        if(angular.isDate(scope.lower)){
                          //query.lower = scope.lower;
                          query.lower = moment(scope.lower).format(scope.fechaFormato);
                        }else{
                          query.lower = undefined;
                        }
                   }else{
                        query.lower = undefined;
                   }

                   if (angular.isDefined(scope.higher) && scope.higher !== null) {
                       if(angular.isDate(scope.higher)){
                         //query.higher = scope.higher;
                         query.higher = moment(scope.higher).format(scope.fechaFormato);
                       }else{
                         query.higher = undefined;
                       }
                   }else{
                       query.higher = undefined;
                   }

                   // scope.$apply(function () {
                       table.search(query, predicateName);
                   // });
                 };

             });
         }
     };
 });

 })();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('datik-selectores')
    .directive('datikDateRange', function (moment) {
     return {
         restrict: 'E',
         require: '^stTable',
         scope: {
             lower: '=',
             higher: '=',
             format: '@'
         },
         template: '<div class="c-datik-date-range">'+
                      '<div class="c-datik-date-range-input-group {{error.lower}}">'+
                          '<input type="text" class="u-datik-placeholder input-sm c-datik-date-range-input" placeholder="{{\'Menor a\' | translate}}" '+
                          'uib-datepicker-popup="{{format}}" ng-model="lower" is-open="popUpLow.opened" '+
                          'datepicker-options="dateOptions" ' +
                          'close-text="{{ \'Cerrar\' | translate }}" clear-text="{{ \'Limpiar\' | translate }}" current-text="{{ \'Hoy\' | translate }}" '+
                          'alt-input-formats="{{altInputFormats}}" ng-change="changeLower()"/>'+
                          '<button type="button" class="btn c-datik-date-range-button" ng-click="openLower()"><i class="glyphicon glyphicon-calendar"></i></button>'+
                       '</div>'+
                       '<div class="c-datik-date-range-input-group {{error.higher}}">'+
                          '<input type="text" class="u-datik-placeholder input-sm c-datik-date-range-input" placeholder="{{\'Mayor a\' | translate}}" '+
                          'uib-datepicker-popup="{{format}}" ng-model="higher" is-open="popUpHigh.opened" '+
                          'datepicker-options="dateOptions" '+
                          'close-text="{{ \'Cerrar\' | translate }}" clear-text="{{ \'Limpiar\' | translate }}" current-text="{{ \'Hoy\' | translate }}" '+
                          'alt-input-formats="altInputFormats" ng-change="changeHigher()" />'+
                          '<button type="button" class="btn c-datik-date-range-button" ng-click="openHigher()"><i class="glyphicon glyphicon-calendar"></i></button>'+
                       '</div>'+
                    '</div>',
         controller : function($scope, constantes){
           $scope.error = {};
           $scope.dateOptions = {
                      datepickerMode: 'day',
                      startingDay: 1,
                      maxMode: 'month',
                      showWeeks : false
                    };
           $scope.altInputFormats = ['yyyy-M!-d!', 'yyyy-MM-dd', 'yyyy-M!-d! HH:mm:ss', 'yyyy-M!-d! HH:mm', 'yyyy-MM-dd HH:mm','yyyy-M!-d! H!:mm:ss', 'yyyy-M!-d! H!:mm', 'yyyy-MM-dd H!:mm', 'yyyy-M!-d! H:m', 'yyyy-MM-dd H!:m!'];
           $scope.popUpLow = { opened: false };
           $scope.popUpHigh = { opened: false };
           $scope.openLower = function(){
             $scope.popUpLow.opened = true;
           };
           $scope.openHigher = function(){
             $scope.popUpHigh.opened = true;
           };
           $scope.fechaFormato =constantes.formatoComunicacion;
           $scope.changeLower = function(){
             if(angular.isUndefined($scope.lower)){
               $scope.error.lower = "c-datik-date-range-error";
             }else{
               $scope.error.lower = "";
             }
           };
           $scope.changeHigher = function(){
             if(angular.isUndefined($scope.higher)){
               $scope.error.higher = "c-datik-date-range-error";
             }else{
               $scope.error.higher = "";
             }
           };
         },
         link: function (scope, element, attr, table) {
             var inputs = element.find('input');
             var inputLower = angular.element(inputs[0]);
             var inputHigher = angular.element(inputs[1]);
             var predicateName = attr.attribute;

             [inputLower, inputHigher].forEach(function (input) {

                 input.bind('blur', function () {
                   actualizarDatos();
                 });

                 input.bind('input', function () {
                   actualizarDatos();
                 });

                 input.bind('change', function () {
                   actualizarDatos();
                 });

                 var actualizarDatos = function(){
                   var query = {};
                   if (angular.isDefined(scope.lower) && scope.lower !== null) {
                        if(angular.isDate(scope.lower)){
                          //query.lower = scope.lower;
                          query.lower = moment(scope.lower).format(scope.fechaFormato);
                        }else{
                          query.lower = undefined;
                        }
                   }else{
                        query.lower = undefined;
                   }

                   if (angular.isDefined(scope.higher) && scope.higher !== null) {
                       if(angular.isDate(scope.higher)){
                         //query.higher = scope.higher;
                         query.higher = moment(scope.higher).format(scope.fechaFormato);
                       }else{
                         query.higher = undefined;
                       }
                   }else{
                       query.higher = undefined;
                   }

                   scope.$apply(function () {
                       table.search(query, predicateName);
                   });
                 };

             });
         }
     };
 });

 })();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('datik-selectores')
    .directive('datikDate', datikDate);

  function datikDate() {
    return {
      restrict: 'E',
      scope: {
        placeholder: '@',
        initDate: '@',
        min: '@',
        max: '@',
        eventName: '@',
        showHours: '@',
        getDate: '='
      },
      templateUrl: 'app/components/datikDate/datikDate.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$filter', '$translate', 'moment', dateController]

    };

    function dateController($log, $scope, $filter, $translate, moment) {

      var vm = this;

      //var fechaHora = $translate.instant('fechaHoraIdioma');
      var fecha = $translate.instant('fechaIdioma');

      vm.isOpen = false;
      vm.open = function(){
        vm.isOpen = true;
      };
      var eventName = "datik-date-change";
      if(angular.isDefined($scope.eventName) && $scope.eventName !== ""){
        eventName = $scope.eventName;
      }
      vm.format = fecha;
      vm.dateOptions = {
        datepickerMode: 'day',
        startingDay: 1,
        maxMode: 'month',
        showWeeks : false
      };
      /*
        Esta version de angular-bootstrap (~0.14.3) tiene un bug y no se puede utilizar el min y el max
        if(angular.isDefined($scope.min) && $scope.min !== ""){
          vm.dateOptions.minDate = new Date($scope.min);
        }
        if(angular.isDefined($scope.max) && $scope.max !== ""){
          vm.dateOptions.maxDate= new Date($scope.max);
        }
      */
      vm.altInputFormats = ['yyyy-M!-d!', 'yyyy-MM-dd', 'yyyy-M!-d! HH:mm:ss', 'yyyy-M!-d! HH:mm', 'yyyy-MM-dd HH:mm','yyyy-M!-d! H!:mm:ss', 'yyyy-M!-d! H!:mm', 'yyyy-MM-dd H!:mm', 'yyyy-M!-d! H:m', 'yyyy-MM-dd H!:m!'];

      vm.changeDate = function(){
        $log.info("CAMBIO EN LA FECHA");
      }
      vm.datikdate = {};
      if(angular.isDefined($scope.initDate) && $scope.initDate != ""){
        var date = new Date($scope.initDate);
        vm.datikdate.date = date;
        vm.datikdate.time = date;
      }

      $scope.getDate = function(){
        var tiempo = "00:00:00";
        if($scope.showHours === "true"){
          if(angular.isDate(vm.datikdate.time)){
            tiempo = moment(vm.datikdate.time).format("HH:mm") + ":00";
          }else{
            return null;
          }
        }
        if(angular.isDate(vm.datikdate.date)){
            var date = moment(vm.datikdate.date).format("YYYY-MM-DD");
            return new Date(date + 'T' + tiempo);
        }
        return null;
      }

      $scope.$watch('vm.datikdate.date',function(newValue, oldValue){
        if(newValue !== oldValue){
          var newDate = $scope.getDate();
          if(newDate === null){
            $scope.error = "c-datik-date-error";
          }else{
            $scope.error = undefined;
            $scope.$emit(eventName, newDate);
          }
        }
      });
      $scope.$watch('vm.datikdate.time',function(newValue, oldValue){
        if(newValue !== oldValue){
          var newDate = $scope.getDate();
          if(newDate === null){
            if(!angular.isDate(vm.datikdate.date)){
              $scope.error = "c-datik-date-error";
            }else{
              $scope.error = undefined;
            }
          }else{
            $scope.error = undefined;
            $scope.$emit(eventName, newDate);
          }
        }
      });
    }

  }

})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikTable
   * Directive de las tablas de Datik
   */
  angular.module('datik-selectores')
    .directive('datikArraySelector', datikArraySelector);

    function datikArraySelector(){
     return {
         restrict: 'E',
         require: '^stTable',
         scope: {
             elements: '=',
             placeholder: '@',
             type: "@"
         },
         template: '<div class="c-datik-array-selector">'+
                      '<ui-select ng-model="selection" theme="" search-enabled="false" append-to-body="true" on-select="onSelected($item)">'+
                        '<ui-select-match placeholder="{{ placeholder }}" allow-clear="true">'+
                            '<div ng-if="type===\'color\'" class="c-datik-array-selector-color-value" style="background-color:{{$select.selected}}">&nbsp;</div>'+
                            '<div ng-if="type===\'colorVehiculos\'" class="c-datik-array-selector-color-value" style="background-color:{{$select.selected}}">&nbsp;</div>'+
                            '<div ng-if="type===\'boolean\'" class="c-datik-array-selector-boolean-value">{{$select.selected}}</div>'+
                            '<div ng-if="(type!==\'color\' && type!==\'colorVehiculos\')&&type!==\'boolean\'" class="c-datik-array-selector-default-value">{{$select.selected}}</div>'+
                        '</ui-select-match>'+
                        '<ui-select-choices repeat="option in selectOptions">'+
                          '<div ng-if="type===\'color\'" class="c-datik-array-selector-color-value" style="background-color:{{option}}">&nbsp;</div>'+
                          '<div ng-if="type===\'colorVehiculos\'" class="c-datik-array-selector-color-value" style="background-color:{{option}}">&nbsp;</div>'+
                          '<div ng-if="type===\'boolean\'" class="c-datik-array-selector-boolean-value">{{option | translate }}</div>'+
                          '<div ng-if="(type!==\'color\' && type!==\'colorVehiculos\')&&type!==\'boolean\'" class="c-datik-array-selector-default-value">{{option}}</div>'+
                        '</ui-select-choices>'+
                      '</ui-select>'+
                    '</div>',
         link: function (scope, element, attr, table) {
           if(scope.type === 'boolean'){
             scope.selectOptions = ['', 'Sí', 'No'];
           }else{
              scope.selectOptions = [''].concat(scope.elements);
           }
           var predicateName = attr.attribute;
           scope.onSelected = function(item){
             if(scope.type === 'boolean'){
               if(item === 'Sí'){
                 table.search('true', predicateName);
               }else if(item === 'No'){
                table.search('false', predicateName);
               }else{
                 table.search('', predicateName);
               }
             } else if(scope.type === 'colorVehiculos' && angular.isDefined(item)){
               var param = item.split(";");
               item = param[0];
               table.search(item, predicateName);
             } else{
               table.search(item, predicateName);
             }

           }
         }
     };
 }

 })();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.Filter:datikMdmTableFilter
   * @description
   * # datikMdmTable
   * Utilizado para filtrar los valores numéricos de los indicadores de la eficiencia en la conducción.
   * Filtra los datos de la tabla, cogiendo como umbral el valor que introduzca el usuario. </br>
   * e.j:  Si el usuario introduce el valor 100 en el campo <i>menor que</i>, en la tabla solo se mostrarán
   * los valores de ese indicador que sean menores a 100
   */
  angular.module('datik-selectores')
  .filter('datikMdmTableFilter', datikMdmTableFilter);

  function datikMdmTableFilter($filter){

    var filterFilter = $filter('filter');
    var standardComparator = function standardComparator(obj, text) {
      text = ('' + text).toLowerCase();
      return ('' + obj).toLowerCase().indexOf(text) > -1;
    };

    return function datikMdmTableFilter(array, expression) {
      function customComparator(actual, expected) {
        var isLower = expected.lower;
        var isHigher = expected.higher;
        var higherLimit;
        var lowerLimit;

        if (angular.isObject(expected)) {
          //date range
          if (angular.isDefined(isLower) || angular.isDefined(isHigher)) {
            //number range
            if (angular.isDefined(isLower)) {
              higherLimit = expected.lower;
              if(angular.isUndefined(actual) || actual === '-'){
                return false;
              }
              if (actual > higherLimit) {
                return false;
              }
            }
            if (angular.isDefined(isHigher)) {
              lowerLimit = expected.higher;
              if(angular.isUndefined(actual) || actual === '-'){
                return false;
              }
              if (actual < lowerLimit) {
                return false;
              }
            }
            return true;
          }
          return true;
        }
        return standardComparator(actual, expected);
      }

      var output = filterFilter(array, expression, customComparator);
      return output;
    };
  }


})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-selectores.directive:datikTable
   * @description
   * # datikMdmTable
   * Directive de las tablas de Datik
   */
  angular.module('datik-selectores')
    .directive('datikMdmTable', datikMdmTable)
    .directive('infinitescrollmdm', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          element.bind('scroll', function() {
            if (element[0].scrollTop + element[0].offsetHeight == element[0].scrollHeight) {
              if (element[0].scrollHeight > 0) {
                scope.$broadcast("scrollTopMdmPaginado",element[0].scrollTop);
                scope.$apply(attrs.infinitescrollmdm);
              }
            }
          });
        }
      };
    });


  function datikMdmTable() {
    return {
      restrict: 'E',
      scope: {
        contenedor: '@', // Nombre del contenedor (Su tamaño)
        maxHeight: '@', //Altura máxima calc(100vh - 100px) p.e.
        perPage: '@', // Número de elementos por página
        currentPage: '=', // Página actual que se muestra
        numberElementsShowing: '=', //Función para saber el número de elemenentos que se muestra
        elements: '=', //Array para saber que elementos tenemos que mostrar
        data: '=', // Array con los datos a mostrar
        options: '=', //Botones que permiten hacer cosas con los datos
        loading: '=', // Elemento para saber cuando esta cargando
        csvData: '=', // Función para obtener los datos en un array
        selection: '=', // Que tipo de selección queremos para la tabla
        isSortable: '@', //False si no se quiere que se muestre los filtros para filtrar
        loadData: '='
      },
      templateUrl: 'app/components/datik-mdm-table/datikMdmTable.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope', '$parse', '$filter', '$translate', '$timeout', '$sce', '$q', 'utilidades', tableController]

    };

    function tableController($log, $scope, $parse, $filter, $translate, $timeout, $sce, $q, utilidades) {

      var vm = this;
      var scrollTopMdm = 0;
      vm.showFilter = true;
      vm.enableSort = true
      vm.id = parseInt(Math.random() * 1000);
      var enableInfiniteScroll = true;

      vm.dynamicData = [];

      //Elementos para la paginación

      var fechaHora = $translate.instant('fechaHoraIdioma');
      var fecha = $translate.instant('fechaIdioma');

      vm.container = "";
      if (!utilidades.isEmpty($scope.contenedor)) {
        vm.container = $scope.contenedor;
      }

      $scope.$on('scrollTopMdmPaginado',function(evento,elemento){
        scrollTopMdm = elemento;
      });


      /**
       * Configuración de la altura
       */
      vm.tableStyle = "";
      if (!utilidades.isEmpty($scope.maxHeight)) {
        vm.tableStyle += "max-height:" + $scope.maxHeight + ";";
      }

      // VALIDA QUE EL CARACTER INGRESADO EN EL INPUT SEA UN PUNTO O DOS PUNTOS
      vm.validaCaracter = function(e) {
       var keyCode = e.key;
       if (keyCode == "," || keyCode == ":") {
         e.preventDefault();
       }
     };

      /**
       * Muestra el número de elementos que se muestran
       */
      $scope.numberElementsShowing = function() {
        return vm.dynamicData.length;
      };

      /**
       * Devuelve el ancho correspondiente
       */
      vm.getWidth = function(elemento, index) {
        if (!utilidades.isEmpty(elemento.width)) {
          return elemento.width;
        } else {
          if (index === -1) {
            $log.info("Este el tamaño del ancho " + elemento.width);
            $log.info("Este es el index: " + (index - 1));
            return (elemento.buttons.length * 40) + 'px';
          }
          var mod = 100 % $scope.elements.length;
          var percentage = 100 / $scope.elements.length;
          if (index < mod) {
            return (percentage + 1) + '%';
          } else {
            return percentage + '%';
          }
        }
      };

      /**
       * Obtiene el valor a mostrar en el elemento
       */
      vm.getData = function(data, elemento) {
        var value = undefined;
        var color = undefined;
        var bubble = undefined;
        var titleText = undefined;
        var htmlValue = undefined;
        var getter = $parse(elemento.information);
        var getterTitle = $parse(elemento.titleText);
        try {
          value = getter(data);
          if (utilidades.isEmpty(value) || value === '-') {
            return '-';
          }
          titleText = getterTitle(data);
          switch (elemento.type) {
            case 'string':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView(value, color, bubble);
            case 'integer':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($filter('number')(value), color, bubble);
            case 'number':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($filter('number')(value, 2), color, bubble);
            case 'datetime':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($filter('date')(value, fechaHora), color, bubble);
            case 'date':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView($filter('date')(value, fecha), color, bubble);
            case 'array':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              return getDataForView(value.toString(), color, bubble);
            case 'boolean':
              color = getDataColor(data, elemento);
              bubble = getDataBubble(data, elemento);
              if (value) {
                return getDataForView($translate.instant('Sí'), color, bubble);
              } else {
                return getDataForView($translate.instant('No'), color, bubble);
              }
              break;
            case 'color':
              if (utilidades.isEmpty(titleText)) {
                titleText = '';
              }
              htmlValue = '<div class="c-datik-color-value" title="' + titleText + '" style="background-color:' + value + '">&nbsp;</div>';
              return $sce.trustAsHtml(htmlValue);
            case 'progress':
              if (value >= 100) {
                value = 100;
              }
              if (value <= 0) {
                value = 0;
              }
              if (utilidades.isEmpty(titleText)) {
                titleText = '';
              }
              htmlValue = '<div class="progress c-datik-table-progress" title="' + titleText + '" style="margin-bottom: 0px;background-color: #DFDFDF;color:#979796;">' +
                '<div class="progress-bar progress-bar-success" style="line-height: 15px;width: ' + value + '%;"' +
                'aria-valuenow="' + value + '" aria-valuemin="0" aria-valuemax="100">' +
                value + ' %' +
                '</div>' +
                '</div>';
              return $sce.trustAsHtml(htmlValue);
            default:
              $log.error("No se ha encontrado tipo de elemento para mostrar en la tabla " + elemento.type);
              return '-';
          }
        } catch (e) {
          return '-';
        }
      };

      /**
       * Parsea los datos para el csv
       */
      function getDataForCSV(data, elemento) {
        var value = undefined;
        var viewValue = undefined;
        var getter = $parse(elemento.information);
        try {
          value = getter(data);
          if (utilidades.isEmpty(value) || value === '-') {
            return '-';
          }
          switch (elemento.type) {
            case 'string':
              return value;
            case 'integer':
              viewValue = $filter('number')(value);
              return viewValue;
            case 'number':
              viewValue = $filter('number')(value, 2);
              return viewValue;
            case 'datetime':
              viewValue = $filter('date')(value, fechaHora);
              return viewValue;
            case 'date':
              viewValue = $filter('date')(value, fecha);
              return viewValue;
            case 'boolean':
              return $translate.instant(value ? 'Sí' : 'No')
            case 'array':
              return value.toString();
            case 'color':
              return value;
            case 'progress':
              return value + ' %';
            default:
              $log.error("No se ha encontrado tipo de elemento pasar al csv " + elemento.type);
              return '-';
          }
        } catch (e) {
          return '-';
        }
      }

      function getDataColor(data, elemento) {
        if (!utilidades.isEmpty(elemento.color)) {
          var getterColor = $parse(elemento.color);
          try {
            return getterColor(data);
          } catch (e) {
            return;
          }
        }
        return;
      }

      function getDataBubble(data, elemento) {
        if (!utilidades.isEmpty(elemento.bubble)) {
          var getterBubble = $parse(elemento.bubble);
          try {
            return getterBubble(data);
          } catch (e) {
            return;
          }
        }
        return;
      }

      function getDataForView(value, color, bubble) {
        if (utilidades.isEmpty(color) && utilidades.isEmpty(bubble)) {
          return value;
        } else {
          if (utilidades.isEmpty(bubble)) {
            return $sce.trustAsHtml('<div style="color:' + color + '">' + value + '</div>');
          } else {
            var colorStyle = '';
            if (!utilidades.isEmpty(color)) {
              colorStyle = 'color:' + color + ';';
            }
            return $sce.trustAsHtml('<div class="c-datik-bubble-type"><div class="c-datik-bubble-value" style="background-color:' + bubble + '; ' + colorStyle + ' ">' + value + '</div></div>');
          }
        }
      }
      /**
       * Obtiene la unidad del elemento
       */
      vm.obtenerUnidad = function(elemento) {
        if (elemento.type === 'number' || elemento.type === 'integer') {
          if (!utilidades.isEmpty(elemento, "elemento.unit")) {
            if (elemento.unit === 'percentage') {
              return '(%)';
            } else {
              return '(' + $filter('unidad')(elemento.unit) + ')';
            }
          }
        }
      };
      /**
       * Función para definir cual es el elemento que hay que ordenar inicialmente
       */
      vm.initialSort = function(elemento) {
        if (!utilidades.isEmpty(elemento, "elemento.sort")) {
          if (elemento.sort === true || elemento.sort === 'true') {
            return 'true';
          } else if (elemento.sort === 'reverse') {
            return 'reverse';
          }
        }
        return 'false';
      };
      /**
       * Función que se ejecuta cuando se ejecuta el boton
       */
      vm.clickButton = function(bottom, data, index) {
        bottom.function(data, index);
      };
      /**
       * El boton esta disponible o no disponible
       */
      vm.isDisabled = function(bottom, data, index) {
        if (!utilidades.isEmpty(bottom, "bottom.disabled")) {
          return bottom.disabled(data, index);
        }
        return false;
      };
      /**
       * Se debe mostrar loading en el boton
       */
      vm.showLoading = function(bottom, data, index) {
        if (!utilidades.isEmpty(bottom, "bottom.showLoadingImage")) {
          return bottom.showLoadingImage(data, index);
        }
        return false;
      };
      /**
       * Sabe si el elemento es buscable o no
       */
      vm.isElementSearchable = function(element) {
        if (element.type === 'string' || element.type === 'integer' ||
          element.type === 'number' || element.type === 'date' ||
          element.type === 'datetime' || element.type === 'progress') {
          return true;
        } else if (!utilidades.isEmpty(element, "element.sortArray")) {
          return true;
        }
        return false;
      };
      /*
       *Function para obtencion de status de resultado por dispositivo
       */
      vm.obtainSystemStatus = function(element) {
        if(!utilidades.isEmpty(element, "element.subsystems")){
          var core = ''; var mdm = ''; var cctv = ''; var wifi = ''; var ecoassist = '';
          var systems = element.subsystems;
          var colors = ['#E84B3A', '#27AE61', '#CCCCCC'];
          for (var j = 0; j < systems.length; j++) {
            if (systems[j].status == null) {
              systems[j].status = 2;
            }
  
            if (!utilidades.isEmpty(systems[j]) && systems[j].name == "core") {
              core = '<span class="fa fa-circle fa-lg" style="color:' + colors[systems[j].status] + '; padding-right: 5px;"></span>';
            } else if (!utilidades.isEmpty(systems[j]) && systems[j].name == "mdm") {
              mdm = '<span class="fa fa-refresh fa-lg" style="color:' + colors[systems[j].status] + '; padding-right: 5px;"></span>';
            } else if (!utilidades.isEmpty(systems[j]) && systems[j].name == "cctv") {
              cctv = '<span class="fa fa-video-camera fa-lg" style="color:' + colors[systems[j].status] + '; padding-right: 5px;"></span>';
            } else if (!utilidades.isEmpty(systems[j]) && systems[j].name == "wifi") {
              wifi = '<span class="fa fa-wifi fa-lg" style="color:' + colors[systems[j].status] + '; padding-right: 5px;"></span>';
            } else if (!utilidades.isEmpty(systems[j]) && systems[j].name == "ecoassist") {
              ecoassist = '<span class="fa fa-television fa-lg" style="color:' + colors[systems[j].status] + '; padding-right: 5px;"></span>';
            }
          }
          return $sce.trustAsHtml(core+mdm+cctv+wifi+ecoassist);
        }
      };

      
      function splitTaskList(taskList) {
        return taskList.length > 5 ? taskList.slice(taskList.length-5, taskList.length) : taskList
      }

      /*
       *Function para obtencion de status de las tareas por dispositivos
       */
      vm.obtainStatus = function(element) {
        var htmlValue = '';
        if(!utilidades.isEmpty(element, "element.task")){

          element.task = splitTaskList(element.task)

          element.task.forEach(function (tarea) {
            htmlValue += select_tag(tarea, htmlValue);
          }); 
        } else {
          htmlValue = '<md-icon class="md-font material-icons fa fa-times style-Md-Icon-Tbl" style="opacity:-0.5"></md-icon>';
        }
        return $sce.trustAsHtml(htmlValue);
      };

        function select_tag(item) {
          if(item.status === 'success'){
            return '<md-icon class="md-font material-icons fa fa-check style-Md-Icon-Tbl"></md-icon>';
          } else if(item.status === 'failure'){
            return '<md-icon class="md-font material-icons fa fa-times style-Md-Icon-Tbl"></md-icon>';
          } 
          return '<md-icon class="md-font material-icons style-Md-Icon-Tbl"> ' +
          '<md-progress-circular class="md-mode-indeterminate" style="width: 20px;height: 24px;margin-left: -2px;line-height: 30px;">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" style="width: 20px; height: 24px; transform-origin: 10px 10px 10px;">' +
              '<path fill="none" stroke-width="2" stroke-linecap="square" d="M10,1A9,9 0 1 1 1,10" stroke-dasharray="42.411500823462205" stroke-dashoffset="55.55671476964585" transform="rotate(-180 10 10)"></path>' +
            '</svg>' +
          '</md-progress-circular>' +
        '</md-icon>';
        }


      /*
       *Function para colorear los direfentes tipos de grupos
       */
      vm.obtainGroups = function(element) {
        var htmlValue = '';
        var color = '#3598DB';
        for (var j = 0; j < element.groups.length; j++) {
          htmlValue += '<b style="padding-right: 5px"><span class="badge badge-' + color + '">' + element.groups[j] + '</span></b>';
        }
        return $sce.trustAsHtml(htmlValue);
      };
      /**
       * Función para la obtencion de los resultados de Diagnosis
       */
      vm.obtainDianosis = function(element) {
        var htmlValue = '';
        var services = ["3G", "GPS", "CAN"];
        var connectivity = (element.connectivity !== null) ?
          [element.connectivity.gprsState, element.connectivity.gpsState, element.connectivity.canState] : [null, null, null];
        for (var j = 0; j < connectivity.length; j++) {
          if (connectivity[j] == null) {
            connectivity[j] = 2;
          }
        }
        var colors = ['#E84B3A', '#27AE61', '#CCCCCC'];
        for (var i = 0; i < services.length; i++) {
          htmlValue += '<b style="color:' + colors[connectivity[i]] + '; padding-right: 5px">' + services[i] + '</b>';
        }
        return $sce.trustAsHtml(htmlValue);
      };
      /**
       * Función para la proyección de datos en  respectiva directive
       */
      vm.obtainTask = function(element) {
        var htmlValue = '';
        var tareas = element.data.content;
        for (var i = 0; i < tareas.length; i++) {
          switch_data(tareas[i]);
        }

        function switch_data(item) {
          switch (item.status) {
            case 2:
              htmlValue += '<i class="fa fa-check fa-2x" style="color:green;"></i><b>"' + item.date_ini + '      ' + item.description + '"</b><br>';
              break;
            case 1:
              htmlValue += '<i class="fa fa-spinner fa-2x" style="color:blue;"></i><b>"' + item.date_ini + '     ' + item.description + '"</b><br>';
              break;
            default:
              htmlValue += '<i class="fa fa-times fa-2x" style="color:red;"></i><b>"' + item.date_ini + '     ' + item.description + '"</b><br>';
              break;
          }
        }
        return $sce.trustAsHtml(htmlValue);
      };
      /**
       * Saca los elementos a devolver si se pide el csv
       */
      $scope.csvData = function() {
        var titulos = [];
        $scope.elements.forEach(function(element) {
          titulos.push($translate.instant(element.title));
        });
        var respuesta = [titulos, []];
        vm.dynamicData.forEach(function(row) {
          var columna = [];
          $scope.elements.forEach(function(element) {
            columna.push(getDataForCSV(row, element));
          });
          respuesta.push(columna);
        });
        return respuesta;
      };
      /**
       * Iniciamos la seleccion
       */

      if (utilidades.isEmpty($scope.selection)) {
        vm.selection = {
          mode: undefined
        };
      } else {
        vm.selection = $scope.selection;
        if (utilidades.isEmpty(vm, "vm.selection.changeSelectionEventName")) {
          vm.selection.changeSelectionEventName = 'datik-table-change-selection';
        }
        $scope.selection.getSelectedElements = getSelectedElements;
        // Si hay cambios en página en la que esta generamos un evento
        if (!utilidades.isEmpty($scope.selection.mode)) {
          $scope.$watch('currentPage', function(newValue) {
            var currentPage = Number(newValue);
            if (currentPage > 0) {
              changeSelectionEvent();
            }
          });
          // Si hay cambios en el numero elementos es que se ha hecho
          // un cambio en la tabla por lo que si el tamaño es distinto
          //  a lo anteriormente seleccionadogeneramos el evento
          $scope.$watch('vm.dynamicData.length', function(value) {
            if (value > 0) {
              var selectedElements = getSelectedElements();
              if (previusSelectedElements.length !== selectedElements.length) {
                $scope.$emit(vm.selection.changeSelectionEventName, selectedElements);
              }
              previusSelectedElements = selectedElements;
            }
          });
        }
      }

      /**
       * Función para obtener los elementos que el usuario tiene a la vista
       * y estan seleccionados
       */
      function getSelectedElements() {
        var perPage = parseInt($scope.perPage);
        var currentPage = parseInt($scope.currentPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return [];
        }
        var ii = perPage * (currentPage - 1);
        var response = [];
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          if (vm.dynamicData[ii].selected) {
            response.push(vm.dynamicData[ii]);
          }
        }
        return response;
      }

      /**
       * Función para ver si hay que enseñar los checkboxes
       */
      vm.selection.showCheckBoxes = function() {
        return !utilidades.isEmpty(vm, "vm.selection.mode") && vm.selection.mode === 'checkbox';
      };
      /**
       * Función para saber cuantos elementos seleccionados se estan mostrando
       */
      vm.selection.numShowingElementsSelected = function() {
        var perPage = Number($scope.perPage);
        var currentPage = Number($scope.currentPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return 0;
        }
        var response = 0;
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          if (vm.dynamicData[ii].selected) {
            response++;
          }
        }
        return response;
      };
      /**
       * Número de elementos que se estan mostrando
       */
      vm.selection.numElementsShowing = function() {
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return 0;
        }
        var ii = perPage * (currentPage - 1);
        var length = ii + perPage;
        if (length > vm.dynamicData.length) {
          length = vm.dynamicData.length;
        }
        return length - ii;
      };
      /**
       * Selecciona los elementos que esta viendo el usuario
       */
      vm.selection.selectElements = function() {
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return;
        }
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          vm.dynamicData[ii].selected = true;
        }
        $timeout(changeSelectionEvent, 0);
      };
      /*
       * Deselecciona los elementos que ve el usuario
       */
      vm.selection.unselectElements = function() {
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return;
        }
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          vm.dynamicData[ii].selected = false;
        }
        $timeout(changeSelectionEvent, 0);
      };
      /**
       * Selecciona un elemento
       */
      vm.selection.selectElement = function(row) {
        row.selected = true;
        $timeout(changeSelectionEvent, 0);
      };
      /**
       * Deselecciona un elemento
       */
      vm.selection.unselectElement = function(row) {
        row.selected = false;
        $timeout(changeSelectionEvent, 0);
      };

      function unselectElement() {
        var currentPage = Number($scope.currentPage);
        var perPage = Number($scope.perPage);
        if (!angular.isNumber(perPage) || !angular.isNumber(currentPage) || currentPage < 1) {
          return;
        }
        var ii = perPage * (currentPage - 1);
        var length = vm.selection.numElementsShowing() + ii;
        for (ii; ii < length; ii++) {
          vm.dynamicData[ii].selected = false;
        }
        $timeout(changeSelectionEvent, 0);
      }

      /**
       * Se hace click sobre una seccion
       */
      var previusSelection = undefined;
      vm.selection.rowClicked = function(row, indice, event) {
        if (!utilidades.isEmpty(vm, "vm.selection.mode")) {
          if (event.ctrlKey) {
            if (vm.selection.mode === 'multiple') {
              if (row.selected) {
                row.selected = false;
              } else {
                row.selected = true;
              }
              previusSelection = undefined;
              $timeout(changeSelectionEvent, 0);
            }
          } else if (vm.selection.mode === 'multiple') {
            var cont = 0;
            for (var i = 0; i < vm.dynamicData.length; i++) {
              if (vm.dynamicData[i].selected && utilidades.isEmpty(previusSelection)) {
                cont++;
              }
            }
            if (cont >= 1) {
              cont = 0;
              previusSelection = row;
              unselectElement();
            }
            if (row.selected) {
              row.selected = false;
              $timeout(changeSelectionEvent, 0);
            } else {
              if (!utilidades.isEmpty(previusSelection)) {
                previusSelection.selected = false;
              }
              row.selected = true;
              previusSelection = row;
              $timeout(changeSelectionEvent, 0);
            }
          }
        }
      };
      /**
       * Gestiona el cambio de eventos seleccionados
       */
      var previusSelectedElements = [];

      function changeSelectionEvent() {
        var response = getSelectedElements();
        if (previusSelectedElements.length != 0 || response.length != 0) {
          $scope.$emit(vm.selection.changeSelectionEventName, response);
        }
        previusSelectedElements = response;
      }

      $scope.$watch('vm.dynamicData', validateScrollTable);
      /**
       * Mira si la tabla esta con escroll y si es asi ajusta la cabecera
       */
      function validateScrollTable() {
        var elem = angular.element('#tbody' + vm.id);
        if (elem.length > 0 && elem[0].clientHeight < elem[0].scrollHeight) {
          vm.theadClass = "c-datik-table-thead-withscroll";
        } else {
          vm.theadClass = "";
        }
      }

      $scope.$on('cambiarPreviusSelection',function(evento,elemento){
        previusSelection = elemento;
      });

      /* NÚMERO DE PAGINA CON LA QUE SE VA INICIALIZAR */
      vm.currentpage = 1;
      // EL NÚMERO DE ELEMENTOS QUE SE MOSTRARARN POR PAGINA
      vm.size = 40;
      // TOTAL DE REGISTROS EXISTENTES
      vm.totalRegistros = 10000;
      // ELEMENTOS A BUSACR EN LA TABLA
      vm.filteredSearch = undefined;
      vm.filteredSort = undefined;
      
      //EVENTO QUE SE EJECUTA AL MOVER EL SCROLL
      vm.loadMoreMdm = function() {
        vm.firstTime = 0;
        if(enableInfiniteScroll){
          var resp = $scope.loadData(vm.currentpage, vm.size, vm.filteredSort, vm.filteredSearch, 0, 0, scrollTopMdm, $q.defer());
          resp.then(function(response) {
            if (!utilidades.isEmpty(response)) { 
              response.content.forEach(function(value) {
                if(vm.dynamicData.every(function (x) {return x.equipmentId !== value.equipmentId})){
                  vm.dynamicData.push(value);
                }
              });
              vm.currentpage++;
              vm.totalRegistros = response.totalElements;
            }
          });
        }
      };

      vm.testCallMdn = function callServerMdn(tableState) {
        vm.filteredSearch = tableState.search.predicateObject;
        vm.filteredSort = !utilidades.isEmpty(tableState, "tableState.sort.predicate") ? tableState.sort.predicate + ":" + (tableState.sort.reverse ? "desc" : "asc") : "";

        if (!utilidades.isEmpty(vm, "vm.filteredSearch")) {
          vm.dynamicData = [];
          vm.currentpage = 1;
        }

        var resp = $scope.loadData(vm.currentpage, vm.size, vm.filteredSort, vm.filteredSearch, 1, 1, scrollTopMdm, $q.defer());
        resp.then(function(response) {
          if (!utilidades.isEmpty(response)) {
            vm.dynamicData = response.content;
            vm.currentpage++;
            vm.totalRegistros = response.totalElements;
          }
        });

      };

      $scope.$on('manially-show-filter', function (ev, data){
        enableInfiniteScroll = vm.showFilter = vm.enableSort = data;
      })

      $scope.$on('mdm-data-table', function(ev, data){
        vm.dynamicData = data;
      })

      $scope.$on('clean-mdm-table', function(){
        vm.dynamicData = [];
      })
    }

  }

})();

(function() {
  'use strict';

  /**
   * @ngdoc interface
   * @name utilidades
   * @module utilidades
   *
   * @description
   * Modulo mediante el cual añade diferentes utilidades para poder utilizar en iPanel.
   * Entre las diferentes utilidades hay una directiva para hacer elementos draggables,
   * poder filtrar por propiedades, hacer mayusculas la primera letra u obtener cual es el
   * número en formato local entre otros.
   */
  angular.module('datik-utils', ['pascalprecht.translate']);

})();

(function() {

  /**
   * @ngdoc service
   * @name utilidades.service:utilidades
   * @module utilidades
   *
   * @description
   * Servicio con diferentes funciones utilies para todo el proyecto.
   */
  angular.module('datik-utils')
    .service('utilidades',
      function($window, $timeout, $translate, $document, moment, conexion, $mdToast) {

        /**
         * @ngdoc method
         * @name utilidades#convertFromUTCToClientTimeZone
         * @methodOf utilidades.service:utilidades
         * @description
         * Función que convierte de UTC a dateTime del timeZone del usuario
         */
        this.convertFromUTCToClientTimeZone = function(dateTime) {
          return moment.utc(dateTime).tz(conexion.getUsuario().timeZone);
        };

        /**
         * @ngdoc method
         * @name utilidades#getUTCDate
         * @methodOf utilidades.service:utilidades
         *
         * @description
         * Funcion para obtener la hora en UTC
         * @return {date} Hora actual en UTC
         */
        this.getUTCDate = function() {
          var now = new Date();
          var nowUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
          return nowUTC;
        };


        /**
         * @ngdoc method
         * @name utilidades.utilidades#getUserDate
         * @methodOf utilidades.service:utilidades
         *
         * @description
         * Funcion para obtener la hora del usuario
         * @return {date} Hora actual del usuario
         */
        this.getUserDate = function(timeZone) {
          if (angular.isUndefined(timeZone) || timeZone === null) {
            return new Date();
          }
          var now = moment.tz(timeZone);
          return now.toDate();
        };

        /**
         * @ngdoc method
         * @name utilidades.utilidades#mayusculaPrimeraLetra
         * @methodOf utilidades.service:utilidades
         *
         * @description
         * Función mediante la cual hacemos que la primera letra de la palabra sea mayúscula.
         * @param {string} palabra Palabra la cual deseamos modificar
         * @return {string} Palabra con la primera letra en mayúscula
         */
        this.mayusculaPrimeraLetra = function(palabra) {
          if (angular.isString(palabra)) {
            palabra = String(palabra);
          }
          return palabra.charAt(0).toUpperCase() + palabra.slice(1);
        };

        /**
         * @ngdoc method
         * @name utilidades#capitalizeFirstLetter
         * @methodOf utilidades.service:utilidades
         *
         * @description
         * Una vez introducido el modulo utilidades a cualquier variable de tipo String
         * se le añade esta función. Mediante la cual podemos hacer mayuscula la primera letra.
         * El modo de usarlo sería el siguiente
         * <pre>
         * 'gato'.capitalizeFirstLetter();
         * //Otro modo de uso
         * var gato = 'gato';
         * gato.capitalizeFirstLetter();
         * </pre>
         */
        String.prototype.capitalizeFirstLetter = function() {
          return this.charAt(0).toUpperCase() + this.slice(1);
        };

        /**
         * @ngdoc method
         * @name utilidades#resaltado
         * @methodOf utilidades.service:utilidades
         *
         * @description
         * Una vez introducido el modulo utilidades a cualquier variable de tipo String
         * se le añade esta función. Esta función nos permite resaltar el texto ya que lo pasa
         * a negrita.
         * El modo de usarlo sería el siguiente
         * <pre>
         * 'gato'.resaltado();
         * //Otro modo de uso
         * var gato = 'gato';
         * gato.resaltado();
         * </pre>
         */
        String.prototype.resaltado = function() {
          return this.bold();
        };

        /**
         * @ngdoc method
         * @name utilidades#ajustarPantalla
         * @methodOf utilidades.service:utilidades
         *
         * @description
         * Función para llamar al evento resize y que ciertos elementos como mapas se
         * se actualicen.
         */
        var timeoutAnterior;
        this.ajustarPantalla = function() {
          if (angular.isUndefined(timeoutAnterior)) {
            timeoutAnterior = $timeout(function() {
              angular.element($window).triggerHandler('resize');
              $window.dispatchEvent(new Event('resize'));
              timeoutAnterior = undefined;
            }, 100);
          } else {
            $timeout.cancel(timeoutAnterior);
            timeoutAnterior = undefined;
            this.ajustarPantalla();
          }
        };

        /**
         * @ngdoc method
         * @name utilidades#ajustarPantalla
         * @methodOf utilidades.service:utilidades
         * @description
         * Función que imite un click sobre unas coordenadas x o y
         * @param {int} x Coordenada X
         * @param {int} y Coordenada Y
         */
        this.click = function(x, y) {
          var ev = $window.document.createEvent('MouseEvent');
          var el = $window.document.elementFromPoint(x, y);
          ev.initMouseEvent(
            'click',
            true /* bubble */ , true /* cancelable */ ,
            window, null,
            x, y, 0, 0, /* coordinates */
            false, false, false, false, /* modifier keys */
            0 /*left*/ , null
          );
          el.dispatchEvent(ev);
        };

        /**
         * @ngdoc method
         * @name utilidades#mostrarProblemaConexion
         * @methodOf utilidades.service:utilidades
         * @description
         * Función que muestra que hay problemas de conexión
         */
        this.mostrarProblemaConexion = function() {
          var problemas = angular.element($document[0].querySelector('#problemas'));
          if (!problemas.length) {
            var vista = angular.element('#cabecera');
            var texto = $translate.instant('Problemas de conexión');
            var elementoComp = '<span id="problemas" class="problemas">' + texto + '</span>';
            vista.append(elementoComp);
          }
        };
        /**
         * @ngdoc method
         * @name utilidades#ocultarProblemaConexion
         * @methodOf utilidades.service:utilidades
         * @description
         * Función que oculta el problema de conexión
         */
        this.ocultarProblemaConexion = function() {
          var problemas = angular.element($document[0].querySelector('#problemas'));
          if (problemas.length) {
            problemas.remove();
          }
        };

        /* Funcion que comprueba si el elemento es vacio
       @elem Elemento a tratar
       @attr Atributo a analizar*/

        var isEmpty = function(elem, attr){
          return angular.isUndefined(attr) ? elemIsEmpty(elem) : nestedElemIsEmpty(elem, attr);
        }
        this.isEmpty = isEmpty;

        /* Funcion privada que determina si un elemento es vacio
          @elem Elemento a tratar
        */
        function elemIsEmpty(elem){
          if(angular.isUndefined(elem) || elem === null){
            return true;
          } else if(angular.isString(elem)){
            return elem.length === 0;
          } else if(angular.isArray(elem)){
            return elem.length === 0;
          } else if(angular.isObject(elem)){
            for(var key in elem) {
              if(elem.hasOwnProperty(key))
                return false;
            }
            return true;
          } else {
            return false;
          }
        }

        this.includesSpecialCharacters = function (value) {
          var regex = /^[a-zA-Z0-9ñÑ -]+$/;
          return !regex.test(value);
        }

        /* Funcion privada que determina si un atributo de un elemento anidado es vacio
          @elem Elemento a tratar
          @attr Atributo a analizar
        */
        function nestedElemIsEmpty(elem, attr){
          var elem_c = angular.copy(elem);
          if(elemIsEmpty(elem_c) || elemIsEmpty(attr) || !angular.isObject(elem_c) || !angular.isString(attr) || !attr.includes('.')){
            return true;
          } else {
            var attrs = attr.split('.').slice(1);
            for(var i=0; i < attrs.length; i++){
              if(angular.isObject(elem_c) && !elemIsEmpty(elem_c[attrs[i]])){
                elem_c = elem_c[attrs[i]];
              } else {
                return true;
              }
            }
            return false;
          }
        }

        /**
         * @ngdoc method
         * @name utilidades#getBrowser
         * @methodOf utilidades.service:utilidades
         * @description
         * Función que obtiene el navegador
         */
        this.getBrowser = function() {
          var nVer = navigator.appVersion;
          var nAgt = navigator.userAgent;
          var browserName = navigator.appName;
          var fullVersion = '' + parseFloat(navigator.appVersion);
          var majorVersion = parseInt(navigator.appVersion, 10);
          var nameOffset, verOffset, ix;

          // In Opera, the true version is after "Opera" or after "Version"
          if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
            browserName = 'Opera';
            fullVersion = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf('Version')) !== -1) {
              fullVersion = nAgt.substring(verOffset + 8);
            }
          }
          // In MSIE, the true version is after "MSIE" in userAgent
          else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
            browserName = 'Microsoft Internet Explorer';
            fullVersion = nAgt.substring(verOffset + 5);
          }
          // In Chrome, the true version is after "Chrome"
          else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
            browserName = 'Chrome';
            fullVersion = nAgt.substring(verOffset + 7);
          }
          // In Safari, the true version is after "Safari" or after "Version"
          else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
            browserName = 'Safari';
            fullVersion = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) !== -1) {
              fullVersion = nAgt.substring(verOffset + 8);
            }
          }
          // In Firefox, the true version is after "Firefox"
          else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
            browserName = 'Firefox';
            fullVersion = nAgt.substring(verOffset + 8);
          }
          // In most other browsers, "name/version" is at the end of userAgent
          else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browserName = nAgt.substring(nameOffset, verOffset);
            fullVersion = nAgt.substring(verOffset + 1);
            if (browserName.toLowerCase() === browserName.toUpperCase()) {
              browserName = navigator.appName;
            }
          }
          // trim the fullVersion string at semicolon/space if present
          if ((ix = fullVersion.indexOf(';')) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
          }

          if ((ix = fullVersion.indexOf(' ')) !== -1) {
            fullVersion = fullVersion.substring(0, ix);
          }

          majorVersion = parseInt('' + fullVersion, 10);
          if (isNaN(majorVersion)) {
            fullVersion = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
          }

          nVer = browserName + ' ' + fullVersion;
          return nVer;
        };

        /**
         * @ngdoc method
         * @name utilidades#getOS
         * @methodOf utilidades.service:utilidades
         * @description
         * Función que obtiene el sistema operativo
         */
        this.getOS = function() {
          var OSName = 'Unknown OS';
          if (navigator.appVersion.indexOf('Win') !== -1) {
            OSName = 'Windows';
          }
          if (navigator.appVersion.indexOf('Mac') !== -1) {
            OSName = 'MacOS';
          }
          if (navigator.appVersion.indexOf('X11') !== -1) {
            OSName = 'UNIX';
          }
          if (navigator.appVersion.indexOf('Linux') !== -1) {
            OSName = 'Linux';
          }
          return OSName;
        };
        /* Funcion que genera la URL final a partir de los parametros
          @params Parametros formateados para la URL
          @variable Variables a añadir en la url
          @nombre Nombre de la variable a tratar
        */
        this.generateUrlParams = function (params, variable, nombre) {
          if (isEmpty(variable) || isEmpty(nombre)) {
            return params;
          } else {
            return (params + (isEmpty(params) ? '?' : '&') + nombre + '=' + variable);
          }
        };

        /*
          Funcion interna que crea la parametrizacion para el toast
          @msg Mensaje a mostrar en el toast
          @messageData Objeto con la informacion a interpolar
          @container Identificador del container en el que se quiere enseñar. Ej: #idContainer
        */
        function defineToast(message, messageData) {
          var msg = isEmpty(messageData)
              ? $translate.instant(message)
              : $translate.instant(message, messageData);
          var toastInfo = $mdToast
              .simple()
              .textContent(msg)
              .position(getToastPosition())
              .hideDelay(3000);
          return toastInfo;
        }

        /* Funcion que devuelve la posicion del toast */
          function getToastPosition() {
            var toastPosition = angular.extend(
                {},
                { bottom: false, top: true, left: false, right: true }
            );
            return Object.keys(toastPosition)
                .filter(function (pos) {
                    return toastPosition[pos];
                })
                .join(' ');
        }

        /*
          Funcion que se encarga de visualizar el toast para notificar si una operacion
          se ha realizado correctamente o no
          @msg Mensaje a mostrar en el toast
          @messageData Objeto con la informacion a interpolar
        */
        this.showNotificacion = function (message, messageData) {
          if (!isEmpty(message)) {
            $mdToast.show(defineToast(message, messageData));
          }
        };
      });

})();

(function() {
  'use strict';


  angular.module('datik-utils')

    /**
     * @ngdoc filter
     * @name utilidades.filter:numeroLocal
     * @module utilidades
     *
     * @description
     * Filtro para pasar cualquier numero a formato local
     * @param {number} input Numero a transformar en local
     * @return {string} Número con formato local
     */
    .filter('numeroLocal', function(utilidades) {
      return function(input) {
        return utilidades.getNumeroLocal(input);
      };
    })
    /**
     * @ngdoc filter
     * @name utilidades.filter:mayusculaPrimeraLetra
     * @module utilidades
     *
     * @description
     * Filtro que transforma un String cambiando el primer caráctere y poniendo a este en mayúscula.
     * @param {string} input String a modificar
     * @return {string} Devuelve un string con la primera letra en mayúscula
     */
    .filter('mayusculaPrimeraLetra', function(utilidades) {
      return function(input) {
        return utilidades.mayusculaPrimeraLetra(input);
      };
    })

    /**
     * @ngdoc filter
     * @name utilidades.filter:filtroPropiedades
     * @module utilidades
     *
     * @description
     * El filtro por defecto de angular suma las propiedades mediante AND
     * nosotros queremos unirlos mediante la propiedad OR
     * @param {array} items Lista de los elementos
     * @param {array} props Lista de las propiedads
     * @return {array} Lista de elementos
     */
    .filter('filtroPropiedades', function() {
      return function(items, props) {
        var out = [];

        if (angular.isArray(items)) {
          items.forEach(function(item) {
            var itemMatches = false;

            var keys = Object.keys(props);
            for (var i = 0; i < keys.length; i++) {
              var prop = keys[i];
              var text = props[prop].toLowerCase();
              if (angular.isString(item[prop])) {
                if (item[prop].toLowerCase().indexOf(text) !== -1) {
                  itemMatches = true;
                  break;
                }
              } else {
                if (item[prop] && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                  itemMatches = true;
                  break;
                }
              }
            }

            if (itemMatches) {
              out.push(item);
            }
          });
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      };
    })

    /**
     * @ngdoc filter
     * @name utilidades.filter:filtroTabla
     * @module utilidades
     *
     * @description
     * El filtro por defecto de angular suma las propiedades mediante AND
     * nosotros queremos unirlos mediante la propiedad OR
     * @param {array} items Lista de los elementos
     * @param {array} props Lista de las propiedads
     * @return {array} Lista de elementos
     */
    .filter('filtroTabla', function() {
      return function(items, props) {
        var out = [];
        var keys = Object.keys(props);

        if (keys.length === 0) {
          out = items;
        } else {
          if (angular.isArray(items)) {
            items.forEach(function(item) {
              var itemMatches = false;

              keys = Object.keys(props);
              for (var i = 0; i < keys.length; i++) {
                var prop = keys[i];
                var text;
                var isObjKey;
                if (angular.isString(props[prop])) {
                  text = props[prop].toLowerCase();
                } else if (angular.isObject(props[prop])) {
                  var keysObj = Object.keys(props[prop]);
                  isObjKey = keysObj[0];
                  text = props[prop][isObjKey].toLowerCase();
                }
                var propSplited = prop.split('.');
                if (propSplited.length > 1) {
                  var b = item[propSplited[0]];
                  if (angular.isDefined(b)) {
                    b = b[propSplited[1]];
                    if (b.toString().toLowerCase().indexOf(text) !== -1) {
                      itemMatches = true;
                      break;
                    }
                  }
                } else {
                  if (angular.isDefined(item[prop])) {
                    var itemString = item[prop];
                    if (angular.isDefined(isObjKey)) {
                      itemString = itemString[isObjKey];
                    }
                    if (itemString.toString().toLowerCase().indexOf(text) !== -1) {
                      itemMatches = true;
                      break;
                    }
                  }
                }
              }
              if (itemMatches) {
                out.push(item);
              }
            });
          } else {
            // Let the output be the input untouched
            out = items;
          }
        }
        return out;
      };
    })

    /**
     * @ngdoc filter
     * @name utilidades.filter:tiempoCantidad
     * @module utilidades
     *
     * @description
     * El filtro devuelve la vision del tiempo en horas minutos segundos
     * @param {number} input Tiempo en segundos
     * @return {string} String con el tiempo
     */
    .filter('tiempoCantidad', function($translate) {
      return function(input /*, props*/ ) {
        if (!angular.isNumber(input)) {
          return '-';
        }
        var out = '';
        var segundos, minutos, horas, dias;
        if (input < 0) {
          if (input > -60) {
            segundos = input;
          } else {
            minutos = parseInt(input / 60);
            segundos = input % 60;
            if (minutos < -60) {
              horas = parseInt(minutos / 60);
              minutos = minutos % 60;
              if (horas < -24) {
                dias = parseInt(horas / 24);
                horas = horas % 24;
                horas = horas * (-1);
                minutos = minutos * (-1);
                segundos = segundos * (-1);
              } else {
                minutos = minutos * (-1);
                segundos = segundos * (-1);
              }
            } else {
              segundos = segundos * (-1);
            }
          }
        } else {
          if (input < 60) {
            segundos = input;
          } else {
            minutos = parseInt(input / 60);
            segundos = input % 60;
            if (minutos > 60) {
              horas = parseInt(minutos / 60);
              minutos = minutos % 60;
              if (horas > 24) {
                dias = parseInt(horas / 24);
                horas = horas % 24;
              }
            }
          }
        }
        if (angular.isDefined(dias) && dias !== 0) {
          out += dias + $translate.instant('día letra');
        }
        if (angular.isDefined(horas) && horas !== 0) {
          out += ' ' + horas + $translate.instant('hora letra');
        }
        if (angular.isDefined(minutos) && minutos !== 0) {
          out += ' ' + minutos + $translate.instant('minuto letra');
        }
        if (angular.isDefined(segundos) && segundos !== 0) {
          out += ' ' + segundos + $translate.instant('segundo letra');
        }
        return out;
      };
    })

    /**
     * @ngdoc filter
     * @name utilidades.filter:tiempoCantidadHHMM
     * @module utilidades
     *
     * @description
     * El filtro devuelve la vision del tiempo en formato HH:MM
     * @param {number} input Tiempo en minutos
     * @return {string} String con el tiempo en formato HH:MM
     */
    .filter('tiempoCantidadHHMM', function() {
      return function(input /*, props*/ ) {
        if (!angular.isNumber(input)) {
          return '-';
        }
        var out = '';
        var /*segundos,*/ minutos, horas /*, dias*/ ;
        /*if (input < 60) {
          segundos = input;
        } else*/
        if (input >= 60) {
          minutos = parseInt(input / 60);
          //segundos = input % 60;
          if (minutos > 60) {
            horas = parseInt(minutos / 60);
            minutos = minutos % 60;
          }
        }
        if (angular.isUndefined(minutos)) {
          minutos = 0;
        }
        if (angular.isUndefined(horas)) {
          horas = 0;
        }
        if (minutos < 10) {
          minutos = '0' + minutos;
        }
        out = horas + ':' + minutos;

        return out;
      };
    })

    /**
     * @ngdoc filter
     * @name utilidades.filter:unidad
     * @module utilidades
     *
     * @description
     * El filtro devuelve la unidad en el formato requerido por el usuario
     * @param {unidad} input Tipo de unidad que se quiere obtener
     * @return {string} String correspondiente a la configuracion del cliente
     */
     .filter('unidad', function(conexion) {

       return function(unidad) {

         var unidadConsumo = conexion.getUsuario().valores.UNIDAD_CONSUMO;

         if (unidad === 'Consumo' || unidad === 'consumo') {
           // Unidad: Consumo

           if (unidadConsumo === 0 || unidadConsumo == "0") {
             return 'L/100Km';
           } else if (unidadConsumo === 1 || unidadConsumo == "1") {
             return 'Km/L';
           } else if (unidadConsumo === 2 || unidadConsumo == "2") {
             return 'MPG';
           }

         } else if (unidad === 'Distancia' || unidad === 'distancia') {
           // Unidad: Distancia

           if (unidadConsumo === 0 || unidadConsumo == "0") {
             return 'Km';
           } else if (unidadConsumo === 1 || unidadConsumo == "1") {
             return 'Km';
           } else if (unidadConsumo === 2 || unidadConsumo == "2") {
             return 'Mi';
           }

         } else if (unidad === 'Combustible' || unidad === 'combustible') {
           // Unidad: Combustible

           if (unidadConsumo === 0 || unidadConsumo == "0") {
             return 'L';
           } else if (unidadConsumo === 1 || unidadConsumo == "1") {
             return 'L';
           } else if (unidadConsumo === 2 || unidadConsumo == "2") {
             return 'Gal';
          }

         } else if (unidad === 'Velocidad' || unidad === 'velocidad') {
           // Unidad : Velocidad

         if (unidadConsumo === 0 || unidadConsumo == "0") {
             return 'Km/h';
           } else if (unidadConsumo === 1 || unidadConsumo == "1") {
             return 'Km/h';
           } else if (unidadConsumo === 2 || unidadConsumo == "2") {
             return 'Mi/h';
           }

         } else if (unidad === 'Frenada' || unidad === 'frenada') {
           // Unidad : Frenada

           if (unidadConsumo === 0 || unidadConsumo == "0") {
             return 'Bra./100Km';
           } else if (unidadConsumo === 1 || unidadConsumo == "1") {
             return 'Bra./100Km';
           } else if (unidadConsumo === 2 || unidadConsumo == "2") {
             return 'Bra./100Mi';
           }

         } else if (unidad === 'Aceleracion' || unidad === 'aceleracion') {
           // Unidad : Aceleracion

           if (unidadConsumo === 0 || unidadConsumo == "0") {
             return 'Acc./100Km';
           } else if (unidadConsumo === 1 || unidadConsumo == "1") {
             return 'Acc./100Km';
           } else if (unidadConsumo === 2 || unidadConsumo == "2") {
             return 'Acc./100Mi';
           }

         }

         return unidad;

       };

     });


})();

(function() {
  'use strict';

  /**
   * @ngdoc directive
   * @name utilidades.directive:draggable
   * @element div
   * @restrict EA
   *
   * @description
   * Hace que cualquier etiqueta se convierta en dragable
   *
   */
  angular.module('datik-utils')
    .directive('draggable', function($document) {
      return function(scope, element, attr) {
        var startX = 0,
          startY = 0,
          x = 0,
          y = 0;
        if (angular.isDefined(attr.startx)) {
          x = parseInt(attr.startx);
        }
        if (angular.isDefined(attr.starty)) {
          y = parseInt(attr.starty);
        }
        var isTouchDevice = function() {
          try {
            if (navigator.maxTouchPoints > 0) {
              $document.createEvent('TouchEvent');
              return true;
            } else {
              return false;
            }
          } catch (e) {
            return false;
          }
        };
        if (isTouchDevice()) {
          x = 10;
          y = 10;
        }

        element.css({
          position: 'fixed',
          cursor: 'pointer',
          display: 'block',
          width: '300px',
          top: y + 'px',
          left: x + 'px'
        });
        element.on('mousedown', function(event) {
          // Prevent default dragging of selected content
          event.preventDefault();
          startX = event.screenX - x;
          startY = event.screenY - y;
          $document.on('mousemove', mousemove);
          $document.on('mouseup', mouseup);
        });

        function mousemove(event) {
          y = event.screenY - startY;
          x = event.screenX - startX;
          element.css({
            top: y + 'px',
            left: x + 'px'
          });
        }

        function mouseup() {
          $document.off('mousemove', mousemove);
          $document.off('mouseup', mouseup);
        }
      };
    });


})();

(function() {

    angular.module('app')
      .constant('datikThemeConstants', {
        'accentPalette': 'grey'
      })
      .constant('datikPalette', {
        '50': 'e3f6fd',
        '100': 'b7e8fa',
        '200': '8ad9f7',
        '300': '61c9f3',
        '400': '48bdf1',
        '500': '297fb8',
        '600': '33a3e0',
        '700': '2c90cc',
        '800': '297fb8',
        '900': '205f96',
        'A100': 'f5f5f5',
        'A200': 'eeeeee',
        'A400': 'e0e0e0',
        'A700': 'bdbdbd',
        // By default, text (contrast) on this palette should be white with 87% opacity.
        'contrastDefaultColor': 'light'
      })
      .constant('datikPrimaryPalette', {
        'default': '800' // by default use shade 800 from the datikPalette for primary intentions
      })
      .constant('datikAccentPalette', {
        'default': '800' // by default use shade 800 from the datikPalette for primary intentions
      });


})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-constants
   * @module datik-constants
   *
   * @description
   * Modulo mediante el que cargamos todas las constantes que se van a utilizar en iPanel.
   * Este se encarga de cargar los archivos JSON para luego poder utilizarlos en cualquier apartado.
   * Hay 5 apartados definidos, agrupados, colores, constantes, imagenes e indicadores.
   */
  angular.module('datik-constants', []);

})();
(function() {

  /**
   * @ngdoc service
   * @name Constantes.service.constantes
   * @module Constantes
   *
   * @description
   * Servicio para el manejo de las constantes. Mediante este servicio obtenemos las
   * distintas constantes estas como imagenes, url de la api, colores...
   */
  angular.module('datik-constants')
         .service('constantes', servicioConstantes);

      function servicioConstantes($log, $q,
                                  jsonFactory){

          var apis;
          var promTodas;
          var promApi;
          var cargado = false;

          var service = {
            //FECHA PARA LA COMUNICACION CON LAS APIS
            formatoComunicacion : 'YYYY-MM-DDTHH:mm:ss',
            //CARGA LOS DATOS
            cargarDatos : cargarDatos,
            //Devuelve un booleano si esta cargado o no
            isCargado : isCargado,
            //Obtiene la url de la api
            getApiUrl : getApiUrl,
            //Obtiene
            promesaCargaConstantes : promesaCargaConstantes
          };
          return service;

          //Funcion para cargar los datos
          function cargarDatos() {
            promApi = jsonFactory.api().then(function(datos) {
              apis = datos;
            });
            promTodas = $q.all([promApi]).then(function() {
              cargado = true;
            });
          }

          function isCargado() {
            return cargado;
          }

          function promesaCargaConstantes(){
            return promTodas;
          }

          /**
           * @ngdoc method
           * @name datik-constants.service.constantes#getApiUrl
           * @methodOf datik-constants.service.constantes
           *
           * @description
           * Obtiene la url para atacar una api mediante su identificador
           * @param {string} idApi Identificador de la API
           * @param {string} idFunction Identificador de la función
           * @return {string} Valor de la dirección URL
           */
           function getApiUrl(idApi, idFunction) {
            // Detect undefined and null values to shorten the execution and prevent exceptions
            if (idApi === null || angular.isUndefined(idApi) || idFunction === null || angular.isUndefined(idFunction)) {
              return undefined;
            }
            // We discarded unacceptable values. So we just need to verify if translationId is empty String
            if (angular.isString(idApi) && idApi.length < 1) {
              return undefined;
            }
            if (angular.isString(idFunction) && idFunction.length < 1) {
              return undefined;
            }
            //  trim off any whitespace
            if (idApi) {
              idApi = trim.apply(idApi);
            }
            if (idFunction) {
              idFunction = trim.apply(idFunction);
            }
            //Obtenemos la url a la api
            try {
              if (cargado) {
                var url = apis.endpoint + apis[idApi].url + apis[idApi].methods[idFunction];
                return url;
              } else {
                promApi.then(function(datos) {
                  if (datos === null || angular.isUndefined(datos)) {
                    return undefined;
                  }
                  var url = apis.endpoint + datos[idApi].url + datos[idApi].methods[idFunction];
                  return url;
                });
              }
            } catch (err) {
              $log.error("No se encuentra de la api: " + idApi + " la funcion: " + idFunction)
              return undefined
            }

          }

          /**
           * @name trim
           * @private
           *
           * @description
           * trim polyfill
           *
           * @returns {string} The string stripped of whitespace from both ends
           */
          function trim() {
            return this.replace(/^\s+|\s+$/g, '');
          }

      }

})();

(function() {
  angular.module('datik-constants')
    .run(obtenerConstantes);

  /** @ngInject */
  function obtenerConstantes(constantes) {
    constantes.cargarDatos();
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name datik-constants.factory:jsonFactory
   * @module datik-constants
   *
   * @description
   * Modulo para devolver las promesas de los datos de los archivos JSON
   */
  angular.module('datik-constants')
    .factory('jsonFactory', jsonFactory);

  /** @ngInject */
  function jsonFactory($http, $q, entornoIPanel) {
    var url = "assets/jsons/";

    var getApi = $http.get(url + 'api.json').then(function(response) {
      return response.data;
    });

    var jsonFactory = {
      api: function() {
        var deferred = $q.defer();
        getApi.then(function(data) {
          deferred.resolve(data);
        });
        return deferred.promise;
      }
    };
    return jsonFactory;
  }

})();

/* global entornoIPanel: false */
(function() {
  'use strict';

  angular
    .module('datik-constants')
    .constant('entornoIPanel', entornoIPanel);

})();

(function() {
  'use strict';

  angular
    .module('datik-connection',
    [
      'pascalprecht.translate', 'ngLocale',
      'datik-constants'
    ]);

})();

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name datik-connection.service:conexionService
   * @description
   * Factory con las interacciones del apartado conexion
   */
  angular
    .module('datik-connection')
    .factory('conexionService', conexionService);

  function conexionService($log, $http, constantes) {

    var service = {
      actualizarToken: actualizarToken,
      isSessionActive: isSessionActive
    };
    return service

    function actualizarToken(refreshToken, token) {
      var url = constantes.getApiUrl('ips_authorization', 'sessionRenew');
      var variables = {
        "refresh_token" : refreshToken
      }
      return $http.post(url, variables, {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          timeout: 90000
        }).then(actualizarTokenComplete)
        .catch(actualizarTokenFailed);

      function actualizarTokenComplete(response) {
        $log.info('Actualizar complete');
        return response.data;
      }

      function actualizarTokenFailed() {
        $log.error('Actualizar token fail');
      }
    }

    function isSessionActive(token) {
      var url = constantes.getApiUrl('ips_authorization', 'session')

      return $http.get(url, {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          timeout: 90000
        }).then(isSessionActiveComplete)
        .catch(isSessionActiveFailed);

      function isSessionActiveComplete() {
        return true;
      }

      function isSessionActiveFailed(error) {
        if (error.status === 401) {
          return false;
        }
        return;
      }
    }


  }

})();

(function() {
  'use strict';
  /**
   * @ngdoc service
   * @name conexion
   * @description
   * # Servicio para la gestion de la conexión. Se encarga de gestionar si el usuario está conectado,
   * de la gestión del token, de cargar los datos del usuario, el cambio de idioma y del cambio de unidad
   * de los indicadores entre otras cosas
   */
  angular.module('datik-connection')
    .factory('conexion',
      function($log, $location, $rootScope,
        $translate, $locale, $q,
        $window, $timeout, moment,
        constantes, entornoIPanel, conexionService) {

        var usuario;
        var promesaInicio = $q.defer();
        var firstTime = true;
        var tiempoRenovarToken = 15 * 60 * 1000;

        var service = {
          iniciar: iniciar,
          promesaCargaConexion: promesaCargaConexion,
          setUsuario: setUsuario,
          getUsuario: getUsuario,
          cambiarIdioma: cambiarIdioma,
          getAuthToken: getAuthToken,
          irAPaginaSignIn: irAPaginaSignIn,
          desconectar: desconectar,
          estaConectado: estaConectado,
          validarConexion: validarConexion
        }

        return service;

        function validarConexion() {
          if (!firstTime && !estaConectado()) {
            desconectar();
          }
        }

        function estaConectado() {
          if (angular.isUndefined(usuario)) {
            return false;
          } else {
            var expiration = new Date(usuario.exp * 1000);
            var now = new Date();
            if (expiration > now) {
              return true;
            } else {
              return false;
            }
          }
        }

        function iniciar() {
          if (!firstTime) {
            return promesaInicio.promise;
          }
          firstTime = false;
          
          var promesaCargaUsuario = cargarUsuario();
          
          $q.all([promesaCargaUsuario]).then(function() {
            $log.info("Habia elementos en el localStorage");
            promesaInicio.resolve(true);
          }, function() {
            $log.info("Inicio desde signIn");
            promesaInicio.resolve(true);
          });
          
          return promesaInicio.promise;
        }

        function setUsuario(user) {
          usuario = user;
          $rootScope.usuario = {
            'nombre': user.nombre,
            'apellido': user.apellido
          };
          usuario.idioma = $window.localStorage.getItem('Idioma')
          $window.localStorage.setItem('usuario', angular.toJson(usuario));

          $translate.use(usuario.idioma);

          var expiration = new Date(usuario.exp * 1000);
          var now = new Date();
          var diff = expiration.getTime() - now.getTime();
          constantes.promesaCargaConstantes().then(function() {
            if (diff > 0 && diff < tiempoRenovarToken) {
              renovarToken();
            } else if (diff >= tiempoRenovarToken) {
              $log.info("Siguiente renovacion en " + (tiempoRenovarToken / 60000) + " mins");
              $timeout(renovarToken, tiempoRenovarToken);
            } else {
              desconectar();
            }
          });
        }

        function renovarToken() {
          $log.info("Se procede a renovar token");
          conexionService.actualizarToken(usuario.refreshToken, usuario.token).then(function(data) {
            if (angular.isDefined(data)) {
              $log.info("Se ha renovado el token...");

              usuario.expiresIn = data.expiresIn;
              usuario.token = data.access_token;
              var user = parseToken(usuario.token);
              usuario.exp = user.exp;

              $log.info("Siguiente renovacion en " + (tiempoRenovarToken / 60000) + " mins");
              $timeout(renovarToken, tiempoRenovarToken);

              $window.localStorage.setItem('usuario', angular.toJson(usuario));
            }
          });
        }

        function parseToken(token) {
          var authToken = token.replace(/(\r\n|\n|\r)/gm, '');
          var splitedToken = authToken.split('.',3);
          var strData = b64DecodeUnicode(splitedToken[1]);
          var respuesta = angular.fromJson(strData);
          return respuesta;
        }

        function b64DecodeUnicode(str) {
            // Going backwards: from bytestream, to percent-encoding, to original string.
            return decodeURIComponent($window.atob(str).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        }

        function getUsuario() {
          return angular.isDefined(usuario) ? usuario : undefined;
        }

        function promesaCargaConexion() {
          return promesaInicio.promise;
        }

        function cambiarIdioma(idioma) {
          $window.localStorage.setItem('Idioma', idioma);

          if (angular.isDefined(usuario)) {
            usuario.idioma = idioma;
          }

          
          $translate.use(idioma);
          var usoLocal = idioma.substring(0, 2) + '-' + idioma.substring(2, 4);
          $locale.id = usoLocal.toLowerCase();
          moment.locale($locale.id);
        }


        function getAuthToken() {
          return angular.isDefined(usuario) ? usuario.token : undefined;
        }

        function irAPaginaSignIn() {
          $window.location.href = '/#/signIn';
        }

        function desconectar() {
          if (angular.isDefined(usuario)) {
            usuario = undefined;
            $rootScope.usuario = undefined;
          }
          $window.localStorage.removeItem('usuario');

          irAPaginaSignIn();
        }


        function cargarUsuario() {
          var deferred = $q.defer();
          var promesaUsuario = $window.localStorage.getItem('usuario');
          $q.all([promesaUsuario]).then(function(datos) {
            var userResponse = datos[0];
            if (angular.isDefined(userResponse) && userResponse !== null && userResponse !== {}) {
              try {
                var user = angular.fromJson(userResponse);
                if (angular.isUndefined(user.token) || user.token === "") {
                  deferred.reject();
                }
                setUsuario(user);
                deferred.resolve(true);
              } catch (e) {
                desconectar();
                irAPaginaSignIn();
                deferred.reject();
              }
            } else {
              irAPaginaSignIn();
              deferred.reject();
            }
          });
          return deferred.promise;
        }
      });
})();

/* global moment:false, entornoIPanel: false */
(function() {
  'use strict';

  angular
    .module('datik-connection')
    .constant('moment', moment)
    .constant('entornoIPanel', entornoIPanel);

})();

(function() {
  'use strict';
  /**
   * @ngdoc service
   * @name Composicion
   * @description
   * # Servicio para la gestion del modulo del login, se encarga de la conexion como del cambio de idioma
   */
  angular.module('datik-composition')
    .service('composicion',
      function($log, $rootScope, $translate,
               $sce, $window, $timeout,
               utilidades) {

        var vm = this;

        /**
         * @ngdoc method
         * @name composicion.mostrarMenuNavegacion
         * @methodOf Composicion
         * @description
         * Función para mostrar u ocultar el menu lateral de navegación
         * @param {boolean} mostrar Si es false oculta el menu
         */
        vm.mostrarMenuNavegacion = function(mostrar) {
          if (mostrar === false) {
            if ($rootScope.index.verMenuNavegacion === true) {
              $rootScope.index.verMenuNavegacion = false;
              $rootScope.index.contenidoColumnas = $rootScope.index.contenidoColumnas + 2;
            }
          } else {
            if ($rootScope.index.verMenuNavegacion === true) {
              $rootScope.index.verMenuNavegacion = false;
              $rootScope.index.contenidoColumnas = $rootScope.index.contenidoColumnas + 2;
            } else {
              if ($rootScope.index.verMenuUsuario === true) {
                $rootScope.index.mostrarMenuUsuario(false);
              }
              $rootScope.index.verMenuNavegacion = true;
              $rootScope.index.contenidoColumnas = $rootScope.index.contenidoColumnas - 2;
            }
            $rootScope.index.verAyuda = false;
          }
          utilidades.ajustarPantalla();
        };

        /**
         * @ngdoc method
         * @name composicion.mostrarMenuUsuario
         * @methodOf Composicion
         * @description
         * Función para mostrar u ocultar el menu lateral de información del usuario
         * @param {boolean} mostrar Si es false oculta el menu
         */
        vm.mostrarMenuUsuario = function(mostrar) {
          if (mostrar === false) {
            if ($rootScope.index.verMenuUsuario === true) {
              $rootScope.index.verMenuUsuario = false;
              $rootScope.index.contenidoColumnas = $rootScope.index.contenidoColumnas + 2;
            }
          } else {
            if ($rootScope.index.verMenuUsuario === true) {
              $rootScope.index.verMenuUsuario = false;
              $rootScope.index.contenidoColumnas = $rootScope.index.contenidoColumnas + 2;
            } else {
              if ($rootScope.index.verMenuNavegacion === true) {
                $rootScope.index.mostrarMenuNavegacion(false);
              }
              $rootScope.index.verMenuUsuario = true;
              $rootScope.index.contenidoColumnas = $rootScope.index.contenidoColumnas - 2;
            }
            $rootScope.index.verAyuda = false;
          }
          utilidades.ajustarPantalla();
        };

        /**
         * @ngdoc method
         * @name composicion.isAyudaVisible
         * @methodOf Composicion
         * @description
         * Función para sabes si se esta mostrando la ayuda
         * @return {boolean} true si esta visible la ayuda
         */
        vm.isAyudaVisible = function() {
          return $rootScope.index.verAyuda;
        };

        /**
         * @ngdoc method
         * @name composicion.mostrarAyuda
         * @methodOf Composicion
         * @description
         * Si el apartado de ayuda se está mostrando lo oculta y si esta oculto lo muestra
         */
        vm.mostrarAyuda = function() {
          if ($rootScope.index.verAyuda === false) {
            $rootScope.index.verAyuda = true;
            this.mostrarMenuNavegacion(false);
            this.mostrarMenuUsuario(false);
          } else {
            $rootScope.index.verAyuda = false;
          }
          $timeout(
            function() {
              utilidades.ajustarPantalla();
            }, 100);
        };

        vm.close = function() {
          $uibModalInstance.dismiss();
        };

        /**
         * @ngdoc method
         * @name composicion.ocultarAyuda
         * @methodOf Composicion
         * @description
         * Si el apartado de ayuda se está mostrando lo oculta y si esta oculto lo muestra
         */
        vm.ocultarAyuda = function() {
          if ($rootScope.index.verAyuda === true) {
            $rootScope.index.verAyuda = false;
            $timeout(
              function() {
                utilidades.ajustarPantalla();
              }, 100);
          }
        };

        /**
         * @ngdoc method
         * @name composicion.cerrarMenus
         * @methodOf Composicion
         * @description
         * Función que oculta todos los menus
         */
        vm.cerrarMenus = function() {
          if ($rootScope.index.verMenuUsuario) {
            this.mostrarMenuUsuario(false);
          }
          if ($rootScope.index.verMenuNavegacion) {
            this.mostrarMenuNavegacion(false);
          }
          if ($rootScope.index.verAyuda) {
            this.ocultarAyuda();
          }
          $rootScope.showSubMenuVar = false;
          $rootScope.showSubSubMenuVar = false;
        };


        vm.getMaxHeight = function() {


          var bodyHeight = (angular.element('#cabeceraRight').height() + angular.element('#vista').height());
          var menuHeight = (angular.element('#menuLateralId').height());

          var sumRealHeight = 29; // tamaño de la imagen de ipanel.
          var list = $window.document.getElementsByClassName("objetosMenu1");
          for (var i = 0; i < list.length; i++) {
            if (angular.isDefined(list[i].clientHeight)) {
              sumRealHeight += list[i].clientHeight;
            }
          }
          $log.info('index bodyHeight  ' + bodyHeight + ' menuHeight ' + menuHeight + " sumRealHeight " + sumRealHeight);
          return "height:" + (Math.max(Math.max(bodyHeight, menuHeight), sumRealHeight)) + "px;";

        };

        vm.pantallaLogin = function() {
          $rootScope.index.wrapper = 'login-background';
          $rootScope.index.verHeader = false;
          $rootScope.index.verMenuNavegacion = false;
          $rootScope.index.verMenuUsuario = false;
          $rootScope.index.verAyuda = false;
          $rootScope.index.verFooter = true;
          if (typeof $rootScope.pie === 'undefined') {
            $rootScope.pie = {};
          }
          $rootScope.pie.color = 'BLANCO';
          $rootScope.ayuda = {
            tituloVista: '',
            valorVista: ''
          };
          utilidades.ocultarProblemaConexion();
        };

        vm.iniciarPantallaNoToken = function() {
          $rootScope.index.wrapper = 'difuminado-background';
          $rootScope.index.verBotonMemuHome = false;
          $rootScope.index.apartado = '';
          $rootScope.index.cabeceraBackground = 'cabecera_login';
          $rootScope.index.verHeader = false;
          $rootScope.index.verFooter = true;
          if ($rootScope.index.verMenuNavegacion) {
            $rootScope.index.mostrarMenuNavegacion(false);
          }
          if (typeof $rootScope.pie === 'undefined') {
            $rootScope.pie = {};
          }
          $rootScope.pie.color = 'BLANCO';
          utilidades.ocultarProblemaConexion();
        };

        vm.iniciarPantalla = function() {
          $rootScope.index.wrapper = 'white';
          $rootScope.index.verBotonMemuHome = true;
          $rootScope.index.apartado = 'Analisis';
          $rootScope.index.cabeceraBackground = 'cabecera_no_login';
          $rootScope.index.verHeader = true;
          $rootScope.index.verFooter = false;
          if (typeof $rootScope.pie === 'undefined') {
            $rootScope.pie = {};
          }
          $rootScope.pie.color = 'GRIS';
          utilidades.ocultarProblemaConexion();
        };

        vm.iniciar = function() {
          /* Variables de inicio de la composición */
          $rootScope.index = {
            contenidoColumnas: 12,
            verMenuNavegacion: false,
            verMenuUsuario: false,
            verHeader: false,
            verBotonMemuHome: false,
            apartado: '',
            cabeceraBackground: 'cabecera_no_login',
            mostrarMenuNavegacion: vm.mostrarMenuNavegacion,
            mostrarMenuUsuario: vm.mostrarMenuUsuario,
            mostrarAyuda: vm.mostrarAyuda,
            ocultarAyuda: vm.ocultarAyuda,
            cerrarMenus: vm.cerrarMenus,
            verAyuda: false,
            verFooter: false
          };

        };
      }

    );
})();

/* global moment:false */
(function(){
  'use strict';

   angular.module('datik-selectores')
          .constant('moment', moment);
})();

(function() {
  'use strict';

  angular
    .module('app')
    .run(iniciarComposicion)
    .run(iniciarConexion);

  /** @ngInject */
  function iniciarComposicion($log, composicion) {
    $log.info("Inicia composición");
    composicion.iniciar();
  }

  function iniciarConexion($log, conexion) {
    $log.info("Inicia la conexion");
    conexion.iniciar();
  }


})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/views/main/main.html',
        controller: 'MainController',
        controllerAs: 'vm',
        resolve: {
          cargadaConstantes: cargadaConstantes,
          cargadaConexion: cargadaConexion
        }
      })
      .when('/signIn', {
        templateUrl: 'app/views/login/signIn/signIn.html',
        controller: 'SignInViewController',
        controllerAs: 'vm',
        resolve: {
          cargadaConstantes: cargadaConstantes,
          cargadaConexion: cargadaConexion
        }
      })

      // //CUENTAS
      // .when('/cuentas/tblCuentas', {
      //   templateUrl: 'app/views/cuentas/tblCuentas.html',
      //   controller: 'lstCuentasController',
      //   controllerAs: 'vm',
      //   resolve: {
      //     cargadaConstantes: cargadaConstantes,
      //     cargadaConexion: cargadaConexion
      //   }
      // })

      //EXAMPLES
      .when('/examples/fecha', {
        templateUrl: 'app/views/examples/fecha/fecha.html',
        controller: 'ExampleFechaController',
        controllerAs: 'vm',
        resolve: {
          cargadaConstantes: cargadaConstantes,
          cargadaConexion: cargadaConexion
        }
      })
      .when('/examples/notificaciones', {
        templateUrl: 'app/views/examples/notificaciones/notificaciones.html',
        controller: 'ExamplesNotificacionesController',
        controllerAs: 'vm',
        resolve: {
          cargadaConstantes: cargadaConstantes,
          cargadaConexion: cargadaConexion
        }
      })
      .when('/examples/tabla', {
        templateUrl: 'app/views/examples/tabla/tabla.html',
        controller: 'ExampleTablaController',
        controllerAs: 'vm',
        resolve: {
          cargadaConstantes: cargadaConstantes,
          cargadaConexion: cargadaConexion
        }
      })
      .when('/examples/tablaPantallaCompleta', {
        templateUrl: 'app/views/examples/tablaPantallaCompleta/tablaPantallaCompleta.html',
        controller: 'ExampleTablaPantallaCompletaController',
        controllerAs: 'vm',
        resolve: {
          cargadaConstantes: cargadaConstantes,
          cargadaConexion: cargadaConexion
        }
      })

      .otherwise({
        redirectTo: '/'
      });
  }



  function cargadaConstantes(constantes) {
    return constantes.promesaCargaConstantes();
  }

  function cargadaConexion(conexion) {
    return conexion.promesaCargaConexion();
  }

})();

/* global moment:false, entornoIPanel:false, $:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('moment', moment)
    .constant('entornoIPanel', entornoIPanel)
    .constant('$', $);

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config)
    .config(languageConfiguration)
    .config(initTheme);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

  function languageConfiguration($translateProvider, entornoIPanel) {

    var urlPrefix = 'assets/jsons/i18n/';

    $translateProvider.useStaticFilesLoader({
      prefix: urlPrefix,
      suffix: '.json'
    });
    if (entornoIPanel.isLocal && angular.isDefined(entornoIPanel.idioma)) {
      $translateProvider.preferredLanguage(entornoIPanel.idioma);
    } else if (localStorage.getItem('Idioma') === null) {
      $translateProvider.preferredLanguage('esES');
    } else {
      $translateProvider.preferredLanguage(localStorage.getItem('Idioma'));
    }
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

  }

  // Se inicializa el tema de Angular JS material usando las constantes de temas
  function initTheme($mdThemingProvider, datikThemeConstants, datikPalette, datikPrimaryPalette, datikAccentPalette) {
    $mdThemingProvider.definePalette('datikPalette', datikPalette);
    $mdThemingProvider.theme('default')
      .primaryPalette('datikPalette', datikPrimaryPalette)
      .accentPalette(datikThemeConstants.accentPalette, datikAccentPalette);
  }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/datik-mdm-table/datikMdmTable.html","<div><table class=\"c-datik-table table-striped c-datik-table-responsive {{vm.container}}\" st-table=vm.dynamicData st-pipe=vm.testCallMdn st-safe-src=data style={{vm.tableStyle}} st-set-filter=datikTableFilter id=mdm><thead class=\"c-datik-table-head {{vm.theadClass}}\"><tr class=c-datik-table-head-tr><th class=\"c-datik-table-head-th c-datik-chekbox-td\" ng-if=::vm.selection.showCheckBoxes()><i class=\"fal fa-square pointer\" ng-show=\"vm.selection.numShowingElementsSelected() === 0\" ng-click=vm.selection.selectElements()></i> <i class=\"fa fa-check-square pointer\" ng-show=\"vm.dynamicData.length > 0 && vm.selection.numShowingElementsSelected() === vm.selection.numElementsShowing()\" ng-click=vm.selection.unselectElements()></i> <i class=\"fa fa-minus-square pointer\" ng-show=\"vm.selection.numShowingElementsSelected() > 0 && vm.selection.numShowingElementsSelected() < vm.selection.numElementsShowing()\" ng-click=vm.selection.unselectElements()></i></th><th ng-show=!vm.enableSort style=\"width:{{vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\" class=c-datik-table-head-th>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}</th><th ng-show=vm.enableSort style=\"width:{{vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\" st-skip-natural=\"{{ element.type === \'number\' }}\" st-sort-default=\"{{ ::vm.initialSort(element) }}\" st-sort=\"{{ element.information }}\" class=c-datik-table-head-th>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}</th><th ng-if=options style=\"width:{{vm.getWidth(options, -1)}};min-width:{{::vm.getWidth(options,-1)}}\" class=\"c-datik-table-head-th c-datik-table-no-search\">{{ options.title | translate }}</th></tr><tr ng-show=vm.showFilter class=\"c-datik-table-head-tr c-datik-table-filter-row\"><th class=c-datik-chekbox-td ng-if=::vm.selection.showCheckBoxes()></th><th style=\"width:{{vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\" class=\"c-datik-table-filter {{ ::(vm.isElementSearchable(element) ? \'c-datik-table-no-search\' : \'\') }}\"><input ng-if=\"!element.sortArray && element.type === \'string\'\" st-search=\"{{ element.information }}\" placeholder=\"{{ element.title | translate }}\" class=\"form-control input-sm c-datik-table-filter-input\" ng-enter-blur st-input-event=blur ng-blur=vm.validaCaracter($event) type=search><datik-number-range ng-if=\"!element.sortArray && element.type === \'integer\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'number\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'progress\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'integerbubble\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-date-range ng-if=\"!element.sortArray && element.type === \'datetime\'\" attribute={{::element.information}} lower=\"\" higher=\"\" format=\"{{ \'fechaHoraIdioma\' | translate }}\"></datik-date-range><datik-date-range ng-if=\"!element.sortArray && element.type === \'date\'\" attribute={{::element.information}} lower=\"\" higher=\"\" format=\"{{ \'fechaIdioma\' | translate }}\"></datik-date-range><datik-array-selector ng-if=element.sortArray type={{element.type}} elements=element.sortArray attribute={{::element.information}} placeholder=\"{{ element.title | translate }}\"></datik-array-selector></th><th ng-if=options style=\"width:{{vm.getWidth(options, -1)}};min-width:{{::vm.getWidth(options,-1)}}\" class=c-datik-table-no-search style=\"background-color: pink\"></th></tr></thead><tbody class=c-datik-table-body id=\"tbody{{::vm.id }}\" infinitescrollmdm=vm.loadMoreMdm();><tr class=c-datik-table-body-tr ng-show=\"vm.dynamicData.length === 0\"><td colspan=100% style=height:50px;padding-left:10px>{{ loading ? (\"Cargando...\" | translate) : (\"No hay datos\" | translate) }}</td></tr><tr class=c-datik-table-body-tr ng-repeat=\"row in vm.dynamicData\" ng-if=\"$index >= perPage*(currentPage-1) && $index < perPage*currentPage\"><td ng-if=::vm.selection.showCheckBoxes() class=\"c-datik-chekbox-td {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\"><i class=\"fal fa-square pointer\" ng-hide=row.selected ng-click=vm.selection.selectElement(row);></i> <i class=\"fa fa-check-square pointer\" ng-show=row.selected ng-click=vm.selection.unselectElement(row)></i></td><td ng-if=\"::(vm.selection.mode === \'simple\' || vm.selection.mode === \'multiple\' )\" class=\"c-datik-table-row {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\" style=\"width:{{::vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements \" ng-click=\"vm.selection.rowClicked(row, $index, $event);\"><label class=c-datik-table-responsive-info>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}:</label><div ng-if=\"::element.title === \'Mac\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></div><div ng-if=\"::element.title === \'Tipo\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></div><div ng-if=\"::element.title === \'Version\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></div><div ng-if=\"::element.title === \'Cliente\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></div><div ng-if=\"::element.title === \'Tipo de recurso\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></div><div ng-if=\"::element.title === \'Vehiculo\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></div><div ng-if=\"::element.title === \'Grupos\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.obtainGroups(row, element)\"></div></div><div ng-if=\"::element.title === \'Unidad\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></div><div ng-if=\"::element.title === \'Sistemas\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=vm.obtainSystemStatus(row,element) ng-click=vm.scroll()></div></div><div ng-if=\"::element.title === \'Diagnosis\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=\"vm.obtainDianosis(row, element)\"></div></div><div ng-if=\"::element.title === \'Task\'\"><div class=\"c-datik-type-task c-datik-type-{{::element.type}}\" ng-bind-html=\"vm.obtainStatus(row, element)\"></div></div><div ng-if=\"::element.title === \'task\'\"><div class=c-datik-type-{{::element.type}} ng-bind-html=vm.obtainTask(row,element)></div></div></td><td ng-if=\"::(vm.selection.mode != \'simple\' && vm.selection.mode != \'multiple\' )\" class=\"c-datik-table-row {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\" style=\"width:{{::vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\"><label class=c-datik-table-responsive-info>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}:</label><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></td><td ng-if=options style=width:{{::vm.getWidth(options,-1)}};min-width:{{::vm.getWidth(options,-1)}} class=c-datik-table-options-td><div class=btn-group><bottom type=button ng-repeat=\"option in options.buttons\" title=\"{{ ::option.title | translate}}\" ng-click=vm.clickButton(option,row,$parent.$index) ng-disabled=vm.isDisabled(option,row,$parent.$index) class=\"btn c-datik-table-button c-datik-table-button-{{option.type}}\"><a ng-if=\"::option.type===\'alert\'\"><i class=\"fa fa-exclamation-triangle\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'streaming\'\"><i class=\"fa fa-video-camera\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'message\'\"><i class=\"fa fa-envelope-o\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'geolocate\'\"><img src=assets/images/live/geolocalizar.png style=padding-bottom:1px> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'edit\'\"><i class=\"fa fa-pencil\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'assign\'\"><i class=\"fa fa-paperclip icon-margin-left\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'delete\'\"><span ng-show=!vm.showLoading(option,row,$parent.$index)><i class=\"fa fa-times icon-margin-left\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </span><span style=\"background-color: transparent\" ng-show=vm.showLoading(option,row,$parent.$index)><md-progress-circular class=md-hue-2 md-diameter=15px></md-progress-circular></span></a><a ng-if=\"::option.type===\'info\'\"><i class=\"fa fa-info-circle\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'play\'\"><i class=\"fa fa-play\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'request\'\"><i class=\"fa fa-upload\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'download\'\"><span ng-show=!vm.showLoading(option,row,$parent.$index)><i class=\"fa fa-download\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </span><span style=\"background-color: transparent\" ng-show=vm.showLoading(option,row,$parent.$index)><md-progress-circular class=md-hue-2 md-diameter=15px></md-progress-circular></span></a><a ng-if=\"::option.type===\'graphic\'\"><i class=\"fa fa-area-chart\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'battery\'\"><i class=\"fa fa-battery-half fa-rotate-270\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }}</a></bottom></div></td></tr></tbody><tfoot class=c-datik-table-foot></tfoot></table></div>");
$templateCache.put("app/components/datikDate/datikDate.html","<div class=\"c-datik-date {{error}}\"><div class=\"c-datik-date-input-group input-group\"><input type=text class=\"u-datik-placeholder form-control c-datik-date-input\" style=\"width:100px; padding:8px 12px; margin:0\" uib-datepicker-popup={{vm.format}} ng-model=vm.datikdate.date is-open=vm.isOpen datepicker-options=vm.dateOptions placeholder=\"{{ placeholder | translate}}\" close-text=\"{{ \'Cerrar\' | translate }}\" clear-text=\"{{ \'Limpiar\' | translate }}\" current-text=\"{{ \'Hoy\' | translate }}\" alt-input-formats={{vm.altInputFormats}}><div class=input-group-prepend><button type=button class=\"btn c-datik-date-button\" ng-click=vm.open()><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div><uib-timepicker class=c-datik-date-timepicker ng-if=\"showHours === \'true\'\" ng-model=vm.datikdate.time hour-step=1 minute-step=1 show-meridian=false></uib-timepicker></div>");
$templateCache.put("app/components/datikTable/datikScrollableTable.html","<div style=min-height:50px><table class=\"c-datik-table table-striped c-datik-table-responsive {{vm.container}}\" st-table=vm.dynamicData st-pipe=vm.testCall st-safe-src=data style={{vm.tableStyle}} st-set-filter=datikTableFilter><thead class=\"c-datik-table-head {{vm.theadClass}}\"><tr class=c-datik-table-head-tr><th class=\"c-datik-table-head-th c-datik-chekbox-td\" id=idCheckCabecera ng-if=::vm.selection.showCheckBoxes()><i class=\"fal fa-square pointer\" ng-show=\"vm.selection.numShowingElementsSelected() === 0\" ng-click=vm.selection.selectElements()></i> <i class=\"fa fa-check-square pointer\" ng-show=\"vm.dynamicData.length > 0 && vm.selection.numShowingElementsSelected() === vm.selection.numElementsShowing()\" ng-click=vm.selection.unselectElements()></i> <i class=\"fa fa-minus-square pointer\" ng-show=\"vm.selection.numShowingElementsSelected() > 0 && vm.selection.numShowingElementsSelected() < vm.selection.numElementsShowing()\" ng-click=vm.selection.unselectElements()></i></th><th style=\"width:{{vm.getWidth(element, $index)}}\" st-skip-natural=\"{{ element.type === \'number\' ? true : false}}\" st-sort=\"{{ element.information }}\" st-sort-default=\"{{ ::vm.initialSort(element) }}\" ng-repeat=\"element in elements\" class=c-datik-table-head-th>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}</th><th ng-if=options style=\"width:{{vm.getWidth(options, -1)}};min-width:{{::vm.getWidth(options,-1)}}\" class=\"c-datik-table-head-th c-datik-table-no-search\">{{ options.title | translate }}</th></tr><tr ng-show=vm.showFilter() class=\"c-datik-table-head-tr c-datik-table-filter-row\"><th class=c-datik-chekbox-td ng-if=::vm.selection.showCheckBoxes()></th><th style=\"width:{{vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\" class=\"c-datik-table-filter {{ ::(vm.isElementSearchable(element) ? \'c-datik-table-no-search\' : \'\') }}\"><input ng-if=\"!element.sortArray && element.type === \'string\'\" st-search=\"{{ element.information }}\" placeholder=\"{{ element.title | translate }}\" class=\"form-control input-sm c-datik-table-filter-input\" type=search st-input-event=blur type=search ng-enter-blur ng-blur=vm.validaCaracter($event)><datik-number-range ng-if=\"!element.sortArray && element.type === \'integer\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'number\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'progress\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'integerbubble\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-date-range ng-if=\"!element.sortArray && element.type === \'datetime\'\" attribute={{::element.information}} lower=\"\" higher=\"\" format=\"{{ \'fechaHoraIdioma\' | translate }}\"></datik-date-range><datik-date-range-scroll ng-if=\"!element.sortArray && element.type === \'date\'\" attribute={{::element.information}} lower=\"\" higher=\"\" format=\"{{ \'fechaIdioma\' | translate }}\"></datik-date-range-scroll><datik-array-selector ng-if=element.sortArray type={{element.type}} elements=element.sortArray attribute={{::element.information}} placeholder=\"{{ element.title | translate }}\"></datik-array-selector></th><th ng-if=options style=\"width:{{vm.getWidth(options, -1)}};min-width:{{::vm.getWidth(options,-1)}}\" class=c-datik-table-no-search style=\"background-color: pink\"></th></tr></thead><tbody class=c-datik-table-body id=\"tbody{{::vm.id }}\" infinitescroll=vm.loadMore();><tr class=c-datik-table-body-tr ng-show=\"data.length === 0\"><td id=datikTableEmptyMessage colspan=100% style=height:50px;padding-left:10px>{{ loading ? (\"Cargando...\" | translate) : (\"No hay datos\" | translate) }}</td></tr><tr class=c-datik-table-body-tr ng-repeat=\"row in vm.dynamicData\" ng-if=\"$index >= perPage*(currentPage-1) && $index < perPage*currentPage\"><td ng-if=::vm.selection.showCheckBoxes() class=\"c-datik-chekbox-td {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\"><i class=\"fal fa-square pointer\" ng-hide=row.selected ng-click=vm.selection.selectElement(row) style={{row.disabled}}></i> <i class=\"fa fa-check-square pointer\" ng-show=row.selected ng-click=vm.selection.unselectElement(row) style={{row.disabled}}></i></td><td ng-if=\"::(vm.selection.mode === \'simple\' || vm.selection.mode === \'multiple\' )\" class=\"c-datik-table-row {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\" style=\"width:{{::vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\" ng-click=\"vm.selection.rowClicked(row, $index)\"><label class=c-datik-table-responsive-info>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}:</label><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></td><td ng-if=\"::(vm.selection.mode != \'simple\' && vm.selection.mode != \'multiple\' )\" class=\"c-datik-table-row {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\" style=\"width:{{::vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\"><label class=c-datik-table-responsive-info>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}:</label><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></td><td ng-if=options style=\"width:{{::vm.getWidth(options,-1)}};min-width:{{::vm.getWidth(options,-1)}};padding-left: {{::vm.getLeftPadding(options, vm.dynamicData,$parent.$index, -1)}}\" class=\"c-datik-table-options-td {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\"><div class=btn-group><bottom type=button ng-repeat=\"option in options.buttons\" title=\"{{ ::option.title | translate}}\" ng-click=vm.clickButton(option,row,$parent.$index) ng-disabled=vm.isDisabled(option,row,$parent.$index) ng-show=!vm.shouldHide(option,row,$parent.$index) class=\"btn c-datik-table-button c-datik-table-button-{{option.type}}\"><a ng-if=\"::option.type===\'tooltip\'\"><i class=\"fa fa-info\"><md-tooltip class=tooltip-multiline><div ng-repeat=\"dtos in row.tooltip\"><span>{{dtos.name}}</span></div></md-tooltip></i></a><a ng-if=\"::option.type===\'plus\'\"><span><i class=\"fa fa-power-off\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </span></a><a ng-if=\"::option.type===\'into\'\"><span><i class=\"glyphicon glyphicon-share-alt\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </span></a><a ng-if=\"::option.type===\'addUser\'\"><i class=\"fa fa-user-plus\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'alert\'\"><i class=\"fa fa-exclamation-triangle\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'streaming\'\"><i class=\"fa fa-video-camera\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'message\'\"><i class=\"fa fa-envelope-o\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'geolocate\'\"><img src=assets/images/live/geolocalizar.png style=padding-bottom:1px> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'edit\'\"><i class=\"fa fa-pencil\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'assign\'\"><i class=\"fa fa-paperclip icon-margin-left\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'delete\'\"><span ng-show=!vm.showLoading(option,row,$parent.$index)><i class=\"fa fa-times icon-margin-left\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </span><span style=\"background-color: transparent\" ng-show=vm.showLoading(option,row,$parent.$index)><md-progress-circular class=md-hue-2 md-diameter=15px></md-progress-circular></span></a><a ng-if=\"::option.type===\'off\'\"><span ng-show=!vm.showLoading(option,row,$parent.$index)><i class=\"fa fa-power-off icon-margin-left\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </span><span style=\"background-color: transparent\" ng-show=vm.showLoading(option,row,$parent.$index)><md-progress-circular class=md-hue-2 md-diameter=15px></md-progress-circular></span></a><a ng-if=\"::option.type===\'info\'\"><i class=\"fa fa-info\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'play\'\"><i class=\"fa fa-play\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'request\'\"><i class=\"fa fa-upload\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'download\'\"><span ng-show=!vm.showLoading(option,row,$parent.$index)><i class=\"fa fa-download\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </span><span style=\"background-color: transparent\" ng-show=vm.showLoading(option,row,$parent.$index)><img src=assets/images/loading/loader2.gif style=\"height: 15px\"> </span></a><a ng-if=\"::option.type===\'graphic\'\"><i class=\"fa fa-area-chart\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'battery\'\"><i class=\"fa fa-battery-half fa-rotate-270\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }}</a></bottom></div></td></tr></tbody><tfoot class=c-datik-table-foot></tfoot></table></div><style>.tooltip-multiline {\n   font-size:13px;\n   height: auto;\n}</style>");
$templateCache.put("app/components/datikTable/datikTable.html","<div style=min-height:50px><table class=\"c-datik-table table-striped c-datik-table-responsive constrained\" st-table=vm.dynamicData st-safe-src=data style={{vm.tableStyle}} st-set-filter=datikTableFilter><thead class=\"c-datik-table-head {{vm.theadClass}}\"><tr class=c-datik-table-head-tr><th class=\"c-datik-table-head-th c-datik-chekbox-td\" id=idCheckCabecera ng-if=::vm.selection.showCheckBoxes()><i class=\"fal fa-square pointer\" ng-show=\"vm.selection.numShowingElementsSelected() === 0\" ng-click=vm.selection.selectElements()></i> <i class=\"fa fa-check-square pointer\" ng-show=\"vm.dynamicData.length > 0 && vm.selection.numShowingElementsSelected() === vm.selection.numElementsShowing()\" ng-click=vm.selection.unselectElements()></i> <i class=\"fa fa-minus-square pointer\" ng-show=\"vm.selection.numShowingElementsSelected() > 0 && vm.selection.numShowingElementsSelected() < vm.selection.numElementsShowing()\" ng-click=vm.selection.unselectElements()></i></th><th style=\"width:{{vm.getWidth(element, $index)}}\" st-skip-natural=\"{{ element.type === \'number\' ? true : false}}\" st-sort=\"{{ element.information }}\" st-sort-default=\"{{ ::vm.initialSort(element) }}\" ng-repeat=\"element in elements\" class=c-datik-table-head-th>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}</th><th ng-if=options style=\"width:{{vm.getWidth(options, -1)}};min-width:{{::vm.getWidth(options,-1)}}\" class=\"c-datik-table-head-th c-datik-table-no-search\">{{ options.title | translate }}</th></tr><tr ng-show=vm.showFilter() class=\"c-datik-table-head-tr c-datik-table-filter-row\"><th class=c-datik-chekbox-td ng-if=::vm.selection.showCheckBoxes()></th><th style=\"width:{{vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\" class=\"c-datik-table-filter {{ ::(vm.isElementSearchable(element) ? \'c-datik-table-no-search\' : \'\') }}\"><input ng-if=\"!element.sortArray && element.type === \'string\'\" st-search=\"{{ element.information }}\" placeholder=\"{{ element.title | translate }}\" class=\"form-control input-sm c-datik-table-filter-input\" type=search><datik-number-range ng-if=\"!element.sortArray && element.type === \'integer\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'number\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'progress\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-number-range ng-if=\"!element.sortArray && element.type === \'integerbubble\'\" attribute={{::element.information}} lower=\"\" higher=\"\" multiplier=1></datik-number-range><datik-date-range ng-if=\"!element.sortArray && element.type === \'datetime\'\" attribute={{::element.information}} lower=\"\" higher=\"\" format=\"{{ \'fechaHoraIdioma\' | translate }}\"></datik-date-range><datik-date-range ng-if=\"!element.sortArray && element.type === \'date\'\" attribute={{::element.information}} lower=\"\" higher=\"\" format=\"{{ \'fechaIdioma\' | translate }}\"></datik-date-range><datik-array-selector ng-if=element.sortArray type={{element.type}} elements=element.sortArray attribute={{::element.information}} placeholder=\"{{ element.title | translate }}\"></datik-array-selector></th><th ng-if=options style=\"width:{{vm.getWidth(options, -1)}};min-width:{{::vm.getWidth(options,-1)}}\" class=c-datik-table-no-search style=\"background-color: pink\"></th></tr></thead><tbody class=c-datik-table-body id=\"tbody{{::vm.id }}\"><tr class=c-datik-table-body-tr ng-show=\"data.length === 0\"><td id=datikTableEmptyMessage colspan=100% style=height:50px;padding-left:10px>{{ loading ? (\"Cargando...\" | translate) : (\"No hay datos\" | translate) }}</td></tr><tr class=c-datik-table-body-tr ng-repeat=\"row in vm.dynamicData\" ng-if=\"$index >= perPage*(currentPage-1) && $index < perPage*currentPage\" vm.previusselection=row.select ng-show=\"row.hide === undefined\"><td ng-if=::vm.selection.showCheckBoxes() class=\"c-datik-chekbox-td {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\"><i class=\"fal fa-square pointer\" ng-hide=row.selected ng-click=vm.selection.selectElement(row) style={{row.disabled}}></i> <i class=\"fa fa-check-square pointer\" ng-show=row.selected ng-click=vm.selection.unselectElement(row) style={{row.disabled}}></i></td><td ng-if=\"::(vm.selection.mode === \'simple\' || vm.selection.mode === \'multiple\' )\" class=\"c-datik-table-row {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\" style=\"width:{{::vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\" ng-click=\"vm.selection.rowClicked(row, $index)\"><label class=c-datik-table-responsive-info>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}:</label><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></td><td ng-if=\"::(vm.selection.mode != \'simple\' && vm.selection.mode != \'multiple\' )\" class=\"c-datik-table-row {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\" style=\"width:{{::vm.getWidth(element, $index)}}\" ng-repeat=\"element in elements\"><label class=c-datik-table-responsive-info>{{ ::element.title | translate }} {{ ::vm.obtenerUnidad(element) }}:</label><div class=c-datik-type-{{::element.type}} ng-bind-html=\"::vm.getData(row, element)\"></div></td><td ng-if=options style=\"width:{{::vm.getWidth(options,-1)}};min-width:{{::vm.getWidth(options,-1)}};padding-left: {{::vm.getLeftPadding(options, vm.dynamicData,$parent.$index, -1)}}\" class=\"c-datik-table-options-td {{row.selected ? \'c-datik-table-row-selected\': \'\'}}\"><div class=btn-group><bottom type=button ng-repeat=\"option in options.buttons\" title=\"{{ ::option.title | translate}}\" ng-click=vm.clickButton(option,row,$parent.$index) ng-disabled=vm.isDisabled(option,row,$parent.$index) ng-show=!vm.shouldHide(option,row,$parent.$index) class=\"btn c-datik-table-button c-datik-table-button-{{option.type}}\"><a ng-if=\"::option.type===\'infoParamEdit\'\"><i class=\"fa fa-sliders\" style=\"font-size: 15px\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'tooltip\'\"><i class=\"fa fa-info c-datik-table-tooltip-icon\"><md-tooltip class=tooltip-multiline><div ng-repeat=\"dtos in row.tooltip\"><span>{{dtos.name}}</span></div></md-tooltip></i></a><a ng-if=\"::option.type===\'tooltipPermisos\'\"><i class=\"fa fa-info c-datik-table-tooltip-icon\"><md-tooltip class=tooltip-tareas md-direction=left><div ng-repeat=\"dtos in row.tooltip\"><span>{{dtos.name}}</span></div></md-tooltip></i></a><a ng-if=\"::option.type===\'tooltipGestMoviles\'\"><i class=\"fa fa-info c-datik-table-tooltip-icon\"><md-tooltip class=tooltip-tareas md-direction=left id=tooltipGestMoviles><div ng-repeat=\"dtos in row.tooltip\"><span>{{dtos.name}}</span></div></md-tooltip></i></a><a ng-if=\"::option.type===\'plus\'\"><span><i class=\"fa fa-plus\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </span></a><a ng-if=\"::option.type===\'into\'\"><span><i class=\"glyphicon glyphicon-share-alt\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </span></a><a ng-if=\"::option.type===\'addUser\'\"><i class=\"fa fa-user-plus\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'alert\'\"><i class=\"fa fa-exclamation-triangle\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'streaming\'\"><i class=\"fa fa-video-camera\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'message\'\"><i class=\"fa fa-envelope-o\"></i> {{ ::(option.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'edit\'\"><i class=\"fa fa-pencil\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'assign\'\"><i class=\"fa fa-paperclip icon-margin-left\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'delete\'\"><span ng-show=!vm.showLoading(option,row,$parent.$index)><i class=\"fa fa-times icon-margin-left\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </span><span style=\"background-color: transparent\" ng-show=vm.showLoading(option,row,$parent.$index)><md-progress-circular class=md-hue-2 md-diameter=15px></md-progress-circular></span></a><a ng-if=\"::option.type===\'info\'\"><i class=\"fa fa-info\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'play\'\"><i class=\"fa fa-play\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'request\'\"><i class=\"fa fa-upload\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'download\'\"><span ng-show=!vm.showLoading(option,row,$parent.$index)><i class=\"fa fa-download\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </span><span style=\"background-color: transparent\" ng-show=vm.showLoading(option,row,$parent.$index)><md-progress-circular class=md-hue-2 md-diameter=15px></md-progress-circular></span></a><a ng-if=\"::option.type===\'graphic\'\"><i class=\"fa fa-area-chart\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }} </a><a ng-if=\"::option.type===\'battery\'\"><i class=\"fa fa-battery-half fa-rotate-270\"></i> {{ ::(options.showTitles ? (option.title | translate) : \"\") }}</a></bottom></div></td></tr></tbody><tfoot class=c-datik-table-foot></tfoot></table></div>");
$templateCache.put("app/components/periodo/periodo.html","<div class=btn-group><button class=\"btn btn-default\" ng-click=atrasTiempo()><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=true></span></button><div class=\"btn-group dropdown\" uib-dropdown auto-close=outsideClick ng-click=clickSelectorFecha() is-open=dropIsOpen><button title={{titletextoFechaPeriodo}} class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle><span><i style=\"font-size: 15px\" class=\"fa fa-calendar\"></i> {{ textoFechaPeriodo }}</span> <b class=caret></b></button><div class=\"dropdown-menu {{ alineado === \'derecha\' || alineado === \'right\' ? \'dropdown-menu-right\' : \'\' }} menuSelectorPeriodo {{ verMenuRapido(\'todos\') ? \'cuerpoConMenuRapido\' : \'cuerpoSinMenuRapido\'}}\" role=menu ng-click=$event.stopPropagation()><div class=menuRapidoSelectorPeriodo ng-show=\"verMenuRapido(\'todos\')\"><ul class=listaRapidaSelectorPeriodo><li style=\"padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'6horas\')\" ng-click=\"seleccionRapida(\'6horas\')\"><a>{{ \"Útimas 6 horas\" | translate }}</a></li><li style=\"background-color:white;padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'hoy\')\" ng-click=\"seleccionRapida(\'hoy\')\"><a>{{ \"Hoy\" | translate }}</a></li><li style=\"padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'ayer\')\" ng-click=\"seleccionRapida(\'ayer\')\"><a>{{ \"Ayer\" | translate }}</a></li><li style=\"background-color:white;padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'semana\')\" ng-click=\"seleccionRapida(\'semana\')\"><a>{{ \"Esta semana\" | translate }}</a></li><li style=\"padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'7dias\')\" ng-click=\"seleccionRapida(\'7dias\')\"><a>{{ \"Últimos 7 días\" | translate }}</a></li><li style=\"background-color:white;padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'ultsemana\')\" ng-click=\"seleccionRapida(\'ultsemana\')\"><a>{{ \"Semana anterior\" | translate }}</a></li><li style=\"padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'mes\')\" ng-click=\"seleccionRapida(\'mes\')\"><a>{{ \"Este mes\" | translate }}</a></li><li style=\"background-color:white;padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'30dias\')\" ng-click=\"seleccionRapida(\'30dias\')\"><a>{{ \"Últimos 30 días\" | translate }}</a></li><li style=\"padding-left: 5px;padding-right:10px\" ng-show=\"verMenuRapido(\'ultmes\')\" ng-click=\"seleccionRapida(\'ultmes\')\"><a>{{ \"Mes anterior\" | translate }}</a></li></ul></div><div class=\"cuerpoSelectorPeriodo {{ verMenuRapido(\'todos\') ? \'cuerpoConMenuRapido\' : \'cuerpoSinMenuRapido\'}}\"><div class=pestanasSelectorPeriodo><ul ng-show=mostrarApartados><li ng-class=\"seleccionadoApartado(\'dia\')\" ng-click=\"seleccionarApartado(\'dia\')\"><a>{{ \"Día\" | translate }}</a></li><li ng-class=\"seleccionadoApartado(\'semana\')\" ng-click=\"seleccionarApartado(\'semana\')\" ng-show=mostrarSemana><a>{{ \"Semana\" | translate }}</a></li><li ng-class=\"seleccionadoApartado(\'mes\')\" ng-click=\"seleccionarApartado(\'mes\')\" ng-show=mostrarMes><a>{{ \"Mes\" | translate }}</a></li><li ng-class=\"seleccionadoApartado(\'personalizado\')\" ng-click=\"seleccionarApartado(\'personalizado\')\"><a>{{ \"Personalizado\" | translate }}</a></li></ul><div class=\"contenidoSelectorPeriodo {{ mostrarApartados ? \'conApartados\' : \'sinApartados\'}}\"><!-- AQUI VA LA SELECCION --><!-- DAY --><uib-datepicker ng-model=fechaDia ng-change=cambioDia() starting-day=1 min-date=fechaMin max-date=fechaMaxDesdeString datepicker-mode=day min-mode=day max-mode=day show-weeks=false class=calendario init-date=fechaSeleccion custom-class=\"getDayClass(date, mode)\" ng-show=\"seleccionadoApartado(\'dia\')\"></uib-datepicker><!-- WEEK --><uib-datepicker ng-model=fechaSemana ng-change=cambioSemana() starting-day=1 min-date=fechaMin max-date=fechaMaxDesdeString datepicker-mode=day min-mode=day max-mode=day show-weeks=false class=calendario init-date=fechaSeleccion ng-show=\"seleccionadoApartado(\'semana\')\" custom-class=claseParaSemana(date,mode) jm-dp-refresh-view=cambioPromise></uib-datepicker><!-- MONTH --><uib-datepicker ng-model=fechaMes starting-day=1 min-date=fechaMin max-date=fechaMaxDesdeString datepicker-mode=month max-mode=month min-mode=month show-weeks=false class=calendario init-date=fechaSeleccion ng-show=\"seleccionadoApartado(\'mes\')\"></uib-datepicker><!-- PERSONALIZADO --><form name=formPersonalizado><!-- con hora --><div class=personalizadoSelectorPeriodo ng-show=\"seleccionadoApartado(\'personalizado\') && mostrandohoras\"><span class=row><label class=col-xs-3 style=margin-top:27px>{{ \"Fecha inicio\" | translate }}:</label><input type=date id=fechaInicioPersonalizado name=input class=\"input col-xs-5\" ng-model=personalizado.fechaInicio uib-datepicker-popup placeholder=\"{{ \'fechaIdioma\' | translate }}\" min={{fechaMinString}} max={{fechaMaxDesdeString}} style=margin-top:27px required><uib-timepicker ng-model=personalizado.horaInicio hour-step=1 minute-step=1 show-meridian=false class=col-xs-3 style=\"margin-left: 5px\"></uib-timepicker></span><span class=row><label class=col-xs-3 style=margin-top:27px>{{ \"Fecha fin\" | translate }}:</label><input type=date id=fechaFinPersonalizado name=input class=\"input col-xs-5\" ng-model=personalizado.fechaFin uib-datepicker-popup placeholder=\"{{ \'fechaIdioma\' | translate }}\" min={{fechaMinString}} max={{fechaMaxString}} style=margin-top:27px required><uib-timepicker ng-model=personalizado.horaFin hour-step=1 minute-step=1 show-meridian=false class=col-xs-3 style=\"margin-left: 5px\"></uib-timepicker></span></div><!-- sin hora --><div class=personalizadoSelectorPeriodo ng-show=\"seleccionadoApartado(\'personalizado\') && !mostrandohoras\"><span class=row><label class=col-xs-3 style=margin-top:27px>{{ \"Fecha inicio\" | translate }}:</label><input type=date id=fechaInicioPersonalizado name=input class=\"input col-xs-9\" ng-model=personalizado.fechaInicio uib-datepicker-popup placeholder=\"{{ \'fechaIdioma\' | translate }}\" min={{fechaMinString}} max={{fechaMaxDesdeString}} style=margin-top:27px required> </span><span class=row><label class=col-xs-3 style=margin-top:27px>{{ \"Fecha fin\" | translate }}:</label><input type=date id=fechaFinPersonalizado name=input class=\"input col-xs-9\" ng-model=personalizado.fechaFin uib-datepicker-popup placeholder=\"{{ \'fechaIdioma\' | translate }}\" min={{fechaMinString}} max={{fechaMaxString}} style=margin-top:27px required></span></div></form><p ng-show=tiempoMaximo style=margin-left:5px;font-size:12px>{{ \"Tiempo máximo\" | translate}} : {{tiempoMaximo}}</p></div></div></div><div class=contenidoSelectorBotonesSeleccionador><button class=\"btn btn-primary col-xs-6\" ng-click=seleccionarFecha()>{{ \'Seleccionar\' | translate }}</button> <button class=\"btn btn-default col-xs-6\" ng-click=cancelar()>{{ \'Cancelar\' | translate }}</button></div></div></div><button class=\"btn btn-default\" ng-click=adelanteTiempo()><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=true></span></button></div>");
$templateCache.put("app/views/cuentas/tblCuentas.html","<div style=\"padding:0px 20px 0px 20px\"><!-- CUENTAS --><datik-cuentas-manager accountevent=\"{{ vm.eventoCuentaSeleccion }}\"></datik-cuentas-manager><!-- TABS = USUARIOS - APLICACIONES - VINCULACION --><div ng-show=vm.mostrar.usuarios class=contenido-modal><md-nav-bar md-selected-nav-item=vm.tabsCuentas nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"vm.gotoD(\'usuarios\')\" name=usuarios>{{\'Usuarios\' | translate}}</md-nav-item><md-nav-item md-nav-click=\"vm.gotoD(\'aplicaciones\')\" name=aplicaciones>{{\'Aplicaciones\' | translate}}</md-nav-item><md-nav-item md-nav-click=\"vm.gotoD(\'vinculaciones\')\" name=vinculaciones>{{\'Vinculaciones\' | translate}}</md-nav-item></md-nav-bar><datik-usuarios-manager ng-show=\"vm.tabsCuentas == \'usuarios\'\"></datik-usuarios-manager><datik-apps-cuentas-manager accountevent=\"{{ vm.eventoApp }}\" ng-show=\"vm.tabsCuentas == \'aplicaciones\'\"></datik-apps-cuentas-manager><datik-vinculacion-manager ng-show=\"vm.tabsCuentas == \'vinculaciones\'\"></datik-vinculacion-manager></div><div layout=row layout-align=\"center center\" class=dtallsCta ng-show=vm.mostrar.msjCuentas><div layout=column layout-align=\"center center\"><div flex align=center><span class=\"fa fa-user fa-3x\" aria-hidden=true></span><h6 class=flex-50>{{\'Seleccione una cuenta para ver sus detalles o busque un usuario\' | translate}}:</h6></div><md-autocomplete class=completeBsqUsuario placeholder=\"{{ \'Buscar Usuario\' | translate}}\" md-no-cache=true ng-disabled=vm.isDisabled md-selected-item=vm.selectedItem md-search-text-change=vm.searchTextChange(vm.searchText) md-search-text=vm.searchText md-selected-item-change=vm.selectedItemChange(item) md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=item.name md-menu-class=autocomplete-custom-template md-menu-container-class=custom-container><md-item-template><span class=item-title><md-icon md-font-icon=\"fa fa-user fa-2x\"></md-icon><strong>{{item.username}}</strong> </span><span class=item-metadata><span>cliente: <strong>{{item.uidOperator}}</strong></span></span></md-item-template></md-autocomplete></div></div></div>");
$templateCache.put("app/views/main/main.html","<div><div id=cabecera class=col-12 ng-cloak><!-- Barra de navegacion --><div class=\"scroll col-md-9 col-lg-10 col-sm-8\" ng-cloak><md-nav-bar id=navBar nav-bar-aria-label=\"navigation links\" md-selected-nav-item=vm.currentNavItem><md-nav-item md-nav-click=\"vm.goto(\'cuentas\')\" name=cuentas ng-class=\"{\'active\': vm.currentNavItem === \'cuentas\'}\" class=nav-tab><span class=nombre-boton><i class=\"fas fa-sitemap\"></i> {{\'Cuentas\' | translate}}</span></md-nav-item><md-nav-item ng-class=\"{\'active\': vm.currentNavItem === \'usuarios\'}\" class=nav-tab ng-click=vm.tabSelected() md-nav-click=\"vm.goto(\'usuarios\')\" name=usuarios ng-if=vm.mostrarUsuarios><span class=nombre-boton><i class=\"fas fa-users\"></i> {{\'Usuarios\' | translate}}</span></md-nav-item><md-nav-item class=nav-tab ng-class=\"{\'active\': vm.currentNavItem === \'equipamientos\'}\" md-nav-click=\"vm.goto(\'equipamientos\')\" name=equipamientos><span class=nombre-boton><i class=\"fas fa-digital-tachograph\"></i> {{\'Equipamientos\' | translate}}</span></md-nav-item><md-nav-item class=nav-tab md-nav-click=\"vm.goto(\'vehiculos\')\" ng-class=\"{\'active\': vm.currentNavItem === \'vehiculos\'}\" name=vehiculos><i class=\"fas fa-bus\"></i> <span class=nombre-boton>{{\'Vehiculos\' | translate}}</span></md-nav-item><md-nav-item class=nav-tab ng-class=\"{\'active\': vm.currentNavItem === \'cargadores\'}\" md-nav-click=\"vm.goto(\'cargadores\')\" name=cargadores ng-show=vm.mostrarCargadores><span class=nombre-boton><i class=\"fas fa-charging-station\"></i> {{\'Cargadores\' | translate}}</span></md-nav-item><md-nav-item class=nav-tab md-nav-click=\"vm.goto(\'recursos\')\" name=recursos ng-class=\"{\'active\': vm.currentNavItem === \'recursos\'}\" ng-if=vm.mostrarRecursos><i class=\"fas fa-box\"></i> <span class=nombre-boton>{{\'Recursos\' | translate}}</span></md-nav-item><md-nav-item class=nav-tab ng-class=\"{\'active\': vm.currentNavItem === \'gestion\'}\" md-nav-click=\"vm.goto(\'gestion\')\" name=gestion ng-if=vm.mostrarMDM><span class=nombre-boton><i class=\"far fa-sync-alt\"></i> <span>{{\'Gestión de dispositivos moviles\' | translate}}</span></span></md-nav-item><md-nav-item class=nav-tab ng-class=\"{\'active\': vm.currentNavItem === \'nagios\'}\" md-nav-click=\"vm.goto(\'nagios\')\" name=nagios ng-if=vm.mostrarNagios><span class=nombre-boton><i class=\"fas fa-monitor-heart-rate\"></i> {{\'Nagios\' | translate}}</span></md-nav-item></md-nav-bar></div><!-- User info --><div class=\"user-info col-md-3 col-lg-2 col-sm-4\"><div id=ayudaDiv layout=row><a id=ayuda ng-href=https://datik.ipanel.cloud/help/go/ title=\"{{ \'Ayuda\' | translate }}\"><i class=\"fas fa-question-circle\"></i></a></div><md-menu id=configuracionUsuario layout=row><div id=perfil ng-click=vm.abrirMenu($mdMenu) title=\"{{ \'Configurar usuario\' | translate }}\"><div><div id=userName><span>{{usuario.nombre}} {{usuario.apellido}}</span></div><div id=fechaHora layout=row><span>{{ vm.fechaUsuario | date : \'h:mm:ss a\' }}</span></div></div><div class=icono-perfil><i class=\"fas fa-user-circle\"></i></div></div><md-menu-content width=3><md-menu-item><md-button ng-click=menuUsuarioController.desconectar();index.mostrarMenuUsuario(false)>{{\"Desconectar\" | translate}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><!-- Directivas --><datik-cuentas ng-if=\"vm.currentNavItem === \'cuentas\'\"></datik-cuentas><datik-users ng-if=\"vm.currentNavItem === \'usuarios\'\"></datik-users><datik-equipamientos ng-if=\"vm.currentNavItem === \'equipamientos\'\"></datik-equipamientos><datik-vehiculos ng-if=\"vm.currentNavItem === \'vehiculos\'\"></datik-vehiculos><datik-cargadores ng-if=\"vm.currentNavItem === \'cargadores\'\"></datik-cargadores><datik-recursos ng-if=\"vm.currentNavItem === \'recursos\'\"></datik-recursos><datik-gestion-dispositivos-moviles ng-if=\"vm.currentNavItem === \'gestion\'\"></datik-gestion-dispositivos-moviles><datik-nagios ng-if=\"vm.currentNavItem === \'nagios\'\"></datik-nagios></div>");
$templateCache.put("app/composition/directives/menuUsuario/menuUsuario.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{\"Cambio de contraseña\" | translate }}</h3><i ng-click=UsuarioModalCtrl.close() class=\"fas fa-times\"></i></md-toolbar><form name=UsuarioModalCtrl.insertForm ng-cloak layout=row><div class=pwd-cuerpo><md-content class=pwd-reset><md-input-container layout=row><label>{{UsuarioModalCtrl.pwdActualTexto}}</label><input type=password name=actualPwd required ng-model=UsuarioModalCtrl.objeto.pwdactual><!-- Message --><div class=errors ng-messages=UsuarioModalCtrl.insertForm.objeto.pwdactual.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container layout=row><label>{{UsuarioModalCtrl.newPwdTexto}}</label><input type=password name=newPwd required ng-model=UsuarioModalCtrl.objeto.pwdnueva><!-- Message --><div class=errors ng-messages=UsuarioModalCtrl.insertForm.objeto.pwdnueva.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container layout=row><label>{{UsuarioModalCtrl.repitNewPwdTexto}}</label><input type=password name=newPwd2 required ng-model=UsuarioModalCtrl.objeto.pwdnuevabis><!-- Message --><div class=errors ng-messages=UsuarioModalCtrl.insertForm.objeto.pwdnuevabis.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><div class=error-modal ng-show=UsuarioModalCtrl.errorClave>{{ UsuarioModalCtrl.errorClave | translate }}</div><md-dialog-actions layout=row class=acciones-modal-pwd><md-button ng-click=UsuarioModalCtrl.guardarElemento(UsuarioModalCtrl.objeto) class=\"md-primary md-raised\"><i class=\"fas fa-save\"></i> {{\'Guardar\' | translate}}</md-button><md-button ng-click=UsuarioModalCtrl.close()>{{\"Cancelar\" | translate }}</md-button></md-dialog-actions></md-content></div></form>");
$templateCache.put("app/composition/directives/pie/pie.html","<div id=pie class=footer><div id=pieLogo><a ng-href=http://www.datik.es/ ><img ng-src=assets/images/header/LOGO-BLANCO.png width=80px alt=\"Datik Información Inteligente\" title=\"Datik Información Inteligente\"></a><!-- <img ng-show=\"{{pie.color === \'BLANCO\'}}\" ng-src=\"images/header/LOGO-BLANCO.png\" width=\"80px\" alt=\"Datik Información Inteligente\" title=\"Datik Información Inteligente\" /></a>\n      <img ng-show=\"{{pie.color !== \'BLANCO\'}}\" ng-src=\"images/header/LOGO-GRIS.png\" width=\"80px\" alt=\"Datik Información Inteligente\" title=\"Datik Información Inteligente\" /></a> --></div><div id=pieInfo class={{pie.color}}>Paseo Mikeletegi 56 20009 Donostia – San Sebastian Gipuzkoa Tel. : +34 943 224 120 <a class={{pie.color}} href=mailto:info@datik.es>info@datik.es</a></div></div>");
$templateCache.put("app/composition/directives/ayuda/ayuda.html","");
$templateCache.put("app/views/cargadores/directives/cargadores.html","<div id=cargadoresGui><md-button class=\"md-primary md-raised\" ng-click=vm.registrarCargador()><i class=\"fa fa-plus\"></i> {{\'Registrar cargadores\' | translate }}</md-button><datik-table contenedor={{vm.tblCargadores.contenedor}} max-height=\"{{ vm.tblCargadores.maxHeight }}\" per-page=\"{{ vm.tblCargadores.perPage }}\" current-page=vm.tblCargadores.currentPage loading=vm.loading elements=vm.tblCargadores.elements data=vm.tblCargadores.data options=vm.tblCargadores.options selection=vm.tblCargadores.selection number-elements-showing=vm.tblCargadores.numberElementsShowing csv-data=vm.tblCargadores.getCsvData is-sortable=true></datik-table><div class=numero-registros ng.show=\"vm.tblCargadores.numberElementsShowing !== 0\"><span>{{ \'Num registros\' | translate }}: {{vm.tblCargadores.numberElementsShowing}}</span></div></div>");
$templateCache.put("app/views/cargadores/modals/editarCargadores.modal.html","<div id=editarCargador><md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>Editar cargador</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><div class=cuerpo-modal><md-content class=contenido-modal><div class=contenido-modal layout=row><md-input-container class=modal-2-elementos><label>{{ \'Codigo\' | translate }}</label><input type=text ng-model=vm.cargadorEditar.code></md-input-container><md-input-container class=modal-2-elementos><label>{{ \'Nombre\' | translate }}</label><input type=text ng-model=vm.cargadorEditar.name></md-input-container></div><div class=contenido-modal layout=row><md-input-container class=modal-2-elementos><label>{{ \'Descripcion\' | translate }}</label><input type=text ng-model=vm.cargadorEditar.description></md-input-container><md-autocomplete class=\"modal-2-elementos autocomplete-no-shadow\" md-items=\"cliente in vm.filterClient(vm.searchText)\" md-selected-item=vm.cargadorEditar.operatorName md-no-cache=true md-search-text=vm.searchText md-require-match=true md-item-text=cliente.name md-floating-label=\"{{ \'Cliente\' |translate }}\"><md-item-template><span md-highlight-text=vm.searchText md-highlight-flag=^i>{{ cliente.name }}</span></md-item-template></md-autocomplete></div><div class=contenido-modal layout=row><md-input-container class=modal-2-elementos><label>{{ \'Latitud\' | translate }}</label><input type=text ng-model=vm.cargadorEditar.lat></md-input-container><md-input-container class=modal-2-elementos><label>{{ \'Longitud\' | translate }}</label><input type=text ng-model=vm.cargadorEditar.lon></md-input-container></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><div ng-show=\"!vm.loading && !vm.showError\"><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button><md-button ng-click=vm.editarCargador(vm.cargadorEditar) class=\"md-raised md-primary\">{{ \'Guardar\' | translate }}</md-button></div><md-progress-circular ng-show=vm.loading class=md-hue-2 md-diameter=30px></md-progress-circular></md-dialog-actions></div>");
$templateCache.put("app/views/cargadores/modals/registrarCargadores.modal.html","<div id=registrarCargador><md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>Registrar cargador</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><div class=cuerpo-modal><md-content class=contenido-modal><div class=contenido-modal layout=row><md-input-container class=modal-2-elementos><label>{{ \'Código\' | translate }}</label><input type=text required ng-model=vm.cargador.code></md-input-container><md-input-container class=modal-2-elementos><label>{{ \'Nombre\' | translate }}</label><input type=text required ng-model=vm.cargador.name></md-input-container></div><div class=\"contenido-modal auto-comp-float-label\" layout=row><md-input-container class=modal-2-elementos><label>{{ \'Descripción\' | translate }}</label><input type=text ng-model=vm.cargador.description></md-input-container><md-autocomplete class=modal-2-elementos required class=autocomplete-no-shadow md-input-name=autocompleteField md-items=\"cliente in vm.filterClient(vm.searchText)\" md-selected-item=vm.itemSelected md-selected-item-change=vm.getFleet(cliente) md-no-cache=true md-search-text=vm.searchText md-require-match=true md-item-text=cliente.name md-floating-label=\"{{ \'Cliente\' |translate }}\"><md-item-template><span md-highlight-text=vm.searchText md-highlight-flag=i>{{ cliente.name }}</span></md-item-template></md-autocomplete></div><div class=\"contenido-modal auto-comp-float-label\" layout=row><md-input-container class=modal-2-elementos><label>{{ \'Latitud\' | translate }}</label><input type=text ng-model=vm.cargador.lat></md-input-container><md-input-container class=modal-2-elementos><label>{{ \'Longitud\' | translate }}</label><input type=text ng-model=vm.cargador.lon></md-input-container></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><div ng-show=\"!vm.loading && !vm.showError\"><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button><md-button ng-click=vm.guardarCargador() class=\"md-raised md-primary\">{{ \'Guardar\' | translate }}</md-button></div><md-progress-circular ng-show=vm.loading class=md-hue-2 md-diameter=30px></md-progress-circular></md-dialog-actions></div>");
$templateCache.put("app/views/equipamientos/modals/equipamientoAlta.modal.html","<div id=equipamientos layout=column><md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form name=vm.response.projectFormEquipa ng-cloak><div class=cuerpo-modal><md-content class=contenido-modal><h4><strong>{{\'Datos de equipamiento\' | translate}}</strong></h4><div class=ng-hide><md-input-container><input name=equipmentIdViejo ng-model=vm.response.equipmentIdViejo aria-label=equipmentIdViejo></md-input-container></div><!-- MAC Tipo Hardware --><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Mac\' | translate}}</label><input required name=equipmentId ng-model=vm.response.equipmentId ng-keypress=vm.validaEspacios($event) ng-keyup=vm.lowerCase(vm.response.equipmentId) ng-disabled=vm.disableMac><div ng-messages=vm.response.projectFormEquipa.equipmentId.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-autocomplete flex required md-selected-item=vm.response.th md-no-cache=true md-input-name=autocompleteTH md-selected-item=vm.selectedItemTH md-selected-item-change=vm.selectedItemChange(tipo) md-search-text=vm.searchTextTH md-items=\"tipo in vm.querySearchTH(vm.searchTextTH)\" md-item-text=tipo.display md-require-matchmodal- md-floating-label=\"{{\'Tipo de hardware\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchTextTH md-highlight-flags=^i>{{tipo.display}}</span></md-item-template><div ng-messages=vm.response.projectFormEquipa.autocompleteTH.$error ng-if=vm.response.projectFormEquipa.autocompleteTH.$touched><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match><i class=\"fas fa-exclamation-triangle\"></i> {{\'Por favor seleccione un tipo existente.\' | translate}}</div></div></md-autocomplete></div><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Actualización\' | translate}} (H)</label><input required name=updateTime ng-model=vm.response.updateTime><div ng-messages=vm.response.projectFormEquipa.updateTime.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container class=modal-2-elementos><label>{{\'Versión requerida\' | translate}}</label><input ng-model=vm.response.updateVersion></md-input-container></div><div layout=row><h4 layout=row><strong>{{\'Subsistemas\' | translate}}</strong></h4></div><label ng-show=vm.showSinSubsis>{{\'No hay subsistemas disponibles para este tipo de hardware.\' | translate}}</label><label ng-if=\"vm.showCheks === true && vm.showSinSubsis === false\">{{\'Los subsistemas se mostraran después de seleccionar un Tipo de hardware.\' | translate}}</label><div layout=row ng-show=!vm.showCheks layout-wrap class=subsistemas-container><div class=subsistemas><md-checkbox ng-model=val.select ng-repeat=\"val in vm.response.subsystems\" ng-change=vm.toggleCheck(val); ng-disabled={{val.disabled}}>{{val.code}}</md-checkbox></div></div><!-- Asignar Vehículo --><div layout=row class=asignar-vehiculo ng-hide=vm.hideAsignation><md-switch class=md-primary ng-model=vm.asignarVehiculo ng-show=!vm.showCheks ng-click=vm.asignarVehiculoOrecurso()></md-switch><div class=sub-titulos><h4><strong ng-show=vm.asignarVehiculo>{{\'Asignar vehículo\' | translate}}</strong></h4><h4><strong ng-show=!vm.asignarVehiculo>{{\'Asignar recurso\' | translate}}</strong></h4></div></div><div ng-hide=vm.hideAsignation><div class=asignar-vehiculo-inputs><md-autocomplete required md-selected-item=vm.response.flota md-no-cache=true class=\"flota modal-2-elementos\" md-input-name=autocompleteFlota md-selected-item=vm.selectedItemFlota md-selected-item-change=vm.selectedItemChangeFlota(flota) md-search-text=vm.searchFlota md-items=\"flota in vm.querySearchFlota(vm.searchFlota)\" md-item-text=flota.display md-floating-label=\"{{\'Flota\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchFlota md-highlight-flags=^i>{{flota.display}}</span></md-item-template><div ng-messages=vm.response.projectFormEquipa.autocompleteFlota.$error ng-if=vm.response.projectFormEquipa.autocompleteFlota.$touched><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match><i class=\"fas fa-exclamation-triangle\"></i> {{ \'Por favor seleccione una Flota existente.\' | translate}}</div></div></md-autocomplete><md-autocomplete ng-disabled=vm.vehiDisabled required ng-show=\"vm.vehiDisabledEquipa && !vm.onBoard\" class=\"{{vm.styleWarningCheck}} modal-2-elementos\" md-selected-item=vm.response.vehi md-no-cache=true md-input-name=autocompleteVehi md-selected-item=vm.selectedItemVehi md-search-text=vm.searchVehi md-items=\"vehi in vm.querySearchVehi(vm.searchVehi)\" md-item-text=vehi.code md-require-match md-floating-label=\"{{\'Vehiculos\' | translate}}\" md-min-length=0 md-selected-item-change=vm.selectedItemChangeVehiculoRecurso(vehi,0)><md-item-template><span md-highlight-text=vm.searchVehi md-highlight-flags=^i>{{vehi.code}}</span></md-item-template><div ng-messages=vm.response.projectFormEquipa.autocompleteVehi.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match><i class=\"fas fa-exclamation-triangle\"></i> {{\'Por favor seleccione un vehículo existente.\' | translate}}</div></div></md-autocomplete><span><md-input-container ng-show=!vm.vehiDisabledEquipa><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span></md-input-container><div class=icons><span class=elementoBarra ng-show=vm.loadingRecuVehi><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span><md-icon md-font-icon=\"fa fa-check fa-lg\" ng-show=vm.checkVehiRecu></md-icon><md-icon md-font-icon=\"fa fa-exclamation-triangle fa-lg\" ng-show=vm.warningVehiRecu data-toggle=tooltip data-placement=left title={{vm.tooltip}}></md-icon></div></span></div><div><md-chips class={{vm.styleWarningCheck}} md-on-change=vm.onChangeResource($chip) ng-disabled=vm.recuDisabled ng-model=vm.selectedRecModel md-require-match=true ng-show=\"vm.vehiDisabledEquipa && vm.onBoard\"><md-chip-template><span><strong>{{$chip.code}} ({{$chip.resourceTypeCode}})</strong></span></md-chip-template><md-autocomplete placeholder=\"{{ \'Recursos\' |translate }}\" class={{vm.styleWarningCheck}} md-no-cache=true md-search-text=vm.searchRecu md-item-text=recu.code md-items=\"recu in vm.querySearchRecu(vm.searchRecu)\" md-min-length=0><span md-highlight-text=vm.searchRecu md-highlight-flags=^i>{{recu.code}}</span></md-autocomplete></md-chips></div></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><div ng-show=vm.equipaShow><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button><md-button flex class=\"md-raised md-primary\" ng-click=vm.altaEquipamiento(vm.response)>{{\'Dar de alta\' | translate}}</md-button></div><div ng-show=!vm.equipaShow><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button><md-button flex class=\"md-raised md-primary\" ng-click=vm.editEquipamiento(vm.response)>{{\'Guardar\' | translate}}</md-button></div></md-dialog-actions></form></div>");
$templateCache.put("app/views/equipamientos/modals/equipamientoMultiple.modal.html","<div><md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><div class=cuerpo-modal><md-content class=contenido-modal><div ng-show=vm.showContent><div><a href=assets/plantillas/Alta_MultipleEquipamientos.csv download=Plantilla.csv><strong>{{\"DESCARGAR PLANTILLA\" | translate }}</strong></a></div><md-input-container><label for=file ng-click=vm.loadDatos();><strong>{{ \'CARGAR EQUIPAMIENTOS\' | translate }}</strong></label><input class=input-file type=file id=file name=file multiple accept=\"..xlsx, .xls, .csv\"></md-input-container></div><div ng-show=!vm.showContent><div layout=row layout-align=\"space-between center\"><div layout-align=\"start center\"><md-input-container flex=40><label>{{\'Cliente\' | translate}}</label><input ng-model=vm.codeVehiculo></md-input-container><md-input-container flex=40><label>{{\'Tipo de Hardware\' | translate}}</label><input ng-model=vm.typeVehiculo></md-input-container></div><div layout-align=\"end center\"><md-input-container><span class=elementoBarra ng-show=vm.disabledBtnAlta><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span></md-input-container></div></div></div><div class=virtualRepeatdemoInfiniteScroll id=seccionTareas><md-content layout=column><md-virtual-repeat-container id=vertical-container><div class=repeated-item layout=row layout-align=\"space-around center\" md-virtual-repeat=\"item in vm.Items | filter: { equipmentId: vm.codeVehiculo, typeHardware: vm.typeVehiculo } \"><span class=text-center>{{item.equipmentId}}</span> <span class=text-center>{{item.typeHardware}}</span> <span class=text-center tooltip-placement=auto uib-tooltip-html=item.cadena>({{item.dtos}} datos más)</span></div></md-virtual-repeat-container></md-content></div><div><button ng-click=vm.cargar(); ng-disabled=vm.disabledBtnAlta><strong ng-show=true>{{ \'COMENZAR ALTA\' | translate }}</strong></button></div><div class=progress ng-show=vm.loadingAlta><div class=\"progress-bar progress-bar-striped active btn-group btn-group-justified\" role=progressbar aria-valuenow=70 aria-valuemin=0 aria-valuemax=100><span><strong>{{ \'SUBIENDO\' | translate }}</strong></span></div></div></md-content><md-dialog-actions layout=row class=acciones-modal><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button><md-button ng-click=vm.close()>{{\"Listo\" | translate }}</md-button></md-dialog-actions></div></div>");
$templateCache.put("app/views/equipamientos/directives/mainEquipamientos.html","<div style=\"padding:0px 20px 0px 20px\"><!-- TBL_EQUIPAMENTO --><datik-equipamientos-manager accountevent={{vm.eventoEquipamentoSeleccionado}}></datik-equipamientos-manager></div>");
$templateCache.put("app/views/equipamientos/directives/tblEquipamientos.directive.html","<label ng-model=vm.dtosFormEquipa></label><div layout=row layout-align=\"space-between center\" style=margin-top:10px><div style=\"margin-right: -7px\" ng-if=\"vm.loadingBoton === false\"><md-button class=\"md-raised md-secondary\" ng-disabled=vm.disabledCSV aria-label=boton ng-show=!vm.loadingCSV ng-csv=vm.exportarDatos(); filename=\"{{ \'equipamentos.csv\'| translate}}\" csv-header=vm.headerEquipamentos charset=utf-8><md-icon md-font-icon=\"fa fa-download\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Exportar CSV\' | translate}}</md-button><span class=elementoBarra ng-show=vm.loadingCSV><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span><md-button class=\"md-raised md-primary btnIpanelGo\" ng-click=vm.agregarEquipa() ng-disabled=vm.permisoEquipamiento autofocus><md-icon md-font-icon=\"fa fa-plus\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Alta de equipamiento\' | translate }}</md-button></div><div ng-show=vm.loadingBoton style=\"margin-right: 2px\"><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=30px></md-progress-circular></span></div></div><div class=row><div class=col-lg-12><datik-scrollable-table contenedor={{vm.tblEquipamientos.contenedor}} max-height=\"{{ vm.tblEquipamientos.maxHeight }}\" per-page=\"{{ vm.tblEquipamientos.perPage }}\" current-page=vm.tblEquipamientos.currentPage number-elements-showing=vm.tblEquipamientos.numberElementsShowing elements=vm.tblEquipamientos.elements data=vm.tblEquipamientos.data load-data=vm.tblEquipamientos.loadData options=vm.tblEquipamientos.options loading=vm.loading selection=vm.tblEquipamientos.selection csv-data=vm.tblEquipamientos.getCsvData is-sortable=true></datik-scrollable-table><md-progress-linear md-mode=query ng-show=\"vm.loading || vm.loadingFiltros\"></md-progress-linear></div></div><div style=margin-top:20px><div class=row><div class=col-lg-6><span class=elementoBarra ng-show=\"vm.tblEquipamientos.data.length > 0\"><label>{{ \'Num registros\' | translate }}: {{vm.tblEquipamientos.totalCount}}</label></span></div><div class=col-lg-6></div></div></div>");
$templateCache.put("app/views/gestDispositivosMoviles/directives/configDisp.directive.html","<div ng-show=!vm.showUnicVersionSelector class=massive-update-contianer><div class=massive-update><i class=\"far fa-sync-alt\"></i> <span>{{ vm.equipmentSelectionTxt }}</span></div><div class=mt-10><span ng-show=vm.showMsgDiffTypes><strong>{{ vm.updateAmountDiffTxt }}</strong></span><div class=massive-update-msg ng-show=!vm.showMsgDiffTypes><span class=update><strong>{{vm.updateAmountTxt}}</strong><div class=same-version ng-show=vm.showSameVersionTxt><i class=\"fas fa-asterisk\"></i> <i>{{vm.updateVersionAmountTxt}}</i></div></span><span class=cancel-update><strong>{{vm.notUpdateAmountTxt}}</strong></span></div></div><div class=mt-10 ng-show=!vm.showMsgDiffTypes><div class=available-versions><span>{{\'Versiones disponibles\' | translate}} {{vm.versionEquipmente}}</span></div><div class=\"massive-update-select mt-10\"><md-select flex=30 placeholder=\"{{\'Seleccione\' | translate}}\" ng-change=vm.onVersionSelectorChange() ng-model=vm.massiveVersionSelected ng-disabled=!vm.showUpdateButton><md-option ng-value=option ng-repeat=\"option in vm.unicVersionSelector.list\">{{ option.version }}</md-option></md-select><md-button class=\"md-primary md-raised ml-10\" ng-click=vm.updateAll() ng-show=vm.showUpdateButton ng-disabled=vm.disableMassiveSendBtn><md-icon md-font-icon=\"fas fa-rocket\"></md-icon>{{\'Actualizacion masiva\' | translate}}</md-button><md-button class=\"md-primary md-raised ml-10\" ng-click=vm.cancelUpdate() ng-show=vm.showCancelUpdatingButton ng-disabled=vm.disableMassiveCancelBtn><md-icon md-font-icon=\"fas fa-ban\"></md-icon>{{\'Anular actualizacion masiva\' | translate}}</md-button></div></div></div><div ng-show=vm.showConfig><div ng-show=vm.showUnicVersionSelector class=mdm-config><div layout=row layout-align=\"start center\"><div class=mac-container><md-icon class=icon md-font-icon=\"fas fa-microchip fa-lg\"></md-icon><span>{{vm.mac}}</span></div></div><md-nav-bar md-no-ink-bar=disableInkBar md-selected-nav-item=vm.currentNavItem nav-bar-aria-label=\"navigation links\"><md-nav-item ng-repeat=\"sistema in vm.subsistemas\" class=colorConfigDisp name={{sistema.name}} md-nav-click=\"vm.obtenerHash(sistema.uidSubsystemType,0, sistema);\"><span class={{sistema.icon}} style={{sistema.color}}></span> <span class=colorConfigDisp>{{sistema.name | translate}}</span></md-nav-item></md-nav-bar><div layout=column layout-align=start ng-show=vm.showSistemaTab class=system-tab><div flex layout=row layout-align=start class=system-tab-container1><div><md-icon md-font-icon=\"fa fa-code-fork fa-lg\"></md-icon><span><strong>{{\'Versión\' | translate}}:</strong></span></div><div flex ng-show=!vm.updating class=version-subsystem><span><strong>{{vm.versionSubsystema}}</strong></span></div><div flex class=circular-loading ng-show=vm.updating><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular></div><div flex class=sybsystem-version-info ng-show=vm.updating><span>{{\'El equipo se esta actualizando\' | translate}}</span></div></div><div layout=row class=available-versions ng-show=!vm.blackListFlag><span>{{\'Versiones disponibles\' | translate}} {{vm.versionEquipmente}}</span></div><div layout=row class=system-tab-container2><div ng-show=vm.blackListFlag class=msg><span>{{\'Este tipo de DCB no permite actualizacion desde mdm\' | translate }}</span></div><div class=\"d-flex selector\" ng-show=!vm.blackListFlag><md-select ng-change=vm.soloSelectorChange() flex=30 placeholder=\"{{\'Seleccione\' | translate}}\" ng-model=vm.selectVersion1 ng-disabled=vm.updating><md-option value={{option.hash}} ng-repeat=\"option in vm.selectVersion\">{{option.version}}</md-option></md-select><md-input-container flex=5 ng-show=vm.loadingUpdateVersion layout=row layout-align=\"center center\"><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular></md-input-container><md-button class=\"md-raised btn-actualizar-gest\" ng-click=vm.putVersions(); ng-show=!vm.updating ng-disabled=vm.disableUpdateOption><md-icon md-font-icon=\"fas fa-rocket\"></md-icon>{{\'Actualizar\' | translate}}</md-button><md-button class=\"md-raised btn-actualizar-gest\" ng-click=vm.cancelUpdate(vm.selectedEquip); ng-show=vm.updating ng-disabled=vm.disableCancelBtn><md-icon md-font-icon=\"fas fa-ban\"></md-icon>{{\'Cancelar actualizacion\' | translate}}</md-button></div></div></div><div ng-show=!vm.showSistemaTab class=other-tabs><div layout=row layout-align=\"center center\" class=other-tabs-contiainer1><div flex=30 ng-show=!vm.loadingConfig><md-select ng-change=vm.loadConfigFichero(vm.configuraciones.selectedOption); ng-disabled=vm.select1 aria-label=ShowHideAccountant ng-model=vm.configuraciones.selectedOption ng-model-options=\"{trackBy: \'$value.configurationType.uidConfigurationType\'}\"><md-option ng-value={{option}} ng-repeat=\"option in vm.configuraciones.availableOptions\">{{option.configurationType.name}}</md-option></md-select></div><md-input-container flex=30 ng-show=vm.loadingConfig layout=row layout-align=\"center center\"><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular></md-input-container><div flex><md-button class=\"md-icon-button md-primary mdm-new-version-btn new-version\" ng-model=vm.new_version ng-disabled=vm.plusDisabled ng-click=vm.newVersion()><md-icon md-font-icon=\"fa fa-plus\"></md-icon></md-button></div><div flex=55 ng-show=!vm.loadingHashActual><p ng-model=vm.hashActual><b>{{\'Hash actual\' | translate}}</b>: <span ng-show=!vm.showMjsActualizacion>{{ (vm.hashActual) ? vm.hashActual : vm.select_hash.hash}} </span><span ng-show=vm.showMjsActualizacion>{{\'Actualizando configuración\' | translate}}</span></p></div><div flex=55 layout=row layout-align=\"center center\" ng-show=vm.loadingHashActual><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular></div></div><div layout=row layout-align=\"center center\"><md-content flex class=no-padding><div class=config-textarea><div layout-gt-xs=row class=version-selector><md-input-container flex=30 class=md-block ng-hide=vm.select_v flex-gt-sm><md-select class=config-disp-editor-select ng-change=vm.loadConfig(vm.select_version.selectedOption); ng-disabled=\"vm.cmbVersion && vm.disableUpdateOption\" aria-label=ShowHideAccountant ng-model=vm.select_version.selectedOption ng-model-options=\"{trackBy: \'$value.version\'}\"><md-option ng-value={{option}} ng-repeat=\"option in vm.select_version.availableOptions\">{{option.version}}</md-option></md-select></md-input-container><md-input-container class=config-disp-editor-input flex=30 md-no-float class=md-block ng-hide=vm.input_nv flex-gt-sm><input ng-model=vm.fileVersionName class=placeholderColor placeholder=\"Nombre versión\" aria-label=\"Nombre versión\" ng-disabled=vm.inpVersionDisabled></md-input-container><md-input-container flex=30 ng-show=vm.loadingVersions layout=row layout-align=\"center center\"><md-progress-circular class=md-accent md-mode=indeterminate md-diameter=20px></md-progress-circular></md-input-container><md-input-container ng-show=!vm.loadingSave class=btns-container><md-button class=\"md-icon-button md-primary\" ng-click=vm.backVersion(); ng-hide=vm.btn_rtn><md-icon md-font-icon=\"fa fa-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button md-primary\" ng-click=vm.editVersion(); ng-hide=vm.btn_edit ng-disabled=vm.editDisabled><md-icon md-font-icon=\"fa fa-pencil\"></md-icon></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.sendFile(vm.aceOption1,vm.fileVersionName, vm.select_version.selectedOption);\" ng-hide=vm.btn_save><md-icon md-font-icon=\"fa fa-save\"></md-icon></md-button><md-button class=\"md-icon-button md-primary\" ng-click=vm.delFunction(vm.select_version.selectedOption); ng-hide=vm.btn_del ng-disabled=vm.deleteDisabled><md-icon md-font-icon=\"fa fa-trash\"></md-icon></md-button></md-input-container><md-input-container ng-show=vm.loadingSave><md-button class=\"md-icon-button no-pointer-events\" aria-label=btnLoading><md-progress-circular class=md-accent md-mode=indeterminate md-diameter=20px></md-progress-circular></md-button></md-input-container><md-input-container flex=40 class=md-block flex-gt-sm></md-input-container><md-input-container flex=20 class=md-block flex-gt-sm><md-select aria-label=ShowHideAccountant class=config-disp-editor-select ng-model=vm.modes.selectedOption ng-model-options=\"{trackBy: \'$value.editor\'}\" ng-change=vm.modeChanged(vm.modes.selectedOption);><md-option ng-value={{m}} ng-repeat=\"m in vm.modes.availableOptions\">{{m.editor}}</md-option></md-select></md-input-container></div><div layout-gt-xs=row class=hash-container><md-input-container class=md-block flex-gt-sm><div ui-ace=vm.aceOption ng-model=vm.aceOption1 id=ace_editor ng-keyup=vm.generateHash(vm.aceOption1);></div><div layout=row layout-align=\"space-between center\" class=hash-console-container><div class=hash-console><p ng-show=vm.input_nv>{{\'Hash de \' | translate}} \'{{ vm.select_version.selectedOption.version }}\': {{vm.hashg}}</p><p ng-hide=vm.input_nv>{{\'Hash de \' | translate}} \'{{vm.fileVersionName}}\': {{vm.hashg}}</p></div><div class=hash-console-btns><md-button class=\"md-raised md-primary hash-send-btn\" ng-click=vm.sendConfig() ng-hide=vm.guardarConfig ng-disabled=vm.sendDisabled ng-show=!vm.loadSendConfig><md-icon md-font-icon=\"fa fa-paper-plane\"></md-icon>{{\'Enviar Configuración\' | translate}}</md-button><md-progress-circular class=\"md-accent hash-loading\" md-mode=indeterminate md-diameter=30px ng-show=vm.loadSendConfig></md-progress-circular></div></div></md-input-container></div></div></md-content></div></div></div></div>");
$templateCache.put("app/views/gestDispositivosMoviles/directives/configMultiple.directive.html","<div class=\"well well-lg\" style=background:white><md-nav-bar md-no-ink-bar=disableInkBar md-selected-nav-item=vm.currentNavItem nav-bar-aria-label=\"navigation links\"><md-nav-item ng-repeat=\"sistema in vm.subSistemasMultiple\" name={{sistema.name}} md-nav-click=vm.obtenerConfig(sistema);><span class={{sistema.icon}}></span> <span class=colorConfigDisp>{{sistema.name}}</span> <span class=\"badge badgeConfigMul\">{{sistema.idsMac.length}}</span></md-nav-item></md-nav-bar><br><div ng-show=vm.showSistemaTab><h5>{{\'Equipamientos seleccionados\' | translate}}</h5><div layout=column layout-align=start flex><div flex><md-chips class=myChips><md-chip ng-repeat=\"(key,val) in vm.macs\">{{val}}</md-chip></md-chips></div><div layout=row layout-align=\"start center\" flex><md-input-container flex=33><label>{{\'Versión\' | translate}}:</label><md-select flex placeholder=\"{{\'Seleccione\' | translate}}\" ng-model=vm.selectVersion1><md-option value={{option.version}} ng-repeat=\"option in vm.selectVersion\">{{option.version}}</md-option></md-select></md-input-container><md-button class=\"md-raised md-primary flex-10\" style=\"border-radius: 4px; background-color: #297fb8; font-weight: 500\" ng-click=vm.cambiaVersion();><md-icon md-font-icon=\"fas fa-rocket\"></md-icon>{{\'Actualizar\' | translate}}</md-button><md-button class=\"md-raised md-primary flex-15\" style=\"background-color: #f5f5f5;color: #222222; border-radius: 4px; font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal\" ng-click=vm.gestionarVersiones();><md-icon md-font-icon=\"fa fa-cloud-upload\" style=color:#222222></md-icon>{{\'Gestionar versiones\' | translate}}</md-button></div></div></div><div layout=column layout-align=start flex ng-show=!vm.showSistemaTab><div flex><md-chips class=myChips><md-chip ng-repeat=\"(key,val) in vm.macs\">{{val}}</md-chip></md-chips></div><br><div layout=row layout-align=\"start center\" flex><div flex=10><h5>{{\'Configuraciones\' | translate}}</h5></div><md-input-container flex=33><label>{{\'Configuración\' | translate}}:</label><md-select ng-change=vm.getVersionesConfig(vm.configMultiple.selectedOption); ng-disabled=vm.configMultipleDisabled aria-label=ShowHideAccountant ng-model=vm.configMultiple.selectedOption ng-model-options=\"{trackBy: \'$value.uidConfigurationType\'}\"><md-option ng-value={{option}} ng-repeat=\"option in vm.configMultiple.availableOptions\">{{option.name}}</md-option></md-select></md-input-container><md-input-container flex=33><md-select class=config-disp-editor-select ng-disabled=vm.configMultipleVersionDisabled aria-label=ShowHideAccountant ng-model=vm.configMultipleVersion.selectedOption ng-model-options=\"{trackBy: \'$value.version\'}\"><md-option ng-value={{option}} ng-repeat=\"option in vm.configMultipleVersion.availableOptions\">{{option.version}}</md-option></md-select></md-input-container><div flex=33><md-button class=\"md-raised md-primary\" ng-click=vm.cambiaConfig() ng-disabled=vm.aplicarDisabled><md-icon md-font-icon=\"fa fa-paper-plane\" style=\"margin-bottom: 1px\"></md-icon>{{\'Aplicar a todos\' | translate}}</md-button></div></div></div></div>");
$templateCache.put("app/views/gestDispositivosMoviles/directives/mainGestDispMoviles.html","<div style=\"padding:0px 20px 0px 20px\"><!-- TBL_EQUIPAMENTO --><datik-gestion-dispositivos-moviles-manager></datik-gestion-dispositivos-moviles-manager></div>");
$templateCache.put("app/views/gestDispositivosMoviles/directives/mdm.directive.html","<br><div class=row><div class=col-lg-12><datik-mdm-table contenedor={{vm.table_mdm.contenedor}} max-height=\"{{ vm.table_mdm.maxHeight }}\" per-page=\"{{ vm.table_mdm.perPage }}\" current-page=vm.table_mdm.currentPage number-elements-showing=vm.table_mdm.numberElementsShowing load-data=vm.table_mdm.loadData elements=vm.table_mdm.elements data=vm.table_mdm.data options=vm.table_mdm.options loading=vm.loading selection=vm.table_mdm.selection csv-data=vm.table_mdm.getCsvData is-sortable=true></datik-mdm-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></div></div><div class=row><div class=col-lg-6><span class=elementoBarra ng-show=\"vm.table_mdm.data.length > 0\"><label style=\"padding-left: 2px; padding-top: 5px\">{{ \'Num registros\' | translate }}: {{vm.table_mdm.totalCount}}</label></span></div><div class=col-lg-6></div></div>");
$templateCache.put("app/views/gestDispositivosMoviles/directives/scrollInfinito.view.html","<div ng-controller=datikScrollController id=scrollExample><!--md-content layout=\"column\" style=\"border:1px\">--><!-- <md-virtual-repeat-container id=\"vertical-container\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap>\n          <div md-virtual-repeat=\"item in ctrl.infiniteItems\"\n              class=\"repeated-item\" flex>\n            {{item}}\n          </div>\n        </md-virtual-repeat-container>\n         <md-content md-scroll-y>\n        </md-content>\n        <div ng-repeat=\"item in ctrl.infiniteItems\" style=\"border:1\">\n          <label>{{item}}</label><br>\n        </div> --><!--section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap>\n        <md-button class=\"md-raised\">Button</md-button>\n        <md-button class=\"md-raised md-primary\">Primary</md-button>\n        <md-button ng-disabled=\"true\" class=\"md-raised md-primary\">Disabled</md-button>\n        <md-button class=\"md-raised md-warn\">Warn</md-button>\n        <div class=\"label\">Raised</div>\n      </section>\n\n  </md-content--><div class=\"col-sm-4 min-padding\" style=1px><div class=input-group><input type=text class=form-control placeholder=\"Search term\" data-ng-model=searchTerm></div><md-content layout=column style=height:200px infinite-scroll=loadMore() infinite-scroll-distance=1 infinite-scroll-parent=true><!--md-virtual-repeat-container id=\"vertical-container\" style=\"height:400px\">\n        <div md-virtual-repeat=\"item in vm.items\" class=\"repeated-item\" >\n          {{item}}\n        </div>\n      </md-virtual-repeat-container--><md-virtual-repeat-container id=vertical-container style=height:200px><div md-virtual-repeat=\"item in vm.dynamicItems\" md-on-demand class=repeated-item flex>{{item}}</div></md-virtual-repeat-container></md-content></div><!--\n<div class=\"constrained\">\n    <table class=\"table table-striped\" id=\"loggingTable\" infinite-scroll=\"loadMore()\" infinite-scroll-container=\'\".constrained\"\' infinite-scroll-distance=\"1\" infinite-scroll-parent=\"true\">\n        <tr data-ng-show=\"logEventFilter.length === 0\">\n            <td class=\"center\" colspan=\"3\">Nobody is here</td>\n        </tr>\n\n        <tr data-ng-repeat=\"logEvent in logEventFilter = (logEvents | filter:searchTerm | limitTo:numberToDisplay) track by $index\">\n            <td> {{$index}} </td>\n            <td> {{logEvent.name}} </td>\n            <td> {{numberToDisplay}} </td>\n        </tr>\n    </table>\n</div --></div>");
$templateCache.put("app/views/gestDispositivosMoviles/directives/tareas.directive.html","<div id=scrollExample style=\"background:white;margin-bottom: 0\"><div ng-show=vm.mostrar.tareas><div class=row><div class=col-lg-6><span class=\"fas fa-tasks fa-lg\"></span><b class=ng-binding> Tasks</b></div><div class=\"col-lg-6 text-right\"><md-button class=\"md-raised md-primary\" ng-click=vm.showLogs(); ng-if=false style=\"padding-right: 5px;margin-top: 0px; margin-right: 0px;margin-left: 0px;height: 33px;min-height: 33px;border-radius: 4px;background-color: #f5f5f5;color: #222222;font-size: 18px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal\"><md-icon md-font-icon=\"fas fa-file-alt\" style=\"margin-bottom: 5px;color: #222222\"><span>{{\'Ver\' | translate}} logs</span></md-icon></md-button></div></div><div class=row><div class=col-lg-12><div class=virtualRepeatdemoInfiniteScroll id=seccionTareas><md-content layout=column style=\"padding: 0;margin: 10px 0 0 0\"><md-virtual-repeat-container id=vertical-container><div md-virtual-repeat=\"item in vm.dynamicItems1\" md-on-demand class=\"repeated-item estiloTareas\" flex><div style=\"margin-left: 10px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden\"><div style=\"width: 180px; display: inline-block\"><div style=\"display: inline-block\"><md-icon ng-show=\"item.status.code >= 300\" md-font-icon=\"fa fa-times\" aria-label=success></md-icon><md-icon ng-show=\"item.status.code >= 200 && item.status.code < 300\" md-font-icon=\"fa fa-check\" aria-label=fail></md-icon><md-icon ng-show=\"item.status.code < 200\" aria-label=progress><md-progress-circular style=\"margin-top: 4px\" md-mode=indeterminate value={{vm.determinateValue}} md-diameter=15px></md-progress-circular></md-icon><md-icon md-font-icon=\"far fa-clock\" style=\"color: #222222\" aria-label=clock></md-icon><md-tooltip class=tooltip-tareas>{{item.status.message}}</md-tooltip></div><div style=\"width: 125px;display: inline-block\">{{(item.utcIniDate | date: \'HH:mm dd MMM\')}}</div></div><div style=\"display: inline-block\"><md-icon md-font-icon=\"fa fa-code\" style=\"margin-bottom: 4px; color: #222222\"></md-icon><span style=\"font-weight: 400\">{{item.description}}</span><md-tooltip class=tooltip-tareas>{{item.description}}</md-tooltip></div></div></div></md-virtual-repeat-container></md-content></div></div></div></div></div>");
$templateCache.put("app/views/gestDispositivosMoviles/directives/tblGestDispMoviles.directive.html","<!-- PANEL PRINCIPAL --><div id=mdmGUI><div class=mac-filter-container><div class=input-container><div class=chips-filter><md-chips ng-model=vm.macList ng-change=vm.onChange()><input type=text class=input-txt ng-model=vm.query placeholder=\"{{\'Pegar una lista de MACs para filtrar masivamente\' | translate}}\"><md-chip-template><span>{{$chip}}</span></md-chip-template></md-chips></div><md-button class=\"fas fa-times clear-btn\" ng-show=vm.showClearBtn ng-click=vm.cleanMassiveFilter()></md-button></div><span><md-button class=\"md-raised gestionar-versiones\" ng-show=vm.showVersionManagement ng-click=vm.gestionarVersiones();><md-icon md-font-icon=\"fa fa-cloud-upload\"></md-icon>{{\'Gestionar versiones\' | translate}}</md-button></span></div><div class=row><div class=col-lg-12><datik-mdm class=table-border accountevent=\"{{ vm.eventoEquipoSeleccionado }}\"></datik-mdm></div></div><br><div class=row><div class=col-lg-6 ng-show=vm.mostrar.tareas><datik-tareas></datik-tareas></div><div class=col-lg-6><datik-config-disp></datik-config-disp></div></div><datik-config ng-show=vm.mostrar.dispMultiples></datik-config><span ng-show=vm.mostrar.msjSelec class=aviso-gest-moviles>{{\'Por favor seleccione equipamientos del mismo tipo para acciones multiple\' | translate}}</span></div>");
$templateCache.put("app/views/gestDispositivosMoviles/modals/addEditVersion.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><div class=cuerpo-modal><div class=contenido-modal><div layout=row layout-align=\"start center\"><div flex=40><input class=input-file type=file id=file name=file accept=\".image, .upgrade\"><label for=file class=labelAdjuntar ng-click=vm.loadDatos(); ng-class=\"{\'pointerEventsVersions\': vm.dtosEdit}\"><md-icon md-font-icon=\"fas fa-file-upload fa-lg\"></md-icon><span class=adjuntar>{{\'Escoger fichero\' | translate | uppercase}}</span></label></div><md-chips flex=40 class=chip-version ng-model=vm.archivo readonly md-removable=true ng-change=vm.removeFile() ng-class=\"{\'chipError\': vm.chipClass, \'chipOk\': !vm.chipClass, \'hideBtnRemoveFileVersion\': vm.dtosEdit}\"><md-chip-template><span><strong>{{$chip.name}}</strong></span></md-chip-template></md-chips><span><md-tooltip md-direction=Right md-visible=vm.chipClass>{{vm.msjError}}</md-tooltip></span><div flex=20 ng-show=vm.archivo layout-align=\"end center\"><md-checkbox ng-model=vm.response.internal>{{ \'Privada\' | translate }}</md-checkbox></div></div><div layout=row layout-align=\"center center\"><md-input-container flex><label>{{\'Nombre version\' | translate}}:</label><input type=text ng-model=vm.response.nameVersion ng-disabled=true></md-input-container></div><div layout=row class=check-equipment layout-wrap><md-checkbox ng-checked=item.checked ng-click=vm.checkEquipment(item) ng-repeat=\"item in vm.lstEquipamiento\"><span>{{item.code}}</span></md-checkbox></div><div layout=row layout-align=\"center center\"><md-input-container flex><label>{{\'Descripcion\' | translate}}:</label><input type=text ng-model=vm.response.descripcion placeholder=\"{{\'Anadir detalles\' | translate}}...\"></md-input-container></div><div layout=row layout-align=\"center center\"><md-input-container flex><label>{{\'Changelog\' | translate}}:</label><input type=text ng-model=vm.response.changelog placeholder=\"{{\'Describir cambios\' | translate}}...\"></md-input-container></div><div layout=row layout-align=\"start center\" ng-show=vm.loading><md-progress-circular md-mode=indeterminate md-diameter=30px></md-progress-circular></div></div></div><md-dialog-actions class=acciones-modal><md-button ng-if=\"vm.dtosEdit == undefined\" class=\"md-primary md-raised\" ng-click=vm.addVersion() ng-disabled=vm.btnAddVersion><md-icon md-font-icon=\"fa fa-cloud-upload-alt\"></md-icon>{{\'Añadir\' | translate}}</md-button><md-button ng-if=vm.dtosEdit class=\"md-primary md-raised\" ng-click=vm.editVersion() ng-disabled=vm.btnAddVersion><md-icon md-font-icon=\"fa fa-cloud-upload-alt\"></md-icon>{{\'Guardar\' | translate}}</md-button><md-button ng-click=vm.close();>{{\'Cancelar\' | translate }}</md-button></md-dialog-actions>");
$templateCache.put("app/views/gestDispositivosMoviles/modals/configuracion.modal.html","<form class=modal-form name=\"\" novalidate ng-model=vm.modalConfiguracion><div class=modal-header><h3 class=modal-title>{{ vm.titulo | translate }}</h3></div><div class=modal-body style=\"padding: 15px 15px 0px 15px\"><div class=row><div class=col-lg-12><uib-tabset active=activeSystem justified=true><uib-tab ng-repeat=\"sistema in vm.subsistemas\" ng-click=vm.obtenerHash(sistema.uidSubsystemType); heading={{sistema.name}}><b style=font-size:10%>{{sistem.name}}</b></uib-tab></uib-tabset></div></div><br><div class=row><div class=col-lg-3><span class=\"fa fa-code-fork fa-1x\"></span> <b class=ng-binding>{{\'Versión\' | translate}}:</b></div><div class=col-lg-3></div><div class=col-lg-3><select class=form-control disabled><option value=\"\">Seleccione</option><option value=\"\">Algunos valores</option></select></div><div class=col-lg-3><button class=\"btn btn-block fa fa-cloud-upload fa-2x\" disabled><b class=ng-binding>{{\'Cambiar versión\' | translate}}</b></button></div></div><hr><div class=row><div class=col-lg-4><select class=form-control ng-change=vm.loadConfigFichero(vm.configuraciones.selectedOption); ng-disabled=vm.select1 ng-options=\"option.configurationType.name for option in vm.configuraciones.availableOptions track by option.configurationType.name\" ng-model=vm.configuraciones.selectedOption></select></div><div class=col-lg-1><button class=\"btn btn-default fa fa-plus\" type=button ng-model=vm.new_version ng-click=vm.newVersion()></button></div><div class=col-lg-1></div><div class=col-lg-6><p ng-model=vm.hashActual>Actual: {{ (vm.hashActual) ? vm.hashActual : vm.select_hash.hash}}</p></div></div><br><div class=config-textarea><div class=row><div class=col-lg-4><select class=form-control ng-change=vm.loadConfig(vm.select_version.selectedOption); ng-hide=vm.select_v ng-options=\"option.version for option in vm.select_version.availableOptions track by option.version\" ng-model=vm.select_version.selectedOption></select><input type=text class=form-control ng-model=vm.fileVersionName placeholder=\"Nombre versión\" ng-hide=vm.input_nv style=color:black></div><div class=col-lg-2><button class=\"btn btn-default fa fa-chevron-left\" ng-click=vm.backVersion(); ng-hide=vm.btn_rtn></button> <button class=\"btn btn-default fa fa-pencil\" ng-click=vm.editVersion(); ng-hide=vm.btn_edit></button> <button class=\"btn btn-default fa fa-save\" ng-click=\"vm.sendFile(vm.textarea1,vm.fileVersionName, vm.select_version.selectedOption);\" ng-hide=vm.btn_save></button> <button class=\"btn btn-default fa fa-trash\" ng-click=vm.delFunction(vm.select_version.selectedOption); ng-hide=vm.btn_del></button></div></div><div class=row><div class=col-lg-12><textarea class=config-textarea1 id=vm.textarea rows=8 ng-model=vm.textarea1 ng-keyup=vm.generateHash(vm.textarea1);></textarea><p style=\"border-top: 3px dotted white;margin-left:17px;margin-right:15px\">Hash Generado: {{vm.hashg}}</p></div></div></div><br><div class=row><div class=col-lg-12><button ng-hide=vm.guardarConfig class=\"btn btn-guardar fa fa-paper-plane pull-right\" titulo=\"{{\'Guardar\' | translate}}\" ng-click=vm.sendConfig(vm.select_version.selectedOption)>{{\'Enviar Configuración\' | translate}}</button></div></div><br></div></form>");
$templateCache.put("app/views/gestDispositivosMoviles/modals/gestionarVersiones.modal.html","<div id=gestionVersiones><md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form><div class=cuerpo-modal><md-content class=contenido-modal><datik-table max-height=\"{{ vm.gestionarVersiones.maxHeight }}\" per-page=\"{{ vm.gestionarVersiones.perPage }}\" current-page=vm.gestionarVersiones.currentPage number-elements-showing=vm.gestionarVersiones.numberElementsShowing elements=vm.gestionarVersiones.elements data=vm.gestionarVersiones.data options=vm.gestionarVersiones.options loading=vm.loading csv-data=vm.gestionarVersiones.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></md-content></div></form><md-dialog-actions layout=row class=acciones-modal><md-button class=\"md-primary md-raised\" ng-click=vm.addVersion();><md-icon md-font-icon=\"fa fa-plus\" aria-hidden=true></md-icon>{{\'Añadir version\' | translate}}</md-button><md-button ng-click=vm.close();>{{\'listo\' | translate }}</md-button></md-dialog-actions></div>");
$templateCache.put("app/views/gestDispositivosMoviles/modals/infoVersion.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form><div class=cuerpo-modal><md-content class=contenido-modal><div><h4 layout=row>{{\'Description\' | translate}}:</h4><span layout=row>{{vm.description}}</span></div><div><h4 layout=row>{{\'ChangeLog\' | translate}}:</h4><span layout=row>{{vm.changeLog}}</span></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><md-button ng-click=vm.close() class=\"md-raised md-primary\">{{\'listo\' | translate }}</md-button></md-dialog-actions></form>");
$templateCache.put("app/views/gestDispositivosMoviles/modals/verLogs.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form><div class=cuerpo-modal><md-content class=contenido-modal><div><div ng-readonly=true ui-ace=vm.logsAce ng-model=vm.logsAce1></div></div></md-content></div><md-dialog-actions class=acciones-modal><md-button ng-click=vm.close()>{{\'listo\' | translate }}</md-button></md-dialog-actions></form>");
$templateCache.put("app/views/cuentas/directives/apadrinamientoManager.directive.html","<div class=row><div class=col-lg-12><h4 class=tituloCabeceraVista><span class=\"fa fa-handshake-o\" aria-hidden=true></span><b> {{\'Apadrinamiento\' | translate}} : </b><font size=5>{{vm.organizacionPadre}} <span class=\"fa fa-arrow-right\"></span> {{vm.flotaHijo}} </font></h4><div class=barraSeleccion style=width:100%><uib-pagination class=pull-right style=margin-top:10px ng-show=\"!vm.loading && vm.vehiculos.perPage < vm.vehiculos.numberElementsShowing()\" total-items=vm.vehiculos.numberElementsShowing() items-per-page=vm.vehiculos.perPage ng-model=vm.vehiculos.currentPage boundary-links=true max-size=5 previous-text=\"{{ \'Anterior\'| translate}}\" next-text=\"{{ \'Siguiente\'| translate}}\" first-text=\"{{ \'Primera\'| translate}}\" last-text=\"{{ \'Última\'| translate}}\"></uib-pagination></div><datik-table max-height=\"{{ vm.vehiculos.maxHeight }}\" per-page=\"{{ vm.vehiculos.perPage }}\" current-page=vm.vehiculos.currentPage number-elements-showing=vm.vehiculos.numberElementsShowing elements=vm.vehiculos.elements data=vm.vehiculos.data options=vm.vehiculos.options loading=vm.loading selection=vm.vehiculos.selection csv-data=vm.vehiculos.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></div></div><div style=margin-top:15px><div class=row><div class=col-lg-6><span class=elementoBarra ng-show=\"vm.vehiculos.data.length > 0 && vm.loading === false\"><label>{{ \'Num registros\' | translate }}: {{vm.vehiculos.numberElementsShowing()}}</label></span></div></div></div>");
$templateCache.put("app/views/cuentas/directives/appsCuentasManager.directive.html","<div class=row><div class=col-lg-12><div class=barraSeleccion style=width:100%><uib-pagination class=pull-right style=margin-top:10px ng-show=\"!vm.loading && vm.appsCuenta.perPage < vm.appsCuenta.numberElementsShowing()\" total-items=vm.appsCuenta.numberElementsShowing() items-per-page=vm.appsCuenta.perPage ng-model=vm.appsCuenta.currentPage boundary-links=true max-size=5 previous-text=\"{{ \'Anterior\'| translate}}\" next-text=\"{{ \'Siguiente\'| translate}}\" first-text=\"{{ \'Primera\'| translate}}\" last-text=\"{{ \'Última\'| translate}}\"></uib-pagination></div><datik-table max-height=\"{{ vm.appsCuenta.maxHeight }}\" per-page=\"{{ vm.appsCuenta.perPage }}\" current-page=vm.appsCuenta.currentPage number-elements-showing=vm.appsCuenta.numberElementsShowing elements=vm.appsCuenta.elements data=vm.appsCuenta.data selection=vm.appsCuenta.selection options=vm.appsCuenta.options loading=vm.loading csv-data=vm.appsCuenta.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></div></div><div style=margin-top:15px><div class=row><div class=col-lg-12><span class=elementoBarra ng-show=\"vm.appsCuenta.data.length > 0 && !vm.loading\"><label>{{ \'Num registros\' | translate }}: {{vm.appsCuenta.numberElementsShowing()}}</label></span></div></div></div>");
$templateCache.put("app/views/cuentas/directives/cuentasManager.directive.html","<div class=row><div class=col-lg-12><div class=barraSeleccion style=width:100%></div></div></div><div class=row><div class=col-lg-12><datik-table max-height=\"{{ vm.cuentas.maxHeight }}\" per-page=\"{{ vm.cuentas.perPage }}\" current-page=vm.cuentas.currentPage number-elements-showing=vm.cuentas.numberElementsShowing elements=vm.cuentas.elements data=vm.cuentas.data options=vm.cuentas.options loading=vm.loading selection=vm.cuentas.selection csv-data=vm.cuentas.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></div></div><div layout=row layout-align=\"space-between center\" style=margin-top:10px><div><span class=elementoBarra ng-show=\"vm.cuentas.data.length > 0\"><label>{{ \'Num registros\' | translate }}: {{vm.cuentas.numberElementsShowing()}}</label></span></div><div style=\"margin-right: -7px\" ng-if=\"vm.loadingBoton === false\"><md-button class=\"md-raised md-secondary\" aria-label=boton ng-csv=vm.exportarUsuarios(); filename=\"{{ \'usuarios.csv\'| translate}}\" csv-header=vm.headerUsuarios charset=utf-8><md-icon md-font-icon=\"fa fa-download\" aria-hidden=true></md-icon>{{ \'Exportar Usuarios\' | translate}}</md-button><md-button class=\"md-raised md-secondary\" aria-label=boton ng-show=!vm.loadingCSV ng-csv=vm.exportarCuentas(); filename=\"{{ \'cuentas.csv\'| translate}}\" csv-header=vm.headerCuentas charset=utf-8><md-icon md-font-icon=\"fa fa-download\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Exportar Cuentas\' | translate}}</md-button><span class=elementoBarra ng-show=vm.loadingCSV><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span><md-button class=\"md-raised md-primary btnIpanelGo\" ng-click=vm.agregar() ng-disabled=vm.permisoCuentas autofocus><md-icon md-font-icon=\"fa fa-plus\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Añadir\' | translate }} {{\'Cuenta\' | translate }}</md-button></div><div ng-show=vm.loadingBoton style=\"margin-right: 2px\"><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=30px></md-progress-circular></span></div></div>");
$templateCache.put("app/views/cuentas/directives/permisosManager.directive.html","<div class=col-12><div class=\"col-md-2 pull-right\"><md-progress-circular ng-show=vm.cloning class=md-hue-2 md-diameter=35px></md-progress-circular><md-button ng-click=vm.cloneModal() ng-show=!vm.cloning class=\"mt-0 md-primary md-raised\" ng-disabled=vm.loading>{{ \'Clonar permisos\'| translate}}</md-button></div></div><div class=row><div class=col-lg-12><div class=tabs-permisos><md-tabs md-selected=vm.permisosIdx md-autoselect><md-tab ng-click=vm.lstPerfiles(tab.code) ng-repeat=\"tab in vm.appsUsu\" label=\"{{tab.code | translate}}\" style={{tab.vistaApp}} ng-mouseover=vm.onMouseOver(tab.description);></md-tab></md-tabs></div><div class=barraSeleccion style=width:100%><uib-pagination class=pull-right style=margin-top:10px ng-show=\"!vm.loading && vm.perfilesApp.perPage < vm.perfilesApp.numberElementsShowing()\" total-items=vm.perfilesApp.numberElementsShowing() items-per-page=vm.perfilesApp.perPage ng-model=vm.perfilesApp.currentPage boundary-links=true max-size=5 previous-text=\"{{ \'Anterior\'| translate}}\" next-text=\"{{ \'Siguiente\'| translate}}\" first-text=\"{{ \'Primera\'| translate}}\" last-text=\"{{ \'Última\'| translate}}\"></uib-pagination></div><datik-table max-height=\"{{ vm.perfilesApp.maxHeight }}\" per-page=\"{{ vm.perfilesApp.perPage }}\" current-page=vm.perfilesApp.currentPage number-elements-showing=vm.perfilesApp.numberElementsShowing elements=vm.perfilesApp.elements data=vm.perfilesApp.data selection=vm.perfilesApp.selection options=vm.perfilesApp.options loading=vm.loading csv-data=vm.perfilesApp.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></div></div><div style=margin-top:15px><div class=row><div class=col-lg-6><span class=elementoBarra ng-show=\"vm.perfilesApp.data.length > 0 && vm.loading === false\"><label>{{ \'Num registros\' | translate }}: {{vm.perfilesApp.numberElementsShowing()}}</label></span></div></div></div>");
$templateCache.put("app/views/cuentas/directives/usuariosManager.directive.html","<div class=row><div class=col-lg-6><div class=row><div class=col-lg-12><div class=\"barraSeleccion mt-10\"><uib-pagination class=\"pull-right mt-10\" ng-show=\"!vm.loading && vm.usuarios.perPage < vm.usuarios.numberElementsShowing()\" total-items=vm.usuarios.numberElementsShowing() items-per-page=vm.usuarios.perPage ng-model=vm.usuarios.currentPage boundary-links=true max-size=5 previous-text=\"{{ \'Anterior\'| translate}}\" next-text=\"{{ \'Siguiente\'| translate}}\" first-text=\"{{ \'Primera\'| translate}}\" last-text=\"{{ \'Última\'| translate}}\"></uib-pagination></div><datik-table max-height=\"{{ vm.usuarios.maxHeight }}\" per-page=\"{{ vm.usuarios.perPage }}\" current-page=vm.usuarios.currentPage number-elements-showing=vm.usuarios.numberElementsShowing elements=vm.usuarios.elements data=vm.usuarios.data options=vm.usuarios.options loading=vm.loading selection=vm.usuarios.selection csv-data=vm.usuarios.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></div></div><div layout=row layout-align=\"space-between center mt-10\"><div><span class=elementoBarra ng-show=\"vm.usuarios.data.length > 0\"><label>{{ \'Num registros\' | translate }}: {{vm.usuarios.numberElementsShowing()}}</label></span></div><div layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary btnIpanelGo\" ng-click=vm.agregarUsu() ng-disabled=vm.permisoUsuario autofocus><md-icon md-font-icon=\"fa fa-plus\" aria-hidden=true></md-icon>{{ \'Añadir\' | translate }} {{\'Usuario\' | translate }}</md-button><div ng-show=vm.loadingBoton><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=30px></md-progress-circular></span></div></div></div></div><div class=col-lg-6><div ng-show=vm.mostrar.apps><md-content class=md-padding><!-- DIRECTIVA DE PERMISOS --><md-autocomplete id=campo2 class=\"completeBsqUsuario user-search-bar col-md-10\" placeholder=\"{{ \'Buscar Usuario\' | translate}}\" md-no-cache=true ng-disabled=vm.isDisabled md-selected-item=vm.selectedItem md-search-text-change=vm.searchTextChange(vm.searchText) md-search-text=vm.searchText md-selected-item-change=vm.selectedItemChange(item) md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=item.name md-menu-class=autocomplete-custom-template md-menu-container-class=custom-container><md-item-template><span class=item-title><md-icon md-font-icon=\"fa fa-user fa-2x\"></md-icon><strong>{{item.username}}</strong> </span><span class=item-metadata><span>cliente: <strong>{{item.uidOperator}}</strong></span></span></md-item-template></md-autocomplete><datik-permisos-manager></datik-permisos-manager></md-content></div><div ng-show=vm.mostrar.msjUsuarios><div layout=row layout-wrap class=dtallsPermisos><div flex=30></div><div flex align=center><span class=\"fa fa-lock fa-3x\" aria-hidden=true></span><h6>{{\'Seleccione un usuario para modificar sus permisos\' | translate}}</h6><md-autocomplete id=campo2 class=\"completeBsqUsuario user-search-bar\" placeholder=\"{{ \'Buscar Usuario\' | translate}}\" md-no-cache=true ng-disabled=vm.isDisabled md-selected-item=vm.selectedItem md-search-text-change=vm.searchTextChange(vm.searchText) md-search-text=vm.searchText md-selected-item-change=vm.selectedItemChange(item) md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=item.name md-menu-class=autocomplete-custom-template md-menu-container-class=custom-container><md-item-template><span class=item-title><md-icon md-font-icon=\"fa fa-user fa-2x\"></md-icon><strong>{{item.username}}</strong> </span><span class=item-metadata><span>cliente: <strong>{{item.uidOperator}}</strong></span></span></md-item-template></md-autocomplete></div><div flex=30></div></div></div></div></div>");
$templateCache.put("app/views/cuentas/directives/vinculacionManager.directive.html","<div class=row><div class=col-lg-6><div class=row><div class=col-lg-12><div style=\"padding:10px 0px 0px 0px\"><nav class=breadcrumb ng-show=vm.showArbolVehi><span class=breadcrumb-item style={{miga.style}} ng-repeat=\"miga in vm.migas\" ng-click=vm.vistaVin(miga)><span class=\"fa fa-chevron-right\"></span> {{miga.name}}</span></nav></div><div class=barraSeleccion style=width:100%><uib-pagination class=pull-right style=margin-top:10px ng-show=\"!vm.loading && vm.viculacion.perPage < vm.viculacion.numberElementsShowing()\" total-items=vm.viculacion.numberElementsShowing() items-per-page=vm.viculacion.perPage ng-model=vm.viculacion.currentPage boundary-links=true max-size=5 previous-text=\"{{ \'Anterior\'| translate}}\" next-text=\"{{ \'Siguiente\'| translate}}\" first-text=\"{{ \'Primera\'| translate}}\" last-text=\"{{ \'Última\'| translate}}\"></uib-pagination></div><datik-table max-height=\"{{ vm.viculacion.maxHeight }}\" per-page=\"{{ vm.viculacion.perPage }}\" current-page=vm.viculacion.currentPage number-elements-showing=vm.viculacion.numberElementsShowing elements=vm.viculacion.elements data=vm.viculacion.data options=vm.viculacion.options loading=vm.loading selection=vm.viculacion.selection csv-data=vm.viculacion.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></div></div><div layout=row layout-align=\"space-between center\" style=margin-top:10px><div style=\"/*margin-top: -25px;*/\"><span class=elementoBarra ng-show=\"vm.viculacion.data.length > 0\"><label>{{ \'Num registros\' | translate }}: {{vm.viculacion.numberElementsShowing()}}</label></span></div><div style=\"margin-right: -7px\" ng-if=\"vm.loadingBoton === false && vm.showArbolVehi === true\"><md-button class=\"md-raised md-primary btnIpanelGo\" ng-click=vm.agregarOper() ng-disabled=vm.permisoVinculo autofocus><md-icon md-font-icon=\"fa fa-plus\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Añadir\' | translate}} {{\'Vinculación\' | translate}}</md-button></div><div ng-show=vm.loadingBoton style=\"margin-right: 2px\"><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=30px></md-progress-circular></span></div></div></div><div class=col-lg-6 ng-show=vm.showArbolVehi><div ng-show=vm.mostrar.vehiculos><datik-apadrinamiento-manager></datik-apadrinamiento-manager></div><div ng-show=!vm.mostrar.vehiculos><datik-vinculacion-tree-manager></datik-vinculacion-tree-manager></div></div></div>");
$templateCache.put("app/views/cuentas/directives/vinculacionesTree.directive.html","<h4 class=tituloCabeceraVista><span class=\"fa fa-sitemap\" aria-hidden=true></span><b> {{\'Árbol de vinculaciones\' | translate}} </b><font size=5><div id=vinculacionesTree class=row style=\"max-height: 600px;overflow-y: scroll\"><style>.chart div,.chart dl,.chart dt,.chart dd,.chart ul,.chart ol,.chart i,.chart h1,.chart h2,.chart h3,.chart h4,.chart h5,.chart h6,.chart pre,.chart form,.chart fieldset,.chart input,.chart textarea,.chart p,.chart blockquote,.chart th,.chart td { margin:0; padding:0; }\n\n		/* optional Container STYLES */\n		.chart { height: 400px; width: 600px; margin: 5px; margin: 15px auto;}\n\n		.node { font-size: 14px; }\n\n		.node.big-commpany {\n			cursor: pointer;\n			padding: 5px 5px;\n			min-width: 70px;\n			text-align: center;\n			height: 40px;\n			border: 1px solid #48647C;\n			border-radius: 2px;\n			background: #fff;\n		}\n\n		.node.big-commpany.Flota{\n			cursor: pointer;\n			padding: 5px 5px;\n			min-width: 70px;\n			text-align: center;\n			color: #3598DB;\n			height: 40px;\n			border: 1px solid #3598DB;\n			border-radius: 2px;\n			background: #fff;\n		}\n\n		.node.big-commpany.OrgActiva{\n			cursor: pointer;\n    	padding: 5px 5px;\n    	min-width: 70px;\n    	text-align: center;\n    	height: 43px;\n    	border: 2px solid #48647C;\n    	border-radius: 2px;\n    	background: #fff;\n    	font-weight: 500;\n		}\n\n		.node.big-commpany .node-name {\n			line-height: 30px;\n			color: #48647C;\n		}\n\n		.node.big-commpany.Flota .node-name {\n			line-height: 30px;\n			color: #3598DB;\n		}</style><br><span class=elementoBarra ng-show=vm.loadingTree><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span><div id=OrganiseChart-big-commpany ng-show=!vm.loadingTree></div></div></font></h4>");
$templateCache.put("app/views/cuentas/modals/altaVinculacion.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}} {{ \'Vinculación\' | translate}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form name=vm.response.vinForm><div class=cuerpo-modal><md-content class=contenido-modal><div layout=row><md-input-container flex=50><label>{{ \'Organización\' | translate}}</label><input name=nombre ng-model=vm.nombre disabled></md-input-container><md-autocomplete flex=50 ng-show=vm.showOrgFlo required md-selected-item=vm.response.cuentaVinculacion md-no-cache=true md-input-name=autocompleteOrgFlo md-search-text=vm.cuentaVinculacion md-items=\"val in vm.querySearch(vm.cuentaVinculacion) | orderBy: \'name\'\" md-item-text=val.display md-floating-label=\"{{ vm.orgFlo | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.cuentaVinculacion md-highlight-flags=^i>{{val.display}}</span></md-item-template><div ng-messages=vm.response.vinForm.autocompleteOrgFlo.$error ng-if=vm.response.vinForm.autocompleteOrgFlo.$touched><div ng-message=required>{{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match>{{\'Por favor seleccione una opción existente.\' | translate}}</div></div></md-autocomplete><md-input-container flex=50 ng-show=!vm.showOrgFlo><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span></md-input-container></div><!-- Error --><div layout=row><div flex class=error ng-show=vm.error>{{vm.error | translate}}</div></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><md-button ng-click=vm.guardar(vm.response) class=\"md-raised md-primary\">{{ \'Guardar\' | translate }}</md-button><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button></md-dialog-actions></form>");
$templateCache.put("app/views/cuentas/modals/clonarPermisos.modal.html","<div><md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{ \'Clonar permisos\' | translate}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><div class=cuerpo-modal><md-content class=contenido-modal><md-input-container class=contenido-modal><md-select ng-model=vm.user placeholder=\"{{\'Seleccionar usuario\' | translate}}\"><md-option ng-repeat=\"user in vm.userList\" ng-blur=vm.getUser(user.name) value={{user}}>{{user.username}}</md-option></md-select></md-input-container><div class=m-5><span>{{vm.str}} {{vm.usDestino}}</span></div><div class=permisos-wrapper><p class=permisos ng-repeat=\"permisos in vm.todosPermisos track by $index\">{{permisos}}</p></div></md-content></div><md-dialog-actions class=acciones-modal><md-button ng-click=vm.copiarPermisos(vm.user); class=\"md-raised md-primary\" ng-disabled=!vm.user>{{ \'Guardar\' | translate }}</md-button><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button></md-dialog-actions></div>");
$templateCache.put("app/views/cuentas/modals/cuentas.modal.html","<div layout=column><md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}} {{ \'Cuenta\' | translate}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form name=vm.response.cuentasForm ng-cloak><div class=cuerpo-modal><md-content class=contenido-modal><div layout=row><md-input-container class=contenido-modal><label>{{\'Nombre\' | translate}}</label><input required name=name ng-model=vm.response.name ng-change=vm.validateAccountName(vm.response)><div ng-messages=vm.response.cuentasForm.name.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container></div><!-- Tipo CIF  --><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Tipo\' | translate}}</label><md-select name=type ng-model=vm.response.type required><md-option value=1>{{ \'Flota\' | translate}}</md-option><md-option value=2>{{\'Organización\' | translate}}</md-option></md-select><div ng-messages=vm.response.cuentasForm.type.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container class=modal-2-elementos><label>CIF</label><input required name=cif ng-model=vm.response.cif><div ng-messages=vm.response.cuentasForm.cif.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container></div><!-- Idioma Zona horaria --><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Idioma\' | translate}}</label><md-select name=type ng-model=vm.response.language required><md-option value=en>{{\'English\' | translate}}</md-option><md-option value=es>{{\'Español\' | translate}}</md-option><md-option value=fr>{{\'Français\' | translate}}</md-option><md-option value=pt>{{\'Portugués\' | translate}}</md-option></md-select></md-input-container><md-input-container class=modal-2-elementos><label>{{\'Zona Horaria\' | translate}}</label><md-select name=timeZone ng-model=vm.response.timeZone required><md-option value={{val}} ng-repeat=\"(key,val) in vm.timeZone\">{{val}}</md-option></md-select><div ng-messages=vm.response.cuentasForm.language.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container></div><!-- Fecha Alta --><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Fecha Alta\' | translate}}</label><input type=text ng-model=vm.response.fecha disabled></md-input-container><div layout=row><div class=error ng-show=vm.error><i class=\"fas fa-exclamation-triangle\"></i> {{vm.error | translate}}</div></div></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><md-button ng-click=vm.guardar(vm.response) class=\"md-raised md-primary\" ng-disabled=vm.disableSaveAccount>{{ \'Guardar\' | translate }}</md-button><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button></md-dialog-actions></form></div>");
$templateCache.put("app/views/cuentas/modals/editParam.modal.html","<form novalidate><md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><div role=dialog layout=column class=cuerpo-modal><div layout=row layout-align=\"center center\"><uib-pagination layout=row layout-align=\"center center\" ng-show=\"!vm.loading && vm.editParam.perPage < vm.editParam.numberElementsShowing()\" total-items=vm.editParam.numberElementsShowing() items-per-page=vm.editParam.perPage ng-model=vm.editParam.currentPage boundary-links=true max-size=5 previous-text=\"{{ \'Anterior\'| translate}}\" next-text=\"{{ \'Siguiente\'| translate}}\" first-text=\"{{ \'Primera\'| translate}}\" last-text=\"{{ \'Última\'| translate}}\"></uib-pagination></div><div layout=column><div><datik-table max-height=\"{{ vm.editParam.maxHeight }}\" per-page=\"{{ vm.editParam.perPage }}\" current-page=vm.editParam.currentPage number-elements-showing=vm.editParam.numberElementsShowing elements=vm.editParam.elements data=vm.editParam.data options=vm.editParam.options selection=vm.editParam.selection loading=vm.loading csv-data=vm.editParam.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear></div><div layout=row layout-align=end><span size=2 ng-show=\"vm.editParam.data.length > 0\">{{ \'Num registros\' | translate }}: {{vm.editParam.numberElementsShowing()}}</span></div></div><div layouou=row><h6 ng-show=vm.paramAE>{{\'Añadir parámetro\' | translate}} {{vm.parametroTipo}}:</h6><h6 ng-show=!vm.paramAE>{{\'Editar parámetro\' | translate}} {{vm.parametroTipo}}:</h6></div><div layout=row ng-form=vm.editParamForm><md-input-container ng-show=vm.paramAE><md-select name=param ng-model=vm.response.param md-on-close=vm.clearSearchTerm() aria-label=select ng-change=vm.changeParam(vm.response.param); data-md-container-class=select-demo-select-header required><md-select-header class=demo-select-header><input ng-model=vm.searchTerm placeholder=\"{{\'Buscar un parámetro\' | translate}}\" ng-keydown=$event.stopPropagation() class=\"demo-header-searchbox md-text\" id=searchParam></md-select-header><md-optgroup><md-option ng-value=tiposParam ng-repeat=\"tiposParam in vm.tiposParam | filter:vm.searchTerm\">{{tiposParam.parameter}}</md-option></md-optgroup></md-select><div class=errors ng-messages=vm.editParamForm.param.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container flex=30 ng-show=!vm.paramAE><input type=text name=text ng-model=vm.editParametroSelec aria-label=input disabled></md-input-container><md-input-container flex=30 ng-show=\"vm.tipoParametro !== \'boolean\' && vm.tipoParametro !== \'select\'\"><input required type=text name=text ng-model=vm.response.valueParam aria-label=input ng-keypress=\"vm.valida($event, vm.tipoParametro)\" ng-blur=vm.validaDtosParam(vm.response);><div ng-messages=vm.editParamForm.text.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container flex=30 ng-show=\"vm.tipoParametro === \'boolean\' && vm.tipoParametro !== \'select\'\"><md-select name=boolean ng-model=vm.response.valueParam required aria-label=select ng-blur=vm.validaDtosParam(vm.response);><md-option ng-value={{true}}>true</md-option><md-option ng-value={{false}}>false</md-option></md-select><div class=errors ng-messages=vm.editParamForm.boolean.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container flex=30 ng-show=\"vm.tipoParametro === \'select\'\" required><md-select name=select ng-model=vm.response.valueParam required aria-label=select placeholder=\"{{\'Autenticación\' | translate}}\" ng-blur=vm.validaDtosParam(vm.response);><md-option ng-value=items.value ng-repeat=\"items in vm.autenticacionArray\" required>{{ items.value }}</md-option></md-select><div class=errors ng-messages=vm.editParamForm.select.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container flex=10 ng-show=\"vm.paramAE && !vm.loadingParam\"><md-button class=md-icon-button ng-click=vm.agregarParametro(vm.response); ng-disabled=vm.disabledParam><md-icon md-font-icon=\"fa fa-plus-circle fa-2x\"></md-icon></md-button></md-input-container><md-input-container flex=10 ng-show=\"!vm.paramAE && !vm.loadingParam\"><md-button class=md-icon-button ng-click=vm.editarParametro(vm.response); ng-disabled=vm.disabledParam><md-icon md-font-icon=\"fa fa-check-circle fa-2x\"></md-icon></md-button></md-input-container><md-input-container flex=10 ng-show=vm.loadingParam><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span></md-input-container></div><div class=progress-circular-center><md-progress-circular md-mode=indeterminate md-diameter=20px ng-show=vm.loadingCameras></md-progress-circular></div><div class=modal-2-elementos id=camaras ng-show=\"vm.includesTV && vm.isTipoFlota && !vm.loadingCameras\"><div><span>{{\'Camaras por defecto:\' | translate}}</span><md-input-container class=numero-camaras><input type=number aria-label=\"Camera amount input\" ng-model=vm.response.cameraAmount min=0 max=50 ng-change=vm.checkInfo(vm.response.cameraAmount)></md-input-container></div><md-button class=\"fas fa-save save-button md-primary\" aria-label=\"save button\" ng-click=vm.putCamerasAmount() ng-disabled=vm.disable></md-button></div></div><md-dialog-actions layout=row class=acciones-modal><md-button ng-click=vm.close()>{{\"Listo\" | translate }}</md-button></md-dialog-actions></form>");
$templateCache.put("app/views/cuentas/modals/info.modal.html","<form name=\"\" class=modal-form novalidate><div role=dialog layout=column layout-align=\"center center\"><md-toolbar style=\"background-color: #404048\"><div class=md-toolbar-tools layout=row layout-align=\"center center\"><h3 style=\"color: #FFF\">{{vm.titulo}}</h3></div></md-toolbar><div class=row style=\"background:white; width: 100%\"><div class=col-lg-12><div class=barraSeleccion style=width:100%><uib-pagination class=pull-right style=margin-top:10px ng-show=\"!vm.loading && vm.informacion.perPage < vm.informacion.numberElementsShowing()\" total-items=vm.informacion.numberElementsShowing() items-per-page=vm.informacion.perPage ng-model=vm.informacion.currentPage boundary-links=true max-size=5 previous-text=\"{{ \'Anterior\'| translate}}\" next-text=\"{{ \'Siguiente\'| translate}}\" first-text=\"{{ \'Primera\'| translate}}\" last-text=\"{{ \'Última\'| translate}}\"></uib-pagination></div><datik-table max-height=\"{{ vm.informacion.maxHeight }}\" per-page=\"{{ vm.informacion.perPage }}\" current-page=vm.informacion.currentPage number-elements-showing=vm.informacion.numberElementsShowing elements=vm.informacion.elements data=vm.informacion.data options=vm.informacion.options loading=vm.loading csv-data=vm.informacion.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=vm.loading></md-progress-linear><div style=\"padding: 15px 0px 15px 0px\"><font size=2 class=elementoBarra ng-show=\"vm.informacion.data.length > 0\">{{ \'Num registros\' | translate }}: {{vm.informacion.numberElementsShowing()}}</font></div></div></div><md-toolbar style=\"background-color: #6eb0b7\"><div class=\"bottom-sheet-demo inset\" layout=row layout-sm=column layout-align=end><md-button ng-click=vm.close() class=\"md-accent md-hue-3\" style=\"background-color: transparent;color:white\" type=button><b>{{\"Cancelar\" | translate }}</b></md-button><md-button ng-click=vm.close() class=\"md-raised md-accent md-hue-3\" style=\"background-color: #3F888F\" type=button><b>{{ \'Aceptar\' | translate }}</b></md-button></div></md-toolbar></div></form>");
$templateCache.put("app/views/cuentas/modals/usuarios.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}} {{ \'Usuario\' | translate}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form name=vm.response.usuariosForm><div class=cuerpo-modal><md-content class=contenido-modal><!-- UID - Usuario --><div layout=row><md-input-container flex><label>UID</label><input name=cuenta ng-model=vm.cuenta disabled></md-input-container><md-input-container flex class=md-block flex-gt-sm><label>{{\'Usuario\' | translate}}</label><input name=id ng-model=vm.response.id disabled></md-input-container></div><!-- Nombre -  Apellido --><div layout=row><md-input-container flex class=md-block flex-gt-sm><label>{{\'Nombre\' | translate}}</label><input required name=name ng-model=vm.response.name><div ng-messages=vm.response.usuariosForm.name.$error><div ng-message=required>{{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container flex class=md-block flex-gt-sm><label>{{\'Apellido\' | translate}}</label><input required name=surname ng-model=vm.response.surname><div ng-messages=vm.response.usuariosForm.surname.$error><div ng-message=required>{{\'Este campo es requerido.\' | translate}}</div></div></md-input-container></div><!-- Correo - Teléfono --><div layout=row><md-input-container flex class=md-block flex-gt-sm><label>{{\'Correo\' | translate}}</label><input required name=email ng-model=vm.response.email minlength=3 maxlength=80 ng-pattern=/^.+@.+\\..+$/ ><div ng-messages=vm.response.usuariosForm.email.$error><div ng-message=required>{{\'Este campo es requerido.\' | translate}}</div><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">{{\'Su correo electrónico debe tener entre 10 y 20 caracteres y parecer una dirección de correo electrónico.\' | translate}}</div></div></md-input-container><md-input-container flex class=md-block flex-gt-sm><label>{{\'Teléfono\' | translate}}</label><input name=telephone ng-model=vm.response.telephone minlength=7 maxlength=14 ng-pattern=/^[0-9]{7,14}$/ ><div ng-messages=vm.response.usuariosForm.telephone.$error><div ng-message-exp=\"[\'pattern\']\">{{\'Por favor ingrese un número de teléfono valido.\' | translate}}</div></div></md-input-container></div><!-- Fecha Alta - Lenguaje --><div layout=row><md-input-container flex class=md-block flex-gt-sm><label>{{\'Fecha Alta\' | translate}}</label><input name=fecha ng-model=vm.response.fecha disabled></md-input-container><md-input-container flex><label for=vm.response.language>{{\'Idioma\' | translate}}</label><md-select name=language placeholder={{vm.response.language}} ng-model=vm.response.language><md-option value=enGB>enGB</md-option><md-option value=esMX>esMX</md-option><md-option value=frFR>frFR</md-option><md-option value=esES>esES</md-option><md-option value=ptPT>ptPT</md-option></md-select></md-input-container></div><!-- Cuentas  --><div layout=row><md-input-container flex=50 class=md-block ng-show=vm.showCuentas flex-gt-sm><label>{{\'Cuentas\' | translate}}</label><md-select name=param ng-model=vm.response.account md-on-close=vm.clearSearchTerm() aria-label=select data-md-container-class=select-demo-select-header><md-select-header class=demo-select-header><input ng-model=vm.searchTerm placeholder=\"{{\'Buscar un parámetro\' | translate}}\" ng-keydown=$event.stopPropagation() class=\"demo-header-searchbox md-text\" id=searchParam></md-select-header><md-optgroup><md-option ng-value=cuentas ng-repeat=\"cuentas in vm.cuentas | filter:vm.searchTerm\">{{cuentas.name}}</md-option></md-optgroup></md-select><div class=errors ng-messages=vm.response.usuariosForm.$error><div ng-message=required>{{\'Este campo es requerido.\' | translate}}</div></div></md-input-container></div><!-- Error --><div layout=row><div class=error ng-show=vm.error>{{vm.error | translate}}</div></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><md-button ng-click=vm.guardar(vm.response) class=\"md-raised md-primary\">{{ \'Guardar\' | translate }}</md-button><md-button ng-click=vm.close()>{{\"Cancelar\" | translate }}</md-button></md-dialog-actions></form>");
$templateCache.put("app/views/login/forgotPwd/forgotPwd.html","<div class=forgot-pwd-modal><md-toolbar class=md-toolbar-tools><i class=\"fas fa-user-cog\"></i><h3 class=cabecera-modal>{{vm.titulo}} {{ \'Restablecer contraseña\' | translate}}</h3><i ng-click=vm.cancelar() class=\"fas fa-times\"></i></md-toolbar><form name=insertForm class=\"ng-pristine ng-valid ng-scope\" novalidate><div class=cuerpo-modal><md-content class=contenido-modal ng-show=!vm.enviadaPwd><h4>{{ \"Introduce tu email y te mandaremos un email para que puedas restablecer tu contraseña.\" | translate}}</h4><md-input-container layout=row><input type=email id=email placeholder=\"{{\'email\'}}\" ng-model=vm.email class=\"ng-pristine ng-untouched ng-valid\" required autofocus></md-input-container><div class=\"alert alert-danger\" ng-show=\"vm.error !== \'\'\">{{ vm.error | translate}}</div><div ng-show=vm.loading><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><md-button class=\"md-raised md-primary\" title=\"{{\'Enviar\' | translate }}\" ng-click=vm.enviarEmail()>{{ \"Enviar\" | translate }}</md-button><md-button title=\"{{ \'Cancelar\' | translate }}\" ng-click=vm.cancelar()>{{ \"Cancelar\" | translate }}</md-button></md-dialog-actions></form></div>");
$templateCache.put("app/views/login/resetPwd/resetPwd.html","<div class=\"modal-content col-sm-12 col-md-4 col-md-push-4\" style=padding:0;margin-top:20vh><form name=insertForm class=\"modal-form ng-pristine ng-valid ng-scope\" novalidate><div class=modal-header><img src=assets/images/utils/configurar.png><h3 class=modal-tittle>{{\'Establecer contraseña\' | translate }}</h3></div><div class=modal-body ng-show=!vm.enviadaPwd><p>{{ \"Introduce la actual contraseña e introduce una nueva contraseña\" | translate}}</p><br><input type=password id=actualPwd placeholder=\"{{\'Contraseña actual\'}}\" ng-model=vm.actualPwd class=\"ng-pristine ng-untouched ng-valid\" autofocus><br><br><input type=password id=newPwd placeholder=\"{{\'Nueva contraseña\'}}\" ng-model=vm.newPwd class=\"ng-pristine ng-untouched ng-valid\"><br><br><input type=password id=newPwd2 placeholder=\"{{\'Repita la nueva contraseña\'}}\" ng-model=vm.newPwd2 class=\"ng-pristine ng-untouched ng-valid\"><br><div style=margin-top:15px;margin-bottom:0px class=\"alert alert-danger alerta-modal\" ng-show=\"vm.error !== \'\'\">{{ vm.error | translate}}</div><div ng-show=vm.loading style=\"width: 100%\"><br><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></div><br><div class=modal-footer style=display:flex><button class=\"btn btn-guardar\" title=\"{{\'Enviar\' | translate }}\" ng-click=vm.enviar() style=width:100%>{{ \"Enviar\" | translate }}</button></div></div></form></div>");
$templateCache.put("app/views/login/restorePwd/restorePwd.html","<div style=\"padding-right: 20px;padding-top: 10px\"><a href=\"\" ng-click=\"vm.cambiarIdioma(\'enGB\')\" style=float:right;color:white>EN</a> <a href=\"\" ng-click=\"vm.cambiarIdioma(\'esES\')\" style=\"float:right;color:white; border-right: 1px solid white; margin-right:5px;padding-right:5px\">ES</a><div><div class=\"modal-content col-sm-12 col-md-4 col-md-push-4\" style=padding:0;margin-top:20vh><form name=insertForm class=\"modal-form ng-pristine ng-valid ng-scope\" novalidate><div class=modal-header><img src=assets/images/utils/configurar.png><h3 class=modal-tittle>{{\'Establecer contraseña\' | translate }}</h3></div><div class=modal-body ng-show=!vm.enviadaPwd><p>{{ \"Introduce la nueva contraseña\" | translate}}</p><br><input type=email id=email placeholder=\"{{\'Usuario\'}}\" ng-model=vm.email class=\"ng-pristine ng-untouched ng-valid\"><br><br><input type=password id=newPwd placeholder=\"{{\'Nueva contraseña\'}}\" ng-model=vm.newPwd class=\"ng-pristine ng-untouched ng-valid\" autofocus><br><div style=margin-top:15px;margin-bottom:0px class=\"alert alert-danger alerta-modal\" ng-show=\"vm.error !== \'\'\">{{ vm.error | translate}}</div><div ng-show=vm.loading style=\"width: 100%\"><br><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular><img id=loginLoader style=\"width: 30px; margin: 0 auto; display:block\" src=assets/images/loading/loader2.gif></div><br><div class=modal-footer style=display:flex><button class=\"btn btn-guardar btn-dos\" title=\"{{\'Enviar\' | translate }}\" ng-click=vm.enviar()>{{ \"Enviar\" | translate }}</button> <button class=\"btn btn-cancelar btn-dos\" title=\"{{ \'Cancelar\' | translate }}\" ng-click=vm.cancelar()>{{ \"Cancelar\" | translate }}</button></div></div></form></div></div></div>");
$templateCache.put("app/views/login/signIn/signIn.html","<div style=\"padding-right: 20px;padding-top: 10px\"><a href=\"\" ng-click=\"vm.cambiarIdioma(\'enGB\')\" style=float:right;color:white>EN</a> <a href=\"\" ng-click=\"vm.cambiarIdioma(\'esES\')\" style=\"float:right;color:white; border-right: 1px solid white; margin-right:5px;padding-right:5px\">ES</a> <a href=\"\" ng-click=\"vm.cambiarIdioma(\'euES\')\" style=\"float:right;color:white; border-right: 1px solid white; margin-right:5px;padding-right:5px\">EU</a><div><div id=contenedorLogin><!--h1 id=\"tituloLogin\" class=\"text-center\">iPanel GO</h1--><!--img id=\"tituloLogin\" src=\"assets/images/Logo.PNG\" /--><h1 id=tituloLogin class=\"text-center noselect\">iPanel GO</h1><form id=loginContent name=loginForm ng-submit=vm.logear()><img id=loginLoader src=assets/images/loading/loader.gif ng-show=vm.loading><!--<video autoplay muted loop>\n	  <source  id=\"loginLoader\"  src=\"assets/videos/fondo_datik_1.webm\"   preload=\"auto\" type=\"video/mp4\" ng-show=\"vm.loading\">\n	Your browser does not support the video tag.\n	</video>\n	--><div class=input-login><!--<label for=\"usuario\">Usuario</label>--> <input type=text id=usuario placeholder=\"{{\'Usuario\' | translate}}\" ng-model=vm.user.usuario required autofocus></div><div class=input-login><!--<label for=\"pwd\">Clave</label>--> <input type=password id=pwd placeholder=\"{{\'Contraseña\' | translate}}\" ng-model=vm.user.pwd required></div><div id=loginBotones><span id=loginError ng-show=vm.user.error>{{ vm.user.error | translate}}</span> <input type=submit id=submit value=\"{{ \'Entrar\' | translate}}\" ng-disabled=vm.loading></div></form></div></div></div>");
$templateCache.put("app/views/examples/fecha/fecha.html","<div class=cabeceraVista ng-mouseenter=\"ayuda.ponerValor(\'\',arrayAyuda[0].valor,arrayAyuda[0].numero)\" ng-mouseleave=ayuda.restaurarValor()><span ng-show=index.verAyuda class=ayudaCirculoPequeno style=margin-left:10px;margin-top:5px>{{arrayAyuda[0].numero}}</span><h2 class=tituloCabeceraVista>{{\'Fecha\' | translate}}</h2><div class=cabeceraVistaAcciones style=top:0></div></div><div class=alturaCompleta style=\"min-height: 500px\"><div class=row><div class=col-md-6><div style=\"padding-top: 20px; padding-bottom:20px\"><code>&lt;datik-date placeholder=\"string\" init-date=\"string\" min=\"string\" max=\"string\" event-name=\"string\" show-hours=\"string\" get-date=\"javascript\" &gt; &lt;/datik-date&gt;</code></div><div ng-if=vm.mostrar style=display:block><datik-date placeholder={{vm.date.placeholder}} init-date={{vm.date.initDate}} min={{vm.date.min}} max={{vm.date.max}} event-name={{vm.date.eventName}} show-hours={{vm.date.showHours}} get-date=vm.date.getDate></datik-date></div><div style=display:block><div style=\"padding-top: 20px; padding-bottom:20px\"><button ng-click=vm.aplicarCambios()>{{ \"Aplicar cambios\" | translate }}</button></div><div><code>placeholder:</code> <input type=text ng-model=vm.datos.placeholder></div><div><code>initDate:</code> <input type=text ng-model=vm.datos.initDate></div><div><code>min:</code> <input type=text ng-model=vm.datos.min></div><div><code>max:</code> <input type=text ng-model=vm.datos.max></div><div><code>eventName:</code> <input type=text ng-model=vm.datos.eventName></div><div><code>showHours:</code> <input type=text ng-model=vm.datos.showHours></div><div><code>getDate:</code> {{ vm.date.getDate() }}</div></div></div><div class=col-md-6 style=\"max-height: calc(100vh - 100px);overflow: auto\"><h4>Opciones</h4><div><h5>Fecha</h5><p>Este es un selector para escoger una fecha o una fecha y hora</p><div><h6>Placeholder</h6><p>Le pasamos un string al elemento y este es el que se mostrará cuando este vacio (el elemento lo traduce)</p><span>Código: <code>placeholder</code><label>Tipo: String</label></span></div><div><h6>Init date</h6><p>Esta es la fecha que queremos que muestre al inicio. Le enviamos en el formato de comunicacion \"yyyy-MM-ddThh:mm:ss\"</p><span>Código: <code>init-date</code><label>Tipo: String</label></span><p>Valores ejemplo: \'2018-12-12T12:22:33\' o \'2017-11-01T02:22:53\'</p></div><div><h6>Min</h6><p>No funciona con la version de angular-bootstrap actual (0.14.3) Si se actualiza en un futuro es una propiedad que funcionara. Le enviamos en el formato de comunicacion \"yyyy-MM-ddThh:mm:ss\"</p><span>Código: <code>min</code><label>Tipo: String</label></span><p>Valores ejemplo: \'2018-12-12T12:22:33\' o \'2017-11-01T02:22:53\'</p></div><div><h6>Max</h6><p>No funciona con la version de angular-bootstrap actual (0.14.3) Si se actualiza en un futuro es una propiedad que funcionara. Le enviamos en el formato de comunicacion \"yyyy-MM-ddThh:mm:ss\"</p><span>Código: <code>max</code><label>Tipo: String</label></span><p>Valores ejemplo: \'2018-12-12T12:22:33\' o \'2017-11-01T02:22:53\'</p></div><div><h6>Event name</h6><p>Por defecto el nombre del eveno es: datik-date-change pero le podemos indicar otro nombre para que cuando cambie nos notifique. Solo notifica fechas válidas. El evento envia una fecha en formato Date de javascript</p><span>Código: <code>event-name</code><label>Tipo: String</label></span><p>Valores ejemplo: \'fecha1evento\', por defecto el valor del evento es \'datik-date-change\'</p></div><div><h6>Show hours</h6><p>True si queremos que se muestre la hora y los minutos para seleccionar</p><span>Código: <code>show-hours</code><label>Tipo: String</label></span><p>Valores ejemplo: \'true\', cualquier otro valor hace que no se muestren las horas</p></div><div><h6>Get date</h6><p>Si le pasamos un elemento ahi pondrá la función para obtener la fecha que se ha seleccionado. La función devuelve en formato Date de javascript</p><span>Código: <code>get-date</code><label>Tipo: javascript</label></span><p>Valores ejemplo: \'true\', cualquier otro valor hace que no se muestren las horas</p></div></div></div></div></div>");
$templateCache.put("app/views/examples/notificaciones/notificaciones.html","<div class=cabeceraVista><h2 class=tituloCabeceraVista>{{\'Notificaciones\' | translate}}</h2></div><div class=alturaCompleta style=\"min-height: 500px\"><div class=col-md-6><h3>Opciones de tipo de noficación</h3><select name=opciones id=opciones ng-model=vm.opcion><option ng-repeat=\"option in vm.opcionesNotificaciones\" value={{option}}>{{option}}</option></select><h3>Título del modal</h3><input type=text ng-model=vm.tituloNotificaciones><h3>Texto a mostrar en la notificación</h3><input type=text ng-model=vm.textoNotificaciones><p><button ng-click=vm.showNotification()>Mostrar notificación</button></p></div><div class=col-md-6><h3>{{ \"Servicio Notificaciones\" | translate}}</h3><p>Utiliza el servicio de notificaciones:</p><p>Carga <code>notificaciones</code> en el controllador donde lo desees utilizar:</p><h4>Métodos</h4><p>Notificacies tiene los siguientes métodos:</p><p><code>showNotification</code>: Al método se le pasa 3 valores, el primero el título de la notificacion, despues el mensaje a mostrar y por último el tipo de notifiación</p><p>Hay 4 tipos de notificación: <code>success/error/warning/info</code></p><p><b>Ejemplo:</b> notificaciones.showNotification(\"Título a mostrar\",\"Mensaje a mostrar\", \"success\")</p></div></div>");
$templateCache.put("app/views/examples/tabla/tabla.html","<div class=cabeceraVista ng-mouseenter=\"ayuda.ponerValor(\'\',arrayAyuda[0].valor,arrayAyuda[0].numero)\" ng-mouseleave=ayuda.restaurarValor()><!--<a href=\"#/{{volver}}\" class=\"volverCabeceraVista\">--><!--<a href=\"#/\" class=\"volverCabeceraVista\">\n    {{\'Volver\' | translate}}\n  </a>--> <span ng-show=index.verAyuda class=ayudaCirculoPequeno style=margin-left:10px;margin-top:5px>{{arrayAyuda[0].numero}}</span><h2 class=tituloCabeceraVista>{{\'Tabla\' | translate}}</h2><div class=cabeceraVistaAcciones style=\"top:0; padding-right: 40px\"><button type=button class=\"btn btn-default\" ng-click=vm.selectTabla(1)>Tabla checbox</button> <button type=button class=\"btn btn-default\" ng-click=vm.selectTabla(2)>Tabla multiple</button> <button type=button class=\"btn btn-default\" ng-click=vm.selectTabla(3)>Tabla simple</button> <button type=button class=\"btn btn-default\" ng-click=vm.selectTabla(4)>Tabla</button></div></div><div class=alturaCompleta style=\"min-height: 500px\"><div class=row><div class=col-md-6><div ng-if=vm.showTable><datik-table max-height=\"calc(100vh - 100px)\" per-page={{vm.table.perPage}} current-page=vm.table.currentPage number-elements-showing=vm.numElements elements=vm.elementos data=vm.datos options=vm.opciones loading=vm.loading selection=vm.selection csv-data=vm.table.csvData is-sortable=true></datik-table></div></div><div class=col-md-6 style=\"max-height: calc(100vh - 100px); overflow-y: auto\"><div style=\"padding-top: 20px; padding-bottom:20px\"><h4>Ejemplo</h4><code>&lt;datik-table max-height=\"string\" per-page=\"string\" current-page=\"javascript\" number-elements-showing=\"javascript\" elements=\"javascript\" data=\"javascript\" options=\"javascript\" loading=\"javascript\" csv-data=\"javascript\" selection=\"javascript\" is-sortable=\"string\" &gt;&lt;/datik-table&gt;</code></div><h4>Opciones</h4><div><h5>Max height</h5><p>Mediante esta propiedad le indicamos cual es la altura máxima del elemento</p><span>Código: <code>max-height</code><label>Tipo: String</label></span><p>Para este ejemplo le pasamos: calc(100vh - 100px)</p></div><div><h5>Paginación</h5><p>Elementos para gestionar la paginación</p><div><h6>Per page</h6><p>Número de elementos que se muestran por página</p><span>Código: <code>per-page</code><label>Tipo: Number</label></span><input type=text ng-model=vm.table.perPage></div><div><h6>Current page</h6><p>Página en la cual se encuentra actualmente</p><span>Código: <code>current-page</code><label>Tipo: Number</label></span><input type=text ng-model=vm.table.currentPage></div><div><h6>Number Elements Showing</h6><p>Elemento para saber el número de elementos que se estan mostrando</p><span>Código: <code>number-elements-showing</code><label>Tipo: Función</label></span><div>Númeo de elementos = {{ vm.numElements() }}</div></div><div><h6>Loading</h6><p>Mediante esta variable le indicamos si estamos cargando los datos o no tenemos datos.</p><span>Código: <code>loading</code><label>Tipo: boolean</label></span><div>Es un booleano javascript <code>true</code> si estamos cargando <code>false</code> de lo contrario.</div></div></div><div><h5>DATOS</h5><p>Apartado de como le decimos que datos hay que mostrar y los datos mismos</p><div><h5>Elements</h5><p>Indicamos a la tabla que apartados de la lista json que le pasamos tiene que mostrar</p><span>Código: <code>elements</code><label>Tipo: Array</label><p>El Array tiene que estar compuesto como ejemplo de esta manera: <code>[{ title: \'Fecha\', information: \'date\', type: \'datetime\', sort: \'reverse\' }]</code></p><p><b>title:</b> Texto que se va a mostrar en la cabecera</p><p><b>information:</b> En el array de datos donde esta la información (por ejemplo:\"vehicle.code\")</p><p><b>type:</b> El tipo de datos que es los valores que se aceptan son: <code>string/integer/number/date/datetime/array/boolean/color</code></p><p><b>unit:</b> (Opcional y sólo para integer y number) Si es alguna unidad se la indicamos y utilizará el filtro de utilidades unidad con la variable que acepta el filtro de utilidades</p><p><b>sort:</b> (Opcional solamente 1 y valores posibles (true / reverse)) Sí se indica cual es el valor que se ordena por defecto</p><p><b>color:</b> (Opcional) Si queremos que las letras que aparecen queremos que tengan un color le definimos de donde ha de obtener ese color</p><p><b>sortArray:</b> (Opcional) Array con una lista de elementos por los que se quiere filtrar</p><p><b>bubble:</b> (Opcional) Si queremos que el valor aparezca en una burbuja de un color en esta propiedad le indicaremos donde deseamos obtener el color de la burbuja</p></span></div><div><h5>Datos de la tabla</h5><p>El Array con los datos que se han de mostrar</p><span>Código: <code>data</code><label>Tipo: Array</label></span></div><div><h5>Options</h5><p>Apartado opcional donde le pasamos que funciones vamos a poder a hacer con los elementos.</p><p>Ahora mismo hay definidos 6 tipos de acciones posibles <code>edit/delete/assign/streaming/message/geolocate/info/alert/graphic/battery</code></p><span>Código: <code>options</code><label>Tipo: Object</label></span><p>El Objeto tiene que estar compuesto como ejemplo de esta manera: <code>{ title: \'Opciones\', showTitle: \'No funciona correctamente\', width: \'No funciona correctamente\', buttons:[ {title:\'Editar\', type:\'edit\', function:funcionEditar, disabled:notDisabledFunction} ] }</code></p><p><b>title:</b><code>String</code>Title Que aparecera en la cabecera en la parte de arriva</p><p><b>showTitle:</b><code>true/false</code>(No funciona del todo) Muestra el title en los botones</p><p><b>width:</b><code>String</code>(No funciona del todo) Tamaño de la botonera hay que indicar el parametro \'200px\' por ejemplo</p><p><b>buttons:</b><code>Array</code>Array con los botones estos se componen con el siguiente array:</p><p>&nbsp;&nbsp;&nbsp;<b>title:</b><code>String</code>Título del boton</p><p></p><p>&nbsp;&nbsp;&nbsp;<b>type:</b><code>String</code>Típo de boton actualmente estos tipos <code>edit/delete/assign/streaming/message/geolocate</code></p><p></p><p>&nbsp;&nbsp;&nbsp;<b>function:</b><code>Function</code>Función a ejecutar, la directiva ejecutara pasando dos elementos, primero el elemento que se ejecuta y su index (no fiarse ya que puede ser relativo)</p><p></p><p>&nbsp;&nbsp;&nbsp;<b>disabled:</b><code>Function</code>(Opcional, si no se define siempre esta disponible)Función que ejecuta sobre el elemento para saber si esta disponible el boton o no. Pasa como primer valor el elemento en el que se ejecuta y su index relativo en la que se esta mostrando (no fiarse del index)</p><p></p></div></div><div><h5>Selection</h5><span>Código: <code>selection</code><label>Tipo: Object</label><p>Este es un objeto que tenemos que pasar este objeto tiene que tener la siguiente forma: <code>{ mode: \'multiple\', getSelectedElements : undefined, changeSelectionEventName : \'datik-table-change-selection\' }</code></p><p><b>code:</b><code>String</code>Modo en que queremos que sea la seleccion (checkbox/multiple/simple)</p><p><b>getSelectedElements:</b><code>function</code>La directiva pone una función para saber cuales son los elementos seleccionados que se están mostrando en este momento</p><p><b>changeSelectionEventName:</b><code>String</code>Cuando hay un cambio se genera un evento, si deseamos capturarlo por defecto es \'datik-table-change-selection\' o el nombre que le hemos puesto.</p></span></div><div><h5>CSV</h5><span>Código: <code>csv-data</code><label>Tipo: function</label><p>Aquí se pone una funcion que retornará los elementos que se muestran en arrays para devolver como csv</p><button type=button ng-click=vm.table.csvData()>Ejecutar csv-data</button></span></div><div><h5>Sortable</h5><span>Código: <code>is-sortable</code><label>Tipo:String</label><p>Este es un string con el cual le decimos si ha de mostrar los elementos para filtrar la tabla. Por defecto se muestran, si no queremos que se muestre tenemos que indicarle con un valor de <code>false</code></p></span></div></div></div></div>");
$templateCache.put("app/views/examples/tablaPantallaCompleta/tablaPantallaCompleta.html","<div class=cabeceraVista><h2 class=tituloCabeceraVista>{{\'Tabla pantalla completa\' | translate}}</h2><div class=cabeceraVistaAcciones style=top:5px><ul ng-mouseenter=\"ayuda.ponerValor(\'\',vm.arrayAyuda[0].valor,vm.arrayAyuda[0].numero)\" ng-mouseleave=ayuda.restaurarValor()><span ng-show=index.verAyuda class=ayudaCirculoPequeno style=display:table-cell>{{vm.arrayAyuda[0].numero}}</span><li ng-show=\"!vm.loading && vm.table.numberElementsShowing()>0\" style=cursor:pointer><img title=\"{{\'Exportar formato CSV\' | translate}}\" style=width:25px ng-csv=vm.csv.exportarDatos() filename={{::vm.csv.nombreFichero()}} ng-src=assets/images/utils/exportar.png></li></ul></div></div><!-- BARRA DE OPCIONES --><div class=barraSeleccion style=width:100%><span class=elementoBarra><button class=\"btn btn-default\" ng-click=vm.add() autofocus>{{ \'Añadir\' | translate }}</button> </span><span class=elementoBarra ng-show=vm.loading><md-progress-circular class=md-hue-2 md-diameter=30px></md-progress-circular></span><span class=elementoBarra style=float:right ng-show=\"vm.table.data.length > 0\"><label>{{ \'Num registros\' | translate }}: {{vm.table.numberElementsShowing()}}</label></span><uib-pagination class=pull-right style=margin-top:10px ng-show=\"!vm.loading && vm.table.perPage < vm.table.numberElementsShowing()\" total-items=vm.table.numberElementsShowing() items-per-page=vm.table.perPage ng-model=vm.table.currentPage boundary-links=true max-size=5 previous-text=\"{{ \'Anterior\'| translate}}\" next-text=\"{{ \'Siguiente\'| translate}}\" first-text=\"{{ \'Primera\'| translate}}\" last-text=\"{{ \'Última\'| translate}}\"></uib-pagination></div><div style=\"padding:0 10px\"><datik-table max-height=\"{{ vm.table.maxHeight }}\" per-page=\"{{ vm.table.perPage }}\" current-page=vm.table.currentPage number-elements-showing=vm.table.numberElementsShowing elements=vm.table.elements data=vm.table.data options=vm.table.options loading=vm.loading csv-data=vm.table.getCsvData is-sortable=true></datik-table></div>");
$templateCache.put("app/views/recursos/modals/recursosAltaCamb.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form><div class=cuerpo-modal><md-content class=contenido-modal><h4><strong>{{\'Datos de recursos\' | translate}}</strong></h4><div layout-gt-sm=row class=ng-hide><md-input-container flex class=md-block flex-gt-sm><input name=codigoOld ng-model=vm.response.codigoOld aria-label=codigoOld></md-input-container><md-input-container flex class=md-block flex-gt-sm><input name=clienteOld ng-model=vm.response.clienteOld aria-label=clienteOld></md-input-container></div><div layout=column><md-input-container ng-show=vm.showIdRecurso><label>{{\'Recurso\' | translate}}</label><input name=recursoUid ng-model=vm.response.recursoUid disabled></md-input-container><md-input-container><label>{{\'Código\' | translate}}</label><input required name=codigo ng-model=vm.response.codigo ng-blur=vm.recuperDtos(vm.response);vm.focusRecursos(vm.response);><div ng-messages=vm.formRecurso.codigo.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Tipo de recurso\' | translate}}</label><md-select name=recurso ng-model=vm.response.recurso ng-change=vm.recuperDtos(vm.response);vm.focusRecursos(vm.response); ng-disabled=!vm.showboton required><md-option value=totem>{{\'Totem\' | translate}}</md-option><md-option value=pip>{{\'Pip\' | translate}}</md-option></md-select><div class=errors ng-messages=vm.formRecurso.recurso.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-autocomplete class=modal-2-elementos required md-selected-item=vm.response.cliente md-no-cache=true md-input-name=autocompleteCliente md-selected-item=vm.selectedItemCliente md-selected-item-change=vm.selectedItemChange(tipo);vm.recuperDtos(vm.response);vm.focusRecursos(vm.response); md-search-text=vm.searchTextCliente md-items=\"tipo in vm.querySearchCliente(vm.searchTextCliente)\" md-item-text=tipo.display md-floating-label=\"{{\'Cliente\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchTextCliente md-highlight-flags=^i>{{tipo.display}}</span></md-item-template><div ng-messages=vm.formRecurso.autocompleteCliente.$error ng-if=vm.formRecurso.autocompleteCliente.$touched><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match><i class=\"fas fa-exclamation-triangle\"></i> {{\'Por favor seleccione un tipo existente.\' | translate}}</div></div></md-autocomplete></div></div></md-content></div><md-dialog-actions class=acciones-modal><md-button ng-show=vm.showboton class=\"md-primary md-raised\" ng-click=vm.altaRecursos(vm.response); ng-disabled=vm.recursosDisabled>{{\'Dar de alta\' | translate}}</md-button><md-button ng-show=vm.showboton ng-click=vm.close()>{{\'Cancelar\' | translate}}</md-button><md-button ng-show=!vm.showboton class=\"md-primary md-raised\" ng-show=vm.showboton ng-click=vm.editarRecursos(vm.response); ng-disabled=vm.recursosDisabled>{{\'Guardar\' | translate}}</md-button><md-button ng-show=!vm.showboton ng-show=vm.showboton ng-click=vm.close()>{{\'Cancelar\' | translate}}</md-button></md-dialog-actions></form>");
$templateCache.put("app/views/recursos/directives/mainRecursos.html","<div style=\"padding:0px 20px 0px 20px\"><!-- TBL_EQUIPAMENTO --><datik-recursos-manager accountevent={{vm.eventoRecursosSeleccionado}}></datik-recursos-manager></div>");
$templateCache.put("app/views/recursos/directives/tblRecursos.directive.html","<label ng-model=vm.dtosFormRecursos></label><div layout=row layout-align=\"space-between center\" style=margin-top:10px><div style=\"margin-right: -7px\" ng-if=\"vm.loadingBoton === false\"><md-button class=\"md-raised md-secondary\" aria-label=boton ng-show=!vm.loadingCSV ng-csv=vm.exportarDatos(); filename=\"{{ \'recursos.csv\'| translate}}\" csv-header=vm.headerRecursos charset=utf-8><md-icon md-font-icon=\"fa fa-download\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Exportar CSV\' | translate}}</md-button><span class=elementoBarra ng-show=vm.loadingCSV><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span><md-button class=\"md-raised md-primary btnIpanelGo\" ng-click=vm.agregarRecurso() ng-disabled=vm.permisoRecursos autofocus><md-icon md-font-icon=\"fa fa-plus\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Alta de recursos\' | translate }}</md-button></div><div ng-show=vm.loadingBoton style=\"margin-right: 2px\"><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=30px></md-progress-circular></span></div></div><div class=row><div class=col-lg-12><datik-scrollable-table contenedor={{vm.tblRecursos.contenedor}} max-height=\"{{ vm.tblRecursos.maxHeight }}\" per-page=\"{{ vm.tblRecursos.perPage }}\" current-page=vm.tblRecursos.currentPage number-elements-showing=vm.tblRecursos.numberElementsShowing elements=vm.tblRecursos.elements data=vm.tblRecursos.data load-data=vm.tblRecursos.loadData options=vm.tblRecursos.options loading=vm.loading selection=vm.tblRecursos.selection csv-data=vm.tblRecursos.getCsvData is-sortable=true></datik-scrollable-table><md-progress-linear md-mode=query ng-show=\"vm.loading || vm.loadingFiltros\"></md-progress-linear></div></div><div style=margin-top:20px><div class=row><div class=col-lg-6><span class=elementoBarra ng-show=\"vm.tblRecursos.data.length > 0\"><label>{{ \'Num registros\' | translate }}: {{vm.tblRecursos.totalCount}}</label></span></div><div class=col-lg-6></div></div></div>");
$templateCache.put("app/views/nagios/directives/gridListNagios.directive.html","<div ng-cloak=\"\" id=gridListNagios><div class=barraSeleccion style=width:100%><span class=elementoBarra ng-show=vm.loading><md-progress-circular md-mode=indeterminate class=progress-nagios md-diameter=50></md-progress-circular></span></div><md-content class=\"md-padding {{vm.messageNagios.color}}\" ng-show=!vm.loading><md-nav-bar md-selected-nav-item=vm.tabServicios nav-bar-aria-label=\"navigation links\" class=nav-bar-nagios><md-nav-item md-nav-click=\"vm.goto(item.name, item.datos, item.systemsErrorsWarnings, item.messageGeneral)\" name={{item.name}} ng-repeat=\"item in vm.nagios\"><span>{{item.name | translate}}</span> <span class=\"fa-stack fa-1x ng-scope\" ng-show=\"item.totalErrorsWarnings !== 0\"><i class=\"fa fa-circle fa-stack-2x {{item.messageGeneral.color}}-number\"></i> <strong class=\"fa-stack-1x fa-stack-text fa-inverse\">{{item.totalErrorsWarnings}}</strong></span></md-nav-item><md-button class=md-icon-button ng-click=vm.getSystemas();><md-icon md-font-icon=\"fa fa-refresh fa-lg\" ng-show=!vm.loadingSystems></md-icon><md-progress-circular md-mode=indeterminate md-diameter=20px ng-show=vm.loadingSystems></md-progress-circular></md-button></md-nav-bar><br><div class=\"row col-media-query general-message\" ng-show=\"vm.messageNagios !== undefined\"><div style=\"max-width: 600px\"><ul class=list-group><li class=\"list-group-item {{vm.messageNagios.color}}\"><div class=row><div class=col-lg-12><span class=list-group-item-heading><b>{{vm.messageNagios.message | translate}}</b></span></div></div></li></ul></div></div><br><div class=\"row col-media-query\"><div class=col-lg-3 ng-repeat=\"item in vm.datosErrorsWarnings | orderBy: \'issues\'\"><ul class=list-group><li class=\"list-group-item item-nagios\"><div class=row><div class=col-lg-10><h6 class=\"list-group-item-heading item-heading-nagios\"><b>{{item.host}}</b></h6></div><div class=\"col-lg-2 text-right icon-nagios\"><span ng-if=\"item.issues === \'error\'\" class=\"fa fa-exclamation-circle fa-2x {{item.issues}}-span\"></span> <span ng-if=\"item.issues === \'warning\'\" class=\"fa fa-exclamation-triangle fa-2x {{item.issues}}-span\"></span> <span ng-if=\"item.issues === \'zunknown\'\" class=\"fa fa-question-circle fa-2x {{item.issues}}-span\"></span></div></div><div class=row><div class=\"col-lg-12 span-description-nagio\"><span class={{item.issues}}-span><p>{{item.messageError}}</p></span><md-tooltip md-direction=bottom style=\"margin-top: 5px\" ng-if=\"item.messageError !== \'\'\">{{item.messageError}}</md-tooltip></div></div></li></ul></div></div><br><br><div class=\"row col-media-query\"><div class=col-lg-3 ng-repeat=\"item in vm.datosServicios\" ng-if=\"item.totalServices > 0\"><ul class=list-group><li class=\"list-group-item item-nagios\"><div class=row><div class=col-lg-10><h6 class=\"list-group-item-heading item-heading-nagios\"><b>{{item.host}}</b> <span class=span-total-services>({{item.totalServices}} {{\'services\' | translate}})</span></h6></div><div class=\"col-lg-2 text-right icon-nagios\"><span ng-if=\"item.issues === \'ok\'\" class=\"fa fa-check-circle fa-2x color-cyan\"></span></div></div><div class=row><div class=col-lg-12><label ng-if=\"item.issues === \'ok\'\">{{\'All services operational\' | translate}}</label></div></div></li></ul></div></div></md-content><div class=barraSeleccion style=\"width:100%;text-align: center\"><span class=elementoBarra ng-show=\"!vm.loading && vm.nagios === null\"><p>{{ \'No se ha podido obtener la información de monitorización\' | translate}}</p></span></div></div>");
$templateCache.put("app/views/usuarios/directives/mainUsuarios.html","<div style=\"padding:0px 20px 0px 20px\"><!-- TBL_EQUIPAMENTO --><datik-tblusuarios-manager accountevent={{vm.eventoUsuariosSeleccionado}}></datik-tblusuarios-manager></div>");
$templateCache.put("app/views/usuarios/directives/tblUsuarios.directive.html","<div layout=row layout-align=\"space-between center\" style=margin-top:10px></div><div class=row><div class=col-lg-12><datik-table class=tblUser max-height=\"{{ vm.tblUsuarios.maxHeight }}\" per-page=\"{{ vm.tblUsuarios.perPage }}\" current-page=vm.tblUsuarios.currentPage number-elements-showing=vm.tblUsuarios.numberElementsShowing elements=vm.tblUsuarios.elements data=vm.tblUsuarios.data load-data=vm.tblUsuarios.loadData options=vm.tblUsuarios.options loading=vm.loading selection=vm.tblUsuarios.selection csv-data=vm.tblUsuarios.getCsvData is-sortable=true></datik-table><md-progress-linear md-mode=query ng-show=\"vm.loading || vm.loadingFiltros\"></md-progress-linear></div></div><div style=margin-top:20px><div class=row><div class=col-lg-6><span class=elementoBarra ng-show=\"vm.tblUsuarios.data.length > 0\"><label>{{ \'Num registros\' | translate }}: {{vm.tblUsuarios.numberElementsShowing()}}</label></span></div><div class=col-lg-6></div></div></div><br><div class=row ng-show=vm.showPermisos><div class=col-lg-12><i class=\"fa fa-lock\" aria-hidden=true></i> {{\'Permisos\' | translate}}<!-- DIRECTIVA DE PERMISOS --><datik-permisos-manager></datik-permisos-manager></div></div>");
$templateCache.put("app/views/vehiculos/directives/mainVehiculos.html","<div style=\"padding:0px 20px 0px 20px\"><!-- TBL_EQUIPAMENTO --><datik-vehiculos-manager accountevent={{vm.eventoVehiculosSeleccionado}}></datik-vehiculos-manager></div>");
$templateCache.put("app/views/vehiculos/directives/tblVehiculos.directive.html","<label ng-model=vm.dtosForm></label><div layout=row layout-align=\"space-between center\" style=margin-top:10px><div style=\"margin-right: -7px\" ng-if=\"vm.loadingBoton === false\"><md-button class=\"md-raised md-secondary\" aria-label=boton ng-disabled=vm.disabledCSV ng-show=!vm.loadingCSV ng-csv=vm.exportarDatos(); filename=\"{{ \'vehiculos.csv\'| translate}}\" csv-header=vm.headerVehiculos charset=utf-8><md-icon md-font-icon=\"fa fa-download\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Exportar CSV\' | translate}}</md-button><span class=elementoBarra ng-show=vm.loadingCSV><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span><md-button class=\"md-raised md-primary btnIpanelGo\" ng-click=vm.agregarVehi() ng-disabled=vm.permisoVehiculos autofocus><md-icon md-font-icon=\"fa fa-plus\" aria-hidden=true style=\"margin-bottom: 1px\"></md-icon>{{ \'Alta de vehículo\' | translate }}</md-button></div><div ng-show=vm.loadingBoton style=\"margin-right: 2px\"><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=30px></md-progress-circular></span></div></div><div class=row><div class=col-lg-12><datik-scrollable-table contenedor={{vm.tblVehiculos.contenedor}} max-height=\"{{ vm.tblVehiculos.maxHeight }}\" per-page=\"{{ vm.tblVehiculos.perPage }}\" current-page=vm.tblVehiculos.currentPage number-elements-showing=vm.tblVehiculos.numberElementsShowing elements=vm.tblVehiculos.elements data=vm.tblVehiculos.data load-data=vm.tblVehiculos.loadData options=vm.tblVehiculos.options loading=vm.loading selection=vm.tblVehiculos.selection csv-data=vm.tblVehiculos.getCsvData is-sortable=true></datik-scrollable-table><md-progress-linear md-mode=query ng-show=\"vm.loading || vm.loadingFiltros\"></md-progress-linear></div></div><div style=margin-top:20px><div class=row><div class=col-lg-6><span class=elementoBarra ng-show=\"vm.tblVehiculos.data.length > 0\"><label>{{ \'Num registros\' | translate }}: {{vm.tblVehiculos.totalCount}}</label></span></div><div class=col-lg-6></div></div></div>");
$templateCache.put("app/views/vehiculos/modals/vehiculoEdicionSegundaParte.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{ \'Asignar cliente\' | translate}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><form name=vm.response.projectPartDosForm><div class=cuerpo-modal><md-content class=contenido-modal><div layout=row class=modal-3-elementos><md-autocomplete required md-selected-item=vm.response.nameOperator md-no-cache=true ng-blur=vm.focusEditar(vm.response) md-input-name=autocompleteFlota md-selected-item=vm.selectedItemFlota md-selected-item-change=vm.selectedItemChange(flota) md-search-text=vm.searchFlota md-items=\"flota in vm.querySearchFlota(vm.searchFlota)\" md-item-text=flota.display md-floating-label=\"{{\'Flota\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchFlota md-highlight-flags=^i>{{flota.display}}</span></md-item-template><div ng-messages=vm.response.projectPartDosForm.autocompleteFlota.$error ng-if=vm.response.projectPartDosForm.autocompleteFlota.$touched><div ng-message=required>{{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match>{{\'Por favor seleccione una Flota existente.\' | translate}}</div></div></md-autocomplete><md-autocomplete ng-show=vm.showSedeGrupo ng-disabled=vm.sedeDisabled flex required md-selected-item=vm.response.nameHeadquarters md-no-cache=true ng-blur=vm.focusEditar(vm.response) md-input-name=autocompleteSede md-selected-item=vm.selectedItemSede md-search-text=vm.searchSede md-items=\"sede in vm.querySearchSede(vm.searchSede)\" md-item-text=sede.display md-floating-label=\"{{\'Sede\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchSede md-highlight-flags=^i>{{sede.display}}</span></md-item-template><div ng-messages=vm.response.projectPartDosForm.autocompleteSede.$error ng-if=vm.response.projectPartDosForm.autocompleteSede.$touched><div ng-message=required>{{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match>{{\'Por favor seleccione una Sede existente.\' | translate}}</div></div></md-autocomplete><md-autocomplete ng-show=vm.showSedeGrupo ng-disabled=vm.grupoDisabled flex required md-selected-item=vm.response.nameGroupType md-no-cache=true ng-blur=vm.focusEditar(vm.response) md-input-name=autocompleteGrupo md-selected-item=vm.selectedItemGrupo md-search-text=vm.searchGrupo md-items=\"grupo in vm.querySearchGrupo(vm.searchGrupo)\" md-item-text=grupo.display md-floating-label=\"{{\'Grupo\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchGrupo md-highlight-flags=^i>{{grupo.display}}</span></md-item-template><div ng-messages=vm.response.projectPartDosForm.autocompleteGrupo.$error ng-if=vm.response.projectPartDosForm.autocompleteGrupo.$touched><div ng-message=required>{{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match>{{\'Por favor seleccione un Grupo existente.\' | translate}}</div></div></md-autocomplete></div><h4 layout=row><strong>{{ \'Asignar equipamento\' | translate}}</strong></h4><div layout=row><md-switch class=md-success ng-model=vm.equimanto aria-label=\"Switch 1\" ng-disabled=true>{{\'Sin equipamiento\' | translate}}</md-switch></div></md-content></div><md-dialog-actions layout=row class=acciones-modal><md-button ng-click=vm.guardarEditVehi(vm.response) ng-disabled=vm.guardarEditDos class=\"md-raised md-primary\">{{ \'Guardar\' | translate }}</md-button><md-button ng-click=vm.close()>{{ \'Cancelar\' | translate }}</md-button></md-dialog-actions></form>");
$templateCache.put("app/views/vehiculos/modals/vehiculoMultiple.modal.html","<div role=dialog layout=column layout-align=center><md-toolbar style=\"background-color: #404048\"><div class=md-toolbar-tools><div class=col-lg-3></div><div class=col-lg-6><h3 style=\"color: #FFF;text-align: center\">{{vm.titulo}}</h3></div><div class=col-lg-3></div></div></md-toolbar><div class=demo-dialog-content style=\"padding: 50px 0px 50px 0px\" ng-show=vm.showContent><div class=row><div class=col-lg-4></div><div class=col-lg-4><div class=\"btn-group btn-group-justified\" role=group aria-label=...><div class=btn-group role=group><a href=assets/plantillas/Alta_MultipleVehiculos.csv class=\"btn btn-default\" download=Plantilla.csv style=\"background-color: #999999; color: white\"><b>{{\"DESCARGAR PLANTILLA\" | translate }}</b></a></div></div></div><div class=col-lg-4></div></div><br><div class=row><div class=col-lg-4></div><div class=col-lg-4><div class=\"btn-group btn-group-justified\" role=group aria-label=...><div class=btn-group role=group><input class=input-file type=file id=file name=file multiple accept=\"..xlsx, .xls, .csv\"><label for=file class=\"btn btn-default\" style=\"background-color: #3F888F; color: white\" ng-click=vm.loadDatos();><b>{{ \'CARGAR VEHÍCULOS\' | translate }}</b></label></div></div></div><div class=col-lg-4></div></div></div><div class=demo-dialog-content style=\"padding:0px 20px 0px 20px\" ng-show=!vm.showContent><br><div layout=row layout-align=\"space-between center\"><div layout-align=\"start center\"><md-input-container flex=40><label>{{\'Código Vehículo\' | translate}}</label><input ng-model=vm.codeVehiculo></md-input-container><md-input-container flex=40><label>{{\'Tipo de Vehiculo\' | translate}}</label><input ng-model=vm.typeVehiculo></md-input-container></div><div layout-align=\"end center\"><md-input-container><span class=elementoBarra ng-show=vm.disabledBtnAlta><img src=assets/images/loading/loader2.gif style=\"height: 25px; margin-top:-25px\"></span></md-input-container></div></div><div class=row style=\"margin-top: -35px\"><div class=col-lg-12><div class=virtualRepeatdemoInfiniteScroll id=seccionTareas><md-content layout=column style=\"padding: 0;margin: 10px 0 0 0\"><md-virtual-repeat-container id=vertical-container><div md-virtual-repeat=\"item in vm.Items | filter: { code: vm.codeVehiculo, type: vm.typeVehiculo } \" class=repeated-item layout=row layout-align=\"space-around center\"><div style=\"text-align: center\">{{item.code}}</div><div style=\"width: 150px; text-align: center\">{{item.type}}</div><div style=\"text-align: center\" tooltip-placement=auto uib-tooltip-html=item.cadena>({{item.dtos}} datos más)</div><div style=\"text-align: center\"><md-progress-circular md-mode=indeterminate md-diameter=15px ng-show=\"item.status === 0\"></md-progress-circular><md-icon style=\"color: red\" md-font-icon=\"fa fa-times\" ng-show=\"item.status >= 300\" tooltip-placement=auto uib-tooltip={{item.message}} tooltip-is-open=true></md-icon><md-icon style=\"color: green\" md-font-icon=\"fa fa-check\" ng-show=\"item.status >= 200 && item.status < 300\"></md-icon></div></div></md-virtual-repeat-container></md-content></div></div></div><br><div class=row><div class=col-lg-4></div><div class=col-lg-4><div class=\"btn-group btn-group-justified\" role=group aria-label=... ng-show=!vm.loadingAlta><div class=btn-group role=group><button ng-click=vm.cargar(); class=\"btn btn-default\" style=\"background-color: #3F888F; color: white\" ng-disabled=vm.disabledBtnAlta><b ng-show=true>{{ \'COMENZAR ALTA\' | translate }}</b></button></div></div><div class=progress style=height:40px ng-show=vm.loadingAlta><div class=\"progress-bar progress-bar-striped active btn-group btn-group-justified\" role=progressbar aria-valuenow=70 aria-valuemin=0 aria-valuemax=100 style=\"width:{{vm.progressBar}}%; background-color: #3F888F\"><div class=btn-group><b style=\"font-size: 14px\">{{ \'SUBIENDO\' | translate }}</b></div></div></div></div><div class=col-lg-4></div></div><br></div><md-toolbar style=\"background-color: #6eb0b7\"><div class=\"bottom-sheet-demo inset\" layout=row layout-sm=column layout-align=end><md-button ng-click=vm.close() class=\"md-accent md-hue-3\" style=\"background-color: transparent;color:white\" type=button><b>{{\"Listo\" | translate }}</b></md-button></div></md-toolbar></div>");
$templateCache.put("app/views/vehiculos/modals/vehiculoPrimeraParte.modal.html","<md-toolbar class=md-toolbar-tools><h3 class=cabecera-modal>{{vm.titulo}}</h3><i ng-click=vm.close() class=\"fas fa-times\"></i></md-toolbar><div class=cuerpo-modal><md-content ng-show=vm.modalPrimerPart><h4 layout=row><strong>{{ \'Datos de vehículo\' | translate}}&nbsp;{{ (vm.response.uid !== undefined) ? (\' (\' + vm.response.uid + \')\') : \'\'}}</strong></h4><form name=vm.response.projectForm><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Código\' | translate}}</label><input required name=code ng-model=vm.response.code ng-blur=vm.focusAlta(vm.response);vm.recuperDtos(vm.response); ng-keypress=vm.validaEspacios($event)><div ng-messages=vm.response.projectForm.code.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container class=modal-2-elementos><label>{{\'Tipo\' | translate}}</label><md-select name=type ng-model=vm.response.type required ng-change=vm.itemChange(vm.response.type); ng-blur=vm.focusAlta(vm.response);vm.recuperDtos(vm.response);><md-option value=0>{{\'Hibrido\' | translate}}</md-option><md-option value=1>{{\'Diesel\' | translate}}</md-option><md-option value=2>{{\'Eléctrico\' | translate}}</md-option></md-select><div class=errors ng-messages=vm.response.projectForm.type.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container></div><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Modelo\' | translate}}</label><input required name=model ng-model=vm.response.model ng-blur=vm.focusAlta(vm.response);vm.recuperDtos(vm.response);><div ng-messages=vm.response.projectForm.model.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container class=modal-2-elementos><label>{{\'Vel. Max.\' | translate}} (KM/H)</label><input required name=velMax ng-model=vm.response.velMax ng-blur=vm.focusAlta(vm.response);vm.recuperDtos(vm.response);><div ng-messages=vm.response.projectForm.velMax.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container></div><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Depósito\' | translate}} (L)</label><input required name=deposit ng-model=vm.response.deposit ng-blur=vm.focusAlta(vm.response);vm.recuperDtos(vm.response);><div ng-messages=vm.response.projectForm.deposit.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container class=modal-2-elementos><label>{{\'Motor\' | translate}}</label><input required name=engine ng-model=vm.response.engine ng-blur=vm.focusAlta(vm.response);vm.recuperDtos(vm.response);><div ng-messages=vm.response.projectForm.engine.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container></div><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Matrícula\' | translate}}</label><input required name=registration ng-model=vm.response.registration ng-blur=vm.focusAlta(vm.response);vm.recuperDtos(vm.response);><div ng-messages=vm.response.projectForm.registration.$error><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div></div></md-input-container><md-input-container class=modal-2-elementos><label>ID {{\'vehículo externo\' | translate}}</label><input ng-model=vm.response.idExternal ng-blur=vm.recuperDtos(vm.response);></md-input-container></div><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Número de obra\' | translate}}</label><input ng-model=vm.response.workNumber ng-blur=vm.recuperDtos(vm.response);></md-input-container><md-input-container class=modal-2-elementos><label>{{\'VIN\' | translate}}</label><input ng-model=vm.response.vin ng-blur=vm.recuperDtos(vm.response);></md-input-container></div><div layout=row><md-input-container class=modal-2-elementos><label>{{\'Chasis\' | translate}}</label><input ng-model=vm.response.sistemConfiguration ng-blur=vm.recuperDtos(vm.response);></md-input-container><md-input-container class=modal-2-elementos ng-show=vm.macInter><label>{{\'Mac interoperable\' | translate}}</label><input ng-model=vm.response.macInteroperable ng-blur=vm.recuperDtos(vm.response);></md-input-container></div></form><md-dialog-acionts layout=row ng-show=vm.ocultaPasos><div layout=row layout-align=\"start center\" flex md-truncate><strong>{{\'Paso 1 de 2\' | translate}}</strong></div><md-button ng-click=vm.close() layout=row><span>{{\"Cancelar\" | translate }}</span></md-button><md-button ng-click=vm.almacenar(vm.response) class=\"md-raised md-primary\" ng-disabled=vm.disabled><span>{{ \'Asignar\' | translate }}</span></md-button></md-dialog-acionts><md-dialog-actions layout=row ng-show=!vm.ocultaPasos><div layout=row layout-align=\"start center\" flex md-truncate><strong ng-if=\"{{vm.ocultaPasos ? visibilidad : \'\' }}\">{{\'Paso 1 de 2\' | translate}}</strong></div><div layout=row><md-button ng-click=vm.close() layout=row><span>{{\"Cancelar\" | translate }}</span></md-button><md-button class=\"md-raised md-primary\" ng-click=vm.guardarPP(vm.response) ng-disabled=vm.disabled><span>{{\'Guardar\' | translate}}</span></md-button></div></md-dialog-actions></md-content><div ng-show=vm.modalSegPart><datik-vehiculos-segparte></datik-vehiculos-segparte></div></div>");
$templateCache.put("app/views/vehiculos/modals/vehiculoSegundaParte.modal.html","<form name=vm.response.projectPartDosForm><h4 layout=row><strong>{{ \'Asignar cliente\' | translate}}</strong></h4><div layout=row><md-autocomplete flex required md-selected-item=vm.response.nameOperator md-no-cache=true ng-blur=vm.recuperDtosDos(vm.response);vm.validaDtosForm(vm.response); md-input-name=autocompleteFlota md-selected-item=vm.selectedItemFlota md-selected-item-change=vm.selectedItemChange(flota) md-search-text=vm.searchFlota md-items=\"flota in vm.querySearchFlota(vm.searchFlota)\" md-item-text=flota.display md-require-match md-floating-label=\"{{\'Flota\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchFlota md-highlight-flags=^i>{{flota.display}}</span></md-item-template><div ng-messages=vm.response.projectPartDosForm.autocompleteFlota.$error ng-if=vm.response.projectPartDosForm.autocompleteFlota.$touched><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match><i class=\"fas fa-exclamation-triangle\"></i> {{\'Por favor seleccione una Flota existente.\' | translate}}</div></div></md-autocomplete><md-autocomplete ng-show=vm.showSedeGrupo ng-disabled=vm.sedeDisabled flex required md-selected-item=vm.response.nameHeadquarters md-no-cache=true ng-blur=vm.recuperDtosDos(vm.response);vm.validaDtosForm(vm.response); md-input-name=autocompleteSede md-selected-item=vm.selectedItemSede md-search-text=vm.searchSede md-items=\"sede in vm.querySearchSede(vm.searchSede)\" md-item-text=sede.display md-floating-label=\"{{\'Sede\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchSede md-highlight-flags=^i>{{sede.display}}</span></md-item-template><div ng-messages=vm.response.projectPartDosForm.autocompleteSede.$error ng-if=vm.response.projectPartDosForm.autocompleteSede.$touched><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match><i class=\"fas fa-exclamation-triangle\"></i> {{\'Por favor seleccione una Sede existente.\' | translate}}</div></div></md-autocomplete><md-autocomplete ng-show=vm.showSedeGrupo ng-disabled=vm.grupoDisabled required md-selected-item=vm.response.nameGroupType md-no-cache=true ng-blur=vm.recuperDtosDos(vm.response);vm.validaDtosForm(vm.response); md-input-name=autocompleteGrupo md-selected-item=vm.selectedItemGrupo md-search-text=vm.searchGrupo md-items=\"grupo in vm.querySearchGrupo(vm.searchGrupo)\" md-item-text=grupo.display md-floating-label=\"{{\'Grupo\' | translate}}\" md-min-length=0><md-item-template><span md-highlight-text=vm.searchGrupo md-highlight-flags=^i>{{grupo.display}}</span></md-item-template><div ng-messages=vm.response.projectPartDosForm.autocompleteGrupo.$error ng-if=vm.response.projectPartDosForm.autocompleteGrupo.$touched><div ng-message=required><i class=\"fas fa-exclamation-triangle\"></i> {{\'Este campo es requerido.\' | translate}}</div><div ng-message=md-require-match><i class=\"fas fa-exclamation-triangle\"></i> {{\'Por favor seleccione un Grupo existente.\' | translate}}</div></div></md-autocomplete></div><md-input-container layout=row ng-show=!vm.showSedeGrupo><span class=elementoBarra><md-progress-circular class=md-hue-2 md-diameter=25px></md-progress-circular></span></md-input-container><div><h4 layout=row><strong>{{ \'Asignar equipamento\' | translate}}</strong></h4><div><md-switch class=md-success ng-model=vm.equimanto aria-label=\"Switch 1\" ng-disabled=true>{{\'Sin equipamiento\' | translate}}</md-switch></div></div><md-dialog-actions layout=row><span layout=row layout-align=\"start center\" flex md-truncate><strong>{{\'Paso 2 de 2\' | translate}}</strong></span><md-button ng-click=vm.regPrimeraPrt(vm.response)>&#60; {{\'Atrás\' | translate}}</md-button><md-button class=\"md-raised md-primary\" ng-disabled=vm.btnSegPart ng-click=vm.guardarVehi(vm.response)>{{\'Dar de alta\' | translate}}</md-button></md-dialog-actions></form>");
$templateCache.put("app/views/examples/tablaPantallaCompleta/modals/TablaPantallaController.modal.html","<form name=\"\" class=modal-form novalidate><div class=modal-header><h3 class=modal-title>{{ \"Añadir\" | translate }}</h3></div><div class=modal-body style=\"padding: 15px 15px 0px 15px\"><label>{{ \"Datos\" | translate }}</label><div><p>{{vm.datos}}</p></div><label for=objeto.minutos>{{\'Ejemplo input number\' | translate}} (1-5 min)</label><div><input type=number min=1 max=5 class=form-control style=width:100% ng-model=objeto.minutos></div><label for=objeto.texto>{{\'Ejemplo input texto\' | translate}}</label><div><input type=text class=form-control style=width:100% ng-model=objeto.texto></div></div><!--<div class=\"modal-footer\" style=\"display:flex\">\n    <button ng-click=\"vm.close()\" type=\"button\" style=\"width:100%;\" class=\"btn btn-cancelar btn-dos\" title=\"{{ \'Cancelar\' | translate }}\">\n      <img style=\"margin-bottom:2px;margin-right:2px\" src=\"assets/images/utils/cancelar.png\">\n      {{ \"Cerrar\" | translate }}\n    </button>\n  </div> --><div class=modal-footer style=display:flex><button class=\"btn btn-guardar btn-dos\" title=\"{{ \'Guardar\' | translate }}\" ng-click=vm.save(objeto)><img style=margin-bottom:2px;margin-right:2px src=assets/images/utils/guardar.png>{{\'Solicitar\' | translate }}</button> <button class=\"btn btn-cancelar btn-dos\" title=\"{{ \'Cancelar\' | translate }}\" ng-click=vm.close()><img style=margin-bottom:2px;margin-right:2px src=assets/images/utils/cancelar.png>{{\'Cancelar\' | translate }}</button></div></form>");}]);